var dartNodePreambleSelf="undefined"!=typeof global?global:window,self=Object.create(dartNodePreambleSelf);if(self.scheduleImmediate=self.setImmediate?function(e){dartNodePreambleSelf.setImmediate(e)}:function(e){setTimeout(e,0)},self.exports=exports,"undefined"!=typeof process)self.process=process;if("undefined"!=typeof __dirname)self.__dirname=__dirname;if("undefined"!=typeof __filename)self.__filename=__filename;if(!dartNodePreambleSelf.window&&!('undefined'!==typeof WorkerGlobalScope&&dartNodePreambleSelf instanceof WorkerGlobalScope)){var url=("undefined"!=typeof __webpack_require__?__non_webpack_require__:require)("url");self.location={get href(){if(url.pathToFileURL)return url.pathToFileURL(process.cwd()).href+"/";else return"file://"+function(){var e=process.cwd();if("win32"!=process.platform)return e;else return"/"+e.replace(/\\/g,"/")}()+"/"}},function(){function e(){try{throw new Error}catch(t){var e=t.stack,r=new RegExp("^ *at [^(]*\\((.*):[0-9]*:[0-9]*\\)$","mg"),l=null;do{var n=r.exec(e);if(null!=n)l=n}while(null!=n);return l[1]}}var r=null;self.document={get currentScript(){if(null==r)r={src:e()};return r}}}(),self.dartDeferredLibraryLoader=function(e,r,l){try{load(e),r()}catch(e){l(e)}}}// Generated by dart2js (fast startup emitter, strong), the Dart to JavaScript compiler version: 2.7.2.
// The code supports the following hooks:
// dartPrint(message):
//    if this function is defined it is called instead of the Dart [print]
//    method.
//
// dartMainRunner(main, args):
//    if this function is defined, the Dart [main] method will not be invoked
//    directly. Instead, a closure that will invoke [main], and its arguments
//    [args] is passed to [dartMainRunner].
//
// dartDeferredLibraryLoader(uri, successCallback, errorCallback):
//    if this function is defined, it will be called when a deferred library
//    is loaded. It should load and eval the javascript of `uri`, and call
//    successCallback. If it fails to do so, it should call errorCallback with
//    an error.
//
// dartCallInstrumentation(id, qualifiedName):
//    if this function is defined, it will be called at each entry of a
//    method or constructor. Used only when compiling programs with
//    --experiment-call-instrumentation.
{
}
(function dartProgram() {
  function copyProperties(from, to) {
    var keys = Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      to[key] = from[key];
    }
  }
  var supportsDirectProtoAccess = function() {
    var cls = function() {
    };
    cls.prototype = {p: {}};
    var object = new cls();
    if (!(object.__proto__ && object.__proto__.p === cls.prototype.p))
      return false;
    try {
      if (typeof navigator != "undefined" && typeof navigator.userAgent == "string" && navigator.userAgent.indexOf("Chrome/") >= 0)
        return true;
      if (typeof version == "function" && version.length == 0) {
        var v = version();
        if (/^\d+\.\d+\.\d+\.\d+$/.test(v))
          return true;
      }
    } catch (_) {
    }
    return false;
  }();
  function setFunctionNamesIfNecessary(holders) {
    function t() {
    }
    ;
    if (typeof t.name == "string")
      return;
    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      var keys = Object.keys(holder);
      for (var j = 0; j < keys.length; j++) {
        var key = keys[j];
        var f = holder[key];
        if (typeof f == 'function')
          f.name = key;
      }
    }
  }
  function inherit(cls, sup) {
    cls.prototype.constructor = cls;
    cls.prototype["$is" + cls.name] = cls;
    if (sup != null) {
      if (supportsDirectProtoAccess) {
        cls.prototype.__proto__ = sup.prototype;
        return;
      }
      var clsPrototype = Object.create(sup.prototype);
      copyProperties(cls.prototype, clsPrototype);
      cls.prototype = clsPrototype;
    }
  }
  function inheritMany(sup, classes) {
    for (var i = 0; i < classes.length; i++)
      inherit(classes[i], sup);
  }
  function mixin(cls, mixin) {
    copyProperties(mixin.prototype, cls.prototype);
    cls.prototype.constructor = cls;
  }
  function lazy(holder, name, getterName, initializer) {
    var uninitializedSentinel = holder;
    holder[name] = uninitializedSentinel;
    holder[getterName] = function() {
      holder[getterName] = function() {
        H.throwCyclicInit(name);
      };
      var result;
      var sentinelInProgress = initializer;
      try {
        if (holder[name] === uninitializedSentinel) {
          result = holder[name] = sentinelInProgress;
          result = holder[name] = initializer();
        } else
          result = holder[name];
      } finally {
        if (result === sentinelInProgress)
          holder[name] = null;
        holder[getterName] = function() {
          return this[name];
        };
      }
      return result;
    };
  }
  function makeConstList(list) {
    list.immutable$list = Array;
    list.fixed$length = Array;
    return list;
  }
  function convertToFastObject(properties) {
    function t() {
    }
    t.prototype = properties;
    new t();
    return properties;
  }
  function convertAllToFastObject(arrayOfObjects) {
    for (var i = 0; i < arrayOfObjects.length; ++i)
      convertToFastObject(arrayOfObjects[i]);
  }
  var functionCounter = 0;
  function tearOffGetter(funcs, applyTrampolineIndex, reflectionInfo, name, isIntercepted) {
    return isIntercepted ? new Function("funcs", "applyTrampolineIndex", "reflectionInfo", "name", "H", "c", "return function tearOff_" + name + functionCounter++ + "(receiver) {" + "if (c === null) c = " + "H.closureFromTearOff" + "(" + "this, funcs, applyTrampolineIndex, reflectionInfo, false, true, name);" + "return new c(this, funcs[0], receiver, name);" + "}")(funcs, applyTrampolineIndex, reflectionInfo, name, H, null) : new Function("funcs", "applyTrampolineIndex", "reflectionInfo", "name", "H", "c", "return function tearOff_" + name + functionCounter++ + "() {" + "if (c === null) c = " + "H.closureFromTearOff" + "(" + "this, funcs, applyTrampolineIndex, reflectionInfo, false, false, name);" + "return new c(this, funcs[0], null, name);" + "}")(funcs, applyTrampolineIndex, reflectionInfo, name, H, null);
  }
  function tearOff(funcs, applyTrampolineIndex, reflectionInfo, isStatic, name, isIntercepted) {
    var cache = null;
    return isStatic ? function() {
      if (cache === null)
        cache = H.closureFromTearOff(this, funcs, applyTrampolineIndex, reflectionInfo, true, false, name).prototype;
      return cache;
    } : tearOffGetter(funcs, applyTrampolineIndex, reflectionInfo, name, isIntercepted);
  }
  var typesOffset = 0;
  function installTearOff(container, getterName, isStatic, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex) {
    var funs = [];
    for (var i = 0; i < funsOrNames.length; i++) {
      var fun = funsOrNames[i];
      if (typeof fun == 'string')
        fun = container[fun];
      fun.$callName = callNames[i];
      funs.push(fun);
    }
    var fun = funs[0];
    fun.$requiredArgCount = requiredParameterCount;
    fun.$defaultValues = optionalParameterDefaultValues;
    var reflectionInfo = funType;
    if (typeof reflectionInfo == "number")
      reflectionInfo += typesOffset;
    var name = funsOrNames[0];
    fun.$stubName = name;
    var getterFunction = tearOff(funs, applyIndex || 0, reflectionInfo, isStatic, name, isIntercepted);
    container[getterName] = getterFunction;
    if (isStatic)
      fun.$tearOff = getterFunction;
  }
  function installStaticTearOff(container, getterName, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex) {
    return installTearOff(container, getterName, true, false, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex);
  }
  function installInstanceTearOff(container, getterName, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex) {
    return installTearOff(container, getterName, false, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, funsOrNames, funType, applyIndex);
  }
  function setOrUpdateInterceptorsByTag(newTags) {
    var tags = init.interceptorsByTag;
    if (!tags) {
      init.interceptorsByTag = newTags;
      return;
    }
    copyProperties(newTags, tags);
  }
  function setOrUpdateLeafTags(newTags) {
    var tags = init.leafTags;
    if (!tags) {
      init.leafTags = newTags;
      return;
    }
    copyProperties(newTags, tags);
  }
  function updateTypes(newTypes) {
    var types = init.types;
    var length = types.length;
    types.push.apply(types, newTypes);
    return length;
  }
  function updateHolder(holder, newHolder) {
    copyProperties(newHolder, holder);
    return holder;
  }
  var hunkHelpers = function() {
    var mkInstance = function(isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, applyIndex) {
        return function(container, getterName, name, funType) {
          return installInstanceTearOff(container, getterName, isIntercepted, requiredParameterCount, optionalParameterDefaultValues, callNames, [name], funType, applyIndex);
        };
      },
      mkStatic = function(requiredParameterCount, optionalParameterDefaultValues, callNames, applyIndex) {
        return function(container, getterName, name, funType) {
          return installStaticTearOff(container, getterName, requiredParameterCount, optionalParameterDefaultValues, callNames, [name], funType, applyIndex);
        };
      };
    return {inherit: inherit, inheritMany: inheritMany, mixin: mixin, installStaticTearOff: installStaticTearOff, installInstanceTearOff: installInstanceTearOff, _instance_0u: mkInstance(0, 0, null, ["call$0"], 0), _instance_1u: mkInstance(0, 1, null, ["call$1"], 0), _instance_2u: mkInstance(0, 2, null, ["call$2"], 0), _instance_0i: mkInstance(1, 0, null, ["call$0"], 0), _instance_1i: mkInstance(1, 1, null, ["call$1"], 0), _instance_2i: mkInstance(1, 2, null, ["call$2"], 0), _static_0: mkStatic(0, null, ["call$0"], 0), _static_1: mkStatic(1, null, ["call$1"], 0), _static_2: mkStatic(2, null, ["call$2"], 0), makeConstList: makeConstList, lazy: lazy, updateHolder: updateHolder, convertToFastObject: convertToFastObject, setFunctionNamesIfNecessary: setFunctionNamesIfNecessary, updateTypes: updateTypes, setOrUpdateInterceptorsByTag: setOrUpdateInterceptorsByTag, setOrUpdateLeafTags: setOrUpdateLeafTags};
  }();
  function initializeDeferredHunk(hunk) {
    typesOffset = init.types.length;
    hunk(hunkHelpers, init, holders, $);
  }
  function getGlobalFromName(name) {
    for (var i = 0; i < holders.length; i++) {
      if (holders[i] == C)
        continue;
      if (holders[i][name])
        return holders[i][name];
    }
  }
  var C = {},
  H = {JS_CONST: function JS_CONST() {
    },
    CastIterable_CastIterable: function(source, $S, $T) {
      if (H.checkSubtype(source, "$isEfficientLengthIterable", [$S], "$asEfficientLengthIterable"))
        return new H._EfficientLengthCastIterable(source, [$S, $T]);
      return new H.CastIterable(source, [$S, $T]);
    },
    hexDigitValue: function(char) {
      var letter,
        digit = char ^ 48;
      if (digit <= 9)
        return digit;
      letter = char | 32;
      if (97 <= letter && letter <= 102)
        return letter - 87;
      return -1;
    },
    parseHexByte: function(source, index) {
      var digit1 = H.hexDigitValue(C.JSString_methods.codeUnitAt$1(source, index)),
        digit2 = H.hexDigitValue(C.JSString_methods.codeUnitAt$1(source, index + 1));
      return digit1 * 16 + digit2 - (digit2 & 256);
    },
    SubListIterable$: function(_iterable, _start, _endOrLength, $E) {
      P.RangeError_checkNotNegative(_start, "start");
      return new H.SubListIterable(_iterable, _start, _endOrLength, [$E]);
    },
    MappedIterable_MappedIterable: function(iterable, $function, $S, $T) {
      if (!!J.getInterceptor$(iterable).$isEfficientLengthIterable)
        return new H.EfficientLengthMappedIterable(iterable, $function, [$S, $T]);
      return new H.MappedIterable(iterable, $function, [$S, $T]);
    },
    SkipIterable_SkipIterable: function(iterable, count, $E) {
      if (!!J.getInterceptor$(iterable).$isEfficientLengthIterable) {
        P.RangeError_checkNotNegative(count, "count");
        return new H.EfficientLengthSkipIterable(iterable, count, [$E]);
      }
      P.RangeError_checkNotNegative(count, "count");
      return new H.SkipIterable(iterable, count, [$E]);
    },
    IterableElementError_noElement: function() {
      return new P.StateError("No element");
    },
    IterableElementError_tooFew: function() {
      return new P.StateError("Too few elements");
    },
    _CastIterableBase: function _CastIterableBase() {
    },
    CastIterator: function CastIterator(t0, t1) {
      this._source = t0;
      this.$ti = t1;
    },
    CastIterable: function CastIterable(t0, t1) {
      this._source = t0;
      this.$ti = t1;
    },
    _EfficientLengthCastIterable: function _EfficientLengthCastIterable(t0, t1) {
      this._source = t0;
      this.$ti = t1;
    },
    _CastListBase: function _CastListBase() {
    },
    CastList: function CastList(t0, t1) {
      this._source = t0;
      this.$ti = t1;
    },
    CastMap: function CastMap(t0, t1) {
      this._source = t0;
      this.$ti = t1;
    },
    CastMap_forEach_closure: function CastMap_forEach_closure(t0, t1) {
      this.$this = t0;
      this.f = t1;
    },
    CodeUnits: function CodeUnits(t0) {
      this._string = t0;
    },
    EfficientLengthIterable: function EfficientLengthIterable() {
    },
    ListIterable: function ListIterable() {
    },
    SubListIterable: function SubListIterable(t0, t1, t2, t3) {
      var _ = this;
      _.__internal$_iterable = t0;
      _._start = t1;
      _._endOrLength = t2;
      _.$ti = t3;
    },
    ListIterator: function ListIterator(t0, t1, t2) {
      var _ = this;
      _.__internal$_iterable = t0;
      _.__internal$_length = t1;
      _.__internal$_index = 0;
      _.__internal$_current = null;
      _.$ti = t2;
    },
    MappedIterable: function MappedIterable(t0, t1, t2) {
      this.__internal$_iterable = t0;
      this._f = t1;
      this.$ti = t2;
    },
    EfficientLengthMappedIterable: function EfficientLengthMappedIterable(t0, t1, t2) {
      this.__internal$_iterable = t0;
      this._f = t1;
      this.$ti = t2;
    },
    MappedIterator: function MappedIterator(t0, t1, t2) {
      var _ = this;
      _.__internal$_current = null;
      _._iterator = t0;
      _._f = t1;
      _.$ti = t2;
    },
    MappedListIterable: function MappedListIterable(t0, t1, t2) {
      this._source = t0;
      this._f = t1;
      this.$ti = t2;
    },
    WhereIterable: function WhereIterable(t0, t1, t2) {
      this.__internal$_iterable = t0;
      this._f = t1;
      this.$ti = t2;
    },
    WhereIterator: function WhereIterator(t0, t1, t2) {
      this._iterator = t0;
      this._f = t1;
      this.$ti = t2;
    },
    SkipIterable: function SkipIterable(t0, t1, t2) {
      this.__internal$_iterable = t0;
      this._skipCount = t1;
      this.$ti = t2;
    },
    EfficientLengthSkipIterable: function EfficientLengthSkipIterable(t0, t1, t2) {
      this.__internal$_iterable = t0;
      this._skipCount = t1;
      this.$ti = t2;
    },
    SkipIterator: function SkipIterator(t0, t1, t2) {
      this._iterator = t0;
      this._skipCount = t1;
      this.$ti = t2;
    },
    EmptyIterable: function EmptyIterable(t0) {
      this.$ti = t0;
    },
    EmptyIterator: function EmptyIterator(t0) {
      this.$ti = t0;
    },
    FixedLengthListMixin: function FixedLengthListMixin() {
    },
    UnmodifiableListMixin: function UnmodifiableListMixin() {
    },
    UnmodifiableListBase: function UnmodifiableListBase() {
    },
    Symbol: function Symbol(t0) {
      this.__internal$_name = t0;
    },
    __CastListBase__CastIterableBase_ListMixin: function __CastListBase__CastIterableBase_ListMixin() {
    },
    ConstantMap__throwUnmodifiable: function() {
      throw H.wrapException(P.UnsupportedError$("Cannot modify unmodifiable Map"));
    },
    unminifyOrTag: function(rawClassName) {
      var preserved = H.unmangleGlobalNameIfPreservedAnyways(rawClassName);
      if (typeof preserved === "string")
        return preserved;
      return rawClassName;
    },
    getType: function(index) {
      return init.types[H.intTypeCheck(index)];
    },
    isJsIndexable: function(object, record) {
      var result;
      if (record != null) {
        result = record.x;
        if (result != null)
          return result;
      }
      return !!J.getInterceptor$(object).$isJavaScriptIndexingBehavior;
    },
    S: function(value) {
      var res;
      if (typeof value === "string")
        return value;
      if (typeof value === "number") {
        if (value !== 0)
          return "" + value;
      } else if (true === value)
        return "true";
      else if (false === value)
        return "false";
      else if (value == null)
        return "null";
      res = J.toString$0$(value);
      if (typeof res !== "string")
        throw H.wrapException(H.argumentErrorValue(value));
      return res;
    },
    Primitives_objectHashCode: function(object) {
      var hash = object.$identityHash;
      if (hash == null) {
        hash = Math.random() * 0x3fffffff | 0;
        object.$identityHash = hash;
      }
      return hash;
    },
    Primitives_parseInt: function(source, radix) {
      var match, decimalMatch, maxCharCode, digitsPart, t1, i;
      if (typeof source !== "string")
        H.throwExpression(H.argumentErrorValue(source));
      match = /^\s*[+-]?((0x[a-f0-9]+)|(\d+)|([a-z0-9]+))\s*$/i.exec(source);
      if (match == null)
        return;
      if (3 >= match.length)
        return H.ioore(match, 3);
      decimalMatch = H.stringTypeCheck(match[3]);
      if (radix == null) {
        if (decimalMatch != null)
          return parseInt(source, 10);
        if (match[2] != null)
          return parseInt(source, 16);
        return;
      }
      if (radix < 2 || radix > 36)
        throw H.wrapException(P.RangeError$range(radix, 2, 36, "radix", null));
      if (radix === 10 && decimalMatch != null)
        return parseInt(source, 10);
      if (radix < 10 || decimalMatch == null) {
        maxCharCode = radix <= 10 ? 47 + radix : 86 + radix;
        digitsPart = match[1];
        for (t1 = digitsPart.length, i = 0; i < t1; ++i)
          if ((C.JSString_methods._codeUnitAt$1(digitsPart, i) | 32) > maxCharCode)
            return;
      }
      return parseInt(source, radix);
    },
    Primitives_objectTypeName: function(object) {
      return H.Primitives__objectClassName(object) + H._joinArguments(H.getRuntimeTypeInfo(object), 0, null);
    },
    Primitives__objectClassName: function(object) {
      var interceptorConstructorName, $name, t1, dispatchName, objectConstructor, match, decompiledName,
        interceptor = J.getInterceptor$(object),
        interceptorConstructor = interceptor.constructor;
      if (typeof interceptorConstructor == "function") {
        interceptorConstructorName = interceptorConstructor.name;
        $name = typeof interceptorConstructorName === "string" ? interceptorConstructorName : null;
      } else
        $name = null;
      t1 = $name == null;
      if (t1 || interceptor === C.Interceptor_methods || !!interceptor.$isUnknownJavaScriptObject) {
        dispatchName = C.C_JS_CONST(object);
        if (t1)
          $name = dispatchName;
        if (dispatchName === "Object") {
          objectConstructor = object.constructor;
          if (typeof objectConstructor == "function") {
            match = String(objectConstructor).match(/^\s*function\s*([\w$]*)\s*\(/);
            decompiledName = match == null ? null : match[1];
            if (typeof decompiledName === "string" && /^\w+$/.test(decompiledName))
              $name = decompiledName;
          }
        }
        return $name;
      }
      $name = $name;
      return H.unminifyOrTag($name.length > 1 && C.JSString_methods._codeUnitAt$1($name, 0) === 36 ? C.JSString_methods.substring$1($name, 1) : $name);
    },
    Primitives__fromCharCodeApply: function(array) {
      var result, i, i0, chunkEnd,
        end = J.get$length$asx(array);
      if (end <= 500)
        return String.fromCharCode.apply(null, array);
      for (result = "", i = 0; i < end; i = i0) {
        i0 = i + 500;
        chunkEnd = i0 < end ? i0 : end;
        result += String.fromCharCode.apply(null, array.slice(i, chunkEnd));
      }
      return result;
    },
    Primitives_stringFromCodePoints: function(codePoints) {
      var t1, _i, i,
        a = H.setRuntimeTypeInfo([], [P.int]);
      for (t1 = codePoints.length, _i = 0; _i < codePoints.length; codePoints.length === t1 || (0, H.throwConcurrentModificationError)(codePoints), ++_i) {
        i = codePoints[_i];
        if (typeof i !== "number" || Math.floor(i) !== i)
          throw H.wrapException(H.argumentErrorValue(i));
        if (i <= 65535)
          C.JSArray_methods.add$1(a, i);
        else if (i <= 1114111) {
          C.JSArray_methods.add$1(a, 55296 + (C.JSInt_methods._shrOtherPositive$1(i - 65536, 10) & 1023));
          C.JSArray_methods.add$1(a, 56320 + (i & 1023));
        } else
          throw H.wrapException(H.argumentErrorValue(i));
      }
      return H.Primitives__fromCharCodeApply(a);
    },
    Primitives_stringFromCharCodes: function(charCodes) {
      var t1, _i, i;
      for (t1 = charCodes.length, _i = 0; _i < t1; ++_i) {
        i = charCodes[_i];
        if (typeof i !== "number" || Math.floor(i) !== i)
          throw H.wrapException(H.argumentErrorValue(i));
        if (i < 0)
          throw H.wrapException(H.argumentErrorValue(i));
        if (i > 65535)
          return H.Primitives_stringFromCodePoints(charCodes);
      }
      return H.Primitives__fromCharCodeApply(charCodes);
    },
    Primitives_stringFromNativeUint8List: function(charCodes, start, end) {
      var i, result, i0, chunkEnd;
      if (end <= 500 && start === 0 && end === charCodes.length)
        return String.fromCharCode.apply(null, charCodes);
      for (i = start, result = ""; i < end; i = i0) {
        i0 = i + 500;
        chunkEnd = i0 < end ? i0 : end;
        result += String.fromCharCode.apply(null, charCodes.subarray(i, chunkEnd));
      }
      return result;
    },
    Primitives_stringFromCharCode: function(charCode) {
      var bits;
      if (0 <= charCode) {
        if (charCode <= 65535)
          return String.fromCharCode(charCode);
        if (charCode <= 1114111) {
          bits = charCode - 65536;
          return String.fromCharCode((55296 | C.JSInt_methods._shrOtherPositive$1(bits, 10)) >>> 0, 56320 | bits & 1023);
        }
      }
      throw H.wrapException(P.RangeError$range(charCode, 0, 1114111, null, null));
    },
    Primitives_lazyAsJsDate: function(receiver) {
      if (receiver.date === void 0)
        receiver.date = new Date(receiver._value);
      return receiver.date;
    },
    Primitives_getYear: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCFullYear() + 0 : H.Primitives_lazyAsJsDate(receiver).getFullYear() + 0;
    },
    Primitives_getMonth: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCMonth() + 1 : H.Primitives_lazyAsJsDate(receiver).getMonth() + 1;
    },
    Primitives_getDay: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCDate() + 0 : H.Primitives_lazyAsJsDate(receiver).getDate() + 0;
    },
    Primitives_getHours: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCHours() + 0 : H.Primitives_lazyAsJsDate(receiver).getHours() + 0;
    },
    Primitives_getMinutes: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCMinutes() + 0 : H.Primitives_lazyAsJsDate(receiver).getMinutes() + 0;
    },
    Primitives_getSeconds: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCSeconds() + 0 : H.Primitives_lazyAsJsDate(receiver).getSeconds() + 0;
    },
    Primitives_getMilliseconds: function(receiver) {
      return receiver.isUtc ? H.Primitives_lazyAsJsDate(receiver).getUTCMilliseconds() + 0 : H.Primitives_lazyAsJsDate(receiver).getMilliseconds() + 0;
    },
    Primitives_functionNoSuchMethod: function($function, positionalArguments, namedArguments) {
      var $arguments, namedArgumentList, t1 = {};
      t1.argumentCount = 0;
      $arguments = [];
      namedArgumentList = [];
      t1.argumentCount = positionalArguments.length;
      C.JSArray_methods.addAll$1($arguments, positionalArguments);
      t1.names = "";
      if (namedArguments != null && namedArguments.__js_helper$_length !== 0)
        namedArguments.forEach$1(0, new H.Primitives_functionNoSuchMethod_closure(t1, namedArgumentList, $arguments));
      "" + t1.argumentCount;
      return J.noSuchMethod$1$($function, new H.JSInvocationMirror(C.Symbol_call, 0, $arguments, namedArgumentList, 0));
    },
    Primitives_applyFunction: function($function, positionalArguments, namedArguments) {
      var t1, $arguments, argumentCount, jsStub;
      if (positionalArguments instanceof Array)
        t1 = namedArguments == null || namedArguments.__js_helper$_length === 0;
      else
        t1 = false;
      if (t1) {
        $arguments = positionalArguments;
        argumentCount = $arguments.length;
        if (argumentCount === 0) {
          if (!!$function.call$0)
            return $function.call$0();
        } else if (argumentCount === 1) {
          if (!!$function.call$1)
            return $function.call$1($arguments[0]);
        } else if (argumentCount === 2) {
          if (!!$function.call$2)
            return $function.call$2($arguments[0], $arguments[1]);
        } else if (argumentCount === 3) {
          if (!!$function.call$3)
            return $function.call$3($arguments[0], $arguments[1], $arguments[2]);
        } else if (argumentCount === 4) {
          if (!!$function.call$4)
            return $function.call$4($arguments[0], $arguments[1], $arguments[2], $arguments[3]);
        } else if (argumentCount === 5)
          if (!!$function.call$5)
            return $function.call$5($arguments[0], $arguments[1], $arguments[2], $arguments[3], $arguments[4]);
        jsStub = $function["call" + "$" + argumentCount];
        if (jsStub != null)
          return jsStub.apply($function, $arguments);
      }
      return H.Primitives__genericApplyFunction2($function, positionalArguments, namedArguments);
    },
    Primitives__genericApplyFunction2: function($function, positionalArguments, namedArguments) {
      var $arguments, argumentCount, requiredParameterCount, defaultValuesClosure, t1, defaultValues, interceptor, jsFunction, keys, _i, used, t2;
      if (positionalArguments != null)
        $arguments = positionalArguments instanceof Array ? positionalArguments : P.List_List$from(positionalArguments, true, null);
      else
        $arguments = [];
      argumentCount = $arguments.length;
      requiredParameterCount = $function.$requiredArgCount;
      if (argumentCount < requiredParameterCount)
        return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
      defaultValuesClosure = $function.$defaultValues;
      t1 = defaultValuesClosure == null;
      defaultValues = !t1 ? defaultValuesClosure() : null;
      interceptor = J.getInterceptor$($function);
      jsFunction = interceptor["call*"];
      if (typeof jsFunction === "string")
        jsFunction = interceptor[jsFunction];
      if (t1) {
        if (namedArguments != null && namedArguments.__js_helper$_length !== 0)
          return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
        if (argumentCount === requiredParameterCount)
          return jsFunction.apply($function, $arguments);
        return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
      }
      if (defaultValues instanceof Array) {
        if (namedArguments != null && namedArguments.__js_helper$_length !== 0)
          return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
        if (argumentCount > requiredParameterCount + defaultValues.length)
          return H.Primitives_functionNoSuchMethod($function, $arguments, null);
        C.JSArray_methods.addAll$1($arguments, defaultValues.slice(argumentCount - requiredParameterCount));
        return jsFunction.apply($function, $arguments);
      } else {
        if (argumentCount > requiredParameterCount)
          return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
        keys = Object.keys(defaultValues);
        if (namedArguments == null)
          for (t1 = keys.length, _i = 0; _i < keys.length; keys.length === t1 || (0, H.throwConcurrentModificationError)(keys), ++_i)
            C.JSArray_methods.add$1($arguments, defaultValues[H.stringTypeCheck(keys[_i])]);
        else {
          for (t1 = keys.length, used = 0, _i = 0; _i < keys.length; keys.length === t1 || (0, H.throwConcurrentModificationError)(keys), ++_i) {
            t2 = H.stringTypeCheck(keys[_i]);
            if (namedArguments.containsKey$1(t2)) {
              ++used;
              C.JSArray_methods.add$1($arguments, namedArguments.$index(0, t2));
            } else
              C.JSArray_methods.add$1($arguments, defaultValues[t2]);
          }
          if (used !== namedArguments.__js_helper$_length)
            return H.Primitives_functionNoSuchMethod($function, $arguments, namedArguments);
        }
        return jsFunction.apply($function, $arguments);
      }
    },
    iae: function(argument) {
      throw H.wrapException(H.argumentErrorValue(argument));
    },
    ioore: function(receiver, index) {
      if (receiver == null)
        J.get$length$asx(receiver);
      throw H.wrapException(H.diagnoseIndexError(receiver, index));
    },
    diagnoseIndexError: function(indexable, index) {
      var $length, _s5_ = "index";
      if (typeof index !== "number" || Math.floor(index) !== index)
        return new P.ArgumentError(true, index, _s5_, null);
      $length = H.intTypeCheck(J.get$length$asx(indexable));
      if (index < 0 || index >= $length)
        return P.IndexError$(index, indexable, _s5_, null, $length);
      return P.RangeError$value(index, _s5_);
    },
    diagnoseRangeError: function(start, end, $length) {
      var _s13_ = "Invalid value";
      if (start < 0 || start > $length)
        return new P.RangeError(0, $length, true, start, "start", _s13_);
      if (end != null)
        if (end < start || end > $length)
          return new P.RangeError(start, $length, true, end, "end", _s13_);
      return new P.ArgumentError(true, end, "end", null);
    },
    argumentErrorValue: function(object) {
      return new P.ArgumentError(true, object, null, null);
    },
    wrapException: function(ex) {
      var wrapper;
      if (ex == null)
        ex = new P.NullThrownError();
      wrapper = new Error();
      wrapper.dartException = ex;
      if ("defineProperty" in Object) {
        Object.defineProperty(wrapper, "message", {get: H.toStringWrapper});
        wrapper.name = "";
      } else
        wrapper.toString = H.toStringWrapper;
      return wrapper;
    },
    toStringWrapper: function() {
      return J.toString$0$(this.dartException);
    },
    throwExpression: function(ex) {
      throw H.wrapException(ex);
    },
    throwConcurrentModificationError: function(collection) {
      throw H.wrapException(P.ConcurrentModificationError$(collection));
    },
    TypeErrorDecoder_extractPattern: function(message) {
      var match, $arguments, argumentsExpr, expr, method, receiver;
      message = H.quoteStringForRegExp(message.replace(String({}), '$receiver$'));
      match = message.match(/\\\$[a-zA-Z]+\\\$/g);
      if (match == null)
        match = H.setRuntimeTypeInfo([], [P.String]);
      $arguments = match.indexOf("\\$arguments\\$");
      argumentsExpr = match.indexOf("\\$argumentsExpr\\$");
      expr = match.indexOf("\\$expr\\$");
      method = match.indexOf("\\$method\\$");
      receiver = match.indexOf("\\$receiver\\$");
      return new H.TypeErrorDecoder(message.replace(new RegExp('\\\\\\$arguments\\\\\\$', 'g'), '((?:x|[^x])*)').replace(new RegExp('\\\\\\$argumentsExpr\\\\\\$', 'g'), '((?:x|[^x])*)').replace(new RegExp('\\\\\\$expr\\\\\\$', 'g'), '((?:x|[^x])*)').replace(new RegExp('\\\\\\$method\\\\\\$', 'g'), '((?:x|[^x])*)').replace(new RegExp('\\\\\\$receiver\\\\\\$', 'g'), '((?:x|[^x])*)'), $arguments, argumentsExpr, expr, method, receiver);
    },
    TypeErrorDecoder_provokeCallErrorOn: function(expression) {
      return function($expr$) {
        var $argumentsExpr$ = '$arguments$';
        try {
          $expr$.$method$($argumentsExpr$);
        } catch (e) {
          return e.message;
        }
      }(expression);
    },
    TypeErrorDecoder_provokePropertyErrorOn: function(expression) {
      return function($expr$) {
        try {
          $expr$.$method$;
        } catch (e) {
          return e.message;
        }
      }(expression);
    },
    NullError$: function(_message, match) {
      return new H.NullError(_message, match == null ? null : match.method);
    },
    JsNoSuchMethodError$: function(_message, match) {
      var t1 = match == null,
        t2 = t1 ? null : match.method;
      return new H.JsNoSuchMethodError(_message, t2, t1 ? null : match.receiver);
    },
    unwrapException: function(ex) {
      var message, number, ieErrorCode, nsme, notClosure, nullCall, nullLiteralCall, undefCall, undefLiteralCall, nullProperty, undefProperty, undefLiteralProperty, match, t2, _null = null,
        t1 = new H.unwrapException_saveStackTrace(ex);
      if (ex == null)
        return;
      if (ex instanceof H.ExceptionAndStackTrace)
        return t1.call$1(ex.dartException);
      if (typeof ex !== "object")
        return ex;
      if ("dartException" in ex)
        return t1.call$1(ex.dartException);
      else if (!("message" in ex))
        return ex;
      message = ex.message;
      if ("number" in ex && typeof ex.number == "number") {
        number = ex.number;
        ieErrorCode = number & 65535;
        if ((C.JSInt_methods._shrOtherPositive$1(number, 16) & 8191) === 10)
          switch (ieErrorCode) {
            case 438:
              return t1.call$1(H.JsNoSuchMethodError$(H.S(message) + " (Error " + ieErrorCode + ")", _null));
            case 445:
            case 5007:
              return t1.call$1(H.NullError$(H.S(message) + " (Error " + ieErrorCode + ")", _null));
          }
      }
      if (ex instanceof TypeError) {
        nsme = $.$get$TypeErrorDecoder_noSuchMethodPattern();
        notClosure = $.$get$TypeErrorDecoder_notClosurePattern();
        nullCall = $.$get$TypeErrorDecoder_nullCallPattern();
        nullLiteralCall = $.$get$TypeErrorDecoder_nullLiteralCallPattern();
        undefCall = $.$get$TypeErrorDecoder_undefinedCallPattern();
        undefLiteralCall = $.$get$TypeErrorDecoder_undefinedLiteralCallPattern();
        nullProperty = $.$get$TypeErrorDecoder_nullPropertyPattern();
        $.$get$TypeErrorDecoder_nullLiteralPropertyPattern();
        undefProperty = $.$get$TypeErrorDecoder_undefinedPropertyPattern();
        undefLiteralProperty = $.$get$TypeErrorDecoder_undefinedLiteralPropertyPattern();
        match = nsme.matchTypeError$1(message);
        if (match != null)
          return t1.call$1(H.JsNoSuchMethodError$(H.stringTypeCheck(message), match));
        else {
          match = notClosure.matchTypeError$1(message);
          if (match != null) {
            match.method = "call";
            return t1.call$1(H.JsNoSuchMethodError$(H.stringTypeCheck(message), match));
          } else {
            match = nullCall.matchTypeError$1(message);
            if (match == null) {
              match = nullLiteralCall.matchTypeError$1(message);
              if (match == null) {
                match = undefCall.matchTypeError$1(message);
                if (match == null) {
                  match = undefLiteralCall.matchTypeError$1(message);
                  if (match == null) {
                    match = nullProperty.matchTypeError$1(message);
                    if (match == null) {
                      match = nullLiteralCall.matchTypeError$1(message);
                      if (match == null) {
                        match = undefProperty.matchTypeError$1(message);
                        if (match == null) {
                          match = undefLiteralProperty.matchTypeError$1(message);
                          t2 = match != null;
                        } else
                          t2 = true;
                      } else
                        t2 = true;
                    } else
                      t2 = true;
                  } else
                    t2 = true;
                } else
                  t2 = true;
              } else
                t2 = true;
            } else
              t2 = true;
            if (t2)
              return t1.call$1(H.NullError$(H.stringTypeCheck(message), match));
          }
        }
        return t1.call$1(new H.UnknownJsTypeError(typeof message === "string" ? message : ""));
      }
      if (ex instanceof RangeError) {
        if (typeof message === "string" && message.indexOf("call stack") !== -1)
          return new P.StackOverflowError();
        message = function(ex) {
          try {
            return String(ex);
          } catch (e) {
          }
          return null;
        }(ex);
        return t1.call$1(new P.ArgumentError(false, _null, _null, typeof message === "string" ? message.replace(/^RangeError:\s*/, "") : message));
      }
      if (typeof InternalError == "function" && ex instanceof InternalError)
        if (typeof message === "string" && message === "too much recursion")
          return new P.StackOverflowError();
      return ex;
    },
    getTraceFromException: function(exception) {
      var trace;
      if (exception instanceof H.ExceptionAndStackTrace)
        return exception.stackTrace;
      if (exception == null)
        return new H._StackTrace(exception);
      trace = exception.$cachedTrace;
      if (trace != null)
        return trace;
      return exception.$cachedTrace = new H._StackTrace(exception);
    },
    objectHashCode: function(object) {
      if (object == null || typeof object != 'object')
        return J.get$hashCode$(object);
      else
        return H.Primitives_objectHashCode(object);
    },
    fillLiteralMap: function(keyValuePairs, result) {
      var index, index0, index1,
        $length = keyValuePairs.length;
      for (index = 0; index < $length; index = index1) {
        index0 = index + 1;
        index1 = index0 + 1;
        result.$indexSet(0, keyValuePairs[index], keyValuePairs[index0]);
      }
      return result;
    },
    fillLiteralSet: function(values, result) {
      var index,
        $length = values.length;
      for (index = 0; index < $length; ++index)
        result.add$1(0, values[index]);
      return result;
    },
    invokeClosure: function(closure, numberOfArguments, arg1, arg2, arg3, arg4) {
      H.interceptedTypeCheck(closure, "$isFunction");
      switch (H.intTypeCheck(numberOfArguments)) {
        case 0:
          return closure.call$0();
        case 1:
          return closure.call$1(arg1);
        case 2:
          return closure.call$2(arg1, arg2);
        case 3:
          return closure.call$3(arg1, arg2, arg3);
        case 4:
          return closure.call$4(arg1, arg2, arg3, arg4);
      }
      throw H.wrapException(new P._Exception("Unsupported number of arguments for wrapped closure"));
    },
    convertDartClosureToJS: function(closure, arity) {
      var $function;
      if (closure == null)
        return;
      $function = closure.$identity;
      if (!!$function)
        return $function;
      $function = function(closure, arity, invoke) {
        return function(a1, a2, a3, a4) {
          return invoke(closure, arity, a1, a2, a3, a4);
        };
      }(closure, arity, H.invokeClosure);
      closure.$identity = $function;
      return $function;
    },
    Closure_fromTearOff: function(receiver, functions, applyTrampolineIndex, reflectionInfo, isStatic, isIntercepted, propertyName) {
      var $constructor, t1, trampoline, signatureFunction, applyTrampoline, i, stub, stubCallName, _null = null,
        $function = functions[0],
        callName = $function.$callName,
        $prototype = isStatic ? Object.create(new H.StaticClosure().constructor.prototype) : Object.create(new H.BoundClosure(_null, _null, _null, _null).constructor.prototype);
      $prototype.$initialize = $prototype.constructor;
      if (isStatic)
        $constructor = function static_tear_off() {
          this.$initialize();
        };
      else {
        t1 = $.Closure_functionCounter;
        if (typeof t1 !== "number")
          return t1.$add();
        $.Closure_functionCounter = t1 + 1;
        t1 = new Function("a,b,c,d" + t1, "this.$initialize(a,b,c,d" + t1 + ")");
        $constructor = t1;
      }
      $prototype.constructor = $constructor;
      $constructor.prototype = $prototype;
      if (!isStatic) {
        trampoline = H.Closure_forwardCallTo(receiver, $function, isIntercepted);
        trampoline.$reflectionInfo = reflectionInfo;
      } else {
        $prototype.$static_name = propertyName;
        trampoline = $function;
      }
      signatureFunction = H.Closure__computeSignatureFunctionLegacy(reflectionInfo, isStatic, isIntercepted);
      $prototype.$signature = signatureFunction;
      $prototype[callName] = trampoline;
      for (applyTrampoline = trampoline, i = 1; i < functions.length; ++i) {
        stub = functions[i];
        stubCallName = stub.$callName;
        if (stubCallName != null) {
          stub = isStatic ? stub : H.Closure_forwardCallTo(receiver, stub, isIntercepted);
          $prototype[stubCallName] = stub;
        }
        if (i === applyTrampolineIndex) {
          stub.$reflectionInfo = reflectionInfo;
          applyTrampoline = stub;
        }
      }
      $prototype["call*"] = applyTrampoline;
      $prototype.$requiredArgCount = $function.$requiredArgCount;
      $prototype.$defaultValues = $function.$defaultValues;
      return $constructor;
    },
    Closure__computeSignatureFunctionLegacy: function(functionType, isStatic, isIntercepted) {
      var getReceiver;
      if (typeof functionType == "number")
        return function(getType, t) {
          return function() {
            return getType(t);
          };
        }(H.getType, functionType);
      if (typeof functionType == "function")
        if (isStatic)
          return functionType;
        else {
          getReceiver = isIntercepted ? H.BoundClosure_receiverOf : H.BoundClosure_selfOf;
          return function(f, r) {
            return function() {
              return f.apply({$receiver: r(this)}, arguments);
            };
          }(functionType, getReceiver);
        }
      throw H.wrapException("Error in functionType of tearoff");
    },
    Closure_cspForwardCall: function(arity, isSuperCall, stubName, $function) {
      var getSelf = H.BoundClosure_selfOf;
      switch (isSuperCall ? -1 : arity) {
        case 0:
          return function(n, S) {
            return function() {
              return S(this)[n]();
            };
          }(stubName, getSelf);
        case 1:
          return function(n, S) {
            return function(a) {
              return S(this)[n](a);
            };
          }(stubName, getSelf);
        case 2:
          return function(n, S) {
            return function(a, b) {
              return S(this)[n](a, b);
            };
          }(stubName, getSelf);
        case 3:
          return function(n, S) {
            return function(a, b, c) {
              return S(this)[n](a, b, c);
            };
          }(stubName, getSelf);
        case 4:
          return function(n, S) {
            return function(a, b, c, d) {
              return S(this)[n](a, b, c, d);
            };
          }(stubName, getSelf);
        case 5:
          return function(n, S) {
            return function(a, b, c, d, e) {
              return S(this)[n](a, b, c, d, e);
            };
          }(stubName, getSelf);
        default:
          return function(f, s) {
            return function() {
              return f.apply(s(this), arguments);
            };
          }($function, getSelf);
      }
    },
    Closure_forwardCallTo: function(receiver, $function, isIntercepted) {
      var stubName, arity, lookedUpFunction, t1, t2, selfName, $arguments;
      if (isIntercepted)
        return H.Closure_forwardInterceptedCallTo(receiver, $function);
      stubName = $function.$stubName;
      arity = $function.length;
      lookedUpFunction = receiver[stubName];
      t1 = $function == null ? lookedUpFunction == null : $function === lookedUpFunction;
      t2 = !t1 || arity >= 27;
      if (t2)
        return H.Closure_cspForwardCall(arity, !t1, stubName, $function);
      if (arity === 0) {
        t1 = $.Closure_functionCounter;
        if (typeof t1 !== "number")
          return t1.$add();
        $.Closure_functionCounter = t1 + 1;
        selfName = "self" + t1;
        t1 = "return function(){var " + selfName + " = this.";
        t2 = $.BoundClosure_selfFieldNameCache;
        return new Function(t1 + H.S(t2 == null ? $.BoundClosure_selfFieldNameCache = H.BoundClosure_computeFieldNamed("self") : t2) + ";return " + selfName + "." + H.S(stubName) + "();}")();
      }
      $arguments = "abcdefghijklmnopqrstuvwxyz".split("").splice(0, arity).join(",");
      t1 = $.Closure_functionCounter;
      if (typeof t1 !== "number")
        return t1.$add();
      $.Closure_functionCounter = t1 + 1;
      $arguments += t1;
      t1 = "return function(" + $arguments + "){return this.";
      t2 = $.BoundClosure_selfFieldNameCache;
      return new Function(t1 + H.S(t2 == null ? $.BoundClosure_selfFieldNameCache = H.BoundClosure_computeFieldNamed("self") : t2) + "." + H.S(stubName) + "(" + $arguments + ");}")();
    },
    Closure_cspForwardInterceptedCall: function(arity, isSuperCall, $name, $function) {
      var getSelf = H.BoundClosure_selfOf,
        getReceiver = H.BoundClosure_receiverOf;
      switch (isSuperCall ? -1 : arity) {
        case 0:
          throw H.wrapException(H.RuntimeError$("Intercepted function with no arguments."));
        case 1:
          return function(n, s, r) {
            return function() {
              return s(this)[n](r(this));
            };
          }($name, getSelf, getReceiver);
        case 2:
          return function(n, s, r) {
            return function(a) {
              return s(this)[n](r(this), a);
            };
          }($name, getSelf, getReceiver);
        case 3:
          return function(n, s, r) {
            return function(a, b) {
              return s(this)[n](r(this), a, b);
            };
          }($name, getSelf, getReceiver);
        case 4:
          return function(n, s, r) {
            return function(a, b, c) {
              return s(this)[n](r(this), a, b, c);
            };
          }($name, getSelf, getReceiver);
        case 5:
          return function(n, s, r) {
            return function(a, b, c, d) {
              return s(this)[n](r(this), a, b, c, d);
            };
          }($name, getSelf, getReceiver);
        case 6:
          return function(n, s, r) {
            return function(a, b, c, d, e) {
              return s(this)[n](r(this), a, b, c, d, e);
            };
          }($name, getSelf, getReceiver);
        default:
          return function(f, s, r, a) {
            return function() {
              a = [r(this)];
              Array.prototype.push.apply(a, arguments);
              return f.apply(s(this), a);
            };
          }($function, getSelf, getReceiver);
      }
    },
    Closure_forwardInterceptedCallTo: function(receiver, $function) {
      var t2, stubName, arity, lookedUpFunction, t3, t4, $arguments,
        t1 = $.BoundClosure_selfFieldNameCache;
      if (t1 == null)
        t1 = $.BoundClosure_selfFieldNameCache = H.BoundClosure_computeFieldNamed("self");
      t2 = $.BoundClosure_receiverFieldNameCache;
      if (t2 == null)
        t2 = $.BoundClosure_receiverFieldNameCache = H.BoundClosure_computeFieldNamed("receiver");
      stubName = $function.$stubName;
      arity = $function.length;
      lookedUpFunction = receiver[stubName];
      t3 = $function == null ? lookedUpFunction == null : $function === lookedUpFunction;
      t4 = !t3 || arity >= 28;
      if (t4)
        return H.Closure_cspForwardInterceptedCall(arity, !t3, stubName, $function);
      if (arity === 1) {
        t1 = "return function(){return this." + H.S(t1) + "." + H.S(stubName) + "(this." + H.S(t2) + ");";
        t2 = $.Closure_functionCounter;
        if (typeof t2 !== "number")
          return t2.$add();
        $.Closure_functionCounter = t2 + 1;
        return new Function(t1 + t2 + "}")();
      }
      $arguments = "abcdefghijklmnopqrstuvwxyz".split("").splice(0, arity - 1).join(",");
      t1 = "return function(" + $arguments + "){return this." + H.S(t1) + "." + H.S(stubName) + "(this." + H.S(t2) + ", " + $arguments + ");";
      t2 = $.Closure_functionCounter;
      if (typeof t2 !== "number")
        return t2.$add();
      $.Closure_functionCounter = t2 + 1;
      return new Function(t1 + t2 + "}")();
    },
    closureFromTearOff: function(receiver, functions, applyTrampolineIndex, reflectionInfo, isStatic, isIntercepted, $name) {
      return H.Closure_fromTearOff(receiver, functions, applyTrampolineIndex, reflectionInfo, !!isStatic, !!isIntercepted, $name);
    },
    BoundClosure_selfOf: function(closure) {
      return closure._self;
    },
    BoundClosure_receiverOf: function(closure) {
      return closure._receiver;
    },
    BoundClosure_computeFieldNamed: function(fieldName) {
      var t1, i, $name,
        template = new H.BoundClosure("self", "target", "receiver", "name"),
        names = J.JSArray_markFixedList(Object.getOwnPropertyNames(template));
      for (t1 = names.length, i = 0; i < t1; ++i) {
        $name = names[i];
        if (template[$name] === fieldName)
          return $name;
      }
    },
    boolConversionCheck: function(value) {
      if (value == null)
        H.assertThrow("boolean expression must not be null");
      return value;
    },
    stringTypeCheck: function(value) {
      if (value == null)
        return value;
      if (typeof value === "string")
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "String"));
    },
    doubleTypeCheck: function(value) {
      if (value == null)
        return value;
      if (typeof value === "number")
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "double"));
    },
    numTypeCheck: function(value) {
      if (value == null)
        return value;
      if (typeof value === "number")
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "num"));
    },
    boolTypeCheck: function(value) {
      if (value == null)
        return value;
      if (typeof value === "boolean")
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "bool"));
    },
    intTypeCheck: function(value) {
      if (value == null)
        return value;
      if (typeof value === "number" && Math.floor(value) === value)
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "int"));
    },
    propertyTypeError: function(value, property) {
      throw H.wrapException(H.TypeErrorImplementation$(value, H.unminifyOrTag(H.stringTypeCheck(property).substring(3))));
    },
    propertyTypeCastError: function(value, property) {
      throw H.wrapException(H.CastErrorImplementation$(value, H.unminifyOrTag(H.stringTypeCheck(property).substring(3))));
    },
    interceptedTypeCheck: function(value, property) {
      if (value == null)
        return value;
      if ((typeof value === "object" || typeof value === "function") && J.getInterceptor$(value)[property])
        return value;
      H.propertyTypeError(value, property);
    },
    interceptedTypeCast: function(value, property) {
      var t1;
      if (value != null)
        t1 = (typeof value === "object" || typeof value === "function") && J.getInterceptor$(value)[property];
      else
        t1 = true;
      if (t1)
        return value;
      H.propertyTypeCastError(value, property);
    },
    stringSuperNativeTypeCheck: function(value, property) {
      if (value == null)
        return value;
      if (typeof value === "string")
        return value;
      if (J.getInterceptor$(value)[property])
        return value;
      H.propertyTypeError(value, property);
    },
    listTypeCheck: function(value) {
      if (value == null)
        return value;
      if (!!J.getInterceptor$(value).$isList)
        return value;
      throw H.wrapException(H.TypeErrorImplementation$(value, "List<dynamic>"));
    },
    listSuperNativeTypeCheck: function(value, property) {
      var t1;
      if (value == null)
        return value;
      t1 = J.getInterceptor$(value);
      if (!!t1.$isList)
        return value;
      if (t1[property])
        return value;
      H.propertyTypeError(value, property);
    },
    listSuperNativeTypeCast: function(value, property) {
      var t1 = J.getInterceptor$(value);
      if (!!t1.$isList || value == null)
        return value;
      if (t1[property])
        return value;
      H.propertyTypeCastError(value, property);
    },
    extractFunctionTypeObjectFromInternal: function(o) {
      var signature;
      if ("$signature" in o) {
        signature = o.$signature;
        if (typeof signature == "number")
          return init.types[H.intTypeCheck(signature)];
        else
          return o.$signature();
      }
      return;
    },
    functionTypeTest: function(value, functionTypeRti) {
      var functionTypeObject;
      if (typeof value == "function")
        return true;
      functionTypeObject = H.extractFunctionTypeObjectFromInternal(J.getInterceptor$(value));
      if (functionTypeObject == null)
        return false;
      return H._isFunctionSubtype(functionTypeObject, null, functionTypeRti, null);
    },
    functionTypeCheck: function(value, functionTypeRti) {
      var $self, t1;
      if (value == null)
        return value;
      if ($._inTypeAssertion)
        return value;
      $._inTypeAssertion = true;
      try {
        if (H.functionTypeTest(value, functionTypeRti))
          return value;
        $self = H.runtimeTypeToString(functionTypeRti);
        t1 = H.TypeErrorImplementation$(value, $self);
        throw H.wrapException(t1);
      } finally {
        $._inTypeAssertion = false;
      }
    },
    futureOrCheck: function(o, futureOrRti) {
      if (o != null && !H.checkSubtypeOfRuntimeType(o, futureOrRti))
        H.throwExpression(H.TypeErrorImplementation$(o, H.runtimeTypeToString(futureOrRti)));
      return o;
    },
    TypeErrorImplementation$: function(value, type) {
      return new H.TypeErrorImplementation("TypeError: " + P.Error_safeToString(value) + ": type '" + H.S(H._typeDescription(value)) + "' is not a subtype of type '" + type + "'");
    },
    CastErrorImplementation$: function(value, type) {
      return new H.CastErrorImplementation("CastError: " + P.Error_safeToString(value) + ": type '" + H.S(H._typeDescription(value)) + "' is not a subtype of type '" + type + "'");
    },
    _typeDescription: function(value) {
      var functionTypeObject,
        t1 = J.getInterceptor$(value);
      if (!!t1.$isClosure) {
        functionTypeObject = H.extractFunctionTypeObjectFromInternal(t1);
        if (functionTypeObject != null)
          return H.runtimeTypeToString(functionTypeObject);
        return "Closure";
      }
      return H.Primitives_objectTypeName(value);
    },
    assertThrow: function(message) {
      throw H.wrapException(new H._AssertionError(message));
    },
    throwCyclicInit: function(staticName) {
      throw H.wrapException(new P.CyclicInitializationError(staticName));
    },
    RuntimeError$: function(message) {
      return new H.RuntimeError(message);
    },
    getIsolateAffinityTag: function($name) {
      return init.getIsolateTag($name);
    },
    createRuntimeType: function(rti) {
      return new H.TypeImpl(rti);
    },
    setRuntimeTypeInfo: function(target, rti) {
      target.$ti = rti;
      return target;
    },
    getRuntimeTypeInfo: function(target) {
      if (target == null)
        return;
      return target.$ti;
    },
    getRuntimeTypeArguments: function(interceptor, object, substitutionName) {
      return H.substitute(interceptor["$as" + H.S(substitutionName)], H.getRuntimeTypeInfo(object));
    },
    getRuntimeTypeArgumentIntercepted: function(interceptor, target, substitutionName, index) {
      var $arguments = H.substitute(interceptor["$as" + H.S(substitutionName)], H.getRuntimeTypeInfo(target));
      return $arguments == null ? null : $arguments[index];
    },
    getRuntimeTypeArgument: function(target, substitutionName, index) {
      var $arguments = H.substitute(target["$as" + H.S(substitutionName)], H.getRuntimeTypeInfo(target));
      return $arguments == null ? null : $arguments[index];
    },
    getTypeArgumentByIndex: function(target, index) {
      var rti = H.getRuntimeTypeInfo(target);
      return rti == null ? null : rti[index];
    },
    runtimeTypeToString: function(rti) {
      return H._runtimeTypeToString(rti, null);
    },
    _runtimeTypeToString: function(rti, genericContext) {
      var t1, t2;
      if (rti == null)
        return "dynamic";
      if (rti === -1)
        return "void";
      if (typeof rti === "object" && rti !== null && rti.constructor === Array)
        return H.unminifyOrTag(rti[0].name) + H._joinArguments(rti, 1, genericContext);
      if (typeof rti == "function")
        return H.unminifyOrTag(rti.name);
      if (rti === -2)
        return "dynamic";
      if (typeof rti === "number") {
        H.intTypeCheck(rti);
        if (genericContext == null || rti < 0 || rti >= genericContext.length)
          return "unexpected-generic-index:" + rti;
        t1 = genericContext.length;
        t2 = t1 - rti - 1;
        if (t2 < 0 || t2 >= t1)
          return H.ioore(genericContext, t2);
        return H.S(genericContext[t2]);
      }
      if ('func' in rti)
        return H._functionRtiToString(rti, genericContext);
      if ('futureOr' in rti)
        return "FutureOr<" + H._runtimeTypeToString("type" in rti ? rti.type : null, genericContext) + ">";
      return "unknown-reified-type";
    },
    _functionRtiToString: function(rti, genericContext) {
      var boundsRti, outerContextLength, offset, i, i0, typeParameters, typeSep, t1, t2, boundRti, returnTypeText, $arguments, argumentsText, sep, _i, argument, optionalArguments, namedArguments, t3, _s2_ = ", ";
      if ("bounds" in rti) {
        boundsRti = rti.bounds;
        if (genericContext == null) {
          genericContext = H.setRuntimeTypeInfo([], [P.String]);
          outerContextLength = null;
        } else
          outerContextLength = genericContext.length;
        offset = genericContext.length;
        for (i = boundsRti.length, i0 = i; i0 > 0; --i0)
          C.JSArray_methods.add$1(genericContext, "T" + (offset + i0));
        for (typeParameters = "<", typeSep = "", i0 = 0; i0 < i; ++i0, typeSep = _s2_) {
          typeParameters += typeSep;
          t1 = genericContext.length;
          t2 = t1 - i0 - 1;
          if (t2 < 0)
            return H.ioore(genericContext, t2);
          typeParameters = C.JSString_methods.$add(typeParameters, genericContext[t2]);
          boundRti = boundsRti[i0];
          if (boundRti != null && boundRti !== P.Object)
            typeParameters += " extends " + H._runtimeTypeToString(boundRti, genericContext);
        }
        typeParameters += ">";
      } else {
        typeParameters = "";
        outerContextLength = null;
      }
      returnTypeText = !!rti.v ? "void" : H._runtimeTypeToString(rti.ret, genericContext);
      if ("args" in rti) {
        $arguments = rti.args;
        for (t1 = $arguments.length, argumentsText = "", sep = "", _i = 0; _i < t1; ++_i, sep = _s2_) {
          argument = $arguments[_i];
          argumentsText = argumentsText + sep + H._runtimeTypeToString(argument, genericContext);
        }
      } else {
        argumentsText = "";
        sep = "";
      }
      if ("opt" in rti) {
        optionalArguments = rti.opt;
        argumentsText += sep + "[";
        for (t1 = optionalArguments.length, sep = "", _i = 0; _i < t1; ++_i, sep = _s2_) {
          argument = optionalArguments[_i];
          argumentsText = argumentsText + sep + H._runtimeTypeToString(argument, genericContext);
        }
        argumentsText += "]";
      }
      if ("named" in rti) {
        namedArguments = rti.named;
        argumentsText += sep + "{";
        for (t1 = H.extractKeys(namedArguments), t2 = t1.length, sep = "", _i = 0; _i < t2; ++_i, sep = _s2_) {
          t3 = H.stringTypeCheck(t1[_i]);
          argumentsText = argumentsText + sep + H._runtimeTypeToString(namedArguments[t3], genericContext) + (" " + H.S(t3));
        }
        argumentsText += "}";
      }
      if (outerContextLength != null)
        genericContext.length = outerContextLength;
      return typeParameters + "(" + argumentsText + ") => " + returnTypeText;
    },
    _joinArguments: function(types, startIndex, genericContext) {
      var buffer, index, separator, allDynamic, t1, argument;
      if (types == null)
        return "";
      buffer = new P.StringBuffer("");
      for (index = startIndex, separator = "", allDynamic = true, t1 = ""; index < types.length; ++index, separator = ", ") {
        buffer._contents = t1 + separator;
        argument = types[index];
        if (argument != null)
          allDynamic = false;
        t1 = buffer._contents += H._runtimeTypeToString(argument, genericContext);
      }
      return "<" + buffer.toString$0(0) + ">";
    },
    substitute: function(substitution, $arguments) {
      if (substitution == null)
        return $arguments;
      substitution = substitution.apply(null, $arguments);
      if (substitution == null)
        return;
      if (typeof substitution === "object" && substitution !== null && substitution.constructor === Array)
        return substitution;
      if (typeof substitution == "function")
        return substitution.apply(null, $arguments);
      return $arguments;
    },
    checkSubtype: function(object, isField, checks, asField) {
      var $arguments, interceptor;
      if (object == null)
        return false;
      $arguments = H.getRuntimeTypeInfo(object);
      interceptor = J.getInterceptor$(object);
      if (interceptor[isField] == null)
        return false;
      return H.areSubtypes(H.substitute(interceptor[asField], $arguments), null, checks, null);
    },
    subtypeCast: function(object, isField, checks, asField) {
      if (object == null)
        return object;
      if (H.checkSubtype(object, isField, checks, asField))
        return object;
      throw H.wrapException(H.CastErrorImplementation$(object, function(str, names) {
        return str.replace(/[^<,> ]+/g, function(m) {
          return names[m] || m;
        });
      }(H.unminifyOrTag(isField.substring(3)) + H._joinArguments(checks, 0, null), init.mangledGlobalNames)));
    },
    assertSubtype: function(object, isField, checks, asField) {
      if (object == null)
        return object;
      if (H.checkSubtype(object, isField, checks, asField))
        return object;
      throw H.wrapException(H.TypeErrorImplementation$(object, function(str, names) {
        return str.replace(/[^<,> ]+/g, function(m) {
          return names[m] || m;
        });
      }(H.unminifyOrTag(isField.substring(3)) + H._joinArguments(checks, 0, null), init.mangledGlobalNames)));
    },
    areSubtypes: function(s, sEnv, t, tEnv) {
      var len, i;
      if (t == null)
        return true;
      if (s == null) {
        len = t.length;
        for (i = 0; i < len; ++i)
          if (!H._isSubtype(null, null, t[i], tEnv))
            return false;
        return true;
      }
      len = s.length;
      for (i = 0; i < len; ++i)
        if (!H._isSubtype(s[i], sEnv, t[i], tEnv))
          return false;
      return true;
    },
    computeSignature: function(signature, context, contextName) {
      return signature.apply(context, H.substitute(J.getInterceptor$(context)["$as" + H.S(contextName)], H.getRuntimeTypeInfo(context)));
    },
    isSupertypeOfNullRecursive: function(type) {
      var typeArgument;
      if (typeof type === "number")
        return false;
      if ('futureOr' in type) {
        typeArgument = "type" in type ? type.type : null;
        return type == null || type.name === "Object" || type.name === "Null" || type === -1 || type === -2 || H.isSupertypeOfNullRecursive(typeArgument);
      }
      return false;
    },
    checkSubtypeOfRuntimeType: function(o, t) {
      var type, rti;
      if (o == null)
        return t == null || t.name === "Object" || t.name === "Null" || t === -1 || t === -2 || H.isSupertypeOfNullRecursive(t);
      if (t == null || t === -1 || t.name === "Object" || t === -2)
        return true;
      if (typeof t == "object") {
        if ('futureOr' in t)
          if (H.checkSubtypeOfRuntimeType(o, "type" in t ? t.type : null))
            return true;
        if ('func' in t)
          return H.functionTypeTest(o, t);
      }
      type = J.getInterceptor$(o).constructor;
      rti = H.getRuntimeTypeInfo(o);
      if (rti != null) {
        rti = rti.slice();
        rti.splice(0, 0, type);
        type = rti;
      }
      return H._isSubtype(type, null, t, null);
    },
    subtypeOfRuntimeTypeCast: function(object, type) {
      if (object != null && !H.checkSubtypeOfRuntimeType(object, type))
        throw H.wrapException(H.CastErrorImplementation$(object, H.runtimeTypeToString(type)));
      return object;
    },
    assertSubtypeOfRuntimeType: function(object, type) {
      if (object != null && !H.checkSubtypeOfRuntimeType(object, type))
        throw H.wrapException(H.TypeErrorImplementation$(object, H.runtimeTypeToString(type)));
      return object;
    },
    _isSubtype: function(s, sEnv, t, tEnv) {
      var t1, typeOfS, tTypeArgument, futureSubstitution, futureArguments, t2, typeOfT, typeOfTString, substitution, _null = null;
      if (s === t)
        return true;
      if (t == null || t === -1 || t.name === "Object" || t === -2)
        return true;
      if (s === -2)
        return true;
      if (s == null || s === -1 || s.name === "Object" || s === -2) {
        if (typeof t === "number")
          return false;
        if ('futureOr' in t)
          return H._isSubtype(s, sEnv, "type" in t ? t.type : _null, tEnv);
        return false;
      }
      if (typeof s === "number")
        return H._isSubtype(sEnv[H.intTypeCheck(s)], sEnv, t, tEnv);
      if (typeof t === "number")
        return false;
      if (s.name === "Null")
        return true;
      t1 = typeof s === "object" && s !== null && s.constructor === Array;
      typeOfS = t1 ? s[0] : s;
      if ('futureOr' in t) {
        tTypeArgument = "type" in t ? t.type : _null;
        if ('futureOr' in s)
          return H._isSubtype("type" in s ? s.type : _null, sEnv, tTypeArgument, tEnv);
        else if (H._isSubtype(s, sEnv, tTypeArgument, tEnv))
          return true;
        else {
          if (!('$is' + "Future" in typeOfS.prototype))
            return false;
          futureSubstitution = typeOfS.prototype["$as" + "Future"];
          futureArguments = H.substitute(futureSubstitution, t1 ? s.slice(1) : _null);
          return H._isSubtype(typeof futureArguments === "object" && futureArguments !== null && futureArguments.constructor === Array ? futureArguments[0] : _null, sEnv, tTypeArgument, tEnv);
        }
      }
      if ('func' in t)
        return H._isFunctionSubtype(s, sEnv, t, tEnv);
      if ('func' in s)
        return t.name === "Function";
      t2 = typeof t === "object" && t !== null && t.constructor === Array;
      typeOfT = t2 ? t[0] : t;
      if (typeOfT !== typeOfS) {
        typeOfTString = typeOfT.name;
        if (!('$is' + typeOfTString in typeOfS.prototype))
          return false;
        substitution = typeOfS.prototype["$as" + typeOfTString];
      } else
        substitution = _null;
      if (!t2)
        return true;
      t1 = t1 ? s.slice(1) : _null;
      t2 = t.slice(1);
      return H.areSubtypes(H.substitute(substitution, t1), sEnv, t2, tEnv);
    },
    _isFunctionSubtype: function(s, sEnv, t, tEnv) {
      var sBounds, tBounds, sParameterTypes, tParameterTypes, sOptionalParameterTypes, tOptionalParameterTypes, sParametersLen, tParametersLen, sOptionalParametersLen, tOptionalParametersLen, pos, tPos, sPos, sNamedParameters, tNamedParameters;
      if (!('func' in s))
        return false;
      if ("bounds" in s) {
        if (!("bounds" in t))
          return false;
        sBounds = s.bounds;
        tBounds = t.bounds;
        if (sBounds.length !== tBounds.length)
          return false;
        sEnv = sEnv == null ? sBounds : sBounds.concat(sEnv);
        tEnv = tEnv == null ? tBounds : tBounds.concat(tEnv);
      } else if ("bounds" in t)
        return false;
      if (!H._isSubtype(s.ret, sEnv, t.ret, tEnv))
        return false;
      sParameterTypes = s.args;
      tParameterTypes = t.args;
      sOptionalParameterTypes = s.opt;
      tOptionalParameterTypes = t.opt;
      sParametersLen = sParameterTypes != null ? sParameterTypes.length : 0;
      tParametersLen = tParameterTypes != null ? tParameterTypes.length : 0;
      sOptionalParametersLen = sOptionalParameterTypes != null ? sOptionalParameterTypes.length : 0;
      tOptionalParametersLen = tOptionalParameterTypes != null ? tOptionalParameterTypes.length : 0;
      if (sParametersLen > tParametersLen)
        return false;
      if (sParametersLen + sOptionalParametersLen < tParametersLen + tOptionalParametersLen)
        return false;
      for (pos = 0; pos < sParametersLen; ++pos)
        if (!H._isSubtype(tParameterTypes[pos], tEnv, sParameterTypes[pos], sEnv))
          return false;
      for (tPos = pos, sPos = 0; tPos < tParametersLen; ++sPos, ++tPos)
        if (!H._isSubtype(tParameterTypes[tPos], tEnv, sOptionalParameterTypes[sPos], sEnv))
          return false;
      for (tPos = 0; tPos < tOptionalParametersLen; ++sPos, ++tPos)
        if (!H._isSubtype(tOptionalParameterTypes[tPos], tEnv, sOptionalParameterTypes[sPos], sEnv))
          return false;
      sNamedParameters = s.named;
      tNamedParameters = t.named;
      if (tNamedParameters == null)
        return true;
      if (sNamedParameters == null)
        return false;
      return H.namedParametersSubtypeCheck(sNamedParameters, sEnv, tNamedParameters, tEnv);
    },
    namedParametersSubtypeCheck: function(s, sEnv, t, tEnv) {
      var t1, i, $name,
        names = Object.getOwnPropertyNames(t);
      for (t1 = names.length, i = 0; i < t1; ++i) {
        $name = names[i];
        if (!Object.hasOwnProperty.call(s, $name))
          return false;
        if (!H._isSubtype(t[$name], tEnv, s[$name], sEnv))
          return false;
      }
      return true;
    },
    defineProperty: function(obj, property, value) {
      Object.defineProperty(obj, property, {value: value, enumerable: false, writable: true, configurable: true});
    },
    lookupAndCacheInterceptor: function(obj) {
      var interceptor, interceptorClass, mark, t1,
        tag = H.stringTypeCheck($.getTagFunction.call$1(obj)),
        record = $.dispatchRecordsForInstanceTags[tag];
      if (record != null) {
        Object.defineProperty(obj, init.dispatchPropertyName, {value: record, enumerable: false, writable: true, configurable: true});
        return record.i;
      }
      interceptor = $.interceptorsForUncacheableTags[tag];
      if (interceptor != null)
        return interceptor;
      interceptorClass = init.interceptorsByTag[tag];
      if (interceptorClass == null) {
        tag = H.stringTypeCheck($.alternateTagFunction.call$2(obj, tag));
        if (tag != null) {
          record = $.dispatchRecordsForInstanceTags[tag];
          if (record != null) {
            Object.defineProperty(obj, init.dispatchPropertyName, {value: record, enumerable: false, writable: true, configurable: true});
            return record.i;
          }
          interceptor = $.interceptorsForUncacheableTags[tag];
          if (interceptor != null)
            return interceptor;
          interceptorClass = init.interceptorsByTag[tag];
        }
      }
      if (interceptorClass == null)
        return;
      interceptor = interceptorClass.prototype;
      mark = tag[0];
      if (mark === "!") {
        record = H.makeLeafDispatchRecord(interceptor);
        $.dispatchRecordsForInstanceTags[tag] = record;
        Object.defineProperty(obj, init.dispatchPropertyName, {value: record, enumerable: false, writable: true, configurable: true});
        return record.i;
      }
      if (mark === "~") {
        $.interceptorsForUncacheableTags[tag] = interceptor;
        return interceptor;
      }
      if (mark === "-") {
        t1 = H.makeLeafDispatchRecord(interceptor);
        Object.defineProperty(Object.getPrototypeOf(obj), init.dispatchPropertyName, {value: t1, enumerable: false, writable: true, configurable: true});
        return t1.i;
      }
      if (mark === "+")
        return H.patchInteriorProto(obj, interceptor);
      if (mark === "*")
        throw H.wrapException(P.UnimplementedError$(tag));
      if (init.leafTags[tag] === true) {
        t1 = H.makeLeafDispatchRecord(interceptor);
        Object.defineProperty(Object.getPrototypeOf(obj), init.dispatchPropertyName, {value: t1, enumerable: false, writable: true, configurable: true});
        return t1.i;
      } else
        return H.patchInteriorProto(obj, interceptor);
    },
    patchInteriorProto: function(obj, interceptor) {
      var proto = Object.getPrototypeOf(obj);
      Object.defineProperty(proto, init.dispatchPropertyName, {value: J.makeDispatchRecord(interceptor, proto, null, null), enumerable: false, writable: true, configurable: true});
      return interceptor;
    },
    makeLeafDispatchRecord: function(interceptor) {
      return J.makeDispatchRecord(interceptor, false, null, !!interceptor.$isJavaScriptIndexingBehavior);
    },
    makeDefaultDispatchRecord: function(tag, interceptorClass, proto) {
      var interceptor = interceptorClass.prototype;
      if (init.leafTags[tag] === true)
        return H.makeLeafDispatchRecord(interceptor);
      else
        return J.makeDispatchRecord(interceptor, proto, null, null);
    },
    initNativeDispatch: function() {
      if (true === $.initNativeDispatchFlag)
        return;
      $.initNativeDispatchFlag = true;
      H.initNativeDispatchContinue();
    },
    initNativeDispatchContinue: function() {
      var map, tags, fun, i, tag, proto, record, interceptorClass;
      $.dispatchRecordsForInstanceTags = Object.create(null);
      $.interceptorsForUncacheableTags = Object.create(null);
      H.initHooks();
      map = init.interceptorsByTag;
      tags = Object.getOwnPropertyNames(map);
      if (typeof window != "undefined") {
        window;
        fun = function() {
        };
        for (i = 0; i < tags.length; ++i) {
          tag = tags[i];
          proto = $.prototypeForTagFunction.call$1(tag);
          if (proto != null) {
            record = H.makeDefaultDispatchRecord(tag, map[tag], proto);
            if (record != null) {
              Object.defineProperty(proto, init.dispatchPropertyName, {value: record, enumerable: false, writable: true, configurable: true});
              fun.prototype = proto;
            }
          }
        }
      }
      for (i = 0; i < tags.length; ++i) {
        tag = tags[i];
        if (/^[A-Za-z_]/.test(tag)) {
          interceptorClass = map[tag];
          map["!" + tag] = interceptorClass;
          map["~" + tag] = interceptorClass;
          map["-" + tag] = interceptorClass;
          map["+" + tag] = interceptorClass;
          map["*" + tag] = interceptorClass;
        }
      }
    },
    initHooks: function() {
      var transformers, i, transformer, getTag, getUnknownTag, prototypeForTag,
        hooks = C.C_JS_CONST0();
      hooks = H.applyHooksTransformer(C.C_JS_CONST1, H.applyHooksTransformer(C.C_JS_CONST2, H.applyHooksTransformer(C.C_JS_CONST3, H.applyHooksTransformer(C.C_JS_CONST3, H.applyHooksTransformer(C.C_JS_CONST4, H.applyHooksTransformer(C.C_JS_CONST5, H.applyHooksTransformer(C.C_JS_CONST6(C.C_JS_CONST), hooks)))))));
      if (typeof dartNativeDispatchHooksTransformer != "undefined") {
        transformers = dartNativeDispatchHooksTransformer;
        if (typeof transformers == "function")
          transformers = [transformers];
        if (transformers.constructor == Array)
          for (i = 0; i < transformers.length; ++i) {
            transformer = transformers[i];
            if (typeof transformer == "function")
              hooks = transformer(hooks) || hooks;
          }
      }
      getTag = hooks.getTag;
      getUnknownTag = hooks.getUnknownTag;
      prototypeForTag = hooks.prototypeForTag;
      $.getTagFunction = new H.initHooks_closure(getTag);
      $.alternateTagFunction = new H.initHooks_closure0(getUnknownTag);
      $.prototypeForTagFunction = new H.initHooks_closure1(prototypeForTag);
    },
    applyHooksTransformer: function(transformer, hooks) {
      return transformer(hooks) || hooks;
    },
    JSSyntaxRegExp_makeNative: function(source, multiLine, caseSensitive, unicode, dotAll, global) {
      var m = multiLine ? "m" : "",
        i = caseSensitive ? "" : "i",
        u = unicode ? "u" : "",
        s = dotAll ? "s" : "",
        g = global ? "g" : "",
        regexp = function(source, modifiers) {
          try {
            return new RegExp(source, modifiers);
          } catch (e) {
            return e;
          }
        }(source, m + i + u + s + g);
      if (regexp instanceof RegExp)
        return regexp;
      throw H.wrapException(P.FormatException$("Illegal RegExp pattern (" + String(regexp) + ")", source, null));
    },
    escapeReplacement: function(replacement) {
      if (replacement.indexOf("$", 0) >= 0)
        return replacement.replace(/\$/g, "$$$$");
      return replacement;
    },
    quoteStringForRegExp: function(string) {
      if (/[[\]{}()*+?.\\^$|]/.test(string))
        return string.replace(/[[\]{}()*+?.\\^$|]/g, "\\$&");
      return string;
    },
    stringReplaceAllUnchecked: function(receiver, pattern, replacement) {
      var t1 = H.stringReplaceAllUncheckedString(receiver, pattern, replacement);
      return t1;
    },
    stringReplaceAllUncheckedString: function(receiver, pattern, replacement) {
      var $length, t1, i, index;
      if (pattern === "") {
        if (receiver === "")
          return replacement;
        $length = receiver.length;
        for (t1 = replacement, i = 0; i < $length; ++i)
          t1 = t1 + receiver[i] + replacement;
        return t1.charCodeAt(0) == 0 ? t1 : t1;
      }
      index = receiver.indexOf(pattern, 0);
      if (index < 0)
        return receiver;
      if (receiver.length < 500 || replacement.indexOf("$", 0) >= 0)
        return receiver.split(pattern).join(replacement);
      return receiver.replace(new RegExp(H.quoteStringForRegExp(pattern), 'g'), H.escapeReplacement(replacement));
    },
    ConstantMapView: function ConstantMapView(t0, t1) {
      this._map = t0;
      this.$ti = t1;
    },
    ConstantMap: function ConstantMap() {
    },
    ConstantStringMap: function ConstantStringMap(t0, t1, t2, t3) {
      var _ = this;
      _.__js_helper$_length = t0;
      _._jsObject = t1;
      _.__js_helper$_keys = t2;
      _.$ti = t3;
    },
    _ConstantMapKeyIterable: function _ConstantMapKeyIterable(t0, t1) {
      this.__js_helper$_map = t0;
      this.$ti = t1;
    },
    GeneralConstantMap: function GeneralConstantMap(t0, t1) {
      this._jsData = t0;
      this.$ti = t1;
    },
    JSInvocationMirror: function JSInvocationMirror(t0, t1, t2, t3, t4) {
      var _ = this;
      _._memberName = t0;
      _._kind = t1;
      _._arguments = t2;
      _._namedArgumentNames = t3;
      _._typeArgumentCount = t4;
    },
    Primitives_functionNoSuchMethod_closure: function Primitives_functionNoSuchMethod_closure(t0, t1, t2) {
      this._box_0 = t0;
      this.namedArgumentList = t1;
      this.$arguments = t2;
    },
    TypeErrorDecoder: function TypeErrorDecoder(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _._pattern = t0;
      _._arguments = t1;
      _._argumentsExpr = t2;
      _._expr = t3;
      _._method = t4;
      _._receiver = t5;
    },
    NullError: function NullError(t0, t1) {
      this._message = t0;
      this._method = t1;
    },
    JsNoSuchMethodError: function JsNoSuchMethodError(t0, t1, t2) {
      this._message = t0;
      this._method = t1;
      this._receiver = t2;
    },
    UnknownJsTypeError: function UnknownJsTypeError(t0) {
      this._message = t0;
    },
    ExceptionAndStackTrace: function ExceptionAndStackTrace(t0, t1) {
      this.dartException = t0;
      this.stackTrace = t1;
    },
    unwrapException_saveStackTrace: function unwrapException_saveStackTrace(t0) {
      this.ex = t0;
    },
    _StackTrace: function _StackTrace(t0) {
      this._exception = t0;
      this._trace = null;
    },
    Closure: function Closure() {
    },
    TearOffClosure: function TearOffClosure() {
    },
    StaticClosure: function StaticClosure() {
    },
    BoundClosure: function BoundClosure(t0, t1, t2, t3) {
      var _ = this;
      _._self = t0;
      _._target = t1;
      _._receiver = t2;
      _._name = t3;
    },
    TypeErrorImplementation: function TypeErrorImplementation(t0) {
      this.message = t0;
    },
    CastErrorImplementation: function CastErrorImplementation(t0) {
      this.message = t0;
    },
    RuntimeError: function RuntimeError(t0) {
      this.message = t0;
    },
    _AssertionError: function _AssertionError(t0) {
      this.message = t0;
    },
    TypeImpl: function TypeImpl(t0) {
      this._rti = t0;
      this._hashCode = this.__typeName = null;
    },
    JsLinkedHashMap: function JsLinkedHashMap(t0) {
      var _ = this;
      _.__js_helper$_length = 0;
      _._last = _._first = _.__js_helper$_rest = _.__js_helper$_nums = _.__js_helper$_strings = null;
      _._modifications = 0;
      _.$ti = t0;
    },
    JsLinkedHashMap_values_closure: function JsLinkedHashMap_values_closure(t0) {
      this.$this = t0;
    },
    LinkedHashMapCell: function LinkedHashMapCell(t0, t1) {
      this.hashMapCellKey = t0;
      this.hashMapCellValue = t1;
      this._next = null;
    },
    LinkedHashMapKeyIterable: function LinkedHashMapKeyIterable(t0, t1) {
      this.__js_helper$_map = t0;
      this.$ti = t1;
    },
    LinkedHashMapKeyIterator: function LinkedHashMapKeyIterator(t0, t1, t2) {
      var _ = this;
      _.__js_helper$_map = t0;
      _._modifications = t1;
      _.__js_helper$_current = _._cell = null;
      _.$ti = t2;
    },
    initHooks_closure: function initHooks_closure(t0) {
      this.getTag = t0;
    },
    initHooks_closure0: function initHooks_closure0(t0) {
      this.getUnknownTag = t0;
    },
    initHooks_closure1: function initHooks_closure1(t0) {
      this.prototypeForTag = t0;
    },
    JSSyntaxRegExp: function JSSyntaxRegExp(t0, t1) {
      var _ = this;
      _.pattern = t0;
      _._nativeRegExp = t1;
      _._nativeAnchoredRegExp = _._nativeGlobalRegExp = null;
    },
    _MatchImplementation: function _MatchImplementation(t0) {
      this._match = t0;
    },
    _checkViewArguments: function(buffer, offsetInBytes, $length) {
    },
    _ensureNativeList: function(list) {
      return list;
    },
    NativeByteData_NativeByteData$view: function(buffer, offsetInBytes, $length) {
      var t1;
      H._checkViewArguments(buffer, offsetInBytes, $length);
      t1 = new DataView(buffer, offsetInBytes);
      return t1;
    },
    NativeFloat32List_NativeFloat32List: function($length) {
      return new Float32Array($length);
    },
    NativeInt8List__create1: function(arg) {
      return new Int8Array(arg);
    },
    NativeUint16List_NativeUint16List$view: function(buffer, offsetInBytes, $length) {
      var t1;
      H._checkViewArguments(buffer, offsetInBytes, $length);
      t1 = new Uint16Array(buffer, offsetInBytes, $length);
      return t1;
    },
    NativeUint32List_NativeUint32List$view: function(buffer, offsetInBytes, $length) {
      var t1;
      H._checkViewArguments(buffer, offsetInBytes, $length);
      t1 = new Uint32Array(buffer, offsetInBytes, $length);
      return t1;
    },
    NativeUint8List_NativeUint8List$view: function(buffer, offsetInBytes, $length) {
      var t1;
      H._checkViewArguments(buffer, offsetInBytes, $length);
      t1 = new Uint8Array(buffer, offsetInBytes, $length);
      return t1;
    },
    _checkValidIndex: function(index, list, $length) {
      if (index >>> 0 !== index || index >= $length)
        throw H.wrapException(H.diagnoseIndexError(list, index));
    },
    _checkValidRange: function(start, end, $length) {
      var t1;
      if (!(start >>> 0 !== start))
        t1 = end >>> 0 !== end || start > end || end > $length;
      else
        t1 = true;
      if (t1)
        throw H.wrapException(H.diagnoseRangeError(start, end, $length));
      return end;
    },
    NativeTypedData: function NativeTypedData() {
    },
    NativeByteData: function NativeByteData() {
    },
    NativeTypedArray: function NativeTypedArray() {
    },
    NativeTypedArrayOfDouble: function NativeTypedArrayOfDouble() {
    },
    NativeTypedArrayOfInt: function NativeTypedArrayOfInt() {
    },
    NativeFloat32List: function NativeFloat32List() {
    },
    NativeFloat64List: function NativeFloat64List() {
    },
    NativeInt16List: function NativeInt16List() {
    },
    NativeInt32List: function NativeInt32List() {
    },
    NativeInt8List: function NativeInt8List() {
    },
    NativeUint16List: function NativeUint16List() {
    },
    NativeUint32List: function NativeUint32List() {
    },
    NativeUint8ClampedList: function NativeUint8ClampedList() {
    },
    NativeUint8List: function NativeUint8List() {
    },
    _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin: function _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin() {
    },
    _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin: function _NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin() {
    },
    _NativeTypedArrayOfInt_NativeTypedArray_ListMixin: function _NativeTypedArrayOfInt_NativeTypedArray_ListMixin() {
    },
    _NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin: function _NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin() {
    },
    extractKeys: function(victim) {
      return J.JSArray_JSArray$markFixed(victim ? Object.keys(victim) : [], null);
    },
    unmangleGlobalNameIfPreservedAnyways: function($name) {
      return init.mangledGlobalNames[$name];
    }
  },
  J = {
    makeDispatchRecord: function(interceptor, proto, extension, indexability) {
      return {i: interceptor, p: proto, e: extension, x: indexability};
    },
    getNativeInterceptor: function(object) {
      var proto, objectProto, $constructor, interceptor,
        record = object[init.dispatchPropertyName];
      if (record == null)
        if ($.initNativeDispatchFlag == null) {
          H.initNativeDispatch();
          record = object[init.dispatchPropertyName];
        }
      if (record != null) {
        proto = record.p;
        if (false === proto)
          return record.i;
        if (true === proto)
          return object;
        objectProto = Object.getPrototypeOf(object);
        if (proto === objectProto)
          return record.i;
        if (record.e === objectProto)
          throw H.wrapException(P.UnimplementedError$("Return interceptor for " + H.S(proto(object, record))));
      }
      $constructor = object.constructor;
      interceptor = $constructor == null ? null : $constructor[$.$get$JS_INTEROP_INTERCEPTOR_TAG()];
      if (interceptor != null)
        return interceptor;
      interceptor = H.lookupAndCacheInterceptor(object);
      if (interceptor != null)
        return interceptor;
      if (typeof object == "function")
        return C.JavaScriptFunction_methods;
      proto = Object.getPrototypeOf(object);
      if (proto == null)
        return C.PlainJavaScriptObject_methods;
      if (proto === Object.prototype)
        return C.PlainJavaScriptObject_methods;
      if (typeof $constructor == "function") {
        Object.defineProperty($constructor, $.$get$JS_INTEROP_INTERCEPTOR_TAG(), {value: C.UnknownJavaScriptObject_methods, enumerable: false, writable: true, configurable: true});
        return C.UnknownJavaScriptObject_methods;
      }
      return C.UnknownJavaScriptObject_methods;
    },
    JSArray_JSArray$fixed: function($length, $E) {
      if ($length < 0 || $length > 4294967295)
        throw H.wrapException(P.RangeError$range($length, 0, 4294967295, "length", null));
      return J.JSArray_JSArray$markFixed(new Array($length), $E);
    },
    JSArray_JSArray$markFixed: function(allocation, $E) {
      return J.JSArray_markFixedList(H.setRuntimeTypeInfo(allocation, [$E]));
    },
    JSArray_markFixedList: function(list) {
      list.fixed$length = Array;
      return list;
    },
    JSString__isWhitespace: function(codeUnit) {
      if (codeUnit < 256)
        switch (codeUnit) {
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 32:
          case 133:
          case 160:
            return true;
          default:
            return false;
        }
      switch (codeUnit) {
        case 5760:
        case 8192:
        case 8193:
        case 8194:
        case 8195:
        case 8196:
        case 8197:
        case 8198:
        case 8199:
        case 8200:
        case 8201:
        case 8202:
        case 8232:
        case 8233:
        case 8239:
        case 8287:
        case 12288:
        case 65279:
          return true;
        default:
          return false;
      }
    },
    JSString__skipTrailingWhitespace: function(string, index) {
      var index0, codeUnit;
      for (; index > 0; index = index0) {
        index0 = index - 1;
        codeUnit = C.JSString_methods.codeUnitAt$1(string, index0);
        if (codeUnit !== 32 && codeUnit !== 13 && !J.JSString__isWhitespace(codeUnit))
          break;
      }
      return index;
    },
    getInterceptor$: function(receiver) {
      if (typeof receiver == "number") {
        if (Math.floor(receiver) == receiver)
          return J.JSInt.prototype;
        return J.JSDouble.prototype;
      }
      if (typeof receiver == "string")
        return J.JSString.prototype;
      if (receiver == null)
        return J.JSNull.prototype;
      if (typeof receiver == "boolean")
        return J.JSBool.prototype;
      if (receiver.constructor == Array)
        return J.JSArray.prototype;
      if (typeof receiver != "object") {
        if (typeof receiver == "function")
          return J.JavaScriptFunction.prototype;
        return receiver;
      }
      if (receiver instanceof P.Object)
        return receiver;
      return J.getNativeInterceptor(receiver);
    },
    getInterceptor$asx: function(receiver) {
      if (typeof receiver == "string")
        return J.JSString.prototype;
      if (receiver == null)
        return receiver;
      if (receiver.constructor == Array)
        return J.JSArray.prototype;
      if (typeof receiver != "object") {
        if (typeof receiver == "function")
          return J.JavaScriptFunction.prototype;
        return receiver;
      }
      if (receiver instanceof P.Object)
        return receiver;
      return J.getNativeInterceptor(receiver);
    },
    getInterceptor$ax: function(receiver) {
      if (receiver == null)
        return receiver;
      if (receiver.constructor == Array)
        return J.JSArray.prototype;
      if (typeof receiver != "object") {
        if (typeof receiver == "function")
          return J.JavaScriptFunction.prototype;
        return receiver;
      }
      if (receiver instanceof P.Object)
        return receiver;
      return J.getNativeInterceptor(receiver);
    },
    getInterceptor$n: function(receiver) {
      if (typeof receiver == "number")
        return J.JSNumber.prototype;
      if (receiver == null)
        return receiver;
      if (!(receiver instanceof P.Object))
        return J.UnknownJavaScriptObject.prototype;
      return receiver;
    },
    getInterceptor$s: function(receiver) {
      if (typeof receiver == "string")
        return J.JSString.prototype;
      if (receiver == null)
        return receiver;
      if (!(receiver instanceof P.Object))
        return J.UnknownJavaScriptObject.prototype;
      return receiver;
    },
    getInterceptor$x: function(receiver) {
      if (receiver == null)
        return receiver;
      if (typeof receiver != "object") {
        if (typeof receiver == "function")
          return J.JavaScriptFunction.prototype;
        return receiver;
      }
      if (receiver instanceof P.Object)
        return receiver;
      return J.getNativeInterceptor(receiver);
    },
    set$length$asx: function(receiver, value) {
      return J.getInterceptor$asx(receiver).set$length(receiver, value);
    },
    set$supportedExtensions$x: function(receiver, value) {
      return J.getInterceptor$x(receiver).set$supportedExtensions(receiver, value);
    },
    set$validateBytes$x: function(receiver, value) {
      return J.getInterceptor$x(receiver).set$validateBytes(receiver, value);
    },
    set$validateString$x: function(receiver, value) {
      return J.getInterceptor$x(receiver).set$validateString(receiver, value);
    },
    set$version$x: function(receiver, value) {
      return J.getInterceptor$x(receiver).set$version(receiver, value);
    },
    get$hashCode$: function(receiver) {
      return J.getInterceptor$(receiver).get$hashCode(receiver);
    },
    get$isEmpty$asx: function(receiver) {
      return J.getInterceptor$asx(receiver).get$isEmpty(receiver);
    },
    get$isNotEmpty$asx: function(receiver) {
      return J.getInterceptor$asx(receiver).get$isNotEmpty(receiver);
    },
    get$iterator$ax: function(receiver) {
      return J.getInterceptor$ax(receiver).get$iterator(receiver);
    },
    get$length$asx: function(receiver) {
      return J.getInterceptor$asx(receiver).get$length(receiver);
    },
    get$validateAccessorData$x: function(receiver) {
      return J.getInterceptor$x(receiver).get$validateAccessorData(receiver);
    },
    get$writeTimestamp$x: function(receiver) {
      return J.getInterceptor$x(receiver).get$writeTimestamp(receiver);
    },
    $eq$: function(receiver, a0) {
      if (receiver == null)
        return a0 == null;
      if (typeof receiver != "object")
        return a0 != null && receiver === a0;
      return J.getInterceptor$(receiver).$eq(receiver, a0);
    },
    $index$asx: function(receiver, a0) {
      if (typeof a0 === "number")
        if (receiver.constructor == Array || typeof receiver == "string" || H.isJsIndexable(receiver, receiver[init.dispatchPropertyName]))
          if (a0 >>> 0 === a0 && a0 < receiver.length)
            return receiver[a0];
      return J.getInterceptor$asx(receiver).$index(receiver, a0);
    },
    $indexSet$ax: function(receiver, a0, a1) {
      return J.getInterceptor$ax(receiver).$indexSet(receiver, a0, a1);
    },
    _codeUnitAt$1$s: function(receiver, a0) {
      return J.getInterceptor$s(receiver)._codeUnitAt$1(receiver, a0);
    },
    add$1$ax: function(receiver, a0) {
      return J.getInterceptor$ax(receiver).add$1(receiver, a0);
    },
    cast$1$0$ax: function(receiver, $T1) {
      return J.getInterceptor$ax(receiver).cast$1$0(receiver, $T1);
    },
    contains$1$ax: function(receiver, a0) {
      return J.getInterceptor$ax(receiver).contains$1(receiver, a0);
    },
    elementAt$1$ax: function(receiver, a0) {
      return J.getInterceptor$ax(receiver).elementAt$1(receiver, a0);
    },
    fillRange$3$x: function(receiver, a0, a1, a2) {
      return J.getInterceptor$x(receiver).fillRange$3(receiver, a0, a1, a2);
    },
    map$1$1$ax: function(receiver, a0, $T1) {
      return J.getInterceptor$ax(receiver).map$1$1(receiver, a0, $T1);
    },
    noSuchMethod$1$: function(receiver, a0) {
      return J.getInterceptor$(receiver).noSuchMethod$1(receiver, a0);
    },
    skip$1$ax: function(receiver, a0) {
      return J.getInterceptor$ax(receiver).skip$1(receiver, a0);
    },
    startsWith$1$s: function(receiver, a0) {
      return J.getInterceptor$s(receiver).startsWith$1(receiver, a0);
    },
    then$1$1$x: function(receiver, a0, $T1) {
      return J.getInterceptor$x(receiver).then$1$1(receiver, a0, $T1);
    },
    then$2$x: function(receiver, a0, a1) {
      return J.getInterceptor$x(receiver).then$2(receiver, a0, a1);
    },
    toInt$0$n: function(receiver) {
      return J.getInterceptor$n(receiver).toInt$0(receiver);
    },
    toList$1$growable$ax: function(receiver, a0) {
      return J.getInterceptor$ax(receiver).toList$1$growable(receiver, a0);
    },
    toString$0$: function(receiver) {
      return J.getInterceptor$(receiver).toString$0(receiver);
    },
    trimRight$0$s: function(receiver) {
      return J.getInterceptor$s(receiver).trimRight$0(receiver);
    },
    Interceptor: function Interceptor() {
    },
    JSBool: function JSBool() {
    },
    JSNull: function JSNull() {
    },
    JavaScriptObject: function JavaScriptObject() {
    },
    PlainJavaScriptObject: function PlainJavaScriptObject() {
    },
    UnknownJavaScriptObject: function UnknownJavaScriptObject() {
    },
    JavaScriptFunction: function JavaScriptFunction() {
    },
    JSArray: function JSArray(t0) {
      this.$ti = t0;
    },
    JSUnmodifiableArray: function JSUnmodifiableArray(t0) {
      this.$ti = t0;
    },
    ArrayIterator: function ArrayIterator(t0, t1, t2) {
      var _ = this;
      _._iterable = t0;
      _._length = t1;
      _._index = 0;
      _._current = null;
      _.$ti = t2;
    },
    JSNumber: function JSNumber() {
    },
    JSInt: function JSInt() {
    },
    JSDouble: function JSDouble() {
    },
    JSString: function JSString() {
    }
  },
  P = {
    _AsyncRun__initializeScheduleImmediate: function() {
      var div, span, t1 = {};
      if (self.scheduleImmediate != null)
        return P.async__AsyncRun__scheduleImmediateJsOverride$closure();
      if (self.MutationObserver != null && self.document != null) {
        div = self.document.createElement("div");
        span = self.document.createElement("span");
        t1.storedCallback = null;
        new self.MutationObserver(H.convertDartClosureToJS(new P._AsyncRun__initializeScheduleImmediate_internalCallback(t1), 1)).observe(div, {childList: true});
        return new P._AsyncRun__initializeScheduleImmediate_closure(t1, div, span);
      } else if (self.setImmediate != null)
        return P.async__AsyncRun__scheduleImmediateWithSetImmediate$closure();
      return P.async__AsyncRun__scheduleImmediateWithTimer$closure();
    },
    _AsyncRun__scheduleImmediateJsOverride: function(callback) {
      self.scheduleImmediate(H.convertDartClosureToJS(new P._AsyncRun__scheduleImmediateJsOverride_internalCallback(H.functionTypeCheck(callback, {func: 1, ret: -1})), 0));
    },
    _AsyncRun__scheduleImmediateWithSetImmediate: function(callback) {
      self.setImmediate(H.convertDartClosureToJS(new P._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback(H.functionTypeCheck(callback, {func: 1, ret: -1})), 0));
    },
    _AsyncRun__scheduleImmediateWithTimer: function(callback) {
      H.functionTypeCheck(callback, {func: 1, ret: -1});
      P._TimerImpl$(0, callback);
    },
    _TimerImpl$: function(milliseconds, callback) {
      var t1 = new P._TimerImpl();
      t1._TimerImpl$2(milliseconds, callback);
      return t1;
    },
    _makeAsyncAwaitCompleter: function($T) {
      return new P._AsyncAwaitCompleter(new P._Future($.Zone__current, [$T]), [$T]);
    },
    _asyncStartSync: function(bodyFunction, completer) {
      bodyFunction.call$2(0, null);
      completer.isSync = true;
      return completer._future;
    },
    _asyncAwait: function(object, bodyFunction) {
      P._awaitOnObject(object, bodyFunction);
    },
    _asyncReturn: function(object, completer) {
      completer.complete$1(object);
    },
    _asyncRethrow: function(object, completer) {
      completer.completeError$2(H.unwrapException(object), H.getTraceFromException(object));
    },
    _awaitOnObject: function(object, bodyFunction) {
      var future, _null = null,
        thenCallback = new P._awaitOnObject_closure(bodyFunction),
        errorCallback = new P._awaitOnObject_closure0(bodyFunction),
        t1 = J.getInterceptor$(object);
      if (!!t1.$is_Future)
        object._thenAwait$1$2(thenCallback, errorCallback, _null);
      else if (!!t1.$isFuture)
        object.then$1$2$onError(0, thenCallback, errorCallback, _null);
      else {
        future = new P._Future($.Zone__current, [null]);
        H.assertSubtypeOfRuntimeType(object, null);
        future._state = 4;
        future._resultOrListeners = object;
        future._thenAwait$1$2(thenCallback, _null, _null);
      }
    },
    _wrapJsFunctionForAsync: function($function) {
      var $protected = function(fn, ERROR) {
        return function(errorCode, result) {
          while (true)
            try {
              fn(errorCode, result);
              break;
            } catch (error) {
              result = error;
              errorCode = ERROR;
            }
        };
      }($function, 1);
      return $.Zone__current.registerBinaryCallback$3$1(new P._wrapJsFunctionForAsync_closure($protected), P.Null, P.int, null);
    },
    _IterationMarker_yieldStar: function(values) {
      return new P._IterationMarker(values, 1);
    },
    _IterationMarker_endOfIteration: function() {
      return C._IterationMarker_null_2;
    },
    _IterationMarker_uncaughtError: function(error) {
      return new P._IterationMarker(error, 3);
    },
    _makeSyncStarIterable: function(body, $T) {
      return new P._SyncStarIterable(body, [$T]);
    },
    _Future__chainForeignFuture: function(source, target) {
      var e, s, exception;
      target._state = 1;
      try {
        source.then$1$2$onError(0, new P._Future__chainForeignFuture_closure(target), new P._Future__chainForeignFuture_closure0(target), P.Null);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        P.scheduleMicrotask(new P._Future__chainForeignFuture_closure1(target, e, s));
      }
    },
    _Future__chainCoreFuture: function(source, target) {
      var t1, listeners;
      for (; t1 = source._state, t1 === 2;)
        source = H.interceptedTypeCheck(source._resultOrListeners, "$is_Future");
      if (t1 >= 4) {
        listeners = target._removeListeners$0();
        target._state = source._state;
        target._resultOrListeners = source._resultOrListeners;
        P._Future__propagateToListeners(target, listeners);
      } else {
        listeners = H.interceptedTypeCheck(target._resultOrListeners, "$is_FutureListener");
        target._state = 2;
        target._resultOrListeners = source;
        source._prependListeners$1(listeners);
      }
    },
    _Future__propagateToListeners: function(source, listeners) {
      var _box_0, hasError, asyncError, listeners0, sourceResult, t2, t3, zone, t4, oldZone, current, result, _null = null, _box_1 = {},
        t1 = _box_1.source = source;
      for (; true;) {
        _box_0 = {};
        hasError = t1._state === 8;
        if (listeners == null) {
          if (hasError) {
            asyncError = H.interceptedTypeCheck(t1._resultOrListeners, "$isAsyncError");
            P._rootHandleUncaughtError(_null, _null, t1._zone, asyncError.error, asyncError.stackTrace);
          }
          return;
        }
        for (; listeners0 = listeners._nextListener, listeners0 != null; listeners = listeners0) {
          listeners._nextListener = null;
          P._Future__propagateToListeners(_box_1.source, listeners);
        }
        t1 = _box_1.source;
        sourceResult = t1._resultOrListeners;
        _box_0.listenerHasError = hasError;
        _box_0.listenerValueOrError = sourceResult;
        t2 = !hasError;
        if (t2) {
          t3 = listeners.state;
          t3 = (t3 & 1) !== 0 || (t3 & 15) === 8;
        } else
          t3 = true;
        if (t3) {
          t3 = listeners.result;
          zone = t3._zone;
          if (hasError) {
            t4 = t1._zone === zone;
            t4 = !(t4 || t4);
          } else
            t4 = false;
          if (t4) {
            H.interceptedTypeCheck(sourceResult, "$isAsyncError");
            P._rootHandleUncaughtError(_null, _null, t1._zone, sourceResult.error, sourceResult.stackTrace);
            return;
          }
          oldZone = $.Zone__current;
          if (oldZone !== zone)
            $.Zone__current = zone;
          else
            oldZone = _null;
          t1 = listeners.state;
          if ((t1 & 15) === 8)
            new P._Future__propagateToListeners_handleWhenCompleteCallback(_box_1, _box_0, listeners, hasError).call$0();
          else if (t2) {
            if ((t1 & 1) !== 0)
              new P._Future__propagateToListeners_handleValueCallback(_box_0, listeners, sourceResult).call$0();
          } else if ((t1 & 2) !== 0)
            new P._Future__propagateToListeners_handleError(_box_1, _box_0, listeners).call$0();
          if (oldZone != null)
            $.Zone__current = oldZone;
          t1 = _box_0.listenerValueOrError;
          if (!!J.getInterceptor$(t1).$isFuture) {
            if (t1._state >= 4) {
              current = H.interceptedTypeCheck(t3._resultOrListeners, "$is_FutureListener");
              t3._resultOrListeners = null;
              listeners = t3._reverseListeners$1(current);
              t3._state = t1._state;
              t3._resultOrListeners = t1._resultOrListeners;
              _box_1.source = t1;
              continue;
            } else
              P._Future__chainCoreFuture(t1, t3);
            return;
          }
        }
        result = listeners.result;
        current = H.interceptedTypeCheck(result._resultOrListeners, "$is_FutureListener");
        result._resultOrListeners = null;
        listeners = result._reverseListeners$1(current);
        t1 = _box_0.listenerHasError;
        t2 = _box_0.listenerValueOrError;
        if (!t1) {
          H.assertSubtypeOfRuntimeType(t2, H.getTypeArgumentByIndex(result, 0));
          result._state = 4;
          result._resultOrListeners = t2;
        } else {
          H.interceptedTypeCheck(t2, "$isAsyncError");
          result._state = 8;
          result._resultOrListeners = t2;
        }
        _box_1.source = result;
        t1 = result;
      }
    },
    _registerErrorHandler: function(errorHandler, zone) {
      if (H.functionTypeTest(errorHandler, {func: 1, args: [P.Object, P.StackTrace]}))
        return zone.registerBinaryCallback$3$1(errorHandler, null, P.Object, P.StackTrace);
      if (H.functionTypeTest(errorHandler, {func: 1, args: [P.Object]}))
        return H.functionTypeCheck(errorHandler, {func: 1, ret: null, args: [P.Object]});
      throw H.wrapException(P.ArgumentError$value(errorHandler, "onError", "Error handler must accept one Object or one Object and a StackTrace as arguments, and return a a valid result"));
    },
    _microtaskLoop: function() {
      var t1, t2;
      for (; t1 = $._nextCallback, t1 != null;) {
        $._lastPriorityCallback = null;
        t2 = t1.next;
        $._nextCallback = t2;
        if (t2 == null)
          $._lastCallback = null;
        t1.callback.call$0();
      }
    },
    _startMicrotaskLoop: function() {
      $._isInCallbackLoop = true;
      try {
        P._microtaskLoop();
      } finally {
        $._lastPriorityCallback = null;
        $._isInCallbackLoop = false;
        if ($._nextCallback != null)
          $.$get$_AsyncRun__scheduleImmediateClosure().call$1(P.async___startMicrotaskLoop$closure());
      }
    },
    _scheduleAsyncCallback: function(callback) {
      var newEntry = new P._AsyncCallbackEntry(callback);
      if ($._nextCallback == null) {
        $._nextCallback = $._lastCallback = newEntry;
        if (!$._isInCallbackLoop)
          $.$get$_AsyncRun__scheduleImmediateClosure().call$1(P.async___startMicrotaskLoop$closure());
      } else
        $._lastCallback = $._lastCallback.next = newEntry;
    },
    _schedulePriorityAsyncCallback: function(callback) {
      var entry, t2,
        t1 = $._nextCallback;
      if (t1 == null) {
        P._scheduleAsyncCallback(callback);
        $._lastPriorityCallback = $._lastCallback;
        return;
      }
      entry = new P._AsyncCallbackEntry(callback);
      t2 = $._lastPriorityCallback;
      if (t2 == null) {
        entry.next = t1;
        $._nextCallback = $._lastPriorityCallback = entry;
      } else {
        entry.next = t2.next;
        $._lastPriorityCallback = t2.next = entry;
        if (entry.next == null)
          $._lastCallback = entry;
      }
    },
    scheduleMicrotask: function(callback) {
      var _null = null,
        currentZone = $.Zone__current;
      if (C.C__RootZone === currentZone) {
        P._rootScheduleMicrotask(_null, _null, C.C__RootZone, callback);
        return;
      }
      P._rootScheduleMicrotask(_null, _null, currentZone, H.functionTypeCheck(currentZone.bindCallbackGuarded$1(callback), {func: 1, ret: -1}));
    },
    Stream_Stream$fromFuture: function(future, $T) {
      var _null = null,
        controller = new P._SyncStreamController(_null, _null, _null, _null, [$T]);
      future.then$1$2$onError(0, new P.Stream_Stream$fromFuture_closure(controller, $T), new P.Stream_Stream$fromFuture_closure0(controller), P.Null);
      return new P._ControllerStream(controller, [$T]);
    },
    Stream_Stream$fromIterable: function(elements, $T) {
      return new P._GeneratedStreamImpl(new P.Stream_Stream$fromIterable_closure(elements, $T), [$T]);
    },
    StreamIterator_StreamIterator: function(stream, $T) {
      if (stream == null)
        H.throwExpression(P.ArgumentError$notNull("stream"));
      return new P._StreamIterator([$T]);
    },
    StreamController_StreamController: function(onCancel, onPause, onResume, $T) {
      return new P._AsyncStreamController(null, onPause, onResume, onCancel, [$T]);
    },
    _runGuarded: function(notificationHandler) {
      var e, s, exception;
      if (notificationHandler == null)
        return;
      try {
        notificationHandler.call$0();
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        P._rootHandleUncaughtError(null, null, $.Zone__current, e, H.interceptedTypeCheck(s, "$isStackTrace"));
      }
    },
    _BufferingStreamSubscription$: function(onData, onError, onDone, cancelOnError, $T) {
      var t1 = $.Zone__current,
        t2 = cancelOnError ? 1 : 0;
      t2 = new P._BufferingStreamSubscription(t1, t2, [$T]);
      t2._BufferingStreamSubscription$4(onData, onError, onDone, cancelOnError, $T);
      return t2;
    },
    _nullErrorHandler: function(error, stackTrace) {
      P._rootHandleUncaughtError(null, null, $.Zone__current, error, stackTrace);
    },
    _rootHandleUncaughtError: function($self, $parent, zone, error, stackTrace) {
      var t1 = {};
      t1.error = error;
      P._schedulePriorityAsyncCallback(new P._rootHandleUncaughtError_closure(t1, stackTrace));
    },
    _rootRun: function($self, $parent, zone, f, $R) {
      var old,
        t1 = $.Zone__current;
      if (t1 === zone)
        return f.call$0();
      $.Zone__current = zone;
      old = t1;
      try {
        t1 = f.call$0();
        return t1;
      } finally {
        $.Zone__current = old;
      }
    },
    _rootRunUnary: function($self, $parent, zone, f, arg, $R, $T) {
      var old,
        t1 = $.Zone__current;
      if (t1 === zone)
        return f.call$1(arg);
      $.Zone__current = zone;
      old = t1;
      try {
        t1 = f.call$1(arg);
        return t1;
      } finally {
        $.Zone__current = old;
      }
    },
    _rootRunBinary: function($self, $parent, zone, f, arg1, arg2, $R, T1, T2) {
      var old,
        t1 = $.Zone__current;
      if (t1 === zone)
        return f.call$2(arg1, arg2);
      $.Zone__current = zone;
      old = t1;
      try {
        t1 = f.call$2(arg1, arg2);
        return t1;
      } finally {
        $.Zone__current = old;
      }
    },
    _rootScheduleMicrotask: function($self, $parent, zone, f) {
      var t1;
      H.functionTypeCheck(f, {func: 1, ret: -1});
      t1 = C.C__RootZone !== zone;
      if (t1)
        f = !(!t1 || false) ? zone.bindCallbackGuarded$1(f) : zone.bindCallback$1$1(f, -1);
      P._scheduleAsyncCallback(f);
    },
    _AsyncRun__initializeScheduleImmediate_internalCallback: function _AsyncRun__initializeScheduleImmediate_internalCallback(t0) {
      this._box_0 = t0;
    },
    _AsyncRun__initializeScheduleImmediate_closure: function _AsyncRun__initializeScheduleImmediate_closure(t0, t1, t2) {
      this._box_0 = t0;
      this.div = t1;
      this.span = t2;
    },
    _AsyncRun__scheduleImmediateJsOverride_internalCallback: function _AsyncRun__scheduleImmediateJsOverride_internalCallback(t0) {
      this.callback = t0;
    },
    _AsyncRun__scheduleImmediateWithSetImmediate_internalCallback: function _AsyncRun__scheduleImmediateWithSetImmediate_internalCallback(t0) {
      this.callback = t0;
    },
    _TimerImpl: function _TimerImpl() {
    },
    _TimerImpl_internalCallback: function _TimerImpl_internalCallback(t0, t1) {
      this.$this = t0;
      this.callback = t1;
    },
    _AsyncAwaitCompleter: function _AsyncAwaitCompleter(t0, t1) {
      this._future = t0;
      this.isSync = false;
      this.$ti = t1;
    },
    _awaitOnObject_closure: function _awaitOnObject_closure(t0) {
      this.bodyFunction = t0;
    },
    _awaitOnObject_closure0: function _awaitOnObject_closure0(t0) {
      this.bodyFunction = t0;
    },
    _wrapJsFunctionForAsync_closure: function _wrapJsFunctionForAsync_closure(t0) {
      this.$protected = t0;
    },
    _IterationMarker: function _IterationMarker(t0, t1) {
      this.value = t0;
      this.state = t1;
    },
    _SyncStarIterator: function _SyncStarIterator(t0, t1) {
      var _ = this;
      _._body = t0;
      _._suspendedBodies = _._nestedIterator = _._async$_current = null;
      _.$ti = t1;
    },
    _SyncStarIterable: function _SyncStarIterable(t0, t1) {
      this._outerHelper = t0;
      this.$ti = t1;
    },
    Future: function Future() {
    },
    _Completer: function _Completer() {
    },
    _AsyncCompleter: function _AsyncCompleter(t0, t1) {
      this.future = t0;
      this.$ti = t1;
    },
    _FutureListener: function _FutureListener(t0, t1, t2, t3, t4) {
      var _ = this;
      _._nextListener = null;
      _.result = t0;
      _.state = t1;
      _.callback = t2;
      _.errorCallback = t3;
      _.$ti = t4;
    },
    _Future: function _Future(t0, t1) {
      var _ = this;
      _._state = 0;
      _._zone = t0;
      _._resultOrListeners = null;
      _.$ti = t1;
    },
    _Future__addListener_closure: function _Future__addListener_closure(t0, t1) {
      this.$this = t0;
      this.listener = t1;
    },
    _Future__prependListeners_closure: function _Future__prependListeners_closure(t0, t1) {
      this._box_0 = t0;
      this.$this = t1;
    },
    _Future__chainForeignFuture_closure: function _Future__chainForeignFuture_closure(t0) {
      this.target = t0;
    },
    _Future__chainForeignFuture_closure0: function _Future__chainForeignFuture_closure0(t0) {
      this.target = t0;
    },
    _Future__chainForeignFuture_closure1: function _Future__chainForeignFuture_closure1(t0, t1, t2) {
      this.target = t0;
      this.e = t1;
      this.s = t2;
    },
    _Future__asyncComplete_closure: function _Future__asyncComplete_closure(t0, t1) {
      this.$this = t0;
      this.value = t1;
    },
    _Future__chainFuture_closure: function _Future__chainFuture_closure(t0, t1) {
      this.$this = t0;
      this.value = t1;
    },
    _Future__asyncCompleteError_closure: function _Future__asyncCompleteError_closure(t0, t1, t2) {
      this.$this = t0;
      this.error = t1;
      this.stackTrace = t2;
    },
    _Future__propagateToListeners_handleWhenCompleteCallback: function _Future__propagateToListeners_handleWhenCompleteCallback(t0, t1, t2, t3) {
      var _ = this;
      _._box_1 = t0;
      _._box_0 = t1;
      _.listener = t2;
      _.hasError = t3;
    },
    _Future__propagateToListeners_handleWhenCompleteCallback_closure: function _Future__propagateToListeners_handleWhenCompleteCallback_closure(t0) {
      this.originalSource = t0;
    },
    _Future__propagateToListeners_handleValueCallback: function _Future__propagateToListeners_handleValueCallback(t0, t1, t2) {
      this._box_0 = t0;
      this.listener = t1;
      this.sourceResult = t2;
    },
    _Future__propagateToListeners_handleError: function _Future__propagateToListeners_handleError(t0, t1, t2) {
      this._box_1 = t0;
      this._box_0 = t1;
      this.listener = t2;
    },
    _AsyncCallbackEntry: function _AsyncCallbackEntry(t0) {
      this.callback = t0;
      this.next = null;
    },
    Stream: function Stream() {
    },
    Stream_Stream$fromFuture_closure: function Stream_Stream$fromFuture_closure(t0, t1) {
      this.controller = t0;
      this.T = t1;
    },
    Stream_Stream$fromFuture_closure0: function Stream_Stream$fromFuture_closure0(t0) {
      this.controller = t0;
    },
    Stream_Stream$fromIterable_closure: function Stream_Stream$fromIterable_closure(t0, t1) {
      this.elements = t0;
      this.T = t1;
    },
    Stream_length_closure: function Stream_length_closure(t0, t1) {
      this._box_0 = t0;
      this.$this = t1;
    },
    Stream_length_closure0: function Stream_length_closure0(t0, t1) {
      this._box_0 = t0;
      this.future = t1;
    },
    StreamTransformerBase: function StreamTransformerBase() {
    },
    _StreamController: function _StreamController() {
    },
    _StreamController__subscribe_closure: function _StreamController__subscribe_closure(t0) {
      this.$this = t0;
    },
    _StreamController__recordCancel_complete: function _StreamController__recordCancel_complete(t0) {
      this.$this = t0;
    },
    _SyncStreamControllerDispatch: function _SyncStreamControllerDispatch() {
    },
    _AsyncStreamControllerDispatch: function _AsyncStreamControllerDispatch() {
    },
    _AsyncStreamController: function _AsyncStreamController(t0, t1, t2, t3, t4) {
      var _ = this;
      _._varData = null;
      _._state = 0;
      _._doneFuture = null;
      _.onListen = t0;
      _.onPause = t1;
      _.onResume = t2;
      _.onCancel = t3;
      _.$ti = t4;
    },
    _SyncStreamController: function _SyncStreamController(t0, t1, t2, t3, t4) {
      var _ = this;
      _._varData = null;
      _._state = 0;
      _._doneFuture = null;
      _.onListen = t0;
      _.onPause = t1;
      _.onResume = t2;
      _.onCancel = t3;
      _.$ti = t4;
    },
    _ControllerStream: function _ControllerStream(t0, t1) {
      this._controller = t0;
      this.$ti = t1;
    },
    _ControllerSubscription: function _ControllerSubscription(t0, t1, t2, t3) {
      var _ = this;
      _._controller = t0;
      _._onDone = _._onError = _._onData = null;
      _._zone = t1;
      _._state = t2;
      _._pending = _._cancelFuture = null;
      _.$ti = t3;
    },
    _BufferingStreamSubscription: function _BufferingStreamSubscription(t0, t1, t2) {
      var _ = this;
      _._onDone = _._onError = _._onData = null;
      _._zone = t0;
      _._state = t1;
      _._pending = _._cancelFuture = null;
      _.$ti = t2;
    },
    _BufferingStreamSubscription__sendError_sendError: function _BufferingStreamSubscription__sendError_sendError(t0, t1, t2) {
      this.$this = t0;
      this.error = t1;
      this.stackTrace = t2;
    },
    _BufferingStreamSubscription__sendDone_sendDone: function _BufferingStreamSubscription__sendDone_sendDone(t0) {
      this.$this = t0;
    },
    _StreamImpl: function _StreamImpl() {
    },
    _GeneratedStreamImpl: function _GeneratedStreamImpl(t0, t1) {
      this._pending = t0;
      this._async$_isUsed = false;
      this.$ti = t1;
    },
    _IterablePendingEvents: function _IterablePendingEvents(t0, t1) {
      this._async$_iterator = t0;
      this._state = 0;
      this.$ti = t1;
    },
    _DelayedEvent: function _DelayedEvent() {
    },
    _DelayedData: function _DelayedData(t0, t1) {
      this.value = t0;
      this.next = null;
      this.$ti = t1;
    },
    _DelayedError: function _DelayedError(t0, t1) {
      this.error = t0;
      this.stackTrace = t1;
      this.next = null;
    },
    _DelayedDone: function _DelayedDone() {
    },
    _PendingEvents: function _PendingEvents() {
    },
    _PendingEvents_schedule_closure: function _PendingEvents_schedule_closure(t0, t1) {
      this.$this = t0;
      this.dispatch = t1;
    },
    _StreamImplEvents: function _StreamImplEvents(t0) {
      var _ = this;
      _.lastPendingEvent = _.firstPendingEvent = null;
      _._state = 0;
      _.$ti = t0;
    },
    _StreamIterator: function _StreamIterator(t0) {
      this.$ti = t0;
    },
    AsyncError: function AsyncError(t0, t1) {
      this.error = t0;
      this.stackTrace = t1;
    },
    _Zone: function _Zone() {
    },
    _rootHandleUncaughtError_closure: function _rootHandleUncaughtError_closure(t0, t1) {
      this._box_0 = t0;
      this.stackTrace = t1;
    },
    _RootZone: function _RootZone() {
    },
    _RootZone_bindCallback_closure: function _RootZone_bindCallback_closure(t0, t1, t2) {
      this.$this = t0;
      this.f = t1;
      this.R = t2;
    },
    _RootZone_bindCallbackGuarded_closure: function _RootZone_bindCallbackGuarded_closure(t0, t1) {
      this.$this = t0;
      this.f = t1;
    },
    _HashMap__getTableEntry: function(table, key) {
      var entry = table[key];
      return entry === table ? null : entry;
    },
    _HashMap__setTableEntry: function(table, key, value) {
      if (value == null)
        table[key] = table;
      else
        table[key] = value;
    },
    _HashMap__newHashTable: function() {
      var table = Object.create(null);
      P._HashMap__setTableEntry(table, "<non-identifier-key>", table);
      delete table["<non-identifier-key>"];
      return table;
    },
    LinkedHashMap_LinkedHashMap$_literal: function(keyValuePairs, $K, $V) {
      return H.assertSubtype(H.fillLiteralMap(keyValuePairs, new H.JsLinkedHashMap([$K, $V])), "$isLinkedHashMap", [$K, $V], "$asLinkedHashMap");
    },
    LinkedHashMap_LinkedHashMap$_empty: function($K, $V) {
      return new H.JsLinkedHashMap([$K, $V]);
    },
    LinkedHashSet_LinkedHashSet: function($E) {
      return new P._LinkedHashSet([$E]);
    },
    LinkedHashSet_LinkedHashSet$_empty: function($E) {
      return new P._LinkedHashSet([$E]);
    },
    LinkedHashSet_LinkedHashSet$_literal: function(values, $E) {
      return H.assertSubtype(H.fillLiteralSet(values, new P._LinkedHashSet([$E])), "$isLinkedHashSet", [$E], "$asLinkedHashSet");
    },
    _LinkedHashSet__newHashTable: function() {
      var table = Object.create(null);
      table["<non-identifier-key>"] = table;
      delete table["<non-identifier-key>"];
      return table;
    },
    IterableBase_iterableToShortString: function(iterable, leftDelimiter, rightDelimiter) {
      var parts, t1;
      if (P._isToStringVisiting(iterable)) {
        if (leftDelimiter === "(" && rightDelimiter === ")")
          return "(...)";
        return leftDelimiter + "..." + rightDelimiter;
      }
      parts = H.setRuntimeTypeInfo([], [P.String]);
      C.JSArray_methods.add$1($._toStringVisiting, iterable);
      try {
        P._iterablePartsToStrings(iterable, parts);
      } finally {
        if (0 >= $._toStringVisiting.length)
          return H.ioore($._toStringVisiting, -1);
        $._toStringVisiting.pop();
      }
      t1 = P.StringBuffer__writeAll(leftDelimiter, H.listSuperNativeTypeCheck(parts, "$isIterable"), ", ") + rightDelimiter;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    IterableBase_iterableToFullString: function(iterable, leftDelimiter, rightDelimiter) {
      var buffer, t1;
      if (P._isToStringVisiting(iterable))
        return leftDelimiter + "..." + rightDelimiter;
      buffer = new P.StringBuffer(leftDelimiter);
      C.JSArray_methods.add$1($._toStringVisiting, iterable);
      try {
        t1 = buffer;
        t1._contents = P.StringBuffer__writeAll(t1._contents, iterable, ", ");
      } finally {
        if (0 >= $._toStringVisiting.length)
          return H.ioore($._toStringVisiting, -1);
        $._toStringVisiting.pop();
      }
      buffer._contents += rightDelimiter;
      t1 = buffer._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    _isToStringVisiting: function(o) {
      var t1, i;
      for (t1 = $._toStringVisiting.length, i = 0; i < t1; ++i)
        if (o === $._toStringVisiting[i])
          return true;
      return false;
    },
    _iterablePartsToStrings: function(iterable, parts) {
      var next, ultimateString, penultimateString, penultimate, ultimate, ultimate0, elision,
        it = iterable.get$iterator(iterable),
        $length = 0, count = 0;
      while (true) {
        if (!($length < 80 || count < 3))
          break;
        if (!it.moveNext$0())
          return;
        next = H.S(it.get$current());
        C.JSArray_methods.add$1(parts, next);
        $length += next.length + 2;
        ++count;
      }
      if (!it.moveNext$0()) {
        if (count <= 5)
          return;
        if (0 >= parts.length)
          return H.ioore(parts, -1);
        ultimateString = parts.pop();
        if (0 >= parts.length)
          return H.ioore(parts, -1);
        penultimateString = parts.pop();
      } else {
        penultimate = it.get$current();
        ++count;
        if (!it.moveNext$0()) {
          if (count <= 4) {
            C.JSArray_methods.add$1(parts, H.S(penultimate));
            return;
          }
          ultimateString = H.S(penultimate);
          if (0 >= parts.length)
            return H.ioore(parts, -1);
          penultimateString = parts.pop();
          $length += ultimateString.length + 2;
        } else {
          ultimate = it.get$current();
          ++count;
          for (; it.moveNext$0(); penultimate = ultimate, ultimate = ultimate0) {
            ultimate0 = it.get$current();
            ++count;
            if (count > 100) {
              while (true) {
                if (!($length > 75 && count > 3))
                  break;
                if (0 >= parts.length)
                  return H.ioore(parts, -1);
                $length -= parts.pop().length + 2;
                --count;
              }
              C.JSArray_methods.add$1(parts, "...");
              return;
            }
          }
          penultimateString = H.S(penultimate);
          ultimateString = H.S(ultimate);
          $length += ultimateString.length + penultimateString.length + 4;
        }
      }
      if (count > parts.length + 2) {
        $length += 5;
        elision = "...";
      } else
        elision = null;
      while (true) {
        if (!($length > 80 && parts.length > 3))
          break;
        if (0 >= parts.length)
          return H.ioore(parts, -1);
        $length -= parts.pop().length + 2;
        if (elision == null) {
          $length += 5;
          elision = "...";
        }
      }
      if (elision != null)
        C.JSArray_methods.add$1(parts, elision);
      C.JSArray_methods.add$1(parts, penultimateString);
      C.JSArray_methods.add$1(parts, ultimateString);
    },
    LinkedHashSet_LinkedHashSet$from: function(elements, $E) {
      var t1,
        result = P.LinkedHashSet_LinkedHashSet($E);
      for (t1 = J.get$iterator$ax(elements); t1.moveNext$0();)
        result.add$1(0, H.assertSubtypeOfRuntimeType(t1.get$current(), $E));
      return result;
    },
    MapBase_mapToString: function(m) {
      var result, t1 = {};
      if (P._isToStringVisiting(m))
        return "{...}";
      result = new P.StringBuffer("");
      try {
        C.JSArray_methods.add$1($._toStringVisiting, m);
        result._contents += "{";
        t1.first = true;
        m.forEach$1(0, new P.MapBase_mapToString_closure(t1, result));
        result._contents += "}";
      } finally {
        if (0 >= $._toStringVisiting.length)
          return H.ioore($._toStringVisiting, -1);
        $._toStringVisiting.pop();
      }
      t1 = result._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    _HashMap: function _HashMap() {
    },
    _IdentityHashMap: function _IdentityHashMap(t0) {
      var _ = this;
      _._collection$_length = 0;
      _._keys = _._rest = _._nums = _._strings = null;
      _.$ti = t0;
    },
    _HashMapKeyIterable: function _HashMapKeyIterable(t0, t1) {
      this._map = t0;
      this.$ti = t1;
    },
    _HashMapKeyIterator: function _HashMapKeyIterator(t0, t1, t2) {
      var _ = this;
      _._map = t0;
      _._keys = t1;
      _._offset = 0;
      _._collection$_current = null;
      _.$ti = t2;
    },
    _LinkedHashSet: function _LinkedHashSet(t0) {
      var _ = this;
      _._collection$_length = 0;
      _._collection$_last = _._collection$_first = _._rest = _._nums = _._strings = null;
      _._collection$_modifications = 0;
      _.$ti = t0;
    },
    _LinkedHashSetCell: function _LinkedHashSetCell(t0) {
      this._element = t0;
      this._previous = this._collection$_next = null;
    },
    _LinkedHashSetIterator: function _LinkedHashSetIterator(t0, t1, t2) {
      var _ = this;
      _._set = t0;
      _._collection$_modifications = t1;
      _._collection$_current = _._collection$_cell = null;
      _.$ti = t2;
    },
    UnmodifiableListView: function UnmodifiableListView(t0, t1) {
      this._collection$_source = t0;
      this.$ti = t1;
    },
    IterableBase: function IterableBase() {
    },
    ListBase: function ListBase() {
    },
    ListMixin: function ListMixin() {
    },
    MapBase: function MapBase() {
    },
    MapBase_mapToString_closure: function MapBase_mapToString_closure(t0, t1) {
      this._box_0 = t0;
      this.result = t1;
    },
    MapMixin: function MapMixin() {
    },
    MapMixin_entries_closure: function MapMixin_entries_closure(t0) {
      this.$this = t0;
    },
    _UnmodifiableMapMixin: function _UnmodifiableMapMixin() {
    },
    MapView: function MapView() {
    },
    UnmodifiableMapView: function UnmodifiableMapView(t0, t1) {
      this._map = t0;
      this.$ti = t1;
    },
    _SetBase: function _SetBase() {
    },
    _UnmodifiableSet: function _UnmodifiableSet(t0, t1) {
      this._map = t0;
      this.$ti = t1;
    },
    _ListBase_Object_ListMixin: function _ListBase_Object_ListMixin() {
    },
    _UnmodifiableMapView_MapView__UnmodifiableMapMixin: function _UnmodifiableMapView_MapView__UnmodifiableMapMixin() {
    },
    _parseJson: function(source, reviver) {
      var e, exception, t1, parsed = null;
      try {
        parsed = JSON.parse(source);
      } catch (exception) {
        e = H.unwrapException(exception);
        t1 = P.FormatException$(String(e), null, null);
        throw H.wrapException(t1);
      }
      t1 = P._convertJsonToDartLazy(parsed);
      return t1;
    },
    _convertJsonToDartLazy: function(object) {
      var i;
      if (object == null)
        return;
      if (typeof object != "object")
        return object;
      if (Object.getPrototypeOf(object) !== Array.prototype)
        return new P._JsonMap(object, Object.create(null));
      for (i = 0; i < object.length; ++i)
        object[i] = P._convertJsonToDartLazy(object[i]);
      return object;
    },
    Utf8Decoder__convertIntercepted: function(allowMalformed, codeUnits, start, end) {
      if (codeUnits instanceof Uint8Array)
        return P.Utf8Decoder__convertInterceptedUint8List(false, codeUnits, start, end);
      return;
    },
    Utf8Decoder__convertInterceptedUint8List: function(allowMalformed, codeUnits, start, end) {
      var t1, $length,
        decoder = $.$get$Utf8Decoder__decoder();
      if (decoder == null)
        return;
      t1 = 0 === start;
      if (t1 && true)
        return P.Utf8Decoder__useTextDecoderChecked(decoder, codeUnits);
      $length = codeUnits.length;
      end = P.RangeError_checkValidRange(start, end, $length);
      if (t1 && end === $length)
        return P.Utf8Decoder__useTextDecoderChecked(decoder, codeUnits);
      return P.Utf8Decoder__useTextDecoderChecked(decoder, codeUnits.subarray(start, end));
    },
    Utf8Decoder__useTextDecoderChecked: function(decoder, codeUnits) {
      if (P.Utf8Decoder__unsafe(codeUnits))
        return;
      return P.Utf8Decoder__useTextDecoderUnchecked(decoder, codeUnits);
    },
    Utf8Decoder__useTextDecoderUnchecked: function(decoder, codeUnits) {
      var t1, exception;
      try {
        t1 = decoder.decode(codeUnits);
        return t1;
      } catch (exception) {
        H.unwrapException(exception);
      }
      return;
    },
    Utf8Decoder__unsafe: function(codeUnits) {
      var i,
        limit = codeUnits.length - 2;
      for (i = 0; i < limit; ++i)
        if (codeUnits[i] === 237)
          if ((codeUnits[i + 1] & 224) === 160)
            return true;
      return false;
    },
    Utf8Decoder__makeDecoder: function() {
      var t1, exception;
      try {
        t1 = new TextDecoder("utf-8", {fatal: true});
        return t1;
      } catch (exception) {
        H.unwrapException(exception);
      }
      return;
    },
    _scanOneByteCharacters: function(units, from, endIndex) {
      var t1, i, unit;
      for (t1 = J.getInterceptor$asx(units), i = from; i < endIndex; ++i) {
        unit = t1.$index(units, i);
        if (typeof unit !== "number")
          return unit.$and();
        if ((unit & 127) !== unit)
          return i - from;
      }
      return endIndex - from;
    },
    Base64Codec__checkPadding: function(source, sourceIndex, sourceEnd, firstPadding, paddingCount, $length) {
      if (C.JSInt_methods.$mod($length, 4) !== 0)
        throw H.wrapException(P.FormatException$("Invalid base64 padding, padded length must be multiple of four, is " + $length, source, sourceEnd));
      if (firstPadding + paddingCount !== $length)
        throw H.wrapException(P.FormatException$("Invalid base64 padding, '=' not at the end", source, sourceIndex));
      if (paddingCount > 2)
        throw H.wrapException(P.FormatException$("Invalid base64 padding, more than two '=' characters", source, sourceIndex));
    },
    _Base64Decoder_decodeChunk: function(input, start, end, output, outIndex, state) {
      var i, charOr, char, t1, t2, code, outIndex0, expectedPadding,
        _s31_ = "Invalid encoding before padding",
        _s17_ = "Invalid character",
        bits = C.JSInt_methods._shrOtherPositive$1(state, 2),
        count = state & 3;
      for (i = start, charOr = 0; i < end; ++i) {
        char = C.JSString_methods.codeUnitAt$1(input, i);
        charOr |= char;
        t1 = $.$get$_Base64Decoder__inverseAlphabet();
        t2 = char & 127;
        if (t2 >= t1.length)
          return H.ioore(t1, t2);
        code = t1[t2];
        if (code >= 0) {
          bits = (bits << 6 | code) & 16777215;
          count = count + 1 & 3;
          if (count === 0) {
            outIndex0 = outIndex + 1;
            t1 = output.length;
            if (outIndex >= t1)
              return H.ioore(output, outIndex);
            output[outIndex] = bits >>> 16 & 255;
            outIndex = outIndex0 + 1;
            if (outIndex0 >= t1)
              return H.ioore(output, outIndex0);
            output[outIndex0] = bits >>> 8 & 255;
            outIndex0 = outIndex + 1;
            if (outIndex >= t1)
              return H.ioore(output, outIndex);
            output[outIndex] = bits & 255;
            outIndex = outIndex0;
            bits = 0;
          }
          continue;
        } else if (code === -1 && count > 1) {
          if (charOr > 127)
            break;
          if (count === 3) {
            if ((bits & 3) !== 0)
              throw H.wrapException(P.FormatException$(_s31_, input, i));
            outIndex0 = outIndex + 1;
            t1 = output.length;
            if (outIndex >= t1)
              return H.ioore(output, outIndex);
            output[outIndex] = bits >>> 10;
            if (outIndex0 >= t1)
              return H.ioore(output, outIndex0);
            output[outIndex0] = bits >>> 2;
          } else {
            if ((bits & 15) !== 0)
              throw H.wrapException(P.FormatException$(_s31_, input, i));
            if (outIndex >= output.length)
              return H.ioore(output, outIndex);
            output[outIndex] = bits >>> 4;
          }
          expectedPadding = (3 - count) * 3;
          if (char === 37)
            expectedPadding += 2;
          return P._Base64Decoder__checkPadding(input, i + 1, end, -expectedPadding - 1);
        }
        throw H.wrapException(P.FormatException$(_s17_, input, i));
      }
      if (charOr >= 0 && charOr <= 127)
        return (bits << 2 | count) >>> 0;
      for (i = start; i < end; ++i) {
        char = C.JSString_methods.codeUnitAt$1(input, i);
        if (char > 127)
          break;
      }
      throw H.wrapException(P.FormatException$(_s17_, input, i));
    },
    _Base64Decoder__allocateBuffer: function(input, start, end, state) {
      var paddingStart = P._Base64Decoder__trimPaddingChars(input, start, end),
        $length = (state & 3) + (paddingStart - start),
        bufferLength = C.JSInt_methods._shrOtherPositive$1($length, 2) * 3,
        remainderLength = $length & 3;
      if (remainderLength !== 0 && paddingStart < end)
        bufferLength += remainderLength - 1;
      if (bufferLength > 0)
        return new Uint8Array(bufferLength);
      return;
    },
    _Base64Decoder__trimPaddingChars: function(input, start, end) {
      var char,
        newEnd = end,
        index = newEnd,
        padding = 0;
      while (true) {
        if (!(index > start && padding < 2))
          break;
        c$0: {
          --index;
          char = C.JSString_methods.codeUnitAt$1(input, index);
          if (char === 61) {
            ++padding;
            newEnd = index;
            break c$0;
          }
          if ((char | 32) === 100) {
            if (index === start)
              break;
            --index;
            char = C.JSString_methods.codeUnitAt$1(input, index);
          }
          if (char === 51) {
            if (index === start)
              break;
            --index;
            char = C.JSString_methods.codeUnitAt$1(input, index);
          }
          if (char === 37) {
            ++padding;
            newEnd = index;
            break c$0;
          }
          break;
        }
      }
      return newEnd;
    },
    _Base64Decoder__checkPadding: function(input, start, end, state) {
      var expectedPadding, char;
      if (start === end)
        return state;
      expectedPadding = -state - 1;
      for (; expectedPadding > 0;) {
        char = C.JSString_methods.codeUnitAt$1(input, start);
        if (expectedPadding === 3) {
          if (char === 61) {
            expectedPadding -= 3;
            ++start;
            break;
          }
          if (char === 37) {
            --expectedPadding;
            ++start;
            if (start === end)
              break;
            char = C.JSString_methods.codeUnitAt$1(input, start);
          } else
            break;
        }
        if ((expectedPadding > 3 ? expectedPadding - 3 : expectedPadding) === 2) {
          if (char !== 51)
            break;
          ++start;
          --expectedPadding;
          if (start === end)
            break;
          char = C.JSString_methods.codeUnitAt$1(input, start);
        }
        if ((char | 32) !== 100)
          break;
        ++start;
        --expectedPadding;
        if (start === end)
          break;
      }
      if (start !== end)
        throw H.wrapException(P.FormatException$("Invalid padding character", input, start));
      return -expectedPadding - 1;
    },
    _JsonMap: function _JsonMap(t0, t1) {
      this._original = t0;
      this._processed = t1;
      this._data = null;
    },
    _JsonMapKeyIterable: function _JsonMapKeyIterable(t0) {
      this._convert$_parent = t0;
    },
    _JsonDecoderSink: function _JsonDecoderSink(t0, t1, t2) {
      this._reviver = t0;
      this._sink = t1;
      this._stringSink = t2;
    },
    Base64Codec: function Base64Codec() {
    },
    Base64Encoder: function Base64Encoder() {
    },
    Base64Decoder: function Base64Decoder() {
    },
    _Base64Decoder: function _Base64Decoder() {
      this._convert$_state = 0;
    },
    ByteConversionSink: function ByteConversionSink() {
    },
    ChunkedConversionSink: function ChunkedConversionSink() {
    },
    _SimpleCallbackSink: function _SimpleCallbackSink(t0, t1, t2) {
      this._callback = t0;
      this._accumulated = t1;
      this.$ti = t2;
    },
    Codec: function Codec() {
    },
    Converter: function Converter() {
    },
    Encoding: function Encoding() {
    },
    JsonCodec: function JsonCodec() {
    },
    JsonDecoder: function JsonDecoder(t0) {
      this._reviver = t0;
    },
    StringConversionSinkBase: function StringConversionSinkBase() {
    },
    StringConversionSinkMixin: function StringConversionSinkMixin() {
    },
    _StringSinkConversionSink: function _StringSinkConversionSink() {
    },
    _Utf8StringSinkAdapter: function _Utf8StringSinkAdapter(t0, t1) {
      this._decoder = t0;
      this._sink = t1;
    },
    Utf8Codec: function Utf8Codec() {
    },
    Utf8Decoder: function Utf8Decoder(t0) {
      this._allowMalformed = t0;
    },
    _Utf8Decoder: function _Utf8Decoder(t0, t1) {
      var _ = this;
      _._allowMalformed = t0;
      _._stringSink = t1;
      _._isFirstCharacter = true;
      _._extraUnits = _._expectedUnits = _._convert$_value = 0;
    },
    int_parse: function(source, onError, radix) {
      var value = H.Primitives_parseInt(source, radix);
      if (value != null)
        return value;
      if (onError != null)
        return onError.call$1(source);
      throw H.wrapException(P.FormatException$(source, null, null));
    },
    Error__objectToString: function(object) {
      if (object instanceof H.Closure)
        return object.toString$0(0);
      return "Instance of '" + H.S(H.Primitives_objectTypeName(object)) + "'";
    },
    List_List$filled: function($length, fill, $E) {
      var i,
        result = J.JSArray_JSArray$fixed($length, $E);
      if ($length !== 0 && true)
        for (i = 0; i < result.length; ++i)
          C.JSArray_methods.$indexSet(result, i, fill);
      return H.assertSubtype(result, "$isList", [$E], "$asList");
    },
    List_List$from: function(elements, growable, $E) {
      var t2,
        t1 = [$E],
        list = H.setRuntimeTypeInfo([], t1);
      for (t2 = J.get$iterator$ax(elements); t2.moveNext$0();)
        C.JSArray_methods.add$1(list, H.assertSubtypeOfRuntimeType(t2.get$current(), $E));
      if (growable)
        return list;
      return H.assertSubtype(J.JSArray_markFixedList(list), "$isList", t1, "$asList");
    },
    String_String$fromCharCodes: function(charCodes, start, end) {
      var len;
      if (typeof charCodes === "object" && charCodes !== null && charCodes.constructor === Array) {
        H.assertSubtype(charCodes, "$isJSArray", [P.int], "$asJSArray");
        len = charCodes.length;
        end = P.RangeError_checkValidRange(start, end, len);
        return H.Primitives_stringFromCharCodes(start > 0 || end < len ? C.JSArray_methods.sublist$2(charCodes, start, end) : charCodes);
      }
      if (!!J.getInterceptor$(charCodes).$isNativeUint8List)
        return H.Primitives_stringFromNativeUint8List(charCodes, start, P.RangeError_checkValidRange(start, end, charCodes.length));
      return P.String__stringFromIterable(charCodes, start, end);
    },
    String__stringFromIterable: function(charCodes, start, end) {
      var t1, it, i, list, _null = null;
      if (start < 0)
        throw H.wrapException(P.RangeError$range(start, 0, J.get$length$asx(charCodes), _null, _null));
      t1 = end == null;
      if (!t1 && end < start)
        throw H.wrapException(P.RangeError$range(end, start, J.get$length$asx(charCodes), _null, _null));
      it = J.get$iterator$ax(charCodes);
      for (i = 0; i < start; ++i)
        if (!it.moveNext$0())
          throw H.wrapException(P.RangeError$range(start, 0, i, _null, _null));
      list = [];
      if (t1)
        for (; it.moveNext$0();)
          list.push(it.get$current());
      else
        for (i = start; i < end; ++i) {
          if (!it.moveNext$0())
            throw H.wrapException(P.RangeError$range(end, start, i, _null, _null));
          list.push(it.get$current());
        }
      return H.Primitives_stringFromCharCodes(list);
    },
    RegExp_RegExp: function(source) {
      return new H.JSSyntaxRegExp(source, H.JSSyntaxRegExp_makeNative(source, false, true, false, false, false));
    },
    StringBuffer__writeAll: function(string, objects, separator) {
      var iterator = J.get$iterator$ax(objects);
      if (!iterator.moveNext$0())
        return string;
      if (separator.length === 0) {
        do
          string += H.S(iterator.get$current());
        while (iterator.moveNext$0());
      } else {
        string += H.S(iterator.get$current());
        for (; iterator.moveNext$0();)
          string = string + separator + H.S(iterator.get$current());
      }
      return string;
    },
    NoSuchMethodError$: function(receiver, memberName, positionalArguments, namedArguments) {
      return new P.NoSuchMethodError(receiver, memberName, positionalArguments, namedArguments);
    },
    DateTime__fourDigits: function(n) {
      var absN = Math.abs(n),
        sign = n < 0 ? "-" : "";
      if (absN >= 1000)
        return "" + n;
      if (absN >= 100)
        return sign + "0" + absN;
      if (absN >= 10)
        return sign + "00" + absN;
      return sign + "000" + absN;
    },
    DateTime__sixDigits: function(n) {
      var absN = Math.abs(n),
        sign = n < 0 ? "-" : "+";
      if (absN >= 100000)
        return sign + absN;
      return sign + "0" + absN;
    },
    DateTime__threeDigits: function(n) {
      if (n >= 100)
        return "" + n;
      if (n >= 10)
        return "0" + n;
      return "00" + n;
    },
    DateTime__twoDigits: function(n) {
      if (n >= 10)
        return "" + n;
      return "0" + n;
    },
    Error_safeToString: function(object) {
      if (typeof object === "number" || typeof object === "boolean" || null == object)
        return J.toString$0$(object);
      if (typeof object === "string")
        return JSON.stringify(object);
      return P.Error__objectToString(object);
    },
    ArgumentError$: function(message) {
      return new P.ArgumentError(false, null, null, message);
    },
    ArgumentError$value: function(value, $name, message) {
      return new P.ArgumentError(true, value, $name, message);
    },
    ArgumentError$notNull: function($name) {
      return new P.ArgumentError(false, null, $name, "Must not be null");
    },
    RangeError$value: function(value, $name) {
      return new P.RangeError(null, null, true, value, $name, "Value not in range");
    },
    RangeError$range: function(invalidValue, minValue, maxValue, $name, message) {
      return new P.RangeError(minValue, maxValue, true, invalidValue, $name, "Invalid value");
    },
    RangeError_checkValidRange: function(start, end, $length) {
      if (0 > start || start > $length)
        throw H.wrapException(P.RangeError$range(start, 0, $length, "start", null));
      if (end != null) {
        if (start > end || end > $length)
          throw H.wrapException(P.RangeError$range(end, start, $length, "end", null));
        return end;
      }
      return $length;
    },
    RangeError_checkNotNegative: function(value, $name) {
      if (typeof value !== "number")
        return value.$lt();
      if (value < 0)
        throw H.wrapException(P.RangeError$range(value, 0, null, $name, null));
    },
    IndexError$: function(invalidValue, indexable, $name, message, $length) {
      var t1 = H.intTypeCheck($length == null ? J.get$length$asx(indexable) : $length);
      return new P.IndexError(t1, true, invalidValue, $name, "Index out of range");
    },
    UnsupportedError$: function(message) {
      return new P.UnsupportedError(message);
    },
    UnimplementedError$: function(message) {
      return new P.UnimplementedError(message);
    },
    StateError$: function(message) {
      return new P.StateError(message);
    },
    ConcurrentModificationError$: function(modifiedObject) {
      return new P.ConcurrentModificationError(modifiedObject);
    },
    FormatException$: function(message, source, offset) {
      return new P.FormatException(message, source, offset);
    },
    Iterable_Iterable$generate: function(count, generator, $E) {
      if (count <= 0)
        return new H.EmptyIterable([$E]);
      return new P._GeneratorIterable(count, generator, [$E]);
    },
    List_List$generate: function($length, generator, growable, $E) {
      var result, t1, i;
      if (growable) {
        result = H.setRuntimeTypeInfo([], [$E]);
        C.JSArray_methods.set$length(result, $length);
      } else {
        t1 = new Array($length);
        t1.fixed$length = Array;
        result = H.setRuntimeTypeInfo(t1, [$E]);
      }
      for (i = 0; i < $length; ++i)
        C.JSArray_methods.$indexSet(result, i, generator.call$1(i));
      return result;
    },
    Map_castFrom: function(source, $K, $V, K2, V2) {
      return new H.CastMap(source, [$K, $V, K2, V2]);
    },
    Uri_parse: function(uri) {
      var dataDelta, t1, indices, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, isSimple, scheme, t2, schemeAuth, delta, queryStart0, pathStart0, _null = null,
        end = uri.length;
      if (end >= 5) {
        dataDelta = P._startsWithData(uri, 0);
        if (dataDelta === 0) {
          t1 = P.UriData__parse(end < end ? C.JSString_methods.substring$2(uri, 0, end) : uri, 5, _null);
          return t1.get$uri(t1);
        } else if (dataDelta === 32) {
          t1 = P.UriData__parse(C.JSString_methods.substring$2(uri, 5, end), 0, _null);
          return t1.get$uri(t1);
        }
      }
      t1 = new Array(8);
      t1.fixed$length = Array;
      indices = H.setRuntimeTypeInfo(t1, [P.int]);
      C.JSArray_methods.$indexSet(indices, 0, 0);
      C.JSArray_methods.$indexSet(indices, 1, -1);
      C.JSArray_methods.$indexSet(indices, 2, -1);
      C.JSArray_methods.$indexSet(indices, 7, -1);
      C.JSArray_methods.$indexSet(indices, 3, 0);
      C.JSArray_methods.$indexSet(indices, 4, 0);
      C.JSArray_methods.$indexSet(indices, 5, end);
      C.JSArray_methods.$indexSet(indices, 6, end);
      if (P._scan(uri, 0, end, 0, indices) >= 14)
        C.JSArray_methods.$indexSet(indices, 7, end);
      schemeEnd = indices[1];
      if (typeof schemeEnd !== "number")
        return schemeEnd.$ge();
      if (schemeEnd >= 0)
        if (P._scan(uri, 0, schemeEnd, 20, indices) === 20)
          indices[7] = schemeEnd;
      t1 = indices[2];
      if (typeof t1 !== "number")
        return t1.$add();
      hostStart = t1 + 1;
      portStart = indices[3];
      pathStart = indices[4];
      queryStart = indices[5];
      fragmentStart = indices[6];
      if (typeof fragmentStart !== "number")
        return fragmentStart.$lt();
      if (typeof queryStart !== "number")
        return H.iae(queryStart);
      if (fragmentStart < queryStart)
        queryStart = fragmentStart;
      if (typeof pathStart !== "number")
        return pathStart.$lt();
      if (pathStart < hostStart)
        pathStart = queryStart;
      else if (pathStart <= schemeEnd)
        pathStart = schemeEnd + 1;
      if (typeof portStart !== "number")
        return portStart.$lt();
      if (portStart < hostStart)
        portStart = pathStart;
      t1 = indices[7];
      if (typeof t1 !== "number")
        return t1.$lt();
      isSimple = t1 < 0;
      if (isSimple)
        if (hostStart > schemeEnd + 3) {
          scheme = _null;
          isSimple = false;
        } else {
          t1 = portStart > 0;
          if (t1 && portStart + 1 === pathStart) {
            scheme = _null;
            isSimple = false;
          } else {
            if (!(queryStart < end && queryStart === pathStart + 2 && C.JSString_methods.startsWith$2(uri, "..", pathStart)))
              t2 = queryStart > pathStart + 2 && C.JSString_methods.startsWith$2(uri, "/..", queryStart - 3);
            else
              t2 = true;
            if (t2) {
              scheme = _null;
              isSimple = false;
            } else {
              if (schemeEnd === 4)
                if (C.JSString_methods.startsWith$2(uri, "file", 0)) {
                  if (hostStart <= 0) {
                    if (!C.JSString_methods.startsWith$2(uri, "/", pathStart)) {
                      schemeAuth = "file:///";
                      delta = 3;
                    } else {
                      schemeAuth = "file://";
                      delta = 2;
                    }
                    uri = schemeAuth + C.JSString_methods.substring$2(uri, pathStart, end);
                    schemeEnd -= 0;
                    t1 = delta - 0;
                    queryStart += t1;
                    fragmentStart += t1;
                    end = uri.length;
                    hostStart = 7;
                    portStart = 7;
                    pathStart = 7;
                  } else if (pathStart === queryStart) {
                    queryStart0 = queryStart + 1;
                    ++fragmentStart;
                    uri = C.JSString_methods.replaceRange$3(uri, pathStart, queryStart, "/");
                    ++end;
                    queryStart = queryStart0;
                  }
                  scheme = "file";
                } else if (C.JSString_methods.startsWith$2(uri, "http", 0)) {
                  if (t1 && portStart + 3 === pathStart && C.JSString_methods.startsWith$2(uri, "80", portStart + 1)) {
                    pathStart0 = pathStart - 3;
                    queryStart -= 3;
                    fragmentStart -= 3;
                    uri = C.JSString_methods.replaceRange$3(uri, portStart, pathStart, "");
                    end -= 3;
                    pathStart = pathStart0;
                  }
                  scheme = "http";
                } else
                  scheme = _null;
              else if (schemeEnd === 5 && C.JSString_methods.startsWith$2(uri, "https", 0)) {
                if (t1 && portStart + 4 === pathStart && C.JSString_methods.startsWith$2(uri, "443", portStart + 1)) {
                  pathStart0 = pathStart - 4;
                  queryStart -= 4;
                  fragmentStart -= 4;
                  uri = C.JSString_methods.replaceRange$3(uri, portStart, pathStart, "");
                  end -= 3;
                  pathStart = pathStart0;
                }
                scheme = "https";
              } else
                scheme = _null;
              isSimple = true;
            }
          }
        }
      else
        scheme = _null;
      if (isSimple) {
        if (end < uri.length) {
          uri = C.JSString_methods.substring$2(uri, 0, end);
          schemeEnd -= 0;
          hostStart -= 0;
          portStart -= 0;
          pathStart -= 0;
          queryStart -= 0;
          fragmentStart -= 0;
        }
        return new P._SimpleUri(uri, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, scheme);
      }
      return P._Uri__Uri$notSimple(uri, 0, end, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, scheme);
    },
    Uri__parseIPv4Address: function(host, start, end) {
      var t1, i, partStart, partIndex, char, part, partIndex0, _null = null,
        _s43_ = "IPv4 address should contain exactly 4 parts",
        _s37_ = "each part must be in the range 0..255",
        error = new P.Uri__parseIPv4Address_error(host),
        result = new Uint8Array(4);
      for (t1 = result.length, i = start, partStart = i, partIndex = 0; i < end; ++i) {
        char = C.JSString_methods.codeUnitAt$1(host, i);
        if (char !== 46) {
          if ((char ^ 48) > 9)
            error.call$2("invalid character", i);
        } else {
          if (partIndex === 3)
            error.call$2(_s43_, i);
          part = P.int_parse(C.JSString_methods.substring$2(host, partStart, i), _null, _null);
          if (typeof part !== "number")
            return part.$gt();
          if (part > 255)
            error.call$2(_s37_, partStart);
          partIndex0 = partIndex + 1;
          if (partIndex >= t1)
            return H.ioore(result, partIndex);
          result[partIndex] = part;
          partStart = i + 1;
          partIndex = partIndex0;
        }
      }
      if (partIndex !== 3)
        error.call$2(_s43_, end);
      part = P.int_parse(C.JSString_methods.substring$2(host, partStart, end), _null, _null);
      if (typeof part !== "number")
        return part.$gt();
      if (part > 255)
        error.call$2(_s37_, partStart);
      if (partIndex >= t1)
        return H.ioore(result, partIndex);
      result[partIndex] = part;
      return result;
    },
    Uri_parseIPv6Address: function(host, start, end) {
      var parts, i, partStart, wildcardSeen, seenDot, char, atEnd, t1, last, bytes, t2, wildCardLength, index, value, j, t3,
        error = new P.Uri_parseIPv6Address_error(host),
        parseHex = new P.Uri_parseIPv6Address_parseHex(error, host);
      if (host.length < 2)
        error.call$1("address is too short");
      parts = H.setRuntimeTypeInfo([], [P.int]);
      for (i = start, partStart = i, wildcardSeen = false, seenDot = false; i < end; ++i) {
        char = C.JSString_methods.codeUnitAt$1(host, i);
        if (char === 58) {
          if (i === start) {
            ++i;
            if (C.JSString_methods.codeUnitAt$1(host, i) !== 58)
              error.call$2("invalid start colon.", i);
            partStart = i;
          }
          if (i === partStart) {
            if (wildcardSeen)
              error.call$2("only one wildcard `::` is allowed", i);
            C.JSArray_methods.add$1(parts, -1);
            wildcardSeen = true;
          } else
            C.JSArray_methods.add$1(parts, parseHex.call$2(partStart, i));
          partStart = i + 1;
        } else if (char === 46)
          seenDot = true;
      }
      if (parts.length === 0)
        error.call$1("too few parts");
      atEnd = partStart === end;
      t1 = C.JSArray_methods.get$last(parts);
      if (atEnd && t1 !== -1)
        error.call$2("expected a part after last `:`", end);
      if (!atEnd)
        if (!seenDot)
          C.JSArray_methods.add$1(parts, parseHex.call$2(partStart, end));
        else {
          last = P.Uri__parseIPv4Address(host, partStart, end);
          C.JSArray_methods.add$1(parts, (last[0] << 8 | last[1]) >>> 0);
          C.JSArray_methods.add$1(parts, (last[2] << 8 | last[3]) >>> 0);
        }
      if (wildcardSeen) {
        if (parts.length > 7)
          error.call$1("an address with a wildcard must have less than 7 parts");
      } else if (parts.length !== 8)
        error.call$1("an address without a wildcard must contain exactly 8 parts");
      bytes = new Uint8Array(16);
      for (t1 = parts.length, t2 = bytes.length, wildCardLength = 9 - t1, i = 0, index = 0; i < t1; ++i) {
        value = parts[i];
        if (value === -1)
          for (j = 0; j < wildCardLength; ++j) {
            if (index < 0 || index >= t2)
              return H.ioore(bytes, index);
            bytes[index] = 0;
            t3 = index + 1;
            if (t3 >= t2)
              return H.ioore(bytes, t3);
            bytes[t3] = 0;
            index += 2;
          }
        else {
          t3 = C.JSInt_methods._shrOtherPositive$1(value, 8);
          if (index < 0 || index >= t2)
            return H.ioore(bytes, index);
          bytes[index] = t3;
          t3 = index + 1;
          if (t3 >= t2)
            return H.ioore(bytes, t3);
          bytes[t3] = value & 255;
          index += 2;
        }
      }
      return bytes;
    },
    _Uri__Uri$notSimple: function(uri, start, end, schemeEnd, hostStart, portStart, pathStart, queryStart, fragmentStart, scheme) {
      var userInfoStart, userInfo, host, t1, port, path, query, _null = null;
      if (scheme == null)
        if (schemeEnd > start)
          scheme = P._Uri__makeScheme(uri, start, schemeEnd);
        else {
          if (schemeEnd === start)
            P._Uri__fail(uri, start, "Invalid empty scheme");
          scheme = "";
        }
      if (hostStart > start) {
        userInfoStart = schemeEnd + 3;
        userInfo = userInfoStart < hostStart ? P._Uri__makeUserInfo(uri, userInfoStart, hostStart - 1) : "";
        host = P._Uri__makeHost(uri, hostStart, portStart, false);
        if (typeof portStart !== "number")
          return portStart.$add();
        t1 = portStart + 1;
        if (typeof pathStart !== "number")
          return H.iae(pathStart);
        port = t1 < pathStart ? P._Uri__makePort(P.int_parse(C.JSString_methods.substring$2(uri, t1, pathStart), new P._Uri__Uri$notSimple_closure(uri, portStart), _null), scheme) : _null;
      } else {
        port = _null;
        host = port;
        userInfo = "";
      }
      path = P._Uri__makePath(uri, pathStart, queryStart, _null, scheme, host != null);
      if (typeof queryStart !== "number")
        return queryStart.$lt();
      query = queryStart < fragmentStart ? P._Uri__makeQuery(uri, queryStart + 1, fragmentStart, _null) : _null;
      return new P._Uri(scheme, userInfo, host, port, path, query, fragmentStart < end ? P._Uri__makeFragment(uri, fragmentStart + 1, end) : _null);
    },
    _Uri__defaultPort: function(scheme) {
      if (scheme === "http")
        return 80;
      if (scheme === "https")
        return 443;
      return 0;
    },
    _Uri__fail: function(uri, index, message) {
      throw H.wrapException(P.FormatException$(message, uri, index));
    },
    _Uri__makePort: function(port, scheme) {
      if (port != null && port === P._Uri__defaultPort(scheme))
        return;
      return port;
    },
    _Uri__makeHost: function(host, start, end, strictIPv6) {
      var t1, t2, index, zoneIDstart, zoneID, i;
      if (start === end)
        return "";
      if (C.JSString_methods.codeUnitAt$1(host, start) === 91) {
        if (typeof end !== "number")
          return end.$sub();
        t1 = end - 1;
        if (C.JSString_methods.codeUnitAt$1(host, t1) !== 93)
          P._Uri__fail(host, start, "Missing end `]` to match `[` in host");
        t2 = start + 1;
        index = P._Uri__checkZoneID(host, t2, t1);
        if (typeof index !== "number")
          return index.$lt();
        if (index < t1) {
          zoneIDstart = index + 1;
          zoneID = P._Uri__normalizeZoneID(host, C.JSString_methods.startsWith$2(host, "25", zoneIDstart) ? index + 3 : zoneIDstart, t1, "%25");
        } else
          zoneID = "";
        P.Uri_parseIPv6Address(host, t2, index);
        return C.JSString_methods.substring$2(host, start, index).toLowerCase() + zoneID + "]";
      }
      if (typeof end !== "number")
        return H.iae(end);
      i = start;
      for (; i < end; ++i)
        if (C.JSString_methods.codeUnitAt$1(host, i) === 58) {
          index = C.JSString_methods.indexOf$2(host, "%", start);
          if (!(index >= start && index < end))
            index = end;
          if (index < end) {
            zoneIDstart = index + 1;
            zoneID = P._Uri__normalizeZoneID(host, C.JSString_methods.startsWith$2(host, "25", zoneIDstart) ? index + 3 : zoneIDstart, end, "%25");
          } else
            zoneID = "";
          P.Uri_parseIPv6Address(host, start, index);
          return "[" + C.JSString_methods.substring$2(host, start, index) + zoneID + "]";
        }
      return P._Uri__normalizeRegName(host, start, end);
    },
    _Uri__checkZoneID: function(host, start, end) {
      var t1,
        index = C.JSString_methods.indexOf$2(host, "%", start);
      if (index >= start) {
        if (typeof end !== "number")
          return H.iae(end);
        t1 = index < end;
      } else
        t1 = false;
      return t1 ? index : end;
    },
    _Uri__normalizeZoneID: function(host, start, end, prefix) {
      var index, sectionStart, isNormalized, char, replacement, t1, t2, tail, sourceLength,
        buffer = prefix !== "" ? new P.StringBuffer(prefix) : null;
      if (typeof end !== "number")
        return H.iae(end);
      index = start;
      sectionStart = index;
      isNormalized = true;
      for (; index < end;) {
        char = C.JSString_methods.codeUnitAt$1(host, index);
        if (char === 37) {
          replacement = P._Uri__normalizeEscape(host, index, true);
          t1 = replacement == null;
          if (t1 && isNormalized) {
            index += 3;
            continue;
          }
          if (buffer == null)
            buffer = new P.StringBuffer("");
          t2 = buffer._contents += C.JSString_methods.substring$2(host, sectionStart, index);
          if (t1)
            replacement = C.JSString_methods.substring$2(host, index, index + 3);
          else if (replacement === "%")
            P._Uri__fail(host, index, "ZoneID should not contain % anymore");
          buffer._contents = t2 + replacement;
          index += 3;
          sectionStart = index;
          isNormalized = true;
        } else {
          if (char < 127) {
            t1 = char >>> 4;
            if (t1 >= 8)
              return H.ioore(C.List_nxB, t1);
            t1 = (C.List_nxB[t1] & 1 << (char & 15)) !== 0;
          } else
            t1 = false;
          if (t1) {
            if (isNormalized && 65 <= char && 90 >= char) {
              if (buffer == null)
                buffer = new P.StringBuffer("");
              if (sectionStart < index) {
                buffer._contents += C.JSString_methods.substring$2(host, sectionStart, index);
                sectionStart = index;
              }
              isNormalized = false;
            }
            ++index;
          } else {
            if ((char & 64512) === 55296 && index + 1 < end) {
              tail = C.JSString_methods.codeUnitAt$1(host, index + 1);
              if ((tail & 64512) === 56320) {
                char = 65536 | (char & 1023) << 10 | tail & 1023;
                sourceLength = 2;
              } else
                sourceLength = 1;
            } else
              sourceLength = 1;
            if (buffer == null)
              buffer = new P.StringBuffer("");
            buffer._contents += C.JSString_methods.substring$2(host, sectionStart, index);
            buffer._contents += P._Uri__escapeChar(char);
            index += sourceLength;
            sectionStart = index;
          }
        }
      }
      if (buffer == null)
        return C.JSString_methods.substring$2(host, start, end);
      if (sectionStart < end)
        buffer._contents += C.JSString_methods.substring$2(host, sectionStart, end);
      t1 = buffer._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    _Uri__normalizeRegName: function(host, start, end) {
      var index, sectionStart, buffer, isNormalized, char, replacement, t1, slice, t2, sourceLength, tail;
      if (typeof end !== "number")
        return H.iae(end);
      index = start;
      sectionStart = index;
      buffer = null;
      isNormalized = true;
      for (; index < end;) {
        char = C.JSString_methods.codeUnitAt$1(host, index);
        if (char === 37) {
          replacement = P._Uri__normalizeEscape(host, index, true);
          t1 = replacement == null;
          if (t1 && isNormalized) {
            index += 3;
            continue;
          }
          if (buffer == null)
            buffer = new P.StringBuffer("");
          slice = C.JSString_methods.substring$2(host, sectionStart, index);
          t2 = buffer._contents += !isNormalized ? slice.toLowerCase() : slice;
          if (t1) {
            replacement = C.JSString_methods.substring$2(host, index, index + 3);
            sourceLength = 3;
          } else if (replacement === "%") {
            replacement = "%25";
            sourceLength = 1;
          } else
            sourceLength = 3;
          buffer._contents = t2 + replacement;
          index += sourceLength;
          sectionStart = index;
          isNormalized = true;
        } else {
          if (char < 127) {
            t1 = char >>> 4;
            if (t1 >= 8)
              return H.ioore(C.List_qNA, t1);
            t1 = (C.List_qNA[t1] & 1 << (char & 15)) !== 0;
          } else
            t1 = false;
          if (t1) {
            if (isNormalized && 65 <= char && 90 >= char) {
              if (buffer == null)
                buffer = new P.StringBuffer("");
              if (sectionStart < index) {
                buffer._contents += C.JSString_methods.substring$2(host, sectionStart, index);
                sectionStart = index;
              }
              isNormalized = false;
            }
            ++index;
          } else {
            if (char <= 93) {
              t1 = char >>> 4;
              if (t1 >= 8)
                return H.ioore(C.List_2Vk0, t1);
              t1 = (C.List_2Vk0[t1] & 1 << (char & 15)) !== 0;
            } else
              t1 = false;
            if (t1)
              P._Uri__fail(host, index, "Invalid character");
            else {
              if ((char & 64512) === 55296 && index + 1 < end) {
                tail = C.JSString_methods.codeUnitAt$1(host, index + 1);
                if ((tail & 64512) === 56320) {
                  char = 65536 | (char & 1023) << 10 | tail & 1023;
                  sourceLength = 2;
                } else
                  sourceLength = 1;
              } else
                sourceLength = 1;
              if (buffer == null)
                buffer = new P.StringBuffer("");
              slice = C.JSString_methods.substring$2(host, sectionStart, index);
              buffer._contents += !isNormalized ? slice.toLowerCase() : slice;
              buffer._contents += P._Uri__escapeChar(char);
              index += sourceLength;
              sectionStart = index;
            }
          }
        }
      }
      if (buffer == null)
        return C.JSString_methods.substring$2(host, start, end);
      if (sectionStart < end) {
        slice = C.JSString_methods.substring$2(host, sectionStart, end);
        buffer._contents += !isNormalized ? slice.toLowerCase() : slice;
      }
      t1 = buffer._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    _Uri__makeScheme: function(scheme, start, end) {
      var i, containsUpperCase, codeUnit, t1;
      if (start === end)
        return "";
      if (!P._Uri__isAlphabeticCharacter(C.JSString_methods._codeUnitAt$1(scheme, start)))
        P._Uri__fail(scheme, start, "Scheme not starting with alphabetic character");
      for (i = start, containsUpperCase = false; i < end; ++i) {
        codeUnit = C.JSString_methods._codeUnitAt$1(scheme, i);
        if (codeUnit < 128) {
          t1 = codeUnit >>> 4;
          if (t1 >= 8)
            return H.ioore(C.List_JYB, t1);
          t1 = (C.List_JYB[t1] & 1 << (codeUnit & 15)) !== 0;
        } else
          t1 = false;
        if (!t1)
          P._Uri__fail(scheme, i, "Illegal scheme character");
        if (65 <= codeUnit && codeUnit <= 90)
          containsUpperCase = true;
      }
      scheme = C.JSString_methods.substring$2(scheme, start, end);
      return P._Uri__canonicalizeScheme(containsUpperCase ? scheme.toLowerCase() : scheme);
    },
    _Uri__canonicalizeScheme: function(scheme) {
      if (scheme === "http")
        return "http";
      if (scheme === "file")
        return "file";
      if (scheme === "https")
        return "https";
      if (scheme === "package")
        return "package";
      return scheme;
    },
    _Uri__makeUserInfo: function(userInfo, start, end) {
      return P._Uri__normalizeOrSubstring(userInfo, start, end, C.List_gRj, false);
    },
    _Uri__makePath: function(path, start, end, pathSegments, scheme, hasAuthority) {
      var isFile = scheme === "file",
        ensureLeadingSlash = isFile || hasAuthority,
        result = P._Uri__normalizeOrSubstring(path, start, end, C.List_qg4, true);
      if (result.length === 0) {
        if (isFile)
          return "/";
      } else if (ensureLeadingSlash && !C.JSString_methods.startsWith$1(result, "/"))
        result = "/" + result;
      return P._Uri__normalizePath(result, scheme, hasAuthority);
    },
    _Uri__normalizePath: function(path, scheme, hasAuthority) {
      var t1 = scheme.length === 0;
      if (t1 && !hasAuthority && !C.JSString_methods.startsWith$1(path, "/"))
        return P._Uri__normalizeRelativePath(path, !t1 || hasAuthority);
      return P._Uri__removeDotSegments(path);
    },
    _Uri__makeQuery: function(query, start, end, queryParameters) {
      return P._Uri__normalizeOrSubstring(query, start, end, C.List_CVk, true);
    },
    _Uri__makeFragment: function(fragment, start, end) {
      return P._Uri__normalizeOrSubstring(fragment, start, end, C.List_CVk, true);
    },
    _Uri__normalizeEscape: function(source, index, lowerCase) {
      var firstDigit, secondDigit, firstDigitValue, secondDigitValue, value,
        t1 = index + 2;
      if (t1 >= source.length)
        return "%";
      firstDigit = C.JSString_methods.codeUnitAt$1(source, index + 1);
      secondDigit = C.JSString_methods.codeUnitAt$1(source, t1);
      firstDigitValue = H.hexDigitValue(firstDigit);
      secondDigitValue = H.hexDigitValue(secondDigit);
      if (firstDigitValue < 0 || secondDigitValue < 0)
        return "%";
      value = firstDigitValue * 16 + secondDigitValue;
      if (value < 127) {
        t1 = C.JSInt_methods._shrOtherPositive$1(value, 4);
        if (t1 >= 8)
          return H.ioore(C.List_nxB, t1);
        t1 = (C.List_nxB[t1] & 1 << (value & 15)) !== 0;
      } else
        t1 = false;
      if (t1)
        return H.Primitives_stringFromCharCode(lowerCase && 65 <= value && 90 >= value ? (value | 32) >>> 0 : value);
      if (firstDigit >= 97 || secondDigit >= 97)
        return C.JSString_methods.substring$2(source, index, index + 3).toUpperCase();
      return;
    },
    _Uri__escapeChar: function(char) {
      var t1, codeUnits, flag, encodedBytes, index, byte,
        _s16_ = "0123456789ABCDEF";
      if (char < 128) {
        t1 = new Array(3);
        t1.fixed$length = Array;
        codeUnits = H.setRuntimeTypeInfo(t1, [P.int]);
        C.JSArray_methods.$indexSet(codeUnits, 0, 37);
        C.JSArray_methods.$indexSet(codeUnits, 1, C.JSString_methods._codeUnitAt$1(_s16_, char >>> 4));
        C.JSArray_methods.$indexSet(codeUnits, 2, C.JSString_methods._codeUnitAt$1(_s16_, char & 15));
      } else {
        if (char > 2047)
          if (char > 65535) {
            flag = 240;
            encodedBytes = 4;
          } else {
            flag = 224;
            encodedBytes = 3;
          }
        else {
          flag = 192;
          encodedBytes = 2;
        }
        t1 = new Array(3 * encodedBytes);
        t1.fixed$length = Array;
        codeUnits = H.setRuntimeTypeInfo(t1, [P.int]);
        for (index = 0; --encodedBytes, encodedBytes >= 0; flag = 128) {
          byte = C.JSInt_methods._shrReceiverPositive$1(char, 6 * encodedBytes) & 63 | flag;
          C.JSArray_methods.$indexSet(codeUnits, index, 37);
          C.JSArray_methods.$indexSet(codeUnits, index + 1, C.JSString_methods._codeUnitAt$1(_s16_, byte >>> 4));
          C.JSArray_methods.$indexSet(codeUnits, index + 2, C.JSString_methods._codeUnitAt$1(_s16_, byte & 15));
          index += 3;
        }
      }
      return P.String_String$fromCharCodes(codeUnits, 0, null);
    },
    _Uri__normalizeOrSubstring: function(component, start, end, charTable, escapeDelimiters) {
      var t1 = P._Uri__normalize(component, start, end, charTable, escapeDelimiters);
      return t1 == null ? C.JSString_methods.substring$2(component, start, end) : t1;
    },
    _Uri__normalize: function(component, start, end, charTable, escapeDelimiters) {
      var char, t2, replacement, sourceLength, tail,
        t1 = !escapeDelimiters,
        index = start,
        sectionStart = index,
        buffer = null;
      while (true) {
        if (typeof index !== "number")
          return index.$lt();
        if (typeof end !== "number")
          return H.iae(end);
        if (!(index < end))
          break;
        c$0: {
          char = C.JSString_methods.codeUnitAt$1(component, index);
          if (char < 127) {
            t2 = char >>> 4;
            if (t2 >= 8)
              return H.ioore(charTable, t2);
            t2 = (charTable[t2] & 1 << (char & 15)) !== 0;
          } else
            t2 = false;
          if (t2)
            ++index;
          else {
            if (char === 37) {
              replacement = P._Uri__normalizeEscape(component, index, false);
              if (replacement == null) {
                index += 3;
                break c$0;
              }
              if ("%" === replacement) {
                replacement = "%25";
                sourceLength = 1;
              } else
                sourceLength = 3;
            } else {
              if (t1)
                if (char <= 93) {
                  t2 = char >>> 4;
                  if (t2 >= 8)
                    return H.ioore(C.List_2Vk0, t2);
                  t2 = (C.List_2Vk0[t2] & 1 << (char & 15)) !== 0;
                } else
                  t2 = false;
              else
                t2 = false;
              if (t2) {
                P._Uri__fail(component, index, "Invalid character");
                replacement = null;
                sourceLength = null;
              } else {
                if ((char & 64512) === 55296) {
                  t2 = index + 1;
                  if (t2 < end) {
                    tail = C.JSString_methods.codeUnitAt$1(component, t2);
                    if ((tail & 64512) === 56320) {
                      char = 65536 | (char & 1023) << 10 | tail & 1023;
                      sourceLength = 2;
                    } else
                      sourceLength = 1;
                  } else
                    sourceLength = 1;
                } else
                  sourceLength = 1;
                replacement = P._Uri__escapeChar(char);
              }
            }
            if (buffer == null)
              buffer = new P.StringBuffer("");
            buffer._contents += C.JSString_methods.substring$2(component, sectionStart, index);
            buffer._contents += H.S(replacement);
            if (typeof sourceLength !== "number")
              return H.iae(sourceLength);
            index += sourceLength;
            sectionStart = index;
          }
        }
      }
      if (buffer == null)
        return;
      if (typeof sectionStart !== "number")
        return sectionStart.$lt();
      if (sectionStart < end)
        buffer._contents += C.JSString_methods.substring$2(component, sectionStart, end);
      t1 = buffer._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    _Uri__mayContainDotSegments: function(path) {
      if (C.JSString_methods.startsWith$1(path, "."))
        return true;
      return C.JSString_methods.indexOf$1(path, "/.") !== -1;
    },
    _Uri__removeDotSegments: function(path) {
      var output, t1, t2, appendSlash, _i, segment, t3;
      if (!P._Uri__mayContainDotSegments(path))
        return path;
      output = H.setRuntimeTypeInfo([], [P.String]);
      for (t1 = path.split("/"), t2 = t1.length, appendSlash = false, _i = 0; _i < t2; ++_i) {
        segment = t1[_i];
        if (J.$eq$(segment, "..")) {
          t3 = output.length;
          if (t3 !== 0) {
            if (0 >= t3)
              return H.ioore(output, -1);
            output.pop();
            if (output.length === 0)
              C.JSArray_methods.add$1(output, "");
          }
          appendSlash = true;
        } else if ("." === segment)
          appendSlash = true;
        else {
          C.JSArray_methods.add$1(output, segment);
          appendSlash = false;
        }
      }
      if (appendSlash)
        C.JSArray_methods.add$1(output, "");
      return C.JSArray_methods.join$1(output, "/");
    },
    _Uri__normalizeRelativePath: function(path, allowScheme) {
      var output, t1, t2, appendSlash, _i, segment;
      if (!P._Uri__mayContainDotSegments(path))
        return !allowScheme ? P._Uri__escapeScheme(path) : path;
      output = H.setRuntimeTypeInfo([], [P.String]);
      for (t1 = path.split("/"), t2 = t1.length, appendSlash = false, _i = 0; _i < t2; ++_i) {
        segment = t1[_i];
        if (".." === segment)
          if (output.length !== 0 && C.JSArray_methods.get$last(output) !== "..") {
            if (0 >= output.length)
              return H.ioore(output, -1);
            output.pop();
            appendSlash = true;
          } else {
            C.JSArray_methods.add$1(output, "..");
            appendSlash = false;
          }
        else if ("." === segment)
          appendSlash = true;
        else {
          C.JSArray_methods.add$1(output, segment);
          appendSlash = false;
        }
      }
      t1 = output.length;
      if (t1 !== 0)
        if (t1 === 1) {
          if (0 >= t1)
            return H.ioore(output, 0);
          t1 = output[0].length === 0;
        } else
          t1 = false;
      else
        t1 = true;
      if (t1)
        return "./";
      if (appendSlash || C.JSArray_methods.get$last(output) === "..")
        C.JSArray_methods.add$1(output, "");
      if (!allowScheme) {
        if (0 >= output.length)
          return H.ioore(output, 0);
        C.JSArray_methods.$indexSet(output, 0, P._Uri__escapeScheme(output[0]));
      }
      return C.JSArray_methods.join$1(output, "/");
    },
    _Uri__escapeScheme: function(path) {
      var i, char, t2,
        t1 = path.length;
      if (t1 >= 2 && P._Uri__isAlphabeticCharacter(J._codeUnitAt$1$s(path, 0)))
        for (i = 1; i < t1; ++i) {
          char = C.JSString_methods._codeUnitAt$1(path, i);
          if (char === 58)
            return C.JSString_methods.substring$2(path, 0, i) + "%3A" + C.JSString_methods.substring$1(path, i + 1);
          if (char <= 127) {
            t2 = char >>> 4;
            if (t2 >= 8)
              return H.ioore(C.List_JYB, t2);
            t2 = (C.List_JYB[t2] & 1 << (char & 15)) === 0;
          } else
            t2 = true;
          if (t2)
            break;
        }
      return path;
    },
    _Uri__hexCharPairToByte: function(s, pos) {
      var byte, i, charCode;
      for (byte = 0, i = 0; i < 2; ++i) {
        charCode = C.JSString_methods.codeUnitAt$1(s, pos + i);
        if (48 <= charCode && charCode <= 57)
          byte = byte * 16 + charCode - 48;
        else {
          charCode |= 32;
          if (97 <= charCode && charCode <= 102)
            byte = byte * 16 + charCode - 87;
          else
            throw H.wrapException(P.ArgumentError$("Invalid URL encoding"));
        }
      }
      return byte;
    },
    _Uri__uriDecode: function(text, start, end, encoding, plusToSpace) {
      var simple, codeUnit, t1, bytes,
        i = start;
      while (true) {
        if (!(i < end)) {
          simple = true;
          break;
        }
        codeUnit = C.JSString_methods.codeUnitAt$1(text, i);
        if (codeUnit <= 127)
          if (codeUnit !== 37)
            t1 = false;
          else
            t1 = true;
        else
          t1 = true;
        if (t1) {
          simple = false;
          break;
        }
        ++i;
      }
      if (simple) {
        if (C.C_Utf8Codec !== encoding)
          t1 = false;
        else
          t1 = true;
        if (t1)
          return C.JSString_methods.substring$2(text, start, end);
        else
          bytes = new H.CodeUnits(C.JSString_methods.substring$2(text, start, end));
      } else {
        bytes = H.setRuntimeTypeInfo([], [P.int]);
        for (t1 = text.length, i = start; i < end; ++i) {
          codeUnit = C.JSString_methods.codeUnitAt$1(text, i);
          if (codeUnit > 127)
            throw H.wrapException(P.ArgumentError$("Illegal percent encoding in URI"));
          if (codeUnit === 37) {
            if (i + 3 > t1)
              throw H.wrapException(P.ArgumentError$("Truncated URI"));
            C.JSArray_methods.add$1(bytes, P._Uri__hexCharPairToByte(text, i + 1));
            i += 2;
          } else
            C.JSArray_methods.add$1(bytes, codeUnit);
        }
      }
      H.assertSubtype(bytes, "$isList", [P.int], "$asList");
      return new P.Utf8Decoder(false).convert$1(bytes);
    },
    _Uri__isAlphabeticCharacter: function(codeUnit) {
      var lowerCase = codeUnit | 32;
      return 97 <= lowerCase && lowerCase <= 122;
    },
    UriData_parse: function(uri) {
      var dataDelta;
      if (uri.length >= 5) {
        dataDelta = P._startsWithData(uri, 0);
        if (dataDelta === 0)
          return P.UriData__parse(uri, 5, null);
        if (dataDelta === 32)
          return P.UriData__parse(C.JSString_methods.substring$1(uri, 5), 0, null);
      }
      throw H.wrapException(P.FormatException$("Does not start with 'data:'", uri, 0));
    },
    UriData__parse: function(text, start, sourceUri) {
      var t1, i, slashIndex, char, equalsIndex, lastSeparator, t2, data,
        _s17_ = "Invalid MIME type",
        indices = H.setRuntimeTypeInfo([start - 1], [P.int]);
      for (t1 = text.length, i = start, slashIndex = -1, char = null; i < t1; ++i) {
        char = C.JSString_methods._codeUnitAt$1(text, i);
        if (char === 44 || char === 59)
          break;
        if (char === 47) {
          if (slashIndex < 0) {
            slashIndex = i;
            continue;
          }
          throw H.wrapException(P.FormatException$(_s17_, text, i));
        }
      }
      if (slashIndex < 0 && i > start)
        throw H.wrapException(P.FormatException$(_s17_, text, i));
      for (; char !== 44;) {
        C.JSArray_methods.add$1(indices, i);
        ++i;
        for (equalsIndex = -1; i < t1; ++i) {
          char = C.JSString_methods._codeUnitAt$1(text, i);
          if (char === 61) {
            if (equalsIndex < 0)
              equalsIndex = i;
          } else if (char === 59 || char === 44)
            break;
        }
        if (equalsIndex >= 0)
          C.JSArray_methods.add$1(indices, equalsIndex);
        else {
          lastSeparator = C.JSArray_methods.get$last(indices);
          if (char !== 44 || i !== lastSeparator + 7 || !C.JSString_methods.startsWith$2(text, "base64", lastSeparator + 1))
            throw H.wrapException(P.FormatException$("Expecting '='", text, i));
          break;
        }
      }
      C.JSArray_methods.add$1(indices, i);
      t2 = i + 1;
      if ((indices.length & 1) === 1)
        text = C.C_Base64Codec.normalize$3(text, t2, t1);
      else {
        data = P._Uri__normalize(text, t2, t1, C.List_CVk, true);
        if (data != null)
          text = C.JSString_methods.replaceRange$3(text, t2, t1, data);
      }
      return new P.UriData(text, indices, sourceUri);
    },
    _createTables: function() {
      var _s77_ = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-._~!$&'()*+,;=",
        _s1_ = ".", _s1_0 = ":", _s1_1 = "/", _s1_2 = "?", _s1_3 = "#",
        tables = P.List_List$generate(22, new P._createTables_closure(), true, P.Uint8List),
        t1 = new P._createTables_build(tables),
        t2 = new P._createTables_setChars(),
        t3 = new P._createTables_setRange(),
        b = H.interceptedTypeCheck(t1.call$2(0, 225), "$isUint8List");
      t2.call$3(b, _s77_, 1);
      t2.call$3(b, _s1_, 14);
      t2.call$3(b, _s1_0, 34);
      t2.call$3(b, _s1_1, 3);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(14, 225), "$isUint8List");
      t2.call$3(b, _s77_, 1);
      t2.call$3(b, _s1_, 15);
      t2.call$3(b, _s1_0, 34);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(15, 225), "$isUint8List");
      t2.call$3(b, _s77_, 1);
      t2.call$3(b, "%", 225);
      t2.call$3(b, _s1_0, 34);
      t2.call$3(b, _s1_1, 9);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(1, 225), "$isUint8List");
      t2.call$3(b, _s77_, 1);
      t2.call$3(b, _s1_0, 34);
      t2.call$3(b, _s1_1, 10);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(2, 235), "$isUint8List");
      t2.call$3(b, _s77_, 139);
      t2.call$3(b, _s1_1, 131);
      t2.call$3(b, _s1_, 146);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(3, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_1, 68);
      t2.call$3(b, _s1_, 18);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(4, 229), "$isUint8List");
      t2.call$3(b, _s77_, 5);
      t3.call$3(b, "AZ", 229);
      t2.call$3(b, _s1_0, 102);
      t2.call$3(b, "@", 68);
      t2.call$3(b, "[", 232);
      t2.call$3(b, _s1_1, 138);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(5, 229), "$isUint8List");
      t2.call$3(b, _s77_, 5);
      t3.call$3(b, "AZ", 229);
      t2.call$3(b, _s1_0, 102);
      t2.call$3(b, "@", 68);
      t2.call$3(b, _s1_1, 138);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(6, 231), "$isUint8List");
      t3.call$3(b, "19", 7);
      t2.call$3(b, "@", 68);
      t2.call$3(b, _s1_1, 138);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(7, 231), "$isUint8List");
      t3.call$3(b, "09", 7);
      t2.call$3(b, "@", 68);
      t2.call$3(b, _s1_1, 138);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      t2.call$3(H.interceptedTypeCheck(t1.call$2(8, 8), "$isUint8List"), "]", 5);
      b = H.interceptedTypeCheck(t1.call$2(9, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_, 16);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(16, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_, 17);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(17, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_1, 9);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(10, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_, 18);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(18, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_, 19);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(19, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_1, 234);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(11, 235), "$isUint8List");
      t2.call$3(b, _s77_, 11);
      t2.call$3(b, _s1_1, 10);
      t2.call$3(b, _s1_2, 172);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(12, 236), "$isUint8List");
      t2.call$3(b, _s77_, 12);
      t2.call$3(b, _s1_2, 12);
      t2.call$3(b, _s1_3, 205);
      b = H.interceptedTypeCheck(t1.call$2(13, 237), "$isUint8List");
      t2.call$3(b, _s77_, 13);
      t2.call$3(b, _s1_2, 13);
      t3.call$3(H.interceptedTypeCheck(t1.call$2(20, 245), "$isUint8List"), "az", 21);
      b = H.interceptedTypeCheck(t1.call$2(21, 245), "$isUint8List");
      t3.call$3(b, "az", 21);
      t3.call$3(b, "09", 21);
      t2.call$3(b, "+-.", 21);
      return tables;
    },
    _scan: function(uri, start, end, state, indices) {
      var i, table, char, transition,
        tables = $.$get$_scannerTables();
      for (i = start; i < end; ++i) {
        if (state < 0 || state >= tables.length)
          return H.ioore(tables, state);
        table = tables[state];
        char = C.JSString_methods._codeUnitAt$1(uri, i) ^ 96;
        if (char > 95)
          char = 31;
        if (char >= table.length)
          return H.ioore(table, char);
        transition = table[char];
        state = transition & 31;
        C.JSArray_methods.$indexSet(indices, transition >>> 5, i);
      }
      return state;
    },
    _startsWithData: function(text, start) {
      return ((C.JSString_methods._codeUnitAt$1(text, start + 4) ^ 58) * 3 | C.JSString_methods._codeUnitAt$1(text, start) ^ 100 | C.JSString_methods._codeUnitAt$1(text, start + 1) ^ 97 | C.JSString_methods._codeUnitAt$1(text, start + 2) ^ 116 | C.JSString_methods._codeUnitAt$1(text, start + 3) ^ 97) >>> 0;
    },
    NoSuchMethodError_toString_closure: function NoSuchMethodError_toString_closure(t0, t1) {
      this._box_0 = t0;
      this.sb = t1;
    },
    bool: function bool() {
    },
    DateTime: function DateTime(t0, t1) {
      this._value = t0;
      this.isUtc = t1;
    },
    double: function double() {
    },
    Error: function Error() {
    },
    AssertionError: function AssertionError() {
    },
    NullThrownError: function NullThrownError() {
    },
    ArgumentError: function ArgumentError(t0, t1, t2, t3) {
      var _ = this;
      _._hasValue = t0;
      _.invalidValue = t1;
      _.name = t2;
      _.message = t3;
    },
    RangeError: function RangeError(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _.start = t0;
      _.end = t1;
      _._hasValue = t2;
      _.invalidValue = t3;
      _.name = t4;
      _.message = t5;
    },
    IndexError: function IndexError(t0, t1, t2, t3, t4) {
      var _ = this;
      _.length = t0;
      _._hasValue = t1;
      _.invalidValue = t2;
      _.name = t3;
      _.message = t4;
    },
    NoSuchMethodError: function NoSuchMethodError(t0, t1, t2, t3) {
      var _ = this;
      _._core$_receiver = t0;
      _._core$_memberName = t1;
      _._core$_arguments = t2;
      _._namedArguments = t3;
    },
    UnsupportedError: function UnsupportedError(t0) {
      this.message = t0;
    },
    UnimplementedError: function UnimplementedError(t0) {
      this.message = t0;
    },
    StateError: function StateError(t0) {
      this.message = t0;
    },
    ConcurrentModificationError: function ConcurrentModificationError(t0) {
      this.modifiedObject = t0;
    },
    OutOfMemoryError: function OutOfMemoryError() {
    },
    StackOverflowError: function StackOverflowError() {
    },
    CyclicInitializationError: function CyclicInitializationError(t0) {
      this.variableName = t0;
    },
    _Exception: function _Exception(t0) {
      this.message = t0;
    },
    FormatException: function FormatException(t0, t1, t2) {
      this.message = t0;
      this.source = t1;
      this.offset = t2;
    },
    Function: function Function() {
    },
    int: function int() {
    },
    Iterable: function Iterable() {
    },
    _GeneratorIterable: function _GeneratorIterable(t0, t1, t2) {
      this.length = t0;
      this._generator = t1;
      this.$ti = t2;
    },
    Iterator: function Iterator() {
    },
    List: function List() {
    },
    Map: function Map() {
    },
    MapEntry: function MapEntry(t0, t1, t2) {
      this.key = t0;
      this.value = t1;
      this.$ti = t2;
    },
    Null: function Null() {
    },
    num: function num() {
    },
    Object: function Object() {
    },
    Set: function Set() {
    },
    StackTrace: function StackTrace() {
    },
    String: function String() {
    },
    StringBuffer: function StringBuffer(t0) {
      this._contents = t0;
    },
    StringSink: function StringSink() {
    },
    Symbol0: function Symbol0() {
    },
    Type: function Type() {
    },
    Uri: function Uri() {
    },
    Uri__parseIPv4Address_error: function Uri__parseIPv4Address_error(t0) {
      this.host = t0;
    },
    Uri_parseIPv6Address_error: function Uri_parseIPv6Address_error(t0) {
      this.host = t0;
    },
    Uri_parseIPv6Address_parseHex: function Uri_parseIPv6Address_parseHex(t0, t1) {
      this.error = t0;
      this.host = t1;
    },
    _Uri: function _Uri(t0, t1, t2, t3, t4, t5, t6) {
      var _ = this;
      _.scheme = t0;
      _._userInfo = t1;
      _._host = t2;
      _._port = t3;
      _.path = t4;
      _._query = t5;
      _._fragment = t6;
      _._hashCodeCache = _._text = null;
    },
    _Uri__Uri$notSimple_closure: function _Uri__Uri$notSimple_closure(t0, t1) {
      this.uri = t0;
      this.portStart = t1;
    },
    UriData: function UriData(t0, t1, t2) {
      this._text = t0;
      this._separatorIndices = t1;
      this._uriCache = t2;
    },
    _createTables_closure: function _createTables_closure() {
    },
    _createTables_build: function _createTables_build(t0) {
      this.tables = t0;
    },
    _createTables_setChars: function _createTables_setChars() {
    },
    _createTables_setRange: function _createTables_setRange() {
    },
    _SimpleUri: function _SimpleUri(t0, t1, t2, t3, t4, t5, t6, t7) {
      var _ = this;
      _._uri = t0;
      _._schemeEnd = t1;
      _._hostStart = t2;
      _._portStart = t3;
      _._pathStart = t4;
      _._queryStart = t5;
      _._fragmentStart = t6;
      _._schemeCache = t7;
      _._hashCodeCache = null;
    },
    _DataUri: function _DataUri(t0, t1, t2, t3, t4, t5, t6) {
      var _ = this;
      _.scheme = t0;
      _._userInfo = t1;
      _._host = t2;
      _._port = t3;
      _.path = t4;
      _._query = t5;
      _._fragment = t6;
      _._hashCodeCache = _._text = null;
    },
    jsify: function(object) {
      var t1 = J.getInterceptor$(object);
      if (!t1.$isMap && !t1.$isIterable)
        throw H.wrapException(P.ArgumentError$("object must be a Map or Iterable"));
      return P._convertDataTree(object);
    },
    _convertDataTree: function(data) {
      return new P._convertDataTree__convert(new P._IdentityHashMap([null, null])).call$1(data);
    },
    _convertDataTree__convert: function _convertDataTree__convert(t0) {
      this._convertedObjects = t0;
    },
    Uint8List: function Uint8List() {
    },
    _convertDartFunctionFast: function(f) {
      var ret,
        existing = f.$dart_jsFunction;
      if (existing != null)
        return existing;
      ret = function(_call, f) {
        return function() {
          return _call(f, Array.prototype.slice.apply(arguments));
        };
      }(P._callDartFunctionFast, f);
      ret[$.$get$DART_CLOSURE_PROPERTY_NAME()] = f;
      f.$dart_jsFunction = ret;
      return ret;
    },
    _callDartFunctionFast: function(callback, $arguments) {
      H.listTypeCheck($arguments);
      H.interceptedTypeCheck(callback, "$isFunction");
      return H.Primitives_applyFunction(callback, $arguments, null);
    },
    allowInterop: function(f, $F) {
      if (typeof f == "function")
        return f;
      else
        return H.assertSubtypeOfRuntimeType(P._convertDartFunctionFast(f), $F);
    }
  },
  M = {
    Accessor_fromMap: function(map, context) {
      var bufferViewIndex, t2, byteOffset, componentType, count, type, normalized, $length, min, max, sparse, t3, accessor, t4,
        _s10_ = "byteOffset",
        _null = null,
        _s10_0 = "normalized",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_jxI, context);
      bufferViewIndex = F.getIndex(map, "bufferView", context, false);
      if (bufferViewIndex === -1) {
        t2 = map.containsKey$1(_s10_);
        if (t2)
          context.addIssue$3$args$name($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["bufferView"], [t1]), _s10_);
        byteOffset = 0;
      } else
        byteOffset = F.getUint(map, _s10_, context, 0, _null, -1, 0, false);
      componentType = F.getUint(map, "componentType", context, -1, C.List_Q4K, -1, 0, true);
      count = F.getUint(map, "count", context, -1, _null, -1, 1, true);
      type = F.getString(map, "type", context, _null, C.Map_A1ato.get$keys(), _null, true);
      normalized = F.getBool(map, _s10_0, context);
      if (type != null && componentType !== -1) {
        $length = C.Map_A1ato.$index(0, type);
        if ($length != null)
          if (componentType === 5126) {
            t1 = [P.int];
            min = F.getFloatList(map, "min", context, _null, H.setRuntimeTypeInfo([$length], t1), 1 / 0, -1 / 0, true);
            max = F.getFloatList(map, "max", context, _null, H.setRuntimeTypeInfo([$length], t1), 1 / 0, -1 / 0, true);
          } else {
            min = F.getGlIntList(map, "min", context, componentType, $length);
            max = F.getGlIntList(map, "max", context, componentType, $length);
          }
        else {
          min = _null;
          max = min;
        }
      } else {
        min = _null;
        max = min;
      }
      sparse = F.getObjectFromInnerMap(map, "sparse", context, M.accessor_AccessorSparse_fromMap$closure(), false, M.AccessorSparse);
      if (normalized)
        t1 = componentType === 5126 || componentType === 5125;
      else
        t1 = false;
      if (t1)
        context.addIssue$2$name($.$get$SemanticError_accessorNormalizedInvalid(), _s10_0);
      if ((type === "MAT2" || type === "MAT3" || type === "MAT4") && byteOffset !== -1 && (byteOffset & 3) !== 0)
        context.addIssue$2$name($.$get$SemanticError_accessorMatrixAlignment(), _s10_);
      switch (componentType) {
        case 5120:
        case 5121:
        case 5122:
        case 5123:
        case 5125:
          t1 = P.int;
          t2 = [t1];
          H.subtypeCast(max, "$isList", t2, "$asList");
          H.subtypeCast(min, "$isList", t2, "$asList");
          F.getString(map, "name", context, _null, _null, _null, false);
          t2 = F.getExtensions(map, C.Type_Accessor_scC, context, _null, false);
          t3 = F.getExtras(map, context);
          accessor = new M._AccessorInt(bufferViewIndex, byteOffset, componentType, count, type, normalized, max, min, sparse, Z.componentTypeLength(componentType), t2, t3);
          if (min != null) {
            t2 = context.getPointerString$0();
            t3 = P.List_List$filled(min.length, 0, t1);
            t4 = new Array(min.length);
            t4.fixed$length = Array;
            context.addElementChecker$2(accessor, new M.MinIntegerChecker(t3, H.setRuntimeTypeInfo(t4, [t1]), J.toList$1$growable$ax(min, false), t2));
          }
          if (max != null) {
            t2 = context.getPointerString$0();
            t3 = P.List_List$filled(max.length, 0, t1);
            t4 = new Array(max.length);
            t4.fixed$length = Array;
            context.addElementChecker$2(accessor, new M.MaxIntegerChecker(t3, H.setRuntimeTypeInfo(t4, [t1]), J.toList$1$growable$ax(max, false), t2));
          }
          break;
        default:
          t1 = P.double;
          t2 = [t1];
          H.subtypeCast(max, "$isList", t2, "$asList");
          H.subtypeCast(min, "$isList", t2, "$asList");
          F.getString(map, "name", context, _null, _null, _null, false);
          t2 = F.getExtensions(map, C.Type_Accessor_scC, context, _null, false);
          t3 = F.getExtras(map, context);
          accessor = new M._AccessorFloat(bufferViewIndex, byteOffset, componentType, count, type, normalized, max, min, sparse, Z.componentTypeLength(componentType), t2, t3);
          context.addElementChecker$2(accessor, new M.InvalidFloatChecker(context.getPointerString$0()));
          if (min != null) {
            t2 = context.getPointerString$0();
            t3 = P.List_List$filled(min.length, 0, P.int);
            t4 = new Array(min.length);
            t4.fixed$length = Array;
            context.addElementChecker$2(accessor, new M.MinFloatChecker(t3, H.setRuntimeTypeInfo(t4, [t1]), J.toList$1$growable$ax(min, false), t2));
          }
          if (max != null) {
            t2 = context.getPointerString$0();
            t3 = P.List_List$filled(max.length, 0, P.int);
            t4 = new Array(max.length);
            t4.fixed$length = Array;
            context.addElementChecker$2(accessor, new M.MaxFloatChecker(t3, H.setRuntimeTypeInfo(t4, [t1]), J.toList$1$growable$ax(max, false), t2));
          }
          break;
      }
      return accessor;
    },
    Accessor__checkByteOffsetAndLength: function(byteOffset, componentLength, byteLength, bufferView, _bufferViewIndex, context) {
      var t1, totalOffset,
        _s10_ = "byteOffset";
      if (byteOffset === -1)
        return false;
      if (byteOffset % componentLength !== 0)
        if (context != null)
          context.addIssue$3$args$name($.$get$SemanticError_accessorOffsetAlignment(), H.setRuntimeTypeInfo([byteOffset, componentLength], [P.Object]), _s10_);
        else
          return false;
      t1 = bufferView.byteOffset;
      if (t1 === -1)
        return false;
      totalOffset = t1 + byteOffset;
      if (totalOffset % componentLength !== 0)
        if (context != null)
          context.addIssue$2$args($.$get$LinkError_accessorTotalOffsetAlignment(), H.setRuntimeTypeInfo([totalOffset, componentLength], [P.Object]));
        else
          return false;
      t1 = bufferView.byteLength;
      if (byteOffset > t1)
        if (context != null)
          context.addIssue$3$args$name($.$get$LinkError_accessorTooLong(), H.setRuntimeTypeInfo([byteOffset, byteLength, _bufferViewIndex, t1], [P.Object]), _s10_);
        else
          return false;
      else if (byteOffset + byteLength > t1)
        if (context != null)
          context.addIssue$2$args($.$get$LinkError_accessorTooLong(), H.setRuntimeTypeInfo([byteOffset, byteLength, _bufferViewIndex, t1], [P.Object]));
        else
          return false;
      return true;
    },
    Accessor__typedViewIndices: function(componentType, buffer, offsetInBytes, $length) {
      var t1, t2;
      if (buffer != null) {
        t1 = buffer.byteLength;
        t2 = Z.componentTypeLength(componentType);
        if (typeof t1 !== "number")
          return t1.$lt();
        t2 = t1 < offsetInBytes + t2 * $length;
        t1 = t2;
      } else
        t1 = true;
      if (t1)
        return;
      switch (componentType) {
        case 5121:
          buffer.toString;
          return H.NativeUint8List_NativeUint8List$view(buffer, offsetInBytes, $length);
        case 5123:
          return H.NativeUint16List_NativeUint16List$view(buffer, offsetInBytes, $length);
        case 5125:
          return H.NativeUint32List_NativeUint32List$view(buffer, offsetInBytes, $length);
        default:
          return;
      }
    },
    Accessor__typedViewFloat: function(componentType, buffer, offsetInBytes, $length) {
      var t1, t2;
      if (buffer != null) {
        t1 = buffer.byteLength;
        t2 = Z.componentTypeLength(componentType);
        if (typeof t1 !== "number")
          return t1.$lt();
        t2 = t1 < offsetInBytes + t2 * $length;
        t1 = t2;
      } else
        t1 = true;
      if (t1)
        return;
      switch (componentType) {
        case 5126:
          H._checkViewArguments(buffer, offsetInBytes, $length);
          t1 = new Float32Array(buffer, offsetInBytes, $length);
          return t1;
        default:
          return;
      }
    },
    Accessor__typedViewInt: function(componentType, buffer, offsetInBytes, $length) {
      var t1, t2;
      if (buffer != null) {
        t1 = buffer.byteLength;
        t2 = Z.componentTypeLength(componentType);
        if (typeof t1 !== "number")
          return t1.$lt();
        t2 = t1 < offsetInBytes + t2 * $length;
        t1 = t2;
      } else
        t1 = true;
      if (t1)
        return;
      switch (componentType) {
        case 5120:
          H._checkViewArguments(buffer, offsetInBytes, $length);
          t1 = new Int8Array(buffer, offsetInBytes, $length);
          return t1;
        case 5121:
          buffer.toString;
          return H.NativeUint8List_NativeUint8List$view(buffer, offsetInBytes, $length);
        case 5122:
          H._checkViewArguments(buffer, offsetInBytes, $length);
          t1 = new Int16Array(buffer, offsetInBytes, $length);
          return t1;
        case 5123:
          return H.NativeUint16List_NativeUint16List$view(buffer, offsetInBytes, $length);
        case 5125:
          return H.NativeUint32List_NativeUint32List$view(buffer, offsetInBytes, $length);
        default:
          return;
      }
    },
    AccessorSparse_fromMap: function(map, context) {
      var count, indices, values;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_count_indices_values, context);
      count = F.getUint(map, "count", context, -1, null, -1, 1, true);
      indices = F.getObjectFromInnerMap(map, "indices", context, M.accessor_AccessorSparseIndices_fromMap$closure(), true, M.AccessorSparseIndices);
      values = F.getObjectFromInnerMap(map, "values", context, M.accessor_AccessorSparseValues_fromMap$closure(), true, M.AccessorSparseValues);
      if (count === -1 || indices == null || values == null)
        return;
      return new M.AccessorSparse(count, indices, values, F.getExtensions(map, C.Type_AccessorSparse_SoA, context, null, false), F.getExtras(map, context));
    },
    AccessorSparseIndices_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_YcR, context);
      return new M.AccessorSparseIndices(F.getIndex(map, "bufferView", context, true), F.getUint(map, "byteOffset", context, 0, null, -1, 0, false), F.getUint(map, "componentType", context, -1, C.List_5121_5123_5125, -1, 0, true), F.getExtensions(map, C.Type_AccessorSparseIndices_XRi, context, null, false), F.getExtras(map, context));
    },
    AccessorSparseValues_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_bufferView_byteOffset, context);
      return new M.AccessorSparseValues(F.getIndex(map, "bufferView", context, true), F.getUint(map, "byteOffset", context, 0, null, -1, 0, false), F.getExtensions(map, C.Type_AccessorSparseValues_Yas, context, null, false), F.getExtras(map, context));
    },
    Accessor: function Accessor() {
    },
    _AccessorInt: function _AccessorInt(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
      var _ = this;
      _._accessor$_bufferViewIndex = t0;
      _.byteOffset = t1;
      _.componentType = t2;
      _.count = t3;
      _.type = t4;
      _.normalized = t5;
      _.max = t6;
      _.min = t7;
      _.sparse = t8;
      _.componentLength = t9;
      _._bufferView = null;
      _._byteStride = 0;
      _._accessor$_usage = _._containsCubicSpline = null;
      _.extensions = t10;
      _.extras = t11;
      _._isUsed = false;
    },
    _AccessorInt_getElements_closure: function _AccessorInt_getElements_closure(t0, t1, t2, t3, t4) {
      var _ = this;
      _.length = t0;
      _.view = t1;
      _.rowCount = t2;
      _.columnCount = t3;
      _.skip = t4;
    },
    _AccessorInt_getElements_closure0: function _AccessorInt_getElements_closure0(t0) {
      this.view = t0;
    },
    _AccessorInt_getElements_closure1: function _AccessorInt_getElements_closure1() {
    },
    _AccessorInt_getElements_closure2: function _AccessorInt_getElements_closure2(t0, t1, t2, t3, t4) {
      var _ = this;
      _.$this = t0;
      _.indices = t1;
      _.baseElements = t2;
      _.components = t3;
      _.values = t4;
    },
    _AccessorInt_getElementsNormalized_closure: function _AccessorInt_getElementsNormalized_closure(t0) {
      this.denom = t0;
    },
    _AccessorInt_getElementsNormalized_closure0: function _AccessorInt_getElementsNormalized_closure0(t0) {
      this.denom = t0;
    },
    _AccessorFloat: function _AccessorFloat(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
      var _ = this;
      _._accessor$_bufferViewIndex = t0;
      _.byteOffset = t1;
      _.componentType = t2;
      _.count = t3;
      _.type = t4;
      _.normalized = t5;
      _.max = t6;
      _.min = t7;
      _.sparse = t8;
      _.componentLength = t9;
      _._bufferView = null;
      _._byteStride = 0;
      _._accessor$_usage = _._containsCubicSpline = null;
      _.extensions = t10;
      _.extras = t11;
      _._isUsed = false;
    },
    _AccessorFloat_getElements_closure: function _AccessorFloat_getElements_closure(t0, t1, t2, t3, t4) {
      var _ = this;
      _.length = t0;
      _.view = t1;
      _.rowCount = t2;
      _.columnCount = t3;
      _.skip = t4;
    },
    _AccessorFloat_getElements_closure0: function _AccessorFloat_getElements_closure0(t0) {
      this.view = t0;
    },
    _AccessorFloat_getElements_closure1: function _AccessorFloat_getElements_closure1() {
    },
    _AccessorFloat_getElements_closure2: function _AccessorFloat_getElements_closure2(t0, t1, t2, t3, t4) {
      var _ = this;
      _.$this = t0;
      _.indices = t1;
      _.baseElements = t2;
      _.components = t3;
      _.values = t4;
    },
    AccessorSparse: function AccessorSparse(t0, t1, t2, t3, t4) {
      var _ = this;
      _.count = t0;
      _.indices = t1;
      _.values = t2;
      _.extensions = t3;
      _.extras = t4;
      _._isUsed = false;
    },
    AccessorSparseIndices: function AccessorSparseIndices(t0, t1, t2, t3, t4) {
      var _ = this;
      _._accessor$_bufferViewIndex = t0;
      _.byteOffset = t1;
      _.componentType = t2;
      _._bufferView = null;
      _.extensions = t3;
      _.extras = t4;
      _._isUsed = false;
    },
    AccessorSparseValues: function AccessorSparseValues(t0, t1, t2, t3) {
      var _ = this;
      _._accessor$_bufferViewIndex = t0;
      _.byteOffset = t1;
      _._bufferView = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    InvalidFloatChecker: function InvalidFloatChecker(t0) {
      this.path = t0;
    },
    MinFloatChecker: function MinFloatChecker(t0, t1, t2, t3) {
      var _ = this;
      _._invalidMinCount = t0;
      _._computedMin = t1;
      _._providedMin = t2;
      _.path = t3;
    },
    MaxFloatChecker: function MaxFloatChecker(t0, t1, t2, t3) {
      var _ = this;
      _._invalidMaxCount = t0;
      _._computedMax = t1;
      _._providedMax = t2;
      _.path = t3;
    },
    MinIntegerChecker: function MinIntegerChecker(t0, t1, t2, t3) {
      var _ = this;
      _._invalidMinCount = t0;
      _._computedMin = t1;
      _._providedMin = t2;
      _.path = t3;
    },
    MaxIntegerChecker: function MaxIntegerChecker(t0, t1, t2, t3) {
      var _ = this;
      _._invalidMaxCount = t0;
      _._computedMax = t1;
      _._providedMax = t2;
      _.path = t3;
    },
    ValidationOptions$: function(ignoredIssues, maxIssues, severityOverrides) {
      var t1 = P.LinkedHashSet_LinkedHashSet$_empty(P.String),
        t2 = maxIssues == null ? 0 : maxIssues;
      if (ignoredIssues != null)
        t1.addAll$1(0, ignoredIssues);
      return new M.ValidationOptions(t2, t1, severityOverrides);
    },
    Context_defaultExtensionNames: function() {
      var t1 = P.String,
        t2 = H.getTypeArgumentByIndex(C.List_2nP, 0);
      return new H.MappedListIterable(C.List_2nP, H.functionTypeCheck(new M.Context_defaultExtensionNames_closure(), {func: 1, ret: t1, args: [t2]}), [t2, t1]);
    },
    Context$: function(options) {
      var t14, t15, t16,
        t1 = P.String,
        t2 = [t1],
        t3 = H.setRuntimeTypeInfo([], t2),
        t4 = P.Object,
        t5 = H.setRuntimeTypeInfo([], [D.ResourceValidatableExtensionEntry]),
        t6 = D.ExtensionTuple,
        t7 = D.ExtFuncs,
        t8 = P.LinkedHashMap_LinkedHashMap$_empty(t6, t7),
        t9 = H.setRuntimeTypeInfo([], t2),
        t10 = H.setRuntimeTypeInfo([], t2),
        t11 = [P.Map, P.String, P.Object],
        t12 = H.setRuntimeTypeInfo([], [t11]),
        t13 = H.setRuntimeTypeInfo([], [E.Issue]);
      t2 = H.setRuntimeTypeInfo(["image/jpeg", "image/png"], t2);
      t14 = V.AccessorFormat;
      t15 = [P.Set, V.AccessorFormat];
      t16 = P.LinkedHashMap_LinkedHashMap$_literal(["POSITION", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false], t14), "NORMAL", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false], t14), "TANGENT", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC4_5126_false], t14), "TEXCOORD", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC2_5126_false, C.AccessorFormat_VEC2_5121_true, C.AccessorFormat_VEC2_5123_true], t14), "COLOR", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false, C.AccessorFormat_VEC3_5121_true, C.AccessorFormat_VEC3_5123_true, C.AccessorFormat_VEC4_5126_false, C.AccessorFormat_VEC4_5121_true, C.AccessorFormat_VEC4_5123_true], t14), "JOINTS", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC4_5121_false, C.AccessorFormat_VEC4_5123_false], t14), "WEIGHTS", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC4_5126_false, C.AccessorFormat_VEC4_5121_true, C.AccessorFormat_VEC4_5123_true], t14)], t1, t15);
      t15 = P.LinkedHashMap_LinkedHashMap$_literal(["POSITION", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false], t14), "NORMAL", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false], t14), "TANGENT", P.LinkedHashSet_LinkedHashSet$_literal([C.AccessorFormat_VEC3_5126_false], t14)], t1, t15);
      t14 = options == null ? M.ValidationOptions$(null, null, null) : options;
      t15 = new M.Context(t14, t3, P.LinkedHashMap_LinkedHashMap$_empty([M.Accessor, P.num], [P.List, [F.ElementChecker, P.num]]), P.LinkedHashMap_LinkedHashMap$_empty(t4, t4), P.LinkedHashMap_LinkedHashMap$_empty(P.Type, [P.List, D.LinkableExtensionEntry]), t5, P.LinkedHashMap_LinkedHashMap$_empty(V.BufferView, [P.Set, [M.Accessor, P.num]]), P.LinkedHashMap_LinkedHashMap$_empty([F.SafeList,,], [P.List, P.String]), t8, t9, t10, t12, P.LinkedHashSet_LinkedHashSet$_empty(D.Extension), t13, new P.StringBuffer(""), t2, t16, t15);
      t1 = [t1];
      t15.set$_extensionsLoadedView(new P.UnmodifiableListView(t10, t1));
      t15.set$_extensionsUsedView(new P.UnmodifiableListView(t9, t1));
      t15.set$_extensionsFunctionsView(new P.UnmodifiableMapView(t8, [t6, t7]));
      t15.set$_resourcesView(new P.UnmodifiableListView(t12, [t11]));
      return t15;
    },
    ValidationOptions: function ValidationOptions(t0, t1, t2) {
      this.maxIssues = t0;
      this.ignoredIssues = t1;
      this.severityOverrides = t2;
    },
    Context: function Context(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17) {
      var _ = this;
      _.options = t0;
      _.path = t1;
      _.accessorElementCheckers = t2;
      _.owners = t3;
      _.linkableExtensions = t4;
      _.resourceValidatableExtensions = t5;
      _.bufferViewAccessors = t6;
      _.extensionCollections = t7;
      _._isTruncated = false;
      _._extensionsFunctions = t8;
      _._extensionsFunctionsView = null;
      _._extensionsUsed = t9;
      _._extensionsUsedView = null;
      _._extensionsLoaded = t10;
      _._extensionsLoadedView = null;
      _._resources = t11;
      _._resourcesView = null;
      _._userExtensions = t12;
      _._issues = t13;
      _._sb = t14;
      _._isGlb = false;
      _.imageMimeTypes = t15;
      _.attributeAccessorFormats = t16;
      _.morphAttributeAccessorFormats = t17;
    },
    Context_defaultExtensionNames_closure: function Context_defaultExtensionNames_closure() {
    },
    Context_addElementChecker_closure: function Context_addElementChecker_closure() {
    },
    Context_getPointerString_closure: function Context_getPointerString_closure() {
    },
    Context_initExtensions_closure: function Context_initExtensions_closure(t0) {
      this.extensionName = t0;
    },
    Context_initExtensions_closure0: function Context_initExtensions_closure0(t0) {
      this.extensionName = t0;
    },
    Context_initExtensions__closure: function Context_initExtensions__closure(t0) {
      this.extensionName = t0;
    },
    Context_initExtensions__closure0: function Context_initExtensions__closure0() {
    },
    Context_initExtensions_closure1: function Context_initExtensions_closure1(t0, t1) {
      this.$this = t0;
      this.extension = t1;
    },
    IssuesLimitExceededException: function IssuesLimitExceededException() {
    }
  },
  Z = {
    Animation_fromMap: function(map, context) {
      var channelMaps, t1, t2, t3, channels, i, channelMap, samplerMaps, samplers, samplerMap, _null = null,
        _s8_ = "channels",
        _s8_0 = "samplers";
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_channels_samplers_name, context);
      channelMaps = F.getMapList(map, _s8_, context);
      if (channelMaps != null) {
        t1 = channelMaps.get$length(channelMaps);
        t2 = Z.AnimationChannel;
        t3 = new Array(t1);
        t3.fixed$length = Array;
        t3 = H.setRuntimeTypeInfo(t3, [t2]);
        channels = new F.SafeList(t3, t1, _s8_, [t2]);
        t2 = context.path;
        C.JSArray_methods.add$1(t2, _s8_);
        for (t1 = Z.AnimationChannelTarget, i = 0; i < channelMaps.get$length(channelMaps); ++i) {
          channelMap = channelMaps.$index(0, i);
          C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
          F.checkMembers(channelMap, C.List_target_sampler, context);
          C.JSArray_methods.$indexSet(t3, i, new Z.AnimationChannel(F.getIndex(channelMap, "sampler", context, true), F.getObjectFromInnerMap(channelMap, "target", context, Z.animation_AnimationChannelTarget_fromMap$closure(), true, t1), F.getExtensions(channelMap, C.Type_AnimationChannel_nvO, context, _null, false), F.getExtras(channelMap, context)));
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      } else
        channels = _null;
      samplerMaps = F.getMapList(map, _s8_0, context);
      if (samplerMaps != null) {
        t1 = samplerMaps.get$length(samplerMaps);
        t2 = Z.AnimationSampler;
        t3 = new Array(t1);
        t3.fixed$length = Array;
        t3 = H.setRuntimeTypeInfo(t3, [t2]);
        samplers = new F.SafeList(t3, t1, _s8_0, [t2]);
        t2 = context.path;
        C.JSArray_methods.add$1(t2, _s8_0);
        for (i = 0; i < samplerMaps.get$length(samplerMaps); ++i) {
          samplerMap = samplerMaps.$index(0, i);
          C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
          F.checkMembers(samplerMap, C.List_input_interpolation_output, context);
          C.JSArray_methods.$indexSet(t3, i, new Z.AnimationSampler(F.getIndex(samplerMap, "input", context, true), F.getString(samplerMap, "interpolation", context, "LINEAR", C.List_LINEAR_STEP_CUBICSPLINE, _null, false), F.getIndex(samplerMap, "output", context, true), F.getExtensions(samplerMap, C.Type_AnimationSampler_y5u, context, _null, false), F.getExtras(samplerMap, context)));
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      } else
        samplers = _null;
      F.getString(map, "name", context, _null, _null, _null, false);
      return new Z.Animation(channels, samplers, F.getExtensions(map, C.Type_Animation_hcA, context, _null, false), F.getExtras(map, context));
    },
    AnimationChannelTarget_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_node_path, context);
      return new Z.AnimationChannelTarget(F.getIndex(map, "node", context, false), F.getString(map, "path", context, null, C.List_translation_rotation_scale_weights, null, true), F.getExtensions(map, C.Type_AnimationChannelTarget_Nno, context, null, false), F.getExtras(map, context));
    },
    Animation: function Animation(t0, t1, t2, t3) {
      var _ = this;
      _.channels = t0;
      _.samplers = t1;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    Animation_link_closure: function Animation_link_closure(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    Animation_link_closure0: function Animation_link_closure0(t0, t1, t2) {
      this.$this = t0;
      this.context = t1;
      this.gltf = t2;
    },
    AnimationChannel: function AnimationChannel(t0, t1, t2, t3) {
      var _ = this;
      _._animation$_samplerIndex = t0;
      _.target = t1;
      _._animation$_sampler = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    AnimationChannelTarget: function AnimationChannelTarget(t0, t1, t2, t3) {
      var _ = this;
      _._nodeIndex = t0;
      _.path = t1;
      _._node = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    AnimationSampler: function AnimationSampler(t0, t1, t2, t3, t4) {
      var _ = this;
      _._inputIndex = t0;
      _.interpolation = t1;
      _._outputIndex = t2;
      _._output = _._input = null;
      _.extensions = t3;
      _.extras = t4;
      _._isUsed = false;
    },
    AnimationInputChecker: function AnimationInputChecker(t0) {
      this._lastValue = 0;
      this.path = t0;
    },
    QuaternionFloatChecker: function QuaternionFloatChecker(t0, t1, t2, t3) {
      var _ = this;
      _.hasTangents = t0;
      _.normalizeValue = t1;
      _.path = t2;
      _._animation$_sum = _._fullComponentIndex = 0;
      _.$ti = t3;
    },
    componentTypeLength: function(componentType) {
      switch (componentType) {
        case 5120:
        case 5121:
          return 1;
        case 5122:
        case 5123:
          return 2;
        case 5124:
        case 5125:
        case 5126:
          return 4;
        default:
          return -1;
      }
    },
    typeMin: function(type) {
      switch (type) {
        case 5121:
        case 5123:
        case 5125:
          return 0;
        case 5120:
          return -128;
        case 5122:
          return -32768;
        case 5124:
          return -2147483648;
        default:
          throw H.wrapException(P.ArgumentError$(null));
      }
    },
    typeMax: function(type) {
      switch (type) {
        case 5120:
          return 127;
        case 5121:
          return 255;
        case 5122:
          return 32767;
        case 5123:
          return 65535;
        case 5124:
          return 2147483647;
        case 5125:
          return 4294967295;
        default:
          throw H.wrapException(P.ArgumentError$(null));
      }
    }
  },
  T = {
    Asset_fromMap: function(map, context) {
      var t2, t3, t4, asset, t5, _null = null,
        _s10_ = "minVersion",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_avb, context);
      F.getString(map, "copyright", context, _null, _null, _null, false);
      t2 = F.getString(map, "generator", context, _null, _null, _null, false);
      t3 = $.$get$Asset_versionRegexp();
      t4 = F.getString(map, "version", context, _null, _null, t3, true);
      t3 = F.getString(map, _s10_, context, _null, _null, t3, false);
      asset = new T.Asset(t2, t4, t3, F.getExtensions(map, C.Type_Asset_ePM, context, _null, false), F.getExtras(map, context));
      t2 = t3 != null && t4 != null;
      if (t2) {
        t2 = asset.get$majorMinVersion();
        t5 = asset.get$majorVersion();
        if (typeof t2 !== "number")
          return t2.$gt();
        if (typeof t5 !== "number")
          return H.iae(t5);
        if (t2 <= t5)
          if (asset.get$majorMinVersion() == asset.get$majorVersion()) {
            t2 = asset.get$minorMinVersion();
            t5 = asset.get$minorVersion();
            if (typeof t2 !== "number")
              return t2.$gt();
            if (typeof t5 !== "number")
              return H.iae(t5);
            t5 = t2 > t5;
            t2 = t5;
          } else
            t2 = false;
        else
          t2 = true;
        if (t2)
          context.addIssue$3$args$name($.$get$SemanticError_minVersionGreaterThanVersion(), H.setRuntimeTypeInfo([t3, t4], [t1]), _s10_);
      }
      return asset;
    },
    Asset: function Asset(t0, t1, t2, t3, t4) {
      var _ = this;
      _.generator = t0;
      _.version = t1;
      _.minVersion = t2;
      _.extensions = t3;
      _.extras = t4;
      _._isUsed = false;
    },
    Image_fromMap: function(map, context) {
      var uriString, uri, uriData, bufferViewIndex, t2, mimeType, t3, t4, exception, data,
        _s10_ = "bufferView",
        _null = null,
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_bufferView_mimeType_uri_name, context);
      bufferViewIndex = F.getIndex(map, _s10_, context, false);
      t2 = context.imageMimeTypes;
      mimeType = F.getString(map, "mimeType", context, _null, t2, _null, false);
      uriString = F.getString(map, "uri", context, _null, _null, _null, false);
      t3 = bufferViewIndex === -1;
      t4 = !t3;
      if (t4 && mimeType == null)
        context.addIssue$3$args$name($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["mimeType"], [t1]), _s10_);
      if (!(t4 && uriString != null))
        t3 = t3 && uriString == null;
      else
        t3 = true;
      if (t3)
        context.addIssue$2$args($.$get$SchemaError_oneOfMismatch(), H.setRuntimeTypeInfo(["bufferView", "uri"], [t1]));
      uri = null;
      if (uriString != null) {
        uriData = null;
        try {
          uriData = P.UriData_parse(uriString);
        } catch (exception) {
          if (H.unwrapException(exception) instanceof P.FormatException)
            uri = F.getUri(uriString, context);
          else
            throw exception;
        }
        if (uriData != null) {
          if (context._isGlb)
            context.addIssue$2$name($.$get$DataError_dataUriGlb(), "uri");
          data = uriData.contentAsBytes$0();
          if (mimeType == null) {
            t3 = C.JSArray_methods.contains$1(t2, uriData.get$mimeType());
            if (!t3)
              context.addIssue$3$args$name($.$get$SchemaError_valueNotInList(), H.setRuntimeTypeInfo([uriData.get$mimeType(), t2], [t1]), "uri");
            mimeType = uriData.get$mimeType();
          }
        } else
          data = _null;
      } else
        data = _null;
      t1 = uri;
      F.getString(map, "name", context, _null, _null, _null, false);
      return new T.Image(bufferViewIndex, mimeType, t1, data, F.getExtensions(map, C.Type_Image_5hW, context, _null, false), F.getExtras(map, context));
    },
    Image: function Image(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _._bufferViewIndex = t0;
      _.mimeType = t1;
      _.uri = t2;
      _.data = t3;
      _.info = _._image$_bufferView = null;
      _.extensions = t4;
      _.extras = t5;
      _._isUsed = false;
    },
    Sampler_fromMap: function(map, context) {
      var _null = null;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_qPn, context);
      F.getUint(map, "magFilter", context, -1, C.List_9728_9729, -1, 0, false);
      F.getUint(map, "minFilter", context, -1, C.List_BKg, -1, 0, false);
      F.getUint(map, "wrapS", context, 10497, C.List_33071_33648_10497, -1, 0, false);
      F.getUint(map, "wrapT", context, 10497, C.List_33071_33648_10497, -1, 0, false);
      F.getString(map, "name", context, _null, _null, _null, false);
      return new T.Sampler(F.getExtensions(map, C.Type_Sampler_mXu, context, _null, false), F.getExtras(map, context));
    },
    Sampler: function Sampler(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    },
    Matrix4$zero: function() {
      return new T.Matrix4(new Float32Array(16));
    },
    Quaternion$_: function() {
      return new T.Quaternion(new Float32Array(4));
    },
    Vector3_Vector3$array: function(array) {
      var t1 = new Float32Array(3);
      H.assertSubtype(array, "$isList", [P.double], "$asList");
      if (2 >= array.length)
        return H.ioore(array, 2);
      C.NativeFloat32List_methods.$indexSet(t1, 2, array[2]);
      if (1 >= array.length)
        return H.ioore(array, 1);
      C.NativeFloat32List_methods.$indexSet(t1, 1, array[1]);
      if (0 >= array.length)
        return H.ioore(array, 0);
      C.NativeFloat32List_methods.$indexSet(t1, 0, array[0]);
      return new T.Vector3(t1);
    },
    Vector3$zero: function() {
      return new T.Vector3(new Float32Array(3));
    },
    Matrix4: function Matrix4(t0) {
      this._m4storage = t0;
    },
    Quaternion: function Quaternion(t0) {
      this._qStorage = t0;
    },
    Vector3: function Vector3(t0) {
      this._v3storage = t0;
    },
    Vector4: function Vector4(t0) {
      this._v4storage = t0;
    }
  },
  Q = {
    Buffer_fromMap: function(map, context) {
      var uri, uriString, uriData, byteLength, hasUri, exception, data, t2, byteLength0,
        _s10_ = "byteLength",
        _null = null, _s3_ = "uri",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_uri_byteLength_name, context);
      byteLength = F.getUint(map, _s10_, context, -1, _null, -1, 1, true);
      uri = null;
      hasUri = map.containsKey$1(_s3_);
      if (hasUri) {
        uriString = F.getString(map, _s3_, context, _null, _null, _null, false);
        if (uriString != null) {
          uriData = null;
          try {
            uriData = P.UriData_parse(uriString);
          } catch (exception) {
            if (H.unwrapException(exception) instanceof P.FormatException)
              uri = F.getUri(uriString, context);
            else
              throw exception;
          }
          if (uriData != null) {
            if (context._isGlb)
              context.addIssue$2$name($.$get$DataError_dataUriGlb(), _s3_);
            if (uriData.get$mimeType() === "application/octet-stream" || uriData.get$mimeType() === "application/gltf-buffer")
              data = uriData.contentAsBytes$0();
            else {
              context.addIssue$3$args$name($.$get$SemanticError_bufferDataUriMimeTypeInvalid(), H.setRuntimeTypeInfo([uriData.get$mimeType()], [t1]), _s3_);
              data = _null;
            }
          } else
            data = _null;
          if (data != null && byteLength !== -1 && data.length !== byteLength) {
            t2 = $.$get$DataError_bufferEmbeddedBytelengthMismatch();
            byteLength0 = data.length;
            context.addIssue$3$args$name(t2, H.setRuntimeTypeInfo([byteLength0, byteLength], [t1]), _s10_);
            byteLength = byteLength0;
          }
        } else
          data = _null;
      } else
        data = _null;
      t1 = uri;
      F.getString(map, "name", context, _null, _null, _null, false);
      return new Q.Buffer(t1, byteLength, hasUri, data, F.getExtensions(map, C.Type_Buffer_gn0, context, _null, false), F.getExtras(map, context));
    },
    Buffer: function Buffer(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _.uri = t0;
      _.byteLength = t1;
      _.hasUri = t2;
      _.data = t3;
      _.extensions = t4;
      _.extras = t5;
      _._isUsed = false;
    },
    main: function() {
      var t1 = new Q.main_onError();
      J.set$validateBytes$x(self.exports, P.allowInterop(new Q.main_closure(t1), {func: 1, ret: [Q.Promise, -2], args: [P.Uint8List, Q._JSValidationOptions]}));
      J.set$validateString$x(self.exports, P.allowInterop(new Q.main_closure0(t1), {func: 1, ret: [Q.Promise, -2], args: [P.String, Q._JSValidationOptions]}));
      J.set$version$x(self.exports, P.allowInterop(new Q.main_closure1(), {func: 1, ret: P.String}));
      J.set$supportedExtensions$x(self.exports, P.allowInterop(new Q.main_closure2(), {func: 1, ret: P.Object}));
    },
    validateBytes: function(data, options) {
      return Q.validateBytes$body(data, options);
    },
    validateBytes$body: function(data, options) {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter([P.Map, P.String, P.Object]),
        $async$returnValue, $async$handler = 2, $async$currentError, $async$next = [], context, readerResult, reader, _options, t1, exception, $async$exception;
      var $async$validateBytes = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1) {
          $async$currentError = $async$result;
          $async$goto = $async$handler;
        }
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              if (!J.getInterceptor$(data).$isUint8List)
                throw H.wrapException(P.ArgumentError$("data: Argument must be a Uint8Array."));
              _options = Q._checkOptionsObject(options);
              context = Q._getContextFromOptions(_options);
              readerResult = null;
              $async$handler = 4;
              t1 = [P.List, P.int];
              $async$goto = 7;
              return P._asyncAwait(K.GltfReader_detect(P.Stream_Stream$fromIterable(H.setRuntimeTypeInfo([data], [t1]), t1), context), $async$validateBytes);
            case 7:
              // returning from await.
              reader = $async$result;
              $async$goto = 8;
              return P._asyncAwait(reader.read$0(), $async$validateBytes);
            case 8:
              // returning from await.
              readerResult = $async$result;
              $async$handler = 2;
              // goto after finally
              $async$goto = 6;
              break;
            case 4:
              // catch
              $async$handler = 3;
              $async$exception = $async$currentError;
              if (H.unwrapException($async$exception) instanceof K.GltfInvalidFormatException)
                throw $async$exception;
              else
                throw $async$exception;
              // goto after finally
              $async$goto = 6;
              break;
            case 3:
              // uncaught
              // goto rethrow
              $async$goto = 2;
              break;
            case 6:
              // after finally
              $async$returnValue = Q._validateResourcesAndGetReport(_options, context, readerResult);
              // goto return
              $async$goto = 1;
              break;
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
            case 2:
              // rethrow
              return P._asyncRethrow($async$currentError, $async$completer);
          }
      });
      return P._asyncStartSync($async$validateBytes, $async$completer);
    },
    validateString: function(json, options) {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter([P.Map, P.String, P.Object]),
        $async$returnValue, _options, context;
      var $async$validateString = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1)
          return P._asyncRethrow($async$result, $async$completer);
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              if (typeof json !== "string")
                throw H.wrapException(P.ArgumentError$("json: Argument must be a string."));
              _options = Q._checkOptionsObject(options);
              context = Q._getContextFromOptions(_options);
              $async$returnValue = Q._validateResourcesAndGetReport(_options, context, K.GltfJsonReader_readFromJsonString(json, context));
              // goto return
              $async$goto = 1;
              break;
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
          }
      });
      return P._asyncStartSync($async$validateString, $async$completer);
    },
    _checkOptionsObject: function(options) {
      var t1;
      if (options != null)
        t1 = typeof options === "number" || typeof options === "boolean" || typeof options === "string" || !!J.getInterceptor$(options).$isList;
      else
        t1 = false;
      if (t1)
        throw H.wrapException(P.ArgumentError$("options: Value must be an object."));
      return H.interceptedTypeCast(options, "$is_JSValidationOptions");
    },
    _validateResourcesAndGetReport: function(options, context, result) {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter([P.Map, P.String, P.Object]),
        $async$returnValue, t2, uri, externalResourceFunction, t3, loader, t1;
      var $async$_validateResourcesAndGetReport = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1)
          return P._asyncRethrow($async$result, $async$completer);
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              t1 = options == null;
              if (!t1) {
                t2 = J.getInterceptor$x(options);
                uri = Q._getUri(t2.get$uri(options));
                if (t2.get$externalResourceFunction(options) != null && !J.getInterceptor$(t2.get$externalResourceFunction(options)).$isFunction)
                  throw H.wrapException(P.ArgumentError$("options.externalResourceFunction: Value must be a function."));
                else
                  externalResourceFunction = t2.get$externalResourceFunction(options);
                if (t2.get$validateAccessorData(options) != null) {
                  t3 = t2.get$validateAccessorData(options);
                  t3 = typeof t3 !== "boolean";
                } else
                  t3 = false;
                if (t3)
                  throw H.wrapException(P.ArgumentError$("options.validateAccessorData: Value must be a boolean."));
                if (t2.get$writeTimestamp(options) != null) {
                  t2 = t2.get$writeTimestamp(options);
                  t2 = typeof t2 !== "boolean";
                } else
                  t2 = false;
                if (t2)
                  throw H.wrapException(P.ArgumentError$("options.writeTimestamp: Value must be a boolean."));
              } else {
                uri = null;
                externalResourceFunction = null;
              }
              $async$goto = (result == null ? null : result.gltf) != null && externalResourceFunction != null ? 3 : 4;
              break;
            case 3:
              // then
              loader = Q._getResourcesLoader(context, result, externalResourceFunction);
              t2 = J.get$validateAccessorData$x(options);
              $async$goto = 5;
              return P._asyncAwait(loader.load$1$validateAccessorData(t2 == null ? true : t2), $async$_validateResourcesAndGetReport);
            case 5:
              // returning from await.
            case 4:
              // join
              t1 = t1 ? null : J.get$writeTimestamp$x(options);
              $async$returnValue = new A.ValidationResult(uri, context, result, t1 == null ? true : t1).toMap$0();
              // goto return
              $async$goto = 1;
              break;
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
          }
      });
      return P._asyncStartSync($async$_validateResourcesAndGetReport, $async$completer);
    },
    _getUri: function(uri) {
      var e, t1, exception;
      if (uri != null)
        if (typeof uri === "string")
          try {
            t1 = P.Uri_parse(uri);
            return t1;
          } catch (exception) {
            t1 = H.unwrapException(exception);
            if (t1 instanceof P.FormatException) {
              e = t1;
              throw H.wrapException(P.ArgumentError$("options.uri: " + H.S(e) + "."));
            } else
              throw exception;
          }
        else
          throw H.wrapException(P.ArgumentError$("options.uri: Value must be a string."));
      return;
    },
    _getContextFromOptions: function(options) {
      var t1, t2, ignoredIssues, i, entry, severityOverrides, t3, value, validationOptions;
      if (options != null) {
        t1 = J.getInterceptor$x(options);
        if (t1.get$maxIssues(options) != null) {
          t2 = t1.get$maxIssues(options);
          if (typeof t2 === "number" && Math.floor(t2) === t2) {
            t2 = t1.get$maxIssues(options);
            if (typeof t2 !== "number")
              return t2.$lt();
            t2 = t2 < 0;
          } else
            t2 = true;
        } else
          t2 = false;
        if (t2)
          throw H.wrapException(P.ArgumentError$("options.maxIssues: Value must be a non-negative integer."));
        if (t1.get$ignoredIssues(options) != null) {
          if (!J.getInterceptor$(t1.get$ignoredIssues(options)).$isList)
            throw H.wrapException(P.ArgumentError$("options.ignoredIssues: Value must be an array."));
          ignoredIssues = H.setRuntimeTypeInfo([], [P.String]);
          for (i = 0; i < J.get$length$asx(t1.get$ignoredIssues(options)); ++i) {
            entry = J.$index$asx(t1.get$ignoredIssues(options), i);
            if (typeof entry === "string" && entry.length !== 0)
              C.JSArray_methods.add$1(ignoredIssues, entry);
            else
              throw H.wrapException(P.ArgumentError$("options.ignoredIssues[" + i + "]: Value must be a non-empty String."));
          }
        } else
          ignoredIssues = null;
        if (t1.get$severityOverrides(options) != null) {
          t2 = t1.get$severityOverrides(options);
          if (typeof t2 !== "number") {
            t2 = t1.get$severityOverrides(options);
            if (typeof t2 !== "boolean") {
              t2 = t1.get$severityOverrides(options);
              t2 = typeof t2 === "string" || !!J.getInterceptor$(t1.get$severityOverrides(options)).$isList;
            } else
              t2 = true;
          } else
            t2 = true;
          if (t2)
            throw H.wrapException(P.ArgumentError$("options.severityOverrides: Value must be an object."));
          t2 = P.String;
          severityOverrides = P.LinkedHashMap_LinkedHashMap$_empty(t2, E.Severity);
          for (t3 = t1.get$severityOverrides(options), t2 = J.cast$1$0$ax(self.Object.keys(t3), t2), t2 = new H.ListIterator(t2, t2.get$length(t2), [H.getRuntimeTypeArgument(t2, "ListMixin", 0)]); t2.moveNext$0();) {
            t3 = t2.__internal$_current;
            value = t1.get$severityOverrides(options)[t3];
            if (typeof value === "number" && Math.floor(value) === value && value >= 0 && value <= 3)
              severityOverrides.$indexSet(0, t3, C.JSArray_methods.$index(C.List_qFu, value));
            else
              throw H.wrapException(P.ArgumentError$('options.severityOverrides["' + H.S(t3) + '"]: Value must be one of [0, 1, 2, 3].'));
          }
        } else
          severityOverrides = null;
        validationOptions = M.ValidationOptions$(ignoredIssues, t1.get$maxIssues(options), severityOverrides);
      } else
        validationOptions = null;
      return M.Context$(validationOptions);
    },
    _getResourcesLoader: function(context, readerResult, getResource) {
      var t1 = new Q._getResourcesLoader_getBytes(getResource);
      return new N.ResourcesLoader(readerResult.gltf, context, new Q._getResourcesLoader_closure(readerResult, t1), new Q._getResourcesLoader_closure0(t1));
    },
    Promise: function Promise() {
    },
    Exports: function Exports() {
    },
    _JSValidationOptions: function _JSValidationOptions() {
    },
    main_onError: function main_onError() {
    },
    main_closure: function main_closure(t0) {
      this.onError = t0;
    },
    main__closure0: function main__closure0(t0, t1, t2) {
      this.data = t0;
      this.options = t1;
      this.onError = t2;
    },
    main___closure1: function main___closure1(t0) {
      this.resolve = t0;
    },
    main___closure2: function main___closure2(t0, t1) {
      this.onError = t0;
      this.reject = t1;
    },
    main_closure0: function main_closure0(t0) {
      this.onError = t0;
    },
    main__closure: function main__closure(t0, t1, t2) {
      this.json = t0;
      this.options = t1;
      this.onError = t2;
    },
    main___closure: function main___closure(t0) {
      this.resolve = t0;
    },
    main___closure0: function main___closure0(t0, t1) {
      this.onError = t0;
      this.reject = t1;
    },
    main_closure1: function main_closure1() {
    },
    main_closure2: function main_closure2() {
    },
    _getResourcesLoader_getBytes: function _getResourcesLoader_getBytes(t0) {
      this.getResource = t0;
    },
    _getResourcesLoader_getBytes_closure: function _getResourcesLoader_getBytes_closure(t0) {
      this.completer = t0;
    },
    _getResourcesLoader_getBytes_closure0: function _getResourcesLoader_getBytes_closure0(t0) {
      this.completer = t0;
    },
    _getResourcesLoader_closure: function _getResourcesLoader_closure(t0, t1) {
      this.readerResult = t0;
      this.getBytes = t1;
    },
    _getResourcesLoader_closure0: function _getResourcesLoader_closure0(t0) {
      this.getBytes = t0;
    },
    NodeException: function NodeException(t0) {
      this.message = t0;
    }
  },
  V = {
    BufferView_fromMap: function(map, context) {
      var byteLength, byteStride, target, t2, _null = null,
        _s10_ = "byteStride",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_IVU, context);
      byteLength = F.getUint(map, "byteLength", context, -1, _null, -1, 1, true);
      byteStride = F.getUint(map, _s10_, context, -1, _null, 252, 4, false);
      target = F.getUint(map, "target", context, -1, C.List_34962_34963, -1, 0, false);
      if (byteStride !== -1) {
        if (byteLength !== -1 && byteStride > byteLength)
          context.addIssue$3$args$name($.$get$SemanticError_bufferViewTooBigByteStride(), H.setRuntimeTypeInfo([byteStride, byteLength], [t1]), _s10_);
        if (byteStride % 4 !== 0)
          context.addIssue$3$args$name($.$get$SchemaError_valueMultipleOf(), H.setRuntimeTypeInfo([byteStride, 4], [t1]), _s10_);
        if (target === 34963)
          context.addIssue$2$name($.$get$SemanticError_bufferViewInvalidByteStride(), _s10_);
      }
      t1 = F.getIndex(map, "buffer", context, true);
      t2 = F.getUint(map, "byteOffset", context, 0, _null, -1, 0, false);
      F.getString(map, "name", context, _null, _null, _null, false);
      return new V.BufferView(t1, t2, byteLength, byteStride, target, F.getExtensions(map, C.Type_BufferView_JO4, context, _null, false), F.getExtras(map, context));
    },
    BufferView: function BufferView(t0, t1, t2, t3, t4, t5, t6) {
      var _ = this;
      _._buffer_view$_bufferIndex = t0;
      _.byteOffset = t1;
      _.byteLength = t2;
      _.byteStride = t3;
      _._buffer_view$_target = t4;
      _._usage = _._buffer = null;
      _.effectiveByteStride = -1;
      _.extensions = t5;
      _.extras = t6;
      _._isUsed = false;
    },
    Gltf_Gltf$fromMap: function(map, context) {
      var extensionsUsed, extensionsRequired, toSafeList, asset, t1, t2, accessors, animations, buffers, bufferViews, cameras, images, materials, meshes, nodes, samplers, scenes, sceneIndex, scene, skins, textures, extensions, gltf, linkCollection, collections, _i, collection, t3, t4, i, t5, path, t6, t7,
        _s18_ = "extensionsRequired",
        _s14_ = "extensionsUsed",
        _null = null,
        resetPath = new V.Gltf_Gltf$fromMap_resetPath(context);
      resetPath.call$0();
      F.checkMembers(map, C.List_yvP, context);
      if (map.containsKey$1(_s18_) && !map.containsKey$1(_s14_))
        context.addIssue$3$args$name($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["extensionsUsed"], [P.Object]), _s18_);
      extensionsUsed = F.getStringList(map, _s14_, context);
      if (extensionsUsed == null)
        extensionsUsed = H.setRuntimeTypeInfo([], [P.String]);
      extensionsRequired = F.getStringList(map, _s18_, context);
      if (extensionsRequired == null)
        extensionsRequired = H.setRuntimeTypeInfo([], [P.String]);
      context.initExtensions$2(extensionsUsed, extensionsRequired);
      toSafeList = new V.Gltf_Gltf$fromMap_toSafeList(map, resetPath, context);
      asset = new V.Gltf_Gltf$fromMap_toValue(resetPath, map, context).call$1$3$req("asset", T.asset_Asset_fromMap$closure(), true, T.Asset);
      if ((asset == null ? _null : asset.version) == null)
        return;
      else if (asset.get$majorVersion() !== 2) {
        t1 = $.$get$SemanticError_unknownAssetMajorVersion();
        t2 = asset.get$majorVersion();
        context.addIssue$3$args$name(t1, H.setRuntimeTypeInfo([t2], [P.Object]), "version");
        return;
      } else {
        t1 = asset.get$minorVersion();
        if (typeof t1 !== "number")
          return t1.$gt();
        if (t1 > 0) {
          t1 = $.$get$SemanticError_unknownAssetMinorVersion();
          t2 = asset.get$minorVersion();
          context.addIssue$3$args$name(t1, H.setRuntimeTypeInfo([t2], [P.Object]), "version");
        }
      }
      accessors = toSafeList.call$1$2("accessors", M.accessor_Accessor_fromMap$closure(), [M.Accessor, P.num]);
      animations = toSafeList.call$1$2("animations", Z.animation_Animation_fromMap$closure(), Z.Animation);
      buffers = toSafeList.call$1$2("buffers", Q.buffer_Buffer_fromMap$closure(), Q.Buffer);
      bufferViews = toSafeList.call$1$2("bufferViews", V.buffer_view_BufferView_fromMap$closure(), V.BufferView);
      cameras = toSafeList.call$1$2("cameras", G.camera_Camera_fromMap$closure(), G.Camera);
      images = toSafeList.call$1$2("images", T.image_Image_fromMap$closure(), T.Image);
      materials = toSafeList.call$1$2("materials", Y.material_Material_fromMap$closure(), Y.Material);
      meshes = toSafeList.call$1$2("meshes", S.mesh_Mesh_fromMap$closure(), S.Mesh);
      t1 = V.Node;
      nodes = toSafeList.call$1$2("nodes", V.node_Node_fromMap$closure(), t1);
      samplers = toSafeList.call$1$2("samplers", T.sampler_Sampler_fromMap$closure(), T.Sampler);
      scenes = toSafeList.call$1$2("scenes", B.scene_Scene_fromMap$closure(), B.Scene);
      resetPath.call$0();
      sceneIndex = F.getIndex(map, "scene", context, false);
      scene = scenes.$index(0, sceneIndex);
      t2 = sceneIndex !== -1 && scene == null;
      if (t2)
        context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([sceneIndex], [P.Object]), "scene");
      skins = toSafeList.call$1$2("skins", O.skin_Skin_fromMap$closure(), O.Skin);
      textures = toSafeList.call$1$2("textures", U.texture_Texture_fromMap$closure(), U.Texture);
      extensions = F.getExtensions(map, C.Type_Gltf_IeY, context, _null, false);
      resetPath.call$0();
      gltf = new V.Gltf(extensionsUsed, extensionsRequired, accessors, animations, asset, buffers, bufferViews, cameras, images, materials, meshes, nodes, samplers, scene, skins, textures, extensions, F.getExtras(map, context));
      linkCollection = new V.Gltf_Gltf$fromMap_linkCollection(context, gltf);
      linkCollection.call$2(bufferViews, C.Type_BufferView_JO4);
      linkCollection.call$2(accessors, C.Type_Accessor_scC);
      linkCollection.call$2(images, C.Type_Image_5hW);
      linkCollection.call$2(textures, C.Type_Texture_gsm);
      linkCollection.call$2(materials, C.Type_Material_2bi);
      linkCollection.call$2(meshes, C.Type_Mesh_K2f);
      linkCollection.call$2(nodes, C.Type_Node_jrF);
      linkCollection.call$2(skins, C.Type_Skin_OJ4);
      linkCollection.call$2(animations, C.Type_Animation_hcA);
      linkCollection.call$2(scenes, C.Type_Scene_9YE);
      if (extensions.__js_helper$_length !== 0) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "extensions");
        extensions.forEach$1(0, new V.Gltf_Gltf$fromMap_closure(context, gltf));
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t2 = context.path;
      C.JSArray_methods.add$1(t2, "nodes");
      nodes.forEachWithIndices$1(new V.Gltf_Gltf$fromMap_closure0(context, P.LinkedHashSet_LinkedHashSet$_empty(t1)));
      t1 = t2.length;
      if (0 >= t1)
        return H.ioore(t2, -1);
      t2.pop();
      collections = [accessors, buffers, bufferViews, cameras, images, materials, meshes, nodes, samplers, skins, textures];
      for (_i = 0; _i < 11; ++_i) {
        collection = collections[_i];
        if (collection.get$length(collection) === 0)
          continue;
        C.JSArray_methods.add$1(t2, collection.name);
        for (t1 = collection._utils$_length, t3 = collection._list, t4 = t3.length, i = 0; i < t1; ++i) {
          t5 = i >= t4;
          if (t5)
            t5 = _null;
          else {
            if (i >= t4)
              return H.ioore(t3, i);
            t5 = t3[i];
          }
          if ((t5 == null ? _null : t5._isUsed) === false)
            context.addIssue$2$index($.$get$LinkError_unusedObject(), i);
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t1 = context.extensionCollections;
      if (t1.__js_helper$_length !== 0) {
        for (t3 = new H.LinkedHashMapKeyIterable(t1, [H.getTypeArgumentByIndex(t1, 0)]), t3 = t3.get$iterator(t3); t3.moveNext$0();) {
          t4 = t3.__js_helper$_current;
          if (t4.get$length(t4) === 0)
            continue;
          path = t1.$index(0, t4);
          C.JSArray_methods.set$length(t2, 0);
          C.JSArray_methods.addAll$1(t2, path);
          for (t5 = t4._utils$_length, t4 = t4._list, t6 = t4.length, i = 0; i < t5; ++i) {
            t7 = i >= t6;
            if (t7)
              t7 = _null;
            else {
              if (i >= t6)
                return H.ioore(t4, i);
              t7 = t4[i];
            }
            if ((t7 == null ? _null : t7.get$isUsed()) === false)
              context.addIssue$2$index($.$get$LinkError_unusedObject(), i);
          }
        }
        C.JSArray_methods.set$length(t2, 0);
      }
      return gltf;
    },
    Gltf: function Gltf(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17) {
      var _ = this;
      _.extensionsUsed = t0;
      _.extensionsRequired = t1;
      _.accessors = t2;
      _.animations = t3;
      _.asset = t4;
      _.buffers = t5;
      _.bufferViews = t6;
      _.cameras = t7;
      _.images = t8;
      _.materials = t9;
      _.meshes = t10;
      _.nodes = t11;
      _.samplers = t12;
      _.scene = t13;
      _.skins = t14;
      _.textures = t15;
      _.extensions = t16;
      _.extras = t17;
      _._isUsed = false;
    },
    Gltf_Gltf$fromMap_resetPath: function Gltf_Gltf$fromMap_resetPath(t0) {
      this.context = t0;
    },
    Gltf_Gltf$fromMap_toSafeList: function Gltf_Gltf$fromMap_toSafeList(t0, t1, t2) {
      this.map = t0;
      this.resetPath = t1;
      this.context = t2;
    },
    Gltf_Gltf$fromMap_toValue: function Gltf_Gltf$fromMap_toValue(t0, t1, t2) {
      this.resetPath = t0;
      this.map = t1;
      this.context = t2;
    },
    Gltf_Gltf$fromMap_linkCollection: function Gltf_Gltf$fromMap_linkCollection(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    Gltf_Gltf$fromMap_linkCollection_closure: function Gltf_Gltf$fromMap_linkCollection_closure(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    Gltf_Gltf$fromMap_closure: function Gltf_Gltf$fromMap_closure(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    Gltf_Gltf$fromMap_closure0: function Gltf_Gltf$fromMap_closure0(t0, t1) {
      this.context = t0;
      this.seenNodes = t1;
    },
    Gltf_Gltf$fromMap__closure: function Gltf_Gltf$fromMap__closure() {
    },
    Gltf_Gltf$fromMap__closure0: function Gltf_Gltf$fromMap__closure0() {
    },
    Gltf_validateResources_validateResourcesInCollection: function Gltf_validateResources_validateResourcesInCollection(t0, t1) {
      this.$this = t0;
      this.context = t1;
    },
    Gltf_validateResources_validateResourcesInCollection_closure: function Gltf_validateResources_validateResourcesInCollection_closure(t0, t1) {
      this.$this = t0;
      this.context = t1;
    },
    ResourceValidatable: function ResourceValidatable() {
    },
    GltfProperty: function GltfProperty() {
    },
    GltfChildOfRootProperty: function GltfChildOfRootProperty() {
    },
    BufferViewUsage: function BufferViewUsage(t0) {
      this._members$_value = t0;
    },
    AccessorUsage: function AccessorUsage(t0) {
      this._members$_value = t0;
    },
    AccessorFormat: function AccessorFormat(t0, t1, t2) {
      this.type = t0;
      this.componentType = t1;
      this.normalized = t2;
    },
    Node_fromMap: function(map, context) {
      var matrixList, t2, matrix, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14, t15, t16, t17, t18, translationList, translation, rotationList, rotation, scaleList, scale, cameraIndex, childrenIndices, meshIndex, skinIndex, weightsList, _null = null, _s6_ = "matrix",
        _s11_ = "translation",
        _s8_ = "rotation",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_B9o, context);
      if (map.containsKey$1(_s6_)) {
        matrixList = F.getFloatList(map, _s6_, context, _null, C.List_16, 1 / 0, -1 / 0, false);
        if (matrixList != null) {
          t2 = new Float32Array(16);
          matrix = new T.Matrix4(t2);
          t3 = matrixList.length;
          if (0 >= t3)
            return H.ioore(matrixList, 0);
          t4 = matrixList[0];
          if (1 >= t3)
            return H.ioore(matrixList, 1);
          t5 = matrixList[1];
          if (2 >= t3)
            return H.ioore(matrixList, 2);
          t6 = matrixList[2];
          if (3 >= t3)
            return H.ioore(matrixList, 3);
          t7 = matrixList[3];
          if (4 >= t3)
            return H.ioore(matrixList, 4);
          t8 = matrixList[4];
          if (5 >= t3)
            return H.ioore(matrixList, 5);
          t9 = matrixList[5];
          if (6 >= t3)
            return H.ioore(matrixList, 6);
          t10 = matrixList[6];
          if (7 >= t3)
            return H.ioore(matrixList, 7);
          t11 = matrixList[7];
          if (8 >= t3)
            return H.ioore(matrixList, 8);
          t12 = matrixList[8];
          if (9 >= t3)
            return H.ioore(matrixList, 9);
          t13 = matrixList[9];
          if (10 >= t3)
            return H.ioore(matrixList, 10);
          t14 = matrixList[10];
          if (11 >= t3)
            return H.ioore(matrixList, 11);
          t15 = matrixList[11];
          if (12 >= t3)
            return H.ioore(matrixList, 12);
          t16 = matrixList[12];
          if (13 >= t3)
            return H.ioore(matrixList, 13);
          t17 = matrixList[13];
          if (14 >= t3)
            return H.ioore(matrixList, 14);
          t18 = matrixList[14];
          if (15 >= t3)
            return H.ioore(matrixList, 15);
          t3 = matrixList[15];
          H.doubleTypeCheck(t4);
          H.doubleTypeCheck(t5);
          H.doubleTypeCheck(t6);
          H.doubleTypeCheck(t7);
          H.doubleTypeCheck(t8);
          H.doubleTypeCheck(t9);
          H.doubleTypeCheck(t10);
          H.doubleTypeCheck(t11);
          H.doubleTypeCheck(t12);
          H.doubleTypeCheck(t13);
          H.doubleTypeCheck(t14);
          H.doubleTypeCheck(t15);
          H.doubleTypeCheck(t16);
          H.doubleTypeCheck(t17);
          H.doubleTypeCheck(t18);
          C.NativeFloat32List_methods.$indexSet(t2, 15, H.doubleTypeCheck(t3));
          C.NativeFloat32List_methods.$indexSet(t2, 14, t18);
          C.NativeFloat32List_methods.$indexSet(t2, 13, t17);
          C.NativeFloat32List_methods.$indexSet(t2, 12, t16);
          C.NativeFloat32List_methods.$indexSet(t2, 11, t15);
          C.NativeFloat32List_methods.$indexSet(t2, 10, t14);
          C.NativeFloat32List_methods.$indexSet(t2, 9, t13);
          C.NativeFloat32List_methods.$indexSet(t2, 8, t12);
          C.NativeFloat32List_methods.$indexSet(t2, 7, t11);
          C.NativeFloat32List_methods.$indexSet(t2, 6, t10);
          C.NativeFloat32List_methods.$indexSet(t2, 5, t9);
          C.NativeFloat32List_methods.$indexSet(t2, 4, t8);
          C.NativeFloat32List_methods.$indexSet(t2, 3, t7);
          C.NativeFloat32List_methods.$indexSet(t2, 2, t6);
          C.NativeFloat32List_methods.$indexSet(t2, 1, t5);
          C.NativeFloat32List_methods.$indexSet(t2, 0, t4);
        } else
          matrix = _null;
      } else
        matrix = _null;
      if (map.containsKey$1(_s11_)) {
        translationList = F.getFloatList(map, _s11_, context, _null, C.List_3, 1 / 0, -1 / 0, false);
        translation = translationList != null ? T.Vector3_Vector3$array(translationList) : _null;
      } else
        translation = _null;
      if (map.containsKey$1(_s8_)) {
        rotationList = F.getFloatList(map, _s8_, context, _null, C.List_4, 1, -1, false);
        if (rotationList != null) {
          t2 = rotationList.length;
          if (0 >= t2)
            return H.ioore(rotationList, 0);
          t3 = rotationList[0];
          if (1 >= t2)
            return H.ioore(rotationList, 1);
          t4 = rotationList[1];
          if (2 >= t2)
            return H.ioore(rotationList, 2);
          t5 = rotationList[2];
          if (3 >= t2)
            return H.ioore(rotationList, 3);
          t2 = rotationList[3];
          t6 = new Float32Array(4);
          rotation = new T.Quaternion(t6);
          C.NativeFloat32List_methods.$indexSet(t6, 0, t3);
          C.NativeFloat32List_methods.$indexSet(t6, 1, t4);
          C.NativeFloat32List_methods.$indexSet(t6, 2, t5);
          C.NativeFloat32List_methods.$indexSet(t6, 3, t2);
          t2 = Math.sqrt(rotation.get$length2());
          if (Math.abs(1 - t2) > 0.00769)
            context.addIssue$2$name($.$get$SemanticError_rotationNonUnit(), _s8_);
        } else
          rotation = _null;
      } else
        rotation = _null;
      if (map.containsKey$1("scale")) {
        scaleList = F.getFloatList(map, "scale", context, _null, C.List_3, 1 / 0, -1 / 0, false);
        scale = scaleList != null ? T.Vector3_Vector3$array(scaleList) : _null;
      } else
        scale = _null;
      cameraIndex = F.getIndex(map, "camera", context, false);
      childrenIndices = F.getIndicesList(map, "children", context, false);
      meshIndex = F.getIndex(map, "mesh", context, false);
      skinIndex = F.getIndex(map, "skin", context, false);
      weightsList = F.getFloatList(map, "weights", context, _null, _null, 1 / 0, -1 / 0, false);
      if (meshIndex === -1) {
        if (skinIndex !== -1)
          context.addIssue$3$args$name($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["mesh"], [t1]), "skin");
        if (weightsList != null)
          context.addIssue$3$args$name($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["mesh"], [t1]), "weights");
      }
      if (matrix != null) {
        if (translation != null || rotation != null || scale != null)
          context.addIssue$2$name($.$get$SemanticError_nodeMatrixTrs(), _s6_);
        if (matrix.isIdentity$0())
          context.addIssue$2$name($.$get$SemanticError_nodeDefaultMatrix(), _s6_);
        else if (!F.isTrsDecomposable(matrix))
          context.addIssue$2$name($.$get$SemanticError_nodeNonTrsMatrix(), _s6_);
      }
      F.getString(map, "name", context, _null, _null, _null, false);
      return new V.Node(cameraIndex, childrenIndices, skinIndex, matrix, meshIndex, translation, rotation, scale, weightsList, P.LinkedHashSet_LinkedHashSet$_empty(B.Scene), F.getExtensions(map, C.Type_Node_jrF, context, _null, false), F.getExtras(map, context));
    },
    Node: function Node(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11) {
      var _ = this;
      _._cameraIndex = t0;
      _._childrenIndices = t1;
      _._skinIndex = t2;
      _.matrix = t3;
      _._meshIndex = t4;
      _.translation = t5;
      _.rotation = t6;
      _.scale = t7;
      _.weights = t8;
      _._scenes = t9;
      _._skin = _._parent = _._mesh = _._children = _._camera = null;
      _.isJoint = false;
      _.extensions = t10;
      _.extras = t11;
      _._isUsed = false;
    },
    Node_link_closure: function Node_link_closure() {
    },
    Node_link_closure0: function Node_link_closure0() {
    },
    Node_link_closure1: function Node_link_closure1(t0, t1) {
      this.$this = t0;
      this.context = t1;
    }
  },
  G = {
    Camera_fromMap: function(map, context) {
      var t1, _null = null,
        _s12_ = "orthographic",
        _s11_ = "perspective";
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_type_orthographic_perspective_name, context);
      t1 = map.containsKey$1(_s12_) && map.containsKey$1(_s11_);
      if (t1)
        context.addIssue$2$args($.$get$SchemaError_oneOfMismatch(), C.List_orthographic_perspective);
      switch (F.getString(map, "type", context, _null, C.List_orthographic_perspective, _null, true)) {
        case "orthographic":
          F.getObjectFromInnerMap(map, _s12_, context, G.camera_CameraOrthographic_fromMap$closure(), true, G.CameraOrthographic);
          break;
        case "perspective":
          F.getObjectFromInnerMap(map, _s11_, context, G.camera_CameraPerspective_fromMap$closure(), true, G.CameraPerspective);
          break;
      }
      F.getString(map, "name", context, _null, _null, _null, false);
      return new G.Camera(F.getExtensions(map, C.Type_Camera_s3t, context, _null, false), F.getExtras(map, context));
    },
    CameraOrthographic_fromMap: function(map, context) {
      var xmag, ymag, zfar, znear;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_xmag_ymag_zfar_znear, context);
      xmag = F.getFloat(map, "xmag", context, 0 / 0, 1 / 0, -1 / 0, 1 / 0, -1 / 0, true);
      ymag = F.getFloat(map, "ymag", context, 0 / 0, 1 / 0, -1 / 0, 1 / 0, -1 / 0, true);
      zfar = F.getFloat(map, "zfar", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, true);
      znear = F.getFloat(map, "znear", context, 0 / 0, 1 / 0, -1 / 0, 1 / 0, 0, true);
      if (!isNaN(zfar) && !isNaN(znear) && zfar <= znear)
        context.addIssue$1($.$get$SemanticError_cameraZfarLequalZnear());
      if (xmag === 0 || ymag === 0)
        context.addIssue$1($.$get$SemanticError_cameraXmagYmagZero());
      return new G.CameraOrthographic(F.getExtensions(map, C.Type_CameraOrthographic_wIv, context, null, false), F.getExtras(map, context));
    },
    CameraPerspective_fromMap: function(map, context) {
      var zfar, znear, t1;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_aspectRatio_yfov_zfar_znear, context);
      zfar = F.getFloat(map, "zfar", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, false);
      znear = F.getFloat(map, "znear", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, true);
      t1 = !isNaN(zfar) && !isNaN(znear) && zfar <= znear;
      if (t1)
        context.addIssue$1($.$get$SemanticError_cameraZfarLequalZnear());
      F.getFloat(map, "aspectRatio", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, false);
      F.getFloat(map, "yfov", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, true);
      return new G.CameraPerspective(F.getExtensions(map, C.Type_CameraPerspective_EWB, context, null, false), F.getExtras(map, context));
    },
    Camera: function Camera(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    },
    CameraOrthographic: function CameraOrthographic(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    },
    CameraPerspective: function CameraPerspective(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    }
  },
  Y = {
    Material_fromMap: function(map, context) {
      var pbrMetallicRoughness, normalTexture, occlusionTexture, emissiveTexture, alphaMode, t3, extensions, material, _null = null,
        _s11_ = "alphaCutoff",
        t1 = P.String,
        t2 = P.Object;
      H.assertSubtype(map, "$isMap", [t1, t2], "$asMap");
      F.checkMembers(map, C.List_OdV, context);
      pbrMetallicRoughness = F.getObjectFromInnerMap(map, "pbrMetallicRoughness", context, Y.material_PbrMetallicRoughness_fromMap$closure(), false, Y.PbrMetallicRoughness);
      normalTexture = F.getObjectFromInnerMap(map, "normalTexture", context, Y.material_NormalTextureInfo_fromMap$closure(), false, Y.NormalTextureInfo);
      occlusionTexture = F.getObjectFromInnerMap(map, "occlusionTexture", context, Y.material_OcclusionTextureInfo_fromMap$closure(), false, Y.OcclusionTextureInfo);
      emissiveTexture = F.getObjectFromInnerMap(map, "emissiveTexture", context, Y.material_TextureInfo_fromMap$closure(), false, Y.TextureInfo);
      F.getFloatList(map, "emissiveFactor", context, C.List_0_0_0, C.List_3, 1, 0, false);
      alphaMode = F.getString(map, "alphaMode", context, "OPAQUE", C.List_OPAQUE_MASK_BLEND, _null, false);
      F.getFloat(map, _s11_, context, 0.5, 1 / 0, -1 / 0, 1 / 0, 0, false);
      t3 = alphaMode !== "MASK" && map.containsKey$1(_s11_);
      if (t3)
        context.addIssue$2$name($.$get$SemanticError_materialAlphaCutoffInvalidMode(), _s11_);
      F.getBool(map, "doubleSided", context);
      extensions = F.getExtensions(map, C.Type_Material_2bi, context, _null, true);
      F.getString(map, "name", context, _null, _null, _null, false);
      material = new Y.Material(pbrMetallicRoughness, normalTexture, occlusionTexture, emissiveTexture, P.LinkedHashMap_LinkedHashMap$_empty(t1, P.int), extensions, F.getExtras(map, context));
      t1 = H.setRuntimeTypeInfo([], [t2]);
      C.JSArray_methods.add$1(t1, pbrMetallicRoughness);
      C.JSArray_methods.add$1(t1, normalTexture);
      C.JSArray_methods.add$1(t1, occlusionTexture);
      C.JSArray_methods.add$1(t1, emissiveTexture);
      for (t2 = extensions.get$values(), t2 = new H.MappedIterator(J.get$iterator$ax(t2.__internal$_iterable), t2._f, [H.getTypeArgumentByIndex(t2, 0), H.getTypeArgumentByIndex(t2, 1)]); t2.moveNext$0();)
        C.JSArray_methods.add$1(t1, t2.__internal$_current);
      context.registerObjectsOwner$2(material, t1);
      return material;
    },
    PbrMetallicRoughness_fromMap: function(map, context) {
      var t2, baseColorTexture, metallicRoughnessTexture, extensions, pbrMr,
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_chs, context);
      F.getFloatList(map, "baseColorFactor", context, C.List_1_1_1_1, C.List_4, 1, 0, false);
      t2 = Y.TextureInfo;
      baseColorTexture = F.getObjectFromInnerMap(map, "baseColorTexture", context, Y.material_TextureInfo_fromMap$closure(), false, t2);
      F.getFloat(map, "metallicFactor", context, 1, 1 / 0, -1 / 0, 1, 0, false);
      F.getFloat(map, "roughnessFactor", context, 1, 1 / 0, -1 / 0, 1, 0, false);
      metallicRoughnessTexture = F.getObjectFromInnerMap(map, "metallicRoughnessTexture", context, Y.material_TextureInfo_fromMap$closure(), false, t2);
      extensions = F.getExtensions(map, C.Type_PbrMetallicRoughness_k2w, context, null, false);
      pbrMr = new Y.PbrMetallicRoughness(baseColorTexture, metallicRoughnessTexture, extensions, F.getExtras(map, context));
      t1 = H.setRuntimeTypeInfo([], [t1]);
      C.JSArray_methods.add$1(t1, baseColorTexture);
      C.JSArray_methods.add$1(t1, metallicRoughnessTexture);
      for (t2 = extensions.get$values(), t2 = new H.MappedIterator(J.get$iterator$ax(t2.__internal$_iterable), t2._f, [H.getTypeArgumentByIndex(t2, 0), H.getTypeArgumentByIndex(t2, 1)]); t2.moveNext$0();)
        C.JSArray_methods.add$1(t1, t2.__internal$_current);
      context.registerObjectsOwner$2(pbrMr, t1);
      return pbrMr;
    },
    OcclusionTextureInfo_fromMap: function(map, context) {
      var extensions, t1, t2, occlusionTextureInfo;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_index_texCoord_strength, context);
      extensions = F.getExtensions(map, C.Type_OcclusionTextureInfo_YCM, context, C.Type_Material_2bi, false);
      t1 = F.getIndex(map, "index", context, true);
      t2 = F.getUint(map, "texCoord", context, 0, null, -1, 0, false);
      F.getFloat(map, "strength", context, 1, 1 / 0, -1 / 0, 1, 0, false);
      occlusionTextureInfo = new Y.OcclusionTextureInfo(t1, t2, extensions, F.getExtras(map, context));
      context.registerObjectsOwner$2(occlusionTextureInfo, extensions.get$values());
      return occlusionTextureInfo;
    },
    NormalTextureInfo_fromMap: function(map, context) {
      var extensions, t1, t2, normalTextureInfo;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_index_texCoord_scale, context);
      extensions = F.getExtensions(map, C.Type_NormalTextureInfo_0, context, C.Type_Material_2bi, false);
      t1 = F.getIndex(map, "index", context, true);
      t2 = F.getUint(map, "texCoord", context, 0, null, -1, 0, false);
      F.getFloat(map, "scale", context, 1, 1 / 0, -1 / 0, 1 / 0, -1 / 0, false);
      normalTextureInfo = new Y.NormalTextureInfo(t1, t2, extensions, F.getExtras(map, context));
      context.registerObjectsOwner$2(normalTextureInfo, extensions.get$values());
      return normalTextureInfo;
    },
    TextureInfo_fromMap: function(map, context) {
      var extensions, textureInfo;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_index_texCoord, context);
      extensions = F.getExtensions(map, C.Type_TextureInfo_V3H, context, C.Type_Material_2bi, false);
      textureInfo = new Y.TextureInfo(F.getIndex(map, "index", context, true), F.getUint(map, "texCoord", context, 0, null, -1, 0, false), extensions, F.getExtras(map, context));
      context.registerObjectsOwner$2(textureInfo, extensions.get$values());
      return textureInfo;
    },
    Material: function Material(t0, t1, t2, t3, t4, t5, t6) {
      var _ = this;
      _.pbrMetallicRoughness = t0;
      _.normalTexture = t1;
      _.occlusionTexture = t2;
      _.emissiveTexture = t3;
      _.texCoordIndices = t4;
      _.extensions = t5;
      _.extras = t6;
      _._isUsed = false;
    },
    Material_link_linkWithPath: function Material_link_linkWithPath(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    PbrMetallicRoughness: function PbrMetallicRoughness(t0, t1, t2, t3) {
      var _ = this;
      _.baseColorTexture = t0;
      _.metallicRoughnessTexture = t1;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    OcclusionTextureInfo: function OcclusionTextureInfo(t0, t1, t2, t3) {
      var _ = this;
      _._material$_index = t0;
      _.texCoord = t1;
      _._texture = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    NormalTextureInfo: function NormalTextureInfo(t0, t1, t2, t3) {
      var _ = this;
      _._material$_index = t0;
      _.texCoord = t1;
      _._texture = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    TextureInfo: function TextureInfo(t0, t1, t2, t3) {
      var _ = this;
      _._material$_index = t0;
      _.texCoord = t1;
      _._texture = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    ImageInfo$_: function(mimeType, bits, format, width, height, colorPrimaries, colorTransfer, hasAnimation, hasNonSquarePixels) {
      return new Y.ImageInfo(mimeType, bits, format, width, height, colorPrimaries, colorTransfer, hasNonSquarePixels, hasAnimation);
    },
    ImageInfo_parseStreamAsync: function(data) {
      var t2, t3, completer, t1 = {};
      t1.subscription = t1.decoder = null;
      t2 = Y.ImageInfo;
      t3 = new P._Future($.Zone__current, [t2]);
      completer = new P._AsyncCompleter(t3, [t2]);
      t1.isDetected = false;
      t1.subscription = data.listen$3$onDone$onError(new Y.ImageInfo_parseStreamAsync_closure(t1, completer), new Y.ImageInfo_parseStreamAsync_closure0(t1), new Y.ImageInfo_parseStreamAsync_closure1(t1, completer));
      return t3;
    },
    ImageInfo__detectCodec: function(firstChunk) {
      var t1 = new Y.ImageInfo__detectCodec_beginsWith();
      if (H.boolConversionCheck(t1.call$2(firstChunk, C.List_255_216)))
        return C._ImageCodec_0;
      if (H.boolConversionCheck(t1.call$2(firstChunk, C.List_2Vk)))
        return C._ImageCodec_1;
      if (H.boolConversionCheck(t1.call$2(firstChunk, C.List_82_73_70_70)))
        return C._ImageCodec_2;
      return;
    },
    _ImageCodec: function _ImageCodec(t0) {
      this._image_decoder$_name = t0;
    },
    _ColorPrimaries: function _ColorPrimaries(t0, t1) {
      this.index = t0;
      this._image_decoder$_name = t1;
    },
    _ColorTransfer: function _ColorTransfer(t0, t1) {
      this.index = t0;
      this._image_decoder$_name = t1;
    },
    Format: function Format(t0, t1) {
      this.index = t0;
      this._image_decoder$_name = t1;
    },
    ImageInfo: function ImageInfo(t0, t1, t2, t3, t4, t5, t6, t7, t8) {
      var _ = this;
      _.mimeType = t0;
      _.bits = t1;
      _.format = t2;
      _.width = t3;
      _.height = t4;
      _.colorPrimaries = t5;
      _.colorTransfer = t6;
      _.hasNonSquarePixels = t7;
      _.hasAnimation = t8;
    },
    ImageInfo_parseStreamAsync_closure: function ImageInfo_parseStreamAsync_closure(t0, t1) {
      this._box_0 = t0;
      this.completer = t1;
    },
    ImageInfo_parseStreamAsync_closure1: function ImageInfo_parseStreamAsync_closure1(t0, t1) {
      this._box_0 = t0;
      this.completer = t1;
    },
    ImageInfo_parseStreamAsync_closure0: function ImageInfo_parseStreamAsync_closure0(t0) {
      this._box_0 = t0;
    },
    ImageInfo__detectCodec_beginsWith: function ImageInfo__detectCodec_beginsWith() {
    },
    ImageInfoDecoder: function ImageInfoDecoder() {
    },
    JpegInfoDecoder: function JpegInfoDecoder(t0, t1) {
      var _ = this;
      _._segmentIndex = _._segmentLength = _._type = _._image_decoder$_state = 0;
      _._sofBuffer = null;
      _.completer = t0;
      _.subscription = t1;
    },
    JpegInfoDecoder__add_isSOF: function JpegInfoDecoder__add_isSOF() {
    },
    JpegInfoDecoder__add_hasSegment: function JpegInfoDecoder__add_hasSegment() {
    },
    PngInfoDecoder: function PngInfoDecoder(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _._image_decoder$_state = _._chunkDataIndex = _._chunkCrcIndex = _._chunkTypeIndex = _._chunkType = _._chunkLengthIndex = _._chunkLength = 0;
      _._hasTrns = _._hasHeader = false;
      _._transfer = t0;
      _._primaries = t1;
      _._hasNonSquarePixels = false;
      _._headerChunkBytes = t2;
      _._chunkBytes = t3;
      _.completer = t4;
      _.subscription = t5;
    },
    PngInfoDecoder_add_reset: function PngInfoDecoder_add_reset(t0) {
      this.$this = t0;
    },
    WebPInfoDecoder: function WebPInfoDecoder(t0, t1, t2) {
      var _ = this;
      _._image_decoder$_buffer = t0;
      _._bufferIndex = 0;
      _.completer = t1;
      _.subscription = t2;
    },
    UnsupportedImageFormatException: function UnsupportedImageFormatException() {
    },
    UnexpectedEndOfStreamException: function UnexpectedEndOfStreamException() {
    },
    InvalidDataFormatException: function InvalidDataFormatException(t0) {
      this.message = t0;
    }
  },
  S = {
    Mesh_fromMap: function(map, context) {
      var weights, primitivesMaps, t2, t3, t4, primitives, targetsCount, jointsCount, i, primitive, _null = null,
        _s10_ = "primitives",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_primitives_weights_name, context);
      weights = F.getFloatList(map, "weights", context, _null, _null, 1 / 0, -1 / 0, false);
      primitivesMaps = F.getMapList(map, _s10_, context);
      if (primitivesMaps != null) {
        t2 = primitivesMaps.get$length(primitivesMaps);
        t3 = S.MeshPrimitive;
        t4 = new Array(t2);
        t4.fixed$length = Array;
        t4 = H.setRuntimeTypeInfo(t4, [t3]);
        primitives = new F.SafeList(t4, t2, _s10_, [t3]);
        t3 = context.path;
        C.JSArray_methods.add$1(t3, _s10_);
        for (targetsCount = _null, jointsCount = -1, i = 0; i < primitivesMaps.get$length(primitivesMaps); ++i) {
          C.JSArray_methods.add$1(t3, C.JSInt_methods.toString$0(i));
          primitive = S.MeshPrimitive_MeshPrimitive$fromMap(primitivesMaps.$index(0, i), context);
          if (targetsCount == null) {
            t2 = primitive._targetsIndices;
            targetsCount = t2 == null ? _null : t2.length;
          } else {
            t2 = primitive._targetsIndices;
            if (targetsCount !== (t2 == null ? _null : t2.length))
              context.addIssue$2$name($.$get$SemanticError_meshPrimitivesUnequalTargetsCount(), "targets");
          }
          if (jointsCount === -1)
            jointsCount = primitive.jointsCount;
          else if (jointsCount !== primitive.jointsCount)
            context.addIssue$2$name($.$get$SemanticError_meshPrimitivesUnequalJointsCount(), "attributes");
          C.JSArray_methods.$indexSet(t4, i, primitive);
          if (0 >= t3.length)
            return H.ioore(t3, -1);
          t3.pop();
        }
        if (0 >= t3.length)
          return H.ioore(t3, -1);
        t3.pop();
        t2 = targetsCount != null && weights != null && targetsCount !== weights.length;
        if (t2)
          context.addIssue$3$args$name($.$get$SemanticError_meshInvalidWeightsCount(), H.setRuntimeTypeInfo([weights.length, targetsCount], [t1]), "weights");
      } else
        primitives = _null;
      F.getString(map, "name", context, _null, _null, _null, false);
      return new S.Mesh(primitives, F.getExtensions(map, C.Type_Mesh_K2f, context, _null, false), F.getExtras(map, context));
    },
    MeshPrimitive_MeshPrimitive$fromMap: function(map, context) {
      var mode, attributes, t2, t3, t4, targets,
        _s10_ = "attributes",
        t1 = {};
      F.checkMembers(map, C.List_iyy, context);
      t1.hasTangent = t1.hasNormal = t1.hasPosition = false;
      t1.colorCount = 0;
      t1.maxColor = -1;
      t1.jointsCount = 0;
      t1.maxJoints = -1;
      t1.weightsCount = 0;
      t1.maxWeights = -1;
      t1.texcoordCount = 0;
      t1.maxTexcoord = -1;
      mode = F.getUint(map, "mode", context, 4, null, 6, 0, false);
      attributes = F.getIndicesMap(map, _s10_, context, new S.MeshPrimitive_MeshPrimitive$fromMap_checkAttributeSemanticName(t1, context));
      if (attributes != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, _s10_);
        if (!t1.hasPosition)
          context.addIssue$1($.$get$SemanticError_meshPrimitiveNoPosition());
        if (!t1.hasNormal && t1.hasTangent)
          context.addIssue$2$name($.$get$SemanticError_meshPrimitiveTangentWithoutNormal(), "TANGENT");
        if (t1.hasTangent && mode === 0)
          context.addIssue$2$name($.$get$SemanticError_meshPrimitiveTangentPoints(), "TANGENT");
        t3 = new S.MeshPrimitive_MeshPrimitive$fromMap_checkContinuity(context);
        t1.colorCount = t3.call$3(t1.maxColor, t1.colorCount, "COLOR");
        t1.jointsCount = t3.call$3(t1.maxJoints, t1.jointsCount, "JOINTS");
        t1.weightsCount = t3.call$3(t1.maxWeights, t1.weightsCount, "WEIGHTS");
        t1.texcoordCount = t3.call$3(t1.maxTexcoord, t1.texcoordCount, "TEXCOORD");
        t3 = t1.jointsCount;
        t4 = t1.weightsCount;
        if (t3 !== t4) {
          context.addIssue$2$args($.$get$SemanticError_meshPrimitiveJointsWeightsMismatch(), H.setRuntimeTypeInfo([t3, t4], [P.Object]));
          t1.weightsCount = t1.jointsCount = 0;
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      targets = F.getIndicesMapsList(map, "targets", context, new S.MeshPrimitive_MeshPrimitive$fromMap_checkMorphTargetAttributeSemanticName(context));
      return new S.MeshPrimitive(attributes, F.getIndex(map, "indices", context, false), F.getIndex(map, "material", context, false), mode, targets, t1.jointsCount, t1.weightsCount, t1.texcoordCount, P.LinkedHashMap_LinkedHashMap$_empty(P.String, [M.Accessor, P.num]), F.getExtensions(map, C.Type_MeshPrimitive_TPX, context, null, false), F.getExtras(map, context));
    },
    Mesh: function Mesh(t0, t1, t2) {
      var _ = this;
      _.primitives = t0;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    },
    Mesh_link_closure: function Mesh_link_closure(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    MeshPrimitive: function MeshPrimitive(t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10) {
      var _ = this;
      _._attributesIndices = t0;
      _._indicesIndex = t1;
      _._materialIndex = t2;
      _.mode = t3;
      _._targetsIndices = t4;
      _.jointsCount = t5;
      _.weightsCount = t6;
      _.texcoordCount = t7;
      _.attributes = t8;
      _._vertexCount = _._count = -1;
      _._material = _._indices = _._targets = null;
      _.extensions = t9;
      _.extras = t10;
      _._isUsed = false;
    },
    MeshPrimitive_MeshPrimitive$fromMap_checkAttributeSemanticName: function MeshPrimitive_MeshPrimitive$fromMap_checkAttributeSemanticName(t0, t1) {
      this._box_0 = t0;
      this.context = t1;
    },
    MeshPrimitive_MeshPrimitive$fromMap_checkContinuity: function MeshPrimitive_MeshPrimitive$fromMap_checkContinuity(t0) {
      this.context = t0;
    },
    MeshPrimitive_MeshPrimitive$fromMap_checkMorphTargetAttributeSemanticName: function MeshPrimitive_MeshPrimitive$fromMap_checkMorphTargetAttributeSemanticName(t0) {
      this.context = t0;
    },
    MeshPrimitive_link_closure: function MeshPrimitive_link_closure(t0, t1, t2) {
      this.$this = t0;
      this.gltf = t1;
      this.context = t2;
    },
    MeshPrimitive_link_closure0: function MeshPrimitive_link_closure0() {
    },
    MeshPrimitive_link_closure1: function MeshPrimitive_link_closure1(t0, t1, t2) {
      this.$this = t0;
      this.context = t1;
      this.unusedTexCoords = t2;
    },
    MeshPrimitive_link_closure2: function MeshPrimitive_link_closure2() {
    },
    MeshPrimitive_link_closure3: function MeshPrimitive_link_closure3(t0, t1, t2, t3) {
      var _ = this;
      _.$this = t0;
      _.gltf = t1;
      _.context = t2;
      _.i = t3;
    },
    MeshPrimitive__checkAccessorRefs_closure: function MeshPrimitive__checkAccessorRefs_closure() {
    },
    IndexBufferIntegerChecker: function IndexBufferIntegerChecker(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _.maxVertexIndex = t0;
      _.totalTriangles = t1;
      _.primitiveRestartIndex = t2;
      _.isTriangles = t3;
      _._degenerateTriangles = _._vertexIndex = 0;
      _._triangle = t4;
      _.path = t5;
    },
    KhrMaterialsUnlit_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_empty, context);
      return new S.KhrMaterialsUnlit(F.getExtensions(map, C.Type_KhrMaterialsUnlit_0, context, null, false), F.getExtras(map, context));
    },
    KhrMaterialsUnlit: function KhrMaterialsUnlit(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    }
  },
  B = {
    Scene_fromMap: function(map, context) {
      var nodesIndices, _null = null;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_nodes_name, context);
      nodesIndices = F.getIndicesList(map, "nodes", context, false);
      F.getString(map, "name", context, _null, _null, _null, false);
      return new B.Scene(nodesIndices, F.getExtensions(map, C.Type_Scene_9YE, context, _null, false), F.getExtras(map, context));
    },
    Scene: function Scene(t0, t1, t2) {
      var _ = this;
      _._nodesIndices = t0;
      _.nodes = null;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    },
    Scene_link_closure: function Scene_link_closure(t0, t1) {
      this.$this = t0;
      this.context = t1;
    }
  },
  O = {
    Skin_fromMap: function(map, context) {
      var t1, t2, t3, _null = null;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_QW2, context);
      t1 = F.getIndex(map, "inverseBindMatrices", context, false);
      t2 = F.getIndex(map, "skeleton", context, false);
      t3 = F.getIndicesList(map, "joints", context, true);
      F.getString(map, "name", context, _null, _null, _null, false);
      return new O.Skin(t1, t2, t3, P.LinkedHashSet_LinkedHashSet$_empty(V.Node), F.getExtensions(map, C.Type_Skin_OJ4, context, _null, false), F.getExtras(map, context));
    },
    Skin: function Skin(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _._inverseBindMatricesIndex = t0;
      _._skeletonIndex = t1;
      _._jointsIndices = t2;
      _._skeleton = _._joints = _._inverseBindMatrices = null;
      _._commonRoots = t3;
      _.extensions = t4;
      _.extras = t5;
      _._isUsed = false;
    },
    Skin_link_closure: function Skin_link_closure(t0) {
      this.$this = t0;
    },
    IbmMatrixFloatChecker: function IbmMatrixFloatChecker(t0) {
      this.path = t0;
    },
    _guardAccessor: function(accessor, $T) {
      if (accessor == null)
        return;
      if (accessor.type == null || accessor.componentType === -1 || accessor.count === -1)
        return;
      if (accessor._bufferView == null && accessor.sparse == null)
        return;
      return accessor;
    },
    validateAccessorsData: function(gltf, context) {
      var influencesIterators, influencesCheckers, t1, t2, t3, t4, meshIndex, _box_0, t5, mesh, t6, t7, t8, jointsCount, _i, checker;
      gltf.accessors.forEachWithIndices$1(new O.validateAccessorsData_closure(context));
      O._processAccessorElements(context);
      influencesIterators = H.setRuntimeTypeInfo([], [[P.Iterator, P.num]]);
      influencesCheckers = H.setRuntimeTypeInfo([], [O.InfluencesChecker]);
      t1 = context.path;
      C.JSArray_methods.set$length(t1, 0);
      C.JSArray_methods.add$1(t1, "meshes");
      for (t2 = gltf.meshes, t3 = t2._utils$_length, t2 = t2._list, t4 = t2.length, meshIndex = 0; meshIndex < t3; ++meshIndex) {
        _box_0 = {};
        t5 = meshIndex >= t4;
        if (t5)
          mesh = null;
        else {
          if (meshIndex >= t4)
            return H.ioore(t2, meshIndex);
          mesh = t2[meshIndex];
        }
        if ((mesh == null ? null : mesh.primitives) == null)
          continue;
        t5 = mesh.primitives;
        if (t5.every$1(t5, new O.validateAccessorsData_closure0()))
          continue;
        _box_0.limitingSkinIndex = _box_0.maxJoints = -1;
        for (t6 = gltf.nodes, t6 = new H.ListIterator(t6, t6.get$length(t6), [H.getTypeArgumentByIndex(t6, 0)]); t6.moveNext$0();) {
          t7 = t6.__internal$_current;
          if (t7._mesh == mesh) {
            t8 = t7._skin;
            t8 = (t8 == null ? null : t8._joints) != null;
          } else
            t8 = false;
          if (t8) {
            t7 = t7._skin;
            jointsCount = t7._joints.length;
            t8 = _box_0.maxJoints;
            if (t8 === -1 || jointsCount < t8) {
              _box_0.maxJoints = jointsCount;
              t8 = gltf.skins;
              _box_0.limitingSkinIndex = t8.indexOf$1(t8, t7);
            }
          }
        }
        if (_box_0.maxJoints < 1)
          continue;
        C.JSArray_methods.add$1(t1, C.JSInt_methods.toString$0(meshIndex));
        C.JSArray_methods.add$1(t1, "primitives");
        t5.forEachWithIndices$1(new O.validateAccessorsData_closure1(_box_0, context, influencesIterators, influencesCheckers));
        if (0 >= t1.length)
          return H.ioore(t1, -1);
        t1.pop();
        if (0 >= t1.length)
          return H.ioore(t1, -1);
        t1.pop();
      }
      if (0 >= t1.length)
        return H.ioore(t1, -1);
      t1.pop();
      if (influencesIterators.length === 0)
        return;
      for (; O._stepInfluencesIterators(influencesIterators);)
        for (t1 = influencesCheckers.length, _i = 0; _i < influencesCheckers.length; influencesCheckers.length === t1 || (0, H.throwConcurrentModificationError)(influencesCheckers), ++_i) {
          checker = influencesCheckers[_i];
          if (!checker._done)
            checker.checkNext$1(context);
        }
    },
    _stepInfluencesIterators: function(influencesIterators) {
      var t1, _i;
      for (t1 = influencesIterators.length, _i = 0; _i < influencesIterators.length; influencesIterators.length === t1 || (0, H.throwConcurrentModificationError)(influencesIterators), ++_i)
        influencesIterators[_i].moveNext$0();
      t1 = H.functionTypeCheck(new O._stepInfluencesIterators_closure(), {func: 1, ret: P.bool, args: [H.getTypeArgumentByIndex(influencesIterators, 0)]});
      if (!!influencesIterators.fixed$length)
        H.throwExpression(P.UnsupportedError$("removeWhere"));
      C.JSArray_methods._removeWhere$2(influencesIterators, t1, true);
      return influencesIterators.length !== 0;
    },
    _processAccessorElements: function(context) {
      var t1, t2, t3, t4, accessor, components, elementCheckers, t5, index, componentIndex, notEmpty, t6, t;
      for (t1 = context.accessorElementCheckers.get$entries(), t1 = t1.get$iterator(t1), t2 = context.path, t3 = P.num; t1.moveNext$0();) {
        t4 = t1.get$current();
        accessor = O._guardAccessor(t4.key, t3);
        if (accessor == null)
          continue;
        components = C.Map_A1ato.$index(0, accessor.type);
        if (components == null)
          components = 0;
        elementCheckers = t4.value;
        C.JSArray_methods.set$length(t2, 0);
        for (t4 = accessor.getElements$0(), t4 = new P._SyncStarIterator(t4._outerHelper(), [H.getTypeArgumentByIndex(t4, 0)]), t5 = J.getInterceptor$asx(elementCheckers), index = 0, componentIndex = 0, notEmpty = false; t4.moveNext$0(); notEmpty = true) {
          t6 = t4.get$current();
          for (t = 0; t < t5.get$length(elementCheckers); ++t)
            if (!t5.$index(elementCheckers, t).check$4(context, index, componentIndex, t6))
              continue;
          ++componentIndex;
          if (componentIndex === components)
            componentIndex = 0;
          ++index;
        }
        if (notEmpty)
          for (t = 0; t < t5.get$length(elementCheckers); ++t)
            t5.$index(elementCheckers, t).done$1(context);
      }
    },
    validateAccessorsData_closure: function validateAccessorsData_closure(t0) {
      this.context = t0;
    },
    validateAccessorsData_closure0: function validateAccessorsData_closure0() {
    },
    validateAccessorsData_closure1: function validateAccessorsData_closure1(t0, t1, t2, t3) {
      var _ = this;
      _._box_0 = t0;
      _.context = t1;
      _.influencesIterators = t2;
      _.influencesCheckers = t3;
    },
    _stepInfluencesIterators_closure: function _stepInfluencesIterators_closure() {
    },
    InfluencesChecker: function InfluencesChecker(t0, t1, t2, t3, t4, t5) {
      var _ = this;
      _.jointsIterators = t0;
      _.weightsIterators = t1;
      _.maxJointIndex = t2;
      _.limitingSkinIndex = t3;
      _.path = t4;
      _._componentIndex = _._validate_accessors$_index = 0;
      _._done = false;
      _._threshold = _._sum = 0;
      _._currentIndices = t5;
    }
  },
  U = {
    Texture_fromMap: function(map, context) {
      var t1, t2, _null = null;
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      F.checkMembers(map, C.List_sampler_source_name, context);
      t1 = F.getIndex(map, "sampler", context, false);
      t2 = F.getIndex(map, "source", context, false);
      F.getString(map, "name", context, _null, _null, _null, false);
      return new U.Texture(t1, t2, F.getExtensions(map, C.Type_Texture_gsm, context, _null, false), F.getExtras(map, context));
    },
    Texture: function Texture(t0, t1, t2, t3) {
      var _ = this;
      _._samplerIndex = t0;
      _._texture$_sourceIndex = t1;
      _._texture$_source = _._sampler = null;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    _init0: function(context) {
      var _s8_ = "POSITION",
        t1 = context.attributeAccessorFormats;
      t1.$index(0, _s8_).addAll$1(0, C.List_tES);
      t1.$index(0, "NORMAL").addAll$1(0, C.List_a9P);
      t1.$index(0, "TANGENT").addAll$1(0, C.List_zzp);
      t1.$index(0, "TEXCOORD").addAll$1(0, C.List_4CA);
      t1 = context.morphAttributeAccessorFormats;
      t1.$index(0, _s8_).addAll$1(0, C.List_Ri2);
      t1.$index(0, "NORMAL").addAll$1(0, C.List_a9P);
      t1.$index(0, "TANGENT").addAll$1(0, C.List_a9P);
    }
  },
  N = {_Storage: function _Storage(t0, t1) {
      this.index = t0;
      this._resources_loader$_name = t1;
    }, ResourceInfo: function ResourceInfo(t0) {
      var _ = this;
      _.pointer = t0;
      _.image = _.uri = _.byteLength = _.storage = _.mimeType = null;
    }, ResourcesLoader: function ResourcesLoader(t0, t1, t2, t3) {
      var _ = this;
      _.gltf = t0;
      _.context = t1;
      _.externalBytesFetch = t2;
      _.externalStreamFetch = t3;
    }, ResourcesLoader__loadBuffers__fetchBuffer: function ResourcesLoader__loadBuffers__fetchBuffer(t0, t1, t2) {
      this.$this = t0;
      this.info = t1;
      this.i = t2;
    }, ResourcesLoader__loadImages__fetchImageData: function ResourcesLoader__loadImages__fetchImageData(t0, t1) {
      this.$this = t0;
      this.resourceInfo = t1;
    }},
  E = {
    DataError$_: function(type, message, severity) {
      return new E.DataError(severity, type, message);
    },
    SchemaError$_: function(type, message, severity) {
      return new E.SchemaError(severity, type, message);
    },
    SemanticError$_: function(type, message, severity) {
      return new E.SemanticError(severity, type, message);
    },
    LinkError$_: function(type, message, severity) {
      return new E.LinkError(severity, type, message);
    },
    GlbError$_: function(type, message, severity) {
      return new E.GlbError(severity, type, message);
    },
    _q: function(o) {
      return "'" + H.S(o) + "'";
    },
    _mbq: function(o) {
      return typeof o === "string" ? "'" + o + "'" : J.toString$0$(o);
    },
    Severity: function Severity(t0, t1) {
      this.index = t0;
      this._errors$_name = t1;
    },
    IssueType: function IssueType() {
    },
    DataError: function DataError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    DataError_closure16: function DataError_closure16() {
    },
    DataError_closure14: function DataError_closure14() {
    },
    DataError_closure13: function DataError_closure13() {
    },
    DataError_closure20: function DataError_closure20() {
    },
    DataError_closure18: function DataError_closure18() {
    },
    DataError_closure19: function DataError_closure19() {
    },
    DataError_closure17: function DataError_closure17() {
    },
    DataError_closure29: function DataError_closure29() {
    },
    DataError_closure30: function DataError_closure30() {
    },
    DataError_closure22: function DataError_closure22() {
    },
    DataError_closure28: function DataError_closure28() {
    },
    DataError_closure21: function DataError_closure21() {
    },
    DataError_closure27: function DataError_closure27() {
    },
    DataError_closure25: function DataError_closure25() {
    },
    DataError_closure26: function DataError_closure26() {
    },
    DataError_closure24: function DataError_closure24() {
    },
    DataError_closure23: function DataError_closure23() {
    },
    DataError_closure5: function DataError_closure5() {
    },
    DataError_closure4: function DataError_closure4() {
    },
    DataError_closure31: function DataError_closure31() {
    },
    DataError_closure9: function DataError_closure9() {
    },
    DataError_closure8: function DataError_closure8() {
    },
    DataError_closure10: function DataError_closure10() {
    },
    DataError_closure11: function DataError_closure11() {
    },
    DataError_closure12: function DataError_closure12() {
    },
    DataError_closure7: function DataError_closure7() {
    },
    DataError_closure6: function DataError_closure6() {
    },
    DataError_closure15: function DataError_closure15() {
    },
    DataError_closure3: function DataError_closure3() {
    },
    DataError_closure2: function DataError_closure2() {
    },
    DataError_closure1: function DataError_closure1() {
    },
    DataError_closure: function DataError_closure() {
    },
    DataError_closure0: function DataError_closure0() {
    },
    IoError: function IoError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    IoError_closure: function IoError_closure() {
    },
    SchemaError: function SchemaError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    SchemaError_closure3: function SchemaError_closure3() {
    },
    SchemaError_closure4: function SchemaError_closure4() {
    },
    SchemaError_closure9: function SchemaError_closure9() {
    },
    SchemaError_closure7: function SchemaError_closure7() {
    },
    SchemaError_closure14: function SchemaError_closure14() {
    },
    SchemaError_closure10: function SchemaError_closure10() {
    },
    SchemaError_closure5: function SchemaError_closure5() {
    },
    SchemaError_closure11: function SchemaError_closure11() {
    },
    SchemaError_closure8: function SchemaError_closure8() {
    },
    SchemaError_closure: function SchemaError_closure() {
    },
    SchemaError_closure2: function SchemaError_closure2() {
    },
    SchemaError_closure1: function SchemaError_closure1() {
    },
    SchemaError_closure12: function SchemaError_closure12() {
    },
    SchemaError_closure0: function SchemaError_closure0() {
    },
    SchemaError_closure6: function SchemaError_closure6() {
    },
    SchemaError_closure13: function SchemaError_closure13() {
    },
    SemanticError: function SemanticError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    SemanticError_closure38: function SemanticError_closure38() {
    },
    SemanticError_closure37: function SemanticError_closure37() {
    },
    SemanticError_closure28: function SemanticError_closure28() {
    },
    SemanticError_closure26: function SemanticError_closure26() {
    },
    SemanticError_closure27: function SemanticError_closure27() {
    },
    SemanticError_closure25: function SemanticError_closure25() {
    },
    SemanticError_closure23: function SemanticError_closure23() {
    },
    SemanticError_closure24: function SemanticError_closure24() {
    },
    SemanticError_closure33: function SemanticError_closure33() {
    },
    SemanticError_closure34: function SemanticError_closure34() {
    },
    SemanticError_closure22: function SemanticError_closure22() {
    },
    SemanticError_closure21: function SemanticError_closure21() {
    },
    SemanticError_closure20: function SemanticError_closure20() {
    },
    SemanticError_closure19: function SemanticError_closure19() {
    },
    SemanticError_closure18: function SemanticError_closure18() {
    },
    SemanticError_closure16: function SemanticError_closure16() {
    },
    SemanticError_closure10: function SemanticError_closure10() {
    },
    SemanticError_closure9: function SemanticError_closure9() {
    },
    SemanticError_closure8: function SemanticError_closure8() {
    },
    SemanticError_closure15: function SemanticError_closure15() {
    },
    SemanticError_closure12: function SemanticError_closure12() {
    },
    SemanticError_closure14: function SemanticError_closure14() {
    },
    SemanticError_closure11: function SemanticError_closure11() {
    },
    SemanticError_closure13: function SemanticError_closure13() {
    },
    SemanticError_closure7: function SemanticError_closure7() {
    },
    SemanticError_closure5: function SemanticError_closure5() {
    },
    SemanticError_closure4: function SemanticError_closure4() {
    },
    SemanticError_closure3: function SemanticError_closure3() {
    },
    SemanticError_closure6: function SemanticError_closure6() {
    },
    SemanticError_closure39: function SemanticError_closure39() {
    },
    SemanticError_closure40: function SemanticError_closure40() {
    },
    SemanticError_closure41: function SemanticError_closure41() {
    },
    SemanticError_closure42: function SemanticError_closure42() {
    },
    SemanticError_closure32: function SemanticError_closure32() {
    },
    SemanticError_closure31: function SemanticError_closure31() {
    },
    SemanticError_closure30: function SemanticError_closure30() {
    },
    SemanticError_closure29: function SemanticError_closure29() {
    },
    SemanticError_closure36: function SemanticError_closure36() {
    },
    SemanticError_closure35: function SemanticError_closure35() {
    },
    SemanticError_closure17: function SemanticError_closure17() {
    },
    SemanticError_closure0: function SemanticError_closure0() {
    },
    SemanticError_closure: function SemanticError_closure() {
    },
    SemanticError_closure2: function SemanticError_closure2() {
    },
    SemanticError_closure1: function SemanticError_closure1() {
    },
    LinkError: function LinkError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    LinkError_closure4: function LinkError_closure4() {
    },
    LinkError_closure8: function LinkError_closure8() {
    },
    LinkError_closure3: function LinkError_closure3() {
    },
    LinkError_closure17: function LinkError_closure17() {
    },
    LinkError_closure9: function LinkError_closure9() {
    },
    LinkError_closure13: function LinkError_closure13() {
    },
    LinkError_closure12: function LinkError_closure12() {
    },
    LinkError_closure15: function LinkError_closure15() {
    },
    LinkError_closure16: function LinkError_closure16() {
    },
    LinkError_closure11: function LinkError_closure11() {
    },
    LinkError_closure14: function LinkError_closure14() {
    },
    LinkError_closure10: function LinkError_closure10() {
    },
    LinkError_closure2: function LinkError_closure2() {
    },
    LinkError_closure18: function LinkError_closure18() {
    },
    LinkError_closure7: function LinkError_closure7() {
    },
    LinkError_closure35: function LinkError_closure35() {
    },
    LinkError_closure21: function LinkError_closure21() {
    },
    LinkError_closure22: function LinkError_closure22() {
    },
    LinkError_closure19: function LinkError_closure19() {
    },
    LinkError_closure20: function LinkError_closure20() {
    },
    LinkError_closure28: function LinkError_closure28() {
    },
    LinkError_closure27: function LinkError_closure27() {
    },
    LinkError_closure26: function LinkError_closure26() {
    },
    LinkError_closure25: function LinkError_closure25() {
    },
    LinkError_closure29: function LinkError_closure29() {
    },
    LinkError_closure24: function LinkError_closure24() {
    },
    LinkError_closure23: function LinkError_closure23() {
    },
    LinkError_closure6: function LinkError_closure6() {
    },
    LinkError_closure30: function LinkError_closure30() {
    },
    LinkError_closure33: function LinkError_closure33() {
    },
    LinkError_closure32: function LinkError_closure32() {
    },
    LinkError_closure31: function LinkError_closure31() {
    },
    LinkError_closure34: function LinkError_closure34() {
    },
    LinkError_closure36: function LinkError_closure36() {
    },
    LinkError_closure1: function LinkError_closure1() {
    },
    LinkError_closure0: function LinkError_closure0() {
    },
    LinkError_closure: function LinkError_closure() {
    },
    LinkError_closure37: function LinkError_closure37() {
    },
    LinkError_closure38: function LinkError_closure38() {
    },
    LinkError_closure5: function LinkError_closure5() {
    },
    GlbError: function GlbError(t0, t1, t2) {
      this.severity = t0;
      this.code = t1;
      this.message = t2;
    },
    GlbError_closure12: function GlbError_closure12() {
    },
    GlbError_closure11: function GlbError_closure11() {
    },
    GlbError_closure10: function GlbError_closure10() {
    },
    GlbError_closure9: function GlbError_closure9() {
    },
    GlbError_closure0: function GlbError_closure0() {
    },
    GlbError_closure8: function GlbError_closure8() {
    },
    GlbError_closure4: function GlbError_closure4() {
    },
    GlbError_closure5: function GlbError_closure5() {
    },
    GlbError_closure1: function GlbError_closure1() {
    },
    GlbError_closure: function GlbError_closure() {
    },
    GlbError_closure2: function GlbError_closure2() {
    },
    GlbError_closure7: function GlbError_closure7() {
    },
    GlbError_closure6: function GlbError_closure6() {
    },
    GlbError_closure3: function GlbError_closure3() {
    },
    Issue: function Issue(t0, t1, t2, t3, t4) {
      var _ = this;
      _.type = t0;
      _.severityOverride = t1;
      _.pointer = t2;
      _.offset = t3;
      _._args = t4;
    }
  },
  D = {
    _init: function(context) {
      C.JSArray_methods.add$1(context.imageMimeTypes, "image/webp");
    },
    ExtTextureWebPTexture_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_source, context);
      return new D.ExtTextureWebPTexture(F.getIndex(map, "source", context, false), F.getExtensions(map, C.Type_ExtTextureWebPTexture_9YE, context, null, false), F.getExtras(map, context));
    },
    ExtTextureWebPTexture: function ExtTextureWebPTexture(t0, t1, t2) {
      var _ = this;
      _._sourceIndex = t0;
      _._ext_texture_webp$_source = null;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    },
    Extension: function Extension(t0, t1, t2, t3) {
      var _ = this;
      _.name = t0;
      _.functions = t1;
      _.init = t2;
      _.required = t3;
    },
    ExtFuncs: function ExtFuncs(t0) {
      this.fromMap = t0;
    },
    ExtensionTuple: function ExtensionTuple(t0, t1) {
      this.type = t0;
      this.name = t1;
    },
    LinkableExtensionEntry: function LinkableExtensionEntry(t0, t1) {
      this.object = t0;
      this.path = t1;
    },
    ResourceValidatableExtensionEntry: function ResourceValidatableExtensionEntry(t0, t1) {
      this.object = t0;
      this.path = t1;
    }
  },
  X = {
    KhrLightsPunctualGltf_fromMap: function(map, context) {
      var lightMaps, t1, t2, t3, t4, lights, i, lightMap, type, range, _null = null, _s6_ = "lights", _s4_ = "spot";
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_lights, context);
      lightMaps = F.getMapList(map, _s6_, context);
      t1 = X.KhrLightsPunctualLight;
      t2 = [t1];
      t1 = [t1];
      if (lightMaps != null) {
        t3 = lightMaps.get$length(lightMaps);
        t4 = new Array(t3);
        t4.fixed$length = Array;
        t2 = H.setRuntimeTypeInfo(t4, t2);
        lights = new F.SafeList(t2, t3, _s6_, t1);
        t1 = context.path;
        C.JSArray_methods.add$1(t1, _s6_);
        for (t3 = X.KhrLightsPunctualLightSpot, i = 0; i < lightMaps.get$length(lightMaps); ++i) {
          lightMap = lightMaps.$index(0, i);
          C.JSArray_methods.add$1(t1, C.JSInt_methods.toString$0(i));
          F.checkMembers(lightMap, C.List_INA, context);
          F.getFloatList(lightMap, "color", context, C.List_1_1_1, C.List_3, 1, 0, false);
          F.getFloat(lightMap, "intensity", context, 1, 1 / 0, -1 / 0, 1 / 0, 0, false);
          type = F.getString(lightMap, "type", context, _null, C.List_directional_point_spot, _null, true);
          if (type === "spot")
            F.getObjectFromInnerMap(lightMap, _s4_, context, X.khr_lights_punctual_KhrLightsPunctualLightSpot_fromMap$closure(), true, t3);
          else {
            t4 = lightMap.containsKey$1(_s4_);
            if (t4)
              context.addIssue$2$name($.$get$SemanticError_extraProperty(), _s4_);
          }
          range = F.getFloat(lightMap, "range", context, 0 / 0, 1 / 0, 0, 1 / 0, -1 / 0, false);
          t4 = type === "directional" && !isNaN(range);
          if (t4)
            context.addIssue$2$name($.$get$SemanticError_extraProperty(), "range");
          F.getString(lightMap, "name", context, _null, _null, _null, false);
          C.JSArray_methods.$indexSet(t2, i, new X.KhrLightsPunctualLight(F.getExtensions(lightMap, C.Type_KhrLightsPunctualLight_4m4, context, _null, false), F.getExtras(lightMap, context)));
          if (0 >= t1.length)
            return H.ioore(t1, -1);
          t1.pop();
        }
        if (0 >= t1.length)
          return H.ioore(t1, -1);
        t1.pop();
      } else {
        t3 = new Array(0);
        t3.fixed$length = Array;
        lights = new F.SafeList(H.setRuntimeTypeInfo(t3, t2), 0, _s6_, t1);
      }
      return new X.KhrLightsPunctualGltf(lights, F.getExtensions(map, C.Type_KhrLightsPunctualGltf_4YB, context, _null, false), F.getExtras(map, context));
    },
    KhrLightsPunctualLightSpot_fromMap: function(map, context) {
      var innerConeAngle, outerConeAngle, t2,
        _s14_ = "outerConeAngle",
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      F.checkMembers(map, C.List_innerConeAngle_outerConeAngle, context);
      innerConeAngle = F.getFloat(map, "innerConeAngle", context, 0, 1.5707963267948966, -1 / 0, 1 / 0, 0, false);
      outerConeAngle = F.getFloat(map, _s14_, context, 0.7853981633974483, 1 / 0, 0, 1.5707963267948966, -1 / 0, false);
      t2 = !isNaN(outerConeAngle) && !isNaN(innerConeAngle) && outerConeAngle <= innerConeAngle;
      if (t2)
        context.addIssue$3$args$name($.$get$SemanticError_khrLightsPunctualLightSpotAngles(), H.setRuntimeTypeInfo([innerConeAngle, outerConeAngle], [t1]), _s14_);
      return new X.KhrLightsPunctualLightSpot(F.getExtensions(map, C.Type_KhrLightsPunctualLightSpot_oBB, context, null, false), F.getExtras(map, context));
    },
    KhrLightsPunctualNode_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_light, context);
      return new X.KhrLightsPunctualNode(F.getIndex(map, "light", context, true), F.getExtensions(map, C.Type_KhrLightsPunctualNode_eHw, context, null, false), F.getExtras(map, context));
    },
    KhrLightsPunctualGltf: function KhrLightsPunctualGltf(t0, t1, t2) {
      var _ = this;
      _.lights = t0;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    },
    KhrLightsPunctualGltf_link_closure: function KhrLightsPunctualGltf_link_closure(t0, t1) {
      this.context = t0;
      this.gltf = t1;
    },
    KhrLightsPunctualLight: function KhrLightsPunctualLight(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    },
    KhrLightsPunctualLightSpot: function KhrLightsPunctualLightSpot(t0, t1) {
      this.extensions = t0;
      this.extras = t1;
      this._isUsed = false;
    },
    KhrLightsPunctualNode: function KhrLightsPunctualNode(t0, t1, t2) {
      var _ = this;
      _._lightIndex = t0;
      _._light = null;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    }
  },
  A = {
    KhrMaterialsPbrSpecularGlossiness_fromMap: function(map, context) {
      var t2, diffuseTexture, specularGlossinessTexture, extensions, pbrSg,
        t1 = P.Object;
      H.assertSubtype(map, "$isMap", [P.String, t1], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_cwF, context);
      F.getFloatList(map, "diffuseFactor", context, C.List_1_1_1_1, C.List_4, 1, 0, false);
      t2 = Y.TextureInfo;
      diffuseTexture = F.getObjectFromInnerMap(map, "diffuseTexture", context, Y.material_TextureInfo_fromMap$closure(), false, t2);
      F.getFloatList(map, "specularFactor", context, C.List_1_1_1, C.List_3, 1, 0, false);
      F.getFloat(map, "glossinessFactor", context, 1, 1 / 0, -1 / 0, 1, 0, false);
      specularGlossinessTexture = F.getObjectFromInnerMap(map, "specularGlossinessTexture", context, Y.material_TextureInfo_fromMap$closure(), false, t2);
      extensions = F.getExtensions(map, C.Type_DzG, context, null, false);
      pbrSg = new A.KhrMaterialsPbrSpecularGlossiness(diffuseTexture, specularGlossinessTexture, extensions, F.getExtras(map, context));
      t1 = H.setRuntimeTypeInfo([], [t1]);
      C.JSArray_methods.add$1(t1, diffuseTexture);
      C.JSArray_methods.add$1(t1, specularGlossinessTexture);
      for (t2 = extensions.get$values(), t2 = new H.MappedIterator(J.get$iterator$ax(t2.__internal$_iterable), t2._f, [H.getTypeArgumentByIndex(t2, 0), H.getTypeArgumentByIndex(t2, 1)]); t2.moveNext$0();)
        C.JSArray_methods.add$1(t1, t2.__internal$_current);
      context.registerObjectsOwner$2(pbrSg, t1);
      return pbrSg;
    },
    KhrMaterialsPbrSpecularGlossiness: function KhrMaterialsPbrSpecularGlossiness(t0, t1, t2, t3) {
      var _ = this;
      _.diffuseTexture = t0;
      _.specularGlossinessTexture = t1;
      _.extensions = t2;
      _.extras = t3;
      _._isUsed = false;
    },
    GlbReader: function GlbReader(t0, t1, t2) {
      var _ = this;
      _._header = t0;
      _._headerByteData = null;
      _.stream = t1;
      _._glb_reader$_subscription = null;
      _._glb_reader$_completer = t2;
      _._context = null;
      _._glb_reader$_chunkType = _._glb_reader$_chunkLength = _._chunkNumber = _._totalLength = _._glb_reader$_offset = _._localOffset = _._glb_reader$_state = 0;
      _._hasJsonChunk = false;
      _._jsonStreamController = _._jsonReaderResult = _._jsonReader = null;
      _._hasBinChunk = false;
      _._binaryBuffer = null;
    },
    GlbReader_read_closure: function GlbReader_read_closure(t0) {
      this.$this = t0;
    },
    GlbReader__onData_updateState: function GlbReader__onData_updateState(t0) {
      this.$this = t0;
    },
    GlbReader__onDone_closure: function GlbReader__onDone_closure(t0) {
      this.$this = t0;
    },
    ValidationResult: function ValidationResult(t0, t1, t2, t3) {
      var _ = this;
      _.uri = t0;
      _.context = t1;
      _.readerResult = t2;
      _.writeTimestamp = t3;
    },
    ValidationResult__getGltfInfoMap_closure: function ValidationResult__getGltfInfoMap_closure() {
    },
    ValidationResult__getGltfInfoMap__closure: function ValidationResult__getGltfInfoMap__closure() {
    },
    hashObjects: function(objects) {
      var hash,
        t1 = C.NativeFloat32List_methods.fold$1$2(objects, 0, new A.hashObjects_closure(), P.int);
      if (typeof t1 !== "number")
        return H.iae(t1);
      hash = 536870911 & t1 + ((67108863 & t1) << 3);
      hash ^= hash >>> 11;
      return 536870911 & hash + ((16383 & hash) << 15);
    },
    hashObjects_closure: function hashObjects_closure() {
    },
    _combine: function(hash, value) {
      var _hash = 536870911 & hash + value;
      _hash = 536870911 & _hash + ((524287 & _hash) << 10);
      return _hash ^ _hash >>> 6;
    },
    _finish: function(hash) {
      var _hash = 536870911 & hash + ((67108863 & hash) << 3);
      _hash ^= _hash >>> 11;
      return 536870911 & _hash + ((16383 & _hash) << 15);
    }
  },
  L = {
    KhrTextureTransform_fromMap: function(map, context) {
      H.assertSubtype(map, "$isMap", [P.String, P.Object], "$asMap");
      H.interceptedTypeCheck(context, "$isContext");
      context.toString;
      F.checkMembers(map, C.List_offset_rotation_scale_texCoord, context);
      F.getFloatList(map, "offset", context, C.List_0_0, C.List_2, 1 / 0, -1 / 0, false);
      F.getFloat(map, "rotation", context, 0, 1 / 0, -1 / 0, 1 / 0, -1 / 0, false);
      F.getFloatList(map, "scale", context, C.List_1_1, C.List_2, 1 / 0, -1 / 0, false);
      return new L.KhrTextureTransform(F.getUint(map, "texCoord", context, -1, null, -1, 0, false), F.getExtensions(map, C.Type_KhrTextureTransform_xSJ, context, null, false), F.getExtras(map, context));
    },
    KhrTextureTransform: function KhrTextureTransform(t0, t1, t2) {
      var _ = this;
      _.texCoord = t0;
      _.extensions = t1;
      _.extras = t2;
      _._isUsed = false;
    }
  },
  K = {
    GltfReader_detect: function(stream, context) {
      var controller, t1 = {},
        t2 = K.GltfReader,
        t3 = new P._Future($.Zone__current, [t2]);
      t1.formatDetected = false;
      t1.subscription = null;
      controller = P.StreamController_StreamController(new K.GltfReader_detect_closure(t1), new K.GltfReader_detect_closure0(t1), new K.GltfReader_detect_closure1(t1), [P.List, P.int]);
      t1.subscription = stream.listen$2$onDone(new K.GltfReader_detect_closure2(t1, controller, new P._AsyncCompleter(t3, [t2]), context), controller.get$close());
      return t3;
    },
    GltfJsonReader$: function(stream, context) {
      var t1 = K.GltfReaderResult;
      t1 = new K.GltfJsonReader(stream, new P._AsyncCompleter(new P._Future($.Zone__current, [t1]), [t1]));
      t1._gltf_reader$_context = context;
      return t1;
    },
    GltfJsonReader_readFromJsonString: function(jsonString, context) {
      var e, root, exception, t1, t2, parsedJson = null;
      try {
        parsedJson = C.C_JsonCodec.decode$1(jsonString);
      } catch (exception) {
        t1 = H.unwrapException(exception);
        if (t1 instanceof P.FormatException) {
          e = t1;
          context.addIssue$3$args$noPointer($.$get$SchemaError_invalidJson(), H.setRuntimeTypeInfo([e], [P.Object]), true);
          return;
        } else
          throw exception;
      }
      t1 = parsedJson;
      t2 = P.Object;
      if (H.checkSubtype(t1, "$isMap", [P.String, t2], "$asMap"))
        try {
          root = V.Gltf_Gltf$fromMap(parsedJson, context);
          return new K.GltfReaderResult("model/gltf+json", root, null);
        } catch (exception) {
          if (H.unwrapException(exception) instanceof M.IssuesLimitExceededException)
            return;
          else
            throw exception;
        }
      else {
        context.addIssue$3$args$noPointer($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([parsedJson, "object"], [t2]), true);
        return;
      }
    },
    GltfReaderResult: function GltfReaderResult(t0, t1, t2) {
      this.mimeType = t0;
      this.gltf = t1;
      this.buffer = t2;
    },
    GltfReader: function GltfReader() {
    },
    GltfReader_detect_closure0: function GltfReader_detect_closure0(t0) {
      this._box_0 = t0;
    },
    GltfReader_detect_closure1: function GltfReader_detect_closure1(t0) {
      this._box_0 = t0;
    },
    GltfReader_detect_closure: function GltfReader_detect_closure(t0) {
      this._box_0 = t0;
    },
    GltfReader_detect_closure2: function GltfReader_detect_closure2(t0, t1, t2, t3) {
      var _ = this;
      _._box_0 = t0;
      _.controller = t1;
      _.completer = t2;
      _.context = t3;
    },
    GltfJsonReader: function GltfJsonReader(t0, t1) {
      var _ = this;
      _.stream = t0;
      _._gltf_reader$_subscription = null;
      _._completer = t1;
      _._gltf_reader$_context = _._byteSink = null;
      _._isFirstChunk = true;
    },
    GltfJsonReader_read_closure: function GltfJsonReader_read_closure(t0) {
      this.$this = t0;
    },
    GltfInvalidFormatException: function GltfInvalidFormatException() {
    }
  },
  F = {
    _getGuarded: function(map, $name, type, context) {
      var value = map.$index(0, $name);
      if (value == null && map.containsKey$1($name))
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([null, type], [P.Object]), $name);
      return value;
    },
    getIndex: function(map, $name, context, req) {
      var value = F._getGuarded(map, $name, "integer", context);
      if (typeof value === "number" && Math.floor(value) === value) {
        if (value >= 0)
          return value;
        context.addIssue$2$name($.$get$SchemaError_invalidIndex(), $name);
      } else if (value == null) {
        if (req)
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [P.Object]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "integer"], [P.Object]), $name);
      return -1;
    },
    getBool: function(map, $name, context) {
      var value = F._getGuarded(map, $name, "boolean", context);
      if (value == null)
        return false;
      if (typeof value === "boolean")
        return value;
      context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "boolean"], [P.Object]), $name);
      return false;
    },
    getUint: function(map, $name, context, def, list, max, min, req) {
      var t1,
        value = F._getGuarded(map, $name, "integer", context);
      if (typeof value === "number" && Math.floor(value) === value) {
        if (list != null) {
          if (!F.checkEnum($name, value, list, context, false, P.int))
            return -1;
        } else {
          if (!(value < min))
            t1 = max !== -1 && value > max;
          else
            t1 = true;
          if (t1) {
            context.addIssue$3$args$name($.$get$SchemaError_valueNotInRange(), H.setRuntimeTypeInfo([value], [P.Object]), $name);
            return -1;
          }
        }
        return value;
      } else if (value == null) {
        if (!req)
          return def;
        context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [P.Object]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "integer"], [P.Object]), $name);
      return -1;
    },
    getFloat: function(map, $name, context, def, exclMax, exclMin, max, min, req) {
      var value = F._getGuarded(map, $name, "number", context);
      if (typeof value === "number") {
        if (value < min || value <= exclMin || value > max || value >= exclMax) {
          context.addIssue$3$args$name($.$get$SchemaError_valueNotInRange(), H.setRuntimeTypeInfo([value], [P.Object]), $name);
          return 0 / 0;
        }
        return value;
      } else if (value == null) {
        if (!req)
          return def;
        context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [P.Object]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "number"], [P.Object]), $name);
      return 0 / 0;
    },
    getString: function(map, $name, context, def, list, regexp, req) {
      var t1,
        value = F._getGuarded(map, $name, "string", context);
      if (typeof value === "string") {
        if (list != null)
          F.checkEnum($name, value, list, context, false, P.String);
        else {
          if (regexp == null)
            t1 = null;
          else {
            t1 = regexp._nativeRegExp;
            t1 = t1.test(value);
          }
          if (t1 === false) {
            context.addIssue$3$args$name($.$get$SchemaError_patternMismatch(), H.setRuntimeTypeInfo([value, regexp.pattern], [P.Object]), $name);
            return;
          }
        }
        return value;
      } else if (value == null) {
        if (!req)
          return def;
        context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [P.Object]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "string"], [P.Object]), $name);
      return;
    },
    getUri: function(uriString, context) {
      var uri, e, t1, exception;
      try {
        uri = P.Uri_parse(uriString);
        t1 = uri;
        if (t1.get$hasScheme() || t1.get$hasAuthority() || t1.get$hasAbsolutePath() || t1.get$hasQuery() || t1.get$hasFragment())
          context.addIssue$3$args$name($.$get$SemanticError_nonRelativeUri(), H.setRuntimeTypeInfo([uriString], [P.Object]), "uri");
        return uri;
      } catch (exception) {
        t1 = H.unwrapException(exception);
        if (t1 instanceof P.FormatException) {
          e = t1;
          context.addIssue$3$args$name($.$get$SchemaError_invalidUri(), H.setRuntimeTypeInfo([uriString, e], [P.Object]), "uri");
          return;
        } else
          throw exception;
      }
    },
    getMap: function(map, $name, context, req) {
      var value = F._getGuarded(map, $name, "object", context),
        t1 = P.String,
        t2 = P.Object;
      if (H.checkSubtype(value, "$isMap", [t1, t2], "$asMap"))
        return value;
      else if (value == null) {
        if (req) {
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [t2]));
          return;
        }
      } else {
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "object"], [t2]), $name);
        if (req)
          return;
      }
      return P.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
    },
    getObjectFromInnerMap: function(map, $name, context, fromMap, req, $T) {
      var object,
        value = F._getGuarded(map, $name, "object", context),
        t1 = P.Object;
      if (H.checkSubtype(value, "$isMap", [P.String, t1], "$asMap")) {
        t1 = context.path;
        C.JSArray_methods.add$1(t1, $name);
        object = fromMap.call$2(value, context);
        if (0 >= t1.length)
          return H.ioore(t1, -1);
        t1.pop();
        return object;
      } else if (value == null) {
        if (req)
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [t1]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "object"], [t1]), $name);
      return;
    },
    getIndicesList: function(map, $name, context, req) {
      var t2, t3, uniqueItems, i, v,
        value = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(value);
      if (!!t1.$isList) {
        if (t1.get$isEmpty(value)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        }
        t2 = context.path;
        C.JSArray_methods.add$1(t2, $name);
        t3 = P.int;
        uniqueItems = P.LinkedHashSet_LinkedHashSet$_empty(t3);
        for (i = 0; i < t1.get$length(value); ++i) {
          v = t1.$index(value, i);
          if (typeof v === "number" && Math.floor(v) === v && v >= 0) {
            if (!uniqueItems.add$1(0, v))
              context.addIssue$2$index($.$get$SchemaError_arrayDuplicateElements(), i);
          } else {
            t1.$indexSet(value, i, -1);
            context.addIssue$2$index($.$get$SchemaError_invalidIndex(), i);
          }
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
        return t1.cast$1$0(value, t3);
      } else if (value == null) {
        if (req)
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], [P.Object]));
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "array"], [P.Object]), $name);
      return;
    },
    getIndicesMap: function(map, $name, context, checkKey) {
      var t3,
        value = F._getGuarded(map, $name, "object", context),
        t1 = P.String,
        t2 = P.Object;
      if (H.checkSubtype(value, "$isMap", [t1, t2], "$asMap")) {
        t2 = J.getInterceptor$asx(value);
        if (t2.get$isEmpty(value)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        }
        t3 = context.path;
        C.JSArray_methods.add$1(t3, $name);
        t2.forEach$1(value, new F.getIndicesMap_closure(checkKey, value, context));
        if (0 >= t3.length)
          return H.ioore(t3, -1);
        t3.pop();
        return t2.cast$2$0(value, t1, P.int);
      } else {
        t1 = [t2];
        if (value == null)
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], t1));
        else
          context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "object"], t1), $name);
      }
      return;
    },
    getIndicesMapsList: function(map, $name, context, checkKey) {
      var t2, t3, t4, invalidElementFound, i, innerMap, t5,
        list = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(list);
      if (!!t1.$isList) {
        if (t1.get$isEmpty(list)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        } else {
          t2 = context.path;
          C.JSArray_methods.add$1(t2, $name);
          for (t3 = P.Object, t4 = [t3], t3 = [P.String, t3], invalidElementFound = false, i = 0; i < t1.get$length(list); ++i) {
            innerMap = t1.$index(list, i);
            if (H.checkSubtype(innerMap, "$isMap", t3, "$asMap")) {
              t5 = J.getInterceptor$asx(innerMap);
              if (t5.get$isEmpty(innerMap)) {
                context.addIssue$2$index($.$get$SchemaError_emptyEntity(), i);
                invalidElementFound = true;
              } else {
                C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
                t5.forEach$1(innerMap, new F.getIndicesMapsList_closure(checkKey, innerMap, context));
                if (0 >= t2.length)
                  return H.ioore(t2, -1);
                t2.pop();
              }
            } else {
              context.addIssue$2$args($.$get$SchemaError_arrayTypeMismatch(), H.setRuntimeTypeInfo([innerMap, "object"], t4));
              invalidElementFound = true;
            }
          }
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
          if (invalidElementFound)
            return;
        }
        t1 = t1.cast$1$0(list, [P.Map,,,]);
        t2 = [P.Map, P.String, P.int];
        t3 = H.getRuntimeTypeArgument(t1, "ListMixin", 0);
        return new H.MappedListIterable(t1, H.functionTypeCheck(new F.getIndicesMapsList_closure0(), {func: 1, ret: t2, args: [t3]}), [t3, t2]).toList$1$growable(0, false);
      } else if (list != null)
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([list, "array"], [P.Object]), $name);
      return;
    },
    getFloatList: function(map, $name, context, def, lengthsList, max, min, singlePrecision) {
      var t2, result, wrongMemberFound, i, v, t3,
        value = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(value);
      if (!!t1.$isList) {
        if (t1.get$isEmpty(value)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        }
        if (lengthsList != null && !F.checkEnum($name, t1.get$length(value), lengthsList, context, true, P.int))
          return;
        t2 = new Array(t1.get$length(value));
        t2.fixed$length = Array;
        result = H.setRuntimeTypeInfo(t2, [P.double]);
        for (t2 = [P.Object], wrongMemberFound = false, i = 0; i < t1.get$length(value); ++i) {
          v = t1.$index(value, i);
          if (typeof v === "number") {
            t3 = v < min || v > max;
            if (t3) {
              context.addIssue$3$args$name($.$get$SchemaError_valueNotInRange(), H.setRuntimeTypeInfo([v], t2), $name);
              wrongMemberFound = true;
            }
            if (singlePrecision) {
              t3 = $.$get$_float();
              t3[0] = v;
              C.JSArray_methods.$indexSet(result, i, t3[0]);
            } else
              C.JSArray_methods.$indexSet(result, i, v);
          } else {
            context.addIssue$3$args$name($.$get$SchemaError_arrayTypeMismatch(), H.setRuntimeTypeInfo([v, "number"], t2), $name);
            wrongMemberFound = true;
          }
        }
        if (wrongMemberFound)
          return;
        return result;
      } else if (value == null) {
        if (def == null)
          t1 = null;
        else
          t1 = J.JSArray_JSArray$markFixed(def.slice(0), H.getTypeArgumentByIndex(def, 0));
        return t1;
      } else
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "array"], [P.Object]), $name);
      return;
    },
    getGlIntList: function(map, $name, context, type, $length) {
      var min, max, result, t2, t3, wrongMemberFound, i, v, t4,
        value = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(value);
      if (!!t1.$isList) {
        if (t1.get$length(value) !== $length) {
          context.addIssue$3$args$name($.$get$SchemaError_arrayLengthNotInList(), H.setRuntimeTypeInfo([t1.get$length(value), H.setRuntimeTypeInfo([$length], [P.int])], [P.Object]), $name);
          return;
        }
        min = Z.typeMin(type);
        max = Z.typeMax(type);
        result = F.createTypedIntList(type, $length);
        for (t2 = [P.Object], t3 = result.length, wrongMemberFound = false, i = 0; i < t1.get$length(value); ++i) {
          v = t1.$index(value, i);
          if (typeof v === "number" && C.JSNumber_methods.toInt$0(v) === v) {
            if (typeof v !== "number" || Math.floor(v) !== v)
              context.addIssue$3$args$name($.$get$SemanticError_integerWrittenAsFloat(), H.setRuntimeTypeInfo([v], t2), $name);
            if (typeof v !== "number")
              return v.$lt();
            t4 = v < min || v > max;
            if (t4) {
              context.addIssue$3$args$name($.$get$SemanticError_invalidGlValue(), H.setRuntimeTypeInfo([v, C.Map_ZGNO4.$index(0, type)], t2), $name);
              wrongMemberFound = true;
            }
            t4 = J.toInt$0$n(v);
            if (i >= t3)
              return H.ioore(result, i);
            result[i] = t4;
          } else {
            context.addIssue$3$args$name($.$get$SchemaError_arrayTypeMismatch(), H.setRuntimeTypeInfo([v, "integer"], t2), $name);
            wrongMemberFound = true;
          }
        }
        if (wrongMemberFound)
          return;
        return result;
      } else if (value != null)
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "array"], [P.Object]), $name);
      return;
    },
    getStringList: function(map, $name, context) {
      var t2, t3, uniqueItems, t4, wrongMemberFound, i, v,
        value = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(value);
      if (!!t1.$isList) {
        if (t1.get$isEmpty(value)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        }
        t2 = context.path;
        C.JSArray_methods.add$1(t2, $name);
        t3 = P.String;
        uniqueItems = P.LinkedHashSet_LinkedHashSet$_empty(t3);
        for (t4 = [P.Object], wrongMemberFound = false, i = 0; i < t1.get$length(value); ++i) {
          v = t1.$index(value, i);
          if (typeof v === "string") {
            if (!uniqueItems.add$1(0, v))
              context.addIssue$2$index($.$get$SchemaError_arrayDuplicateElements(), i);
          } else {
            context.addIssue$3$args$index($.$get$SchemaError_arrayTypeMismatch(), H.setRuntimeTypeInfo([v, "string"], t4), i);
            wrongMemberFound = true;
          }
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
        if (wrongMemberFound)
          return;
        return t1.cast$1$0(value, t3);
      } else if (value != null)
        context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "array"], [P.Object]), $name);
      return;
    },
    getMapList: function(map, $name, context) {
      var t2, t3, t4, invalidElementFound, v,
        value = F._getGuarded(map, $name, "array", context),
        t1 = J.getInterceptor$(value);
      if (!!t1.$isList) {
        if (t1.get$isEmpty(value)) {
          context.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          return;
        } else {
          for (t2 = t1.get$iterator(value), t3 = P.Object, t4 = [P.String, t3], t3 = [t3], invalidElementFound = false; t2.moveNext$0();) {
            v = t2.get$current();
            if (!H.checkSubtype(v, "$isMap", t4, "$asMap")) {
              context.addIssue$3$args$name($.$get$SchemaError_arrayTypeMismatch(), H.setRuntimeTypeInfo([v, "object"], t3), $name);
              invalidElementFound = true;
            }
          }
          if (invalidElementFound)
            return;
        }
        return t1.cast$1$0(value, [P.Map, P.String, P.Object]);
      } else {
        t1 = [P.Object];
        if (value == null)
          context.addIssue$2$args($.$get$SchemaError_undefinedProperty(), H.setRuntimeTypeInfo([$name], t1));
        else
          context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([value, "array"], t1), $name);
      }
      return;
    },
    getExtensions: function(map, type, context, overriddenType, warnOnMultipleExtensions) {
      var t2, t3, t4, t5, t6, extensionMap, t7, functions, object, t8,
        _s10_ = "extensions",
        t1 = P.Object,
        extensions = P.LinkedHashMap_LinkedHashMap$_empty(P.String, t1),
        extensionMaps = F.getMap(map, _s10_, context, false);
      if (extensionMaps.get$isEmpty(extensionMaps))
        return extensions;
      t2 = context.path;
      C.JSArray_methods.add$1(t2, _s10_);
      if (warnOnMultipleExtensions && extensionMaps.get$length(extensionMaps) > 1)
        context.addIssue$2$args($.$get$SemanticError_multipleExtensions(), H.setRuntimeTypeInfo([null, extensionMaps.get$keys()], [t1]));
      for (t1 = extensionMaps.get$keys(), t1 = t1.get$iterator(t1), t3 = overriddenType == null, t4 = context.linkableExtensions, t5 = context.resourceValidatableExtensions; t1.moveNext$0();) {
        t6 = t1.get$current();
        extensionMap = F.getMap(extensionMaps, t6, context, false);
        t7 = context._extensionsLoadedView;
        if (!t7.contains$1(t7, t6)) {
          extensions.$indexSet(0, t6, null);
          t7 = context._extensionsUsedView;
          t7 = t7.contains$1(t7, t6);
          if (!t7)
            context.addIssue$2$name($.$get$LinkError_undeclaredExtension(), t6);
          continue;
        }
        functions = context._extensionsFunctionsView._map.$index(0, new D.ExtensionTuple(type, t6));
        if (functions == null) {
          context.addIssue$2$name($.$get$LinkError_unexpectedExtensionObject(), t6);
          continue;
        }
        if (extensionMap != null) {
          C.JSArray_methods.add$1(t2, t6);
          object = functions.fromMap.call$2(extensionMap, context);
          extensions.$indexSet(0, t6, object);
          t6 = J.getInterceptor$(object);
          if (!!t6.$isLinkable) {
            t7 = t3 ? type : overriddenType;
            t7 = t4.putIfAbsent$2(t7, new F.getExtensions_closure());
            t8 = H.setRuntimeTypeInfo(t2.slice(0), [H.getTypeArgumentByIndex(t2, 0)]);
            t8.fixed$length = Array;
            J.add$1$ax(t7, new D.LinkableExtensionEntry(object, t8));
          }
          if (!!t6.$isResourceValidatable) {
            t6 = H.setRuntimeTypeInfo(t2.slice(0), [H.getTypeArgumentByIndex(t2, 0)]);
            t6.fixed$length = Array;
            C.JSArray_methods.add$1(t5, new D.ResourceValidatableExtensionEntry(object, t6));
          }
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
      }
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
      return extensions;
    },
    getExtras: function(map, context) {
      var extras = map.$index(0, "extras"),
        t1 = extras != null && !J.getInterceptor$(extras).$isMap;
      if (t1)
        context.addIssue$2$name($.$get$SemanticError_nonObjectExtras(), "extras");
      return extras;
    },
    checkEnum: function($name, value, list, context, lengthList, $T) {
      var t1;
      if (!J.contains$1$ax(list, value)) {
        t1 = lengthList ? $.$get$SchemaError_arrayLengthNotInList() : $.$get$SchemaError_valueNotInList();
        context.addIssue$3$args$name(t1, H.setRuntimeTypeInfo([value, list], [P.Object]), $name);
        return false;
      }
      return true;
    },
    checkMembers: function(map, knownMembers, context) {
      var t1, t2, t3;
      for (t1 = map.get$keys(), t1 = t1.get$iterator(t1); t1.moveNext$0();) {
        t2 = t1.get$current();
        if (!C.JSArray_methods.contains$1(knownMembers, t2)) {
          t3 = C.JSArray_methods.contains$1(C.List_extensions_extras, t2);
          t3 = !t3;
        } else
          t3 = false;
        if (t3)
          context.addIssue$2$name($.$get$SchemaError_unexpectedProperty(), t2);
      }
    },
    resolveNodeList: function(sourceList, targetList, nodes, $name, context, handleNode) {
      var t2, t3, t4, t5, i, nodeIndex, node,
        t1 = context.path;
      C.JSArray_methods.add$1(t1, $name);
      for (t2 = [P.Object], t3 = nodes._list, t4 = t3.length, t5 = targetList && C.JSArray_methods, i = 0; i < sourceList.get$length(sourceList); ++i) {
        nodeIndex = sourceList.$index(0, i);
        if (nodeIndex === -1)
          continue;
        node = nodeIndex == null || nodeIndex < 0 || nodeIndex >= t4 ? null : C.JSArray_methods.$index(t3, nodeIndex);
        if (node != null) {
          node._isUsed = true;
          t5.$indexSet(targetList, i, node);
          handleNode.call$3(node, nodeIndex, i);
        } else
          context.addIssue$3$args$index($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([nodeIndex], t2), i);
      }
      if (0 >= t1.length)
        return H.ioore(t1, -1);
      t1.pop();
    },
    isTrsDecomposable: function(matrix) {
      var t2, t3, t4, v, sx, sy, sz, invSX, invSY, invSZ, t5, t6, t7, t, s, i, j, k, t8, t9, t10, x, y, z, w, x2, y2, z2, xx, xy, xz, yy, yz, zz, wx, wy, wz,
        t1 = matrix._m4storage;
      if (t1[3] !== 0 || t1[7] !== 0 || t1[11] !== 0 || t1[15] !== 1)
        return false;
      if (matrix.determinant$0() === 0)
        return false;
      t2 = $.$get$_translation();
      t3 = $.$get$_rotation();
      t4 = $.$get$_scale();
      v = new T.Vector3(new Float32Array(3));
      v.setValues$3(t1[0], t1[1], t1[2]);
      sx = Math.sqrt(v.get$length2());
      v.setValues$3(t1[4], t1[5], t1[6]);
      sy = Math.sqrt(v.get$length2());
      v.setValues$3(t1[8], t1[9], t1[10]);
      sz = Math.sqrt(v.get$length2());
      if (matrix.determinant$0() < 0)
        sx = -sx;
      t2 = t2._v3storage;
      t2[0] = t1[12];
      t2[1] = t1[13];
      t2[2] = t1[14];
      invSX = 1 / sx;
      invSY = 1 / sy;
      invSZ = 1 / sz;
      t1 = new Float32Array(16);
      new T.Matrix4(t1).setFrom$1(matrix);
      t1[0] = t1[0] * invSX;
      t1[1] = t1[1] * invSX;
      t1[2] = t1[2] * invSX;
      t1[4] = t1[4] * invSY;
      t1[5] = t1[5] * invSY;
      t1[6] = t1[6] * invSY;
      t1[8] = t1[8] * invSZ;
      t1[9] = t1[9] * invSZ;
      t1[10] = t1[10] * invSZ;
      t5 = new Float32Array(9);
      t5[0] = t1[0];
      t5[1] = t1[1];
      t5[2] = t1[2];
      t5[3] = t1[4];
      t5[4] = t1[5];
      t5[5] = t1[6];
      t5[6] = t1[8];
      t5[7] = t1[9];
      t5[8] = t1[10];
      t3.toString;
      t1 = t5[0];
      t6 = t5[4];
      t7 = t5[8];
      t = 0 + t1 + t6 + t7;
      if (t > 0) {
        s = Math.sqrt(t + 1);
        t1 = t3._qStorage;
        t1[3] = s * 0.5;
        s = 0.5 / s;
        t1[0] = (t5[5] - t5[7]) * s;
        t1[1] = (t5[6] - t5[2]) * s;
        t1[2] = (t5[1] - t5[3]) * s;
      } else {
        if (t1 < t6)
          i = t6 < t7 ? 2 : 1;
        else
          i = t1 < t7 ? 2 : 0;
        j = (i + 1) % 3;
        k = (i + 2) % 3;
        t1 = i * 3;
        t6 = t1 + i;
        if (t6 >= 9)
          return H.ioore(t5, t6);
        t6 = t5[t6];
        t7 = j * 3;
        t8 = t7 + j;
        if (t8 >= 9)
          return H.ioore(t5, t8);
        t8 = t5[t8];
        t9 = k * 3;
        t10 = t9 + k;
        if (t10 >= 9)
          return H.ioore(t5, t10);
        s = Math.sqrt(t6 - t8 - t5[t10] + 1);
        t3 = t3._qStorage;
        t3[i] = s * 0.5;
        s = 0.5 / s;
        t10 = t7 + k;
        if (t10 >= 9)
          return H.ioore(t5, t10);
        t10 = t5[t10];
        t8 = t9 + j;
        if (t8 >= 9)
          return H.ioore(t5, t8);
        t3[3] = (t10 - t5[t8]) * s;
        t8 = t1 + j;
        if (t8 >= 9)
          return H.ioore(t5, t8);
        t8 = t5[t8];
        t7 += i;
        if (t7 >= 9)
          return H.ioore(t5, t7);
        t3[j] = (t8 + t5[t7]) * s;
        t1 += k;
        if (t1 >= 9)
          return H.ioore(t5, t1);
        t1 = t5[t1];
        t9 += i;
        if (t9 >= 9)
          return H.ioore(t5, t9);
        t3[k] = (t1 + t5[t9]) * s;
        t1 = t3;
      }
      t3 = t4._v3storage;
      t3[0] = sx;
      t3[1] = sy;
      t3[2] = sz;
      t5 = $.$get$_matrix();
      x = t1[0];
      y = t1[1];
      z = t1[2];
      w = t1[3];
      x2 = x + x;
      y2 = y + y;
      z2 = z + z;
      xx = x * x2;
      xy = x * y2;
      xz = x * z2;
      yy = y * y2;
      yz = y * z2;
      zz = z * z2;
      wx = w * x2;
      wy = w * y2;
      wz = w * z2;
      t1 = t5._m4storage;
      t1[0] = 1 - (yy + zz);
      t1[1] = xy + wz;
      t1[2] = xz - wy;
      t1[3] = 0;
      t1[4] = xy - wz;
      t1[5] = 1 - (xx + zz);
      t1[6] = yz + wx;
      t1[7] = 0;
      t1[8] = xz + wy;
      t1[9] = yz - wx;
      t1[10] = 1 - (xx + yy);
      t1[11] = 0;
      t1[12] = t2[0];
      t1[13] = t2[1];
      t1[14] = t2[2];
      t1[15] = 1;
      if (t4 instanceof T.Vector3) {
        sx = t3[0];
        sy = t3[1];
        sz = t3[2];
      } else {
        sx = null;
        sy = null;
        sz = null;
      }
      t2 = t1[0];
      if (typeof sx !== "number")
        return H.iae(sx);
      t1[0] = t2 * sx;
      t1[1] = t1[1] * sx;
      t1[2] = t1[2] * sx;
      t1[3] = t1[3] * sx;
      t2 = t1[4];
      if (typeof sy !== "number")
        return H.iae(sy);
      t1[4] = t2 * sy;
      t1[5] = t1[5] * sy;
      t1[6] = t1[6] * sy;
      t1[7] = t1[7] * sy;
      t2 = t1[8];
      if (typeof sz !== "number")
        return H.iae(sz);
      t1[8] = t2 * sz;
      t1[9] = t1[9] * sz;
      t1[10] = t1[10] * sz;
      t1[11] = t1[11] * sz;
      t1[12] = t1[12];
      t1[13] = t1[13];
      t1[14] = t1[14];
      t1[15] = t1[15];
      return Math.abs(t5.infinityNorm$0() - matrix.infinityNorm$0()) < 0.00005;
    },
    createTypedIntList: function(type, $length) {
      switch (type) {
        case 5120:
          return new Int8Array($length);
        case 5121:
          return new Uint8Array($length);
        case 5122:
          return new Int16Array($length);
        case 5123:
          return new Uint16Array($length);
        case 5124:
          return new Int32Array($length);
        case 5125:
          return new Uint32Array($length);
        default:
          throw H.wrapException(P.ArgumentError$(null));
      }
    },
    getIndicesMap_closure: function getIndicesMap_closure(t0, t1, t2) {
      this.checkKey = t0;
      this.value = t1;
      this.context = t2;
    },
    getIndicesMapsList_closure: function getIndicesMapsList_closure(t0, t1, t2) {
      this.checkKey = t0;
      this.innerMap = t1;
      this.context = t2;
    },
    getIndicesMapsList_closure0: function getIndicesMapsList_closure0() {
    },
    getExtensions_closure: function getExtensions_closure() {
    },
    SafeList: function SafeList(t0, t1, t2, t3) {
      var _ = this;
      _._list = t0;
      _._utils$_length = t1;
      _.name = t2;
      _.$ti = t3;
    },
    ElementChecker: function ElementChecker() {
    },
    UnitVec3FloatChecker: function UnitVec3FloatChecker(t0, t1) {
      this._utils$_sum = 0;
      this.path = t0;
      this.normalizeValue = t1;
    },
    UnitVec3SignFloatChecker: function UnitVec3SignFloatChecker(t0, t1) {
      this._utils$_sum = 0;
      this.path = t0;
      this.normalizeValue = t1;
    },
    ClampedRangeFloatChecker: function ClampedRangeFloatChecker(t0) {
      this.path = t0;
    }
  };
  var holders = [C, H, J, P, M, Z, T, Q, V, G, Y, S, B, O, U, N, E, D, X, A, L, K, F];
  hunkHelpers.setFunctionNamesIfNecessary(holders);
  var $ = {};
  H.JS_CONST.prototype = {};
  J.Interceptor.prototype = {
    $eq: function(receiver, other) {
      return receiver === other;
    },
    get$hashCode: function(receiver) {
      return H.Primitives_objectHashCode(receiver);
    },
    toString$0: function(receiver) {
      return "Instance of '" + H.S(H.Primitives_objectTypeName(receiver)) + "'";
    },
    noSuchMethod$1: function(receiver, invocation) {
      H.interceptedTypeCheck(invocation, "$isInvocation");
      throw H.wrapException(P.NoSuchMethodError$(receiver, invocation.get$memberName(), invocation.get$positionalArguments(), invocation.get$namedArguments()));
    }
  };
  J.JSBool.prototype = {
    toString$0: function(receiver) {
      return String(receiver);
    },
    get$hashCode: function(receiver) {
      return receiver ? 519018 : 218159;
    },
    $isbool: 1
  };
  J.JSNull.prototype = {
    $eq: function(receiver, other) {
      return null == other;
    },
    toString$0: function(receiver) {
      return "null";
    },
    get$hashCode: function(receiver) {
      return 0;
    },
    noSuchMethod$1: function(receiver, invocation) {
      return this.super$Interceptor$noSuchMethod(receiver, H.interceptedTypeCheck(invocation, "$isInvocation"));
    },
    $isNull: 1
  };
  J.JavaScriptObject.prototype = {
    get$hashCode: function(receiver) {
      return 0;
    },
    toString$0: function(receiver) {
      return String(receiver);
    },
    $isPromise: 1,
    $asPromise: function() {
      return [-2];
    },
    $is_JSValidationOptions: 1,
    then$1$1: function(receiver, p0) {
      return receiver.then(p0);
    },
    then$2: function(receiver, p0, p1) {
      return receiver.then(p0, p1);
    },
    set$validateBytes: function(obj, v) {
      return obj.validateBytes = v;
    },
    set$validateString: function(obj, v) {
      return obj.validateString = v;
    },
    set$version: function(obj, v) {
      return obj.version = v;
    },
    set$supportedExtensions: function(obj, v) {
      return obj.supportedExtensions = v;
    },
    get$uri: function(obj) {
      return obj.uri;
    },
    get$externalResourceFunction: function(obj) {
      return obj.externalResourceFunction;
    },
    get$validateAccessorData: function(obj) {
      return obj.validateAccessorData;
    },
    get$writeTimestamp: function(obj) {
      return obj.writeTimestamp;
    },
    get$maxIssues: function(obj) {
      return obj.maxIssues;
    },
    get$ignoredIssues: function(obj) {
      return obj.ignoredIssues;
    },
    get$severityOverrides: function(obj) {
      return obj.severityOverrides;
    }
  };
  J.PlainJavaScriptObject.prototype = {};
  J.UnknownJavaScriptObject.prototype = {};
  J.JavaScriptFunction.prototype = {
    toString$0: function(receiver) {
      var dartClosure = receiver[$.$get$DART_CLOSURE_PROPERTY_NAME()];
      if (dartClosure == null)
        return this.super$JavaScriptObject$toString(receiver);
      return "JavaScript function for " + H.S(J.toString$0$(dartClosure));
    },
    $signature: function() {
      return {func: 1, opt: [,,,,,,,,,,,,,,,,]};
    },
    $isFunction: 1
  };
  J.JSArray.prototype = {
    cast$1$0: function(receiver, $R) {
      return new H.CastList(receiver, [H.getTypeArgumentByIndex(receiver, 0), $R]);
    },
    add$1: function(receiver, value) {
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(receiver, 0));
      if (!!receiver.fixed$length)
        H.throwExpression(P.UnsupportedError$("add"));
      receiver.push(value);
    },
    _removeWhere$2: function(receiver, test, removeMatching) {
      var retained, end, i, element, t1;
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [H.getTypeArgumentByIndex(receiver, 0)]});
      retained = [];
      end = receiver.length;
      for (i = 0; i < end; ++i) {
        element = receiver[i];
        if (!H.boolConversionCheck(test.call$1(element)))
          retained.push(element);
        if (receiver.length !== end)
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      t1 = retained.length;
      if (t1 === end)
        return;
      this.set$length(receiver, t1);
      for (i = 0; i < retained.length; ++i)
        receiver[i] = retained[i];
    },
    addAll$1: function(receiver, collection) {
      var t1;
      H.assertSubtype(collection, "$isIterable", [H.getTypeArgumentByIndex(receiver, 0)], "$asIterable");
      if (!!receiver.fixed$length)
        H.throwExpression(P.UnsupportedError$("addAll"));
      for (t1 = J.get$iterator$ax(collection); t1.moveNext$0();)
        receiver.push(t1.get$current());
    },
    map$1$1: function(receiver, f, $T) {
      var t1 = H.getTypeArgumentByIndex(receiver, 0);
      return new H.MappedListIterable(receiver, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), [t1, $T]);
    },
    join$1: function(receiver, separator) {
      var i,
        list = new Array(receiver.length);
      list.fixed$length = Array;
      for (i = 0; i < receiver.length; ++i)
        this.$indexSet(list, i, H.S(receiver[i]));
      return list.join(separator);
    },
    skip$1: function(receiver, n) {
      return H.SubListIterable$(receiver, n, null, H.getTypeArgumentByIndex(receiver, 0));
    },
    firstWhere$2$orElse: function(receiver, test, orElse) {
      var end, i, element,
        t1 = H.getTypeArgumentByIndex(receiver, 0);
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [t1]});
      H.functionTypeCheck(orElse, {func: 1, ret: t1});
      end = receiver.length;
      for (i = 0; i < end; ++i) {
        element = receiver[i];
        if (H.boolConversionCheck(test.call$1(element)))
          return element;
        if (receiver.length !== end)
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      return orElse.call$0();
    },
    elementAt$1: function(receiver, index) {
      if (index < 0 || index >= receiver.length)
        return H.ioore(receiver, index);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      if (start < 0 || start > receiver.length)
        throw H.wrapException(P.RangeError$range(start, 0, receiver.length, "start", null));
      if (end < start || end > receiver.length)
        throw H.wrapException(P.RangeError$range(end, start, receiver.length, "end", null));
      if (start === end)
        return H.setRuntimeTypeInfo([], [H.getTypeArgumentByIndex(receiver, 0)]);
      return H.setRuntimeTypeInfo(receiver.slice(start, end), [H.getTypeArgumentByIndex(receiver, 0)]);
    },
    get$last: function(receiver) {
      var t1 = receiver.length;
      if (t1 > 0)
        return receiver[t1 - 1];
      throw H.wrapException(H.IterableElementError_noElement());
    },
    contains$1: function(receiver, other) {
      var i;
      for (i = 0; i < receiver.length; ++i)
        if (J.$eq$(receiver[i], other))
          return true;
      return false;
    },
    get$isEmpty: function(receiver) {
      return receiver.length === 0;
    },
    get$isNotEmpty: function(receiver) {
      return receiver.length !== 0;
    },
    toString$0: function(receiver) {
      return P.IterableBase_iterableToFullString(receiver, "[", "]");
    },
    toList$1$growable: function(receiver, growable) {
      var t1 = J.JSArray_JSArray$markFixed(receiver.slice(0), H.getTypeArgumentByIndex(receiver, 0));
      return t1;
    },
    toSet$0: function(receiver) {
      return P.LinkedHashSet_LinkedHashSet$from(receiver, H.getTypeArgumentByIndex(receiver, 0));
    },
    get$iterator: function(receiver) {
      return new J.ArrayIterator(receiver, receiver.length, [H.getTypeArgumentByIndex(receiver, 0)]);
    },
    get$hashCode: function(receiver) {
      return H.Primitives_objectHashCode(receiver);
    },
    get$length: function(receiver) {
      return receiver.length;
    },
    set$length: function(receiver, newLength) {
      if (!!receiver.fixed$length)
        H.throwExpression(P.UnsupportedError$("set length"));
      if (newLength < 0)
        throw H.wrapException(P.RangeError$range(newLength, 0, null, "newLength", null));
      receiver.length = newLength;
    },
    $index: function(receiver, index) {
      if (index >= receiver.length || index < 0)
        throw H.wrapException(H.diagnoseIndexError(receiver, index));
      return receiver[index];
    },
    $indexSet: function(receiver, index, value) {
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(receiver, 0));
      if (!!receiver.immutable$list)
        H.throwExpression(P.UnsupportedError$("indexed set"));
      if (index >= receiver.length || index < 0)
        throw H.wrapException(H.diagnoseIndexError(receiver, index));
      receiver[index] = value;
    },
    $isEfficientLengthIterable: 1,
    $isIterable: 1,
    $isList: 1
  };
  J.JSUnmodifiableArray.prototype = {};
  J.ArrayIterator.prototype = {
    get$current: function() {
      return this._current;
    },
    moveNext$0: function() {
      var t2, _this = this,
        t1 = _this._iterable,
        $length = t1.length;
      if (_this._length !== $length)
        throw H.wrapException(H.throwConcurrentModificationError(t1));
      t2 = _this._index;
      if (t2 >= $length) {
        _this.set$_current(null);
        return false;
      }
      _this.set$_current(t1[t2]);
      ++_this._index;
      return true;
    },
    set$_current: function(_current) {
      this._current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  J.JSNumber.prototype = {
    toInt$0: function(receiver) {
      var t1;
      if (receiver >= -2147483648 && receiver <= 2147483647)
        return receiver | 0;
      if (isFinite(receiver)) {
        t1 = receiver < 0 ? Math.ceil(receiver) : Math.floor(receiver);
        return t1 + 0;
      }
      throw H.wrapException(P.UnsupportedError$("" + receiver + ".toInt()"));
    },
    toRadixString$1: function(receiver, radix) {
      var result, match, t1, exponent;
      if (radix < 2 || radix > 36)
        throw H.wrapException(P.RangeError$range(radix, 2, 36, "radix", null));
      result = receiver.toString(radix);
      if (C.JSString_methods.codeUnitAt$1(result, result.length - 1) !== 41)
        return result;
      match = /^([\da-z]+)(?:\.([\da-z]+))?\(e\+(\d+)\)$/.exec(result);
      if (match == null)
        H.throwExpression(P.UnsupportedError$("Unexpected toString result: " + result));
      t1 = match.length;
      if (1 >= t1)
        return H.ioore(match, 1);
      result = match[1];
      if (3 >= t1)
        return H.ioore(match, 3);
      exponent = +match[3];
      t1 = match[2];
      if (t1 != null) {
        result += t1;
        exponent -= t1.length;
      }
      return result + C.JSString_methods.$mul("0", exponent);
    },
    toString$0: function(receiver) {
      if (receiver === 0 && 1 / receiver < 0)
        return "-0.0";
      else
        return "" + receiver;
    },
    get$hashCode: function(receiver) {
      var absolute, floorLog2, factor, scaled,
        intValue = receiver | 0;
      if (receiver === intValue)
        return 536870911 & intValue;
      absolute = Math.abs(receiver);
      floorLog2 = Math.log(absolute) / 0.6931471805599453 | 0;
      factor = Math.pow(2, floorLog2);
      scaled = absolute < 1 ? absolute / factor : factor / absolute;
      return 536870911 & ((scaled * 9007199254740992 | 0) + (scaled * 3542243181176521 | 0)) * 599197 + floorLog2 * 1259;
    },
    $mod: function(receiver, other) {
      var result = receiver % other;
      if (result === 0)
        return 0;
      if (result > 0)
        return result;
      if (other < 0)
        return result - other;
      else
        return result + other;
    },
    $tdiv: function(receiver, other) {
      if ((receiver | 0) === receiver)
        if (other >= 1 || other < -1)
          return receiver / other | 0;
      return this._tdivSlow$1(receiver, other);
    },
    _tdivFast$1: function(receiver, other) {
      return (receiver | 0) === receiver ? receiver / other | 0 : this._tdivSlow$1(receiver, other);
    },
    _tdivSlow$1: function(receiver, other) {
      var quotient = receiver / other;
      if (quotient >= -2147483648 && quotient <= 2147483647)
        return quotient | 0;
      if (quotient > 0) {
        if (quotient !== 1 / 0)
          return Math.floor(quotient);
      } else if (quotient > -1 / 0)
        return Math.ceil(quotient);
      throw H.wrapException(P.UnsupportedError$("Result of truncating division is " + H.S(quotient) + ": " + H.S(receiver) + " ~/ " + other));
    },
    $shl: function(receiver, other) {
      if (other < 0)
        throw H.wrapException(H.argumentErrorValue(other));
      return other > 31 ? 0 : receiver << other >>> 0;
    },
    _shrOtherPositive$1: function(receiver, other) {
      var t1;
      if (receiver > 0)
        t1 = this._shrBothPositive$1(receiver, other);
      else {
        t1 = other > 31 ? 31 : other;
        t1 = receiver >> t1 >>> 0;
      }
      return t1;
    },
    _shrReceiverPositive$1: function(receiver, other) {
      if (other < 0)
        throw H.wrapException(H.argumentErrorValue(other));
      return this._shrBothPositive$1(receiver, other);
    },
    _shrBothPositive$1: function(receiver, other) {
      return other > 31 ? 0 : receiver >>> other;
    },
    $isdouble: 1,
    $isnum: 1
  };
  J.JSInt.prototype = {$isint: 1};
  J.JSDouble.prototype = {};
  J.JSString.prototype = {
    codeUnitAt$1: function(receiver, index) {
      if (index < 0)
        throw H.wrapException(H.diagnoseIndexError(receiver, index));
      if (index >= receiver.length)
        H.throwExpression(H.diagnoseIndexError(receiver, index));
      return receiver.charCodeAt(index);
    },
    _codeUnitAt$1: function(receiver, index) {
      if (index >= receiver.length)
        throw H.wrapException(H.diagnoseIndexError(receiver, index));
      return receiver.charCodeAt(index);
    },
    $add: function(receiver, other) {
      if (typeof other !== "string")
        throw H.wrapException(P.ArgumentError$value(other, null, null));
      return receiver + other;
    },
    replaceRange$3: function(receiver, start, end, replacement) {
      var prefix, suffix;
      end = P.RangeError_checkValidRange(start, end, receiver.length);
      prefix = receiver.substring(0, start);
      suffix = receiver.substring(end);
      return prefix + replacement + suffix;
    },
    startsWith$2: function(receiver, pattern, index) {
      var endIndex;
      if (typeof index !== "number" || Math.floor(index) !== index)
        H.throwExpression(H.argumentErrorValue(index));
      if (typeof index !== "number")
        return index.$lt();
      if (index < 0 || index > receiver.length)
        throw H.wrapException(P.RangeError$range(index, 0, receiver.length, null, null));
      endIndex = index + pattern.length;
      if (endIndex > receiver.length)
        return false;
      return pattern === receiver.substring(index, endIndex);
    },
    startsWith$1: function($receiver, pattern) {
      return this.startsWith$2($receiver, pattern, 0);
    },
    substring$2: function(receiver, startIndex, endIndex) {
      if (typeof startIndex !== "number" || Math.floor(startIndex) !== startIndex)
        H.throwExpression(H.argumentErrorValue(startIndex));
      if (endIndex == null)
        endIndex = receiver.length;
      if (typeof startIndex !== "number")
        return startIndex.$lt();
      if (startIndex < 0)
        throw H.wrapException(P.RangeError$value(startIndex, null));
      if (startIndex > endIndex)
        throw H.wrapException(P.RangeError$value(startIndex, null));
      if (endIndex > receiver.length)
        throw H.wrapException(P.RangeError$value(endIndex, null));
      return receiver.substring(startIndex, endIndex);
    },
    substring$1: function($receiver, startIndex) {
      return this.substring$2($receiver, startIndex, null);
    },
    trimRight$0: function(receiver) {
      var result, endIndex, t1;
      if (typeof receiver.trimRight != "undefined") {
        result = receiver.trimRight();
        endIndex = result.length;
        if (endIndex === 0)
          return result;
        t1 = endIndex - 1;
        if (this.codeUnitAt$1(result, t1) === 133)
          endIndex = J.JSString__skipTrailingWhitespace(result, t1);
      } else {
        endIndex = J.JSString__skipTrailingWhitespace(receiver, receiver.length);
        result = receiver;
      }
      if (endIndex === result.length)
        return result;
      if (endIndex === 0)
        return "";
      return result.substring(0, endIndex);
    },
    $mul: function(receiver, times) {
      var s, result;
      if (0 >= times)
        return "";
      if (times === 1 || receiver.length === 0)
        return receiver;
      if (times !== times >>> 0)
        throw H.wrapException(C.C_OutOfMemoryError);
      for (s = receiver, result = ""; true;) {
        if ((times & 1) === 1)
          result = s + result;
        times = times >>> 1;
        if (times === 0)
          break;
        s += s;
      }
      return result;
    },
    padLeft$2: function(receiver, width, padding) {
      var delta = width - receiver.length;
      if (delta <= 0)
        return receiver;
      return this.$mul(padding, delta) + receiver;
    },
    indexOf$2: function(receiver, pattern, start) {
      var t1;
      if (start < 0 || start > receiver.length)
        throw H.wrapException(P.RangeError$range(start, 0, receiver.length, null, null));
      t1 = receiver.indexOf(pattern, start);
      return t1;
    },
    indexOf$1: function($receiver, pattern) {
      return this.indexOf$2($receiver, pattern, 0);
    },
    toString$0: function(receiver) {
      return receiver;
    },
    get$hashCode: function(receiver) {
      var t1, hash, i;
      for (t1 = receiver.length, hash = 0, i = 0; i < t1; ++i) {
        hash = 536870911 & hash + receiver.charCodeAt(i);
        hash = 536870911 & hash + ((524287 & hash) << 10);
        hash ^= hash >> 6;
      }
      hash = 536870911 & hash + ((67108863 & hash) << 3);
      hash ^= hash >> 11;
      return 536870911 & hash + ((16383 & hash) << 15);
    },
    get$length: function(receiver) {
      return receiver.length;
    },
    $isPattern: 1,
    $isString: 1
  };
  H._CastIterableBase.prototype = {
    get$iterator: function(_) {
      return new H.CastIterator(J.get$iterator$ax(this.get$_source()), this.$ti);
    },
    get$length: function(_) {
      return J.get$length$asx(this.get$_source());
    },
    get$isEmpty: function(_) {
      return J.get$isEmpty$asx(this.get$_source());
    },
    get$isNotEmpty: function(_) {
      return J.get$isNotEmpty$asx(this.get$_source());
    },
    skip$1: function(_, count) {
      return H.CastIterable_CastIterable(J.skip$1$ax(this.get$_source(), count), H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 1));
    },
    elementAt$1: function(_, index) {
      return H.subtypeOfRuntimeTypeCast(J.elementAt$1$ax(this.get$_source(), index), H.getTypeArgumentByIndex(this, 1));
    },
    contains$1: function(_, other) {
      return J.contains$1$ax(this.get$_source(), other);
    },
    toString$0: function(_) {
      return J.toString$0$(this.get$_source());
    },
    $asIterable: function($S, $T) {
      return [$T];
    }
  };
  H.CastIterator.prototype = {
    moveNext$0: function() {
      return this._source.moveNext$0();
    },
    get$current: function() {
      return H.subtypeOfRuntimeTypeCast(this._source.get$current(), H.getTypeArgumentByIndex(this, 1));
    },
    $isIterator: 1,
    $asIterator: function($S, $T) {
      return [$T];
    }
  };
  H.CastIterable.prototype = {
    get$_source: function() {
      return this._source;
    }
  };
  H._EfficientLengthCastIterable.prototype = {$isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function($S, $T) {
      return [$T];
    }
  };
  H._CastListBase.prototype = {
    $index: function(_, index) {
      return H.subtypeOfRuntimeTypeCast(J.$index$asx(this._source, index), H.getTypeArgumentByIndex(this, 1));
    },
    $indexSet: function(_, index, value) {
      J.$indexSet$ax(this._source, index, H.subtypeOfRuntimeTypeCast(H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 1)), H.getTypeArgumentByIndex(this, 0)));
    },
    set$length: function(_, $length) {
      J.set$length$asx(this._source, $length);
    },
    add$1: function(_, value) {
      J.add$1$ax(this._source, H.subtypeOfRuntimeTypeCast(H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 1)), H.getTypeArgumentByIndex(this, 0)));
    },
    $isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function($S, $T) {
      return [$T];
    },
    $asListMixin: function($S, $T) {
      return [$T];
    },
    $isList: 1,
    $asList: function($S, $T) {
      return [$T];
    }
  };
  H.CastList.prototype = {
    cast$1$0: function(_, $R) {
      return new H.CastList(this._source, [H.getTypeArgumentByIndex(this, 0), $R]);
    },
    get$_source: function() {
      return this._source;
    }
  };
  H.CastMap.prototype = {
    cast$2$0: function(_, RK, RV) {
      return new H.CastMap(this._source, [H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 1), RK, RV]);
    },
    containsKey$1: function(key) {
      return this._source.containsKey$1(key);
    },
    $index: function(_, key) {
      return H.subtypeOfRuntimeTypeCast(this._source.$index(0, key), H.getTypeArgumentByIndex(this, 3));
    },
    $indexSet: function(_, key, value) {
      var _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 2));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 3));
      _this._source.$indexSet(0, H.subtypeOfRuntimeTypeCast(key, H.getTypeArgumentByIndex(_this, 0)), H.subtypeOfRuntimeTypeCast(value, H.getTypeArgumentByIndex(_this, 1)));
    },
    forEach$1: function(_, f) {
      var _this = this;
      _this._source.forEach$1(0, new H.CastMap_forEach_closure(_this, H.functionTypeCheck(f, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(_this, 2), H.getTypeArgumentByIndex(_this, 3)]})));
    },
    get$keys: function() {
      return H.CastIterable_CastIterable(this._source.get$keys(), H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 2));
    },
    get$length: function(_) {
      var t1 = this._source;
      return t1.get$length(t1);
    },
    get$isEmpty: function(_) {
      var t1 = this._source;
      return t1.get$isEmpty(t1);
    },
    $asMapMixin: function(SK, SV, $K, $V) {
      return [$K, $V];
    },
    $asMap: function(SK, SV, $K, $V) {
      return [$K, $V];
    }
  };
  H.CastMap_forEach_closure.prototype = {
    call$2: function(key, value) {
      var t1 = this.$this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(t1, 0));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(t1, 1));
      this.f.call$2(H.subtypeOfRuntimeTypeCast(key, H.getTypeArgumentByIndex(t1, 2)), H.subtypeOfRuntimeTypeCast(value, H.getTypeArgumentByIndex(t1, 3)));
    },
    $signature: function() {
      var t1 = this.$this;
      return {func: 1, ret: P.Null, args: [H.getTypeArgumentByIndex(t1, 0), H.getTypeArgumentByIndex(t1, 1)]};
    }
  };
  H.CodeUnits.prototype = {
    get$length: function(_) {
      return this._string.length;
    },
    $index: function(_, i) {
      return C.JSString_methods.codeUnitAt$1(this._string, i);
    },
    $asEfficientLengthIterable: function() {
      return [P.int];
    },
    $asUnmodifiableListMixin: function() {
      return [P.int];
    },
    $asListMixin: function() {
      return [P.int];
    },
    $asIterable: function() {
      return [P.int];
    },
    $asList: function() {
      return [P.int];
    }
  };
  H.EfficientLengthIterable.prototype = {};
  H.ListIterable.prototype = {
    get$iterator: function(_) {
      var _this = this;
      return new H.ListIterator(_this, _this.get$length(_this), [H.getRuntimeTypeArgument(_this, "ListIterable", 0)]);
    },
    get$isEmpty: function(_) {
      return this.get$length(this) === 0;
    },
    contains$1: function(_, element) {
      var i, _this = this,
        $length = _this.get$length(_this);
      for (i = 0; i < $length; ++i) {
        if (J.$eq$(_this.elementAt$1(0, i), element))
          return true;
        if ($length !== _this.get$length(_this))
          throw H.wrapException(P.ConcurrentModificationError$(_this));
      }
      return false;
    },
    map$1$1: function(_, f, $T) {
      var t1 = H.getRuntimeTypeArgument(this, "ListIterable", 0);
      return new H.MappedListIterable(this, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), [t1, $T]);
    },
    skip$1: function(_, count) {
      return H.SubListIterable$(this, count, null, H.getRuntimeTypeArgument(this, "ListIterable", 0));
    },
    toList$1$growable: function(_, growable) {
      var result, i, _this = this,
        t1 = new Array(_this.get$length(_this));
      t1.fixed$length = Array;
      result = H.setRuntimeTypeInfo(t1, [H.getRuntimeTypeArgument(_this, "ListIterable", 0)]);
      for (i = 0; i < _this.get$length(_this); ++i)
        C.JSArray_methods.$indexSet(result, i, _this.elementAt$1(0, i));
      return result;
    }
  };
  H.SubListIterable.prototype = {
    get$_endIndex: function() {
      var $length = J.get$length$asx(this.__internal$_iterable);
      return $length;
    },
    get$_startIndex: function() {
      var $length = J.get$length$asx(this.__internal$_iterable),
        t1 = this._start;
      if (t1 > $length)
        return $length;
      return t1;
    },
    get$length: function(_) {
      var $length = J.get$length$asx(this.__internal$_iterable),
        t1 = this._start;
      if (t1 >= $length)
        return 0;
      return $length - t1;
    },
    elementAt$1: function(_, index) {
      var t1, _this = this,
        realIndex = _this.get$_startIndex() + index;
      if (index >= 0) {
        t1 = _this.get$_endIndex();
        if (typeof t1 !== "number")
          return H.iae(t1);
        t1 = realIndex >= t1;
      } else
        t1 = true;
      if (t1)
        throw H.wrapException(P.IndexError$(index, _this, "index", null, null));
      return J.elementAt$1$ax(_this.__internal$_iterable, realIndex);
    },
    skip$1: function(_, count) {
      var _this = this;
      P.RangeError_checkNotNegative(count, "count");
      return H.SubListIterable$(_this.__internal$_iterable, _this._start + count, _this._endOrLength, H.getTypeArgumentByIndex(_this, 0));
    },
    toList$1$growable: function(_, growable) {
      var t3, result, i, _this = this,
        start = _this._start,
        t1 = _this.__internal$_iterable,
        t2 = J.getInterceptor$asx(t1),
        end = t2.get$length(t1),
        $length = end - start;
      if ($length < 0)
        $length = 0;
      t3 = new Array($length);
      t3.fixed$length = Array;
      result = H.setRuntimeTypeInfo(t3, _this.$ti);
      for (i = 0; i < $length; ++i) {
        C.JSArray_methods.$indexSet(result, i, t2.elementAt$1(t1, start + i));
        if (t2.get$length(t1) < end)
          throw H.wrapException(P.ConcurrentModificationError$(_this));
      }
      return result;
    }
  };
  H.ListIterator.prototype = {
    get$current: function() {
      return this.__internal$_current;
    },
    moveNext$0: function() {
      var t3, _this = this,
        t1 = _this.__internal$_iterable,
        t2 = J.getInterceptor$asx(t1),
        $length = t2.get$length(t1);
      if (_this.__internal$_length !== $length)
        throw H.wrapException(P.ConcurrentModificationError$(t1));
      t3 = _this.__internal$_index;
      if (t3 >= $length) {
        _this.set$__internal$_current(null);
        return false;
      }
      _this.set$__internal$_current(t2.elementAt$1(t1, t3));
      ++_this.__internal$_index;
      return true;
    },
    set$__internal$_current: function(_current) {
      this.__internal$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  H.MappedIterable.prototype = {
    get$iterator: function(_) {
      return new H.MappedIterator(J.get$iterator$ax(this.__internal$_iterable), this._f, this.$ti);
    },
    get$length: function(_) {
      return J.get$length$asx(this.__internal$_iterable);
    },
    get$isEmpty: function(_) {
      return J.get$isEmpty$asx(this.__internal$_iterable);
    },
    elementAt$1: function(_, index) {
      return this._f.call$1(J.elementAt$1$ax(this.__internal$_iterable, index));
    },
    $asIterable: function($S, $T) {
      return [$T];
    }
  };
  H.EfficientLengthMappedIterable.prototype = {$isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function($S, $T) {
      return [$T];
    }
  };
  H.MappedIterator.prototype = {
    moveNext$0: function() {
      var _this = this,
        t1 = _this._iterator;
      if (t1.moveNext$0()) {
        _this.set$__internal$_current(_this._f.call$1(t1.get$current()));
        return true;
      }
      _this.set$__internal$_current(null);
      return false;
    },
    get$current: function() {
      return this.__internal$_current;
    },
    set$__internal$_current: function(_current) {
      this.__internal$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 1));
    },
    $asIterator: function($S, $T) {
      return [$T];
    }
  };
  H.MappedListIterable.prototype = {
    get$length: function(_) {
      return J.get$length$asx(this._source);
    },
    elementAt$1: function(_, index) {
      return this._f.call$1(J.elementAt$1$ax(this._source, index));
    },
    $asEfficientLengthIterable: function($S, $T) {
      return [$T];
    },
    $asListIterable: function($S, $T) {
      return [$T];
    },
    $asIterable: function($S, $T) {
      return [$T];
    }
  };
  H.WhereIterable.prototype = {
    get$iterator: function(_) {
      return new H.WhereIterator(J.get$iterator$ax(this.__internal$_iterable), this._f, this.$ti);
    },
    map$1$1: function(_, f, $T) {
      var t1 = H.getTypeArgumentByIndex(this, 0);
      return new H.MappedIterable(this, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), [t1, $T]);
    }
  };
  H.WhereIterator.prototype = {
    moveNext$0: function() {
      var t1, t2;
      for (t1 = this._iterator, t2 = this._f; t1.moveNext$0();)
        if (H.boolConversionCheck(t2.call$1(t1.get$current())))
          return true;
      return false;
    },
    get$current: function() {
      return this._iterator.get$current();
    }
  };
  H.SkipIterable.prototype = {
    skip$1: function(_, count) {
      P.RangeError_checkNotNegative(count, "count");
      return new H.SkipIterable(this.__internal$_iterable, this._skipCount + count, this.$ti);
    },
    get$iterator: function(_) {
      return new H.SkipIterator(J.get$iterator$ax(this.__internal$_iterable), this._skipCount, this.$ti);
    }
  };
  H.EfficientLengthSkipIterable.prototype = {
    get$length: function(_) {
      var $length = J.get$length$asx(this.__internal$_iterable) - this._skipCount;
      if ($length >= 0)
        return $length;
      return 0;
    },
    skip$1: function(_, count) {
      P.RangeError_checkNotNegative(count, "count");
      return new H.EfficientLengthSkipIterable(this.__internal$_iterable, this._skipCount + count, this.$ti);
    },
    $isEfficientLengthIterable: 1
  };
  H.SkipIterator.prototype = {
    moveNext$0: function() {
      var t1, i;
      for (t1 = this._iterator, i = 0; i < this._skipCount; ++i)
        t1.moveNext$0();
      this._skipCount = 0;
      return t1.moveNext$0();
    },
    get$current: function() {
      return this._iterator.get$current();
    }
  };
  H.EmptyIterable.prototype = {
    get$iterator: function(_) {
      return C.C_EmptyIterator;
    },
    get$isEmpty: function(_) {
      return true;
    },
    get$length: function(_) {
      return 0;
    },
    elementAt$1: function(_, index) {
      throw H.wrapException(P.RangeError$range(index, 0, 0, "index", null));
    },
    contains$1: function(_, element) {
      return false;
    },
    map$1$1: function(_, f, $T) {
      H.functionTypeCheck(f, {func: 1, ret: $T, args: [H.getTypeArgumentByIndex(this, 0)]});
      return new H.EmptyIterable([$T]);
    },
    skip$1: function(_, count) {
      P.RangeError_checkNotNegative(count, "count");
      return this;
    }
  };
  H.EmptyIterator.prototype = {
    moveNext$0: function() {
      return false;
    },
    get$current: function() {
      return;
    },
    $isIterator: 1
  };
  H.FixedLengthListMixin.prototype = {
    set$length: function(receiver, newLength) {
      throw H.wrapException(P.UnsupportedError$("Cannot change the length of a fixed-length list"));
    },
    add$1: function(receiver, value) {
      H.assertSubtypeOfRuntimeType(value, H.getRuntimeTypeArgumentIntercepted(this, receiver, "FixedLengthListMixin", 0));
      throw H.wrapException(P.UnsupportedError$("Cannot add to a fixed-length list"));
    }
  };
  H.UnmodifiableListMixin.prototype = {
    $indexSet: function(_, index, value) {
      H.assertSubtypeOfRuntimeType(value, H.getRuntimeTypeArgument(this, "UnmodifiableListMixin", 0));
      throw H.wrapException(P.UnsupportedError$("Cannot modify an unmodifiable list"));
    },
    set$length: function(_, newLength) {
      throw H.wrapException(P.UnsupportedError$("Cannot change the length of an unmodifiable list"));
    },
    add$1: function(_, value) {
      H.assertSubtypeOfRuntimeType(value, H.getRuntimeTypeArgument(this, "UnmodifiableListMixin", 0));
      throw H.wrapException(P.UnsupportedError$("Cannot add to an unmodifiable list"));
    }
  };
  H.UnmodifiableListBase.prototype = {};
  H.Symbol.prototype = {
    get$hashCode: function(_) {
      var hash = this._hashCode;
      if (hash != null)
        return hash;
      hash = 536870911 & 664597 * J.get$hashCode$(this.__internal$_name);
      this._hashCode = hash;
      return hash;
    },
    toString$0: function(_) {
      return 'Symbol("' + H.S(this.__internal$_name) + '")';
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof H.Symbol && this.__internal$_name == other.__internal$_name;
    },
    $isSymbol0: 1
  };
  H.__CastListBase__CastIterableBase_ListMixin.prototype = {};
  H.ConstantMapView.prototype = {};
  H.ConstantMap.prototype = {
    cast$2$0: function(_, RK, RV) {
      return P.Map_castFrom(this, H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 1), RK, RV);
    },
    get$isEmpty: function(_) {
      return this.get$length(this) === 0;
    },
    toString$0: function(_) {
      return P.MapBase_mapToString(this);
    },
    $indexSet: function(_, key, val) {
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(this, 0));
      H.assertSubtypeOfRuntimeType(val, H.getTypeArgumentByIndex(this, 1));
      return H.ConstantMap__throwUnmodifiable();
    },
    $isMap: 1
  };
  H.ConstantStringMap.prototype = {
    get$length: function(_) {
      return this.__js_helper$_length;
    },
    containsKey$1: function(key) {
      if (typeof key !== "string")
        return false;
      if ("__proto__" === key)
        return false;
      return this._jsObject.hasOwnProperty(key);
    },
    $index: function(_, key) {
      if (!this.containsKey$1(key))
        return;
      return this._fetch$1(key);
    },
    _fetch$1: function(key) {
      return this._jsObject[H.stringTypeCheck(key)];
    },
    forEach$1: function(_, f) {
      var keys, t2, i, key, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 1);
      H.functionTypeCheck(f, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(_this, 0), t1]});
      keys = _this.__js_helper$_keys;
      for (t2 = keys.length, i = 0; i < t2; ++i) {
        key = keys[i];
        f.call$2(key, H.assertSubtypeOfRuntimeType(_this._fetch$1(key), t1));
      }
    },
    get$keys: function() {
      return new H._ConstantMapKeyIterable(this, [H.getTypeArgumentByIndex(this, 0)]);
    }
  };
  H._ConstantMapKeyIterable.prototype = {
    get$iterator: function(_) {
      var t1 = this.__js_helper$_map.__js_helper$_keys;
      return new J.ArrayIterator(t1, t1.length, [H.getTypeArgumentByIndex(t1, 0)]);
    },
    get$length: function(_) {
      return this.__js_helper$_map.__js_helper$_keys.length;
    }
  };
  H.GeneralConstantMap.prototype = {
    _getMap$0: function() {
      var _this = this,
        backingMap = _this.$map;
      if (backingMap == null) {
        backingMap = new H.JsLinkedHashMap(_this.$ti);
        H.fillLiteralMap(_this._jsData, backingMap);
        _this.$map = backingMap;
      }
      return backingMap;
    },
    containsKey$1: function(key) {
      return this._getMap$0().containsKey$1(key);
    },
    $index: function(_, key) {
      return this._getMap$0().$index(0, key);
    },
    forEach$1: function(_, f) {
      H.functionTypeCheck(f, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 1)]});
      this._getMap$0().forEach$1(0, f);
    },
    get$keys: function() {
      var t1 = this._getMap$0();
      return new H.LinkedHashMapKeyIterable(t1, [H.getTypeArgumentByIndex(t1, 0)]);
    },
    get$length: function(_) {
      return this._getMap$0().__js_helper$_length;
    }
  };
  H.JSInvocationMirror.prototype = {
    get$memberName: function() {
      var t1 = this._memberName;
      return t1;
    },
    get$positionalArguments: function() {
      var t1, argumentCount, list, index, _this = this;
      if (_this._kind === 1)
        return C.List_empty0;
      t1 = _this._arguments;
      argumentCount = t1.length - _this._namedArgumentNames.length - _this._typeArgumentCount;
      if (argumentCount === 0)
        return C.List_empty0;
      list = [];
      for (index = 0; index < argumentCount; ++index) {
        if (index >= t1.length)
          return H.ioore(t1, index);
        list.push(t1[index]);
      }
      list.fixed$length = Array;
      list.immutable$list = Array;
      return list;
    },
    get$namedArguments: function() {
      var t1, namedArgumentCount, t2, namedArgumentsStartIndex, t3, map, i, t4, t5, _this = this;
      if (_this._kind !== 0)
        return C.Map_empty;
      t1 = _this._namedArgumentNames;
      namedArgumentCount = t1.length;
      t2 = _this._arguments;
      namedArgumentsStartIndex = t2.length - namedArgumentCount - _this._typeArgumentCount;
      if (namedArgumentCount === 0)
        return C.Map_empty;
      t3 = P.Symbol0;
      map = new H.JsLinkedHashMap([t3, null]);
      for (i = 0; i < namedArgumentCount; ++i) {
        if (i >= t1.length)
          return H.ioore(t1, i);
        t4 = t1[i];
        t5 = namedArgumentsStartIndex + i;
        if (t5 < 0 || t5 >= t2.length)
          return H.ioore(t2, t5);
        map.$indexSet(0, new H.Symbol(t4), t2[t5]);
      }
      return new H.ConstantMapView(map, [t3, null]);
    },
    $isInvocation: 1
  };
  H.Primitives_functionNoSuchMethod_closure.prototype = {
    call$2: function($name, argument) {
      var t1;
      H.stringTypeCheck($name);
      t1 = this._box_0;
      t1.names = t1.names + "$" + H.S($name);
      C.JSArray_methods.add$1(this.namedArgumentList, $name);
      C.JSArray_methods.add$1(this.$arguments, argument);
      ++t1.argumentCount;
    },
    $signature: 38
  };
  H.TypeErrorDecoder.prototype = {
    matchTypeError$1: function(message) {
      var result, t1, _this = this,
        match = new RegExp(_this._pattern).exec(message);
      if (match == null)
        return;
      result = Object.create(null);
      t1 = _this._arguments;
      if (t1 !== -1)
        result.arguments = match[t1 + 1];
      t1 = _this._argumentsExpr;
      if (t1 !== -1)
        result.argumentsExpr = match[t1 + 1];
      t1 = _this._expr;
      if (t1 !== -1)
        result.expr = match[t1 + 1];
      t1 = _this._method;
      if (t1 !== -1)
        result.method = match[t1 + 1];
      t1 = _this._receiver;
      if (t1 !== -1)
        result.receiver = match[t1 + 1];
      return result;
    }
  };
  H.NullError.prototype = {
    toString$0: function(_) {
      var t1 = this._method;
      if (t1 == null)
        return "NoSuchMethodError: " + H.S(this._message);
      return "NoSuchMethodError: method not found: '" + t1 + "' on null";
    }
  };
  H.JsNoSuchMethodError.prototype = {
    toString$0: function(_) {
      var t2, _this = this,
        _s38_ = "NoSuchMethodError: method not found: '",
        t1 = _this._method;
      if (t1 == null)
        return "NoSuchMethodError: " + H.S(_this._message);
      t2 = _this._receiver;
      if (t2 == null)
        return _s38_ + t1 + "' (" + H.S(_this._message) + ")";
      return _s38_ + t1 + "' on '" + t2 + "' (" + H.S(_this._message) + ")";
    }
  };
  H.UnknownJsTypeError.prototype = {
    toString$0: function(_) {
      var t1 = this._message;
      return t1.length === 0 ? "Error" : "Error: " + t1;
    }
  };
  H.ExceptionAndStackTrace.prototype = {};
  H.unwrapException_saveStackTrace.prototype = {
    call$1: function(error) {
      if (!!J.getInterceptor$(error).$isError)
        if (error.$thrownJsError == null)
          error.$thrownJsError = this.ex;
      return error;
    },
    $signature: 4
  };
  H._StackTrace.prototype = {
    toString$0: function(_) {
      var trace,
        t1 = this._trace;
      if (t1 != null)
        return t1;
      t1 = this._exception;
      trace = t1 !== null && typeof t1 === "object" ? t1.stack : null;
      return this._trace = trace == null ? "" : trace;
    },
    $isStackTrace: 1
  };
  H.Closure.prototype = {
    toString$0: function(_) {
      var $constructor = this.constructor,
        $name = $constructor == null ? null : $constructor.name;
      return "Closure '" + H.unminifyOrTag($name == null ? "unknown" : $name) + "'";
    },
    $isFunction: 1,
    get$$call: function() {
      return this;
    },
    "call*": "call$1",
    $requiredArgCount: 1,
    $defaultValues: null
  };
  H.TearOffClosure.prototype = {};
  H.StaticClosure.prototype = {
    toString$0: function(_) {
      var $name = this.$static_name;
      if ($name == null)
        return "Closure of unknown static method";
      return "Closure '" + H.unminifyOrTag($name) + "'";
    }
  };
  H.BoundClosure.prototype = {
    $eq: function(_, other) {
      var _this = this;
      if (other == null)
        return false;
      if (_this === other)
        return true;
      if (!(other instanceof H.BoundClosure))
        return false;
      return _this._self === other._self && _this._target === other._target && _this._receiver === other._receiver;
    },
    get$hashCode: function(_) {
      var receiverHashCode,
        t1 = this._receiver;
      if (t1 == null)
        receiverHashCode = H.Primitives_objectHashCode(this._self);
      else
        receiverHashCode = typeof t1 !== "object" ? J.get$hashCode$(t1) : H.Primitives_objectHashCode(t1);
      return (receiverHashCode ^ H.Primitives_objectHashCode(this._target)) >>> 0;
    },
    toString$0: function(_) {
      var receiver = this._receiver;
      if (receiver == null)
        receiver = this._self;
      return "Closure '" + H.S(this._name) + "' of " + ("Instance of '" + H.S(H.Primitives_objectTypeName(receiver)) + "'");
    }
  };
  H.TypeErrorImplementation.prototype = {
    toString$0: function(_) {
      return this.message;
    }
  };
  H.CastErrorImplementation.prototype = {
    toString$0: function(_) {
      return this.message;
    }
  };
  H.RuntimeError.prototype = {
    toString$0: function(_) {
      return "RuntimeError: " + H.S(this.message);
    }
  };
  H._AssertionError.prototype = {
    toString$0: function(_) {
      return "Assertion failed: " + P.Error_safeToString(this.message);
    }
  };
  H.TypeImpl.prototype = {
    get$_typeName: function() {
      var t1 = this.__typeName;
      return t1 == null ? this.__typeName = H.runtimeTypeToString(this._rti) : t1;
    },
    toString$0: function(_) {
      return this.get$_typeName();
    },
    get$hashCode: function(_) {
      var t1 = this._hashCode;
      return t1 == null ? this._hashCode = C.JSString_methods.get$hashCode(this.get$_typeName()) : t1;
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof H.TypeImpl && this.get$_typeName() === other.get$_typeName();
    },
    $isType: 1
  };
  H.JsLinkedHashMap.prototype = {
    get$length: function(_) {
      return this.__js_helper$_length;
    },
    get$isEmpty: function(_) {
      return this.__js_helper$_length === 0;
    },
    get$keys: function() {
      return new H.LinkedHashMapKeyIterable(this, [H.getTypeArgumentByIndex(this, 0)]);
    },
    get$values: function() {
      var _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      return H.MappedIterable_MappedIterable(new H.LinkedHashMapKeyIterable(_this, [t1]), new H.JsLinkedHashMap_values_closure(_this), t1, H.getTypeArgumentByIndex(_this, 1));
    },
    containsKey$1: function(key) {
      var strings, nums, _this = this;
      if (typeof key === "string") {
        strings = _this.__js_helper$_strings;
        if (strings == null)
          return false;
        return _this._containsTableEntry$2(strings, key);
      } else if (typeof key === "number" && (key & 0x3ffffff) === key) {
        nums = _this.__js_helper$_nums;
        if (nums == null)
          return false;
        return _this._containsTableEntry$2(nums, key);
      } else
        return _this.internalContainsKey$1(key);
    },
    internalContainsKey$1: function(key) {
      var rest = this.__js_helper$_rest;
      if (rest == null)
        return false;
      return this.internalFindBucketIndex$2(this._getTableBucket$2(rest, J.get$hashCode$(key) & 0x3ffffff), key) >= 0;
    },
    $index: function(_, key) {
      var strings, cell, t1, nums, _this = this;
      if (typeof key === "string") {
        strings = _this.__js_helper$_strings;
        if (strings == null)
          return;
        cell = _this._getTableCell$2(strings, key);
        t1 = cell == null ? null : cell.hashMapCellValue;
        return t1;
      } else if (typeof key === "number" && (key & 0x3ffffff) === key) {
        nums = _this.__js_helper$_nums;
        if (nums == null)
          return;
        cell = _this._getTableCell$2(nums, key);
        t1 = cell == null ? null : cell.hashMapCellValue;
        return t1;
      } else
        return _this.internalGet$1(key);
    },
    internalGet$1: function(key) {
      var bucket, index,
        rest = this.__js_helper$_rest;
      if (rest == null)
        return;
      bucket = this._getTableBucket$2(rest, J.get$hashCode$(key) & 0x3ffffff);
      index = this.internalFindBucketIndex$2(bucket, key);
      if (index < 0)
        return;
      return bucket[index].hashMapCellValue;
    },
    $indexSet: function(_, key, value) {
      var strings, nums, rest, hash, bucket, index, _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 1));
      if (typeof key === "string") {
        strings = _this.__js_helper$_strings;
        _this.__js_helper$_addHashTableEntry$3(strings == null ? _this.__js_helper$_strings = _this._newHashTable$0() : strings, key, value);
      } else if (typeof key === "number" && (key & 0x3ffffff) === key) {
        nums = _this.__js_helper$_nums;
        _this.__js_helper$_addHashTableEntry$3(nums == null ? _this.__js_helper$_nums = _this._newHashTable$0() : nums, key, value);
      } else {
        rest = _this.__js_helper$_rest;
        if (rest == null)
          rest = _this.__js_helper$_rest = _this._newHashTable$0();
        hash = J.get$hashCode$(key) & 0x3ffffff;
        bucket = _this._getTableBucket$2(rest, hash);
        if (bucket == null)
          _this._setTableEntry$3(rest, hash, [_this._newLinkedCell$2(key, value)]);
        else {
          index = _this.internalFindBucketIndex$2(bucket, key);
          if (index >= 0)
            bucket[index].hashMapCellValue = value;
          else
            bucket.push(_this._newLinkedCell$2(key, value));
        }
      }
    },
    putIfAbsent$2: function(key, ifAbsent) {
      var value, _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0));
      H.functionTypeCheck(ifAbsent, {func: 1, ret: H.getTypeArgumentByIndex(_this, 1)});
      if (_this.containsKey$1(key))
        return _this.$index(0, key);
      value = ifAbsent.call$0();
      _this.$indexSet(0, key, value);
      return value;
    },
    forEach$1: function(_, action) {
      var cell, modifications, _this = this;
      H.functionTypeCheck(action, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(_this, 0), H.getTypeArgumentByIndex(_this, 1)]});
      cell = _this._first;
      modifications = _this._modifications;
      for (; cell != null;) {
        action.call$2(cell.hashMapCellKey, cell.hashMapCellValue);
        if (modifications !== _this._modifications)
          throw H.wrapException(P.ConcurrentModificationError$(_this));
        cell = cell._next;
      }
    },
    __js_helper$_addHashTableEntry$3: function(table, key, value) {
      var cell, _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 1));
      cell = _this._getTableCell$2(table, key);
      if (cell == null)
        _this._setTableEntry$3(table, key, _this._newLinkedCell$2(key, value));
      else
        cell.hashMapCellValue = value;
    },
    _newLinkedCell$2: function(key, value) {
      var _this = this,
        cell = new H.LinkedHashMapCell(H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0)), H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 1)));
      if (_this._first == null)
        _this._first = _this._last = cell;
      else
        _this._last = _this._last._next = cell;
      ++_this.__js_helper$_length;
      _this._modifications = _this._modifications + 1 & 67108863;
      return cell;
    },
    internalFindBucketIndex$2: function(bucket, key) {
      var $length, i;
      if (bucket == null)
        return -1;
      $length = bucket.length;
      for (i = 0; i < $length; ++i)
        if (J.$eq$(bucket[i].hashMapCellKey, key))
          return i;
      return -1;
    },
    toString$0: function(_) {
      return P.MapBase_mapToString(this);
    },
    _getTableCell$2: function(table, key) {
      return table[key];
    },
    _getTableBucket$2: function(table, key) {
      return table[key];
    },
    _setTableEntry$3: function(table, key, value) {
      table[key] = value;
    },
    _deleteTableEntry$2: function(table, key) {
      delete table[key];
    },
    _containsTableEntry$2: function(table, key) {
      return this._getTableCell$2(table, key) != null;
    },
    _newHashTable$0: function() {
      var _s20_ = "<non-identifier-key>",
        table = Object.create(null);
      this._setTableEntry$3(table, _s20_, table);
      this._deleteTableEntry$2(table, _s20_);
      return table;
    },
    $isLinkedHashMap: 1
  };
  H.JsLinkedHashMap_values_closure.prototype = {
    call$1: function(each) {
      var t1 = this.$this;
      return t1.$index(0, H.assertSubtypeOfRuntimeType(each, H.getTypeArgumentByIndex(t1, 0)));
    },
    $signature: function() {
      var t1 = this.$this;
      return {func: 1, ret: H.getTypeArgumentByIndex(t1, 1), args: [H.getTypeArgumentByIndex(t1, 0)]};
    }
  };
  H.LinkedHashMapCell.prototype = {};
  H.LinkedHashMapKeyIterable.prototype = {
    get$length: function(_) {
      return this.__js_helper$_map.__js_helper$_length;
    },
    get$isEmpty: function(_) {
      return this.__js_helper$_map.__js_helper$_length === 0;
    },
    get$iterator: function(_) {
      var t1 = this.__js_helper$_map,
        t2 = new H.LinkedHashMapKeyIterator(t1, t1._modifications, this.$ti);
      t2._cell = t1._first;
      return t2;
    },
    contains$1: function(_, element) {
      return this.__js_helper$_map.containsKey$1(element);
    }
  };
  H.LinkedHashMapKeyIterator.prototype = {
    get$current: function() {
      return this.__js_helper$_current;
    },
    moveNext$0: function() {
      var _this = this,
        t1 = _this.__js_helper$_map;
      if (_this._modifications !== t1._modifications)
        throw H.wrapException(P.ConcurrentModificationError$(t1));
      else {
        t1 = _this._cell;
        if (t1 == null) {
          _this.set$__js_helper$_current(null);
          return false;
        } else {
          _this.set$__js_helper$_current(t1.hashMapCellKey);
          _this._cell = _this._cell._next;
          return true;
        }
      }
    },
    set$__js_helper$_current: function(_current) {
      this.__js_helper$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  H.initHooks_closure.prototype = {
    call$1: function(o) {
      return this.getTag(o);
    },
    $signature: 4
  };
  H.initHooks_closure0.prototype = {
    call$2: function(o, tag) {
      return this.getUnknownTag(o, tag);
    },
    $signature: 42
  };
  H.initHooks_closure1.prototype = {
    call$1: function(tag) {
      return this.prototypeForTag(H.stringTypeCheck(tag));
    },
    $signature: 41
  };
  H.JSSyntaxRegExp.prototype = {
    toString$0: function(_) {
      return "RegExp/" + this.pattern + "/" + this._nativeRegExp.flags;
    },
    firstMatch$1: function(string) {
      var m;
      if (typeof string !== "string")
        H.throwExpression(H.argumentErrorValue(string));
      m = this._nativeRegExp.exec(string);
      if (m == null)
        return;
      return new H._MatchImplementation(m);
    },
    $isPattern: 1
  };
  H._MatchImplementation.prototype = {};
  H.NativeTypedData.prototype = {
    _invalidPosition$3: function(receiver, position, $length, $name) {
      var t1 = P.RangeError$range(position, 0, $length, $name, null);
      throw H.wrapException(t1);
    },
    _checkPosition$3: function(receiver, position, $length, $name) {
      if (position >>> 0 !== position || position > $length)
        this._invalidPosition$3(receiver, position, $length, $name);
    }
  };
  H.NativeByteData.prototype = {$isByteData: 1};
  H.NativeTypedArray.prototype = {
    get$length: function(receiver) {
      return receiver.length;
    },
    _setRangeFast$4: function(receiver, start, end, source, skipCount) {
      var count, sourceLength,
        targetLength = receiver.length;
      this._checkPosition$3(receiver, start, targetLength, "start");
      this._checkPosition$3(receiver, end, targetLength, "end");
      if (start > end)
        throw H.wrapException(P.RangeError$range(start, 0, end, null, null));
      count = end - start;
      if (skipCount < 0)
        throw H.wrapException(P.ArgumentError$(skipCount));
      sourceLength = source.length;
      if (sourceLength - skipCount < count)
        throw H.wrapException(P.StateError$("Not enough elements"));
      if (skipCount !== 0 || sourceLength !== count)
        source = source.subarray(skipCount, skipCount + count);
      receiver.set(source, start);
    },
    $isJavaScriptIndexingBehavior: 1,
    $asJavaScriptIndexingBehavior: function() {
    }
  };
  H.NativeTypedArrayOfDouble.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    $indexSet: function(receiver, index, value) {
      H.doubleTypeCheck(value);
      H._checkValidIndex(index, receiver, receiver.length);
      receiver[index] = value;
    },
    $isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function() {
      return [P.double];
    },
    $asFixedLengthListMixin: function() {
      return [P.double];
    },
    $asListMixin: function() {
      return [P.double];
    },
    $isIterable: 1,
    $asIterable: function() {
      return [P.double];
    },
    $isList: 1,
    $asList: function() {
      return [P.double];
    }
  };
  H.NativeTypedArrayOfInt.prototype = {
    $indexSet: function(receiver, index, value) {
      H.intTypeCheck(value);
      H._checkValidIndex(index, receiver, receiver.length);
      receiver[index] = value;
    },
    setRange$4: function(receiver, start, end, iterable, skipCount) {
      H.assertSubtype(iterable, "$isIterable", [P.int], "$asIterable");
      if (!!J.getInterceptor$(iterable).$isNativeTypedArrayOfInt) {
        this._setRangeFast$4(receiver, start, end, iterable, skipCount);
        return;
      }
      this.super$ListMixin$setRange(receiver, start, end, iterable, skipCount);
    },
    setRange$3: function($receiver, start, end, iterable) {
      return this.setRange$4($receiver, start, end, iterable, 0);
    },
    $isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function() {
      return [P.int];
    },
    $asFixedLengthListMixin: function() {
      return [P.int];
    },
    $asListMixin: function() {
      return [P.int];
    },
    $isIterable: 1,
    $asIterable: function() {
      return [P.int];
    },
    $isList: 1,
    $asList: function() {
      return [P.int];
    }
  };
  H.NativeFloat32List.prototype = {
    sublist$2: function(receiver, start, end) {
      return new Float32Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    },
    $isFloat32List: 1
  };
  H.NativeFloat64List.prototype = {
    sublist$2: function(receiver, start, end) {
      return new Float64Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeInt16List.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Int16Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeInt32List.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Int32Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeInt8List.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Int8Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeUint16List.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Uint16Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeUint32List.prototype = {
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Uint32Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    },
    $isUint32List: 1
  };
  H.NativeUint8ClampedList.prototype = {
    get$length: function(receiver) {
      return receiver.length;
    },
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Uint8ClampedArray(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    }
  };
  H.NativeUint8List.prototype = {
    get$length: function(receiver) {
      return receiver.length;
    },
    $index: function(receiver, index) {
      H._checkValidIndex(index, receiver, receiver.length);
      return receiver[index];
    },
    sublist$2: function(receiver, start, end) {
      return new Uint8Array(receiver.subarray(start, H._checkValidRange(start, end, receiver.length)));
    },
    $isNativeUint8List: 1,
    $isUint8List: 1
  };
  H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin.prototype = {};
  H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin.prototype = {};
  H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin.prototype = {};
  H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin.prototype = {};
  P._AsyncRun__initializeScheduleImmediate_internalCallback.prototype = {
    call$1: function(_) {
      var t1 = this._box_0,
        f = t1.storedCallback;
      t1.storedCallback = null;
      f.call$0();
    },
    $signature: 13
  };
  P._AsyncRun__initializeScheduleImmediate_closure.prototype = {
    call$1: function(callback) {
      var t1, t2;
      this._box_0.storedCallback = H.functionTypeCheck(callback, {func: 1, ret: -1});
      t1 = this.div;
      t2 = this.span;
      t1.firstChild ? t1.removeChild(t2) : t1.appendChild(t2);
    },
    $signature: 106
  };
  P._AsyncRun__scheduleImmediateJsOverride_internalCallback.prototype = {
    call$0: function() {
      this.callback.call$0();
    },
    "call*": "call$0",
    $requiredArgCount: 0,
    $signature: 2
  };
  P._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback.prototype = {
    call$0: function() {
      this.callback.call$0();
    },
    "call*": "call$0",
    $requiredArgCount: 0,
    $signature: 2
  };
  P._TimerImpl.prototype = {
    _TimerImpl$2: function(milliseconds, callback) {
      if (self.setTimeout != null)
        self.setTimeout(H.convertDartClosureToJS(new P._TimerImpl_internalCallback(this, callback), 0), milliseconds);
      else
        throw H.wrapException(P.UnsupportedError$("`setTimeout()` not found."));
    }
  };
  P._TimerImpl_internalCallback.prototype = {
    call$0: function() {
      this.callback.call$0();
    },
    "call*": "call$0",
    $requiredArgCount: 0,
    $signature: 1
  };
  P._AsyncAwaitCompleter.prototype = {
    complete$1: function(value) {
      var t2, t3, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.futureOrCheck(value, {futureOr: 1, type: t1});
      t2 = !_this.isSync || H.checkSubtype(value, "$isFuture", _this.$ti, "$asFuture");
      t3 = _this._future;
      if (t2)
        t3._asyncComplete$1(value);
      else
        t3._completeWithValue$1(H.assertSubtypeOfRuntimeType(value, t1));
    },
    completeError$2: function(e, st) {
      var t1 = this._future;
      if (this.isSync)
        t1._completeError$2(e, st);
      else
        t1._asyncCompleteError$2(e, st);
    },
    $isCompleter: 1
  };
  P._awaitOnObject_closure.prototype = {
    call$1: function(result) {
      return this.bodyFunction.call$2(0, result);
    },
    $signature: 73
  };
  P._awaitOnObject_closure0.prototype = {
    call$2: function(error, stackTrace) {
      this.bodyFunction.call$2(1, new H.ExceptionAndStackTrace(error, H.interceptedTypeCheck(stackTrace, "$isStackTrace")));
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 74
  };
  P._wrapJsFunctionForAsync_closure.prototype = {
    call$2: function(errorCode, result) {
      this.$protected(H.intTypeCheck(errorCode), result);
    },
    $signature: 81
  };
  P._IterationMarker.prototype = {
    toString$0: function(_) {
      return "IterationMarker(" + this.state + ", " + H.S(this.value) + ")";
    }
  };
  P._SyncStarIterator.prototype = {
    get$current: function() {
      var t1 = this._nestedIterator;
      if (t1 == null)
        return this._async$_current;
      return H.assertSubtypeOfRuntimeType(t1.get$current(), H.getTypeArgumentByIndex(this, 0));
    },
    moveNext$0: function() {
      var t1, value, state, inner, _this = this;
      for (; true;) {
        t1 = _this._nestedIterator;
        if (t1 != null)
          if (t1.moveNext$0())
            return true;
          else
            _this._nestedIterator = null;
        value = function(body, SUCCESS, ERROR) {
          var errorValue,
            errorCode = SUCCESS;
          while (true)
            try {
              return body(errorCode, errorValue);
            } catch (error) {
              errorValue = error;
              errorCode = ERROR;
            }
        }(_this._body, 0, 1);
        if (value instanceof P._IterationMarker) {
          state = value.state;
          if (state === 2) {
            t1 = _this._suspendedBodies;
            if (t1 == null || t1.length === 0) {
              _this.set$_async$_current(null);
              return false;
            }
            if (0 >= t1.length)
              return H.ioore(t1, -1);
            _this._body = t1.pop();
            continue;
          } else {
            t1 = value.value;
            if (state === 3)
              throw t1;
            else {
              inner = J.get$iterator$ax(t1);
              if (!!inner.$is_SyncStarIterator) {
                t1 = _this._suspendedBodies;
                if (t1 == null)
                  t1 = _this._suspendedBodies = [];
                C.JSArray_methods.add$1(t1, _this._body);
                _this._body = inner._body;
                continue;
              } else {
                _this._nestedIterator = inner;
                continue;
              }
            }
          }
        } else {
          _this.set$_async$_current(value);
          return true;
        }
      }
      return false;
    },
    set$_async$_current: function(_current) {
      this._async$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  P._SyncStarIterable.prototype = {
    get$iterator: function(_) {
      return new P._SyncStarIterator(this._outerHelper(), this.$ti);
    }
  };
  P.Future.prototype = {};
  P._Completer.prototype = {
    completeError$2: function(error, stackTrace) {
      var t1;
      if (error == null)
        error = new P.NullThrownError();
      t1 = this.future;
      if (t1._state !== 0)
        throw H.wrapException(P.StateError$("Future already completed"));
      t1._asyncCompleteError$2(error, stackTrace);
    },
    completeError$1: function(error) {
      return this.completeError$2(error, null);
    },
    $isCompleter: 1
  };
  P._AsyncCompleter.prototype = {
    complete$1: function(value) {
      var t1;
      H.futureOrCheck(value, {futureOr: 1, type: H.getTypeArgumentByIndex(this, 0)});
      t1 = this.future;
      if (t1._state !== 0)
        throw H.wrapException(P.StateError$("Future already completed"));
      t1._asyncComplete$1(value);
    },
    complete$0: function() {
      return this.complete$1(null);
    }
  };
  P._FutureListener.prototype = {
    matchesErrorTest$1: function(asyncError) {
      if ((this.state & 15) !== 6)
        return true;
      return this.result._zone.runUnary$2$2(H.functionTypeCheck(this.callback, {func: 1, ret: P.bool, args: [P.Object]}), asyncError.error, P.bool, P.Object);
    },
    handleError$1: function(asyncError) {
      var errorCallback = this.errorCallback,
        t1 = P.Object,
        t2 = {futureOr: 1, type: H.getTypeArgumentByIndex(this, 1)},
        t3 = this.result._zone;
      if (H.functionTypeTest(errorCallback, {func: 1, args: [P.Object, P.StackTrace]}))
        return H.futureOrCheck(t3.runBinary$3$3(errorCallback, asyncError.error, asyncError.stackTrace, null, t1, P.StackTrace), t2);
      else
        return H.futureOrCheck(t3.runUnary$2$2(H.functionTypeCheck(errorCallback, {func: 1, args: [P.Object]}), asyncError.error, null, t1), t2);
    }
  };
  P._Future.prototype = {
    then$1$2$onError: function(_, f, onError, $R) {
      var currentZone, result, t2,
        t1 = H.getTypeArgumentByIndex(this, 0);
      H.functionTypeCheck(f, {func: 1, ret: {futureOr: 1, type: $R}, args: [t1]});
      currentZone = $.Zone__current;
      if (currentZone !== C.C__RootZone) {
        H.functionTypeCheck(f, {func: 1, ret: {futureOr: 1, type: $R}, args: [t1]});
        if (onError != null)
          onError = P._registerErrorHandler(onError, currentZone);
      }
      result = new P._Future($.Zone__current, [$R]);
      t2 = onError == null ? 1 : 3;
      this._addListener$1(new P._FutureListener(result, t2, f, onError, [t1, $R]));
      return result;
    },
    then$1$1: function($receiver, f, $R) {
      return this.then$1$2$onError($receiver, f, null, $R);
    },
    _thenAwait$1$2: function(f, onError, $E) {
      var result,
        t1 = H.getTypeArgumentByIndex(this, 0);
      H.functionTypeCheck(f, {func: 1, ret: {futureOr: 1, type: $E}, args: [t1]});
      result = new P._Future($.Zone__current, [$E]);
      this._addListener$1(new P._FutureListener(result, (onError == null ? 1 : 3) | 16, f, onError, [t1, $E]));
      return result;
    },
    whenComplete$1: function(action) {
      var t1, result;
      H.functionTypeCheck(action, {func: 1});
      t1 = $.Zone__current;
      result = new P._Future(t1, this.$ti);
      if (t1 !== C.C__RootZone)
        action = H.functionTypeCheck(action, {func: 1, ret: null});
      t1 = H.getTypeArgumentByIndex(this, 0);
      this._addListener$1(new P._FutureListener(result, 8, action, null, [t1, t1]));
      return result;
    },
    _setValue$1: function(value) {
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 0));
      this._state = 4;
      this._resultOrListeners = value;
    },
    _addListener$1: function(listener) {
      var source, _this = this,
        t1 = _this._state;
      if (t1 <= 1) {
        listener._nextListener = H.interceptedTypeCheck(_this._resultOrListeners, "$is_FutureListener");
        _this._resultOrListeners = listener;
      } else {
        if (t1 === 2) {
          source = H.interceptedTypeCheck(_this._resultOrListeners, "$is_Future");
          t1 = source._state;
          if (t1 < 4) {
            source._addListener$1(listener);
            return;
          }
          _this._state = t1;
          _this._resultOrListeners = source._resultOrListeners;
        }
        P._rootScheduleMicrotask(null, null, _this._zone, H.functionTypeCheck(new P._Future__addListener_closure(_this, listener), {func: 1, ret: -1}));
      }
    },
    _prependListeners$1: function(listeners) {
      var t1, existingListeners, cursor, cursor0, source, _this = this, _box_0 = {};
      _box_0.listeners = listeners;
      if (listeners == null)
        return;
      t1 = _this._state;
      if (t1 <= 1) {
        existingListeners = H.interceptedTypeCheck(_this._resultOrListeners, "$is_FutureListener");
        cursor = _this._resultOrListeners = listeners;
        if (existingListeners != null) {
          for (; cursor0 = cursor._nextListener, cursor0 != null; cursor = cursor0)
            ;
          cursor._nextListener = existingListeners;
        }
      } else {
        if (t1 === 2) {
          source = H.interceptedTypeCheck(_this._resultOrListeners, "$is_Future");
          t1 = source._state;
          if (t1 < 4) {
            source._prependListeners$1(listeners);
            return;
          }
          _this._state = t1;
          _this._resultOrListeners = source._resultOrListeners;
        }
        _box_0.listeners = _this._reverseListeners$1(listeners);
        P._rootScheduleMicrotask(null, null, _this._zone, H.functionTypeCheck(new P._Future__prependListeners_closure(_box_0, _this), {func: 1, ret: -1}));
      }
    },
    _removeListeners$0: function() {
      var current = H.interceptedTypeCheck(this._resultOrListeners, "$is_FutureListener");
      this._resultOrListeners = null;
      return this._reverseListeners$1(current);
    },
    _reverseListeners$1: function(listeners) {
      var current, prev, next;
      for (current = listeners, prev = null; current != null; prev = current, current = next) {
        next = current._nextListener;
        current._nextListener = prev;
      }
      return prev;
    },
    _complete$1: function(value) {
      var t2, listeners, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.futureOrCheck(value, {futureOr: 1, type: t1});
      t2 = _this.$ti;
      if (H.checkSubtype(value, "$isFuture", t2, "$asFuture"))
        if (H.checkSubtype(value, "$is_Future", t2, null))
          P._Future__chainCoreFuture(value, _this);
        else
          P._Future__chainForeignFuture(value, _this);
      else {
        listeners = _this._removeListeners$0();
        H.assertSubtypeOfRuntimeType(value, t1);
        _this._state = 4;
        _this._resultOrListeners = value;
        P._Future__propagateToListeners(_this, listeners);
      }
    },
    _completeWithValue$1: function(value) {
      var listeners, _this = this;
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 0));
      listeners = _this._removeListeners$0();
      _this._state = 4;
      _this._resultOrListeners = value;
      P._Future__propagateToListeners(_this, listeners);
    },
    _completeError$2: function(error, stackTrace) {
      var listeners, _this = this;
      H.interceptedTypeCheck(stackTrace, "$isStackTrace");
      listeners = _this._removeListeners$0();
      _this._state = 8;
      _this._resultOrListeners = new P.AsyncError(error, stackTrace);
      P._Future__propagateToListeners(_this, listeners);
    },
    _completeError$1: function(error) {
      return this._completeError$2(error, null);
    },
    _asyncComplete$1: function(value) {
      var _this = this;
      H.futureOrCheck(value, {futureOr: 1, type: H.getTypeArgumentByIndex(_this, 0)});
      if (H.checkSubtype(value, "$isFuture", _this.$ti, "$asFuture")) {
        _this._chainFuture$1(value);
        return;
      }
      _this._state = 1;
      P._rootScheduleMicrotask(null, null, _this._zone, H.functionTypeCheck(new P._Future__asyncComplete_closure(_this, value), {func: 1, ret: -1}));
    },
    _chainFuture$1: function(value) {
      var _this = this,
        t1 = _this.$ti;
      H.assertSubtype(value, "$isFuture", t1, "$asFuture");
      if (H.checkSubtype(value, "$is_Future", t1, null)) {
        if (value._state === 8) {
          _this._state = 1;
          P._rootScheduleMicrotask(null, null, _this._zone, H.functionTypeCheck(new P._Future__chainFuture_closure(_this, value), {func: 1, ret: -1}));
        } else
          P._Future__chainCoreFuture(value, _this);
        return;
      }
      P._Future__chainForeignFuture(value, _this);
    },
    _asyncCompleteError$2: function(error, stackTrace) {
      H.interceptedTypeCheck(stackTrace, "$isStackTrace");
      this._state = 1;
      P._rootScheduleMicrotask(null, null, this._zone, H.functionTypeCheck(new P._Future__asyncCompleteError_closure(this, error, stackTrace), {func: 1, ret: -1}));
    },
    $isFuture: 1
  };
  P._Future__addListener_closure.prototype = {
    call$0: function() {
      P._Future__propagateToListeners(this.$this, this.listener);
    },
    $signature: 2
  };
  P._Future__prependListeners_closure.prototype = {
    call$0: function() {
      P._Future__propagateToListeners(this.$this, this._box_0.listeners);
    },
    $signature: 2
  };
  P._Future__chainForeignFuture_closure.prototype = {
    call$1: function(value) {
      var t1 = this.target;
      t1._state = 0;
      t1._complete$1(value);
    },
    $signature: 13
  };
  P._Future__chainForeignFuture_closure0.prototype = {
    call$2: function(error, stackTrace) {
      H.interceptedTypeCheck(stackTrace, "$isStackTrace");
      this.target._completeError$2(error, stackTrace);
    },
    call$1: function(error) {
      return this.call$2(error, null);
    },
    "call*": "call$2",
    $defaultValues: function() {
      return [null];
    },
    $signature: 34
  };
  P._Future__chainForeignFuture_closure1.prototype = {
    call$0: function() {
      this.target._completeError$2(this.e, this.s);
    },
    $signature: 2
  };
  P._Future__asyncComplete_closure.prototype = {
    call$0: function() {
      var t1 = this.$this;
      t1._completeWithValue$1(H.assertSubtypeOfRuntimeType(this.value, H.getTypeArgumentByIndex(t1, 0)));
    },
    $signature: 2
  };
  P._Future__chainFuture_closure.prototype = {
    call$0: function() {
      P._Future__chainCoreFuture(this.value, this.$this);
    },
    $signature: 2
  };
  P._Future__asyncCompleteError_closure.prototype = {
    call$0: function() {
      this.$this._completeError$2(this.error, this.stackTrace);
    },
    $signature: 2
  };
  P._Future__propagateToListeners_handleWhenCompleteCallback.prototype = {
    call$0: function() {
      var e, s, t1, exception, t2, originalSource, _this = this, completeResult = null;
      try {
        t1 = _this.listener;
        completeResult = t1.result._zone.run$1$1(H.functionTypeCheck(t1.callback, {func: 1}), null);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        if (_this.hasError) {
          t1 = H.interceptedTypeCheck(_this._box_1.source._resultOrListeners, "$isAsyncError").error;
          t2 = e;
          t2 = t1 == null ? t2 == null : t1 === t2;
          t1 = t2;
        } else
          t1 = false;
        t2 = _this._box_0;
        if (t1)
          t2.listenerValueOrError = H.interceptedTypeCheck(_this._box_1.source._resultOrListeners, "$isAsyncError");
        else
          t2.listenerValueOrError = new P.AsyncError(e, s);
        t2.listenerHasError = true;
        return;
      }
      if (!!J.getInterceptor$(completeResult).$isFuture) {
        if (completeResult instanceof P._Future && completeResult._state >= 4) {
          if (completeResult._state === 8) {
            t1 = _this._box_0;
            t1.listenerValueOrError = H.interceptedTypeCheck(completeResult._resultOrListeners, "$isAsyncError");
            t1.listenerHasError = true;
          }
          return;
        }
        originalSource = _this._box_1.source;
        t1 = _this._box_0;
        t1.listenerValueOrError = J.then$1$1$x(completeResult, new P._Future__propagateToListeners_handleWhenCompleteCallback_closure(originalSource), null);
        t1.listenerHasError = false;
      }
    },
    $signature: 1
  };
  P._Future__propagateToListeners_handleWhenCompleteCallback_closure.prototype = {
    call$1: function(_) {
      return this.originalSource;
    },
    $signature: 40
  };
  P._Future__propagateToListeners_handleValueCallback.prototype = {
    call$0: function() {
      var e, s, t1, t2, t3, t4, exception, _this = this;
      try {
        t1 = _this.listener;
        t2 = H.getTypeArgumentByIndex(t1, 0);
        t3 = H.assertSubtypeOfRuntimeType(_this.sourceResult, t2);
        t4 = H.getTypeArgumentByIndex(t1, 1);
        _this._box_0.listenerValueOrError = t1.result._zone.runUnary$2$2(H.functionTypeCheck(t1.callback, {func: 1, ret: {futureOr: 1, type: t4}, args: [t2]}), t3, {futureOr: 1, type: t4}, t2);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        t1 = _this._box_0;
        t1.listenerValueOrError = new P.AsyncError(e, s);
        t1.listenerHasError = true;
      }
    },
    $signature: 1
  };
  P._Future__propagateToListeners_handleError.prototype = {
    call$0: function() {
      var asyncError, e, s, t1, t2, exception, t3, t4, _this = this;
      try {
        asyncError = H.interceptedTypeCheck(_this._box_1.source._resultOrListeners, "$isAsyncError");
        t1 = _this.listener;
        if (H.boolConversionCheck(t1.matchesErrorTest$1(asyncError)) && t1.errorCallback != null) {
          t2 = _this._box_0;
          t2.listenerValueOrError = t1.handleError$1(asyncError);
          t2.listenerHasError = false;
        }
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        t1 = H.interceptedTypeCheck(_this._box_1.source._resultOrListeners, "$isAsyncError");
        t2 = t1.error;
        t3 = e;
        t4 = _this._box_0;
        if (t2 == null ? t3 == null : t2 === t3)
          t4.listenerValueOrError = t1;
        else
          t4.listenerValueOrError = new P.AsyncError(e, s);
        t4.listenerHasError = true;
      }
    },
    $signature: 1
  };
  P._AsyncCallbackEntry.prototype = {};
  P.Stream.prototype = {
    get$length: function(_) {
      var t1 = {},
        future = new P._Future($.Zone__current, [P.int]);
      t1.count = 0;
      this.listen$4$cancelOnError$onDone$onError(new P.Stream_length_closure(t1, this), true, new P.Stream_length_closure0(t1, future), future.get$_completeError());
      return future;
    }
  };
  P.Stream_Stream$fromFuture_closure.prototype = {
    call$1: function(value) {
      var t1 = this.controller;
      t1._async$_add$1(H.assertSubtypeOfRuntimeType(value, this.T));
      t1._closeUnchecked$0();
    },
    $signature: function() {
      return {func: 1, ret: P.Null, args: [this.T]};
    }
  };
  P.Stream_Stream$fromFuture_closure0.prototype = {
    call$2: function(error, stackTrace) {
      var t2,
        t1 = this.controller;
      H.interceptedTypeCheck(stackTrace, "$isStackTrace");
      t2 = t1._state;
      if ((t2 & 1) !== 0)
        t1._sendError$2(error, stackTrace);
      else if ((t2 & 3) === 0)
        t1._ensurePendingEvents$0().add$1(0, new P._DelayedError(error, stackTrace));
      t1._closeUnchecked$0();
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 15
  };
  P.Stream_Stream$fromIterable_closure.prototype = {
    call$0: function() {
      var t1 = this.elements;
      return new P._IterablePendingEvents(new J.ArrayIterator(t1, 1, [H.getTypeArgumentByIndex(t1, 0)]), [this.T]);
    },
    $signature: function() {
      return {func: 1, ret: [P._IterablePendingEvents, this.T]};
    }
  };
  P.Stream_length_closure.prototype = {
    call$1: function(_) {
      H.assertSubtypeOfRuntimeType(_, H.getTypeArgumentByIndex(this.$this, 0));
      ++this._box_0.count;
    },
    $signature: function() {
      return {func: 1, ret: P.Null, args: [H.getTypeArgumentByIndex(this.$this, 0)]};
    }
  };
  P.Stream_length_closure0.prototype = {
    call$0: function() {
      this.future._complete$1(this._box_0.count);
    },
    $signature: 2
  };
  P.StreamTransformerBase.prototype = {};
  P._StreamController.prototype = {
    get$_pendingEvents: function() {
      var t1, _this = this;
      if ((_this._state & 8) === 0)
        return H.assertSubtype(_this._varData, "$is_PendingEvents", _this.$ti, "$as_PendingEvents");
      t1 = _this.$ti;
      return H.assertSubtype(H.assertSubtype(_this._varData, "$is_StreamControllerAddStreamState", t1, "$as_StreamControllerAddStreamState").get$varData(), "$is_PendingEvents", t1, "$as_PendingEvents");
    },
    _ensurePendingEvents$0: function() {
      var t1, state, _this = this;
      if ((_this._state & 8) === 0) {
        t1 = _this._varData;
        if (t1 == null)
          t1 = _this._varData = new P._StreamImplEvents(_this.$ti);
        return H.assertSubtype(t1, "$is_StreamImplEvents", _this.$ti, "$as_StreamImplEvents");
      }
      t1 = _this.$ti;
      state = H.assertSubtype(_this._varData, "$is_StreamControllerAddStreamState", t1, "$as_StreamControllerAddStreamState");
      state.get$varData();
      return H.assertSubtype(state.get$varData(), "$is_StreamImplEvents", t1, "$as_StreamImplEvents");
    },
    get$_subscription: function() {
      var t1, _this = this;
      if ((_this._state & 8) !== 0) {
        t1 = _this.$ti;
        return H.assertSubtype(H.assertSubtype(_this._varData, "$is_StreamControllerAddStreamState", t1, "$as_StreamControllerAddStreamState").get$varData(), "$is_ControllerSubscription", t1, "$as_ControllerSubscription");
      }
      return H.assertSubtype(_this._varData, "$is_ControllerSubscription", _this.$ti, "$as_ControllerSubscription");
    },
    _badEventState$0: function() {
      if ((this._state & 4) !== 0)
        return new P.StateError("Cannot add event after closing");
      return new P.StateError("Cannot add event while adding a stream");
    },
    _ensureDoneFuture$0: function() {
      var t1 = this._doneFuture;
      if (t1 == null)
        t1 = this._doneFuture = (this._state & 2) !== 0 ? $.$get$Future__nullFuture() : new P._Future($.Zone__current, [null]);
      return t1;
    },
    add$1: function(_, value) {
      var _this = this;
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 0));
      if (_this._state >= 4)
        throw H.wrapException(_this._badEventState$0());
      _this._async$_add$1(value);
    },
    close$0: function() {
      var _this = this,
        t1 = _this._state;
      if ((t1 & 4) !== 0)
        return _this._ensureDoneFuture$0();
      if (t1 >= 4)
        throw H.wrapException(_this._badEventState$0());
      _this._closeUnchecked$0();
      return _this._ensureDoneFuture$0();
    },
    _closeUnchecked$0: function() {
      var t1 = this._state |= 4;
      if ((t1 & 1) !== 0)
        this._sendDone$0();
      else if ((t1 & 3) === 0)
        this._ensurePendingEvents$0().add$1(0, C.C__DelayedDone);
    },
    _async$_add$1: function(value) {
      var t1, _this = this;
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 0));
      t1 = _this._state;
      if ((t1 & 1) !== 0)
        _this._sendData$1(value);
      else if ((t1 & 3) === 0)
        _this._ensurePendingEvents$0().add$1(0, new P._DelayedData(value, _this.$ti));
    },
    _subscribe$4: function(onData, onError, onDone, cancelOnError) {
      var t2, t3, t4, subscription, pendingEvents, addState, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.functionTypeCheck(onData, {func: 1, ret: -1, args: [t1]});
      H.functionTypeCheck(onDone, {func: 1, ret: -1});
      if ((_this._state & 3) !== 0)
        throw H.wrapException(P.StateError$("Stream has already been listened to."));
      t2 = $.Zone__current;
      t3 = cancelOnError ? 1 : 0;
      t4 = _this.$ti;
      subscription = new P._ControllerSubscription(_this, t2, t3, t4);
      subscription._BufferingStreamSubscription$4(onData, onError, onDone, cancelOnError, t1);
      pendingEvents = _this.get$_pendingEvents();
      t1 = _this._state |= 1;
      if ((t1 & 8) !== 0) {
        addState = H.assertSubtype(_this._varData, "$is_StreamControllerAddStreamState", t4, "$as_StreamControllerAddStreamState");
        addState.set$varData(subscription);
        addState.resume$0();
      } else
        _this._varData = subscription;
      subscription._setPendingEvents$1(pendingEvents);
      subscription._guardCallback$1(new P._StreamController__subscribe_closure(_this));
      return subscription;
    },
    _recordCancel$1: function(subscription) {
      var result, e, s, exception, result0, _this = this,
        t1 = _this.$ti;
      H.assertSubtype(subscription, "$isStreamSubscription", t1, "$asStreamSubscription");
      result = null;
      if ((_this._state & 8) !== 0)
        result = H.assertSubtype(_this._varData, "$is_StreamControllerAddStreamState", t1, "$as_StreamControllerAddStreamState").cancel$0();
      _this._varData = null;
      _this._state = _this._state & 4294967286 | 2;
      t1 = _this.onCancel;
      if (t1 != null)
        if (result == null)
          try {
            result = H.interceptedTypeCheck(t1.call$0(), "$isFuture");
          } catch (exception) {
            e = H.unwrapException(exception);
            s = H.getTraceFromException(exception);
            result0 = new P._Future($.Zone__current, [null]);
            result0._asyncCompleteError$2(e, s);
            result = result0;
          }
        else
          result = result.whenComplete$1(t1);
      t1 = new P._StreamController__recordCancel_complete(_this);
      if (result != null)
        result = result.whenComplete$1(t1);
      else
        t1.call$0();
      return result;
    },
    set$onPause: function(onPause) {
      this.onPause = H.functionTypeCheck(onPause, {func: 1, ret: -1});
    },
    set$onResume: function(onResume) {
      this.onResume = H.functionTypeCheck(onResume, {func: 1, ret: -1});
    },
    set$onCancel: function(onCancel) {
      this.onCancel = H.functionTypeCheck(onCancel, {func: 1});
    },
    $isStreamController: 1,
    $is_StreamControllerLifecycle: 1,
    $is_EventDispatch: 1,
    $isSink: 1
  };
  P._StreamController__subscribe_closure.prototype = {
    call$0: function() {
      P._runGuarded(this.$this.onListen);
    },
    $signature: 2
  };
  P._StreamController__recordCancel_complete.prototype = {
    call$0: function() {
      var t1 = this.$this._doneFuture;
      if (t1 != null && t1._state === 0)
        t1._asyncComplete$1(null);
    },
    $signature: 1
  };
  P._SyncStreamControllerDispatch.prototype = {
    _sendData$1: function(data) {
      H.assertSubtypeOfRuntimeType(data, H.getTypeArgumentByIndex(this, 0));
      this.get$_subscription()._async$_add$1(data);
    },
    _sendError$2: function(error, stackTrace) {
      this.get$_subscription()._addError$2(error, stackTrace);
    },
    _sendDone$0: function() {
      this.get$_subscription()._close$0();
    }
  };
  P._AsyncStreamControllerDispatch.prototype = {
    _sendData$1: function(data) {
      var t1 = H.getTypeArgumentByIndex(this, 0);
      H.assertSubtypeOfRuntimeType(data, t1);
      this.get$_subscription()._addPending$1(new P._DelayedData(data, [t1]));
    },
    _sendDone$0: function() {
      this.get$_subscription()._addPending$1(C.C__DelayedDone);
    }
  };
  P._AsyncStreamController.prototype = {};
  P._SyncStreamController.prototype = {};
  P._ControllerStream.prototype = {
    _createSubscription$4: function(onData, onError, onDone, cancelOnError) {
      return this._controller._subscribe$4(H.functionTypeCheck(onData, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(this, 0)]}), onError, H.functionTypeCheck(onDone, {func: 1, ret: -1}), cancelOnError);
    },
    get$hashCode: function(_) {
      return (H.Primitives_objectHashCode(this._controller) ^ 892482866) >>> 0;
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      if (this === other)
        return true;
      return other instanceof P._ControllerStream && other._controller === this._controller;
    }
  };
  P._ControllerSubscription.prototype = {
    _onCancel$0: function() {
      return this._controller._recordCancel$1(this);
    },
    _onPause$0: function() {
      var t1 = this._controller,
        t2 = H.getTypeArgumentByIndex(t1, 0);
      H.assertSubtype(this, "$isStreamSubscription", [t2], "$asStreamSubscription");
      if ((t1._state & 8) !== 0)
        H.assertSubtype(t1._varData, "$is_StreamControllerAddStreamState", [t2], "$as_StreamControllerAddStreamState").pause$0();
      P._runGuarded(t1.onPause);
    },
    _onResume$0: function() {
      var t1 = this._controller,
        t2 = H.getTypeArgumentByIndex(t1, 0);
      H.assertSubtype(this, "$isStreamSubscription", [t2], "$asStreamSubscription");
      if ((t1._state & 8) !== 0)
        H.assertSubtype(t1._varData, "$is_StreamControllerAddStreamState", [t2], "$as_StreamControllerAddStreamState").resume$0();
      P._runGuarded(t1.onResume);
    }
  };
  P._BufferingStreamSubscription.prototype = {
    _BufferingStreamSubscription$4: function(onData, onError, onDone, cancelOnError, $T) {
      var handleError, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.functionTypeCheck(onData, {func: 1, ret: -1, args: [t1]});
      _this.set$_onData(H.functionTypeCheck(onData, {func: 1, ret: null, args: [t1]}));
      handleError = onError == null ? P.async___nullErrorHandler$closure() : onError;
      if (H.functionTypeTest(handleError, {func: 1, ret: -1, args: [P.Object, P.StackTrace]}))
        _this._onError = _this._zone.registerBinaryCallback$3$1(handleError, null, P.Object, P.StackTrace);
      else if (H.functionTypeTest(handleError, {func: 1, ret: -1, args: [P.Object]}))
        _this._onError = H.functionTypeCheck(handleError, {func: 1, ret: null, args: [P.Object]});
      else
        H.throwExpression(P.ArgumentError$("handleError callback must take either an Object (the error), or both an Object (the error) and a StackTrace."));
      H.functionTypeCheck(onDone, {func: 1, ret: -1});
      _this.set$_onDone(H.functionTypeCheck(onDone, {func: 1, ret: -1}));
    },
    _setPendingEvents$1: function(pendingEvents) {
      var _this = this;
      H.assertSubtype(pendingEvents, "$is_PendingEvents", _this.$ti, "$as_PendingEvents");
      if (pendingEvents == null)
        return;
      _this.set$_pending(pendingEvents);
      if (!pendingEvents.get$isEmpty(pendingEvents)) {
        _this._state = (_this._state | 64) >>> 0;
        _this._pending.schedule$1(_this);
      }
    },
    pause$1: function(resumeSignal) {
      var t2, t3, _this = this,
        t1 = _this._state;
      if ((t1 & 8) !== 0)
        return;
      t2 = (t1 + 128 | 4) >>> 0;
      _this._state = t2;
      if (t1 < 128 && _this._pending != null) {
        t3 = _this._pending;
        if (t3._state === 1)
          t3._state = 3;
      }
      if ((t1 & 4) === 0 && (t2 & 32) === 0)
        _this._guardCallback$1(_this.get$_onPause());
    },
    pause$0: function() {
      return this.pause$1(null);
    },
    resume$0: function() {
      var _this = this,
        t1 = _this._state;
      if ((t1 & 8) !== 0)
        return;
      if (t1 >= 128) {
        t1 = _this._state = t1 - 128;
        if (t1 < 128) {
          if ((t1 & 64) !== 0) {
            t1 = _this._pending;
            t1 = !t1.get$isEmpty(t1);
          } else
            t1 = false;
          if (t1)
            _this._pending.schedule$1(_this);
          else {
            t1 = (_this._state & 4294967291) >>> 0;
            _this._state = t1;
            if ((t1 & 32) === 0)
              _this._guardCallback$1(_this.get$_onResume());
          }
        }
      }
    },
    cancel$0: function() {
      var _this = this,
        t1 = (_this._state & 4294967279) >>> 0;
      _this._state = t1;
      if ((t1 & 8) === 0)
        _this._cancel$0();
      t1 = _this._cancelFuture;
      return t1 == null ? $.$get$Future__nullFuture() : t1;
    },
    _cancel$0: function() {
      var t2, _this = this,
        t1 = _this._state = (_this._state | 8) >>> 0;
      if ((t1 & 64) !== 0) {
        t2 = _this._pending;
        if (t2._state === 1)
          t2._state = 3;
      }
      if ((t1 & 32) === 0)
        _this.set$_pending(null);
      _this._cancelFuture = _this._onCancel$0();
    },
    _async$_add$1: function(data) {
      var t1, _this = this;
      H.assertSubtypeOfRuntimeType(data, H.getTypeArgumentByIndex(_this, 0));
      t1 = _this._state;
      if ((t1 & 8) !== 0)
        return;
      if (t1 < 32)
        _this._sendData$1(data);
      else
        _this._addPending$1(new P._DelayedData(data, _this.$ti));
    },
    _addError$2: function(error, stackTrace) {
      var t1 = this._state;
      if ((t1 & 8) !== 0)
        return;
      if (t1 < 32)
        this._sendError$2(error, stackTrace);
      else
        this._addPending$1(new P._DelayedError(error, stackTrace));
    },
    _close$0: function() {
      var _this = this,
        t1 = _this._state;
      if ((t1 & 8) !== 0)
        return;
      t1 = (t1 | 2) >>> 0;
      _this._state = t1;
      if (t1 < 32)
        _this._sendDone$0();
      else
        _this._addPending$1(C.C__DelayedDone);
    },
    _onPause$0: function() {
    },
    _onResume$0: function() {
    },
    _onCancel$0: function() {
      return;
    },
    _addPending$1: function($event) {
      var _this = this,
        t1 = _this.$ti,
        pending = H.assertSubtype(_this._pending, "$is_StreamImplEvents", t1, "$as_StreamImplEvents");
      if (pending == null) {
        pending = new P._StreamImplEvents(t1);
        _this.set$_pending(pending);
      }
      pending.add$1(0, $event);
      t1 = _this._state;
      if ((t1 & 64) === 0) {
        t1 = (t1 | 64) >>> 0;
        _this._state = t1;
        if (t1 < 128)
          _this._pending.schedule$1(_this);
      }
    },
    _sendData$1: function(data) {
      var t2, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.assertSubtypeOfRuntimeType(data, t1);
      t2 = _this._state;
      _this._state = (t2 | 32) >>> 0;
      _this._zone.runUnaryGuarded$1$2(_this._onData, data, t1);
      _this._state = (_this._state & 4294967263) >>> 0;
      _this._checkState$1((t2 & 4) !== 0);
    },
    _sendError$2: function(error, stackTrace) {
      var t1, t2, _this = this;
      H.interceptedTypeCheck(stackTrace, "$isStackTrace");
      t1 = _this._state;
      t2 = new P._BufferingStreamSubscription__sendError_sendError(_this, error, stackTrace);
      if ((t1 & 1) !== 0) {
        _this._state = (t1 | 16) >>> 0;
        _this._cancel$0();
        t1 = _this._cancelFuture;
        if (t1 != null && t1 !== $.$get$Future__nullFuture())
          t1.whenComplete$1(t2);
        else
          t2.call$0();
      } else {
        t2.call$0();
        _this._checkState$1((t1 & 4) !== 0);
      }
    },
    _sendDone$0: function() {
      var t2, _this = this,
        t1 = new P._BufferingStreamSubscription__sendDone_sendDone(_this);
      _this._cancel$0();
      _this._state = (_this._state | 16) >>> 0;
      t2 = _this._cancelFuture;
      if (t2 != null && t2 !== $.$get$Future__nullFuture())
        t2.whenComplete$1(t1);
      else
        t1.call$0();
    },
    _guardCallback$1: function(callback) {
      var t1, _this = this;
      H.functionTypeCheck(callback, {func: 1, ret: -1});
      t1 = _this._state;
      _this._state = (t1 | 32) >>> 0;
      callback.call$0();
      _this._state = (_this._state & 4294967263) >>> 0;
      _this._checkState$1((t1 & 4) !== 0);
    },
    _checkState$1: function(wasInputPaused) {
      var t1, isInputPaused, _this = this;
      if ((_this._state & 64) !== 0) {
        t1 = _this._pending;
        t1 = t1.get$isEmpty(t1);
      } else
        t1 = false;
      if (t1) {
        t1 = _this._state = (_this._state & 4294967231) >>> 0;
        if ((t1 & 4) !== 0)
          if (t1 < 128) {
            t1 = _this._pending;
            t1 = t1 == null || t1.get$isEmpty(t1);
          } else
            t1 = false;
        else
          t1 = false;
        if (t1)
          _this._state = (_this._state & 4294967291) >>> 0;
      }
      for (; true; wasInputPaused = isInputPaused) {
        t1 = _this._state;
        if ((t1 & 8) !== 0) {
          _this.set$_pending(null);
          return;
        }
        isInputPaused = (t1 & 4) !== 0;
        if (wasInputPaused === isInputPaused)
          break;
        _this._state = (t1 ^ 32) >>> 0;
        if (isInputPaused)
          _this._onPause$0();
        else
          _this._onResume$0();
        _this._state = (_this._state & 4294967263) >>> 0;
      }
      t1 = _this._state;
      if ((t1 & 64) !== 0 && t1 < 128)
        _this._pending.schedule$1(_this);
    },
    set$_onData: function(_onData) {
      this._onData = H.functionTypeCheck(_onData, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(this, 0)]});
    },
    set$_onDone: function(_onDone) {
      this._onDone = H.functionTypeCheck(_onDone, {func: 1, ret: -1});
    },
    set$_pending: function(_pending) {
      this._pending = H.assertSubtype(_pending, "$is_PendingEvents", this.$ti, "$as_PendingEvents");
    },
    $isStreamSubscription: 1,
    $is_EventDispatch: 1
  };
  P._BufferingStreamSubscription__sendError_sendError.prototype = {
    call$0: function() {
      var onError, t3, t4,
        t1 = this.$this,
        t2 = t1._state;
      if ((t2 & 8) !== 0 && (t2 & 16) === 0)
        return;
      t1._state = (t2 | 32) >>> 0;
      onError = t1._onError;
      t2 = this.error;
      t3 = P.Object;
      t4 = t1._zone;
      if (H.functionTypeTest(onError, {func: 1, ret: -1, args: [P.Object, P.StackTrace]}))
        t4.runBinaryGuarded$2$3(onError, t2, this.stackTrace, t3, P.StackTrace);
      else
        t4.runUnaryGuarded$1$2(H.functionTypeCheck(t1._onError, {func: 1, ret: -1, args: [P.Object]}), t2, t3);
      t1._state = (t1._state & 4294967263) >>> 0;
    },
    $signature: 1
  };
  P._BufferingStreamSubscription__sendDone_sendDone.prototype = {
    call$0: function() {
      var t1 = this.$this,
        t2 = t1._state;
      if ((t2 & 16) === 0)
        return;
      t1._state = (t2 | 42) >>> 0;
      t1._zone.runGuarded$1(t1._onDone);
      t1._state = (t1._state & 4294967263) >>> 0;
    },
    $signature: 1
  };
  P._StreamImpl.prototype = {
    listen$4$cancelOnError$onDone$onError: function(onData, cancelOnError, onDone, onError) {
      return this._createSubscription$4(H.functionTypeCheck(onData, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(this, 0)]}), onError, H.functionTypeCheck(onDone, {func: 1, ret: -1}), true === cancelOnError);
    },
    listen$3$onDone$onError: function(onData, onDone, onError) {
      return this.listen$4$cancelOnError$onDone$onError(onData, null, onDone, onError);
    },
    listen$2$onDone: function(onData, onDone) {
      return this.listen$4$cancelOnError$onDone$onError(onData, null, onDone, null);
    },
    _createSubscription$4: function(onData, onError, onDone, cancelOnError) {
      var t1 = H.getTypeArgumentByIndex(this, 0);
      return P._BufferingStreamSubscription$(H.functionTypeCheck(onData, {func: 1, ret: -1, args: [t1]}), onError, H.functionTypeCheck(onDone, {func: 1, ret: -1}), cancelOnError, t1);
    }
  };
  P._GeneratedStreamImpl.prototype = {
    _createSubscription$4: function(onData, onError, onDone, cancelOnError) {
      var _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.functionTypeCheck(onData, {func: 1, ret: -1, args: [t1]});
      H.functionTypeCheck(onDone, {func: 1, ret: -1});
      if (_this._async$_isUsed)
        throw H.wrapException(P.StateError$("Stream has already been listened to."));
      _this._async$_isUsed = true;
      t1 = P._BufferingStreamSubscription$(onData, onError, onDone, cancelOnError, t1);
      t1._setPendingEvents$1(_this._pending.call$0());
      return t1;
    }
  };
  P._IterablePendingEvents.prototype = {
    get$isEmpty: function(_) {
      return this._async$_iterator == null;
    },
    handleNext$1: function(dispatch) {
      var hasMore, e, s, t1, exception, _this = this;
      H.assertSubtype(dispatch, "$is_EventDispatch", _this.$ti, "$as_EventDispatch");
      t1 = _this._async$_iterator;
      if (t1 == null)
        throw H.wrapException(P.StateError$("No events pending."));
      hasMore = null;
      try {
        hasMore = t1.moveNext$0();
        if (H.boolConversionCheck(hasMore))
          dispatch._sendData$1(_this._async$_iterator.get$current());
        else {
          _this.set$_async$_iterator(null);
          dispatch._sendDone$0();
        }
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        if (hasMore == null) {
          _this.set$_async$_iterator(C.C_EmptyIterator);
          dispatch._sendError$2(e, s);
        } else
          dispatch._sendError$2(e, s);
      }
    },
    set$_async$_iterator: function(_iterator) {
      this._async$_iterator = H.assertSubtype(_iterator, "$isIterator", this.$ti, "$asIterator");
    }
  };
  P._DelayedEvent.prototype = {
    set$next: function(next) {
      this.next = H.interceptedTypeCheck(next, "$is_DelayedEvent");
    },
    get$next: function() {
      return this.next;
    }
  };
  P._DelayedData.prototype = {
    perform$1: function(dispatch) {
      H.assertSubtype(dispatch, "$is_EventDispatch", this.$ti, "$as_EventDispatch")._sendData$1(this.value);
    }
  };
  P._DelayedError.prototype = {
    perform$1: function(dispatch) {
      dispatch._sendError$2(this.error, this.stackTrace);
    },
    $as_DelayedEvent: function() {
    }
  };
  P._DelayedDone.prototype = {
    perform$1: function(dispatch) {
      dispatch._sendDone$0();
    },
    get$next: function() {
      return;
    },
    set$next: function(_) {
      throw H.wrapException(P.StateError$("No events after a done."));
    },
    $is_DelayedEvent: 1,
    $as_DelayedEvent: function() {
    }
  };
  P._PendingEvents.prototype = {
    schedule$1: function(dispatch) {
      var t1, _this = this;
      H.assertSubtype(dispatch, "$is_EventDispatch", _this.$ti, "$as_EventDispatch");
      t1 = _this._state;
      if (t1 === 1)
        return;
      if (t1 >= 1) {
        _this._state = 1;
        return;
      }
      P.scheduleMicrotask(new P._PendingEvents_schedule_closure(_this, dispatch));
      _this._state = 1;
    }
  };
  P._PendingEvents_schedule_closure.prototype = {
    call$0: function() {
      var t1 = this.$this,
        oldState = t1._state;
      t1._state = 0;
      if (oldState === 3)
        return;
      t1.handleNext$1(this.dispatch);
    },
    $signature: 2
  };
  P._StreamImplEvents.prototype = {
    get$isEmpty: function(_) {
      return this.lastPendingEvent == null;
    },
    add$1: function(_, $event) {
      var _this = this,
        t1 = _this.lastPendingEvent;
      if (t1 == null)
        _this.firstPendingEvent = _this.lastPendingEvent = $event;
      else {
        t1.set$next($event);
        _this.lastPendingEvent = $event;
      }
    },
    handleNext$1: function(dispatch) {
      var $event, t1, _this = this;
      H.assertSubtype(dispatch, "$is_EventDispatch", _this.$ti, "$as_EventDispatch");
      $event = _this.firstPendingEvent;
      t1 = $event.get$next();
      _this.firstPendingEvent = t1;
      if (t1 == null)
        _this.lastPendingEvent = null;
      $event.perform$1(dispatch);
    }
  };
  P._StreamIterator.prototype = {};
  P.AsyncError.prototype = {
    toString$0: function(_) {
      return H.S(this.error);
    },
    $isError: 1
  };
  P._Zone.prototype = {$isZone: 1};
  P._rootHandleUncaughtError_closure.prototype = {
    call$0: function() {
      var error,
        t1 = this._box_0,
        t2 = t1.error;
      t1 = t2 == null ? t1.error = new P.NullThrownError() : t2;
      t2 = this.stackTrace;
      if (t2 == null)
        throw H.wrapException(t1);
      error = H.wrapException(t1);
      error.stack = t2.toString$0(0);
      throw error;
    },
    $signature: 2
  };
  P._RootZone.prototype = {
    runGuarded$1: function(f) {
      var e, s, exception, _null = null;
      H.functionTypeCheck(f, {func: 1, ret: -1});
      try {
        if (C.C__RootZone === $.Zone__current) {
          f.call$0();
          return;
        }
        P._rootRun(_null, _null, this, f, -1);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        P._rootHandleUncaughtError(_null, _null, this, e, H.interceptedTypeCheck(s, "$isStackTrace"));
      }
    },
    runUnaryGuarded$1$2: function(f, arg, $T) {
      var e, s, exception, _null = null;
      H.functionTypeCheck(f, {func: 1, ret: -1, args: [$T]});
      H.assertSubtypeOfRuntimeType(arg, $T);
      try {
        if (C.C__RootZone === $.Zone__current) {
          f.call$1(arg);
          return;
        }
        P._rootRunUnary(_null, _null, this, f, arg, -1, $T);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        P._rootHandleUncaughtError(_null, _null, this, e, H.interceptedTypeCheck(s, "$isStackTrace"));
      }
    },
    runBinaryGuarded$2$3: function(f, arg1, arg2, T1, T2) {
      var e, s, exception, _null = null;
      H.functionTypeCheck(f, {func: 1, ret: -1, args: [T1, T2]});
      H.assertSubtypeOfRuntimeType(arg1, T1);
      H.assertSubtypeOfRuntimeType(arg2, T2);
      try {
        if (C.C__RootZone === $.Zone__current) {
          f.call$2(arg1, arg2);
          return;
        }
        P._rootRunBinary(_null, _null, this, f, arg1, arg2, -1, T1, T2);
      } catch (exception) {
        e = H.unwrapException(exception);
        s = H.getTraceFromException(exception);
        P._rootHandleUncaughtError(_null, _null, this, e, H.interceptedTypeCheck(s, "$isStackTrace"));
      }
    },
    bindCallback$1$1: function(f, $R) {
      return new P._RootZone_bindCallback_closure(this, H.functionTypeCheck(f, {func: 1, ret: $R}), $R);
    },
    bindCallbackGuarded$1: function(f) {
      return new P._RootZone_bindCallbackGuarded_closure(this, H.functionTypeCheck(f, {func: 1, ret: -1}));
    },
    run$1$1: function(f, $R) {
      H.functionTypeCheck(f, {func: 1, ret: $R});
      if ($.Zone__current === C.C__RootZone)
        return f.call$0();
      return P._rootRun(null, null, this, f, $R);
    },
    runUnary$2$2: function(f, arg, $R, $T) {
      H.functionTypeCheck(f, {func: 1, ret: $R, args: [$T]});
      H.assertSubtypeOfRuntimeType(arg, $T);
      if ($.Zone__current === C.C__RootZone)
        return f.call$1(arg);
      return P._rootRunUnary(null, null, this, f, arg, $R, $T);
    },
    runBinary$3$3: function(f, arg1, arg2, $R, T1, T2) {
      H.functionTypeCheck(f, {func: 1, ret: $R, args: [T1, T2]});
      H.assertSubtypeOfRuntimeType(arg1, T1);
      H.assertSubtypeOfRuntimeType(arg2, T2);
      if ($.Zone__current === C.C__RootZone)
        return f.call$2(arg1, arg2);
      return P._rootRunBinary(null, null, this, f, arg1, arg2, $R, T1, T2);
    },
    registerBinaryCallback$3$1: function(f, $R, T1, T2) {
      return H.functionTypeCheck(f, {func: 1, ret: $R, args: [T1, T2]});
    }
  };
  P._RootZone_bindCallback_closure.prototype = {
    call$0: function() {
      return this.$this.run$1$1(this.f, this.R);
    },
    $signature: function() {
      return {func: 1, ret: this.R};
    }
  };
  P._RootZone_bindCallbackGuarded_closure.prototype = {
    call$0: function() {
      return this.$this.runGuarded$1(this.f);
    },
    $signature: 1
  };
  P._HashMap.prototype = {
    get$length: function(_) {
      return this._collection$_length;
    },
    get$isEmpty: function(_) {
      return this._collection$_length === 0;
    },
    get$keys: function() {
      return new P._HashMapKeyIterable(this, [H.getTypeArgumentByIndex(this, 0)]);
    },
    containsKey$1: function(key) {
      var strings, nums;
      if (typeof key === "string" && key !== "__proto__") {
        strings = this._strings;
        return strings == null ? false : strings[key] != null;
      } else if (typeof key === "number" && (key & 1073741823) === key) {
        nums = this._nums;
        return nums == null ? false : nums[key] != null;
      } else
        return this._containsKey$1(key);
    },
    _containsKey$1: function(key) {
      var rest = this._rest;
      if (rest == null)
        return false;
      return this._findBucketIndex$2(this._getBucket$2(rest, key), key) >= 0;
    },
    $index: function(_, key) {
      var strings, t1, nums;
      if (typeof key === "string" && key !== "__proto__") {
        strings = this._strings;
        t1 = strings == null ? null : P._HashMap__getTableEntry(strings, key);
        return t1;
      } else if (typeof key === "number" && (key & 1073741823) === key) {
        nums = this._nums;
        t1 = nums == null ? null : P._HashMap__getTableEntry(nums, key);
        return t1;
      } else
        return this._get$1(key);
    },
    _get$1: function(key) {
      var bucket, index,
        rest = this._rest;
      if (rest == null)
        return;
      bucket = this._getBucket$2(rest, key);
      index = this._findBucketIndex$2(bucket, key);
      return index < 0 ? null : bucket[index + 1];
    },
    $indexSet: function(_, key, value) {
      var strings, rest, hash, bucket, index, _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 1));
      if (typeof key === "string" && key !== "__proto__") {
        strings = _this._strings;
        _this._addHashTableEntry$3(strings == null ? _this._strings = P._HashMap__newHashTable() : strings, key, value);
      } else {
        rest = _this._rest;
        if (rest == null)
          rest = _this._rest = P._HashMap__newHashTable();
        hash = H.objectHashCode(key) & 1073741823;
        bucket = rest[hash];
        if (bucket == null) {
          P._HashMap__setTableEntry(rest, hash, [key, value]);
          ++_this._collection$_length;
          _this._keys = null;
        } else {
          index = _this._findBucketIndex$2(bucket, key);
          if (index >= 0)
            bucket[index + 1] = value;
          else {
            bucket.push(key, value);
            ++_this._collection$_length;
            _this._keys = null;
          }
        }
      }
    },
    forEach$1: function(_, action) {
      var keys, $length, i, key, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.functionTypeCheck(action, {func: 1, ret: -1, args: [t1, H.getTypeArgumentByIndex(_this, 1)]});
      keys = _this._computeKeys$0();
      for ($length = keys.length, i = 0; i < $length; ++i) {
        key = keys[i];
        action.call$2(H.assertSubtypeOfRuntimeType(key, t1), _this.$index(0, key));
        if (keys !== _this._keys)
          throw H.wrapException(P.ConcurrentModificationError$(_this));
      }
    },
    _computeKeys$0: function() {
      var result, strings, names, entries, index, i, nums, rest, bucket, $length, i0, _this = this,
        t1 = _this._keys;
      if (t1 != null)
        return t1;
      result = new Array(_this._collection$_length);
      result.fixed$length = Array;
      strings = _this._strings;
      if (strings != null) {
        names = Object.getOwnPropertyNames(strings);
        entries = names.length;
        for (index = 0, i = 0; i < entries; ++i) {
          result[index] = names[i];
          ++index;
        }
      } else
        index = 0;
      nums = _this._nums;
      if (nums != null) {
        names = Object.getOwnPropertyNames(nums);
        entries = names.length;
        for (i = 0; i < entries; ++i) {
          result[index] = +names[i];
          ++index;
        }
      }
      rest = _this._rest;
      if (rest != null) {
        names = Object.getOwnPropertyNames(rest);
        entries = names.length;
        for (i = 0; i < entries; ++i) {
          bucket = rest[names[i]];
          $length = bucket.length;
          for (i0 = 0; i0 < $length; i0 += 2) {
            result[index] = bucket[i0];
            ++index;
          }
        }
      }
      return _this._keys = result;
    },
    _addHashTableEntry$3: function(table, key, value) {
      var _this = this;
      H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(_this, 0));
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 1));
      if (table[key] == null) {
        ++_this._collection$_length;
        _this._keys = null;
      }
      P._HashMap__setTableEntry(table, key, value);
    },
    _getBucket$2: function(table, key) {
      return table[H.objectHashCode(key) & 1073741823];
    }
  };
  P._IdentityHashMap.prototype = {
    _findBucketIndex$2: function(bucket, key) {
      var $length, i, t1;
      if (bucket == null)
        return -1;
      $length = bucket.length;
      for (i = 0; i < $length; i += 2) {
        t1 = bucket[i];
        if (t1 == null ? key == null : t1 === key)
          return i;
      }
      return -1;
    }
  };
  P._HashMapKeyIterable.prototype = {
    get$length: function(_) {
      return this._map._collection$_length;
    },
    get$isEmpty: function(_) {
      return this._map._collection$_length === 0;
    },
    get$iterator: function(_) {
      var t1 = this._map;
      return new P._HashMapKeyIterator(t1, t1._computeKeys$0(), this.$ti);
    },
    contains$1: function(_, element) {
      return this._map.containsKey$1(element);
    }
  };
  P._HashMapKeyIterator.prototype = {
    get$current: function() {
      return this._collection$_current;
    },
    moveNext$0: function() {
      var _this = this,
        keys = _this._keys,
        offset = _this._offset,
        t1 = _this._map;
      if (keys !== t1._keys)
        throw H.wrapException(P.ConcurrentModificationError$(t1));
      else if (offset >= keys.length) {
        _this.set$_collection$_current(null);
        return false;
      } else {
        _this.set$_collection$_current(keys[offset]);
        _this._offset = offset + 1;
        return true;
      }
    },
    set$_collection$_current: function(_current) {
      this._collection$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  P._LinkedHashSet.prototype = {
    get$iterator: function(_) {
      var _this = this,
        t1 = new P._LinkedHashSetIterator(_this, _this._collection$_modifications, _this.$ti);
      t1._collection$_cell = _this._collection$_first;
      return t1;
    },
    get$length: function(_) {
      return this._collection$_length;
    },
    get$isEmpty: function(_) {
      return this._collection$_length === 0;
    },
    get$isNotEmpty: function(_) {
      return this._collection$_length !== 0;
    },
    contains$1: function(_, object) {
      var strings, nums;
      if (typeof object === "string" && object !== "__proto__") {
        strings = this._strings;
        if (strings == null)
          return false;
        return H.interceptedTypeCheck(strings[object], "$is_LinkedHashSetCell") != null;
      } else if (typeof object === "number" && (object & 1073741823) === object) {
        nums = this._nums;
        if (nums == null)
          return false;
        return H.interceptedTypeCheck(nums[object], "$is_LinkedHashSetCell") != null;
      } else
        return this._contains$1(object);
    },
    _contains$1: function(object) {
      var rest = this._rest;
      if (rest == null)
        return false;
      return this._findBucketIndex$2(this._getBucket$2(rest, object), object) >= 0;
    },
    add$1: function(_, element) {
      var strings, nums, _this = this;
      H.assertSubtypeOfRuntimeType(element, H.getTypeArgumentByIndex(_this, 0));
      if (typeof element === "string" && element !== "__proto__") {
        strings = _this._strings;
        return _this._addHashTableEntry$2(strings == null ? _this._strings = P._LinkedHashSet__newHashTable() : strings, element);
      } else if (typeof element === "number" && (element & 1073741823) === element) {
        nums = _this._nums;
        return _this._addHashTableEntry$2(nums == null ? _this._nums = P._LinkedHashSet__newHashTable() : nums, element);
      } else
        return _this._add$1(element);
    },
    _add$1: function(element) {
      var rest, hash, bucket, _this = this;
      H.assertSubtypeOfRuntimeType(element, H.getTypeArgumentByIndex(_this, 0));
      rest = _this._rest;
      if (rest == null)
        rest = _this._rest = P._LinkedHashSet__newHashTable();
      hash = _this._computeHashCode$1(element);
      bucket = rest[hash];
      if (bucket == null)
        rest[hash] = [_this._collection$_newLinkedCell$1(element)];
      else {
        if (_this._findBucketIndex$2(bucket, element) >= 0)
          return false;
        bucket.push(_this._collection$_newLinkedCell$1(element));
      }
      return true;
    },
    remove$1: function(_, object) {
      var _this = this;
      if (typeof object === "string" && object !== "__proto__")
        return _this._removeHashTableEntry$2(_this._strings, object);
      else if (typeof object === "number" && (object & 1073741823) === object)
        return _this._removeHashTableEntry$2(_this._nums, object);
      else
        return _this._remove$1(object);
    },
    _remove$1: function(object) {
      var bucket, index, _this = this,
        rest = _this._rest;
      if (rest == null)
        return false;
      bucket = _this._getBucket$2(rest, object);
      index = _this._findBucketIndex$2(bucket, object);
      if (index < 0)
        return false;
      _this._unlinkCell$1(bucket.splice(index, 1)[0]);
      return true;
    },
    _filterWhere$2: function(test, removeMatching) {
      var cell, element, next, modifications, t2, _this = this,
        t1 = H.getTypeArgumentByIndex(_this, 0);
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [t1]});
      cell = _this._collection$_first;
      for (; cell != null; cell = next) {
        element = H.assertSubtypeOfRuntimeType(cell._element, t1);
        next = cell._collection$_next;
        modifications = _this._collection$_modifications;
        t2 = test.call$1(element);
        if (modifications !== _this._collection$_modifications)
          throw H.wrapException(P.ConcurrentModificationError$(_this));
        if (false === t2)
          _this.remove$1(0, element);
      }
    },
    clear$0: function(_) {
      var _this = this;
      if (_this._collection$_length > 0) {
        _this._strings = _this._nums = _this._rest = _this._collection$_first = _this._collection$_last = null;
        _this._collection$_length = 0;
        _this._modified$0();
      }
    },
    _addHashTableEntry$2: function(table, element) {
      H.assertSubtypeOfRuntimeType(element, H.getTypeArgumentByIndex(this, 0));
      if (H.interceptedTypeCheck(table[element], "$is_LinkedHashSetCell") != null)
        return false;
      table[element] = this._collection$_newLinkedCell$1(element);
      return true;
    },
    _removeHashTableEntry$2: function(table, element) {
      var cell;
      if (table == null)
        return false;
      cell = H.interceptedTypeCheck(table[element], "$is_LinkedHashSetCell");
      if (cell == null)
        return false;
      this._unlinkCell$1(cell);
      delete table[element];
      return true;
    },
    _modified$0: function() {
      this._collection$_modifications = 1073741823 & this._collection$_modifications + 1;
    },
    _collection$_newLinkedCell$1: function(element) {
      var last, _this = this,
        cell = new P._LinkedHashSetCell(H.assertSubtypeOfRuntimeType(element, H.getTypeArgumentByIndex(_this, 0)));
      if (_this._collection$_first == null)
        _this._collection$_first = _this._collection$_last = cell;
      else {
        last = _this._collection$_last;
        cell._previous = last;
        _this._collection$_last = last._collection$_next = cell;
      }
      ++_this._collection$_length;
      _this._modified$0();
      return cell;
    },
    _unlinkCell$1: function(cell) {
      var _this = this,
        previous = cell._previous,
        next = cell._collection$_next;
      if (previous == null)
        _this._collection$_first = next;
      else
        previous._collection$_next = next;
      if (next == null)
        _this._collection$_last = previous;
      else
        next._previous = previous;
      --_this._collection$_length;
      _this._modified$0();
    },
    _computeHashCode$1: function(element) {
      return J.get$hashCode$(element) & 1073741823;
    },
    _getBucket$2: function(table, element) {
      return table[this._computeHashCode$1(element)];
    },
    _findBucketIndex$2: function(bucket, element) {
      var $length, i;
      if (bucket == null)
        return -1;
      $length = bucket.length;
      for (i = 0; i < $length; ++i)
        if (J.$eq$(bucket[i]._element, element))
          return i;
      return -1;
    },
    $isLinkedHashSet: 1
  };
  P._LinkedHashSetCell.prototype = {};
  P._LinkedHashSetIterator.prototype = {
    get$current: function() {
      return this._collection$_current;
    },
    moveNext$0: function() {
      var _this = this,
        t1 = _this._set;
      if (_this._collection$_modifications !== t1._collection$_modifications)
        throw H.wrapException(P.ConcurrentModificationError$(t1));
      else {
        t1 = _this._collection$_cell;
        if (t1 == null) {
          _this.set$_collection$_current(null);
          return false;
        } else {
          _this.set$_collection$_current(H.assertSubtypeOfRuntimeType(t1._element, H.getTypeArgumentByIndex(_this, 0)));
          _this._collection$_cell = _this._collection$_cell._collection$_next;
          return true;
        }
      }
    },
    set$_collection$_current: function(_current) {
      this._collection$_current = H.assertSubtypeOfRuntimeType(_current, H.getTypeArgumentByIndex(this, 0));
    },
    $isIterator: 1
  };
  P.UnmodifiableListView.prototype = {
    cast$1$0: function(_, $R) {
      return new P.UnmodifiableListView(J.cast$1$0$ax(this._collection$_source, $R), [$R]);
    },
    get$length: function(_) {
      return J.get$length$asx(this._collection$_source);
    },
    $index: function(_, index) {
      return J.elementAt$1$ax(this._collection$_source, index);
    }
  };
  P.IterableBase.prototype = {};
  P.ListBase.prototype = {$isEfficientLengthIterable: 1, $isIterable: 1, $isList: 1};
  P.ListMixin.prototype = {
    get$iterator: function(receiver) {
      return new H.ListIterator(receiver, this.get$length(receiver), [H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0)]);
    },
    elementAt$1: function(receiver, index) {
      return this.$index(receiver, index);
    },
    get$isEmpty: function(receiver) {
      return this.get$length(receiver) === 0;
    },
    get$isNotEmpty: function(receiver) {
      return !this.get$isEmpty(receiver);
    },
    get$first: function(receiver) {
      if (this.get$length(receiver) === 0)
        throw H.wrapException(H.IterableElementError_noElement());
      return this.$index(receiver, 0);
    },
    contains$1: function(receiver, element) {
      var i,
        $length = this.get$length(receiver);
      for (i = 0; i < $length; ++i) {
        if (J.$eq$(this.$index(receiver, i), element))
          return true;
        if ($length !== this.get$length(receiver))
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      return false;
    },
    every$1: function(receiver, test) {
      var $length, i, _this = this;
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0)]});
      $length = _this.get$length(receiver);
      for (i = 0; i < $length; ++i) {
        if (!H.boolConversionCheck(test.call$1(_this.$index(receiver, i))))
          return false;
        if ($length !== _this.get$length(receiver))
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      return true;
    },
    any$1: function(receiver, test) {
      var $length, i, _this = this;
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0)]});
      $length = _this.get$length(receiver);
      for (i = 0; i < $length; ++i) {
        if (H.boolConversionCheck(test.call$1(_this.$index(receiver, i))))
          return true;
        if ($length !== _this.get$length(receiver))
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      return false;
    },
    map$1$1: function(receiver, f, $T) {
      var t1 = H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0);
      return new H.MappedListIterable(receiver, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), [t1, $T]);
    },
    fold$1$2: function(receiver, initialValue, combine, $T) {
      var $length, value, i, _this = this;
      H.assertSubtypeOfRuntimeType(initialValue, $T);
      H.functionTypeCheck(combine, {func: 1, ret: $T, args: [$T, H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0)]});
      $length = _this.get$length(receiver);
      for (value = initialValue, i = 0; i < $length; ++i) {
        value = combine.call$2(value, _this.$index(receiver, i));
        if ($length !== _this.get$length(receiver))
          throw H.wrapException(P.ConcurrentModificationError$(receiver));
      }
      return value;
    },
    skip$1: function(receiver, count) {
      return H.SubListIterable$(receiver, count, null, H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0));
    },
    toList$1$growable: function(receiver, growable) {
      var result, i, _this = this,
        t1 = new Array(_this.get$length(receiver));
      t1.fixed$length = Array;
      result = H.setRuntimeTypeInfo(t1, [H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0)]);
      for (i = 0; i < _this.get$length(receiver); ++i)
        C.JSArray_methods.$indexSet(result, i, _this.$index(receiver, i));
      return result;
    },
    toSet$0: function(receiver) {
      var i,
        result = P.LinkedHashSet_LinkedHashSet(H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0));
      for (i = 0; i < this.get$length(receiver); ++i)
        result.add$1(0, this.$index(receiver, i));
      return result;
    },
    add$1: function(receiver, element) {
      var t1, _this = this;
      H.assertSubtypeOfRuntimeType(element, H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0));
      t1 = _this.get$length(receiver);
      _this.set$length(receiver, t1 + 1);
      _this.$indexSet(receiver, t1, element);
    },
    cast$1$0: function(receiver, $R) {
      return new H.CastList(receiver, [H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0), $R]);
    },
    sublist$2: function(receiver, start, end) {
      var $length, result, i,
        listLength = this.get$length(receiver);
      P.RangeError_checkValidRange(start, end, listLength);
      $length = end - start;
      result = H.setRuntimeTypeInfo([], [H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0)]);
      C.JSArray_methods.set$length(result, $length);
      for (i = 0; i < $length; ++i)
        C.JSArray_methods.$indexSet(result, i, this.$index(receiver, start + i));
      return result;
    },
    fillRange$3: function(receiver, start, end, fill) {
      var i;
      H.assertSubtypeOfRuntimeType(fill, H.getRuntimeTypeArgumentIntercepted(this, receiver, "ListMixin", 0));
      P.RangeError_checkValidRange(start, end, this.get$length(receiver));
      for (i = start; i < end; ++i)
        this.$indexSet(receiver, i, fill);
    },
    setRange$4: function(receiver, start, end, iterable, skipCount) {
      var $length, otherStart, otherList, i, _this = this,
        t1 = H.getRuntimeTypeArgumentIntercepted(_this, receiver, "ListMixin", 0);
      H.assertSubtype(iterable, "$isIterable", [t1], "$asIterable");
      P.RangeError_checkValidRange(start, end, _this.get$length(receiver));
      $length = end - start;
      if ($length === 0)
        return;
      P.RangeError_checkNotNegative(skipCount, "skipCount");
      if (H.checkSubtype(iterable, "$isList", [t1], "$asList")) {
        otherStart = skipCount;
        otherList = iterable;
      } else {
        otherList = J.skip$1$ax(iterable, skipCount).toList$1$growable(0, false);
        otherStart = 0;
      }
      t1 = J.getInterceptor$asx(otherList);
      if (otherStart + $length > t1.get$length(otherList))
        throw H.wrapException(H.IterableElementError_tooFew());
      if (otherStart < start)
        for (i = $length - 1; i >= 0; --i)
          _this.$indexSet(receiver, start + i, t1.$index(otherList, otherStart + i));
      else
        for (i = 0; i < $length; ++i)
          _this.$indexSet(receiver, start + i, t1.$index(otherList, otherStart + i));
    },
    indexOf$1: function(receiver, element) {
      var i;
      for (i = 0; i < this.get$length(receiver); ++i)
        if (J.$eq$(this.$index(receiver, i), element))
          return i;
      return -1;
    },
    toString$0: function(receiver) {
      return P.IterableBase_iterableToFullString(receiver, "[", "]");
    }
  };
  P.MapBase.prototype = {};
  P.MapBase_mapToString_closure.prototype = {
    call$2: function(k, v) {
      var t2,
        t1 = this._box_0;
      if (!t1.first)
        this.result._contents += ", ";
      t1.first = false;
      t1 = this.result;
      t2 = t1._contents += H.S(k);
      t1._contents = t2 + ": ";
      t1._contents += H.S(v);
    },
    $signature: 15
  };
  P.MapMixin.prototype = {
    cast$2$0: function(_, RK, RV) {
      return P.Map_castFrom(this, H.getRuntimeTypeArgument(this, "MapMixin", 0), H.getRuntimeTypeArgument(this, "MapMixin", 1), RK, RV);
    },
    forEach$1: function(_, action) {
      var t1, key, _this = this;
      H.functionTypeCheck(action, {func: 1, ret: -1, args: [H.getRuntimeTypeArgument(_this, "MapMixin", 0), H.getRuntimeTypeArgument(_this, "MapMixin", 1)]});
      for (t1 = _this.get$keys(), t1 = t1.get$iterator(t1); t1.moveNext$0();) {
        key = t1.get$current();
        action.call$2(key, _this.$index(0, key));
      }
    },
    get$entries: function() {
      var _this = this;
      return _this.get$keys().map$1$1(0, new P.MapMixin_entries_closure(_this), [P.MapEntry, H.getRuntimeTypeArgument(_this, "MapMixin", 0), H.getRuntimeTypeArgument(_this, "MapMixin", 1)]);
    },
    containsKey$1: function(key) {
      return this.get$keys().contains$1(0, key);
    },
    get$length: function(_) {
      var t1 = this.get$keys();
      return t1.get$length(t1);
    },
    get$isEmpty: function(_) {
      var t1 = this.get$keys();
      return t1.get$isEmpty(t1);
    },
    toString$0: function(_) {
      return P.MapBase_mapToString(this);
    },
    $isMap: 1
  };
  P.MapMixin_entries_closure.prototype = {
    call$1: function(key) {
      var t1 = this.$this,
        t2 = H.getRuntimeTypeArgument(t1, "MapMixin", 0);
      H.assertSubtypeOfRuntimeType(key, t2);
      return new P.MapEntry(key, t1.$index(0, key), [t2, H.getRuntimeTypeArgument(t1, "MapMixin", 1)]);
    },
    $signature: function() {
      var t1 = this.$this,
        t2 = H.getRuntimeTypeArgument(t1, "MapMixin", 0);
      return {func: 1, ret: [P.MapEntry, t2, H.getRuntimeTypeArgument(t1, "MapMixin", 1)], args: [t2]};
    }
  };
  P._UnmodifiableMapMixin.prototype = {
    $indexSet: function(_, key, value) {
      H.assertSubtypeOfRuntimeType(key, H.getRuntimeTypeArgument(this, "_UnmodifiableMapMixin", 0));
      H.assertSubtypeOfRuntimeType(value, H.getRuntimeTypeArgument(this, "_UnmodifiableMapMixin", 1));
      throw H.wrapException(P.UnsupportedError$("Cannot modify unmodifiable map"));
    }
  };
  P.MapView.prototype = {
    cast$2$0: function(_, RK, RV) {
      return this._map.cast$2$0(0, RK, RV);
    },
    $index: function(_, key) {
      return this._map.$index(0, key);
    },
    $indexSet: function(_, key, value) {
      this._map.$indexSet(0, H.assertSubtypeOfRuntimeType(key, H.getTypeArgumentByIndex(this, 0)), H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 1)));
    },
    containsKey$1: function(key) {
      return this._map.containsKey$1(key);
    },
    forEach$1: function(_, action) {
      this._map.forEach$1(0, H.functionTypeCheck(action, {func: 1, ret: -1, args: [H.getTypeArgumentByIndex(this, 0), H.getTypeArgumentByIndex(this, 1)]}));
    },
    get$isEmpty: function(_) {
      var t1 = this._map;
      return t1.get$isEmpty(t1);
    },
    get$length: function(_) {
      var t1 = this._map;
      return t1.get$length(t1);
    },
    get$keys: function() {
      return this._map.get$keys();
    },
    toString$0: function(_) {
      return this._map.toString$0(0);
    },
    $isMap: 1
  };
  P.UnmodifiableMapView.prototype = {
    cast$2$0: function(_, RK, RV) {
      return new P.UnmodifiableMapView(this._map.cast$2$0(0, RK, RV), [RK, RV]);
    }
  };
  P._SetBase.prototype = {
    get$isEmpty: function(_) {
      return this.get$length(this) === 0;
    },
    get$isNotEmpty: function(_) {
      return this.get$length(this) !== 0;
    },
    addAll$1: function(_, elements) {
      var t1;
      for (t1 = J.get$iterator$ax(H.assertSubtype(elements, "$isIterable", this.$ti, "$asIterable")); t1.moveNext$0();)
        this.add$1(0, t1.get$current());
    },
    toList$1$growable: function(_, growable) {
      var result, t2, i, i0, _this = this,
        t1 = _this.$ti;
      if (growable) {
        result = H.setRuntimeTypeInfo([], t1);
        C.JSArray_methods.set$length(result, _this.get$length(_this));
      } else {
        t2 = new Array(_this.get$length(_this));
        t2.fixed$length = Array;
        result = H.setRuntimeTypeInfo(t2, t1);
      }
      for (t1 = _this.get$iterator(_this), i = 0; t1.moveNext$0(); i = i0) {
        i0 = i + 1;
        C.JSArray_methods.$indexSet(result, i, t1.get$current());
      }
      return result;
    },
    map$1$1: function(_, f, $T) {
      var t1 = H.getTypeArgumentByIndex(this, 0);
      return new H.EfficientLengthMappedIterable(this, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), [t1, $T]);
    },
    toString$0: function(_) {
      return P.IterableBase_iterableToFullString(this, "{", "}");
    },
    every$1: function(_, f) {
      var t1;
      H.functionTypeCheck(f, {func: 1, ret: P.bool, args: [H.getTypeArgumentByIndex(this, 0)]});
      for (t1 = this.get$iterator(this); t1.moveNext$0();)
        if (!H.boolConversionCheck(f.call$1(t1.get$current())))
          return false;
      return true;
    },
    skip$1: function(_, n) {
      return H.SkipIterable_SkipIterable(this, n, H.getTypeArgumentByIndex(this, 0));
    },
    firstWhere$2$orElse: function(_, test, orElse) {
      var element,
        t1 = H.getTypeArgumentByIndex(this, 0);
      H.functionTypeCheck(test, {func: 1, ret: P.bool, args: [t1]});
      H.functionTypeCheck(orElse, {func: 1, ret: t1});
      for (t1 = this.get$iterator(this); t1.moveNext$0();) {
        element = t1.get$current();
        if (H.boolConversionCheck(test.call$1(element)))
          return element;
      }
      return orElse.call$0();
    },
    elementAt$1: function(_, index) {
      var t1, elementIndex, element;
      P.RangeError_checkNotNegative(index, "index");
      for (t1 = this.get$iterator(this), elementIndex = 0; t1.moveNext$0();) {
        element = t1.get$current();
        if (index === elementIndex)
          return element;
        ++elementIndex;
      }
      throw H.wrapException(P.IndexError$(index, this, "index", null, elementIndex));
    },
    $isEfficientLengthIterable: 1,
    $isIterable: 1,
    $isSet: 1
  };
  P._UnmodifiableSet.prototype = {
    contains$1: function(_, element) {
      return this._map.containsKey$1(element);
    },
    get$iterator: function(_) {
      var t1 = this._map.get$keys();
      return t1.get$iterator(t1);
    },
    get$length: function(_) {
      var t1 = this._map;
      return t1.get$length(t1);
    },
    add$1: function(_, value) {
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 0));
      throw H.wrapException(P.UnsupportedError$("Cannot change unmodifiable set"));
    }
  };
  P._ListBase_Object_ListMixin.prototype = {};
  P._UnmodifiableMapView_MapView__UnmodifiableMapMixin.prototype = {};
  P._JsonMap.prototype = {
    $index: function(_, key) {
      var result,
        t1 = this._processed;
      if (t1 == null)
        return this._data.$index(0, key);
      else if (typeof key !== "string")
        return;
      else {
        result = t1[key];
        return typeof result == "undefined" ? this._process$1(key) : result;
      }
    },
    get$length: function(_) {
      return this._processed == null ? this._data.__js_helper$_length : this._convert$_computeKeys$0().length;
    },
    get$isEmpty: function(_) {
      return this.get$length(this) === 0;
    },
    get$keys: function() {
      if (this._processed == null) {
        var t1 = this._data;
        return new H.LinkedHashMapKeyIterable(t1, [H.getTypeArgumentByIndex(t1, 0)]);
      }
      return new P._JsonMapKeyIterable(this);
    },
    $indexSet: function(_, key, value) {
      var processed, original, _this = this;
      if (_this._processed == null)
        _this._data.$indexSet(0, key, value);
      else if (_this.containsKey$1(key)) {
        processed = _this._processed;
        processed[key] = value;
        original = _this._original;
        if (original == null ? processed != null : original !== processed)
          original[key] = null;
      } else
        _this._upgrade$0().$indexSet(0, key, value);
    },
    containsKey$1: function(key) {
      if (this._processed == null)
        return this._data.containsKey$1(key);
      if (typeof key !== "string")
        return false;
      return Object.prototype.hasOwnProperty.call(this._original, key);
    },
    forEach$1: function(_, f) {
      var keys, i, key, value, _this = this;
      H.functionTypeCheck(f, {func: 1, ret: -1, args: [P.String,,]});
      if (_this._processed == null)
        return _this._data.forEach$1(0, f);
      keys = _this._convert$_computeKeys$0();
      for (i = 0; i < keys.length; ++i) {
        key = keys[i];
        value = _this._processed[key];
        if (typeof value == "undefined") {
          value = P._convertJsonToDartLazy(_this._original[key]);
          _this._processed[key] = value;
        }
        f.call$2(key, value);
        if (keys !== _this._data)
          throw H.wrapException(P.ConcurrentModificationError$(_this));
      }
    },
    _convert$_computeKeys$0: function() {
      var keys = H.listTypeCheck(this._data);
      if (keys == null)
        keys = this._data = H.setRuntimeTypeInfo(Object.keys(this._original), [P.String]);
      return keys;
    },
    _upgrade$0: function() {
      var result, keys, i, t1, key, _this = this;
      if (_this._processed == null)
        return _this._data;
      result = P.LinkedHashMap_LinkedHashMap$_empty(P.String, null);
      keys = _this._convert$_computeKeys$0();
      for (i = 0; t1 = keys.length, i < t1; ++i) {
        key = keys[i];
        result.$indexSet(0, key, _this.$index(0, key));
      }
      if (t1 === 0)
        C.JSArray_methods.add$1(keys, null);
      else
        C.JSArray_methods.set$length(keys, 0);
      _this._original = _this._processed = null;
      return _this._data = result;
    },
    _process$1: function(key) {
      var result;
      if (!Object.prototype.hasOwnProperty.call(this._original, key))
        return;
      result = P._convertJsonToDartLazy(this._original[key]);
      return this._processed[key] = result;
    },
    $asMapMixin: function() {
      return [P.String, null];
    },
    $asMap: function() {
      return [P.String, null];
    }
  };
  P._JsonMapKeyIterable.prototype = {
    get$length: function(_) {
      var t1 = this._convert$_parent;
      return t1.get$length(t1);
    },
    elementAt$1: function(_, index) {
      var t1 = this._convert$_parent;
      if (t1._processed == null)
        t1 = t1.get$keys().elementAt$1(0, index);
      else {
        t1 = t1._convert$_computeKeys$0();
        if (index < 0 || index >= t1.length)
          return H.ioore(t1, index);
        t1 = t1[index];
      }
      return t1;
    },
    get$iterator: function(_) {
      var t1 = this._convert$_parent;
      if (t1._processed == null) {
        t1 = t1.get$keys();
        t1 = t1.get$iterator(t1);
      } else {
        t1 = t1._convert$_computeKeys$0();
        t1 = new J.ArrayIterator(t1, t1.length, [H.getTypeArgumentByIndex(t1, 0)]);
      }
      return t1;
    },
    contains$1: function(_, key) {
      return this._convert$_parent.containsKey$1(key);
    },
    $asEfficientLengthIterable: function() {
      return [P.String];
    },
    $asListIterable: function() {
      return [P.String];
    },
    $asIterable: function() {
      return [P.String];
    }
  };
  P._JsonDecoderSink.prototype = {
    close$0: function() {
      var buffer, t1, t2, t3, _this = this;
      _this.super$_StringSinkConversionSink$close();
      buffer = _this._stringSink;
      t1 = buffer._contents;
      buffer._contents = "";
      t2 = _this._sink;
      t3 = t2._accumulated;
      C.JSArray_methods.add$1(t3, H.assertSubtypeOfRuntimeType(P._parseJson(t1.charCodeAt(0) == 0 ? t1 : t1, _this._reviver), H.getTypeArgumentByIndex(t2, 0)));
      t2._callback.call$1(t3);
    },
    $as_StringSinkConversionSink: function() {
      return [P.StringSink];
    },
    $asSink: function() {
      return [P.String];
    }
  };
  P.Base64Codec.prototype = {
    normalize$3: function(source, start, end) {
      var inverseAlphabet, i, sliceStart, buffer, firstPadding, firstPaddingSourceIndex, paddingCount, i0, char, i1, char0, value, t1, t2, endLength, $length,
        _s31_ = "Invalid base64 encoding length ";
      end = P.RangeError_checkValidRange(start, end, source.length);
      inverseAlphabet = $.$get$_Base64Decoder__inverseAlphabet();
      for (i = start, sliceStart = i, buffer = null, firstPadding = -1, firstPaddingSourceIndex = -1, paddingCount = 0; i < end; i = i0) {
        i0 = i + 1;
        char = C.JSString_methods._codeUnitAt$1(source, i);
        if (char === 37) {
          i1 = i0 + 2;
          if (i1 <= end) {
            char0 = H.parseHexByte(source, i0);
            if (char0 === 37)
              char0 = -1;
            i0 = i1;
          } else
            char0 = -1;
        } else
          char0 = char;
        if (0 <= char0 && char0 <= 127) {
          if (char0 < 0 || char0 >= inverseAlphabet.length)
            return H.ioore(inverseAlphabet, char0);
          value = inverseAlphabet[char0];
          if (value >= 0) {
            char0 = C.JSString_methods.codeUnitAt$1("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", value);
            if (char0 === char)
              continue;
            char = char0;
          } else {
            if (value === -1) {
              if (firstPadding < 0) {
                t1 = buffer == null ? null : buffer._contents.length;
                if (t1 == null)
                  t1 = 0;
                firstPadding = t1 + (i - sliceStart);
                firstPaddingSourceIndex = i;
              }
              ++paddingCount;
              if (char === 61)
                continue;
            }
            char = char0;
          }
          if (value !== -2) {
            if (buffer == null)
              buffer = new P.StringBuffer("");
            buffer._contents += C.JSString_methods.substring$2(source, sliceStart, i);
            buffer._contents += H.Primitives_stringFromCharCode(char);
            sliceStart = i0;
            continue;
          }
        }
        throw H.wrapException(P.FormatException$("Invalid base64 data", source, i));
      }
      if (buffer != null) {
        t1 = buffer._contents += C.JSString_methods.substring$2(source, sliceStart, end);
        t2 = t1.length;
        if (firstPadding >= 0)
          P.Base64Codec__checkPadding(source, firstPaddingSourceIndex, end, firstPadding, paddingCount, t2);
        else {
          endLength = C.JSInt_methods.$mod(t2 - 1, 4) + 1;
          if (endLength === 1)
            throw H.wrapException(P.FormatException$(_s31_, source, end));
          for (; endLength < 4;) {
            t1 += "=";
            buffer._contents = t1;
            ++endLength;
          }
        }
        t1 = buffer._contents;
        return C.JSString_methods.replaceRange$3(source, start, end, t1.charCodeAt(0) == 0 ? t1 : t1);
      }
      $length = end - start;
      if (firstPadding >= 0)
        P.Base64Codec__checkPadding(source, firstPaddingSourceIndex, end, firstPadding, paddingCount, $length);
      else {
        endLength = C.JSInt_methods.$mod($length, 4);
        if (endLength === 1)
          throw H.wrapException(P.FormatException$(_s31_, source, end));
        if (endLength > 1)
          source = C.JSString_methods.replaceRange$3(source, end, end, endLength === 2 ? "==" : "=");
      }
      return source;
    },
    $asCodec: function() {
      return [[P.List, P.int], P.String];
    }
  };
  P.Base64Encoder.prototype = {
    $asConverter: function() {
      return [[P.List, P.int], P.String];
    }
  };
  P.Base64Decoder.prototype = {
    convert$2: function(input, start) {
      var decoder, buffer, t1,
        end = P.RangeError_checkValidRange(start, null, input.length);
      if (start === end)
        return new Uint8Array(0);
      decoder = new P._Base64Decoder();
      buffer = decoder.decode$3(input, start, end);
      t1 = decoder._convert$_state;
      if (t1 < -1)
        H.throwExpression(P.FormatException$("Missing padding character", input, end));
      if (t1 > 0)
        H.throwExpression(P.FormatException$("Invalid length, must be multiple of four", input, end));
      decoder._convert$_state = -1;
      return buffer;
    },
    $asConverter: function() {
      return [P.String, [P.List, P.int]];
    }
  };
  P._Base64Decoder.prototype = {
    decode$3: function(input, start, end) {
      var buffer, _this = this,
        t1 = _this._convert$_state;
      if (t1 < 0) {
        _this._convert$_state = P._Base64Decoder__checkPadding(input, start, end, t1);
        return;
      }
      if (start === end)
        return new Uint8Array(0);
      buffer = P._Base64Decoder__allocateBuffer(input, start, end, t1);
      _this._convert$_state = P._Base64Decoder_decodeChunk(input, start, end, buffer, 0, _this._convert$_state);
      return buffer;
    }
  };
  P.ByteConversionSink.prototype = {
    $asChunkedConversionSink: function() {
      return [[P.List, P.int]];
    },
    $asSink: function() {
      return [[P.List, P.int]];
    }
  };
  P.ChunkedConversionSink.prototype = {$isSink: 1};
  P._SimpleCallbackSink.prototype = {};
  P.Codec.prototype = {};
  P.Converter.prototype = {};
  P.Encoding.prototype = {
    $asCodec: function() {
      return [P.String, [P.List, P.int]];
    }
  };
  P.JsonCodec.prototype = {
    decode$1: function(source) {
      var t1 = P._parseJson(source, this.get$decoder()._reviver);
      return t1;
    },
    get$decoder: function() {
      return C.JsonDecoder_null;
    },
    $asCodec: function() {
      return [P.Object, P.String];
    }
  };
  P.JsonDecoder.prototype = {
    $asConverter: function() {
      return [P.String, P.Object];
    }
  };
  P.StringConversionSinkBase.prototype = {};
  P.StringConversionSinkMixin.prototype = {$isSink: 1,
    $asSink: function() {
      return [P.String];
    }
  };
  P._StringSinkConversionSink.prototype = {
    close$0: function() {
    }
  };
  P._Utf8StringSinkAdapter.prototype = {
    close$0: function() {
      this._decoder.flush$0();
      this._sink.close$0();
    }
  };
  P.Utf8Codec.prototype = {};
  P.Utf8Decoder.prototype = {
    convert$1: function(codeUnits) {
      var result, end, oneBytes, firstPart, buffer, start, isFirstCharacter, decoder, t1;
      H.assertSubtype(codeUnits, "$isList", [P.int], "$asList");
      result = P.Utf8Decoder__convertIntercepted(false, codeUnits, 0, null);
      if (result != null)
        return result;
      end = P.RangeError_checkValidRange(0, null, J.get$length$asx(codeUnits));
      oneBytes = P._scanOneByteCharacters(codeUnits, 0, end);
      if (oneBytes > 0) {
        firstPart = P.String_String$fromCharCodes(codeUnits, 0, oneBytes);
        if (oneBytes === end)
          return firstPart;
        buffer = new P.StringBuffer(firstPart);
        start = oneBytes;
        isFirstCharacter = false;
      } else {
        start = 0;
        buffer = null;
        isFirstCharacter = true;
      }
      if (buffer == null)
        buffer = new P.StringBuffer("");
      decoder = new P._Utf8Decoder(false, buffer);
      decoder._isFirstCharacter = isFirstCharacter;
      decoder.convert$3(codeUnits, start, end);
      decoder.flush$2(codeUnits, end);
      t1 = buffer._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    $asConverter: function() {
      return [[P.List, P.int], P.String];
    }
  };
  P._Utf8Decoder.prototype = {
    flush$2: function(source, offset) {
      var t1;
      H.assertSubtype(source, "$isList", [P.int], "$asList");
      if (this._expectedUnits > 0) {
        t1 = P.FormatException$("Unfinished UTF-8 octet sequence", source, offset);
        throw H.wrapException(t1);
      }
    },
    flush$0: function() {
      return this.flush$2(null, null);
    },
    convert$3: function(codeUnits, startIndex, endIndex) {
      var value, expectedUnits, extraUnits, t1, t2, i, unit, t3, oneBytes, i0, i1, t4, _this = this,
        _s21_ = "Bad UTF-8 encoding 0x";
      H.assertSubtype(codeUnits, "$isList", [P.int], "$asList");
      value = _this._convert$_value;
      expectedUnits = _this._expectedUnits;
      extraUnits = _this._extraUnits;
      _this._extraUnits = _this._expectedUnits = _this._convert$_value = 0;
      $label0$0:
        for (t1 = J.getInterceptor$asx(codeUnits), t2 = _this._stringSink, i = startIndex; true; i = i1) {
          $label1$1:
            if (expectedUnits > 0) {
              do {
                if (i === endIndex)
                  break $label0$0;
                unit = t1.$index(codeUnits, i);
                if (typeof unit !== "number")
                  return unit.$and();
                if ((unit & 192) !== 128) {
                  t3 = P.FormatException$(_s21_ + C.JSInt_methods.toRadixString$1(unit, 16), codeUnits, i);
                  throw H.wrapException(t3);
                } else {
                  value = (value << 6 | unit & 63) >>> 0;
                  --expectedUnits;
                  ++i;
                }
              } while (expectedUnits > 0);
              t3 = extraUnits - 1;
              if (t3 < 0 || t3 >= 4)
                return H.ioore(C.List_127_2047_65535_1114111, t3);
              if (value <= C.List_127_2047_65535_1114111[t3]) {
                t3 = P.FormatException$("Overlong encoding of 0x" + C.JSInt_methods.toRadixString$1(value, 16), codeUnits, i - extraUnits - 1);
                throw H.wrapException(t3);
              }
              if (value > 1114111) {
                t3 = P.FormatException$("Character outside valid Unicode range: 0x" + C.JSInt_methods.toRadixString$1(value, 16), codeUnits, i - extraUnits - 1);
                throw H.wrapException(t3);
              }
              if (!_this._isFirstCharacter || value !== 65279)
                t2._contents += H.Primitives_stringFromCharCode(value);
              _this._isFirstCharacter = false;
            }
          for (t3 = i < endIndex; t3;) {
            oneBytes = P._scanOneByteCharacters(codeUnits, i, endIndex);
            if (oneBytes > 0) {
              _this._isFirstCharacter = false;
              i0 = i + oneBytes;
              t2._contents += P.String_String$fromCharCodes(codeUnits, i, i0);
              if (i0 === endIndex)
                break;
            } else
              i0 = i;
            i1 = i0 + 1;
            unit = t1.$index(codeUnits, i0);
            if (typeof unit !== "number")
              return unit.$lt();
            if (unit < 0) {
              t4 = P.FormatException$("Negative UTF-8 code unit: -0x" + C.JSInt_methods.toRadixString$1(-unit, 16), codeUnits, i1 - 1);
              throw H.wrapException(t4);
            } else {
              if ((unit & 224) === 192) {
                value = unit & 31;
                expectedUnits = 1;
                extraUnits = 1;
                continue $label0$0;
              }
              if ((unit & 240) === 224) {
                value = unit & 15;
                expectedUnits = 2;
                extraUnits = 2;
                continue $label0$0;
              }
              if ((unit & 248) === 240 && unit < 245) {
                value = unit & 7;
                expectedUnits = 3;
                extraUnits = 3;
                continue $label0$0;
              }
              t4 = P.FormatException$(_s21_ + C.JSInt_methods.toRadixString$1(unit, 16), codeUnits, i1 - 1);
              throw H.wrapException(t4);
            }
          }
          break $label0$0;
        }
      if (expectedUnits > 0) {
        _this._convert$_value = value;
        _this._expectedUnits = expectedUnits;
        _this._extraUnits = extraUnits;
      }
    }
  };
  P.NoSuchMethodError_toString_closure.prototype = {
    call$2: function(key, value) {
      var t1, t2, t3;
      H.interceptedTypeCheck(key, "$isSymbol0");
      t1 = this.sb;
      t2 = this._box_0;
      t1._contents += t2.comma;
      t3 = t1._contents += H.S(key.__internal$_name);
      t1._contents = t3 + ": ";
      t1._contents += P.Error_safeToString(value);
      t2.comma = ", ";
    },
    $signature: 46
  };
  P.bool.prototype = {};
  P.DateTime.prototype = {
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof P.DateTime && this._value === other._value && this.isUtc === other.isUtc;
    },
    get$hashCode: function(_) {
      var t1 = this._value;
      return (t1 ^ C.JSInt_methods._shrOtherPositive$1(t1, 30)) & 1073741823;
    },
    toUtc$0: function() {
      var t1, t2;
      if (this.isUtc)
        return this;
      t1 = this._value;
      if (Math.abs(t1) <= 864e13)
        t2 = false;
      else
        t2 = true;
      if (t2)
        H.throwExpression(P.ArgumentError$("DateTime is outside valid range: " + t1));
      return new P.DateTime(t1, true);
    },
    toString$0: function(_) {
      var _this = this,
        y = P.DateTime__fourDigits(H.Primitives_getYear(_this)),
        m = P.DateTime__twoDigits(H.Primitives_getMonth(_this)),
        d = P.DateTime__twoDigits(H.Primitives_getDay(_this)),
        h = P.DateTime__twoDigits(H.Primitives_getHours(_this)),
        min = P.DateTime__twoDigits(H.Primitives_getMinutes(_this)),
        sec = P.DateTime__twoDigits(H.Primitives_getSeconds(_this)),
        ms = P.DateTime__threeDigits(H.Primitives_getMilliseconds(_this));
      if (_this.isUtc)
        return y + "-" + m + "-" + d + " " + h + ":" + min + ":" + sec + "." + ms + "Z";
      else
        return y + "-" + m + "-" + d + " " + h + ":" + min + ":" + sec + "." + ms;
    },
    toIso8601String$0: function() {
      var _this = this,
        y = H.Primitives_getYear(_this) >= -9999 && H.Primitives_getYear(_this) <= 9999 ? P.DateTime__fourDigits(H.Primitives_getYear(_this)) : P.DateTime__sixDigits(H.Primitives_getYear(_this)),
        m = P.DateTime__twoDigits(H.Primitives_getMonth(_this)),
        d = P.DateTime__twoDigits(H.Primitives_getDay(_this)),
        h = P.DateTime__twoDigits(H.Primitives_getHours(_this)),
        min = P.DateTime__twoDigits(H.Primitives_getMinutes(_this)),
        sec = P.DateTime__twoDigits(H.Primitives_getSeconds(_this)),
        ms = P.DateTime__threeDigits(H.Primitives_getMilliseconds(_this));
      if (_this.isUtc)
        return y + "-" + m + "-" + d + "T" + h + ":" + min + ":" + sec + "." + ms + "Z";
      else
        return y + "-" + m + "-" + d + "T" + h + ":" + min + ":" + sec + "." + ms;
    }
  };
  P.double.prototype = {};
  P.Error.prototype = {};
  P.AssertionError.prototype = {
    toString$0: function(_) {
      return "Assertion failed";
    }
  };
  P.NullThrownError.prototype = {
    toString$0: function(_) {
      return "Throw of null.";
    }
  };
  P.ArgumentError.prototype = {
    get$_errorName: function() {
      return "Invalid argument" + (!this._hasValue ? "(s)" : "");
    },
    get$_errorExplanation: function() {
      return "";
    },
    toString$0: function(_) {
      var message, prefix, explanation, errorValue, _this = this,
        t1 = _this.name,
        nameString = t1 != null ? " (" + t1 + ")" : "";
      t1 = _this.message;
      message = t1 == null ? "" : ": " + H.S(t1);
      prefix = _this.get$_errorName() + nameString + message;
      if (!_this._hasValue)
        return prefix;
      explanation = _this.get$_errorExplanation();
      errorValue = P.Error_safeToString(_this.invalidValue);
      return prefix + explanation + ": " + errorValue;
    }
  };
  P.RangeError.prototype = {
    get$_errorName: function() {
      return "RangeError";
    },
    get$_errorExplanation: function() {
      var explanation, t2,
        t1 = this.start;
      if (t1 == null) {
        t1 = this.end;
        explanation = t1 != null ? ": Not less than or equal to " + H.S(t1) : "";
      } else {
        t2 = this.end;
        if (t2 == null)
          explanation = ": Not greater than or equal to " + H.S(t1);
        else if (t2 > t1)
          explanation = ": Not in range " + H.S(t1) + ".." + H.S(t2) + ", inclusive";
        else
          explanation = t2 < t1 ? ": Valid value range is empty" : ": Only valid value is " + H.S(t1);
      }
      return explanation;
    }
  };
  P.IndexError.prototype = {
    get$_errorName: function() {
      return "RangeError";
    },
    get$_errorExplanation: function() {
      var t1,
        invalidValue = H.intTypeCheck(this.invalidValue);
      if (typeof invalidValue !== "number")
        return invalidValue.$lt();
      if (invalidValue < 0)
        return ": index must not be negative";
      t1 = this.length;
      if (t1 === 0)
        return ": no indices are valid";
      return ": index should be less than " + t1;
    },
    get$length: function(receiver) {
      return this.length;
    }
  };
  P.NoSuchMethodError.prototype = {
    toString$0: function(_) {
      var t1, t2, _i, t3, t4, argument, receiverText, actualParameters, _this = this, _box_0 = {},
        sb = new P.StringBuffer("");
      _box_0.comma = "";
      for (t1 = _this._core$_arguments, t2 = t1.length, _i = 0, t3 = "", t4 = ""; _i < t2; ++_i, t4 = ", ") {
        argument = t1[_i];
        sb._contents = t3 + t4;
        t3 = sb._contents += P.Error_safeToString(argument);
        _box_0.comma = ", ";
      }
      _this._namedArguments.forEach$1(0, new P.NoSuchMethodError_toString_closure(_box_0, sb));
      receiverText = P.Error_safeToString(_this._core$_receiver);
      actualParameters = sb.toString$0(0);
      t1 = "NoSuchMethodError: method not found: '" + H.S(_this._core$_memberName.__internal$_name) + "'\nReceiver: " + receiverText + "\nArguments: [" + actualParameters + "]";
      return t1;
    }
  };
  P.UnsupportedError.prototype = {
    toString$0: function(_) {
      return "Unsupported operation: " + this.message;
    }
  };
  P.UnimplementedError.prototype = {
    toString$0: function(_) {
      var t1 = this.message;
      return t1 != null ? "UnimplementedError: " + t1 : "UnimplementedError";
    }
  };
  P.StateError.prototype = {
    toString$0: function(_) {
      return "Bad state: " + this.message;
    }
  };
  P.ConcurrentModificationError.prototype = {
    toString$0: function(_) {
      var t1 = this.modifiedObject;
      if (t1 == null)
        return "Concurrent modification during iteration.";
      return "Concurrent modification during iteration: " + P.Error_safeToString(t1) + ".";
    }
  };
  P.OutOfMemoryError.prototype = {
    toString$0: function(_) {
      return "Out of Memory";
    },
    $isError: 1
  };
  P.StackOverflowError.prototype = {
    toString$0: function(_) {
      return "Stack Overflow";
    },
    $isError: 1
  };
  P.CyclicInitializationError.prototype = {
    toString$0: function(_) {
      var t1 = this.variableName;
      return t1 == null ? "Reading static variable during its initialization" : "Reading static variable '" + t1 + "' during its initialization";
    }
  };
  P._Exception.prototype = {
    toString$0: function(_) {
      return "Exception: " + this.message;
    },
    $isException: 1
  };
  P.FormatException.prototype = {
    toString$0: function(_) {
      var source, lineNum, lineStart, previousCharWasCR, i, char, lineEnd, end, start, prefix, postfix, slice,
        t1 = this.message,
        report = t1 != null && "" !== t1 ? "FormatException: " + H.S(t1) : "FormatException",
        offset = this.offset,
        objectSource = this.source;
      if (typeof objectSource === "string") {
        if (offset != null)
          t1 = offset < 0 || offset > objectSource.length;
        else
          t1 = false;
        if (t1)
          offset = null;
        if (offset == null) {
          source = objectSource.length > 78 ? C.JSString_methods.substring$2(objectSource, 0, 75) + "..." : objectSource;
          return report + "\n" + source;
        }
        for (lineNum = 1, lineStart = 0, previousCharWasCR = false, i = 0; i < offset; ++i) {
          char = C.JSString_methods._codeUnitAt$1(objectSource, i);
          if (char === 10) {
            if (lineStart !== i || !previousCharWasCR)
              ++lineNum;
            lineStart = i + 1;
            previousCharWasCR = false;
          } else if (char === 13) {
            ++lineNum;
            lineStart = i + 1;
            previousCharWasCR = true;
          }
        }
        report = lineNum > 1 ? report + (" (at line " + lineNum + ", character " + (offset - lineStart + 1) + ")\n") : report + (" (at character " + (offset + 1) + ")\n");
        lineEnd = objectSource.length;
        for (i = offset; i < lineEnd; ++i) {
          char = C.JSString_methods.codeUnitAt$1(objectSource, i);
          if (char === 10 || char === 13) {
            lineEnd = i;
            break;
          }
        }
        if (lineEnd - lineStart > 78)
          if (offset - lineStart < 75) {
            end = lineStart + 75;
            start = lineStart;
            prefix = "";
            postfix = "...";
          } else {
            if (lineEnd - offset < 75) {
              start = lineEnd - 75;
              end = lineEnd;
              postfix = "";
            } else {
              start = offset - 36;
              end = offset + 36;
              postfix = "...";
            }
            prefix = "...";
          }
        else {
          end = lineEnd;
          start = lineStart;
          prefix = "";
          postfix = "";
        }
        slice = C.JSString_methods.substring$2(objectSource, start, end);
        return report + prefix + slice + postfix + "\n" + C.JSString_methods.$mul(" ", offset - start + prefix.length) + "^\n";
      } else
        return offset != null ? report + (" (at offset " + H.S(offset) + ")") : report;
    },
    $isException: 1
  };
  P.Function.prototype = {};
  P.int.prototype = {};
  P.Iterable.prototype = {
    cast$1$0: function(_, $R) {
      return H.CastIterable_CastIterable(this, H.getRuntimeTypeArgument(this, "Iterable", 0), $R);
    },
    map$1$1: function(_, f, $T) {
      var t1 = H.getRuntimeTypeArgument(this, "Iterable", 0);
      return H.MappedIterable_MappedIterable(this, H.functionTypeCheck(f, {func: 1, ret: $T, args: [t1]}), t1, $T);
    },
    contains$1: function(_, element) {
      var t1;
      for (t1 = this.get$iterator(this); t1.moveNext$0();)
        if (J.$eq$(t1.get$current(), element))
          return true;
      return false;
    },
    toList$1$growable: function(_, growable) {
      return P.List_List$from(this, false, H.getRuntimeTypeArgument(this, "Iterable", 0));
    },
    get$length: function(_) {
      var count,
        it = this.get$iterator(this);
      for (count = 0; it.moveNext$0();)
        ++count;
      return count;
    },
    get$isEmpty: function(_) {
      return !this.get$iterator(this).moveNext$0();
    },
    get$isNotEmpty: function(_) {
      return !this.get$isEmpty(this);
    },
    skip$1: function(_, count) {
      return H.SkipIterable_SkipIterable(this, count, H.getRuntimeTypeArgument(this, "Iterable", 0));
    },
    elementAt$1: function(_, index) {
      var t1, elementIndex, element;
      P.RangeError_checkNotNegative(index, "index");
      for (t1 = this.get$iterator(this), elementIndex = 0; t1.moveNext$0();) {
        element = t1.get$current();
        if (index === elementIndex)
          return element;
        ++elementIndex;
      }
      throw H.wrapException(P.IndexError$(index, this, "index", null, elementIndex));
    },
    toString$0: function(_) {
      return P.IterableBase_iterableToShortString(this, "(", ")");
    }
  };
  P._GeneratorIterable.prototype = {
    elementAt$1: function(_, index) {
      var $length = this.length;
      if (0 > index || index >= $length)
        H.throwExpression(P.IndexError$(index, this, "index", null, $length));
      return this._generator.call$1(index);
    },
    get$length: function(receiver) {
      return this.length;
    }
  };
  P.Iterator.prototype = {};
  P.List.prototype = {$isEfficientLengthIterable: 1, $isIterable: 1};
  P.Map.prototype = {};
  P.MapEntry.prototype = {
    toString$0: function(_) {
      return "MapEntry(" + H.S(this.key) + ": " + H.S(this.value) + ")";
    }
  };
  P.Null.prototype = {
    get$hashCode: function(_) {
      return P.Object.prototype.get$hashCode.call(this, this);
    },
    toString$0: function(_) {
      return "null";
    }
  };
  P.num.prototype = {};
  P.Object.prototype = {constructor: P.Object, $isObject: 1,
    $eq: function(_, other) {
      return this === other;
    },
    get$hashCode: function(_) {
      return H.Primitives_objectHashCode(this);
    },
    toString$0: function(_) {
      return "Instance of '" + H.S(H.Primitives_objectTypeName(this)) + "'";
    },
    noSuchMethod$1: function(_, invocation) {
      H.interceptedTypeCheck(invocation, "$isInvocation");
      throw H.wrapException(P.NoSuchMethodError$(this, invocation.get$memberName(), invocation.get$positionalArguments(), invocation.get$namedArguments()));
    },
    toString: function() {
      return this.toString$0(this);
    }
  };
  P.Set.prototype = {};
  P.StackTrace.prototype = {};
  P.String.prototype = {$isPattern: 1};
  P.StringBuffer.prototype = {
    get$length: function(_) {
      return this._contents.length;
    },
    toString$0: function(_) {
      var t1 = this._contents;
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    $isStringSink: 1
  };
  P.StringSink.prototype = {};
  P.Symbol0.prototype = {};
  P.Type.prototype = {};
  P.Uri.prototype = {};
  P.Uri__parseIPv4Address_error.prototype = {
    call$2: function(msg, position) {
      throw H.wrapException(P.FormatException$("Illegal IPv4 address, " + msg, this.host, position));
    },
    $signature: 50
  };
  P.Uri_parseIPv6Address_error.prototype = {
    call$2: function(msg, position) {
      throw H.wrapException(P.FormatException$("Illegal IPv6 address, " + msg, this.host, position));
    },
    call$1: function(msg) {
      return this.call$2(msg, null);
    },
    $signature: 53
  };
  P.Uri_parseIPv6Address_parseHex.prototype = {
    call$2: function(start, end) {
      var value;
      if (end - start > 4)
        this.error.call$2("an IPv6 part can only contain a maximum of 4 hex digits", start);
      value = P.int_parse(C.JSString_methods.substring$2(this.host, start, end), null, 16);
      if (typeof value !== "number")
        return value.$lt();
      if (value < 0 || value > 65535)
        this.error.call$2("each part must be in the range of `0x0..0xFFFF`", start);
      return value;
    },
    $signature: 54
  };
  P._Uri.prototype = {
    get$userInfo: function() {
      return this._userInfo;
    },
    get$host: function() {
      var t1 = this._host;
      if (t1 == null)
        return "";
      if (C.JSString_methods.startsWith$1(t1, "["))
        return C.JSString_methods.substring$2(t1, 1, t1.length - 1);
      return t1;
    },
    get$port: function() {
      var t1 = this._port;
      if (t1 == null)
        return P._Uri__defaultPort(this.scheme);
      return t1;
    },
    get$query: function() {
      var t1 = this._query;
      return t1 == null ? "" : t1;
    },
    get$fragment: function() {
      var t1 = this._fragment;
      return t1 == null ? "" : t1;
    },
    get$hasScheme: function() {
      return this.scheme.length !== 0;
    },
    get$hasAuthority: function() {
      return this._host != null;
    },
    get$hasQuery: function() {
      return this._query != null;
    },
    get$hasFragment: function() {
      return this._fragment != null;
    },
    get$hasAbsolutePath: function() {
      return C.JSString_methods.startsWith$1(this.path, "/");
    },
    toString$0: function(_) {
      var t2, t3, t4, _this = this,
        t1 = _this._text;
      if (t1 == null) {
        t1 = _this.scheme;
        t2 = t1.length !== 0 ? t1 + ":" : "";
        t3 = _this._host;
        t4 = t3 == null;
        if (!t4 || t1 === "file") {
          t1 = t2 + "//";
          t2 = _this._userInfo;
          if (t2.length !== 0)
            t1 = t1 + H.S(t2) + "@";
          if (!t4)
            t1 += t3;
          t2 = _this._port;
          if (t2 != null)
            t1 = t1 + ":" + H.S(t2);
        } else
          t1 = t2;
        t1 += _this.path;
        t2 = _this._query;
        if (t2 != null)
          t1 = t1 + "?" + t2;
        t2 = _this._fragment;
        if (t2 != null)
          t1 = t1 + "#" + t2;
        t1 = _this._text = t1.charCodeAt(0) == 0 ? t1 : t1;
      }
      return t1;
    },
    $eq: function(_, other) {
      var t1, t2, _this = this;
      if (other == null)
        return false;
      if (_this === other)
        return true;
      if (!!J.getInterceptor$(other).$isUri)
        if (_this.scheme === other.get$scheme())
          if (_this._host != null === other.get$hasAuthority())
            if (_this._userInfo == other.get$userInfo())
              if (_this.get$host() == other.get$host())
                if (_this.get$port() == other.get$port())
                  if (_this.path === other.get$path()) {
                    t1 = _this._query;
                    t2 = t1 == null;
                    if (!t2 === other.get$hasQuery()) {
                      if (t2)
                        t1 = "";
                      if (t1 === other.get$query()) {
                        t1 = _this._fragment;
                        t2 = t1 == null;
                        if (!t2 === other.get$hasFragment()) {
                          if (t2)
                            t1 = "";
                          t1 = t1 === other.get$fragment();
                        } else
                          t1 = false;
                      } else
                        t1 = false;
                    } else
                      t1 = false;
                  } else
                    t1 = false;
                else
                  t1 = false;
              else
                t1 = false;
            else
              t1 = false;
          else
            t1 = false;
        else
          t1 = false;
      else
        t1 = false;
      return t1;
    },
    get$hashCode: function(_) {
      var t1 = this._hashCodeCache;
      return t1 == null ? this._hashCodeCache = C.JSString_methods.get$hashCode(this.toString$0(0)) : t1;
    },
    $isUri: 1,
    get$scheme: function() {
      return this.scheme;
    },
    get$path: function() {
      return this.path;
    }
  };
  P._Uri__Uri$notSimple_closure.prototype = {
    call$1: function(_) {
      throw H.wrapException(P.FormatException$("Invalid port", this.uri, this.portStart + 1));
    },
    $signature: 60
  };
  P.UriData.prototype = {
    get$uri: function(_) {
      var t2, queryIndex, end, query, _this = this, _null = null,
        t1 = _this._uriCache;
      if (t1 != null)
        return t1;
      t1 = _this._separatorIndices;
      if (0 >= t1.length)
        return H.ioore(t1, 0);
      t2 = _this._text;
      t1 = t1[0] + 1;
      queryIndex = C.JSString_methods.indexOf$2(t2, "?", t1);
      end = t2.length;
      if (queryIndex >= 0) {
        query = P._Uri__normalizeOrSubstring(t2, queryIndex + 1, end, C.List_CVk, false);
        end = queryIndex;
      } else
        query = _null;
      return _this._uriCache = new P._DataUri("data", _null, _null, _null, P._Uri__normalizeOrSubstring(t2, t1, end, C.List_qg4, false), query, _null);
    },
    get$mimeType: function() {
      var start, end,
        t1 = this._separatorIndices,
        t2 = t1.length;
      if (0 >= t2)
        return H.ioore(t1, 0);
      start = t1[0] + 1;
      if (1 >= t2)
        return H.ioore(t1, 1);
      end = t1[1];
      if (start === end)
        return "text/plain";
      return P._Uri__uriDecode(this._text, start, end, C.C_Utf8Codec, false);
    },
    contentAsBytes$0: function() {
      var $length, i, result, t2, index, codeUnit, index0, i0, byte,
        text = this._text,
        t1 = this._separatorIndices,
        start = C.JSArray_methods.get$last(t1) + 1;
      if ((t1.length & 1) === 1)
        return C.C_Base64Decoder.convert$2(text, start);
      t1 = text.length;
      $length = t1 - start;
      for (i = start; i < t1; ++i)
        if (C.JSString_methods.codeUnitAt$1(text, i) === 37) {
          i += 2;
          $length -= 2;
        }
      result = new Uint8Array($length);
      if ($length === t1) {
        C.NativeUint8List_methods.setRange$4(result, 0, $length, new H.CodeUnits(text), start);
        return result;
      }
      for (t2 = result.length, i = start, index = 0; i < t1; ++i) {
        codeUnit = C.JSString_methods.codeUnitAt$1(text, i);
        if (codeUnit !== 37) {
          index0 = index + 1;
          if (index >= t2)
            return H.ioore(result, index);
          result[index] = codeUnit;
        } else {
          i0 = i + 2;
          if (i0 < t1) {
            byte = H.parseHexByte(text, i + 1);
            if (byte >= 0) {
              index0 = index + 1;
              if (index >= t2)
                return H.ioore(result, index);
              result[index] = byte;
              i = i0;
              index = index0;
              continue;
            }
          }
          throw H.wrapException(P.FormatException$("Invalid percent escape", text, i));
        }
        index = index0;
      }
      return result;
    },
    toString$0: function(_) {
      var t2,
        t1 = this._separatorIndices;
      if (0 >= t1.length)
        return H.ioore(t1, 0);
      t2 = this._text;
      return t1[0] === -1 ? "data:" + t2 : t2;
    }
  };
  P._createTables_closure.prototype = {
    call$1: function(_) {
      return new Uint8Array(96);
    },
    $signature: 62
  };
  P._createTables_build.prototype = {
    call$2: function(state, defaultTransition) {
      var t1 = this.tables;
      if (state >= t1.length)
        return H.ioore(t1, state);
      t1 = t1[state];
      J.fillRange$3$x(t1, 0, 96, defaultTransition);
      return t1;
    },
    $signature: 63
  };
  P._createTables_setChars.prototype = {
    call$3: function(target, chars, transition) {
      var t1, t2, i, t3;
      for (t1 = chars.length, t2 = target.length, i = 0; i < t1; ++i) {
        t3 = C.JSString_methods._codeUnitAt$1(chars, i) ^ 96;
        if (t3 >= t2)
          return H.ioore(target, t3);
        target[t3] = transition;
      }
    }
  };
  P._createTables_setRange.prototype = {
    call$3: function(target, range, transition) {
      var i, n, t1, t2;
      for (i = C.JSString_methods._codeUnitAt$1(range, 0), n = C.JSString_methods._codeUnitAt$1(range, 1), t1 = target.length; i <= n; ++i) {
        t2 = (i ^ 96) >>> 0;
        if (t2 >= t1)
          return H.ioore(target, t2);
        target[t2] = transition;
      }
    }
  };
  P._SimpleUri.prototype = {
    get$hasScheme: function() {
      return this._schemeEnd > 0;
    },
    get$hasAuthority: function() {
      return this._hostStart > 0;
    },
    get$hasQuery: function() {
      var t1 = this._queryStart;
      if (typeof t1 !== "number")
        return t1.$lt();
      return t1 < this._fragmentStart;
    },
    get$hasFragment: function() {
      return this._fragmentStart < this._uri.length;
    },
    get$_isHttp: function() {
      return this._schemeEnd === 4 && C.JSString_methods.startsWith$1(this._uri, "http");
    },
    get$_isHttps: function() {
      return this._schemeEnd === 5 && C.JSString_methods.startsWith$1(this._uri, "https");
    },
    get$hasAbsolutePath: function() {
      return C.JSString_methods.startsWith$2(this._uri, "/", this._pathStart);
    },
    get$scheme: function() {
      var t2, _this = this, _s4_ = "file",
        _s7_ = "package",
        t1 = _this._schemeEnd;
      if (t1 <= 0)
        return "";
      t2 = _this._schemeCache;
      if (t2 != null)
        return t2;
      if (_this.get$_isHttp())
        t1 = _this._schemeCache = "http";
      else if (_this.get$_isHttps()) {
        _this._schemeCache = "https";
        t1 = "https";
      } else if (t1 === 4 && C.JSString_methods.startsWith$1(_this._uri, _s4_)) {
        _this._schemeCache = _s4_;
        t1 = _s4_;
      } else if (t1 === 7 && C.JSString_methods.startsWith$1(_this._uri, _s7_)) {
        _this._schemeCache = _s7_;
        t1 = _s7_;
      } else {
        t1 = C.JSString_methods.substring$2(_this._uri, 0, t1);
        _this._schemeCache = t1;
      }
      return t1;
    },
    get$userInfo: function() {
      var t1 = this._hostStart,
        t2 = this._schemeEnd + 3;
      return t1 > t2 ? C.JSString_methods.substring$2(this._uri, t2, t1 - 1) : "";
    },
    get$host: function() {
      var t1 = this._hostStart;
      return t1 > 0 ? C.JSString_methods.substring$2(this._uri, t1, this._portStart) : "";
    },
    get$port: function() {
      var t1, t2, _this = this;
      if (_this._hostStart > 0) {
        t1 = _this._portStart;
        if (typeof t1 !== "number")
          return t1.$add();
        t2 = _this._pathStart;
        if (typeof t2 !== "number")
          return H.iae(t2);
        t2 = t1 + 1 < t2;
        t1 = t2;
      } else
        t1 = false;
      if (t1) {
        t1 = _this._portStart;
        if (typeof t1 !== "number")
          return t1.$add();
        return P.int_parse(C.JSString_methods.substring$2(_this._uri, t1 + 1, _this._pathStart), null, null);
      }
      if (_this.get$_isHttp())
        return 80;
      if (_this.get$_isHttps())
        return 443;
      return 0;
    },
    get$path: function() {
      return C.JSString_methods.substring$2(this._uri, this._pathStart, this._queryStart);
    },
    get$query: function() {
      var t1 = this._queryStart,
        t2 = this._fragmentStart;
      if (typeof t1 !== "number")
        return t1.$lt();
      return t1 < t2 ? C.JSString_methods.substring$2(this._uri, t1 + 1, t2) : "";
    },
    get$fragment: function() {
      var t1 = this._fragmentStart,
        t2 = this._uri;
      return t1 < t2.length ? C.JSString_methods.substring$1(t2, t1 + 1) : "";
    },
    get$hashCode: function(_) {
      var t1 = this._hashCodeCache;
      return t1 == null ? this._hashCodeCache = C.JSString_methods.get$hashCode(this._uri) : t1;
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      if (this === other)
        return true;
      return !!J.getInterceptor$(other).$isUri && this._uri === other.toString$0(0);
    },
    toString$0: function(_) {
      return this._uri;
    },
    $isUri: 1
  };
  P._DataUri.prototype = {};
  P._convertDataTree__convert.prototype = {
    call$1: function(o) {
      var t2, convertedMap, key, convertedList,
        t1 = this._convertedObjects;
      if (t1.containsKey$1(o))
        return t1.$index(0, o);
      t2 = J.getInterceptor$(o);
      if (!!t2.$isMap) {
        convertedMap = {};
        t1.$indexSet(0, o, convertedMap);
        for (t1 = o.get$keys(), t1 = t1.get$iterator(t1); t1.moveNext$0();) {
          key = t1.get$current();
          convertedMap[key] = this.call$1(o.$index(0, key));
        }
        return convertedMap;
      } else if (!!t2.$isIterable) {
        convertedList = [];
        t1.$indexSet(0, o, convertedList);
        C.JSArray_methods.addAll$1(convertedList, t2.map$1$1(o, this, null));
        return convertedList;
      } else
        return o;
    },
    $signature: 4
  };
  P.Uint8List.prototype = {$isEfficientLengthIterable: 1,
    $asEfficientLengthIterable: function() {
      return [P.int];
    },
    $isIterable: 1,
    $asIterable: function() {
      return [P.int];
    },
    $isList: 1,
    $asList: function() {
      return [P.int];
    }
  };
  M.Accessor.prototype = {
    get$_isMatrixWithGaps: function() {
      var t2,
        t1 = this.componentType;
      if (t1 === 5121 || t1 === 5120) {
        t2 = this.type;
        t2 = t2 === "MAT2" || t2 === "MAT3";
      } else
        t2 = false;
      if (!t2)
        t1 = (t1 === 5123 || t1 === 5122) && this.type === "MAT3";
      else
        t1 = true;
      return t1;
    },
    get$components: function() {
      var t1 = C.Map_A1ato.$index(0, this.type);
      return t1 == null ? 0 : t1;
    },
    get$elementLength: function() {
      var _this = this,
        t1 = _this.componentType;
      if (t1 === 5121 || t1 === 5120) {
        t1 = _this.type;
        if (t1 === "MAT2")
          return 6;
        else if (t1 === "MAT3")
          return 11;
        return _this.get$components();
      } else if (t1 === 5123 || t1 === 5122) {
        if (_this.type === "MAT3")
          return 22;
        return 2 * _this.get$components();
      }
      return 4 * _this.get$components();
    },
    get$byteStride: function() {
      var _this = this,
        t1 = _this._byteStride;
      if (t1 !== 0)
        return t1;
      t1 = _this.componentType;
      if (t1 === 5121 || t1 === 5120) {
        t1 = _this.type;
        if (t1 === "MAT2")
          return 8;
        else if (t1 === "MAT3")
          return 12;
        return _this.get$components();
      } else if (t1 === 5123 || t1 === 5122) {
        if (_this.type === "MAT3")
          return 24;
        return 2 * _this.get$components();
      }
      return 4 * _this.get$components();
    },
    get$byteLength: function() {
      return this.get$byteStride() * (this.count - 1) + this.get$elementLength();
    },
    link$2: function(gltf, context) {
      var t4, t5, t6, indices, _this = this,
        _s10_ = "bufferView",
        t1 = gltf.bufferViews,
        t2 = _this._accessor$_bufferViewIndex,
        t3 = H.interceptedTypeCheck(t1.$index(0, t2), "$isBufferView");
      _this._bufferView = t3;
      t4 = t3 == null;
      if (!t4 && t3.byteStride !== -1)
        _this._byteStride = t3.byteStride;
      if (_this.componentType === -1 || _this.count === -1 || _this.type == null)
        return;
      if (t2 !== -1)
        if (t4)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t2], [P.Object]), _s10_);
        else {
          t3._isUsed = true;
          t3 = t3.byteStride;
          if (t3 !== -1 && t3 < _this.get$elementLength())
            context.addIssue$2$args($.$get$LinkError_accessorSmallStride(), H.setRuntimeTypeInfo([_this._bufferView.byteStride, _this.get$elementLength()], [P.Object]));
          M.Accessor__checkByteOffsetAndLength(_this.byteOffset, _this.componentLength, _this.get$byteLength(), _this._bufferView, t2, context);
        }
      t2 = _this.sparse;
      if (t2 != null) {
        t3 = t2.count;
        if (t3 !== -1)
          t4 = false;
        else
          t4 = true;
        if (t4)
          return;
        t4 = context.path;
        C.JSArray_methods.add$1(t4, "sparse");
        t5 = _this.count;
        if (t3 > t5)
          context.addIssue$3$args$name($.$get$SemanticError_accessorSparseCountOutOfRange(), H.setRuntimeTypeInfo([t3, t5], [P.Object]), "count");
        t5 = t2.values;
        t6 = t5._accessor$_bufferViewIndex;
        t5._bufferView = H.interceptedTypeCheck(t1.$index(0, t6), "$isBufferView");
        C.JSArray_methods.add$1(t4, "indices");
        indices = t2.indices;
        t2 = indices._accessor$_bufferViewIndex;
        if (t2 !== -1) {
          t1 = H.interceptedTypeCheck(t1.$index(0, t2), "$isBufferView");
          indices._bufferView = t1;
          if (t1 == null)
            context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t2], [P.Object]), _s10_);
          else {
            t1.setUsage$3(C.BufferViewUsage_Other, _s10_, context);
            if (indices._bufferView.byteStride !== -1)
              context.addIssue$2$name($.$get$SemanticError_bufferViewInvalidByteStride(), _s10_);
            t1 = indices.componentType;
            if (t1 !== -1)
              M.Accessor__checkByteOffsetAndLength(indices.byteOffset, Z.componentTypeLength(t1), Z.componentTypeLength(t1) * t3, indices._bufferView, t2, context);
          }
        }
        if (0 >= t4.length)
          return H.ioore(t4, -1);
        t4.pop();
        C.JSArray_methods.add$1(t4, "values");
        if (t6 !== -1) {
          t1 = t5._bufferView;
          if (t1 == null)
            context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t6], [P.Object]), _s10_);
          else {
            t1.setUsage$3(C.BufferViewUsage_Other, _s10_, context);
            if (t5._bufferView.byteStride !== -1)
              context.addIssue$2$name($.$get$SemanticError_bufferViewInvalidByteStride(), _s10_);
            t1 = _this.componentLength;
            t2 = C.Map_A1ato.$index(0, _this.type);
            if (t2 == null)
              t2 = 0;
            M.Accessor__checkByteOffsetAndLength(t5.byteOffset, t1, t1 * t2 * t3, t5._bufferView, t6, context);
          }
        }
        if (0 >= t4.length)
          return H.ioore(t4, -1);
        t4.pop();
        if (0 >= t4.length)
          return H.ioore(t4, -1);
        t4.pop();
      }
    },
    setUsage$3: function(value, $name, context) {
      var t1;
      this._isUsed = true;
      t1 = this._accessor$_usage;
      if (t1 == null)
        this._accessor$_usage = value;
      else if (t1 !== value)
        context.addIssue$3$args$name($.$get$LinkError_accessorUsageOverride(), H.setRuntimeTypeInfo([t1, value], [P.Object]), $name);
    },
    trySetInterpolation$1$cubic: function(cubic) {
      var t1 = this._containsCubicSpline;
      if (t1 == null)
        this._containsCubicSpline = cubic;
      else if (t1 !== cubic)
        return false;
      return true;
    },
    normalizeValue$1: function(value) {
      var width, t1, _this = this;
      H.numTypeCheck(value);
      if (!_this.normalized || 5126 === _this.componentType) {
        value.toString;
        return value;
      }
      width = _this.componentLength * 8;
      t1 = _this.componentType;
      if (t1 === 5120 || t1 === 5122 || t1 === 5124) {
        t1 = C.JSInt_methods.$shl(1, width - 1);
        if (typeof value !== "number")
          return value.$div();
        return Math.max(value / (t1 - 1), -1);
      } else {
        t1 = C.JSInt_methods.$shl(1, width);
        if (typeof value !== "number")
          return value.$div();
        return value / (t1 - 1);
      }
    }
  };
  M._AccessorInt.prototype = {
    getElements$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, components, t2, t3, t4, t5, view, $length, rowCount, elements, t6, t7, t8, t9, indices, values, t1;
        return function $async$getElements$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.componentType;
                if (t1 === -1 || $async$self.count === -1 || $async$self.type == null) {
                  // goto return
                  $async$goto = 1;
                  break;
                }
                components = $async$self.get$components();
                t2 = $async$self.count;
                t3 = $async$self._bufferView;
                if (t3 != null) {
                  t3 = t3._buffer;
                  if ((t3 == null ? null : t3.data) == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  if ($async$self.get$byteStride() < $async$self.get$elementLength()) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t3 = $async$self.byteOffset;
                  t4 = $async$self.componentLength;
                  if (!M.Accessor__checkByteOffsetAndLength(t3, t4, $async$self.get$byteLength(), $async$self._bufferView, null, null)) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t5 = $async$self._bufferView;
                  view = M.Accessor__typedViewInt(t1, t5._buffer.data.buffer, t5.byteOffset + t3, C.JSInt_methods.$tdiv($async$self.get$byteLength(), t4));
                  if (view == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  $length = view.length;
                  if ($async$self.get$_isMatrixWithGaps()) {
                    t3 = C.JSInt_methods.$tdiv($async$self.get$byteStride(), t4);
                    t4 = $async$self.type === "MAT2";
                    t5 = t4 ? 8 : 12;
                    rowCount = t4 ? 2 : 3;
                    elements = new M._AccessorInt_getElements_closure($length, view, rowCount, rowCount, t3 - t5).call$0();
                  } else
                    elements = new M._AccessorInt_getElements_closure0(view).call$3($length, components, C.JSInt_methods.$tdiv($async$self.get$byteStride(), t4) - components);
                } else
                  elements = P.Iterable_Iterable$generate(t2 * components, new M._AccessorInt_getElements_closure1(), P.int);
                t3 = $async$self.sparse;
                if (t3 != null) {
                  t4 = t3.values;
                  t5 = t4.byteOffset;
                  if (t5 !== -1) {
                    t6 = t4._bufferView;
                    if (t6 != null)
                      if (t6.byteLength !== -1)
                        if (t6.byteOffset !== -1) {
                          t6 = t6._buffer;
                          if ((t6 == null ? null : t6.data) != null) {
                            t6 = t3.indices;
                            if (t6.componentType !== -1)
                              if (t6.byteOffset !== -1) {
                                t6 = t6._bufferView;
                                if (t6 != null)
                                  if (t6.byteLength !== -1)
                                    if (t6.byteOffset !== -1) {
                                      t6 = t6._buffer;
                                      t6 = (t6 == null ? null : t6.data) == null;
                                    } else
                                      t6 = true;
                                  else
                                    t6 = true;
                                else
                                  t6 = true;
                              } else
                                t6 = true;
                            else
                              t6 = true;
                          } else
                            t6 = true;
                        } else
                          t6 = true;
                      else
                        t6 = true;
                    else
                      t6 = true;
                  } else
                    t6 = true;
                  if (t6) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t6 = t3.count;
                  if (t6 > t2) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t2 = t3.indices;
                  t3 = t2.byteOffset;
                  t7 = t2.componentType;
                  if (M.Accessor__checkByteOffsetAndLength(t3, Z.componentTypeLength(t7), Z.componentTypeLength(t7) * t6, t2._bufferView, null, null)) {
                    t8 = $async$self.componentLength;
                    t9 = C.Map_A1ato.$index(0, $async$self.type);
                    if (t9 == null)
                      t9 = 0;
                    t9 = !M.Accessor__checkByteOffsetAndLength(t5, t8, t8 * t9 * t6, t4._bufferView, null, null);
                    t8 = t9;
                  } else
                    t8 = true;
                  if (t8) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t2 = t2._bufferView;
                  indices = M.Accessor__typedViewIndices(t7, t2._buffer.data.buffer, t2.byteOffset + t3, t6);
                  t4 = t4._bufferView;
                  values = M.Accessor__typedViewInt(t1, t4._buffer.data.buffer, t4.byteOffset + t5, t6 * components);
                  if (indices == null || values == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  elements = new M._AccessorInt_getElements_closure2($async$self, indices, elements, components, values).call$0();
                }
                $async$goto = 3;
                return P._IterationMarker_yieldStar(elements);
              case 3:
                // after yield
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.int);
    },
    getElementsNormalized$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 1, $async$currentError, t2, t3, t4, width, t1;
        return function $async$getElementsNormalized$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                width = $async$self.componentLength * 8;
                t1 = $async$self.componentType;
                t1 = t1 === 5120 || t1 === 5122 || t1 === 5124;
                t2 = P.double;
                $async$goto = t1 ? 2 : 4;
                break;
              case 2:
                // then
                t1 = C.JSInt_methods.$shl(1, width - 1);
                t3 = $async$self.getElements$0();
                t3.toString;
                t4 = H.getRuntimeTypeArgument(t3, "Iterable", 0);
                $async$goto = 5;
                return P._IterationMarker_yieldStar(H.MappedIterable_MappedIterable(t3, H.functionTypeCheck(new M._AccessorInt_getElementsNormalized_closure(1 / (t1 - 1)), {func: 1, ret: t2, args: [t4]}), t4, t2));
              case 5:
                // after yield
                // goto join
                $async$goto = 3;
                break;
              case 4:
                // else
                t1 = C.JSInt_methods.$shl(1, width);
                t3 = $async$self.getElements$0();
                t3.toString;
                t4 = H.getRuntimeTypeArgument(t3, "Iterable", 0);
                $async$goto = 6;
                return P._IterationMarker_yieldStar(H.MappedIterable_MappedIterable(t3, H.functionTypeCheck(new M._AccessorInt_getElementsNormalized_closure0(1 / (t1 - 1)), {func: 1, ret: t2, args: [t4]}), t4, t2));
              case 6:
                // after yield
              case 3:
                // join
                // implicit return
                return P._IterationMarker_endOfIteration();
              case 1:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.double);
    },
    $asAccessor: function() {
      return [P.int];
    }
  };
  M._AccessorInt_getElements_closure.prototype = {
    call$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, t1, t2, t3, t4, t5, t6, index, rowIndex, columnIndex;
        return function $async$call$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.length, t2 = $async$self.rowCount, t3 = $async$self.view, t4 = t3.length, t5 = $async$self.columnCount, t6 = $async$self.skip, index = 0, rowIndex = 0, columnIndex = 0;
              case 3:
                // for condition
                if (!(index < t1)) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                if (index < 0 || index >= t4) {
                  H.ioore(t3, index);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 5;
                return t3[index];
              case 5:
                // after yield
                ++index;
                ++rowIndex;
                if (rowIndex === t2) {
                  index += 4 - rowIndex;
                  ++columnIndex;
                  if (columnIndex === t5) {
                    index += t6;
                    columnIndex = 0;
                  }
                  rowIndex = 0;
                }
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.int);
    },
    $signature: 17
  };
  M._AccessorInt_getElements_closure0.prototype = {
    call$3: function($async$$length, $async$components, $async$skip) {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $length = $async$$length,
          components = $async$components,
          skip = $async$skip;
        var $async$goto = 0, $async$handler = 2, $async$currentError, t1, t2, index, componentIndex;
        return function $async$call$3($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.view, t2 = t1.length, index = 0, componentIndex = 0;
              case 3:
                // for condition
                if (!(index < $length)) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                if (index < 0 || index >= t2) {
                  H.ioore(t1, index);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 5;
                return t1[index];
              case 5:
                // after yield
                ++index;
                ++componentIndex;
                if (componentIndex === components) {
                  index += skip;
                  componentIndex = 0;
                }
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.int);
    }
  };
  M._AccessorInt_getElements_closure1.prototype = {
    call$1: function(_) {
      H.intTypeCheck(_);
      return 0;
    },
    $signature: 18
  };
  M._AccessorInt_getElements_closure2.prototype = {
    call$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, sparseIndex, t3, t4, t5, t6, t7, index, componentIndex, sparsePosition, t8, t1, t2;
        return function $async$call$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.indices;
                t2 = t1.length;
                if (0 >= t2) {
                  H.ioore(t1, 0);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                sparseIndex = t1[0];
                t3 = J.get$iterator$ax($async$self.baseElements), t4 = $async$self.components, t5 = $async$self.$this.sparse, t6 = $async$self.values, t7 = t6.length, index = 0, componentIndex = 0, sparsePosition = 0;
              case 3:
                // for condition
                if (!t3.moveNext$0()) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                t8 = t3.get$current();
                if (componentIndex === t4) {
                  if (index === sparseIndex && sparsePosition !== t5.count - 1) {
                    ++sparsePosition;
                    if (sparsePosition >= t2) {
                      H.ioore(t1, sparsePosition);
                      // goto return
                      $async$goto = 1;
                      break;
                    }
                    sparseIndex = t1[sparsePosition];
                  }
                  ++index;
                  componentIndex = 0;
                }
                $async$goto = index === sparseIndex ? 5 : 7;
                break;
              case 5:
                // then
                t8 = sparsePosition * t4 + componentIndex;
                if (t8 >= t7) {
                  H.ioore(t6, t8);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 8;
                return t6[t8];
              case 8:
                // after yield
                // goto join
                $async$goto = 6;
                break;
              case 7:
                // else
                $async$goto = 9;
                return t8;
              case 9:
                // after yield
              case 6:
                // join
                ++componentIndex;
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.int);
    },
    $signature: 17
  };
  M._AccessorInt_getElementsNormalized_closure.prototype = {
    call$1: function(value) {
      H.intTypeCheck(value);
      if (typeof value !== "number")
        return value.$mul();
      return Math.max(value * this.denom, -1);
    },
    $signature: 5
  };
  M._AccessorInt_getElementsNormalized_closure0.prototype = {
    call$1: function(value) {
      H.intTypeCheck(value);
      if (typeof value !== "number")
        return value.$mul();
      return value * this.denom;
    },
    $signature: 5
  };
  M._AccessorFloat.prototype = {
    getElements$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, components, t2, t3, t4, t5, view, $length, rowCount, elements, t6, t7, t8, t9, indices, values, t1;
        return function $async$getElements$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.componentType;
                if (t1 === -1 || $async$self.count === -1 || $async$self.type == null) {
                  // goto return
                  $async$goto = 1;
                  break;
                }
                components = $async$self.get$components();
                t2 = $async$self.count;
                t3 = $async$self._bufferView;
                if (t3 != null) {
                  t3 = t3._buffer;
                  if ((t3 == null ? null : t3.data) == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  if ($async$self.get$byteStride() < $async$self.get$elementLength()) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t3 = $async$self.byteOffset;
                  t4 = $async$self.componentLength;
                  if (!M.Accessor__checkByteOffsetAndLength(t3, t4, $async$self.get$byteLength(), $async$self._bufferView, null, null)) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t5 = $async$self._bufferView;
                  view = M.Accessor__typedViewFloat(t1, t5._buffer.data.buffer, t5.byteOffset + t3, C.JSInt_methods.$tdiv($async$self.get$byteLength(), t4));
                  if (view == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  $length = view.length;
                  if ($async$self.get$_isMatrixWithGaps()) {
                    t3 = C.JSInt_methods.$tdiv($async$self.get$byteStride(), t4);
                    t4 = $async$self.type === "MAT2";
                    t5 = t4 ? 8 : 12;
                    rowCount = t4 ? 2 : 3;
                    elements = new M._AccessorFloat_getElements_closure($length, view, rowCount, rowCount, t3 - t5).call$0();
                  } else
                    elements = new M._AccessorFloat_getElements_closure0(view).call$3($length, components, C.JSInt_methods.$tdiv($async$self.get$byteStride(), t4) - components);
                } else
                  elements = P.Iterable_Iterable$generate(t2 * components, new M._AccessorFloat_getElements_closure1(), P.double);
                t3 = $async$self.sparse;
                if (t3 != null) {
                  t4 = t3.values;
                  t5 = t4.byteOffset;
                  if (t5 !== -1) {
                    t6 = t4._bufferView;
                    if (t6 != null)
                      if (t6.byteLength !== -1)
                        if (t6.byteOffset !== -1) {
                          t6 = t6._buffer;
                          if ((t6 == null ? null : t6.data) != null) {
                            t6 = t3.indices;
                            if (t6.componentType !== -1)
                              if (t6.byteOffset !== -1) {
                                t6 = t6._bufferView;
                                if (t6 != null)
                                  if (t6.byteLength !== -1)
                                    if (t6.byteOffset !== -1) {
                                      t6 = t6._buffer;
                                      t6 = (t6 == null ? null : t6.data) == null;
                                    } else
                                      t6 = true;
                                  else
                                    t6 = true;
                                else
                                  t6 = true;
                              } else
                                t6 = true;
                            else
                              t6 = true;
                          } else
                            t6 = true;
                        } else
                          t6 = true;
                      else
                        t6 = true;
                    else
                      t6 = true;
                  } else
                    t6 = true;
                  if (t6) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t6 = t3.count;
                  if (t6 > t2) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t2 = t3.indices;
                  t3 = t2.byteOffset;
                  t7 = t2.componentType;
                  if (M.Accessor__checkByteOffsetAndLength(t3, Z.componentTypeLength(t7), Z.componentTypeLength(t7) * t6, t2._bufferView, null, null)) {
                    t8 = $async$self.componentLength;
                    t9 = C.Map_A1ato.$index(0, $async$self.type);
                    if (t9 == null)
                      t9 = 0;
                    t9 = !M.Accessor__checkByteOffsetAndLength(t5, t8, t8 * t9 * t6, t4._bufferView, null, null);
                    t8 = t9;
                  } else
                    t8 = true;
                  if (t8) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  t2 = t2._bufferView;
                  indices = M.Accessor__typedViewIndices(t7, t2._buffer.data.buffer, t2.byteOffset + t3, t6);
                  t4 = t4._bufferView;
                  values = M.Accessor__typedViewFloat(t1, t4._buffer.data.buffer, t4.byteOffset + t5, t6 * components);
                  if (indices == null || values == null) {
                    // goto return
                    $async$goto = 1;
                    break;
                  }
                  elements = new M._AccessorFloat_getElements_closure2($async$self, indices, elements, components, values).call$0();
                }
                $async$goto = 3;
                return P._IterationMarker_yieldStar(elements);
              case 3:
                // after yield
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.double);
    },
    getElementsNormalized$0: function() {
      return this.getElements$0();
    },
    $asAccessor: function() {
      return [P.double];
    }
  };
  M._AccessorFloat_getElements_closure.prototype = {
    call$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, t1, t2, t3, t4, t5, t6, index, rowIndex, columnIndex;
        return function $async$call$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.length, t2 = $async$self.rowCount, t3 = $async$self.view, t4 = t3.length, t5 = $async$self.columnCount, t6 = $async$self.skip, index = 0, rowIndex = 0, columnIndex = 0;
              case 3:
                // for condition
                if (!(index < t1)) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                if (index < 0 || index >= t4) {
                  H.ioore(t3, index);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 5;
                return t3[index];
              case 5:
                // after yield
                ++index;
                ++rowIndex;
                if (rowIndex === t2) {
                  index += 4 - rowIndex;
                  ++columnIndex;
                  if (columnIndex === t5) {
                    index += t6;
                    columnIndex = 0;
                  }
                  rowIndex = 0;
                }
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.double);
    },
    $signature: 19
  };
  M._AccessorFloat_getElements_closure0.prototype = {
    call$3: function($async$$length, $async$components, $async$skip) {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $length = $async$$length,
          components = $async$components,
          skip = $async$skip;
        var $async$goto = 0, $async$handler = 2, $async$currentError, t1, t2, index, componentIndex;
        return function $async$call$3($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.view, t2 = t1.length, index = 0, componentIndex = 0;
              case 3:
                // for condition
                if (!(index < $length)) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                if (index < 0 || index >= t2) {
                  H.ioore(t1, index);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 5;
                return t1[index];
              case 5:
                // after yield
                ++index;
                ++componentIndex;
                if (componentIndex === components) {
                  index += skip;
                  componentIndex = 0;
                }
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.double);
    }
  };
  M._AccessorFloat_getElements_closure1.prototype = {
    call$1: function(_) {
      H.intTypeCheck(_);
      return 0;
    },
    $signature: 5
  };
  M._AccessorFloat_getElements_closure2.prototype = {
    call$0: function() {
      var $async$self = this;
      return P._makeSyncStarIterable(function() {
        var $async$goto = 0, $async$handler = 2, $async$currentError, sparseIndex, t3, t4, t5, t6, t7, index, componentIndex, sparsePosition, t8, t1, t2;
        return function $async$call$0($async$errorCode, $async$result) {
          if ($async$errorCode === 1) {
            $async$currentError = $async$result;
            $async$goto = $async$handler;
          }
          while (true)
            switch ($async$goto) {
              case 0:
                // Function start
                t1 = $async$self.indices;
                t2 = t1.length;
                if (0 >= t2) {
                  H.ioore(t1, 0);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                sparseIndex = t1[0];
                t3 = J.get$iterator$ax($async$self.baseElements), t4 = $async$self.components, t5 = $async$self.$this.sparse, t6 = $async$self.values, t7 = t6.length, index = 0, componentIndex = 0, sparsePosition = 0;
              case 3:
                // for condition
                if (!t3.moveNext$0()) {
                  // goto after for
                  $async$goto = 4;
                  break;
                }
                t8 = t3.get$current();
                if (componentIndex === t4) {
                  if (index === sparseIndex && sparsePosition !== t5.count - 1) {
                    ++sparsePosition;
                    if (sparsePosition >= t2) {
                      H.ioore(t1, sparsePosition);
                      // goto return
                      $async$goto = 1;
                      break;
                    }
                    sparseIndex = t1[sparsePosition];
                  }
                  ++index;
                  componentIndex = 0;
                }
                $async$goto = index === sparseIndex ? 5 : 7;
                break;
              case 5:
                // then
                t8 = sparsePosition * t4 + componentIndex;
                if (t8 >= t7) {
                  H.ioore(t6, t8);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                $async$goto = 8;
                return t6[t8];
              case 8:
                // after yield
                // goto join
                $async$goto = 6;
                break;
              case 7:
                // else
                $async$goto = 9;
                return t8;
              case 9:
                // after yield
              case 6:
                // join
                ++componentIndex;
                // goto for condition
                $async$goto = 3;
                break;
              case 4:
                // after for
              case 1:
                // return
                return P._IterationMarker_endOfIteration();
              case 2:
                // rethrow
                return P._IterationMarker_uncaughtError($async$currentError);
            }
        };
      }, P.double);
    },
    $signature: 19
  };
  M.AccessorSparse.prototype = {
    get$indicesTypedView: function() {
      var t1 = this.indices,
        t2 = t1._bufferView,
        t3 = t2 == null ? null : t2._buffer;
      if ((t3 == null ? null : t3.data) == null)
        return;
      return M.Accessor__typedViewIndices(t1.componentType, t2._buffer.data.buffer, t2.byteOffset + t1.byteOffset, this.count);
    }
  };
  M.AccessorSparseIndices.prototype = {
    link$2: function(gltf, context) {
      this._bufferView = H.interceptedTypeCheck(gltf.bufferViews.$index(0, this._accessor$_bufferViewIndex), "$isBufferView");
    }
  };
  M.AccessorSparseValues.prototype = {
    link$2: function(gltf, context) {
      this._bufferView = H.interceptedTypeCheck(gltf.bufferViews.$index(0, this._accessor$_bufferViewIndex), "$isBufferView");
    }
  };
  M.InvalidFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      value.toString;
      if (value == 1 / 0 || value == -1 / 0 || isNaN(value)) {
        context.addIssue$3$args$name($.$get$DataError_accessorInvalidFloat(), H.setRuntimeTypeInfo([index, value], [P.Object]), this.path);
        return false;
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  M.MinFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, _this = this;
      if (index !== componentIndex) {
        t1 = _this._computedMin;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        t1 = t1[componentIndex];
        if (typeof t1 !== "number")
          return t1.$gt();
        if (typeof value !== "number")
          return H.iae(value);
        t1 = t1 > value;
      } else
        t1 = true;
      if (t1)
        C.JSArray_methods.$indexSet(_this._computedMin, componentIndex, value);
      t1 = _this._providedMin;
      if (componentIndex >= t1.length)
        return H.ioore(t1, componentIndex);
      t1 = t1[componentIndex];
      if (typeof value !== "number")
        return value.$lt();
      if (typeof t1 !== "number")
        return H.iae(t1);
      if (value < t1) {
        t1 = _this._invalidMinCount;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        C.JSArray_methods.$indexSet(t1, componentIndex, t1[componentIndex] + 1);
      }
      return true;
    },
    done$1: function(context) {
      var t1, t2, t3, t4, t5, t6, t7, c, t8, t9, t10, _this = this;
      for (t1 = _this._computedMin, t2 = t1.length, t3 = _this._providedMin, t4 = _this._invalidMinCount, t5 = t4.length, t6 = _this.path, t7 = [P.Object], c = 0; c < t2; ++c) {
        if (c >= t3.length)
          return H.ioore(t3, c);
        if (!J.$eq$(t3[c], t1[c])) {
          t8 = $.$get$DataError_accessorMinMismatch();
          t9 = t6 + "/min/" + c;
          if (c >= t3.length)
            return H.ioore(t3, c);
          context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t3[c], t1[c]], t7), t9);
          if (c >= t5)
            return H.ioore(t4, c);
          if (t4[c] > 0) {
            t8 = $.$get$DataError_accessorElementOutOfMinBound();
            t9 = t6 + "/min/" + c;
            t10 = t4[c];
            if (c >= t3.length)
              return H.ioore(t3, c);
            context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t10, t3[c]], t7), t9);
          }
        }
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  M.MaxFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, _this = this;
      if (index !== componentIndex) {
        t1 = _this._computedMax;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        t1 = t1[componentIndex];
        if (typeof t1 !== "number")
          return t1.$lt();
        if (typeof value !== "number")
          return H.iae(value);
        t1 = t1 < value;
      } else
        t1 = true;
      if (t1)
        C.JSArray_methods.$indexSet(_this._computedMax, componentIndex, value);
      t1 = _this._providedMax;
      if (componentIndex >= t1.length)
        return H.ioore(t1, componentIndex);
      t1 = t1[componentIndex];
      if (typeof value !== "number")
        return value.$gt();
      if (typeof t1 !== "number")
        return H.iae(t1);
      if (value > t1) {
        t1 = _this._invalidMaxCount;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        C.JSArray_methods.$indexSet(t1, componentIndex, t1[componentIndex] + 1);
      }
      return true;
    },
    done$1: function(context) {
      var t1, t2, t3, t4, t5, t6, t7, c, t8, t9, t10, _this = this;
      for (t1 = _this._computedMax, t2 = t1.length, t3 = _this._providedMax, t4 = _this._invalidMaxCount, t5 = t4.length, t6 = _this.path, t7 = [P.Object], c = 0; c < t2; ++c) {
        if (c >= t3.length)
          return H.ioore(t3, c);
        if (!J.$eq$(t3[c], t1[c])) {
          t8 = $.$get$DataError_accessorMaxMismatch();
          t9 = t6 + "/max/" + c;
          if (c >= t3.length)
            return H.ioore(t3, c);
          context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t3[c], t1[c]], t7), t9);
          if (c >= t5)
            return H.ioore(t4, c);
          if (t4[c] > 0) {
            t8 = $.$get$DataError_accessorElementOutOfMaxBound();
            t9 = t6 + "/max/" + c;
            t10 = t4[c];
            if (c >= t3.length)
              return H.ioore(t3, c);
            context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t10, t3[c]], t7), t9);
          }
        }
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  M.MinIntegerChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, _this = this;
      H.intTypeCheck(value);
      if (index !== componentIndex) {
        t1 = _this._computedMin;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        t1 = t1[componentIndex];
        if (typeof t1 !== "number")
          return t1.$gt();
        if (typeof value !== "number")
          return H.iae(value);
        t1 = t1 > value;
      } else
        t1 = true;
      if (t1)
        C.JSArray_methods.$indexSet(_this._computedMin, componentIndex, value);
      t1 = _this._providedMin;
      if (componentIndex >= t1.length)
        return H.ioore(t1, componentIndex);
      t1 = t1[componentIndex];
      if (typeof value !== "number")
        return value.$lt();
      if (typeof t1 !== "number")
        return H.iae(t1);
      if (value < t1) {
        t1 = _this._invalidMinCount;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        C.JSArray_methods.$indexSet(t1, componentIndex, t1[componentIndex] + 1);
      }
      return true;
    },
    done$1: function(context) {
      var t1, t2, t3, t4, t5, t6, t7, c, t8, t9, t10, _this = this;
      for (t1 = _this._computedMin, t2 = t1.length, t3 = _this._providedMin, t4 = _this._invalidMinCount, t5 = t4.length, t6 = _this.path, t7 = [P.Object], c = 0; c < t2; ++c) {
        if (c >= t3.length)
          return H.ioore(t3, c);
        if (!J.$eq$(t3[c], t1[c])) {
          t8 = $.$get$DataError_accessorMinMismatch();
          t9 = t6 + "/min/" + c;
          if (c >= t3.length)
            return H.ioore(t3, c);
          context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t3[c], t1[c]], t7), t9);
          if (c >= t5)
            return H.ioore(t4, c);
          if (t4[c] > 0) {
            t8 = $.$get$DataError_accessorElementOutOfMinBound();
            t9 = t6 + "/min/" + c;
            t10 = t4[c];
            if (c >= t3.length)
              return H.ioore(t3, c);
            context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t10, t3[c]], t7), t9);
          }
        }
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.int];
    }
  };
  M.MaxIntegerChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, _this = this;
      H.intTypeCheck(value);
      if (index !== componentIndex) {
        t1 = _this._computedMax;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        t1 = t1[componentIndex];
        if (typeof t1 !== "number")
          return t1.$lt();
        if (typeof value !== "number")
          return H.iae(value);
        t1 = t1 < value;
      } else
        t1 = true;
      if (t1)
        C.JSArray_methods.$indexSet(_this._computedMax, componentIndex, value);
      t1 = _this._providedMax;
      if (componentIndex >= t1.length)
        return H.ioore(t1, componentIndex);
      t1 = t1[componentIndex];
      if (typeof value !== "number")
        return value.$gt();
      if (typeof t1 !== "number")
        return H.iae(t1);
      if (value > t1) {
        t1 = _this._invalidMaxCount;
        if (componentIndex >= t1.length)
          return H.ioore(t1, componentIndex);
        C.JSArray_methods.$indexSet(t1, componentIndex, t1[componentIndex] + 1);
      }
      return true;
    },
    done$1: function(context) {
      var t1, t2, t3, t4, t5, t6, t7, c, t8, t9, t10, _this = this;
      for (t1 = _this._computedMax, t2 = t1.length, t3 = _this._providedMax, t4 = _this._invalidMaxCount, t5 = t4.length, t6 = _this.path, t7 = [P.Object], c = 0; c < t2; ++c) {
        if (c >= t3.length)
          return H.ioore(t3, c);
        if (!J.$eq$(t3[c], t1[c])) {
          t8 = $.$get$DataError_accessorMaxMismatch();
          t9 = t6 + "/max/" + c;
          if (c >= t3.length)
            return H.ioore(t3, c);
          context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t3[c], t1[c]], t7), t9);
          if (c >= t5)
            return H.ioore(t4, c);
          if (t4[c] > 0) {
            t8 = $.$get$DataError_accessorElementOutOfMaxBound();
            t9 = t6 + "/max/" + c;
            t10 = t4[c];
            if (c >= t3.length)
              return H.ioore(t3, c);
            context.addIssue$3$args$name(t8, H.setRuntimeTypeInfo([t10, t3[c]], t7), t9);
          }
        }
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.int];
    }
  };
  Z.Animation.prototype = {
    link$2: function(gltf, context) {
      var t2, t3, t4, i, t5, _this = this,
        _s8_ = "samplers",
        t1 = _this.samplers;
      if (t1 == null || _this.channels == null)
        return;
      t2 = context.path;
      C.JSArray_methods.add$1(t2, _s8_);
      t1.forEachWithIndices$1(new Z.Animation_link_closure(context, gltf));
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
      C.JSArray_methods.add$1(t2, "channels");
      _this.channels.forEachWithIndices$1(new Z.Animation_link_closure0(_this, context, gltf));
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
      C.JSArray_methods.add$1(t2, _s8_);
      for (t3 = t1._utils$_length, t1 = t1._list, t4 = t1.length, i = 0; i < t3; ++i) {
        t5 = i >= t4;
        if (t5)
          t5 = null;
        else {
          if (i >= t4)
            return H.ioore(t1, i);
          t5 = t1[i];
        }
        if (!t5._isUsed)
          context.addIssue$2$index($.$get$LinkError_unusedObject(), i);
      }
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    }
  };
  Z.Animation_link_closure.prototype = {
    call$2: function(i, sampler) {
      var t1, t2, t3, t4, t5, inputFormat, _s5_ = "input", _s6_ = "output";
      H.interceptedTypeCheck(sampler, "$isAnimationSampler");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
      t3 = this.gltf.accessors;
      t4 = sampler._inputIndex;
      sampler.set$_input(t3.$index(0, t4));
      t5 = sampler._outputIndex;
      sampler.set$_output(t3.$index(0, t5));
      if (t4 !== -1) {
        t3 = sampler._input;
        if (t3 == null)
          t1.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t4], [P.Object]), _s5_);
        else {
          t3.setUsage$3(C.AccessorUsage_AnimationInput, _s5_, t1);
          t3 = sampler._input._bufferView;
          if (t3 != null)
            t3.setUsage$3(C.BufferViewUsage_Other, _s5_, t1);
          C.JSArray_methods.add$1(t2, _s5_);
          t3 = sampler._input;
          inputFormat = new V.AccessorFormat(t3.type, t3.componentType, t3.normalized);
          if (!inputFormat.$eq(0, C.AccessorFormat_SCALAR_5126_false))
            t1.addIssue$2$args($.$get$LinkError_animationSamplerInputAccessorInvalidFormat(), H.setRuntimeTypeInfo([inputFormat, H.setRuntimeTypeInfo([C.AccessorFormat_SCALAR_5126_false], [V.AccessorFormat])], [P.Object]));
          else
            t1.addElementChecker$2(sampler._input, new Z.AnimationInputChecker(t1.getPointerString$0()));
          t3 = sampler._input;
          if (t3.min == null || t3.max == null)
            t1.addIssue$1($.$get$LinkError_animationSamplerInputAccessorWithoutBounds());
          if (sampler.interpolation === "CUBICSPLINE" && sampler._input.count < 2)
            t1.addIssue$2$args($.$get$LinkError_animationSamplerInputAccessorTooFewElements(), H.setRuntimeTypeInfo(["CUBICSPLINE", 2, sampler._input.count], [P.Object]));
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
      }
      if (t5 !== -1) {
        t3 = sampler._output;
        if (t3 == null)
          t1.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t5], [P.Object]), _s6_);
        else {
          t3.setUsage$3(C.AccessorUsage_AnimationOutput, _s6_, t1);
          t3 = sampler._output._bufferView;
          if (t3 != null)
            t3.setUsage$3(C.BufferViewUsage_Other, _s6_, t1);
          sampler._output.trySetInterpolation$1$cubic("CUBICSPLINE" === sampler.interpolation);
        }
      }
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 107
  };
  Z.Animation_link_closure0.prototype = {
    call$2: function(i, channel) {
      var t1, t2, t3, t4, t5, t6, t7, t8, accessor, outputFormat, validFormats, expectedCount, targetsCount, j, _null = null,
        _s7_ = "sampler";
      H.interceptedTypeCheck(channel, "$isAnimationChannel");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
      t3 = this.$this;
      t4 = channel._animation$_samplerIndex;
      channel._animation$_sampler = H.interceptedTypeCheck(t3.samplers.$index(0, t4), "$isAnimationSampler");
      t5 = channel.target;
      t6 = t5 != null;
      if (t6) {
        t7 = t5._nodeIndex;
        t5._node = H.interceptedTypeCheck(this.gltf.nodes.$index(0, t7), "$isNode");
        if (t7 !== -1) {
          C.JSArray_methods.add$1(t2, "target");
          t8 = t5._node;
          if (t8 == null)
            t1.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t7], [P.Object]), "node");
          else {
            t8._isUsed = true;
            switch (t5.path) {
              case "translation":
              case "rotation":
              case "scale":
                if (t8.matrix != null)
                  t1.addIssue$1($.$get$LinkError_animationChannelTargetNodeMatrix());
                if (t5._node._skin != null)
                  t1.addIssue$2$name($.$get$SemanticError_animationChannelTargetNodeSkin(), "path");
                break;
              case "weights":
                t7 = t8._mesh;
                t7 = t7 == null ? _null : t7.primitives;
                t7 = t7 == null ? _null : t7.get$first(t7);
                if ((t7 == null ? _null : t7._targets) == null)
                  t1.addIssue$1($.$get$LinkError_animationChannelTargetNodeWeightsNoMorphs());
                break;
            }
          }
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
      }
      if (t4 !== -1) {
        t7 = channel._animation$_sampler;
        if (t7 == null)
          t1.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t4], [P.Object]), _s7_);
        else {
          t7._isUsed = true;
          if (t6 && t7._output != null) {
            t4 = t5.path;
            if (t4 === "rotation") {
              accessor = t7._output;
              if (accessor.get$components() === 4) {
                C.JSArray_methods.add$1(t2, _s7_);
                t7 = t1.getPointerString$0();
                t8 = 5126 === accessor.componentType ? _null : accessor.get$normalizeValue();
                t1.addElementChecker$2(accessor, new Z.QuaternionFloatChecker("CUBICSPLINE" === channel._animation$_sampler.interpolation, t8, t7, [P.num]));
                if (0 >= t2.length)
                  return H.ioore(t2, -1);
                t2.pop();
              }
              t7 = channel._animation$_sampler;
              t7._output.toString;
            }
            t7 = t7._output;
            outputFormat = new V.AccessorFormat(t7.type, t7.componentType, t7.normalized);
            validFormats = C.Map_0nNZ.$index(0, t4);
            if ((validFormats == null ? _null : C.JSArray_methods.contains$1(validFormats, outputFormat)) === false)
              t1.addIssue$3$args$name($.$get$LinkError_animationSamplerOutputAccessorInvalidFormat(), H.setRuntimeTypeInfo([outputFormat, validFormats, t4], [P.Object]), _s7_);
            t7 = channel._animation$_sampler;
            t8 = t7._input;
            if (t8 != null && t8.count !== -1 && t7._output.count !== -1 && t7.interpolation != null) {
              expectedCount = t8.count;
              if (t7.interpolation === "CUBICSPLINE")
                expectedCount *= 3;
              if (t4 === "weights") {
                t4 = t5._node;
                t4 = t4 == null ? _null : t4._mesh;
                t4 = t4 == null ? _null : t4.primitives;
                t4 = t4 == null ? _null : t4.get$first(t4);
                t4 = t4 == null ? _null : t4._targets;
                targetsCount = t4 == null ? _null : t4.length;
                expectedCount *= targetsCount == null ? 0 : targetsCount;
              }
              if (expectedCount !== 0 && expectedCount !== channel._animation$_sampler._output.count)
                t1.addIssue$3$args$name($.$get$LinkError_animationSamplerOutputAccessorInvalidCount(), H.setRuntimeTypeInfo([expectedCount, channel._animation$_sampler._output.count], [P.Object]), _s7_);
            }
          }
        }
        for (j = i + 1, t3 = t3.channels, t4 = t3._utils$_length, t7 = [P.Object]; j < t4; ++j) {
          if (t6) {
            t8 = j >= t3._list.length;
            if (t8)
              t8 = _null;
            else {
              t8 = t3._list;
              if (j >= t8.length)
                return H.ioore(t8, j);
              t8 = t8[j];
            }
            t8 = t8.target;
            t8 = t8 != null && t5._nodeIndex === t8._nodeIndex && t5.path == t8.path;
          } else
            t8 = false;
          if (t8)
            t1.addIssue$3$args$name($.$get$LinkError_animationDuplicateTargets(), H.setRuntimeTypeInfo([j], t7), "target");
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    },
    $signature: 31
  };
  Z.AnimationChannel.prototype = {};
  Z.AnimationChannelTarget.prototype = {};
  Z.AnimationSampler.prototype = {
    set$_input: function(_input) {
      this._input = H.assertSubtype(_input, "$isAccessor", [P.num], "$asAccessor");
    },
    set$_output: function(_output) {
      this._output = H.assertSubtype(_output, "$isAccessor", [P.num], "$asAccessor");
    }
  };
  Z.AnimationInputChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var _this = this;
      if (typeof value !== "number")
        return value.$lt();
      if (value < 0)
        context.addIssue$3$args$name($.$get$DataError_accessorAnimationInputNegative(), H.setRuntimeTypeInfo([index, value], [P.Object]), _this.path);
      else {
        if (index !== 0 && value <= _this._lastValue)
          context.addIssue$3$args$name($.$get$DataError_accessorAnimationInputNonIncreasing(), H.setRuntimeTypeInfo([index, value, _this._lastValue], [P.Object]), _this.path);
        _this._lastValue = value;
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  Z.QuaternionFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, v, _this = this;
      H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(_this, 0));
      if (!_this.hasTangents || 4 === (4 & _this._fullComponentIndex)) {
        t1 = _this.normalizeValue;
        v = t1 != null ? t1.call$1(value) : value;
        t1 = _this._animation$_sum;
        if (typeof v !== "number")
          return v.$mul();
        t1 += v * v;
        _this._animation$_sum = t1;
        if (3 === componentIndex) {
          if (Math.abs(Math.sqrt(t1) - 1) > 0.00769)
            context.addIssue$3$args$name($.$get$DataError_accessorAnimationSamplerOutputNonNormalizedQuaternion(), H.setRuntimeTypeInfo([index - 3, index, Math.sqrt(_this._animation$_sum)], [P.Object]), _this.path);
          _this._animation$_sum = 0;
        }
      }
      if (++_this._fullComponentIndex === 12)
        _this._fullComponentIndex = 0;
      return true;
    }
  };
  T.Asset.prototype = {
    get$majorVersion: function() {
      var t2,
        t1 = this.version;
      if (t1 != null) {
        t2 = $.$get$Asset_versionRegexp()._nativeRegExp;
        t2 = !t2.test(t1);
      } else
        t2 = true;
      if (t2)
        return 0;
      t1 = $.$get$Asset_versionRegexp().firstMatch$1(t1)._match;
      if (1 >= t1.length)
        return H.ioore(t1, 1);
      return P.int_parse(t1[1], null, null);
    },
    get$minorVersion: function() {
      var t2,
        t1 = this.version;
      if (t1 != null) {
        t2 = $.$get$Asset_versionRegexp()._nativeRegExp;
        t2 = !t2.test(t1);
      } else
        t2 = true;
      if (t2)
        return 0;
      t1 = $.$get$Asset_versionRegexp().firstMatch$1(t1)._match;
      if (2 >= t1.length)
        return H.ioore(t1, 2);
      return P.int_parse(t1[2], null, null);
    },
    get$majorMinVersion: function() {
      var t2,
        t1 = this.minVersion;
      if (t1 != null) {
        t2 = $.$get$Asset_versionRegexp()._nativeRegExp;
        t2 = !t2.test(t1);
      } else
        t2 = true;
      if (t2)
        return 2;
      t1 = $.$get$Asset_versionRegexp().firstMatch$1(t1)._match;
      if (1 >= t1.length)
        return H.ioore(t1, 1);
      return P.int_parse(t1[1], null, null);
    },
    get$minorMinVersion: function() {
      var t2,
        t1 = this.minVersion;
      if (t1 != null) {
        t2 = $.$get$Asset_versionRegexp()._nativeRegExp;
        t2 = !t2.test(t1);
      } else
        t2 = true;
      if (t2)
        return 0;
      t1 = $.$get$Asset_versionRegexp().firstMatch$1(t1)._match;
      if (2 >= t1.length)
        return H.ioore(t1, 2);
      return P.int_parse(t1[2], null, null);
    }
  };
  Q.Buffer.prototype = {};
  V.BufferView.prototype = {
    setUsage$3: function(value, $name, context) {
      var t1;
      this._isUsed = true;
      t1 = this._usage;
      if (t1 == null)
        this._usage = value;
      else if (t1 !== value)
        context.addIssue$3$args$name($.$get$LinkError_bufferViewTargetOverride(), H.setRuntimeTypeInfo([t1, value], [P.Object]), $name);
    },
    link$2: function(gltf, context) {
      var t3, _this = this,
        t1 = _this._buffer_view$_bufferIndex,
        t2 = H.interceptedTypeCheck(gltf.buffers.$index(0, t1), "$isBuffer");
      _this._buffer = t2;
      _this.effectiveByteStride = _this.byteStride;
      t3 = _this._buffer_view$_target;
      if (t3 === 34962)
        _this._usage = C.BufferViewUsage_VertexBuffer;
      else if (t3 === 34963)
        _this._usage = C.BufferViewUsage_IndexBuffer;
      if (t1 !== -1)
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "buffer");
        else {
          t2._isUsed = true;
          t2 = t2.byteLength;
          if (t2 !== -1) {
            t3 = _this.byteOffset;
            if (t3 >= t2)
              context.addIssue$3$args$name($.$get$LinkError_bufferViewTooLong(), H.setRuntimeTypeInfo([t1, t2], [P.Object]), "byteOffset");
            else if (t3 + _this.byteLength > t2)
              context.addIssue$3$args$name($.$get$LinkError_bufferViewTooLong(), H.setRuntimeTypeInfo([t1, t2], [P.Object]), "byteLength");
          }
        }
    }
  };
  G.Camera.prototype = {};
  G.CameraOrthographic.prototype = {};
  G.CameraPerspective.prototype = {};
  V.Gltf.prototype = {
    validateResources$1: function(context) {
      var extensions, t1, t2, _i, entry;
      new V.Gltf_validateResources_validateResourcesInCollection(this, context).call$1(this.textures);
      extensions = context.resourceValidatableExtensions;
      for (t1 = extensions.length, t2 = context.path, _i = 0; _i < extensions.length; extensions.length === t1 || (0, H.throwConcurrentModificationError)(extensions), ++_i) {
        entry = extensions[_i];
        C.JSArray_methods.set$length(t2, 0);
        C.JSArray_methods.addAll$1(t2, entry.path);
        entry.object.validateResources$2(this, context);
      }
      C.JSArray_methods.set$length(t2, 0);
    }
  };
  V.Gltf_Gltf$fromMap_resetPath.prototype = {
    call$0: function() {
      C.JSArray_methods.set$length(this.context.path, 0);
      return;
    },
    $signature: 1
  };
  V.Gltf_Gltf$fromMap_toSafeList.prototype = {
    call$1$2: function($name, fromMap, $T) {
      var t1, itemsList, t2, t3, t4, t5, t6, t7, t8, i, itemMap, _this = this;
      H.functionTypeCheck(fromMap, {func: 1, ret: $T, args: [[P.Map, P.String, P.Object], M.Context]});
      t1 = _this.map;
      if (!t1.containsKey$1($name)) {
        t1 = new Array(0);
        t1.fixed$length = Array;
        return new F.SafeList(H.setRuntimeTypeInfo(t1, [$T]), 0, $name, [$T]);
      }
      _this.resetPath.call$0();
      itemsList = t1.$index(0, $name);
      t1 = J.getInterceptor$(itemsList);
      if (!!t1.$isList) {
        t2 = [$T];
        t3 = [$T];
        t4 = _this.context;
        if (t1.get$isNotEmpty(itemsList)) {
          t5 = t1.get$length(itemsList);
          t6 = new Array(t5);
          t6.fixed$length = Array;
          t2 = H.setRuntimeTypeInfo(t6, t2);
          t6 = t4.path;
          C.JSArray_methods.add$1(t6, $name);
          for (t7 = P.Object, t8 = [t7], t7 = [P.String, t7], i = 0; i < t1.get$length(itemsList); ++i) {
            itemMap = t1.$index(itemsList, i);
            if (H.checkSubtype(itemMap, "$isMap", t7, "$asMap")) {
              C.JSArray_methods.add$1(t6, C.JSInt_methods.toString$0(i));
              C.JSArray_methods.$indexSet(t2, i, H.assertSubtypeOfRuntimeType(fromMap.call$2(itemMap, t4), $T));
              if (0 >= t6.length)
                return H.ioore(t6, -1);
              t6.pop();
            } else
              t4.addIssue$3$args$index($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([itemMap, "object"], t8), i);
          }
          return new F.SafeList(t2, t5, $name, t3);
        } else {
          t4.addIssue$2$name($.$get$SchemaError_emptyEntity(), $name);
          t1 = new Array(0);
          t1.fixed$length = Array;
          return new F.SafeList(H.setRuntimeTypeInfo(t1, t2), 0, $name, t3);
        }
      } else {
        _this.context.addIssue$3$args$name($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([itemsList, "array"], [P.Object]), $name);
        t1 = new Array(0);
        t1.fixed$length = Array;
        return new F.SafeList(H.setRuntimeTypeInfo(t1, [$T]), 0, $name, [$T]);
      }
    },
    call$2: function($name, fromMap) {
      return this.call$1$2($name, fromMap, null);
    }
  };
  V.Gltf_Gltf$fromMap_toValue.prototype = {
    call$1$3$req: function($name, fromMap, req, $T) {
      var t1, item;
      H.functionTypeCheck(fromMap, {func: 1, ret: $T, args: [[P.Map, P.String, P.Object], M.Context]});
      this.resetPath.call$0();
      t1 = this.context;
      item = F.getMap(this.map, $name, t1, true);
      if (item == null)
        return;
      C.JSArray_methods.add$1(t1.path, $name);
      return fromMap.call$2(item, t1);
    },
    call$2: function($name, fromMap) {
      return this.call$1$3$req($name, fromMap, false, null);
    },
    call$1$2: function($name, fromMap, $T) {
      return this.call$1$3$req($name, fromMap, false, $T);
    }
  };
  V.Gltf_Gltf$fromMap_linkCollection.prototype = {
    call$2: function(list, type) {
      var t1, t2, t3, extensions, oldPath, t4, t5;
      H.assertSubtype(list, "$isSafeList", [V.GltfProperty], "$asSafeList");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, list.name);
      t3 = this.gltf;
      list.forEachWithIndices$1(new V.Gltf_Gltf$fromMap_linkCollection_closure(t1, t3));
      extensions = t1.linkableExtensions.$index(0, type);
      if (extensions != null) {
        oldPath = J.JSArray_JSArray$markFixed(t2.slice(0), H.getTypeArgumentByIndex(t2, 0));
        for (t4 = J.get$iterator$ax(extensions); t4.moveNext$0();) {
          t5 = t4.get$current();
          C.JSArray_methods.set$length(t2, 0);
          C.JSArray_methods.addAll$1(t2, t5.path);
          t5.object.link$2(t3, t1);
        }
        C.JSArray_methods.set$length(t2, 0);
        C.JSArray_methods.addAll$1(t2, oldPath);
      }
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 32
  };
  V.Gltf_Gltf$fromMap_linkCollection_closure.prototype = {
    call$2: function(i, item) {
      var t1, t2;
      H.interceptedTypeCheck(item, "$isGltfProperty");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
      item.link$2(this.gltf, t1);
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 33
  };
  V.Gltf_Gltf$fromMap_closure.prototype = {
    call$2: function($name, object) {
      var t1, t2;
      H.stringTypeCheck($name);
      if (!!J.getInterceptor$(object).$isLinkable) {
        t1 = this.context;
        t2 = t1.path;
        C.JSArray_methods.add$1(t2, $name);
        object.link$2(this.gltf, t1);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    },
    $signature: 6
  };
  V.Gltf_Gltf$fromMap_closure0.prototype = {
    call$2: function(i, node) {
      var t1, temp, topCommonRoot, _this = this;
      H.interceptedTypeCheck(node, "$isNode");
      if (!node.isJoint && node._children == null && node._mesh == null && node._camera == null && node.extensions.__js_helper$_length === 0 && node.extras == null)
        _this.context.addIssue$2$index($.$get$SemanticError_nodeEmpty(), i);
      if (node._parent != null) {
        t1 = _this.seenNodes;
        t1.clear$0(0);
        for (temp = node; temp._parent != null;)
          if (t1.add$1(0, temp))
            temp = temp._parent;
          else {
            if (temp === node)
              _this.context.addIssue$2$index($.$get$LinkError_nodeLoop(), i);
            break;
          }
      }
      if (node._skin != null) {
        if (node._parent != null)
          _this.context.addIssue$2$index($.$get$SemanticError_nodeSkinnedMeshNonRoot(), i);
        t1 = node.matrix;
        if (t1 == null || t1.isIdentity$0()) {
          t1 = node.translation;
          if (t1 != null) {
            t1 = t1._v3storage;
            t1 = t1[0] === 0 && t1[1] === 0 && t1[2] === 0;
          } else
            t1 = true;
          if (t1) {
            t1 = node.rotation;
            if (t1 != null) {
              t1 = t1._qStorage;
              t1 = t1[0] === 0 && t1[1] === 0 && t1[2] === 0 && t1[3] === 1;
            } else
              t1 = true;
            if (t1) {
              t1 = node.scale;
              if (t1 != null) {
                t1 = t1._v3storage;
                t1 = t1[0] === 1 && t1[1] === 1 && t1[2] === 1;
              } else
                t1 = true;
            } else
              t1 = false;
          } else
            t1 = false;
        } else
          t1 = false;
        if (!t1)
          _this.context.addIssue$2$index($.$get$SemanticError_nodeSkinnedMeshLocalTransforms(), i);
        topCommonRoot = node._skin._commonRoots.firstWhere$2$orElse(0, new V.Gltf_Gltf$fromMap__closure(), new V.Gltf_Gltf$fromMap__closure0());
        if (topCommonRoot != null) {
          t1 = topCommonRoot._scenes;
          t1 = !node._scenes.every$1(0, t1.get$contains(t1));
        } else
          t1 = false;
        if (t1)
          _this.context.addIssue$2$index($.$get$SemanticError_nodeSkinNoScene(), i);
      }
    },
    $signature: 35
  };
  V.Gltf_Gltf$fromMap__closure.prototype = {
    call$1: function(root) {
      return H.interceptedTypeCheck(root, "$isNode")._parent == null;
    },
    $signature: 36
  };
  V.Gltf_Gltf$fromMap__closure0.prototype = {
    call$0: function() {
      return;
    },
    $signature: 2
  };
  V.Gltf_validateResources_validateResourcesInCollection.prototype = {
    call$1: function(list) {
      var t1, t2;
      H.assertSubtype(list, "$isSafeList", [V.ResourceValidatable], "$asSafeList");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.set$length(t2, 0);
      C.JSArray_methods.add$1(t2, list.name);
      list.forEachWithIndices$1(new V.Gltf_validateResources_validateResourcesInCollection_closure(this.$this, t1));
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 37
  };
  V.Gltf_validateResources_validateResourcesInCollection_closure.prototype = {
    call$2: function(i, item) {
      var t1, t2;
      H.interceptedTypeCheck(item, "$isResourceValidatable");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
      item.validateResources$2(this.$this, t1);
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 30
  };
  V.ResourceValidatable.prototype = {};
  V.GltfProperty.prototype = {
    get$isUsed: function() {
      return this._isUsed;
    },
    link$2: function(gltf, context) {
    },
    $isLinkable: 1
  };
  V.GltfChildOfRootProperty.prototype = {};
  T.Image.prototype = {
    link$2: function(gltf, context) {
      var t2,
        _s10_ = "bufferView",
        t1 = this._bufferViewIndex;
      if (t1 !== -1) {
        t2 = H.interceptedTypeCheck(gltf.bufferViews.$index(0, t1), "$isBufferView");
        this._image$_bufferView = t2;
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), _s10_);
        else
          t2.setUsage$3(C.BufferViewUsage_Image, _s10_, context);
      }
    },
    tryLoadFromBufferView$0: function() {
      var t3, exception,
        t1 = this._image$_bufferView,
        t2 = t1 == null ? null : t1._buffer;
      if ((t2 == null ? null : t2.data) != null)
        try {
          t2 = t1._buffer.data.buffer;
          t3 = t1.byteOffset;
          t1 = t1.byteLength;
          t2.toString;
          this.data = H.NativeUint8List_NativeUint8List$view(t2, t3, t1);
        } catch (exception) {
          if (!(H.unwrapException(exception) instanceof P.ArgumentError))
            throw exception;
        }
    }
  };
  Y.Material.prototype = {
    link$2: function(gltf, context) {
      var _this = this,
        t1 = new Y.Material_link_linkWithPath(context, gltf);
      t1.call$2(_this.pbrMetallicRoughness, "pbrMetallicRoughness");
      t1.call$2(_this.normalTexture, "normalTexture");
      t1.call$2(_this.occlusionTexture, "occlusionTexture");
      t1.call$2(_this.emissiveTexture, "emissiveTexture");
    }
  };
  Y.Material_link_linkWithPath.prototype = {
    call$2: function(property, $name) {
      var t1, t2;
      if (property != null) {
        t1 = this.context;
        t2 = t1.path;
        C.JSArray_methods.add$1(t2, $name);
        property.link$2(this.gltf, t1);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    },
    $signature: 39
  };
  Y.PbrMetallicRoughness.prototype = {
    link$2: function(gltf, context) {
      var t2,
        t1 = this.baseColorTexture;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "baseColorTexture");
        t1.link$2(gltf, context);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t1 = this.metallicRoughnessTexture;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "metallicRoughnessTexture");
        t1.link$2(gltf, context);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    }
  };
  Y.OcclusionTextureInfo.prototype = {};
  Y.NormalTextureInfo.prototype = {};
  Y.TextureInfo.prototype = {
    link$2: function(gltf, context) {
      var o, _this = this,
        t1 = _this._material$_index,
        t2 = H.interceptedTypeCheck(gltf.textures.$index(0, t1), "$isTexture");
      _this._texture = t2;
      if (t1 !== -1)
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "index");
        else
          t2._isUsed = true;
      for (t1 = context.owners, o = _this; o != null;) {
        o = t1.$index(0, o);
        if (o instanceof Y.Material) {
          o.texCoordIndices.$indexSet(0, context.getPointerString$0(), _this.texCoord);
          break;
        }
      }
    }
  };
  V.BufferViewUsage.prototype = {
    toString$0: function(_) {
      return this._members$_value;
    }
  };
  V.AccessorUsage.prototype = {
    toString$0: function(_) {
      return this._members$_value;
    }
  };
  V.AccessorFormat.prototype = {
    toString$0: function(_) {
      var t1 = "{" + H.S(this.type) + ", " + H.S(C.Map_ZGNO4.$index(0, this.componentType));
      return t1 + (this.normalized ? " normalized" : "") + "}";
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof V.AccessorFormat && other.type == this.type && other.componentType === this.componentType && other.normalized === this.normalized;
    },
    get$hashCode: function(_) {
      return A._finish(A._combine(A._combine(A._combine(0, J.get$hashCode$(this.type)), C.JSInt_methods.get$hashCode(this.componentType)), C.JSBool_methods.get$hashCode(this.normalized)));
    }
  };
  S.Mesh.prototype = {
    link$2: function(gltf, context) {
      var t2,
        t1 = context.path;
      C.JSArray_methods.add$1(t1, "primitives");
      t2 = this.primitives;
      if (t2 != null)
        t2.forEachWithIndices$1(new S.Mesh_link_closure(context, gltf));
      if (0 >= t1.length)
        return H.ioore(t1, -1);
      t1.pop();
    }
  };
  S.Mesh_link_closure.prototype = {
    call$2: function(i, primitive) {
      var t1, t2;
      H.interceptedTypeCheck(primitive, "$isMeshPrimitive");
      t1 = this.context;
      t2 = t1.path;
      C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
      primitive.link$2(this.gltf, t1);
      if (0 >= t2.length)
        return H.ioore(t2, -1);
      t2.pop();
    },
    $signature: 20
  };
  S.MeshPrimitive.prototype = {
    get$trianglesCount: function() {
      switch (this.mode) {
        case 4:
          return C.JSInt_methods._tdivFast$1(this._count, 3);
        case 5:
        case 6:
          var t1 = this._count;
          return t1 > 2 ? t1 - 2 : 0;
        default:
          return 0;
      }
    },
    link$2: function(gltf, context) {
      var t2, format, maxVertexIndex, modesMask, t3, t4, t5, t6, unusedTexCoords, i, targetIndices, _this = this,
        _s10_ = "attributes",
        _s7_ = "indices",
        t1 = _this._attributesIndices;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, _s10_);
        t1.forEach$1(0, new S.MeshPrimitive_link_closure(_this, gltf, context));
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t1 = _this._indicesIndex;
      if (t1 !== -1) {
        _this.set$_indices(gltf.accessors.$index(0, t1));
        t2 = _this._indices;
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), _s7_);
        else {
          _this._count = t2.count;
          t2.setUsage$3(C.AccessorUsage_PrimitiveIndices, _s7_, context);
          t1 = _this._indices._bufferView;
          if (t1 != null)
            t1.setUsage$3(C.BufferViewUsage_IndexBuffer, _s7_, context);
          t1 = context.path;
          C.JSArray_methods.add$1(t1, _s7_);
          t2 = _this._indices._bufferView;
          if (t2 != null && t2.byteStride !== -1)
            context.addIssue$1($.$get$LinkError_meshPrimitiveIndicesAccessorWithByteStride());
          t2 = _this._indices;
          format = new V.AccessorFormat(t2.type, t2.componentType, t2.normalized);
          if (!C.JSArray_methods.contains$1(C.List_AKA, format))
            context.addIssue$2$args($.$get$LinkError_meshPrimitiveIndicesAccessorInvalidFormat(), H.setRuntimeTypeInfo([format, C.List_AKA], [P.Object]));
          else {
            t2 = _this._vertexCount;
            maxVertexIndex = t2 !== -1 ? t2 - 1 : -1;
            t2 = _this.mode;
            modesMask = t2 !== -1 ? C.JSInt_methods.$shl(1, t2) : -1;
            if (modesMask !== 0 && maxVertexIndex >= -1) {
              t2 = _this._indices;
              t3 = context.getPointerString$0();
              t4 = C.JSInt_methods._tdivFast$1(_this._count, 3);
              t5 = _this._indices.componentType;
              t6 = new Uint32Array(3);
              context.addElementChecker$2(t2, new S.IndexBufferIntegerChecker(maxVertexIndex, t4, Z.typeMax(t5), 16 === (16 & modesMask), t6, t3));
            }
          }
          if (0 >= t1.length)
            return H.ioore(t1, -1);
          t1.pop();
        }
      }
      t1 = _this._count;
      if (t1 !== -1) {
        t2 = _this.mode;
        if (!(t2 === 1 && t1 % 2 !== 0))
          if (!((t2 === 2 || t2 === 3) && t1 < 2))
            if (!(t2 === 4 && t1 % 3 !== 0))
              t1 = (t2 === 5 || t2 === 6) && t1 < 3;
            else
              t1 = true;
          else
            t1 = true;
        else
          t1 = true;
      } else
        t1 = false;
      if (t1) {
        t1 = $.$get$LinkError_meshPrimitiveIncompatibleMode();
        t2 = _this._count;
        t3 = _this.mode;
        if (t3 < 0 || t3 >= 7)
          return H.ioore(C.List_WJh, t3);
        context.addIssue$2$args(t1, H.setRuntimeTypeInfo([t2, C.List_WJh[t3]], [P.Object]));
      }
      t1 = _this._materialIndex;
      _this._material = H.interceptedTypeCheck(gltf.materials.$index(0, t1), "$isMaterial");
      unusedTexCoords = P.List_List$generate(_this.texcoordCount, new S.MeshPrimitive_link_closure0(), false, P.int);
      if (t1 !== -1) {
        t2 = _this._material;
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "material");
        else {
          t2._isUsed = true;
          t2.texCoordIndices.forEach$1(0, new S.MeshPrimitive_link_closure1(_this, context, unusedTexCoords));
        }
      }
      for (t1 = H.getTypeArgumentByIndex(unusedTexCoords, 0), t2 = H.functionTypeCheck(new S.MeshPrimitive_link_closure2(), {func: 1, ret: P.bool, args: [t1]}), t3 = C.JSArray_methods.get$iterator(unusedTexCoords), t1 = new H.WhereIterator(t3, t2, [t1]), t2 = context.path; t1.moveNext$0();) {
        t4 = t3.get$current();
        C.JSArray_methods.add$1(t2, _s10_);
        context.addIssue$2$name($.$get$LinkError_unusedObject(), "TEXCOORD_" + H.S(t4));
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t1 = _this._targetsIndices;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "targets");
        t3 = new Array(t1.length);
        t3.fixed$length = Array;
        _this.set$_targets(H.setRuntimeTypeInfo(t3, [[P.Map, P.String, [M.Accessor, P.num]]]));
        for (t3 = P.String, t4 = [M.Accessor, P.num], i = 0; i < t1.length; ++i) {
          targetIndices = t1[i];
          t5 = _this._targets;
          (t5 && C.JSArray_methods).$indexSet(t5, i, P.LinkedHashMap_LinkedHashMap$_empty(t3, t4));
          C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
          targetIndices.forEach$1(0, new S.MeshPrimitive_link_closure3(_this, gltf, context, i));
          if (0 >= t2.length)
            return H.ioore(t2, -1);
          t2.pop();
        }
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    },
    _checkAccessorRefs$3: function(accessor, semantic, context) {
      var t1, accessors;
      H.assertSubtype(accessor, "$isAccessor", [P.num], "$asAccessor");
      t1 = accessor._bufferView;
      if (t1.byteStride === -1) {
        accessors = context.bufferViewAccessors.putIfAbsent$2(t1, new S.MeshPrimitive__checkAccessorRefs_closure());
        if (accessors.add$1(0, accessor) && accessors.get$length(accessors) > 1)
          context.addIssue$2$name($.$get$LinkError_meshPrimitiveAccessorWithoutByteStride(), semantic);
      }
    },
    set$_targets: function(_targets) {
      this._targets = H.assertSubtype(_targets, "$isList", [[P.Map, P.String, [M.Accessor, P.num]]], "$asList");
    },
    set$_indices: function(_indices) {
      this._indices = H.assertSubtype(_indices, "$isAccessor", [P.num], "$asAccessor");
    }
  };
  S.MeshPrimitive_MeshPrimitive$fromMap_checkAttributeSemanticName.prototype = {
    call$1: function(semantic) {
      var semParts, t1, arraySemantic, codeUnits, index, valid, t2, t3, i, digit, t4, maxColor, maxJoints, maxTexcoord, maxWeights, _this = this;
      if (semantic.length !== 0 && J._codeUnitAt$1$s(semantic, 0) === 95)
        return;
      switch (semantic) {
        case "POSITION":
          _this._box_0.hasPosition = true;
          break;
        case "NORMAL":
          _this._box_0.hasNormal = true;
          break;
        case "TANGENT":
          _this._box_0.hasTangent = true;
          break;
        default:
          semParts = H.setRuntimeTypeInfo(semantic.split("_"), [P.String]);
          t1 = semParts.length;
          if (0 >= t1)
            return H.ioore(semParts, 0);
          arraySemantic = semParts[0];
          if (!C.JSArray_methods.contains$1(C.List_COLOR_JOINTS_TEXCOORD_WEIGHTS, arraySemantic) || t1 !== 2) {
            _this.context.addIssue$2$name($.$get$SemanticError_meshPrimitiveInvalidAttribute(), semantic);
            break;
          }
          if (1 >= t1)
            return H.ioore(semParts, 1);
          t1 = semParts[1];
          t1.toString;
          codeUnits = new H.CodeUnits(t1);
          if (codeUnits.get$length(codeUnits) === 0) {
            index = 0;
            valid = false;
          } else {
            t2 = t1.length;
            if (t2 === 1) {
              index = J._codeUnitAt$1$s(t1, 0) - 48;
              valid = !(index < 0 || index > 9) || false;
            } else {
              t3 = J.getInterceptor$s(t1);
              index = 0;
              i = 0;
              while (true) {
                if (!(i < t2)) {
                  valid = true;
                  break;
                }
                digit = t3._codeUnitAt$1(t1, i) - 48;
                if (digit <= 9)
                  if (digit >= 0)
                    t4 = i === 0 && digit === 0;
                  else
                    t4 = true;
                else
                  t4 = true;
                if (t4) {
                  valid = false;
                  break;
                }
                index = 10 * index + digit;
                ++i;
              }
            }
          }
          if (valid)
            switch (arraySemantic) {
              case "COLOR":
                t1 = _this._box_0;
                ++t1.colorCount;
                maxColor = t1.maxColor;
                t1.maxColor = index > maxColor ? index : maxColor;
                break;
              case "JOINTS":
                t1 = _this._box_0;
                ++t1.jointsCount;
                maxJoints = t1.maxJoints;
                t1.maxJoints = index > maxJoints ? index : maxJoints;
                break;
              case "TEXCOORD":
                t1 = _this._box_0;
                ++t1.texcoordCount;
                maxTexcoord = t1.maxTexcoord;
                t1.maxTexcoord = index > maxTexcoord ? index : maxTexcoord;
                break;
              case "WEIGHTS":
                t1 = _this._box_0;
                ++t1.weightsCount;
                maxWeights = t1.maxWeights;
                t1.maxWeights = index > maxWeights ? index : maxWeights;
                break;
            }
          else
            _this.context.addIssue$2$name($.$get$SemanticError_meshPrimitiveInvalidAttribute(), semantic);
      }
    },
    $signature: 21
  };
  S.MeshPrimitive_MeshPrimitive$fromMap_checkContinuity.prototype = {
    call$3: function(maxIndex, count, $name) {
      var t1 = maxIndex + 1;
      if (t1 !== count) {
        this.context.addIssue$2$args($.$get$SemanticError_meshPrimitiveIndexedSemanticContinuity(), H.setRuntimeTypeInfo([$name, t1, count], [P.Object]));
        return 0;
      }
      return count;
    }
  };
  S.MeshPrimitive_MeshPrimitive$fromMap_checkMorphTargetAttributeSemanticName.prototype = {
    call$1: function(semantic) {
      var t1 = this.context;
      if (!t1.morphAttributeAccessorFormats.containsKey$1(semantic) && !J.startsWith$1$s(semantic, "_"))
        t1.addIssue$2$name($.$get$SemanticError_meshPrimitiveInvalidAttribute(), semantic);
    },
    $signature: 21
  };
  S.MeshPrimitive_link_closure.prototype = {
    call$2: function(semantic, accessorIndex) {
      var accessor, t1, t2, t3, t4, format, validFormats, t5, _this = this;
      H.stringTypeCheck(semantic);
      H.intTypeCheck(accessorIndex);
      if (accessorIndex === -1)
        return;
      accessor = _this.gltf.accessors.$index(0, accessorIndex);
      if (accessor == null) {
        _this.context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([accessorIndex], [P.Object]), semantic);
        return;
      }
      t1 = _this.$this;
      t1.attributes.$indexSet(0, semantic, accessor);
      t2 = _this.context;
      accessor.setUsage$3(C.AccessorUsage_VertexAttribute, semantic, t2);
      t3 = accessor._bufferView;
      if (t3 != null)
        t3.setUsage$3(C.BufferViewUsage_VertexBuffer, semantic, t2);
      if (semantic === "POSITION")
        t3 = accessor.min == null || accessor.max == null;
      else
        t3 = false;
      if (t3)
        t2.addIssue$2$name($.$get$LinkError_meshPrimitivePositionAccessorWithoutBounds(), "POSITION");
      t3 = accessor.type;
      t4 = accessor.componentType;
      format = new V.AccessorFormat(t3, t4, accessor.normalized);
      t3 = H.setRuntimeTypeInfo(semantic.split("_"), [P.String]);
      if (0 >= t3.length)
        return H.ioore(t3, 0);
      validFormats = t2.attributeAccessorFormats.$index(0, t3[0]);
      if (validFormats != null)
        if (!validFormats.contains$1(0, format))
          t2.addIssue$3$args$name($.$get$LinkError_meshPrimitiveAttributesAccessorInvalidFormat(), H.setRuntimeTypeInfo([format, validFormats], [P.Object]), semantic);
        else if (semantic === "NORMAL") {
          t3 = t2.path;
          C.JSArray_methods.add$1(t3, "NORMAL");
          t5 = t2.getPointerString$0();
          t2.addElementChecker$2(accessor, new F.UnitVec3FloatChecker(t5, 5126 === t4 ? null : accessor.get$normalizeValue()));
          if (0 >= t3.length)
            return H.ioore(t3, -1);
          t3.pop();
        } else if (semantic === "TANGENT") {
          t3 = t2.path;
          C.JSArray_methods.add$1(t3, "TANGENT");
          t5 = t2.getPointerString$0();
          t2.addElementChecker$2(accessor, new F.UnitVec3SignFloatChecker(t5, 5126 === t4 ? null : accessor.get$normalizeValue()));
          if (0 >= t3.length)
            return H.ioore(t3, -1);
          t3.pop();
        } else if (C.JSString_methods.startsWith$1(semantic, "COLOR_") && 5126 === t4) {
          t3 = t2.path;
          C.JSArray_methods.add$1(t3, semantic);
          t2.addElementChecker$2(accessor, new F.ClampedRangeFloatChecker(t2.getPointerString$0()));
          if (0 >= t3.length)
            return H.ioore(t3, -1);
          t3.pop();
        }
      t3 = accessor.byteOffset;
      if (!(t3 !== -1 && t3 % 4 !== 0))
        if (accessor.get$elementLength() % 4 !== 0) {
          t3 = accessor._bufferView;
          t3 = t3 != null && t3.byteStride === -1;
        } else
          t3 = false;
      else
        t3 = true;
      if (t3)
        t2.addIssue$2$name($.$get$LinkError_meshPrimitiveAccessorUnaligned(), semantic);
      t3 = t1._vertexCount;
      if (t3 === -1)
        t1._count = t1._vertexCount = accessor.count;
      else if (t3 !== accessor.count)
        t2.addIssue$2$name($.$get$LinkError_meshPrimitiveUnequalAccessorsCount(), semantic);
      t3 = accessor._bufferView;
      if (t3 != null && t3.byteStride === -1) {
        if (t3.effectiveByteStride === -1)
          t3.effectiveByteStride = accessor.get$elementLength();
        t1._checkAccessorRefs$3(accessor, semantic, t2);
      }
    },
    $signature: 7
  };
  S.MeshPrimitive_link_closure0.prototype = {
    call$1: function(i) {
      return i;
    },
    $signature: 18
  };
  S.MeshPrimitive_link_closure1.prototype = {
    call$2: function(pointer, texCoord) {
      H.stringTypeCheck(pointer);
      H.intTypeCheck(texCoord);
      if (texCoord !== -1) {
        if (typeof texCoord !== "number")
          return texCoord.$add();
        if (texCoord + 1 > this.$this.texcoordCount)
          this.context.addIssue$3$args$name($.$get$LinkError_meshPrimitiveTooFewTexcoords(), H.setRuntimeTypeInfo([pointer, texCoord], [P.Object]), "material");
        else
          C.JSArray_methods.$indexSet(this.unusedTexCoords, texCoord, -1);
      }
    },
    $signature: 7
  };
  S.MeshPrimitive_link_closure2.prototype = {
    call$1: function(i) {
      return H.intTypeCheck(i) !== -1;
    },
    $signature: 8
  };
  S.MeshPrimitive_link_closure3.prototype = {
    call$2: function(semantic, accessorIndex) {
      var accessor, t1, t2, baseAccessor, t3, format, validFormats, _this = this;
      H.stringTypeCheck(semantic);
      H.intTypeCheck(accessorIndex);
      if (accessorIndex === -1)
        return;
      accessor = _this.gltf.accessors.$index(0, accessorIndex);
      if (accessor == null)
        _this.context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([accessorIndex], [P.Object]), semantic);
      else {
        t1 = _this.context;
        accessor.setUsage$3(C.AccessorUsage_VertexAttribute, semantic, t1);
        t2 = _this.$this;
        baseAccessor = t2.attributes.$index(0, semantic);
        if (baseAccessor == null)
          t1.addIssue$2$name($.$get$LinkError_meshPrimitiveMorphTargetNoBaseAccessor(), semantic);
        else if (baseAccessor.count !== accessor.count)
          t1.addIssue$2$name($.$get$LinkError_meshPrimitiveMorphTargetInvalidAttributeCount(), semantic);
        if (semantic === "POSITION")
          t3 = accessor.min == null || accessor.max == null;
        else
          t3 = false;
        if (t3)
          t1.addIssue$2$name($.$get$LinkError_meshPrimitivePositionAccessorWithoutBounds(), "POSITION");
        format = new V.AccessorFormat(accessor.type, accessor.componentType, accessor.normalized);
        validFormats = t1.morphAttributeAccessorFormats.$index(0, semantic);
        if (validFormats != null && !validFormats.contains$1(0, format))
          t1.addIssue$3$args$name($.$get$LinkError_meshPrimitiveAttributesAccessorInvalidFormat(), H.setRuntimeTypeInfo([format, validFormats], [P.Object]), semantic);
        t3 = accessor.byteOffset;
        if (!(t3 !== -1 && t3 % 4 !== 0))
          if (accessor.get$elementLength() % 4 !== 0) {
            t3 = accessor._bufferView;
            t3 = t3 != null && t3.byteStride === -1;
          } else
            t3 = false;
        else
          t3 = true;
        if (t3)
          t1.addIssue$2$name($.$get$LinkError_meshPrimitiveAccessorUnaligned(), semantic);
        t3 = accessor._bufferView;
        if (t3 != null && t3.byteStride === -1) {
          if (t3.effectiveByteStride === -1)
            t3.effectiveByteStride = accessor.get$elementLength();
          t2._checkAccessorRefs$3(accessor, semantic, t1);
        }
      }
      t1 = _this.$this._targets;
      t2 = _this.i;
      if (t2 >= t1.length)
        return H.ioore(t1, t2);
      t1[t2].$indexSet(0, semantic, accessor);
    },
    $signature: 7
  };
  S.MeshPrimitive__checkAccessorRefs_closure.prototype = {
    call$0: function() {
      return P.LinkedHashSet_LinkedHashSet$_empty([M.Accessor, P.num]);
    },
    $signature: 44
  };
  S.IndexBufferIntegerChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1, t2, t3, _this = this;
      H.intTypeCheck(value);
      t1 = _this.maxVertexIndex;
      if (typeof value !== "number")
        return value.$gt();
      if (value > t1)
        context.addIssue$3$args$name($.$get$DataError_accessorIndexOob(), H.setRuntimeTypeInfo([index, value, t1], [P.Object]), _this.path);
      if (value === _this.primitiveRestartIndex)
        context.addIssue$3$args$name($.$get$DataError_accessorIndexPrimitiveRestart(), H.setRuntimeTypeInfo([value, index], [P.Object]), _this.path);
      if (_this.isTriangles) {
        t1 = _this._triangle;
        t2 = _this._vertexIndex;
        if (t2 >= 3)
          return H.ioore(t1, t2);
        t1[t2] = value;
        ++t2;
        _this._vertexIndex = t2;
        if (t2 === 3) {
          _this._vertexIndex = 0;
          t2 = t1[0];
          t3 = t1[1];
          if (t2 !== t3) {
            t1 = t1[2];
            t1 = t3 === t1 || t1 === t2;
          } else
            t1 = true;
          if (t1)
            ++_this._degenerateTriangles;
        }
      }
      return true;
    },
    done$1: function(context) {
      var t1 = this._degenerateTriangles;
      if (t1 > 0)
        context.addIssue$3$args$name($.$get$DataError_accessorIndexTriangleDegenerate(), H.setRuntimeTypeInfo([t1, this.totalTriangles], [P.Object]), this.path);
      return true;
    },
    $asElementChecker: function() {
      return [P.int];
    }
  };
  V.Node.prototype = {
    link$2: function(gltf, context) {
      var t2, t3, t4, _this = this,
        t1 = _this._cameraIndex;
      _this._camera = H.interceptedTypeCheck(gltf.cameras.$index(0, t1), "$isCamera");
      t2 = _this._skinIndex;
      _this._skin = H.interceptedTypeCheck(gltf.skins.$index(0, t2), "$isSkin");
      t3 = _this._meshIndex;
      _this._mesh = H.interceptedTypeCheck(gltf.meshes.$index(0, t3), "$isMesh");
      if (t1 !== -1) {
        t4 = _this._camera;
        if (t4 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "camera");
        else
          t4._isUsed = true;
      }
      if (t2 !== -1) {
        t1 = _this._skin;
        if (t1 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t2], [P.Object]), "skin");
        else
          t1._isUsed = true;
      }
      if (t3 !== -1) {
        t1 = _this._mesh;
        if (t1 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t3], [P.Object]), "mesh");
        else {
          t1._isUsed = true;
          t1 = t1.primitives;
          if (t1 != null) {
            t2 = _this.weights;
            if (t2 != null) {
              t1 = t1.$index(0, 0)._targets;
              t1 = t1 == null ? null : t1.length;
              t1 = t1 !== t2.length;
            } else
              t1 = false;
            if (t1) {
              t1 = $.$get$LinkError_nodeWeightsInvalid();
              t2 = t2.length;
              t3 = _this._mesh.primitives.$index(0, 0)._targets;
              context.addIssue$3$args$name(t1, H.setRuntimeTypeInfo([t2, t3 == null ? null : t3.length], [P.Object]), "weights");
            }
            if (_this._skin != null) {
              t1 = _this._mesh.primitives;
              if (t1.every$1(t1, new V.Node_link_closure()))
                context.addIssue$1($.$get$LinkError_nodeSkinWithNonSkinnedMesh());
            } else {
              t1 = _this._mesh.primitives;
              if (t1.any$1(t1, new V.Node_link_closure0()))
                context.addIssue$1($.$get$LinkError_nodeSkinnedMeshWithoutSkin());
            }
          }
        }
      }
      t1 = _this._childrenIndices;
      if (t1 != null) {
        t2 = new Array(t1.get$length(t1));
        t2.fixed$length = Array;
        _this.set$_children(H.setRuntimeTypeInfo(t2, [V.Node]));
        F.resolveNodeList(t1, _this._children, gltf.nodes, "children", context, new V.Node_link_closure1(_this, context));
      }
    },
    addScene$1: function(scene) {
      var t1, t2, _i, node;
      this._scenes.add$1(0, scene);
      t1 = this._children;
      if (t1 != null)
        for (t2 = t1.length, _i = 0; _i < t2; ++_i) {
          node = t1[_i];
          if (node != null)
            node.addScene$1(scene);
        }
    },
    set$_children: function(_children) {
      this._children = H.assertSubtype(_children, "$isList", [V.Node], "$asList");
    }
  };
  V.Node_link_closure.prototype = {
    call$1: function(primitive) {
      return H.interceptedTypeCheck(primitive, "$isMeshPrimitive").jointsCount === 0;
    },
    $signature: 3
  };
  V.Node_link_closure0.prototype = {
    call$1: function(primitive) {
      return H.interceptedTypeCheck(primitive, "$isMeshPrimitive").jointsCount !== 0;
    },
    $signature: 3
  };
  V.Node_link_closure1.prototype = {
    call$3: function(node, nodeIndex, index) {
      if (node._parent != null)
        this.context.addIssue$3$args$index($.$get$LinkError_nodeParentOverride(), H.setRuntimeTypeInfo([nodeIndex], [P.Object]), index);
      node._parent = this.$this;
    },
    $signature: 9
  };
  T.Sampler.prototype = {};
  B.Scene.prototype = {
    link$2: function(gltf, context) {
      var t2, _this = this,
        t1 = _this._nodesIndices;
      if (t1 == null)
        return;
      t2 = new Array(t1.get$length(t1));
      t2.fixed$length = Array;
      _this.set$nodes(H.setRuntimeTypeInfo(t2, [V.Node]));
      F.resolveNodeList(t1, _this.nodes, gltf.nodes, "nodes", context, new B.Scene_link_closure(_this, context));
    },
    set$nodes: function(nodes) {
      this.nodes = H.assertSubtype(nodes, "$isList", [V.Node], "$asList");
    }
  };
  B.Scene_link_closure.prototype = {
    call$3: function(node, nodeIndex, index) {
      if (node._parent != null)
        this.context.addIssue$3$args$index($.$get$LinkError_sceneNonRootNode(), H.setRuntimeTypeInfo([nodeIndex], [P.Object]), index);
      node.addScene$1(this.$this);
    },
    $signature: 9
  };
  O.Skin.prototype = {
    link$2: function(gltf, context) {
      var t2, t3, t4, t5, format, _this = this,
        _s19_ = "inverseBindMatrices",
        _s8_ = "skeleton",
        t1 = _this._inverseBindMatricesIndex;
      _this.set$_inverseBindMatrices(gltf.accessors.$index(0, t1));
      t2 = gltf.nodes;
      t3 = _this._skeletonIndex;
      _this._skeleton = H.interceptedTypeCheck(t2.$index(0, t3), "$isNode");
      t4 = _this._jointsIndices;
      if (t4 != null) {
        t5 = new Array(t4.get$length(t4));
        t5.fixed$length = Array;
        _this.set$_joints(H.setRuntimeTypeInfo(t5, [V.Node]));
        F.resolveNodeList(t4, _this._joints, t2, "joints", context, new O.Skin_link_closure(_this));
        if (_this._commonRoots._collection$_length === 0)
          context.addIssue$2$name($.$get$SemanticError_skinNoCommonRoot(), "joints");
      }
      if (t1 !== -1) {
        t2 = _this._inverseBindMatrices;
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), _s19_);
        else {
          t2.setUsage$3(C.AccessorUsage_IBM, _s19_, context);
          t1 = _this._inverseBindMatrices._bufferView;
          if (t1 != null)
            t1.setUsage$3(C.BufferViewUsage_IBM, _s19_, context);
          t1 = context.path;
          C.JSArray_methods.add$1(t1, _s19_);
          t2 = _this._inverseBindMatrices;
          format = new V.AccessorFormat(t2.type, t2.componentType, t2.normalized);
          if (!format.$eq(0, C.AccessorFormat_MAT4_5126_false))
            context.addIssue$2$args($.$get$LinkError_skinIbmInvalidFormat(), H.setRuntimeTypeInfo([format, H.setRuntimeTypeInfo([C.AccessorFormat_MAT4_5126_false], [V.AccessorFormat])], [P.Object]));
          else
            context.addElementChecker$2(_this._inverseBindMatrices, new O.IbmMatrixFloatChecker(context.getPointerString$0()));
          t2 = _this._joints;
          if (t2 != null && _this._inverseBindMatrices.count !== t2.length)
            context.addIssue$2$args($.$get$LinkError_invalidIbmAccessorCount(), H.setRuntimeTypeInfo([t2.length, _this._inverseBindMatrices.count], [P.Object]));
          if (0 >= t1.length)
            return H.ioore(t1, -1);
          t1.pop();
        }
      }
      if (t3 !== -1) {
        t1 = _this._skeleton;
        if (t1 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t3], [P.Object]), _s8_);
        else if (!_this._commonRoots.contains$1(0, t1))
          context.addIssue$2$name($.$get$SemanticError_skinSkeletonInvalid(), _s8_);
      }
    },
    set$_inverseBindMatrices: function(_inverseBindMatrices) {
      this._inverseBindMatrices = H.assertSubtype(_inverseBindMatrices, "$isAccessor", [P.num], "$asAccessor");
    },
    set$_joints: function(_joints) {
      this._joints = H.assertSubtype(_joints, "$isList", [V.Node], "$asList");
    }
  };
  O.Skin_link_closure.prototype = {
    call$3: function(node, nodeIndex, index) {
      var parents, temp, t1;
      node.isJoint = true;
      parents = P.LinkedHashSet_LinkedHashSet$_empty(V.Node);
      temp = node;
      while (true) {
        if (!(temp != null && parents.add$1(0, temp)))
          break;
        temp = temp._parent;
      }
      t1 = this.$this._commonRoots;
      if (t1._collection$_length === 0)
        t1.addAll$1(0, parents);
      else
        t1._filterWhere$2(H.functionTypeCheck(parents.get$contains(parents), {func: 1, ret: P.bool, args: [H.getTypeArgumentByIndex(t1, 0)]}), false);
    },
    $signature: 9
  };
  O.IbmMatrixFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var t1;
      if (!(3 === componentIndex && 0 !== value))
        if (!(7 === componentIndex && 0 !== value))
          if (!(11 === componentIndex && 0 !== value))
            t1 = 15 === componentIndex && 1 !== value;
          else
            t1 = true;
        else
          t1 = true;
      else
        t1 = true;
      if (t1)
        context.addIssue$3$args$name($.$get$DataError_accessorInvalidInverseBindMatrix(), H.setRuntimeTypeInfo([index, componentIndex, value], [P.Object]), this.path);
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  U.Texture.prototype = {
    link$2: function(gltf, context) {
      var t2, t3, _this = this,
        t1 = _this._texture$_sourceIndex;
      _this._texture$_source = H.interceptedTypeCheck(gltf.images.$index(0, t1), "$isImage");
      t2 = _this._samplerIndex;
      _this._sampler = H.interceptedTypeCheck(gltf.samplers.$index(0, t2), "$isSampler");
      if (t1 !== -1) {
        t3 = _this._texture$_source;
        if (t3 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "source");
        else
          t3._isUsed = true;
      }
      if (t2 !== -1) {
        t1 = _this._sampler;
        if (t1 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t2], [P.Object]), "sampler");
        else
          t1._isUsed = true;
      }
    },
    validateResources$2: function(gltf, context) {
      var mimeType,
        t1 = this._texture$_source;
      t1 = t1 == null ? null : t1.info;
      mimeType = t1 == null ? null : t1.mimeType;
      if (mimeType != null && !C.JSArray_methods.contains$1(C.List_6D4, mimeType))
        context.addIssue$3$args$name($.$get$LinkError_textureInvalidImageMimeType(), H.setRuntimeTypeInfo([mimeType, C.List_6D4], [P.Object]), "source");
    },
    $isResourceValidatable: 1
  };
  M.ValidationOptions.prototype = {};
  M.Context.prototype = {
    addElementChecker$2: function(accessor, checker) {
      var t1 = P.num;
      H.assertSubtype(accessor, "$isAccessor", [t1], "$asAccessor");
      H.assertSubtype(checker, "$isElementChecker", [t1], "$asElementChecker");
      J.add$1$ax(this.accessorElementCheckers.putIfAbsent$2(accessor, new M.Context_addElementChecker_closure()), checker);
    },
    registerObjectsOwner$2: function(owner, objects) {
      var t1, t2, o;
      for (t1 = J.get$iterator$ax(H.assertSubtype(objects, "$isIterable", [P.Object], "$asIterable")), t2 = this.owners; t1.moveNext$0();) {
        o = t1.get$current();
        if (o != null)
          t2.$indexSet(0, o, owner);
      }
    },
    getPointerString$1: function(token) {
      var t2, t3, t4, t5, t6,
        t1 = this.path;
      if (t1.length === 0 && token != null && C.JSString_methods.startsWith$1(token, "/"))
        return token;
      t2 = token != null;
      if (t2)
        C.JSArray_methods.add$1(t1, token);
      t3 = this._sb;
      t4 = t3._contents += "/";
      t5 = P.String;
      t6 = H.getTypeArgumentByIndex(t1, 0);
      t3._contents = P.StringBuffer__writeAll(t4, new H.MappedListIterable(t1, H.functionTypeCheck(new M.Context_getPointerString_closure(), {func: 1, ret: t5, args: [t6]}), [t6, t5]), "/");
      if (t2) {
        if (0 >= t1.length)
          return H.ioore(t1, -1);
        t1.pop();
      }
      t1 = t3._contents;
      t3._contents = "";
      return t1.charCodeAt(0) == 0 ? t1 : t1;
    },
    getPointerString$0: function() {
      return this.getPointerString$1(null);
    },
    initExtensions$2: function(extensionsUsed, extensionsRequired) {
      var t2, t3, t4, t5, t6, i, extensionName, t7, prefix, t8, extension, value, _this = this,
        _s16_ = "/extensionsUsed/",
        t1 = [P.String];
      H.assertSubtype(extensionsUsed, "$isList", t1, "$asList");
      H.assertSubtype(extensionsRequired, "$isList", t1, "$asList");
      C.JSArray_methods.addAll$1(_this._extensionsUsed, extensionsUsed);
      for (t1 = J.getInterceptor$asx(extensionsUsed), t2 = _this._extensionsLoaded, t3 = _this._userExtensions, t4 = C.Set_AiVn._map, t5 = [P.Object], t6 = J.getInterceptor$asx(extensionsRequired), i = 0; i < t1.get$length(extensionsUsed); ++i) {
        extensionName = t1.$index(extensionsUsed, i);
        t7 = $.$get$Context__extNameFormat().firstMatch$1(extensionName);
        if (t7 == null)
          prefix = null;
        else {
          t7 = t7._match;
          if (1 >= t7.length)
            return H.ioore(t7, 1);
          prefix = t7[1];
        }
        if (prefix == null)
          _this.addIssue$2$name($.$get$SemanticError_invalidExtensionNameFormat(), _s16_ + i);
        else if (!t4.containsKey$1(prefix)) {
          t7 = $.$get$SemanticError_unreservedExtensionPrefix();
          t8 = _s16_ + i;
          _this.addIssue$3$args$name(t7, H.setRuntimeTypeInfo([prefix], t5), t8);
        }
        extension = t3.firstWhere$2$orElse(0, new M.Context_initExtensions_closure(extensionName), new M.Context_initExtensions_closure0(extensionName));
        if (extension == null) {
          t7 = $.$get$LinkError_unsupportedExtension();
          t8 = _s16_ + i;
          _this.addIssue$3$args$name(t7, H.setRuntimeTypeInfo([extensionName], t5), t8);
          continue;
        }
        extension.functions.forEach$1(0, new M.Context_initExtensions_closure1(_this, extension));
        t7 = extension.init;
        if (t7 != null)
          t7.call$1(_this);
        t7 = extension.required && !t6.contains$1(extensionsRequired, extensionName);
        if (t7) {
          t7 = $.$get$SemanticError_nonRequiredExtension();
          t8 = _s16_ + i;
          _this.addIssue$3$args$name(t7, H.setRuntimeTypeInfo([extensionName], t5), t8);
        }
        C.JSArray_methods.add$1(t2, extensionName);
      }
      for (i = 0; i < t6.get$length(extensionsRequired); ++i) {
        value = t6.$index(extensionsRequired, i);
        if (!t1.contains$1(extensionsUsed, value)) {
          t2 = $.$get$SemanticError_unusedExtensionRequired();
          t3 = "/extensionsRequired/" + i;
          _this.addIssue$3$args$name(t2, H.setRuntimeTypeInfo([value], t5), t3);
        }
      }
    },
    addIssue$6$args$index$name$noPointer$offset: function(issueType, args, index, $name, noPointer, offset) {
      var t1, t2, t3, severityOverride, token, _this = this;
      H.assertSubtype(args, "$isList", [P.Object], "$asList");
      t1 = _this.options;
      t2 = issueType.code;
      if (t1.ignoredIssues.contains$1(0, t2))
        return;
      t3 = t1.maxIssues;
      if (t3 > 0 && _this._issues.length === t3) {
        _this._isTruncated = true;
        throw H.wrapException(C.C_IssuesLimitExceededException);
      }
      t1 = t1.severityOverrides;
      severityOverride = t1 != null ? t1.$index(0, t2) : null;
      if (offset != null)
        C.JSArray_methods.add$1(_this._issues, new E.Issue(issueType, severityOverride, null, offset, args));
      else {
        token = index != null ? C.JSInt_methods.toString$0(index) : $name;
        t1 = noPointer ? "" : _this.getPointerString$1(token);
        C.JSArray_methods.add$1(_this._issues, new E.Issue(issueType, severityOverride, t1, null, args));
      }
    },
    addIssue$2$name: function(issueType, $name) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, null, null, $name, false, null);
    },
    addIssue$2$args: function(issueType, args) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, args, null, null, false, null);
    },
    addIssue$3$args$name: function(issueType, args, $name) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, args, null, $name, false, null);
    },
    addIssue$1: function(issueType) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, null, null, null, false, null);
    },
    addIssue$3$args$noPointer: function(issueType, args, noPointer) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, args, null, null, noPointer, null);
    },
    addIssue$2$index: function(issueType, index) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, null, index, null, false, null);
    },
    addIssue$3$args$index: function(issueType, args, index) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, args, index, null, false, null);
    },
    addIssue$2$offset: function(issueType, offset) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, null, null, null, false, offset);
    },
    addIssue$3$args$offset: function(issueType, args, offset) {
      return this.addIssue$6$args$index$name$noPointer$offset(issueType, args, null, null, false, offset);
    },
    set$_extensionsFunctionsView: function(_extensionsFunctionsView) {
      this._extensionsFunctionsView = H.assertSubtype(_extensionsFunctionsView, "$isMap", [D.ExtensionTuple, D.ExtFuncs], "$asMap");
    },
    set$_extensionsUsedView: function(_extensionsUsedView) {
      this._extensionsUsedView = H.assertSubtype(_extensionsUsedView, "$isList", [P.String], "$asList");
    },
    set$_extensionsLoadedView: function(_extensionsLoadedView) {
      this._extensionsLoadedView = H.assertSubtype(_extensionsLoadedView, "$isList", [P.String], "$asList");
    },
    set$_resourcesView: function(_resourcesView) {
      this._resourcesView = H.assertSubtype(_resourcesView, "$isList", [[P.Map, P.String, P.Object]], "$asList");
    }
  };
  M.Context_defaultExtensionNames_closure.prototype = {
    call$1: function(e) {
      return H.interceptedTypeCheck(e, "$isExtension").name;
    },
    $signature: 47
  };
  M.Context_addElementChecker_closure.prototype = {
    call$0: function() {
      return H.setRuntimeTypeInfo([], [[F.ElementChecker, P.num]]);
    },
    $signature: 48
  };
  M.Context_getPointerString_closure.prototype = {
    call$1: function(s) {
      var t1;
      H.stringTypeCheck(s);
      s.toString;
      t1 = H.stringReplaceAllUnchecked(s, "~", "~0");
      return H.stringReplaceAllUnchecked(t1, "/", "~1");
    },
    $signature: 49
  };
  M.Context_initExtensions_closure.prototype = {
    call$1: function(extension) {
      return H.interceptedTypeCheck(extension, "$isExtension").name === this.extensionName;
    },
    $signature: 22
  };
  M.Context_initExtensions_closure0.prototype = {
    call$0: function() {
      return C.JSArray_methods.firstWhere$2$orElse(C.List_2nP, new M.Context_initExtensions__closure(this.extensionName), new M.Context_initExtensions__closure0());
    },
    $signature: 51
  };
  M.Context_initExtensions__closure.prototype = {
    call$1: function(extension) {
      return H.interceptedTypeCheck(extension, "$isExtension").name === this.extensionName;
    },
    $signature: 22
  };
  M.Context_initExtensions__closure0.prototype = {
    call$0: function() {
      return;
    },
    $signature: 2
  };
  M.Context_initExtensions_closure1.prototype = {
    call$2: function(type, funcs) {
      this.$this._extensionsFunctions.$indexSet(0, new D.ExtensionTuple(H.interceptedTypeCheck(type, "$isType"), this.extension.name), H.interceptedTypeCheck(funcs, "$isExtFuncs"));
    },
    $signature: 52
  };
  M.IssuesLimitExceededException.prototype = {$isException: 1};
  Y._ImageCodec.prototype = {
    toString$0: function(_) {
      return this._image_decoder$_name;
    }
  };
  Y._ColorPrimaries.prototype = {
    toString$0: function(_) {
      return this._image_decoder$_name;
    }
  };
  Y._ColorTransfer.prototype = {
    toString$0: function(_) {
      return this._image_decoder$_name;
    }
  };
  Y.Format.prototype = {
    toString$0: function(_) {
      return this._image_decoder$_name;
    }
  };
  Y.ImageInfo.prototype = {};
  Y.ImageInfo_parseStreamAsync_closure.prototype = {
    call$1: function(data) {
      var t1, t2, t3, t4;
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      t1 = this._box_0;
      if (!t1.isDetected)
        if (J.get$length$asx(data) < 9) {
          t1.subscription.cancel$0();
          this.completer.completeError$1(C.C_UnexpectedEndOfStreamException);
          return;
        } else {
          t2 = Y.ImageInfo__detectCodec(data);
          t3 = t1.subscription;
          t4 = this.completer;
          switch (t2) {
            case C._ImageCodec_0:
              t1.decoder = new Y.JpegInfoDecoder(t4, t3);
              break;
            case C._ImageCodec_1:
              t2 = new Uint8Array(13);
              t1.decoder = new Y.PngInfoDecoder(C._ColorTransfer_0, C._ColorPrimaries_0, t2, new Uint8Array(32), t4, t3);
              break;
            case C._ImageCodec_2:
              t1.decoder = new Y.WebPInfoDecoder(new Uint8Array(30), t4, t3);
              break;
            default:
              t3.cancel$0();
              t4.completeError$1(C.C_UnsupportedImageFormatException);
              return;
          }
          t1.isDetected = true;
        }
      t1.decoder.add$1(0, data);
    },
    $signature: 23
  };
  Y.ImageInfo_parseStreamAsync_closure1.prototype = {
    call$1: function(e) {
      this._box_0.subscription.cancel$0();
      this.completer.completeError$1(e);
    },
    $signature: 24
  };
  Y.ImageInfo_parseStreamAsync_closure0.prototype = {
    call$0: function() {
      var t1 = this._box_0.decoder;
      t1.subscription.cancel$0();
      t1 = t1.completer;
      if (t1.future._state === 0)
        t1.completeError$1(C.C_UnexpectedEndOfStreamException);
    },
    $signature: 2
  };
  Y.ImageInfo__detectCodec_beginsWith.prototype = {
    call$2: function(a, b) {
      var t2, i,
        t1 = [P.int];
      H.assertSubtype(a, "$isList", t1, "$asList");
      H.assertSubtype(b, "$isList", t1, "$asList");
      for (t1 = b.length, t2 = J.getInterceptor$asx(a), i = 0; i < t1; ++i)
        if (!J.$eq$(t2.$index(a, i), b[i]))
          return false;
      return true;
    },
    $signature: 55
  };
  Y.ImageInfoDecoder.prototype = {$isSink: 1,
    $asSink: function() {
      return [[P.List, P.int]];
    }
  };
  Y.JpegInfoDecoder.prototype = {
    add$1: function(_, data) {
      var e, exception, t1;
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      try {
        this._image_decoder$_add$1(data);
      } catch (exception) {
        t1 = H.unwrapException(exception);
        if (t1 instanceof Y.InvalidDataFormatException) {
          e = t1;
          this.subscription.cancel$0();
          this.completer.completeError$1(e);
        } else
          throw exception;
      }
    },
    _image_decoder$_add$1: function(data) {
      var isSOF, hasSegment, t1, index, availableDataLength, byte, t2, t3, t4, bits, t5, format, _this = this;
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      isSOF = new Y.JpegInfoDecoder__add_isSOF();
      hasSegment = new Y.JpegInfoDecoder__add_hasSegment();
      for (t1 = J.getInterceptor$asx(data), index = 0, availableDataLength = 0; index !== t1.get$length(data);) {
        byte = t1.$index(data, index);
        switch (_this._image_decoder$_state) {
          case 0:
            if (255 === byte)
              _this._image_decoder$_state = 255;
            else
              throw H.wrapException(C.InvalidDataFormatException_sAZ);
            break;
          case 255:
            if (H.boolConversionCheck(hasSegment.call$1(byte))) {
              _this._image_decoder$_state = 1;
              _this._type = byte;
              _this._segmentLength = _this._segmentIndex = 0;
            }
            break;
          case 1:
            if (typeof byte !== "number")
              return byte.$shl();
            _this._segmentLength = byte << 8 >>> 0;
            _this._image_decoder$_state = 2;
            break;
          case 2:
            t2 = _this._segmentLength;
            if (typeof byte !== "number")
              return H.iae(byte);
            t2 += byte;
            _this._segmentLength = t2;
            if (t2 < 2)
              throw H.wrapException(C.InvalidDataFormatException_YbV);
            if (H.boolConversionCheck(isSOF.call$1(_this._type))) {
              t2 = _this._segmentLength;
              _this._sofBuffer = new Uint8Array(t2 - 2);
            }
            _this._image_decoder$_state = 3;
            break;
          case 3:
            availableDataLength = Math.min(t1.get$length(data) - index, _this._segmentLength - _this._segmentIndex - 2);
            t2 = H.boolConversionCheck(isSOF.call$1(_this._type));
            t3 = _this._segmentIndex;
            t4 = t3 + availableDataLength;
            if (t2) {
              t2 = _this._sofBuffer;
              _this._segmentIndex = t4;
              (t2 && C.NativeUint8List_methods).setRange$4(t2, t3, t4, data, index);
              if (_this._segmentIndex === _this._segmentLength - 2) {
                _this.subscription.cancel$0();
                data = _this._sofBuffer;
                t1 = data.length;
                if (0 >= t1)
                  return H.ioore(data, 0);
                bits = data[0];
                if (1 >= t1)
                  return H.ioore(data, 1);
                t2 = data[1];
                if (2 >= t1)
                  return H.ioore(data, 2);
                t3 = data[2];
                if (3 >= t1)
                  return H.ioore(data, 3);
                t4 = data[3];
                if (4 >= t1)
                  return H.ioore(data, 4);
                t5 = data[4];
                if (5 >= t1)
                  return H.ioore(data, 5);
                t1 = data[5];
                if (t1 === 3)
                  format = C.Format_1;
                else
                  format = t1 === 1 ? C.Format_3 : C.Format_0;
                t1 = _this.completer;
                t3 = H.futureOrCheck(new Y.ImageInfo("image/jpeg", bits, format, (t4 << 8 | t5) >>> 0, (t2 << 8 | t3) >>> 0, C._ColorPrimaries_0, C._ColorTransfer_0, false, false), {futureOr: 1, type: H.getTypeArgumentByIndex(t1, 0)});
                t1 = t1.future;
                if (t1._state !== 0)
                  H.throwExpression(P.StateError$("Future already completed"));
                t1._asyncComplete$1(t3);
                return;
              }
            } else {
              _this._segmentIndex = t4;
              if (t4 === _this._segmentLength - 2)
                _this._image_decoder$_state = 255;
            }
            index += availableDataLength;
            continue;
        }
        ++index;
      }
    }
  };
  Y.JpegInfoDecoder__add_isSOF.prototype = {
    call$1: function(marker) {
      if (typeof marker !== "number")
        return marker.$and();
      return (marker & 240) === 192 && marker !== 196 && marker !== 200 && marker !== 204 || marker === 222;
    },
    $signature: 8
  };
  Y.JpegInfoDecoder__add_hasSegment.prototype = {
    call$1: function(marker) {
      var t1;
      if (marker !== 1) {
        if (typeof marker !== "number")
          return marker.$and();
        t1 = (marker & 248) === 208 || marker === 216 || marker === 217 || marker === 255;
      } else
        t1 = true;
      return !t1;
    },
    $signature: 8
  };
  Y.PngInfoDecoder.prototype = {
    add$1: function(_, data) {
      var reset, t1, t2, t3, index, availableDataLength, byte, t4, width, height, bits, format, t5, t6, byteData, _this = this;
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      reset = new Y.PngInfoDecoder_add_reset(_this);
      for (t1 = J.getInterceptor$asx(data), t2 = _this._chunkBytes, t3 = _this._headerChunkBytes, index = 0, availableDataLength = 0; index !== t1.get$length(data);) {
        byte = t1.$index(data, index);
        switch (_this._image_decoder$_state) {
          case 0:
            index += 8;
            _this._image_decoder$_state = 1;
            continue;
          case 1:
            t4 = _this._chunkLength;
            if (typeof byte !== "number")
              return H.iae(byte);
            _this._chunkLength = (t4 << 8 | byte) >>> 0;
            if (++_this._chunkLengthIndex === 4)
              _this._image_decoder$_state = 2;
            break;
          case 2:
            t4 = _this._chunkType;
            if (typeof byte !== "number")
              return H.iae(byte);
            t4 = (t4 << 8 | byte) >>> 0;
            _this._chunkType = t4;
            if (++_this._chunkTypeIndex === 4) {
              switch (t4) {
                case 1229472850:
                  if (_this._chunkLength !== 13) {
                    _this.subscription.cancel$0();
                    t1 = _this.completer;
                    if (t1.future._state === 0)
                      t1.completeError$1(C.InvalidDataFormatException_b84);
                    return;
                  }
                  _this._hasHeader = true;
                  break;
                case 1951551059:
                  _this._hasTrns = true;
                  break;
                case 1665684045:
                  if (_this._chunkLength !== 32) {
                    _this.subscription.cancel$0();
                    t1 = _this.completer;
                    if (t1.future._state === 0)
                      t1.completeError$1(C.InvalidDataFormatException_b84);
                    return;
                  }
                  break;
                case 1934772034:
                  if (_this._chunkLength !== 1) {
                    _this.subscription.cancel$0();
                    t1 = _this.completer;
                    if (t1.future._state === 0)
                      t1.completeError$1(C.InvalidDataFormatException_b84);
                    return;
                  }
                  break;
                case 1883789683:
                  if (_this._chunkLength !== 9) {
                    _this.subscription.cancel$0();
                    t1 = _this.completer;
                    if (t1.future._state === 0)
                      t1.completeError$1(C.InvalidDataFormatException_b84);
                    return;
                  }
                  break;
                case 1732332865:
                  if (_this._chunkLength !== 4) {
                    _this.subscription.cancel$0();
                    t1 = _this.completer;
                    if (t1.future._state === 0)
                      t1.completeError$1(C.InvalidDataFormatException_b84);
                    return;
                  }
                  break;
                case 1766015824:
                  _this._transfer = C._ColorTransfer_3;
                  _this._primaries = C._ColorPrimaries_2;
                  break;
                case 1229209940:
                  _this.subscription.cancel$0();
                  if (!_this._hasHeader)
                    _this.completer.completeError$1(C.InvalidDataFormatException_KIf);
                  t1 = t3.buffer;
                  t1.toString;
                  H._checkViewArguments(t1, 0, null);
                  data = new DataView(t1, 0);
                  width = data.getUint32(0, false);
                  height = data.getUint32(4, false);
                  bits = data.getUint8(8);
                  switch (data.getUint8(9)) {
                    case 0:
                      format = _this._hasTrns ? C.Format_4 : C.Format_3;
                      break;
                    case 2:
                    case 3:
                      format = _this._hasTrns ? C.Format_2 : C.Format_1;
                      break;
                    case 4:
                      format = C.Format_4;
                      break;
                    case 6:
                      format = C.Format_2;
                      break;
                    default:
                      format = C.Format_0;
                  }
                  t1 = _this._primaries;
                  if (t1 === C._ColorPrimaries_0)
                    t1 = _this._primaries = C._ColorPrimaries_1;
                  t2 = _this._transfer;
                  if (t2 === C._ColorTransfer_0)
                    t2 = _this._transfer = C._ColorTransfer_2;
                  t3 = _this.completer;
                  t2 = H.futureOrCheck(new Y.ImageInfo("image/png", bits, format, width, height, t1, t2, _this._hasNonSquarePixels, false), {futureOr: 1, type: H.getTypeArgumentByIndex(t3, 0)});
                  t1 = t3.future;
                  if (t1._state !== 0)
                    H.throwExpression(P.StateError$("Future already completed"));
                  t1._asyncComplete$1(t2);
                  return;
              }
              if (_this._chunkLength === 0)
                _this._image_decoder$_state = 4;
              else
                _this._image_decoder$_state = 3;
            }
            break;
          case 3:
            t4 = t1.get$length(data);
            t5 = _this._chunkLength;
            t6 = _this._chunkDataIndex;
            availableDataLength = Math.min(t4 - index, t5 - t6);
            switch (_this._chunkType) {
              case 1229472850:
                t4 = t6 + availableDataLength;
                _this._chunkDataIndex = t4;
                C.NativeUint8List_methods.setRange$4(t3, t6, t4, data, index);
                break;
              case 1665684045:
              case 1732332865:
              case 1883789683:
                t4 = t6 + availableDataLength;
                _this._chunkDataIndex = t4;
                C.NativeUint8List_methods.setRange$4(t2, t6, t4, data, index);
                break;
              case 1934772034:
                _this._transfer = C._ColorTransfer_2;
                _this._primaries = C._ColorPrimaries_1;
                _this._chunkDataIndex = t6 + 1;
                break;
              default:
                _this._chunkDataIndex = t6 + availableDataLength;
            }
            if (_this._chunkDataIndex === _this._chunkLength) {
              switch (_this._chunkType) {
                case 1665684045:
                  if (_this._primaries === C._ColorPrimaries_0)
                    _this._checkChrm$0();
                  break;
                case 1732332865:
                  if (_this._transfer === C._ColorTransfer_0)
                    _this._checkGama$0();
                  break;
                case 1883789683:
                  t4 = t2.buffer;
                  t4.toString;
                  H._checkViewArguments(t4, 0, null);
                  byteData = new DataView(t4, 0);
                  if (byteData.getUint32(0, false) !== byteData.getUint32(4, false))
                    _this._hasNonSquarePixels = true;
                  break;
              }
              _this._image_decoder$_state = 4;
            }
            index += availableDataLength;
            continue;
          case 4:
            if (++_this._chunkCrcIndex === 4) {
              reset.call$0();
              _this._image_decoder$_state = 1;
            }
            break;
        }
        ++index;
      }
    },
    _checkGama$0: function() {
      var t1, _this = this;
      if (_this._transfer === C._ColorTransfer_2)
        return;
      t1 = _this._chunkBytes.buffer;
      t1.toString;
      switch (H.NativeByteData_NativeByteData$view(t1, 0, null).getUint32(0, false)) {
        case 45455:
          _this._transfer = C._ColorTransfer_2;
          break;
        case 100000:
          _this._transfer = C._ColorTransfer_1;
          break;
        default:
          _this._transfer = C._ColorTransfer_3;
      }
    },
    _checkChrm$0: function() {
      var t1, data, _this = this;
      if (_this._primaries === C._ColorPrimaries_1)
        return;
      t1 = _this._chunkBytes.buffer;
      t1.toString;
      data = H.NativeByteData_NativeByteData$view(t1, 0, null);
      if (data.getUint32(0, false) === 31270 && data.getUint32(4, false) === 32900 && data.getUint32(8, false) === 64000 && data.getUint32(12, false) === 33000 && data.getUint32(16, false) === 30000 && data.getUint32(20, false) === 60000 && data.getUint32(24, false) === 15000 && data.getUint32(28, false) === 6000)
        _this._primaries = C._ColorPrimaries_1;
      else
        _this._primaries = C._ColorPrimaries_2;
    }
  };
  Y.PngInfoDecoder_add_reset.prototype = {
    call$0: function() {
      var t1 = this.$this;
      t1._chunkCrcIndex = t1._chunkDataIndex = t1._chunkTypeIndex = t1._chunkType = t1._chunkLengthIndex = t1._chunkLength = 0;
    },
    $signature: 1
  };
  Y.WebPInfoDecoder.prototype = {
    add$1: function(_, bytes) {
      var t1, t2, t3, byteData, width, height, format, hasCustomColorInfo, hasAnimation, features, _this = this;
      H.assertSubtype(bytes, "$isList", [P.int], "$asList");
      t1 = J.get$length$asx(bytes);
      t2 = _this._bufferIndex;
      t3 = _this._image_decoder$_buffer;
      t1 = t2 + Math.min(t1, 30 - t2);
      _this._bufferIndex = t1;
      C.NativeUint8List_methods.setRange$3(t3, t2, t1, bytes);
      t1 = _this._bufferIndex;
      if (t1 >= 25)
        t1 = t1 < 30 && t3[15] !== 76;
      else
        t1 = true;
      if (t1)
        return;
      _this.subscription.cancel$0();
      t1 = t3.buffer;
      t1.toString;
      byteData = H.NativeByteData_NativeByteData$view(t1, 0, null);
      if (byteData.getUint32(0, false) !== 1380533830 || byteData.getUint32(8, false) !== 1464156752) {
        _this._abort$1(C.InvalidDataFormatException_AgZ);
        return;
      }
      switch (byteData.getUint32(12, false)) {
        case 1448097824:
          width = byteData.getUint16(26, true) & 16383;
          height = byteData.getUint16(28, true) & 16383;
          format = C.Format_1;
          hasCustomColorInfo = false;
          hasAnimation = false;
          break;
        case 1448097868:
          t1 = t3[21];
          t2 = t3[22];
          width = 1 + ((t1 | (t2 & 63) << 8) >>> 0);
          t1 = t3[23];
          t3 = t3[24];
          height = 1 + ((t2 >>> 6 | t1 << 2 | (t3 & 15) << 10) >>> 0);
          format = (t3 & 16) === 16 ? C.Format_2 : C.Format_1;
          hasCustomColorInfo = false;
          hasAnimation = false;
          break;
        case 1448097880:
          features = t3[20];
          hasAnimation = (features & 2) === 2;
          hasCustomColorInfo = (features & 32) === 32;
          format = (features & 16) === 16 ? C.Format_2 : C.Format_1;
          width = ((t3[24] | t3[25] << 8 | t3[26] << 16) >>> 0) + 1;
          height = ((t3[27] | t3[28] << 8 | t3[29] << 16) >>> 0) + 1;
          break;
        default:
          _this._abort$1(C.InvalidDataFormatException_AgZ);
          return;
      }
      t1 = hasCustomColorInfo ? C._ColorTransfer_3 : C._ColorTransfer_2;
      _this.completer.complete$1(Y.ImageInfo$_("image/webp", 8, format, width, height, hasCustomColorInfo ? C._ColorPrimaries_2 : C._ColorPrimaries_1, t1, hasAnimation, false));
    },
    _abort$1: function(error) {
      var t1;
      this.subscription.cancel$0();
      t1 = this.completer;
      if (t1.future._state === 0)
        t1.completeError$1(error);
    }
  };
  Y.UnsupportedImageFormatException.prototype = {$isException: 1};
  Y.UnexpectedEndOfStreamException.prototype = {$isException: 1};
  Y.InvalidDataFormatException.prototype = {
    toString$0: function(_) {
      return this.message;
    },
    $isException: 1
  };
  N._Storage.prototype = {
    toString$0: function(_) {
      return this._resources_loader$_name;
    }
  };
  N.ResourceInfo.prototype = {
    toMap$0: function() {
      var t4, _this = this,
        t1 = P.String,
        t2 = P.Object,
        t3 = P.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
      t3.$indexSet(0, "pointer", _this.pointer);
      t4 = _this.mimeType;
      if (t4 != null)
        t3.$indexSet(0, "mimeType", t4);
      t4 = _this.storage;
      if (t4 != null) {
        t4 = t4.index;
        if (t4 >= 4)
          return H.ioore(C.List_UWS, t4);
        t3.$indexSet(0, "storage", C.List_UWS[t4]);
      }
      t4 = _this.uri;
      if (t4 != null)
        t3.$indexSet(0, "uri", t4);
      t4 = _this.byteLength;
      if (t4 != null)
        t3.$indexSet(0, "byteLength", t4);
      t4 = _this.image;
      if (t4 == null)
        t1 = null;
      else {
        t1 = P.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
        t1.$indexSet(0, "width", t4.width);
        t1.$indexSet(0, "height", t4.height);
        t2 = t4.format;
        if (t2 !== C.Format_0) {
          t2 = t2.index;
          if (t2 >= 5)
            return H.ioore(C.List_qVm, t2);
          t1.$indexSet(0, "format", C.List_qVm[t2]);
        }
        t2 = t4.colorPrimaries;
        if (t2 !== C._ColorPrimaries_0) {
          t2 = t2.index;
          if (t2 >= 3)
            return H.ioore(C.List_null_srgb_custom, t2);
          t1.$indexSet(0, "primaries", C.List_null_srgb_custom[t2]);
        }
        t2 = t4.colorTransfer;
        if (t2 !== C._ColorTransfer_0) {
          t2 = t2.index;
          if (t2 >= 4)
            return H.ioore(C.List_null_linear_srgb_custom, t2);
          t1.$indexSet(0, "transfer", C.List_null_linear_srgb_custom[t2]);
        }
        t2 = t4.bits;
        if (typeof t2 !== "number")
          return t2.$gt();
        if (t2 > 0)
          t1.$indexSet(0, "bits", t2);
      }
      if (t1 != null)
        t3.$indexSet(0, "image", t1);
      return t3;
    }
  };
  N.ResourcesLoader.prototype = {
    load$1$validateAccessorData: function(validateAccessorData) {
      return this.load$body$ResourcesLoader(validateAccessorData);
    },
    load$body$ResourcesLoader: function(validateAccessorData) {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter(-1),
        $async$returnValue, $async$handler = 2, $async$currentError, $async$next = [], $async$self = this, exception, $async$exception;
      var $async$load$1$validateAccessorData = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1) {
          $async$currentError = $async$result;
          $async$goto = $async$handler;
        }
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              $async$handler = 4;
              $async$goto = 7;
              return P._asyncAwait($async$self._loadBuffers$0(), $async$load$1$validateAccessorData);
            case 7:
              // returning from await.
              $async$goto = 8;
              return P._asyncAwait($async$self._loadImages$0(), $async$load$1$validateAccessorData);
            case 8:
              // returning from await.
              if (validateAccessorData)
                O.validateAccessorsData($async$self.gltf, $async$self.context);
              $async$self.gltf.validateResources$1($async$self.context);
              $async$handler = 2;
              // goto after finally
              $async$goto = 6;
              break;
            case 4:
              // catch
              $async$handler = 3;
              $async$exception = $async$currentError;
              if (H.unwrapException($async$exception) instanceof M.IssuesLimitExceededException) {
                // goto return
                $async$goto = 1;
                break;
              } else
                throw $async$exception;
              // goto after finally
              $async$goto = 6;
              break;
            case 3:
              // uncaught
              // goto rethrow
              $async$goto = 2;
              break;
            case 6:
              // after finally
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
            case 2:
              // rethrow
              return P._asyncRethrow($async$currentError, $async$completer);
          }
      });
      return P._asyncStartSync($async$load$1$validateAccessorData, $async$completer);
    },
    _loadBuffers$0: function() {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter(-1),
        $async$returnValue, $async$handler = 2, $async$currentError, $async$next = [], $async$self = this, buffer, _fetchBuffer, data, e, t3, t4, t5, t6, t7, t8, i, t9, buffer0, info, exception, paddedLength, t1, t2, $async$exception, $async$temp1;
      var $async$_loadBuffers$0 = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1) {
          $async$currentError = $async$result;
          $async$goto = $async$handler;
        }
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              t1 = $async$self.context;
              t2 = t1.path;
              C.JSArray_methods.set$length(t2, 0);
              C.JSArray_methods.add$1(t2, "buffers");
              t3 = $async$self.gltf.buffers, t4 = t3._utils$_length, t5 = P.Object, t6 = [P.String, t5], t7 = t1._resources, t5 = [t5], t3 = t3._list, t8 = t3.length, i = 0;
            case 3:
              // for condition
              if (!(i < t4)) {
                // goto after for
                $async$goto = 5;
                break;
              }
              t9 = i >= t8;
              if (t9)
                buffer0 = null;
              else {
                if (i >= t8) {
                  $async$returnValue = H.ioore(t3, i);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                buffer0 = t3[i];
              }
              buffer = buffer0;
              if (buffer == null) {
                // goto for update
                $async$goto = 4;
                break;
              }
              C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
              info = new N.ResourceInfo(t1.getPointerString$0());
              info.mimeType = "application/gltf-buffer";
              _fetchBuffer = new N.ResourcesLoader__loadBuffers__fetchBuffer($async$self, info, i);
              data = null;
              $async$handler = 7;
              $async$temp1 = H;
              $async$goto = 10;
              return P._asyncAwait(_fetchBuffer.call$1(buffer), $async$_loadBuffers$0);
            case 10:
              // returning from await.
              data = $async$temp1.interceptedTypeCast($async$result, "$isUint8List");
              $async$handler = 2;
              // goto after finally
              $async$goto = 9;
              break;
            case 7:
              // catch
              $async$handler = 6;
              $async$exception = $async$currentError;
              t9 = H.unwrapException($async$exception);
              if (!!J.getInterceptor$(t9).$isException) {
                e = t9;
                t1.addIssue$3$args$name($.$get$IoError_ioError(), H.setRuntimeTypeInfo([e], t5), "uri");
              } else
                throw $async$exception;
              // goto after finally
              $async$goto = 9;
              break;
            case 6:
              // uncaught
              // goto rethrow
              $async$goto = 2;
              break;
            case 9:
              // after finally
              if (data != null) {
                info.byteLength = J.get$length$asx(data);
                if (J.get$length$asx(data) < buffer.byteLength)
                  t1.addIssue$2$args($.$get$DataError_bufferExternalBytelengthMismatch(), H.setRuntimeTypeInfo([J.get$length$asx(data), buffer.byteLength], t5));
                else {
                  if (t1._isGlb && i === 0 && !buffer.hasUri) {
                    t9 = buffer.byteLength;
                    paddedLength = t9 + (4 - (t9 & 3) & 3);
                    if (J.get$length$asx(data) > paddedLength)
                      t1.addIssue$2$args($.$get$DataError_bufferGlbChunkTooBig(), H.setRuntimeTypeInfo([J.get$length$asx(data) - paddedLength], t5));
                  }
                  t9 = buffer;
                  if (t9.data == null)
                    t9.data = H.interceptedTypeCheck(data, "$isUint8List");
                }
              }
              C.JSArray_methods.add$1(t7, H.assertSubtype(info.toMap$0(), "$isMap", t6, "$asMap"));
              if (0 >= t2.length) {
                $async$returnValue = H.ioore(t2, -1);
                // goto return
                $async$goto = 1;
                break;
              }
              t2.pop();
            case 4:
              // for update
              ++i;
              // goto for condition
              $async$goto = 3;
              break;
            case 5:
              // after for
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
            case 2:
              // rethrow
              return P._asyncRethrow($async$currentError, $async$completer);
          }
      });
      return P._asyncStartSync($async$_loadBuffers$0, $async$completer);
    },
    _loadImages$0: function() {
      var $async$goto = 0,
        $async$completer = P._makeAsyncAwaitCompleter(-1),
        $async$returnValue, $async$handler = 2, $async$currentError, $async$next = [], $async$self = this, image, _fetchImageData, imageDataStream, e, imageInfo, e0, e1, t3, t4, t5, t6, t7, t8, t9, i, t10, image0, resourceInfo, exception, t11, t1, t2, $async$exception;
      var $async$_loadImages$0 = P._wrapJsFunctionForAsync(function($async$errorCode, $async$result) {
        if ($async$errorCode === 1) {
          $async$currentError = $async$result;
          $async$goto = $async$handler;
        }
        while (true)
          switch ($async$goto) {
            case 0:
              // Function start
              t1 = $async$self.context;
              t2 = t1.path;
              C.JSArray_methods.set$length(t2, 0);
              C.JSArray_methods.add$1(t2, "images");
              t3 = $async$self.gltf.images, t4 = t3._utils$_length, t5 = P.Object, t6 = [P.String, t5], t7 = t1._resources, t5 = [t5], t8 = t1.imageMimeTypes, t3 = t3._list, t9 = t3.length, i = 0;
            case 3:
              // for condition
              if (!(i < t4)) {
                // goto after for
                $async$goto = 5;
                break;
              }
              t10 = i >= t9;
              if (t10)
                image0 = null;
              else {
                if (i >= t9) {
                  $async$returnValue = H.ioore(t3, i);
                  // goto return
                  $async$goto = 1;
                  break;
                }
                image0 = t3[i];
              }
              image = image0;
              if (image == null) {
                // goto for update
                $async$goto = 4;
                break;
              }
              C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
              resourceInfo = new N.ResourceInfo(t1.getPointerString$0());
              _fetchImageData = new N.ResourcesLoader__loadImages__fetchImageData($async$self, resourceInfo);
              imageDataStream = null;
              try {
                imageDataStream = _fetchImageData.call$1(image);
              } catch (exception) {
                t10 = H.unwrapException(exception);
                if (!!J.getInterceptor$(t10).$isException) {
                  e = t10;
                  t1.addIssue$3$args$name($.$get$IoError_ioError(), H.setRuntimeTypeInfo([e], t5), "uri");
                } else
                  throw exception;
              }
              imageInfo = null;
              $async$goto = imageDataStream != null ? 6 : 7;
              break;
            case 6:
              // then
              $async$handler = 9;
              $async$goto = 12;
              return P._asyncAwait(Y.ImageInfo_parseStreamAsync(imageDataStream), $async$_loadImages$0);
            case 12:
              // returning from await.
              imageInfo = $async$result;
              t10 = C.JSArray_methods.contains$1(t8, imageInfo.mimeType);
              if (!t10)
                t1.addIssue$2$args($.$get$DataError_imageNonEnabledMimeType(), H.setRuntimeTypeInfo([imageInfo.mimeType], t5));
              $async$handler = 2;
              // goto after finally
              $async$goto = 11;
              break;
            case 9:
              // catch
              $async$handler = 8;
              $async$exception = $async$currentError;
              t10 = H.unwrapException($async$exception);
              t11 = J.getInterceptor$(t10);
              if (!!t11.$isUnsupportedImageFormatException)
                t1.addIssue$1($.$get$DataError_imageUnrecognizedFormat());
              else if (!!t11.$isUnexpectedEndOfStreamException)
                t1.addIssue$1($.$get$DataError_imageUnexpectedEos());
              else if (!!t11.$isInvalidDataFormatException) {
                e0 = t10;
                t1.addIssue$2$args($.$get$DataError_imageDataInvalid(), H.setRuntimeTypeInfo([e0], t5));
              } else if (!!t11.$isException) {
                e1 = t10;
                t1.addIssue$3$args$name($.$get$IoError_ioError(), H.setRuntimeTypeInfo([e1], t5), "uri");
              } else
                throw $async$exception;
              // goto after finally
              $async$goto = 11;
              break;
            case 8:
              // uncaught
              // goto rethrow
              $async$goto = 2;
              break;
            case 11:
              // after finally
              if (imageInfo != null) {
                resourceInfo.mimeType = imageInfo.mimeType;
                if (image.mimeType != null && image.mimeType !== imageInfo.mimeType)
                  t1.addIssue$2$args($.$get$DataError_imageMimeTypeInvalid(), H.setRuntimeTypeInfo([imageInfo.mimeType, image.mimeType], t5));
                t10 = imageInfo.width;
                if (t10 !== 0 && (t10 & t10 - 1) >>> 0 === 0) {
                  t10 = imageInfo.height;
                  t10 = !(t10 !== 0 && (t10 & t10 - 1) >>> 0 === 0);
                } else
                  t10 = true;
                if (t10)
                  t1.addIssue$2$args($.$get$DataError_imageNonPowerOfTwoDimensions(), H.setRuntimeTypeInfo([imageInfo.width, imageInfo.height], t5));
                t10 = imageInfo;
                if (t10.colorPrimaries === C._ColorPrimaries_2 || t10.colorTransfer === C._ColorTransfer_3 || imageInfo.hasAnimation || imageInfo.hasNonSquarePixels)
                  t1.addIssue$1($.$get$DataError_imageFeaturesUnsupported());
                image.info = H.interceptedTypeCheck(imageInfo, "$isImageInfo");
                resourceInfo.image = H.interceptedTypeCheck(imageInfo, "$isImageInfo");
              }
            case 7:
              // join
              C.JSArray_methods.add$1(t7, H.assertSubtype(resourceInfo.toMap$0(), "$isMap", t6, "$asMap"));
              if (0 >= t2.length) {
                $async$returnValue = H.ioore(t2, -1);
                // goto return
                $async$goto = 1;
                break;
              }
              t2.pop();
            case 4:
              // for update
              ++i;
              // goto for condition
              $async$goto = 3;
              break;
            case 5:
              // after for
            case 1:
              // return
              return P._asyncReturn($async$returnValue, $async$completer);
            case 2:
              // rethrow
              return P._asyncRethrow($async$currentError, $async$completer);
          }
      });
      return P._asyncStartSync($async$_loadImages$0, $async$completer);
    }
  };
  N.ResourcesLoader__loadBuffers__fetchBuffer.prototype = {
    call$1: function(buffer) {
      var t1, t2, data, _this = this;
      if (buffer.extensions.__js_helper$_length === 0) {
        t1 = buffer.uri;
        if (t1 != null) {
          t2 = _this.info;
          t2.storage = C._Storage_3;
          t2.uri = t1.toString$0(0);
          return _this.$this.externalBytesFetch.call$1(t1);
        } else {
          t1 = buffer.data;
          if (t1 != null) {
            _this.info.storage = C._Storage_0;
            return t1;
          } else {
            t1 = _this.$this;
            t2 = t1.context;
            if (t2._isGlb && _this.i === 0 && !buffer.hasUri) {
              _this.info.storage = C._Storage_2;
              data = t1.externalBytesFetch.call$0();
              if (data == null)
                t2.addIssue$1($.$get$LinkError_bufferMissingGlbData());
              return data;
            }
          }
        }
      }
      return;
    },
    $signature: 56
  };
  N.ResourcesLoader__loadImages__fetchImageData.prototype = {
    call$1: function(image) {
      var t1, t2, _this = this;
      if (image.extensions.__js_helper$_length === 0) {
        t1 = image.uri;
        if (t1 != null) {
          t2 = _this.resourceInfo;
          t2.storage = C._Storage_3;
          t2.uri = t1.toString$0(0);
          return _this.$this.externalStreamFetch.call$1(t1);
        } else {
          t1 = image.data;
          if (t1 != null && image.mimeType != null) {
            _this.resourceInfo.storage = C._Storage_0;
            t2 = [P.List, P.int];
            return P.Stream_Stream$fromIterable(H.setRuntimeTypeInfo([t1], [t2]), t2);
          } else if (image._image$_bufferView != null) {
            _this.resourceInfo.storage = C._Storage_1;
            image.tryLoadFromBufferView$0();
            t1 = image.data;
            if (t1 != null) {
              t2 = [P.List, P.int];
              return P.Stream_Stream$fromIterable(H.setRuntimeTypeInfo([t1], [t2]), t2);
            }
          }
        }
      }
      return;
    },
    $signature: 57
  };
  O.validateAccessorsData_closure.prototype = {
    call$2: function(i, accessor) {
      var t2, view, t3, t4, index, lastValue, _i, value,
        t1 = P.num;
      H.assertSubtype(accessor, "$isAccessor", [t1], "$asAccessor");
      t1 = O._guardAccessor(accessor, t1);
      if ((t1 == null ? null : t1.sparse) != null) {
        t1 = this.context;
        t2 = t1.path;
        C.JSArray_methods.set$length(t2, 0);
        C.JSArray_methods.add$1(t2, "accessors");
        C.JSArray_methods.add$1(t2, C.JSInt_methods.toString$0(i));
        view = accessor.sparse.get$indicesTypedView();
        if (view != null)
          for (t2 = view.length, t3 = accessor.count, t4 = [P.Object], index = 0, lastValue = -1, _i = 0; _i < t2; ++_i, lastValue = value) {
            value = view[_i];
            if (lastValue !== -1 && value <= lastValue)
              t1.addIssue$3$args$name($.$get$DataError_accessorSparseIndicesNonIncreasing(), H.setRuntimeTypeInfo([index, value, lastValue], t4), "sparse");
            if (value >= t3)
              t1.addIssue$3$args$name($.$get$DataError_accessorSparseIndexOob(), H.setRuntimeTypeInfo([index, value, t3], t4), "sparse");
            ++index;
          }
      }
    },
    $signature: 58
  };
  O.validateAccessorsData_closure0.prototype = {
    call$1: function(primitive) {
      return H.interceptedTypeCheck(primitive, "$isMeshPrimitive").jointsCount === 0;
    },
    $signature: 3
  };
  O.validateAccessorsData_closure1.prototype = {
    call$2: function(primitiveIndex, primitive) {
      var vertexCount, t1, t2, jointsIterators, weightsIterators, skipValidation, t3, t4, t5, i, jointsAccessor, weightsAccessor, t6, _this = this;
      H.interceptedTypeCheck(primitive, "$isMeshPrimitive");
      vertexCount = primitive._vertexCount;
      t1 = primitive.jointsCount;
      t2 = new Array(t1);
      t2.fixed$length = Array;
      jointsIterators = H.setRuntimeTypeInfo(t2, [[P.Iterator, P.int]]);
      t2 = new Array(t1);
      t2.fixed$length = Array;
      weightsIterators = H.setRuntimeTypeInfo(t2, [[P.Iterator, P.double]]);
      t2 = P.int;
      t3 = [t2];
      t4 = primitive.attributes;
      t5 = P.num;
      i = 0;
      while (true) {
        if (!(i < t1)) {
          skipValidation = false;
          break;
        }
        jointsAccessor = O._guardAccessor(t4.$index(0, "JOINTS_" + i), t5);
        weightsAccessor = O._guardAccessor(t4.$index(0, "WEIGHTS_" + i), t5);
        if ((jointsAccessor == null ? null : jointsAccessor.count) === vertexCount)
          t6 = (weightsAccessor == null ? null : weightsAccessor.count) !== vertexCount;
        else
          t6 = true;
        if (t6) {
          skipValidation = true;
          break;
        }
        t6 = H.subtypeCast(jointsAccessor, "$isAccessor", t3, "$asAccessor").getElements$0();
        C.JSArray_methods.$indexSet(jointsIterators, i, new P._SyncStarIterator(t6._outerHelper(), [H.getTypeArgumentByIndex(t6, 0)]));
        t6 = weightsAccessor.getElementsNormalized$0();
        C.JSArray_methods.$indexSet(weightsIterators, i, new P._SyncStarIterator(t6._outerHelper(), [H.getTypeArgumentByIndex(t6, 0)]));
        ++i;
      }
      if (skipValidation)
        return;
      t1 = _this.context;
      t3 = t1.path;
      C.JSArray_methods.add$1(t3, C.JSInt_methods.toString$0(primitiveIndex));
      C.JSArray_methods.add$1(t3, "attributes");
      t4 = _this.influencesIterators;
      C.JSArray_methods.addAll$1(t4, jointsIterators);
      C.JSArray_methods.addAll$1(t4, weightsIterators);
      t1 = t1.getPointerString$0();
      t4 = _this._box_0;
      C.JSArray_methods.add$1(_this.influencesCheckers, new O.InfluencesChecker(jointsIterators, weightsIterators, t4.maxJoints - 1, t4.limitingSkinIndex, t1, P.LinkedHashSet_LinkedHashSet$_empty(t2)));
      if (0 >= t3.length)
        return H.ioore(t3, -1);
      t3.pop();
      if (0 >= t3.length)
        return H.ioore(t3, -1);
      t3.pop();
    },
    $signature: 20
  };
  O._stepInfluencesIterators_closure.prototype = {
    call$1: function(iterator) {
      return H.assertSubtype(iterator, "$isIterator", [P.num], "$asIterator").get$current() == null;
    },
    $signature: 59
  };
  O.InfluencesChecker.prototype = {
    checkNext$1: function(context) {
      var t1, t2, t3, t4, t5, t6, t7, t8, t9, i, joint, t10, t11, weight, unique, _this = this;
      for (t1 = _this.jointsIterators, t2 = t1.length, t3 = _this.weightsIterators, t4 = t3.length, t5 = _this.maxJointIndex, t6 = _this.path, t7 = [P.Object], t8 = _this._currentIndices, t9 = _this.limitingSkinIndex, i = 0; i < t2; ++i) {
        joint = t1[i].get$current();
        if (joint == null) {
          _this._done = true;
          return;
        }
        if (joint > t5) {
          t10 = $.$get$DataError_accessorJointsIndexOob();
          t11 = t6 + "/JOINTS_" + i;
          context.addIssue$3$args$name(t10, H.setRuntimeTypeInfo([_this._validate_accessors$_index, _this._componentIndex, joint, t5, t9], t7), t11);
          continue;
        }
        if (i >= t4)
          return H.ioore(t3, i);
        weight = t3[i].get$current();
        if (weight !== 0) {
          if (!t8.add$1(0, joint)) {
            t10 = $.$get$DataError_accessorJointsIndexDuplicate();
            t11 = t6 + "/JOINTS_" + i;
            context.addIssue$3$args$name(t10, H.setRuntimeTypeInfo([_this._validate_accessors$_index, _this._componentIndex, joint], t7), t11);
            unique = false;
          } else
            unique = true;
          if (typeof weight !== "number")
            return weight.$lt();
          if (weight < 0) {
            t10 = $.$get$DataError_accessorWeightsNegative();
            t11 = t6 + "/WEIGHTS_" + i;
            context.addIssue$3$args$name(t10, H.setRuntimeTypeInfo([_this._validate_accessors$_index, _this._componentIndex, weight], t7), t11);
          } else if (unique) {
            t10 = _this._sum;
            t11 = $.$get$_float();
            t11[0] = t10 + weight;
            _this._sum = t11[0];
            _this._threshold += 2e-7;
          }
        } else if (joint !== 0) {
          t10 = $.$get$DataError_accessorJointsUsedZeroWeight();
          t11 = t6 + "/JOINTS_" + i;
          context.addIssue$3$args$name(t10, H.setRuntimeTypeInfo([_this._validate_accessors$_index, _this._componentIndex, joint], t7), t11);
        }
      }
      if (4 === ++_this._componentIndex) {
        if (Math.abs(_this._sum - 1) > _this._threshold)
          for (i = 0; i < t2; ++i) {
            t1 = $.$get$DataError_accessorWeightsNonNormalized();
            t3 = t6 + "/WEIGHTS_" + i;
            t4 = _this._validate_accessors$_index;
            context.addIssue$3$args$name(t1, H.setRuntimeTypeInfo([t4 - 3, t4, _this._sum], t7), t3);
          }
        t8.clear$0(0);
        _this._sum = _this._threshold = _this._componentIndex = 0;
      }
      ++_this._validate_accessors$_index;
    }
  };
  E.Severity.prototype = {
    toString$0: function(_) {
      return this._errors$_name;
    }
  };
  E.IssueType.prototype = {};
  E.DataError.prototype = {};
  E.DataError_closure16.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Actual Data URI encoded data length " + H.S(args[0]) + " is not equal to the declared buffer byteLength ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure14.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Actual data length " + H.S(args[0]) + " is less than the declared buffer byteLength ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure13.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "GLB-stored BIN chunk contains " + H.S(args[0]) + " extra padding byte(s).";
    },
    $signature: 0
  };
  E.DataError_closure20.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Declared minimum value for this component (" + H.S(args[0]) + ") does not match actual minimum (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.DataError_closure18.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Declared maximum value for this component (" + H.S(args[0]) + ") does not match actual maximum (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.DataError_closure19.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor contains " + H.S(args[0]) + " element(s) less than declared minimum value ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure17.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor contains " + H.S(args[0]) + " element(s) greater than declared maximum value ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure29.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Vector3 at accessor indices " + H.S(args[0]) + "..";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " is not of unit length: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure30.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Vector3 with sign at accessor indices " + H.S(args[0]) + "..";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " has invalid w component: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ". Must be 1.0 or -1.0.";
    },
    $signature: 0
  };
  E.DataError_closure22.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Animation sampler output accessor element at indices " + H.S(args[0]) + "..";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " is not of unit length: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure28.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor element at index " + H.S(args[0]) + " is not clamped to 0..1 range: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure21.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor element at index " + H.S(args[0]) + " is ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure27.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Indices accessor element at index " + H.S(args[0]) + " has value ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " that is greater than the maximum vertex index available (";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ").";
    },
    $signature: 0
  };
  E.DataError_closure25.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Indices accessor contains " + H.S(args[0]) + " degenerate triangles (out of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.DataError_closure26.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Indices accessor contains primitive restart value (" + H.S(args[0]) + ") at index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure24.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Animation input accessor element at index " + H.S(args[0]) + " is negative: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure23.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Animation input accessor element at index " + H.S(args[0]) + " is less than or equal to previous: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " <= ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure5.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor sparse indices element at index " + H.S(args[0]) + " is less than or equal to previous: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " <= ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure4.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor sparse indices element at index " + H.S(args[0]) + " is greater than or equal to the number of accessor elements: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " >= ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure31.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Matrix element at index " + H.S(args[0]) + " (component index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") contains invalid value: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure9.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Image data is invalid. " + H.S(args[0]);
    },
    $signature: 0
  };
  E.DataError_closure8.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Recognized image format " + ("'" + H.S(args[0]) + "'") + " does not match declared image format ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.DataError_closure10.prototype = {
    call$1: function(args) {
      return "Unexpected end of image stream.";
    },
    $signature: 0
  };
  E.DataError_closure11.prototype = {
    call$1: function(args) {
      return "Image format not recognized.";
    },
    $signature: 0
  };
  E.DataError_closure12.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "'" + H.S(args[0]) + "' MIME type requires an extension.";
    },
    $signature: 0
  };
  E.DataError_closure7.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Image has non-power-of-two dimensions: " + H.S(args[0]) + "x";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure6.prototype = {
    call$1: function(args) {
      return "Image contains unsupported features like non-default colorspace information, non-square pixels, or animation.";
    },
    $signature: 0
  };
  E.DataError_closure15.prototype = {
    call$1: function(args) {
      return "Data URI is used in GLB container.";
    },
    $signature: 0
  };
  E.DataError_closure3.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Joints accessor element at index " + H.S(args[0]) + " (component index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") has value ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      t1 = t1 + H.S(args[2]) + " that is greater than the maximum joint index (";
      if (3 >= args.length)
        return H.ioore(args, 3);
      t1 = t1 + H.S(args[3]) + ") set by skin ";
      if (4 >= args.length)
        return H.ioore(args, 4);
      return t1 + H.S(args[4]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure2.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Joints accessor element at index " + H.S(args[0]) + " (component index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") has value ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + " that is already in use for the vertex.";
    },
    $signature: 0
  };
  E.DataError_closure1.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Weights accessor element at index " + H.S(args[0]) + " (component index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") has negative value ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Weights accessor elements (at indices " + H.S(args[0]) + "..";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") have non-normalized sum: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.DataError_closure0.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Joints accessor element at index " + H.S(args[0]) + " (component index ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") is used with zero weight but has non-zero value (";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ").";
    },
    $signature: 0
  };
  E.IoError.prototype = {};
  E.IoError_closure.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return J.toString$0$(args[0]);
    },
    $signature: 0
  };
  E.SchemaError.prototype = {};
  E.SchemaError_closure3.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid array length " + H.S(args[0]) + ". Valid lengths are: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___mbq$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure4.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = args[0];
      t1 = "Type mismatch. Array element " + H.S(typeof t1 === "string" ? "'" + t1 + "'" : J.toString$0$(t1)) + " is not a ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure9.prototype = {
    call$1: function(args) {
      return "Duplicate element.";
    },
    $signature: 0
  };
  E.SchemaError_closure7.prototype = {
    call$1: function(_) {
      return "Index must be a non-negative integer.";
    },
    $signature: 0
  };
  E.SchemaError_closure14.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Invalid JSON data. Parser output: " + H.S(args[0]);
    },
    $signature: 0
  };
  E.SchemaError_closure10.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid URI " + ("'" + H.S(args[0]) + "'") + ". Parser output:\n";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]);
    },
    $signature: 0
  };
  E.SchemaError_closure5.prototype = {
    call$1: function(args) {
      return "Entity cannot be empty.";
    },
    $signature: 0
  };
  E.SchemaError_closure11.prototype = {
    call$1: function(args) {
      var t2,
        t1 = P.String;
      args.toString;
      t2 = H.getTypeArgumentByIndex(args, 0);
      return "Exactly one of " + new H.MappedListIterable(args, H.functionTypeCheck(E.errors___q$closure(), {func: 1, ret: t1, args: [t2]}), [t2, t1]).toString$0(0) + " properties must be defined.";
    },
    $signature: 0
  };
  E.SchemaError_closure8.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Value " + ("'" + H.S(args[0]) + "'") + " does not match regexp pattern ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = args[0];
      t1 = "Type mismatch. Property value " + H.S(typeof t1 === "string" ? "'" + t1 + "'" : J.toString$0$(t1)) + " is not a ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure2.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = args[0];
      t1 = "Invalid value " + H.S(typeof t1 === "string" ? "'" + t1 + "'" : J.toString$0$(t1)) + ". Valid values are ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___mbq$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure1.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Value " + H.S(args[0]) + " is out of range.";
    },
    $signature: 0
  };
  E.SchemaError_closure12.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Value " + H.S(args[0]) + " is not a multiple of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.SchemaError_closure0.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Property " + ("'" + H.S(args[0]) + "'") + " must be defined.";
    },
    $signature: 0
  };
  E.SchemaError_closure6.prototype = {
    call$1: function(args) {
      return "Unexpected property.";
    },
    $signature: 0
  };
  E.SchemaError_closure13.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Dependency failed. " + ("'" + H.S(args[0]) + "'") + " must be defined.";
    },
    $signature: 0
  };
  E.SemanticError.prototype = {};
  E.SemanticError_closure38.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Unknown glTF major asset version: " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure37.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Unknown glTF minor asset version: " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure28.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Asset minVersion " + ("'" + H.S(args[0]) + "'") + " is greater than version ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure26.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid value " + H.S(args[0]) + " for GL type ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure27.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Integer value is written with fractional part: " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure25.prototype = {
    call$1: function(args) {
      return "Only (u)byte and (u)short accessors can be normalized.";
    },
    $signature: 0
  };
  E.SemanticError_closure23.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Offset " + H.S(args[0]) + " is not a multiple of componentType length ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure24.prototype = {
    call$1: function(args) {
      return "Matrix accessors must be aligned to 4-byte boundaries.";
    },
    $signature: 0
  };
  E.SemanticError_closure33.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Sparse accessor overrides more elements (" + H.S(args[0]) + ") than the base accessor contains (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.SemanticError_closure34.prototype = {
    call$1: function(args) {
      return "Animated TRS properties will not affect a skinned mesh.";
    },
    $signature: 0
  };
  E.SemanticError_closure22.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Buffer's Data URI MIME-Type must be 'application/octet-stream' or 'application/gltf-buffer'. Found " + ("'" + H.S(args[0]) + "'") + " instead.";
    },
    $signature: 0
  };
  E.SemanticError_closure21.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Buffer view's byteStride (" + H.S(args[0]) + ") is greater than byteLength (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.SemanticError_closure20.prototype = {
    call$1: function(args) {
      return "Only buffer views with raw vertex data can have byteStride.";
    },
    $signature: 0
  };
  E.SemanticError_closure19.prototype = {
    call$1: function(args) {
      return "xmag and ymag must not be zero.";
    },
    $signature: 0
  };
  E.SemanticError_closure18.prototype = {
    call$1: function(args) {
      return "zfar must be greater than znear.";
    },
    $signature: 0
  };
  E.SemanticError_closure16.prototype = {
    call$1: function(args) {
      return "Alpha cutoff is supported only for 'MASK' alpha mode.";
    },
    $signature: 0
  };
  E.SemanticError_closure10.prototype = {
    call$1: function(args) {
      return "Invalid attribute name.";
    },
    $signature: 0
  };
  E.SemanticError_closure9.prototype = {
    call$1: function(args) {
      return "All primitives must have the same number of morph targets.";
    },
    $signature: 0
  };
  E.SemanticError_closure8.prototype = {
    call$1: function(args) {
      return "All primitives should contain the same number of 'JOINTS' and 'WEIGHTS' attribute sets.";
    },
    $signature: 0
  };
  E.SemanticError_closure15.prototype = {
    call$1: function(args) {
      return "No POSITION attribute found.";
    },
    $signature: 0
  };
  E.SemanticError_closure12.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Indices for indexed attribute semantic " + ("'" + H.S(args[0]) + "'") + " must start with 0 and be continuous. Total expected indices: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ", total provided indices: ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure14.prototype = {
    call$1: function(args) {
      return "TANGENT attribute without NORMAL found.";
    },
    $signature: 0
  };
  E.SemanticError_closure11.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Number of JOINTS attribute semantics (" + H.S(args[0]) + ") does not match the number of WEIGHTS (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.SemanticError_closure13.prototype = {
    call$1: function(args) {
      return "TANGENT attribute defined for POINTS rendering mode.";
    },
    $signature: 0
  };
  E.SemanticError_closure7.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "The length of weights array (" + H.S(args[0]) + ") does not match the number of morph targets (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.SemanticError_closure5.prototype = {
    call$1: function(args) {
      return "A node can have either a matrix or any combination of translation/rotation/scale (TRS) properties.";
    },
    $signature: 0
  };
  E.SemanticError_closure4.prototype = {
    call$1: function(args) {
      return "Do not specify default transform matrix.";
    },
    $signature: 0
  };
  E.SemanticError_closure3.prototype = {
    call$1: function(args) {
      return "Matrix must be decomposable to TRS.";
    },
    $signature: 0
  };
  E.SemanticError_closure6.prototype = {
    call$1: function(args) {
      return "Rotation quaternion must be normalized.";
    },
    $signature: 0
  };
  E.SemanticError_closure39.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Unused extension " + ("'" + H.S(args[0]) + "'") + " cannot be required.";
    },
    $signature: 0
  };
  E.SemanticError_closure40.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Extension " + ("'" + H.S(args[0]) + "'") + " cannot be optional.";
    },
    $signature: 0
  };
  E.SemanticError_closure41.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Extension uses unreserved extension prefix " + ("'" + H.S(args[0]) + "'") + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure42.prototype = {
    call$1: function(args) {
      return "Extension name has invalid format.";
    },
    $signature: 0
  };
  E.SemanticError_closure32.prototype = {
    call$1: function(args) {
      return "Empty node encountered.";
    },
    $signature: 0
  };
  E.SemanticError_closure31.prototype = {
    call$1: function(args) {
      return "Node with a skinned mesh is not root. Parent transforms will not affect a skinned mesh.";
    },
    $signature: 0
  };
  E.SemanticError_closure30.prototype = {
    call$1: function(args) {
      return "Local transforms will not affect a skinned mesh.";
    },
    $signature: 0
  };
  E.SemanticError_closure29.prototype = {
    call$1: function(args) {
      return "A node with a skinned mesh is used in a scene that does not contain joint nodes.";
    },
    $signature: 0
  };
  E.SemanticError_closure36.prototype = {
    call$1: function(args) {
      return "Joints do not have a common root.";
    },
    $signature: 0
  };
  E.SemanticError_closure35.prototype = {
    call$1: function(args) {
      return "Skeleton node is not a common root.";
    },
    $signature: 0
  };
  E.SemanticError_closure17.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Non-relative URI found: " + ("'" + H.S(args[0]) + "'") + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure0.prototype = {
    call$1: function(args) {
      if (1 >= args.length)
        return H.ioore(args, 1);
      return "Multiple extensions are defined for this object: " + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.SemanticError_closure.prototype = {
    call$1: function(args) {
      return "Prefer JSON Objects for extras.";
    },
    $signature: 0
  };
  E.SemanticError_closure2.prototype = {
    call$1: function(args) {
      return "This property should not be defined as it will not be used.";
    },
    $signature: 0
  };
  E.SemanticError_closure1.prototype = {
    call$1: function(args) {
      var t1;
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = "outerConeAngle (" + H.S(args[1]) + ") is less than or equal to innerConeAngle (";
      if (0 >= args.length)
        return H.ioore(args, 0);
      return t1 + H.S(args[0]) + ").";
    },
    $signature: 0
  };
  E.LinkError.prototype = {};
  E.LinkError_closure4.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor's total byteOffset " + H.S(args[0]) + " isn't a multiple of componentType length ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure8.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Referenced bufferView's byteStride value " + H.S(args[0]) + " is less than accessor element's length ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure3.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor (offset: " + H.S(args[0]) + ", length: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + ") does not fit referenced bufferView [";
      if (2 >= args.length)
        return H.ioore(args, 2);
      t1 = t1 + H.S(args[2]) + "] length ";
      if (3 >= args.length)
        return H.ioore(args, 3);
      return t1 + H.S(args[3]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure17.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Override of previously set accessor usage. Initial: " + ("'" + H.S(args[0]) + "'") + ", new: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.LinkError_closure9.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Animation channel has the same target as channel " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure13.prototype = {
    call$1: function(args) {
      return "Animation channel cannot target TRS properties of a node with defined matrix.";
    },
    $signature: 0
  };
  E.LinkError_closure12.prototype = {
    call$1: function(args) {
      return "Animation channel cannot target WEIGHTS when mesh does not have morph targets.";
    },
    $signature: 0
  };
  E.LinkError_closure15.prototype = {
    call$1: function(args) {
      return "accessor.min and accessor.max must be defined for animation input accessor.";
    },
    $signature: 0
  };
  E.LinkError_closure16.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid Animation sampler input accessor format " + ("'" + H.S(args[0]) + "'") + ". Must be one of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure11.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid animation sampler output accessor format " + ("'" + H.S(args[0]) + "'") + " for path ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      t1 = t1 + ("'" + H.S(args[2]) + "'") + ". Must be one of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure14.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Animation sampler output accessor with " + ("'" + H.S(args[0]) + "'") + " interpolation must have at least ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t1 = t1 + H.S(args[1]) + " elements. Got ";
      if (2 >= args.length)
        return H.ioore(args, 2);
      return t1 + H.S(args[2]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure10.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Animation sampler output accessor of count " + H.S(args[0]) + " expected. Found ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure2.prototype = {
    call$1: function(args) {
      return "Buffer refers to an unresolved GLB binary chunk.";
    },
    $signature: 0
  };
  E.LinkError_closure18.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "BufferView does not fit buffer (" + H.S(args[0]) + ") byteLength (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.LinkError_closure7.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Override of previously set bufferView target or usage. Initial: " + ("'" + H.S(args[0]) + "'") + ", new: ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ".";
    },
    $signature: 0
  };
  E.LinkError_closure35.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Accessor of count " + H.S(args[0]) + " expected. Found ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure21.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid accessor format " + ("'" + H.S(args[0]) + "'") + " for this attribute semantic. Must be one of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure22.prototype = {
    call$1: function(args) {
      return "accessor.min and accessor.max must be defined for POSITION attribute accessor.";
    },
    $signature: 0
  };
  E.LinkError_closure19.prototype = {
    call$1: function(args) {
      return "bufferView.byteStride must be defined when two or more accessors use the same buffer view.";
    },
    $signature: 0
  };
  E.LinkError_closure20.prototype = {
    call$1: function(args) {
      return "Vertex attribute data must be aligned to 4-byte boundaries.";
    },
    $signature: 0
  };
  E.LinkError_closure28.prototype = {
    call$1: function(args) {
      return "bufferView.byteStride must not be defined for indices accessor.";
    },
    $signature: 0
  };
  E.LinkError_closure27.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid indices accessor format " + ("'" + H.S(args[0]) + "'") + ". Must be one of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ". ";
    },
    $signature: 0
  };
  E.LinkError_closure26.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Number of vertices or indices (" + H.S(args[0]) + ") is not compatible with used drawing mode (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + ("'" + H.S(args[1]) + "'") + ").";
    },
    $signature: 0
  };
  E.LinkError_closure25.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Material is incompatible with mesh primitive: Texture binding " + ("'" + H.S(args[0]) + "'") + " needs 'TEXCOORD_";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + "' attribute.";
    },
    $signature: 0
  };
  E.LinkError_closure29.prototype = {
    call$1: function(args) {
      return "All accessors of the same primitive must have the same count.";
    },
    $signature: 0
  };
  E.LinkError_closure24.prototype = {
    call$1: function(args) {
      return "No base accessor for this attribute semantic.";
    },
    $signature: 0
  };
  E.LinkError_closure23.prototype = {
    call$1: function(args) {
      return "Base accessor has different count.";
    },
    $signature: 0
  };
  E.LinkError_closure6.prototype = {
    call$1: function(args) {
      return "Node is a part of a node loop.";
    },
    $signature: 0
  };
  E.LinkError_closure30.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Value overrides parent of node " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure33.prototype = {
    call$1: function(args) {
      var t1, t2;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "The length of weights array (" + H.S(args[0]) + ") does not match the number of morph targets (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      t2 = args[1];
      return t1 + H.S(t2 == null ? 0 : t2) + ").";
    },
    $signature: 0
  };
  E.LinkError_closure32.prototype = {
    call$1: function(args) {
      return "Node has skin defined, but mesh has no joints data.";
    },
    $signature: 0
  };
  E.LinkError_closure31.prototype = {
    call$1: function(args) {
      return "Node uses skinned mesh, but has no skin defined.";
    },
    $signature: 0
  };
  E.LinkError_closure34.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Node " + H.S(args[0]) + " is not a root node.";
    },
    $signature: 0
  };
  E.LinkError_closure36.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid IBM accessor format " + ("'" + H.S(args[0]) + "'") + ". Must be one of ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ". ";
    },
    $signature: 0
  };
  E.LinkError_closure1.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Invalid MIME type " + ("'" + H.S(args[0]) + "'") + " for the texture source. Valid MIME types are ";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + J.map$1$1$ax(H.listSuperNativeTypeCast(args[1], "$isIterable"), E.errors___q$closure(), P.String).toString$0(0) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure0.prototype = {
    call$1: function(args) {
      return "Extension is not declared in extensionsUsed.";
    },
    $signature: 0
  };
  E.LinkError_closure.prototype = {
    call$1: function(args) {
      return "Unexpected location for this extension.";
    },
    $signature: 0
  };
  E.LinkError_closure37.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Unresolved reference: " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.LinkError_closure38.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Cannot validate an extension as it is not supported by the validator: " + ("'" + H.S(args[0]) + "'") + ".";
    },
    $signature: 0
  };
  E.LinkError_closure5.prototype = {
    call$1: function(args) {
      return "This object may be unused.";
    },
    $signature: 0
  };
  E.GlbError.prototype = {};
  E.GlbError_closure12.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Invalid GLB magic value (" + H.S(args[0]) + ").";
    },
    $signature: 0
  };
  E.GlbError_closure11.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Invalid GLB version value " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.GlbError_closure10.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Declared GLB length (" + H.S(args[0]) + ") is too small.";
    },
    $signature: 0
  };
  E.GlbError_closure9.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Length of " + H.S(args[0]) + " chunk is not aligned to 4-byte boundaries.";
    },
    $signature: 0
  };
  E.GlbError_closure0.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Declared length (" + H.S(args[0]) + ") does not match GLB length (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ").";
    },
    $signature: 0
  };
  E.GlbError_closure8.prototype = {
    call$1: function(args) {
      var t1;
      if (0 >= args.length)
        return H.ioore(args, 0);
      t1 = "Chunk (" + H.S(args[0]) + ") length (";
      if (1 >= args.length)
        return H.ioore(args, 1);
      return t1 + H.S(args[1]) + ") does not fit total GLB length.";
    },
    $signature: 0
  };
  E.GlbError_closure4.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Chunk (" + H.S(args[0]) + ") cannot have zero length.";
    },
    $signature: 0
  };
  E.GlbError_closure5.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Chunk of type " + H.S(args[0]) + " has already been used.";
    },
    $signature: 0
  };
  E.GlbError_closure1.prototype = {
    call$1: function(args) {
      return "Unexpected end of chunk header.";
    },
    $signature: 0
  };
  E.GlbError_closure.prototype = {
    call$1: function(args) {
      return "Unexpected end of chunk data.";
    },
    $signature: 0
  };
  E.GlbError_closure2.prototype = {
    call$1: function(args) {
      return "Unexpected end of header.";
    },
    $signature: 0
  };
  E.GlbError_closure7.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "First chunk must be of JSON type. Found " + H.S(args[0]) + " instead.";
    },
    $signature: 0
  };
  E.GlbError_closure6.prototype = {
    call$1: function(args) {
      return "BIN chunk must be the second chunk.";
    },
    $signature: 0
  };
  E.GlbError_closure3.prototype = {
    call$1: function(args) {
      if (0 >= args.length)
        return H.ioore(args, 0);
      return "Unknown GLB chunk type: " + H.S(args[0]) + ".";
    },
    $signature: 0
  };
  E.Issue.prototype = {
    get$message: function() {
      var t1 = J.trimRight$0$s(this.type.message.call$1(this._args));
      return t1;
    },
    get$hashCode: function(_) {
      return C.JSString_methods.get$hashCode(this.toString$0(0));
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof E.Issue && other.toString$0(0) === this.toString$0(0);
    },
    toString$0: function(_) {
      var _this = this,
        t1 = _this.pointer;
      if (t1 != null && t1.length !== 0)
        return H.S(t1) + ": " + _this.get$message();
      t1 = _this.offset;
      if (t1 != null)
        return "@" + H.S(t1) + ": " + _this.get$message();
      return _this.get$message();
    }
  };
  D.ExtTextureWebPTexture.prototype = {
    link$2: function(gltf, context) {
      var t1 = this._sourceIndex,
        t2 = H.interceptedTypeCheck(gltf.images.$index(0, t1), "$isImage");
      this._ext_texture_webp$_source = t2;
      if (t1 !== -1)
        if (t2 == null)
          context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "source");
        else
          t2._isUsed = true;
    },
    validateResources$2: function(gltf, context) {
      var mimeType,
        t1 = this._ext_texture_webp$_source;
      t1 = t1 == null ? null : t1.info;
      mimeType = t1 == null ? null : t1.mimeType;
      if (mimeType != null && mimeType !== "image/webp")
        context.addIssue$3$args$name($.$get$LinkError_textureInvalidImageMimeType(), H.setRuntimeTypeInfo([mimeType, C.List_oCz], [P.Object]), "source");
    },
    $isResourceValidatable: 1
  };
  X.KhrLightsPunctualGltf.prototype = {
    link$2: function(gltf, context) {
      var t2, t3,
        t1 = context.path;
      C.JSArray_methods.add$1(t1, "lights");
      t2 = this.lights;
      t3 = J.JSArray_JSArray$markFixed(t1.slice(0), H.getTypeArgumentByIndex(t1, 0));
      context.extensionCollections.$indexSet(0, t2, t3);
      t2.forEachWithIndices$1(new X.KhrLightsPunctualGltf_link_closure(context, gltf));
      if (0 >= t1.length)
        return H.ioore(t1, -1);
      t1.pop();
    }
  };
  X.KhrLightsPunctualGltf_link_closure.prototype = {
    call$2: function(i, light) {
      var t1;
      H.interceptedTypeCheck(light, "$isKhrLightsPunctualLight");
      t1 = this.context.path;
      C.JSArray_methods.add$1(t1, C.JSInt_methods.toString$0(i));
      if (0 >= t1.length)
        return H.ioore(t1, -1);
      t1.pop();
    },
    $signature: 61
  };
  X.KhrLightsPunctualLight.prototype = {};
  X.KhrLightsPunctualLightSpot.prototype = {};
  X.KhrLightsPunctualNode.prototype = {
    link$2: function(gltf, context) {
      var t1, t2,
        lightsExtension = gltf.extensions.$index(0, "KHR_lights_punctual");
      if (lightsExtension instanceof X.KhrLightsPunctualGltf) {
        t1 = this._lightIndex;
        t2 = H.interceptedTypeCheck(lightsExtension.lights.$index(0, t1), "$isKhrLightsPunctualLight");
        this._light = t2;
        if (t1 !== -1)
          if (t2 == null)
            context.addIssue$3$args$name($.$get$LinkError_unresolvedReference(), H.setRuntimeTypeInfo([t1], [P.Object]), "light");
          else
            t2._isUsed = true;
      } else
        context.addIssue$2$args($.$get$SchemaError_unsatisfiedDependency(), H.setRuntimeTypeInfo(["/extensions/KHR_lights_punctual"], [P.Object]));
    }
  };
  A.KhrMaterialsPbrSpecularGlossiness.prototype = {
    link$2: function(gltf, context) {
      var t2,
        t1 = this.diffuseTexture;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "diffuseTexture");
        t1.link$2(gltf, context);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
      t1 = this.specularGlossinessTexture;
      if (t1 != null) {
        t2 = context.path;
        C.JSArray_methods.add$1(t2, "specularGlossinessTexture");
        t1.link$2(gltf, context);
        if (0 >= t2.length)
          return H.ioore(t2, -1);
        t2.pop();
      }
    }
  };
  S.KhrMaterialsUnlit.prototype = {};
  L.KhrTextureTransform.prototype = {
    link$2: function(gltf, context) {
      var t1, o;
      for (t1 = context.owners, o = this; o != null;) {
        o = t1.$index(0, o);
        if (o instanceof Y.Material) {
          o.texCoordIndices.$indexSet(0, context.getPointerString$0(), this.texCoord);
          break;
        }
      }
    }
  };
  D.Extension.prototype = {};
  D.ExtFuncs.prototype = {};
  D.ExtensionTuple.prototype = {
    get$hashCode: function(_) {
      var t1 = J.get$hashCode$(this.type),
        t2 = J.get$hashCode$(this.name);
      return A._finish(A._combine(A._combine(0, C.JSInt_methods.get$hashCode(t1)), C.JSInt_methods.get$hashCode(t2)));
    },
    $eq: function(_, other) {
      if (other == null)
        return false;
      return other instanceof D.ExtensionTuple && this.name == other.name && J.$eq$(this.type, other.type);
    }
  };
  D.LinkableExtensionEntry.prototype = {};
  D.ResourceValidatableExtensionEntry.prototype = {};
  A.GlbReader.prototype = {
    read$0: function() {
      var t1, _this = this;
      _this.set$_glb_reader$_subscription(_this.stream.listen$3$onDone$onError(_this.get$_glb_reader$_onData(), _this.get$_glb_reader$_onDone(), _this.get$_glb_reader$_onError()));
      t1 = _this._jsonStreamController;
      t1.set$onPause(_this._glb_reader$_subscription.get$pause());
      t1.set$onResume(_this._glb_reader$_subscription.get$resume());
      t1.set$onCancel(new A.GlbReader_read_closure(_this));
      return _this._glb_reader$_completer.future;
    },
    _glb_reader$_abort$0: function() {
      this._glb_reader$_subscription.cancel$0();
      var t1 = this._glb_reader$_completer;
      if (t1.future._state === 0)
        t1.complete$1(new K.GltfReaderResult("model/gltf-binary", null, this._binaryBuffer));
    },
    _glb_reader$_onData$1: function(data) {
      var t1, t2, t3, t4, t5, dataOffset, availableLength, t6, t7, magic, version, t8, t9, updateState, dataOffset0, _this = this,
        _s17_ = "model/gltf-binary",
        _s1_ = "0";
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      _this._glb_reader$_subscription.pause$0();
      for (t1 = J.getInterceptor$asx(data), t2 = K.GltfReaderResult, t3 = [t2], t2 = [t2], t4 = [P.Object], t5 = _this._header, dataOffset = 0, availableLength = 0; dataOffset !== t1.get$length(data);)
        switch (_this._glb_reader$_state) {
          case 0:
            t6 = t1.get$length(data);
            t7 = _this._localOffset;
            availableLength = Math.min(t6 - dataOffset, 12 - t7);
            t6 = t7 + availableLength;
            _this._localOffset = t6;
            C.NativeUint8List_methods.setRange$4(t5, t7, t6, data, dataOffset);
            dataOffset += availableLength;
            _this._glb_reader$_offset = availableLength;
            if (_this._localOffset !== 12)
              break;
            magic = _this._headerByteData.getUint32(0, true);
            if (magic !== 1179937895) {
              _this._context.addIssue$3$args$offset($.$get$GlbError_invalidMagic(), H.setRuntimeTypeInfo([magic], t4), 0);
              _this._glb_reader$_subscription.cancel$0();
              t1 = _this._glb_reader$_completer;
              t2 = t1.future;
              if (t2._state === 0) {
                t1 = H.futureOrCheck(new K.GltfReaderResult(_s17_, null, _this._binaryBuffer), {futureOr: 1, type: H.getTypeArgumentByIndex(t1, 0)});
                t2._asyncComplete$1(t1);
              }
              return;
            }
            version = _this._headerByteData.getUint32(4, true);
            if (version !== 2) {
              _this._context.addIssue$3$args$offset($.$get$GlbError_invalidVersion(), H.setRuntimeTypeInfo([version], t4), 4);
              _this._glb_reader$_subscription.cancel$0();
              t1 = _this._glb_reader$_completer;
              t2 = t1.future;
              if (t2._state === 0) {
                t1 = H.futureOrCheck(new K.GltfReaderResult(_s17_, null, _this._binaryBuffer), {futureOr: 1, type: H.getTypeArgumentByIndex(t1, 0)});
                t2._asyncComplete$1(t1);
              }
              return;
            }
            t6 = _this._totalLength = _this._headerByteData.getUint32(8, true);
            if (t6 <= _this._glb_reader$_offset)
              _this._context.addIssue$3$args$offset($.$get$GlbError_lengthTooSmall(), H.setRuntimeTypeInfo([t6], t4), 8);
            _this._glb_reader$_state = 1;
            _this._localOffset = 0;
            break;
          case 1:
            t6 = t1.get$length(data);
            t7 = _this._localOffset;
            availableLength = Math.min(t6 - dataOffset, 8 - t7);
            t6 = t7 + availableLength;
            _this._localOffset = t6;
            C.NativeUint8List_methods.setRange$4(t5, t7, t6, data, dataOffset);
            dataOffset += availableLength;
            _this._glb_reader$_offset += availableLength;
            if (_this._localOffset !== 8)
              break;
            _this._glb_reader$_chunkLength = _this._headerByteData.getUint32(0, true);
            t6 = _this._headerByteData.getUint32(4, true);
            _this._glb_reader$_chunkType = t6;
            if ((_this._glb_reader$_chunkLength & 3) !== 0) {
              t7 = _this._context;
              t8 = $.$get$GlbError_chunkLengthUnaligned();
              t9 = _this._glb_reader$_offset;
              t7.addIssue$3$args$offset(t8, H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(t6, 16), 8, _s1_)], t4), t9 - 8);
            }
            if (_this._glb_reader$_offset + _this._glb_reader$_chunkLength > _this._totalLength)
              _this._context.addIssue$3$args$offset($.$get$GlbError_chunkTooBig(), H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(_this._glb_reader$_chunkType, 16), 8, _s1_), _this._glb_reader$_chunkLength], t4), _this._glb_reader$_offset - 8);
            if (_this._chunkNumber === 0 && _this._glb_reader$_chunkType !== 1313821514)
              _this._context.addIssue$3$args$offset($.$get$GlbError_unexpectedFirstChunk(), H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(_this._glb_reader$_chunkType, 16), 8, _s1_)], t4), _this._glb_reader$_offset - 8);
            t6 = _this._glb_reader$_chunkType;
            if (t6 === 5130562 && _this._chunkNumber > 1 && !_this._hasBinChunk)
              _this._context.addIssue$3$args$offset($.$get$GlbError_unexpectedBinChunk(), H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(t6, 16), 8, _s1_)], t4), _this._glb_reader$_offset - 8);
            updateState = new A.GlbReader__onData_updateState(_this);
            t6 = _this._glb_reader$_chunkType;
            switch (t6) {
              case 1313821514:
                if (_this._glb_reader$_chunkLength === 0) {
                  t7 = _this._context;
                  t8 = $.$get$GlbError_emptyChunk();
                  t9 = _this._glb_reader$_offset;
                  t7.addIssue$3$args$offset(t8, H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(t6, 16), 8, _s1_)], t4), t9 - 8);
                }
                updateState.call$1$seen(_this._hasJsonChunk);
                _this._hasJsonChunk = true;
                break;
              case 5130562:
                updateState.call$1$seen(_this._hasBinChunk);
                _this._hasBinChunk = true;
                break;
              default:
                _this._context.addIssue$3$args$offset($.$get$GlbError_unknownChunkType(), H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(t6, 16), 8, _s1_)], t4), _this._glb_reader$_offset - 8);
                _this._glb_reader$_state = 4294967295;
            }
            ++_this._chunkNumber;
            _this._localOffset = 0;
            break;
          case 1313821514:
            availableLength = Math.min(t1.get$length(data) - dataOffset, _this._glb_reader$_chunkLength - _this._localOffset);
            if (_this._jsonReader == null) {
              t6 = _this._jsonStreamController;
              t7 = _this._context;
              t6 = new K.GltfJsonReader(new P._ControllerStream(t6, [H.getTypeArgumentByIndex(t6, 0)]), new P._AsyncCompleter(new P._Future($.Zone__current, t3), t2));
              t6._gltf_reader$_context = t7;
              _this._jsonReader = t6;
              _this.set$_jsonReaderResult(t6.read$0());
            }
            t6 = _this._jsonStreamController;
            dataOffset0 = dataOffset + availableLength;
            t7 = H.getTypeArgumentByIndex(t6, 0);
            t8 = H.assertSubtypeOfRuntimeType(t1.sublist$2(data, dataOffset, dataOffset0), t7);
            if (t6._state >= 4)
              H.throwExpression(t6._badEventState$0());
            t9 = t6._state;
            if ((t9 & 1) !== 0)
              t6._sendData$1(t8);
            else if ((t9 & 3) === 0) {
              t6 = t6._ensurePendingEvents$0();
              t7 = new P._DelayedData(t8, [t7]);
              t8 = t6.lastPendingEvent;
              if (t8 == null)
                t6.firstPendingEvent = t6.lastPendingEvent = t7;
              else {
                t8.set$next(t7);
                t6.lastPendingEvent = t7;
              }
            }
            t6 = _this._localOffset += availableLength;
            _this._glb_reader$_offset += availableLength;
            if (t6 === _this._glb_reader$_chunkLength) {
              _this._jsonStreamController.close$0();
              _this._glb_reader$_state = 1;
              _this._localOffset = 0;
            }
            dataOffset = dataOffset0;
            break;
          case 5130562:
            t6 = t1.get$length(data);
            t7 = _this._glb_reader$_chunkLength;
            availableLength = Math.min(t6 - dataOffset, t7 - _this._localOffset);
            t6 = _this._binaryBuffer;
            if (t6 == null)
              t6 = _this._binaryBuffer = new Uint8Array(t7);
            t7 = _this._localOffset;
            t8 = t7 + availableLength;
            _this._localOffset = t8;
            C.NativeUint8List_methods.setRange$4(t6, t7, t8, data, dataOffset);
            dataOffset += availableLength;
            _this._glb_reader$_offset += availableLength;
            if (_this._localOffset === _this._glb_reader$_chunkLength) {
              _this._glb_reader$_state = 1;
              _this._localOffset = 0;
            }
            break;
          case 4294967295:
            t6 = t1.get$length(data);
            t7 = _this._glb_reader$_chunkLength;
            t8 = _this._localOffset;
            availableLength = Math.min(t6 - dataOffset, t7 - t8);
            t8 += availableLength;
            _this._localOffset = t8;
            dataOffset += availableLength;
            _this._glb_reader$_offset += availableLength;
            if (t8 === t7) {
              _this._glb_reader$_state = 1;
              _this._localOffset = 0;
            }
            break;
        }
      _this._glb_reader$_subscription.resume$0();
    },
    _glb_reader$_onDone$0: function() {
      var t1, t2, _this = this;
      switch (_this._glb_reader$_state) {
        case 0:
          _this._context.addIssue$2$offset($.$get$GlbError_unexpectedEndOfHeader(), _this._glb_reader$_offset);
          _this._glb_reader$_abort$0();
          break;
        case 1:
          if (_this._localOffset !== 0) {
            _this._context.addIssue$2$offset($.$get$GlbError_unexpectedEndOfChunkHeader(), _this._glb_reader$_offset);
            _this._glb_reader$_abort$0();
          } else {
            t1 = _this._totalLength;
            t2 = _this._glb_reader$_offset;
            if (t1 !== t2)
              _this._context.addIssue$3$args$offset($.$get$GlbError_lengthMismatch(), H.setRuntimeTypeInfo([t1, t2], [P.Object]), _this._glb_reader$_offset);
            t1 = _this._jsonReaderResult;
            if (t1 != null)
              t1.then$1$2$onError(0, new A.GlbReader__onDone_closure(_this), _this.get$_glb_reader$_onError(), P.Null);
            else
              _this._glb_reader$_completer.complete$1(new K.GltfReaderResult("model/gltf-binary", null, _this._binaryBuffer));
          }
          break;
        default:
          if (_this._glb_reader$_chunkLength > 0)
            _this._context.addIssue$2$offset($.$get$GlbError_unexpectedEndOfChunkData(), _this._glb_reader$_offset);
          _this._glb_reader$_abort$0();
      }
    },
    _glb_reader$_onError$1: function(error) {
      var t1;
      this._glb_reader$_subscription.cancel$0();
      t1 = this._glb_reader$_completer;
      if (t1.future._state === 0)
        t1.completeError$1(error);
    },
    set$_glb_reader$_subscription: function(_subscription) {
      this._glb_reader$_subscription = H.assertSubtype(_subscription, "$isStreamSubscription", [[P.List, P.int]], "$asStreamSubscription");
    },
    set$_jsonReaderResult: function(_jsonReaderResult) {
      this._jsonReaderResult = H.assertSubtype(_jsonReaderResult, "$isFuture", [K.GltfReaderResult], "$asFuture");
    },
    set$_jsonStreamController: function(_jsonStreamController) {
      this._jsonStreamController = H.assertSubtype(_jsonStreamController, "$isStreamController", [[P.List, P.int]], "$asStreamController");
    },
    $isGltfReader: 1
  };
  A.GlbReader_read_closure.prototype = {
    call$0: function() {
      var t1 = this.$this;
      if ((t1._jsonStreamController._state & 4) !== 0)
        t1._glb_reader$_subscription.resume$0();
      else
        t1._glb_reader$_abort$0();
    },
    $signature: 2
  };
  A.GlbReader__onData_updateState.prototype = {
    call$1$seen: function(seen) {
      var t1 = this.$this;
      if (seen) {
        t1._context.addIssue$3$args$offset($.$get$GlbError_duplicateChunk(), H.setRuntimeTypeInfo(["0x" + C.JSString_methods.padLeft$2(C.JSInt_methods.toRadixString$1(t1._glb_reader$_chunkType, 16), 8, "0")], [P.Object]), t1._glb_reader$_offset - 8);
        t1._glb_reader$_state = 4294967295;
      } else
        t1._glb_reader$_state = t1._glb_reader$_chunkType;
    },
    call$0: function() {
      return this.call$1$seen(null);
    },
    $signature: 64
  };
  A.GlbReader__onDone_closure.prototype = {
    call$1: function(result) {
      var t1, t2;
      H.interceptedTypeCheck(result, "$isGltfReaderResult");
      t1 = this.$this;
      t2 = result == null ? null : result.gltf;
      t1._glb_reader$_completer.complete$1(new K.GltfReaderResult("model/gltf-binary", t2, t1._binaryBuffer));
    },
    $signature: 65
  };
  K.GltfReaderResult.prototype = {};
  K.GltfReader.prototype = {};
  K.GltfReader_detect_closure0.prototype = {
    call$0: function() {
      return this._box_0.subscription.pause$0();
    },
    $signature: 1
  };
  K.GltfReader_detect_closure1.prototype = {
    call$0: function() {
      return this._box_0.subscription.resume$0();
    },
    $signature: 1
  };
  K.GltfReader_detect_closure.prototype = {
    call$0: function() {
      return this._box_0.subscription.cancel$0();
    },
    $signature: 16
  };
  K.GltfReader_detect_closure2.prototype = {
    call$1: function(data) {
      var t1, t2, byte, t3, t4, t5, _this = this, _null = null;
      H.assertSubtype(data, "$isList", [P.int], "$asList");
      t1 = _this._box_0;
      if (!t1.formatDetected) {
        t2 = J.getInterceptor$asx(data);
        if (t2.get$isEmpty(data)) {
          t1.subscription.cancel$0();
          _this.controller.close$0();
          _this.completer.completeError$1(C.C_GltfInvalidFormatException);
          return;
        }
        byte = t2.$index(data, 0);
        if (103 === byte) {
          t2 = _this.controller;
          t3 = _this.context;
          t4 = new Uint8Array(12);
          t5 = K.GltfReaderResult;
          t5 = new A.GlbReader(t4, new P._ControllerStream(t2, [H.getTypeArgumentByIndex(t2, 0)]), new P._AsyncCompleter(new P._Future($.Zone__current, [t5]), [t5]));
          t3._isGlb = true;
          t5._context = t3;
          t2 = t4.buffer;
          t2.toString;
          t5._headerByteData = H.NativeByteData_NativeByteData$view(t2, 0, _null);
          t5.set$_jsonStreamController(P.StreamController_StreamController(_null, _null, _null, [P.List, P.int]));
          _this.completer.complete$1(t5);
          t1.formatDetected = true;
        } else {
          t2 = 123 === byte || 9 === byte || 32 === byte || 10 === byte || 13 === byte || 239 === byte;
          t3 = _this.completer;
          t4 = _this.controller;
          if (t2) {
            t3.complete$1(K.GltfJsonReader$(new P._ControllerStream(t4, [H.getTypeArgumentByIndex(t4, 0)]), _this.context));
            t1.formatDetected = true;
          } else {
            t1.subscription.cancel$0();
            t4.close$0();
            t3.completeError$1(C.C_GltfInvalidFormatException);
            return;
          }
        }
      }
      _this.controller.add$1(0, data);
    },
    $signature: 23
  };
  K.GltfJsonReader.prototype = {
    read$0: function() {
      var _this = this,
        t1 = P.Object,
        t2 = H.setRuntimeTypeInfo([], [t1]),
        t3 = new P.StringBuffer("");
      _this._byteSink = new P._Utf8StringSinkAdapter(new P._Utf8Decoder(false, t3), new P._JsonDecoderSink(C.C_JsonCodec.get$decoder()._reviver, H.assertSubtype(new P._SimpleCallbackSink(new K.GltfJsonReader_read_closure(_this), t2, [t1]), "$isSink", [t1], "$asSink"), t3));
      _this.set$_gltf_reader$_subscription(_this.stream.listen$3$onDone$onError(_this.get$_gltf_reader$_onData(), _this.get$_gltf_reader$_onDone(), _this.get$_gltf_reader$_onError()));
      return _this._completer.future;
    },
    _gltf_reader$_onData$1: function(data) {
      var e, t2, t3, exception, _this = this,
        t1 = [P.int];
      H.assertSubtype(data, "$isList", t1, "$asList");
      _this._gltf_reader$_subscription.pause$0();
      if (_this._isFirstChunk) {
        if (J.get$isNotEmpty$asx(data) && 239 === J.$index$asx(data, 0))
          _this._gltf_reader$_context.addIssue$3$args$noPointer($.$get$SchemaError_invalidJson(), H.setRuntimeTypeInfo(["BOM found at the beginning of UTF-8 stream."], [P.Object]), true);
        _this._isFirstChunk = false;
      }
      try {
        t2 = _this._byteSink;
        t3 = J.get$length$asx(data);
        t2.toString;
        t1 = H.assertSubtype(data, "$isList", t1, "$asList");
        t2._decoder.convert$3(t1, 0, t3);
        _this._gltf_reader$_subscription.resume$0();
      } catch (exception) {
        t1 = H.unwrapException(exception);
        if (t1 instanceof P.FormatException) {
          e = t1;
          _this._gltf_reader$_context.addIssue$3$args$noPointer($.$get$SchemaError_invalidJson(), H.setRuntimeTypeInfo([e], [P.Object]), true);
          _this._gltf_reader$_subscription.cancel$0();
          _this._completer.complete$0();
        } else
          throw exception;
      }
    },
    _gltf_reader$_onError$1: function(error) {
      var t1;
      this._gltf_reader$_subscription.cancel$0();
      t1 = this._completer;
      if (t1.future._state === 0)
        t1.completeError$1(error);
    },
    _gltf_reader$_onDone$0: function() {
      var e, exception, t1, _this = this;
      try {
        _this._byteSink.close$0();
      } catch (exception) {
        t1 = H.unwrapException(exception);
        if (t1 instanceof P.FormatException) {
          e = t1;
          _this._gltf_reader$_context.addIssue$3$args$noPointer($.$get$SchemaError_invalidJson(), H.setRuntimeTypeInfo([e], [P.Object]), true);
          _this._gltf_reader$_subscription.cancel$0();
          _this._completer.complete$0();
        } else
          throw exception;
      }
    },
    set$_gltf_reader$_subscription: function(_subscription) {
      this._gltf_reader$_subscription = H.assertSubtype(_subscription, "$isStreamSubscription", [[P.List, P.int]], "$asStreamSubscription");
    },
    $isGltfReader: 1
  };
  K.GltfJsonReader_read_closure.prototype = {
    call$1: function(jsonResult) {
      var result, root, t3, exception,
        t1 = P.Object,
        t2 = [t1];
      H.assertSubtype(jsonResult, "$isList", t2, "$asList");
      if (0 >= jsonResult.length)
        return H.ioore(jsonResult, 0);
      result = jsonResult[0];
      t3 = result;
      if (H.checkSubtype(t3, "$isMap", [P.String, t1], "$asMap"))
        try {
          t1 = this.$this;
          root = V.Gltf_Gltf$fromMap(result, t1._gltf_reader$_context);
          t1._completer.complete$1(new K.GltfReaderResult("model/gltf+json", root, null));
        } catch (exception) {
          if (H.unwrapException(exception) instanceof M.IssuesLimitExceededException) {
            t1 = this.$this;
            t1._gltf_reader$_subscription.cancel$0();
            t1._completer.complete$0();
          } else
            throw exception;
        }
      else {
        t1 = this.$this;
        t1._gltf_reader$_context.addIssue$3$args$noPointer($.$get$SchemaError_typeMismatch(), H.setRuntimeTypeInfo([result, "object"], t2), true);
        t1._gltf_reader$_subscription.cancel$0();
        t1._completer.complete$0();
      }
    },
    $signature: 66
  };
  K.GltfInvalidFormatException.prototype = {
    toString$0: function(_) {
      return "Invalid data: could not detect glTF format.";
    },
    $isException: 1
  };
  F.getIndicesMap_closure.prototype = {
    call$2: function(k, v) {
      H.stringTypeCheck(k);
      this.checkKey.call$1(k);
      if (!(typeof v === "number" && Math.floor(v) === v && v >= 0)) {
        this.value.$indexSet(0, k, -1);
        this.context.addIssue$2$name($.$get$SchemaError_invalidIndex(), k);
      }
    },
    $signature: 6
  };
  F.getIndicesMapsList_closure.prototype = {
    call$2: function(k, v) {
      H.stringTypeCheck(k);
      this.checkKey.call$1(k);
      if (!(typeof v === "number" && Math.floor(v) === v && v >= 0)) {
        this.innerMap.$indexSet(0, k, -1);
        this.context.addIssue$2$name($.$get$SchemaError_invalidIndex(), k);
      }
    },
    $signature: 6
  };
  F.getIndicesMapsList_closure0.prototype = {
    call$1: function(m) {
      return H.interceptedTypeCheck(m, "$isMap").cast$2$0(0, P.String, P.int);
    },
    $signature: 67
  };
  F.getExtensions_closure.prototype = {
    call$0: function() {
      return H.setRuntimeTypeInfo([], [D.LinkableExtensionEntry]);
    },
    $signature: 68
  };
  F.SafeList.prototype = {
    $index: function(_, index) {
      return index == null || index < 0 || index >= this._list.length ? null : C.JSArray_methods.$index(this._list, index);
    },
    $indexSet: function(_, index, value) {
      C.JSArray_methods.$indexSet(this._list, index, H.assertSubtypeOfRuntimeType(value, H.getTypeArgumentByIndex(this, 0)));
    },
    get$length: function(_) {
      return this._utils$_length;
    },
    set$length: function(_, newLength) {
      throw H.wrapException(P.UnsupportedError$("Changing length is not supported"));
    },
    toString$0: function(_) {
      return P.IterableBase_iterableToFullString(this._list, "[", "]");
    },
    forEachWithIndices$1: function(action) {
      var t1, t2, t3, i, e;
      H.functionTypeCheck(action, {func: 1, ret: -1, args: [P.int, H.getTypeArgumentByIndex(this, 0)]});
      for (t1 = this._utils$_length, t2 = this._list, t3 = t2.length, i = 0; i < t1; ++i) {
        if (i >= t3)
          return H.ioore(t2, i);
        e = t2[i];
        if (e == null)
          continue;
        action.call$2(i, e);
      }
    }
  };
  F.ElementChecker.prototype = {
    done$1: function(context) {
      return true;
    }
  };
  F.UnitVec3FloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var _this = this,
        t1 = _this.normalizeValue,
        v = t1 != null ? t1.call$1(value) : value;
      t1 = _this._utils$_sum;
      if (typeof v !== "number")
        return v.$mul();
      t1 += v * v;
      _this._utils$_sum = t1;
      if (2 === componentIndex) {
        if (Math.abs(Math.sqrt(t1) - 1) > 0.00674)
          context.addIssue$3$args$name($.$get$DataError_accessorVector3NonUnit(), H.setRuntimeTypeInfo([index - 2, index, Math.sqrt(_this._utils$_sum)], [P.Object]), _this.path);
        _this._utils$_sum = 0;
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.num];
    }
  };
  F.UnitVec3SignFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      var _this = this,
        t1 = _this.normalizeValue,
        v = t1 != null ? t1.call$1(value) : value;
      if (3 === componentIndex) {
        if (1 !== v && -1 !== v)
          context.addIssue$3$args$name($.$get$DataError_accessorInvalidSign(), H.setRuntimeTypeInfo([index - 3, index, v], [P.Object]), _this.path);
      } else {
        t1 = _this._utils$_sum;
        if (typeof v !== "number")
          return v.$mul();
        t1 += v * v;
        _this._utils$_sum = t1;
        if (2 === componentIndex) {
          if (Math.abs(Math.sqrt(t1) - 1) > 0.00674)
            context.addIssue$3$args$name($.$get$DataError_accessorVector3NonUnit(), H.setRuntimeTypeInfo([index - 2, index, Math.sqrt(_this._utils$_sum)], [P.Object]), _this.path);
          _this._utils$_sum = 0;
        }
      }
      return true;
    },
    $asElementChecker: function() {
      return [P.num];
    }
  };
  F.ClampedRangeFloatChecker.prototype = {
    check$4: function(context, index, componentIndex, value) {
      if (typeof value !== "number")
        return H.iae(value);
      if (1 < value || 0 > value)
        context.addIssue$3$args$name($.$get$DataError_accessorNonClamped(), H.setRuntimeTypeInfo([index, value], [P.Object]), this.path);
      return true;
    },
    $asElementChecker: function() {
      return [P.double];
    }
  };
  A.ValidationResult.prototype = {
    toMap$0: function() {
      var t5, issues, issuesMap, numIssues, messages, i, issue, t6, t7, t8, t9, map, _this = this,
        t1 = P.String,
        t2 = P.Object,
        t3 = P.LinkedHashMap_LinkedHashMap$_empty(t1, t2),
        t4 = _this.uri;
      if (t4 != null)
        t3.$indexSet(0, "uri", t4.toString$0(0));
      t4 = _this.readerResult;
      t5 = t4 == null;
      if ((t5 ? null : t4.mimeType) != null)
        t3.$indexSet(0, "mimeType", t5 ? null : t4.mimeType);
      t3.$indexSet(0, "validatorVersion", "2.0.0-dev.3.2");
      if (_this.writeTimestamp)
        t3.$indexSet(0, "validatedAt", new P.DateTime(Date.now(), false).toUtc$0().toIso8601String$0());
      t4 = _this.context;
      issues = t4._issues;
      issuesMap = P.LinkedHashMap_LinkedHashMap$_empty(t1, t2);
      numIssues = H.setRuntimeTypeInfo([0, 0, 0, 0], [P.int]);
      t5 = new Array(issues.length);
      t5.fixed$length = Array;
      messages = H.setRuntimeTypeInfo(t5, [[P.Map, P.String, P.Object]]);
      for (t5 = messages.length, i = 0; i < t5; ++i) {
        if (i >= issues.length)
          return H.ioore(issues, i);
        issue = issues[i];
        t6 = issue.severityOverride;
        t7 = t6 == null;
        t8 = (t7 ? issue.type.severity : t6).index;
        if (t8 >= 4)
          return H.ioore(numIssues, t8);
        C.JSArray_methods.$indexSet(numIssues, t8, numIssues[t8] + 1);
        t8 = issue.type;
        t9 = J.trimRight$0$s(t8.message.call$1(issue._args));
        if (t7)
          t6 = t8.severity;
        map = P.LinkedHashMap_LinkedHashMap$_literal(["code", t8.code, "message", t9, "severity", t6.index], t1, t2);
        t6 = issue.pointer;
        if (t6 != null)
          map.$indexSet(0, "pointer", t6);
        else {
          t6 = issue.offset;
          if (t6 != null)
            map.$indexSet(0, "offset", t6);
        }
        C.JSArray_methods.$indexSet(messages, i, map);
      }
      issuesMap.$indexSet(0, "numErrors", numIssues[0]);
      issuesMap.$indexSet(0, "numWarnings", numIssues[1]);
      issuesMap.$indexSet(0, "numInfos", numIssues[2]);
      issuesMap.$indexSet(0, "numHints", numIssues[3]);
      issuesMap.$indexSet(0, "messages", messages);
      issuesMap.$indexSet(0, "truncated", t4._isTruncated);
      t3.$indexSet(0, "issues", issuesMap);
      t1 = _this._getGltfInfoMap$0();
      if (t1 != null)
        t3.$indexSet(0, "info", t1);
      return t3;
    },
    _getGltfInfoMap$0: function() {
      var map, t2, drawCallCount, maxAttributes, maxUVs, maxInfluences, totalVertexCount, totalTriangleCount, t3, t4,
        t1 = this.readerResult,
        root = t1 == null ? null : t1.gltf;
      t1 = root == null ? null : root.asset;
      if ((t1 == null ? null : t1.version) == null)
        return;
      map = P.LinkedHashMap_LinkedHashMap$_empty(P.String, P.Object);
      t1 = root.asset;
      map.$indexSet(0, "version", t1.version);
      t2 = t1.minVersion;
      if (t2 != null)
        map.$indexSet(0, "minVersion", t2);
      t1 = t1.generator;
      if (t1 != null)
        map.$indexSet(0, "generator", t1);
      t1 = root.extensionsUsed;
      t2 = J.getInterceptor$asx(t1);
      if (t2.get$isNotEmpty(t1))
        map.$indexSet(0, "extensionsUsed", t2.toSet$0(t1).toList$1$growable(0, false));
      t1 = root.extensionsRequired;
      t2 = J.getInterceptor$asx(t1);
      if (t2.get$isNotEmpty(t1))
        map.$indexSet(0, "extensionsRequired", t2.toSet$0(t1).toList$1$growable(0, false));
      t1 = this.context;
      t2 = t1._resourcesView;
      if (!t2.get$isEmpty(t2))
        map.$indexSet(0, "resources", t1._resourcesView);
      map.$indexSet(0, "animationCount", root.animations._utils$_length);
      map.$indexSet(0, "materialCount", root.materials._utils$_length);
      t1 = root.meshes;
      map.$indexSet(0, "hasMorphTargets", t1.any$1(t1, new A.ValidationResult__getGltfInfoMap_closure()));
      t2 = root.skins;
      map.$indexSet(0, "hasSkins", !t2.get$isEmpty(t2));
      t2 = root.textures;
      map.$indexSet(0, "hasTextures", !t2.get$isEmpty(t2));
      map.$indexSet(0, "hasDefaultScene", root.scene != null);
      for (t1 = new H.ListIterator(t1, t1.get$length(t1), [H.getTypeArgumentByIndex(t1, 0)]), drawCallCount = 0, maxAttributes = 0, maxUVs = 0, maxInfluences = 0, totalVertexCount = 0, totalTriangleCount = 0; t1.moveNext$0();) {
        t2 = t1.__internal$_current.primitives;
        if (t2 != null) {
          drawCallCount += t2._utils$_length;
          for (t2 = new H.ListIterator(t2, t2.get$length(t2), [H.getRuntimeTypeArgument(t2, "ListMixin", 0)]); t2.moveNext$0();) {
            t3 = t2.__internal$_current;
            t4 = t3._vertexCount;
            if (t4 !== -1)
              totalVertexCount += t4;
            totalTriangleCount += t3.get$trianglesCount();
            maxAttributes = Math.max(maxAttributes, t3.attributes.__js_helper$_length);
            maxUVs = Math.max(maxUVs, t3.texcoordCount);
            maxInfluences = Math.max(maxInfluences, t3.jointsCount * 4);
          }
        }
      }
      map.$indexSet(0, "drawCallCount", drawCallCount);
      map.$indexSet(0, "totalVertexCount", totalVertexCount);
      map.$indexSet(0, "totalTriangleCount", totalTriangleCount);
      map.$indexSet(0, "maxUVs", maxUVs);
      map.$indexSet(0, "maxInfluences", maxInfluences);
      map.$indexSet(0, "maxAttributes", maxAttributes);
      return map;
    }
  };
  A.ValidationResult__getGltfInfoMap_closure.prototype = {
    call$1: function(mesh) {
      var t1 = H.interceptedTypeCheck(mesh, "$isMesh").primitives;
      return t1 != null && t1.any$1(t1, new A.ValidationResult__getGltfInfoMap__closure());
    },
    $signature: 69
  };
  A.ValidationResult__getGltfInfoMap__closure.prototype = {
    call$1: function(primitive) {
      return H.interceptedTypeCheck(primitive, "$isMeshPrimitive")._targets != null;
    },
    $signature: 3
  };
  A.hashObjects_closure.prototype = {
    call$2: function(h, i) {
      var t1, hash;
      H.intTypeCheck(h);
      t1 = J.get$hashCode$(i);
      if (typeof h !== "number")
        return h.$add();
      hash = 536870911 & h + t1;
      hash = 536870911 & hash + ((524287 & hash) << 10);
      return hash ^ hash >>> 6;
    },
    $signature: 70
  };
  T.Matrix4.prototype = {
    setFrom$1: function(arg) {
      var argStorage = arg._m4storage,
        t1 = this._m4storage;
      t1[15] = argStorage[15];
      t1[14] = argStorage[14];
      t1[13] = argStorage[13];
      t1[12] = argStorage[12];
      t1[11] = argStorage[11];
      t1[10] = argStorage[10];
      t1[9] = argStorage[9];
      t1[8] = argStorage[8];
      t1[7] = argStorage[7];
      t1[6] = argStorage[6];
      t1[5] = argStorage[5];
      t1[4] = argStorage[4];
      t1[3] = argStorage[3];
      t1[2] = argStorage[2];
      t1[1] = argStorage[1];
      t1[0] = argStorage[0];
    },
    toString$0: function(_) {
      var _this = this;
      return "[0] " + _this.getRow$1(0).toString$0(0) + "\n[1] " + _this.getRow$1(1).toString$0(0) + "\n[2] " + _this.getRow$1(2).toString$0(0) + "\n[3] " + _this.getRow$1(3).toString$0(0) + "\n";
    },
    $eq: function(_, other) {
      var t1, t2, t3;
      if (other == null)
        return false;
      if (other instanceof T.Matrix4) {
        t1 = this._m4storage;
        t2 = t1[0];
        t3 = other._m4storage;
        t1 = t2 === t3[0] && t1[1] === t3[1] && t1[2] === t3[2] && t1[3] === t3[3] && t1[4] === t3[4] && t1[5] === t3[5] && t1[6] === t3[6] && t1[7] === t3[7] && t1[8] === t3[8] && t1[9] === t3[9] && t1[10] === t3[10] && t1[11] === t3[11] && t1[12] === t3[12] && t1[13] === t3[13] && t1[14] === t3[14] && t1[15] === t3[15];
      } else
        t1 = false;
      return t1;
    },
    get$hashCode: function(_) {
      return A.hashObjects(this._m4storage);
    },
    getRow$1: function(row) {
      var t3,
        t1 = new Float32Array(4),
        t2 = this._m4storage;
      if (row >= 16)
        return H.ioore(t2, row);
      t1[0] = t2[row];
      t3 = 4 + row;
      if (t3 >= 16)
        return H.ioore(t2, t3);
      t1[1] = t2[t3];
      t3 = 8 + row;
      if (t3 >= 16)
        return H.ioore(t2, t3);
      t1[2] = t2[t3];
      t3 = 12 + row;
      if (t3 >= 16)
        return H.ioore(t2, t3);
      t1[3] = t2[t3];
      return new T.Vector4(t1);
    },
    determinant$0: function() {
      var t1 = this._m4storage,
        t2 = t1[0],
        t3 = t1[5],
        t4 = t1[1],
        t5 = t1[4],
        det2_01_01 = t2 * t3 - t4 * t5,
        t6 = t1[6],
        t7 = t1[2],
        det2_01_02 = t2 * t6 - t7 * t5,
        t8 = t1[7],
        t9 = t1[3],
        det2_01_03 = t2 * t8 - t9 * t5,
        det2_01_12 = t4 * t6 - t7 * t3,
        det2_01_13 = t4 * t8 - t9 * t3,
        det2_01_23 = t7 * t8 - t9 * t6;
      t6 = t1[8];
      t9 = t1[9];
      t8 = t1[10];
      t7 = t1[11];
      return -(t9 * det2_01_23 - t8 * det2_01_13 + t7 * det2_01_12) * t1[12] + (t6 * det2_01_23 - t8 * det2_01_03 + t7 * det2_01_02) * t1[13] - (t6 * det2_01_13 - t9 * det2_01_03 + t7 * det2_01_01) * t1[14] + (t6 * det2_01_12 - t9 * det2_01_02 + t8 * det2_01_01) * t1[15];
    },
    infinityNorm$0: function() {
      var t1 = this._m4storage,
        row_norm = 0 + Math.abs(t1[0]) + Math.abs(t1[1]) + Math.abs(t1[2]) + Math.abs(t1[3]),
        norm = row_norm > 0 ? row_norm : 0;
      row_norm = 0 + Math.abs(t1[4]) + Math.abs(t1[5]) + Math.abs(t1[6]) + Math.abs(t1[7]);
      if (row_norm > norm)
        norm = row_norm;
      row_norm = 0 + Math.abs(t1[8]) + Math.abs(t1[9]) + Math.abs(t1[10]) + Math.abs(t1[11]);
      if (row_norm > norm)
        norm = row_norm;
      row_norm = 0 + Math.abs(t1[12]) + Math.abs(t1[13]) + Math.abs(t1[14]) + Math.abs(t1[15]);
      return row_norm > norm ? row_norm : norm;
    },
    isIdentity$0: function() {
      var t1 = this._m4storage;
      return t1[0] === 1 && t1[1] === 0 && t1[2] === 0 && t1[3] === 0 && t1[4] === 0 && t1[5] === 1 && t1[6] === 0 && t1[7] === 0 && t1[8] === 0 && t1[9] === 0 && t1[10] === 1 && t1[11] === 0 && t1[12] === 0 && t1[13] === 0 && t1[14] === 0 && t1[15] === 1;
    }
  };
  T.Quaternion.prototype = {
    get$length2: function() {
      var t1 = this._qStorage,
        x = t1[0],
        y = t1[1],
        z = t1[2],
        w = t1[3];
      return x * x + y * y + z * z + w * w;
    },
    get$length: function(_) {
      var t1 = this._qStorage,
        x = t1[0],
        y = t1[1],
        z = t1[2],
        w = t1[3];
      return Math.sqrt(x * x + y * y + z * z + w * w);
    },
    toString$0: function(_) {
      var t1 = this._qStorage;
      return H.S(t1[0]) + ", " + H.S(t1[1]) + ", " + H.S(t1[2]) + " @ " + H.S(t1[3]);
    }
  };
  T.Vector3.prototype = {
    setValues$3: function(x_, y_, z_) {
      var t1 = this._v3storage;
      t1[0] = x_;
      t1[1] = y_;
      t1[2] = z_;
    },
    toString$0: function(_) {
      var t1 = this._v3storage;
      return "[" + H.S(t1[0]) + "," + H.S(t1[1]) + "," + H.S(t1[2]) + "]";
    },
    $eq: function(_, other) {
      var t1, t2, t3;
      if (other == null)
        return false;
      if (other instanceof T.Vector3) {
        t1 = this._v3storage;
        t2 = t1[0];
        t3 = other._v3storage;
        t1 = t2 === t3[0] && t1[1] === t3[1] && t1[2] === t3[2];
      } else
        t1 = false;
      return t1;
    },
    get$hashCode: function(_) {
      return A.hashObjects(this._v3storage);
    },
    get$length: function(_) {
      var t1 = this._v3storage,
        t2 = t1[0],
        t3 = t1[1];
      t1 = t1[2];
      return Math.sqrt(t2 * t2 + t3 * t3 + t1 * t1);
    },
    get$length2: function() {
      var t1 = this._v3storage,
        t2 = t1[0],
        t3 = t1[1];
      t1 = t1[2];
      return t2 * t2 + t3 * t3 + t1 * t1;
    }
  };
  T.Vector4.prototype = {
    toString$0: function(_) {
      var t1 = this._v4storage;
      return H.S(t1[0]) + "," + H.S(t1[1]) + "," + H.S(t1[2]) + "," + H.S(t1[3]);
    },
    $eq: function(_, other) {
      var t1, t2, t3;
      if (other == null)
        return false;
      if (other instanceof T.Vector4) {
        t1 = this._v4storage;
        t2 = t1[0];
        t3 = other._v4storage;
        t1 = t2 === t3[0] && t1[1] === t3[1] && t1[2] === t3[2] && t1[3] === t3[3];
      } else
        t1 = false;
      return t1;
    },
    get$hashCode: function(_) {
      return A.hashObjects(this._v4storage);
    },
    get$length: function(_) {
      var t1 = this._v4storage,
        t2 = t1[0],
        t3 = t1[1],
        t4 = t1[2];
      t1 = t1[3];
      return Math.sqrt(t2 * t2 + t3 * t3 + t4 * t4 + t1 * t1);
    }
  };
  Q.Promise.prototype = {};
  Q.Exports.prototype = {};
  Q._JSValidationOptions.prototype = {};
  Q.main_onError.prototype = {
    call$3: function(e, st, reject) {
      var t1 = reject.call$1(J.toString$0$(st));
      return t1;
    }
  };
  Q.main_closure.prototype = {
    call$2: function(data, options) {
      var t1 = P.allowInterop(new Q.main__closure0(H.interceptedTypeCheck(data, "$isUint8List"), options, this.onError), {func: 1, ret: -1, args: [{func: 1, ret: -1, args: [P.Object]}, P.Function]});
      return new self.Promise(t1, P.Object);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 71
  };
  Q.main__closure0.prototype = {
    call$2: function(resolve, reject) {
      H.functionTypeCheck(resolve, {func: 1, ret: -1, args: [P.Object]});
      H.interceptedTypeCheck(reject, "$isFunction");
      Q.validateBytes(this.data, this.options).then$1$2$onError(0, new Q.main___closure1(resolve), new Q.main___closure2(this.onError, reject), P.Null);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 26
  };
  Q.main___closure1.prototype = {
    call$1: function(result) {
      this.resolve.call$1(P.jsify(H.assertSubtype(result, "$isMap", [P.String, P.Object], "$asMap")));
    },
    $signature: 27
  };
  Q.main___closure2.prototype = {
    call$2: function(e, st) {
      return this.onError.call$3(e, H.interceptedTypeCheck(st, "$isStackTrace"), this.reject);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 28
  };
  Q.main_closure0.prototype = {
    call$2: function(json, options) {
      var t1 = P.allowInterop(new Q.main__closure(H.stringTypeCheck(json), options, this.onError), {func: 1, ret: -1, args: [{func: 1, ret: -1, args: [P.Object]}, P.Function]});
      return new self.Promise(t1, P.Object);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 75
  };
  Q.main__closure.prototype = {
    call$2: function(resolve, reject) {
      H.functionTypeCheck(resolve, {func: 1, ret: -1, args: [P.Object]});
      H.interceptedTypeCheck(reject, "$isFunction");
      Q.validateString(this.json, this.options).then$1$2$onError(0, new Q.main___closure(resolve), new Q.main___closure0(this.onError, reject), P.Null);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 26
  };
  Q.main___closure.prototype = {
    call$1: function(result) {
      this.resolve.call$1(P.jsify(H.assertSubtype(result, "$isMap", [P.String, P.Object], "$asMap")));
    },
    $signature: 27
  };
  Q.main___closure0.prototype = {
    call$2: function(e, st) {
      return this.onError.call$3(e, H.interceptedTypeCheck(st, "$isStackTrace"), this.reject);
    },
    "call*": "call$2",
    $requiredArgCount: 2,
    $signature: 28
  };
  Q.main_closure1.prototype = {
    call$0: function() {
      return "2.0.0-dev.3.2";
    },
    "call*": "call$0",
    $requiredArgCount: 0,
    $signature: 114
  };
  Q.main_closure2.prototype = {
    call$0: function() {
      return P.jsify(M.Context_defaultExtensionNames());
    },
    "call*": "call$0",
    $requiredArgCount: 0,
    $signature: 77
  };
  Q._getResourcesLoader_getBytes.prototype = {
    call$1: function(uri) {
      var t1 = P.Uint8List,
        t2 = new P._Future($.Zone__current, [t1]),
        completer = new P._AsyncCompleter(t2, [t1]);
      J.then$2$x(this.getResource.call$1(J.toString$0$(uri)), P.allowInterop(new Q._getResourcesLoader_getBytes_closure(completer), {func: 1, ret: -1, args: [P.Object]}), P.allowInterop(new Q._getResourcesLoader_getBytes_closure0(completer), P.Function));
      return t2;
    },
    $signature: 78
  };
  Q._getResourcesLoader_getBytes_closure.prototype = {
    call$1: function(o) {
      var t1 = this.completer;
      if (!!J.getInterceptor$(o).$isUint8List)
        t1.complete$1(o);
      else
        t1.completeError$1(new P.ArgumentError(false, null, null, "options.externalResourceFunction: Promise must be fulfilled with Uint8Array."));
    },
    $signature: 24
  };
  Q._getResourcesLoader_getBytes_closure0.prototype = {
    call$1: function(e) {
      return this.completer.completeError$1(new Q.NodeException(J.toString$0$(e)));
    },
    $signature: 10
  };
  Q._getResourcesLoader_closure.prototype = {
    call$1: function(uri) {
      H.interceptedTypeCheck(uri, "$isUri");
      if (uri == null)
        return this.readerResult.buffer;
      return this.getBytes.call$1(uri);
    },
    call$0: function() {
      return this.call$1(null);
    },
    "call*": "call$1",
    $requiredArgCount: 0,
    $defaultValues: function() {
      return [null];
    },
    $signature: 79
  };
  Q._getResourcesLoader_closure0.prototype = {
    call$1: function(uri) {
      var t1 = this.getBytes.call$1(H.interceptedTypeCheck(uri, "$isUri"));
      return t1 == null ? null : P.Stream_Stream$fromFuture(t1, H.getTypeArgumentByIndex(t1, 0));
    },
    $signature: 80
  };
  Q.NodeException.prototype = {
    toString$0: function(_) {
      return "Node Exception: " + H.S(this.message);
    },
    $isException: 1
  };
  (function aliases() {
    var _ = J.Interceptor.prototype;
    _.super$Interceptor$noSuchMethod = _.noSuchMethod$1;
    _ = J.JavaScriptObject.prototype;
    _.super$JavaScriptObject$toString = _.toString$0;
    _ = P.ListMixin.prototype;
    _.super$ListMixin$setRange = _.setRange$4;
    _ = P._StringSinkConversionSink.prototype;
    _.super$_StringSinkConversionSink$close = _.close$0;
  })();
  (function installTearOffs() {
    var _static_1 = hunkHelpers._static_1,
      _static_0 = hunkHelpers._static_0,
      _static = hunkHelpers.installStaticTearOff,
      _instance = hunkHelpers.installInstanceTearOff,
      _instance_0_u = hunkHelpers._instance_0u,
      _instance_1_i = hunkHelpers._instance_1i,
      _static_2 = hunkHelpers._static_2,
      _instance_1_u = hunkHelpers._instance_1u;
    _static_1(P, "async__AsyncRun__scheduleImmediateJsOverride$closure", "_AsyncRun__scheduleImmediateJsOverride", 11);
    _static_1(P, "async__AsyncRun__scheduleImmediateWithSetImmediate$closure", "_AsyncRun__scheduleImmediateWithSetImmediate", 11);
    _static_1(P, "async__AsyncRun__scheduleImmediateWithTimer$closure", "_AsyncRun__scheduleImmediateWithTimer", 11);
    _static_0(P, "async___startMicrotaskLoop$closure", "_startMicrotaskLoop", 1);
    _static(P, "async___nullErrorHandler$closure", 1, null, ["call$2", "call$1"], ["_nullErrorHandler", function(error) {
      return P._nullErrorHandler(error, null);
    }], 14, 0);
    _instance(P._Future.prototype, "get$_completeError", 0, 1, function() {
      return [null];
    }, ["call$2", "call$1"], ["_completeError$2", "_completeError$1"], 14, 0);
    _instance_0_u(P._StreamController.prototype, "get$close", "close$0", 16);
    var _;
    _instance_0_u(_ = P._ControllerSubscription.prototype, "get$_onPause", "_onPause$0", 1);
    _instance_0_u(_, "get$_onResume", "_onResume$0", 1);
    _instance(_ = P._BufferingStreamSubscription.prototype, "get$pause", 0, 0, null, ["call$1", "call$0"], ["pause$1", "pause$0"], 43, 0);
    _instance_0_u(_, "get$resume", "resume$0", 1);
    _instance_0_u(_, "get$_onPause", "_onPause$0", 1);
    _instance_0_u(_, "get$_onResume", "_onResume$0", 1);
    _instance_1_i(P._LinkedHashSet.prototype, "get$contains", "contains$1", 45);
    _static_2(M, "accessor_Accessor_fromMap$closure", "Accessor_fromMap", 82);
    _static_2(M, "accessor_AccessorSparse_fromMap$closure", "AccessorSparse_fromMap", 83);
    _static_2(M, "accessor_AccessorSparseIndices_fromMap$closure", "AccessorSparseIndices_fromMap", 84);
    _static_2(M, "accessor_AccessorSparseValues_fromMap$closure", "AccessorSparseValues_fromMap", 85);
    _instance_1_u(M.Accessor.prototype, "get$normalizeValue", "normalizeValue$1", 72);
    _static_2(Z, "animation_Animation_fromMap$closure", "Animation_fromMap", 86);
    _static_2(Z, "animation_AnimationChannelTarget_fromMap$closure", "AnimationChannelTarget_fromMap", 87);
    _static_2(T, "asset_Asset_fromMap$closure", "Asset_fromMap", 88);
    _static_2(Q, "buffer_Buffer_fromMap$closure", "Buffer_fromMap", 89);
    _static_2(V, "buffer_view_BufferView_fromMap$closure", "BufferView_fromMap", 90);
    _static_2(G, "camera_Camera_fromMap$closure", "Camera_fromMap", 91);
    _static_2(G, "camera_CameraOrthographic_fromMap$closure", "CameraOrthographic_fromMap", 92);
    _static_2(G, "camera_CameraPerspective_fromMap$closure", "CameraPerspective_fromMap", 93);
    _static_2(T, "image_Image_fromMap$closure", "Image_fromMap", 94);
    _static_2(Y, "material_Material_fromMap$closure", "Material_fromMap", 95);
    _static_2(Y, "material_PbrMetallicRoughness_fromMap$closure", "PbrMetallicRoughness_fromMap", 96);
    _static_2(Y, "material_OcclusionTextureInfo_fromMap$closure", "OcclusionTextureInfo_fromMap", 97);
    _static_2(Y, "material_NormalTextureInfo_fromMap$closure", "NormalTextureInfo_fromMap", 98);
    _static_2(Y, "material_TextureInfo_fromMap$closure", "TextureInfo_fromMap", 99);
    _static_2(S, "mesh_Mesh_fromMap$closure", "Mesh_fromMap", 100);
    _static_2(V, "node_Node_fromMap$closure", "Node_fromMap", 101);
    _static_2(T, "sampler_Sampler_fromMap$closure", "Sampler_fromMap", 102);
    _static_2(B, "scene_Scene_fromMap$closure", "Scene_fromMap", 103);
    _static_2(O, "skin_Skin_fromMap$closure", "Skin_fromMap", 104);
    _static_2(U, "texture_Texture_fromMap$closure", "Texture_fromMap", 105);
    _static_1(E, "errors___q$closure", "_q", 29);
    _static_1(E, "errors___mbq$closure", "_mbq", 29);
    _static_1(D, "ext_texture_webp___init$closure", "_init", 12);
    _static_2(D, "ext_texture_webp_ExtTextureWebPTexture_fromMap$closure", "ExtTextureWebPTexture_fromMap", 108);
    _static_2(X, "khr_lights_punctual_KhrLightsPunctualGltf_fromMap$closure", "KhrLightsPunctualGltf_fromMap", 109);
    _static_2(X, "khr_lights_punctual_KhrLightsPunctualLightSpot_fromMap$closure", "KhrLightsPunctualLightSpot_fromMap", 110);
    _static_2(X, "khr_lights_punctual_KhrLightsPunctualNode_fromMap$closure", "KhrLightsPunctualNode_fromMap", 111);
    _static_2(A, "khr_materials_pbr_specular_glossiness_KhrMaterialsPbrSpecularGlossiness_fromMap$closure", "KhrMaterialsPbrSpecularGlossiness_fromMap", 112);
    _static_2(S, "khr_materials_unlit_KhrMaterialsUnlit_fromMap$closure", "KhrMaterialsUnlit_fromMap", 113);
    _static_2(L, "khr_texture_transform_KhrTextureTransform_fromMap$closure", "KhrTextureTransform_fromMap", 76);
    _instance_1_u(_ = A.GlbReader.prototype, "get$_glb_reader$_onData", "_glb_reader$_onData$1", 25);
    _instance_0_u(_, "get$_glb_reader$_onDone", "_glb_reader$_onDone$0", 1);
    _instance_1_u(_, "get$_glb_reader$_onError", "_glb_reader$_onError$1", 10);
    _instance_1_u(_ = K.GltfJsonReader.prototype, "get$_gltf_reader$_onData", "_gltf_reader$_onData$1", 25);
    _instance_1_u(_, "get$_gltf_reader$_onError", "_gltf_reader$_onError$1", 10);
    _instance_0_u(_, "get$_gltf_reader$_onDone", "_gltf_reader$_onDone$0", 1);
    _static_1(U, "khr_mesh_quantization___init$closure", "_init0", 12);
  })();
  (function inheritance() {
    var _mixin = hunkHelpers.mixin,
      _inherit = hunkHelpers.inherit,
      _inheritMany = hunkHelpers.inheritMany;
    _inherit(P.Object, null);
    _inheritMany(P.Object, [H.JS_CONST, J.Interceptor, J.ArrayIterator, P.Iterable, H.CastIterator, P.MapMixin, H.Closure, P._ListBase_Object_ListMixin, H.ListIterator, P.Iterator, H.EmptyIterator, H.FixedLengthListMixin, H.UnmodifiableListMixin, H.Symbol, P.MapView, H.ConstantMap, H.JSInvocationMirror, H.TypeErrorDecoder, P.Error, H.ExceptionAndStackTrace, H._StackTrace, H.TypeImpl, H.LinkedHashMapCell, H.LinkedHashMapKeyIterator, H.JSSyntaxRegExp, H._MatchImplementation, P._TimerImpl, P._AsyncAwaitCompleter, P._IterationMarker, P._SyncStarIterator, P.Future, P._Completer, P._FutureListener, P._Future, P._AsyncCallbackEntry, P.Stream, P.StreamTransformerBase, P._StreamController, P._SyncStreamControllerDispatch, P._AsyncStreamControllerDispatch, P._BufferingStreamSubscription, P._PendingEvents, P._DelayedEvent, P._DelayedDone, P._StreamIterator, P.AsyncError, P._Zone, P._HashMapKeyIterator, P._SetBase, P._LinkedHashSetCell, P._LinkedHashSetIterator, P.ListMixin, P._UnmodifiableMapMixin, P.StringConversionSinkMixin, P.Codec, P._Base64Decoder, P.ChunkedConversionSink, P._Utf8Decoder, P.bool, P.DateTime, P.num, P.OutOfMemoryError, P.StackOverflowError, P._Exception, P.FormatException, P.Function, P.List, P.Map, P.MapEntry, P.Null, P.StackTrace, P.String, P.StringBuffer, P.StringSink, P.Symbol0, P.Type, P.Uri, P._Uri, P.UriData, P._SimpleUri, P.Uint8List, V.GltfProperty, F.ElementChecker, V.ResourceValidatable, V.BufferViewUsage, V.AccessorUsage, V.AccessorFormat, M.ValidationOptions, M.Context, M.IssuesLimitExceededException, Y._ImageCodec, Y._ColorPrimaries, Y._ColorTransfer, Y.Format, Y.ImageInfo, Y.ImageInfoDecoder, Y.UnsupportedImageFormatException, Y.UnexpectedEndOfStreamException, Y.InvalidDataFormatException, N._Storage, N.ResourceInfo, N.ResourcesLoader, O.InfluencesChecker, E.Severity, E.IssueType, E.Issue, D.Extension, D.ExtFuncs, D.ExtensionTuple, D.LinkableExtensionEntry, D.ResourceValidatableExtensionEntry, A.GlbReader, K.GltfReaderResult, K.GltfReader, K.GltfJsonReader, K.GltfInvalidFormatException, A.ValidationResult, T.Matrix4, T.Quaternion, T.Vector3, T.Vector4, Q.NodeException]);
    _inheritMany(J.Interceptor, [J.JSBool, J.JSNull, J.JavaScriptObject, J.JSArray, J.JSNumber, J.JSString, H.NativeTypedData]);
    _inheritMany(J.JavaScriptObject, [J.PlainJavaScriptObject, J.UnknownJavaScriptObject, J.JavaScriptFunction, Q.Promise, Q.Exports, Q._JSValidationOptions]);
    _inherit(J.JSUnmodifiableArray, J.JSArray);
    _inheritMany(J.JSNumber, [J.JSInt, J.JSDouble]);
    _inheritMany(P.Iterable, [H._CastIterableBase, H.EfficientLengthIterable, H.MappedIterable, H.WhereIterable, H.SkipIterable, H._ConstantMapKeyIterable, P.IterableBase]);
    _inheritMany(H._CastIterableBase, [H.CastIterable, H.__CastListBase__CastIterableBase_ListMixin]);
    _inherit(H._EfficientLengthCastIterable, H.CastIterable);
    _inherit(H._CastListBase, H.__CastListBase__CastIterableBase_ListMixin);
    _inherit(H.CastList, H._CastListBase);
    _inherit(P.MapBase, P.MapMixin);
    _inheritMany(P.MapBase, [H.CastMap, H.JsLinkedHashMap, P._HashMap, P._JsonMap]);
    _inheritMany(H.Closure, [H.CastMap_forEach_closure, H.Primitives_functionNoSuchMethod_closure, H.unwrapException_saveStackTrace, H.TearOffClosure, H.JsLinkedHashMap_values_closure, H.initHooks_closure, H.initHooks_closure0, H.initHooks_closure1, P._AsyncRun__initializeScheduleImmediate_internalCallback, P._AsyncRun__initializeScheduleImmediate_closure, P._AsyncRun__scheduleImmediateJsOverride_internalCallback, P._AsyncRun__scheduleImmediateWithSetImmediate_internalCallback, P._TimerImpl_internalCallback, P._awaitOnObject_closure, P._awaitOnObject_closure0, P._wrapJsFunctionForAsync_closure, P._Future__addListener_closure, P._Future__prependListeners_closure, P._Future__chainForeignFuture_closure, P._Future__chainForeignFuture_closure0, P._Future__chainForeignFuture_closure1, P._Future__asyncComplete_closure, P._Future__chainFuture_closure, P._Future__asyncCompleteError_closure, P._Future__propagateToListeners_handleWhenCompleteCallback, P._Future__propagateToListeners_handleWhenCompleteCallback_closure, P._Future__propagateToListeners_handleValueCallback, P._Future__propagateToListeners_handleError, P.Stream_Stream$fromFuture_closure, P.Stream_Stream$fromFuture_closure0, P.Stream_Stream$fromIterable_closure, P.Stream_length_closure, P.Stream_length_closure0, P._StreamController__subscribe_closure, P._StreamController__recordCancel_complete, P._BufferingStreamSubscription__sendError_sendError, P._BufferingStreamSubscription__sendDone_sendDone, P._PendingEvents_schedule_closure, P._rootHandleUncaughtError_closure, P._RootZone_bindCallback_closure, P._RootZone_bindCallbackGuarded_closure, P.MapBase_mapToString_closure, P.MapMixin_entries_closure, P.NoSuchMethodError_toString_closure, P.Uri__parseIPv4Address_error, P.Uri_parseIPv6Address_error, P.Uri_parseIPv6Address_parseHex, P._Uri__Uri$notSimple_closure, P._createTables_closure, P._createTables_build, P._createTables_setChars, P._createTables_setRange, P._convertDataTree__convert, M._AccessorInt_getElements_closure, M._AccessorInt_getElements_closure0, M._AccessorInt_getElements_closure1, M._AccessorInt_getElements_closure2, M._AccessorInt_getElementsNormalized_closure, M._AccessorInt_getElementsNormalized_closure0, M._AccessorFloat_getElements_closure, M._AccessorFloat_getElements_closure0, M._AccessorFloat_getElements_closure1, M._AccessorFloat_getElements_closure2, Z.Animation_link_closure, Z.Animation_link_closure0, V.Gltf_Gltf$fromMap_resetPath, V.Gltf_Gltf$fromMap_toSafeList, V.Gltf_Gltf$fromMap_toValue, V.Gltf_Gltf$fromMap_linkCollection, V.Gltf_Gltf$fromMap_linkCollection_closure, V.Gltf_Gltf$fromMap_closure, V.Gltf_Gltf$fromMap_closure0, V.Gltf_Gltf$fromMap__closure, V.Gltf_Gltf$fromMap__closure0, V.Gltf_validateResources_validateResourcesInCollection, V.Gltf_validateResources_validateResourcesInCollection_closure, Y.Material_link_linkWithPath, S.Mesh_link_closure, S.MeshPrimitive_MeshPrimitive$fromMap_checkAttributeSemanticName, S.MeshPrimitive_MeshPrimitive$fromMap_checkContinuity, S.MeshPrimitive_MeshPrimitive$fromMap_checkMorphTargetAttributeSemanticName, S.MeshPrimitive_link_closure, S.MeshPrimitive_link_closure0, S.MeshPrimitive_link_closure1, S.MeshPrimitive_link_closure2, S.MeshPrimitive_link_closure3, S.MeshPrimitive__checkAccessorRefs_closure, V.Node_link_closure, V.Node_link_closure0, V.Node_link_closure1, B.Scene_link_closure, O.Skin_link_closure, M.Context_defaultExtensionNames_closure, M.Context_addElementChecker_closure, M.Context_getPointerString_closure, M.Context_initExtensions_closure, M.Context_initExtensions_closure0, M.Context_initExtensions__closure, M.Context_initExtensions__closure0, M.Context_initExtensions_closure1, Y.ImageInfo_parseStreamAsync_closure, Y.ImageInfo_parseStreamAsync_closure1, Y.ImageInfo_parseStreamAsync_closure0, Y.ImageInfo__detectCodec_beginsWith, Y.JpegInfoDecoder__add_isSOF, Y.JpegInfoDecoder__add_hasSegment, Y.PngInfoDecoder_add_reset, N.ResourcesLoader__loadBuffers__fetchBuffer, N.ResourcesLoader__loadImages__fetchImageData, O.validateAccessorsData_closure, O.validateAccessorsData_closure0, O.validateAccessorsData_closure1, O._stepInfluencesIterators_closure, E.DataError_closure16, E.DataError_closure14, E.DataError_closure13, E.DataError_closure20, E.DataError_closure18, E.DataError_closure19, E.DataError_closure17, E.DataError_closure29, E.DataError_closure30, E.DataError_closure22, E.DataError_closure28, E.DataError_closure21, E.DataError_closure27, E.DataError_closure25, E.DataError_closure26, E.DataError_closure24, E.DataError_closure23, E.DataError_closure5, E.DataError_closure4, E.DataError_closure31, E.DataError_closure9, E.DataError_closure8, E.DataError_closure10, E.DataError_closure11, E.DataError_closure12, E.DataError_closure7, E.DataError_closure6, E.DataError_closure15, E.DataError_closure3, E.DataError_closure2, E.DataError_closure1, E.DataError_closure, E.DataError_closure0, E.IoError_closure, E.SchemaError_closure3, E.SchemaError_closure4, E.SchemaError_closure9, E.SchemaError_closure7, E.SchemaError_closure14, E.SchemaError_closure10, E.SchemaError_closure5, E.SchemaError_closure11, E.SchemaError_closure8, E.SchemaError_closure, E.SchemaError_closure2, E.SchemaError_closure1, E.SchemaError_closure12, E.SchemaError_closure0, E.SchemaError_closure6, E.SchemaError_closure13, E.SemanticError_closure38, E.SemanticError_closure37, E.SemanticError_closure28, E.SemanticError_closure26, E.SemanticError_closure27, E.SemanticError_closure25, E.SemanticError_closure23, E.SemanticError_closure24, E.SemanticError_closure33, E.SemanticError_closure34, E.SemanticError_closure22, E.SemanticError_closure21, E.SemanticError_closure20, E.SemanticError_closure19, E.SemanticError_closure18, E.SemanticError_closure16, E.SemanticError_closure10, E.SemanticError_closure9, E.SemanticError_closure8, E.SemanticError_closure15, E.SemanticError_closure12, E.SemanticError_closure14, E.SemanticError_closure11, E.SemanticError_closure13, E.SemanticError_closure7, E.SemanticError_closure5, E.SemanticError_closure4, E.SemanticError_closure3, E.SemanticError_closure6, E.SemanticError_closure39, E.SemanticError_closure40, E.SemanticError_closure41, E.SemanticError_closure42, E.SemanticError_closure32, E.SemanticError_closure31, E.SemanticError_closure30, E.SemanticError_closure29, E.SemanticError_closure36, E.SemanticError_closure35, E.SemanticError_closure17, E.SemanticError_closure0, E.SemanticError_closure, E.SemanticError_closure2, E.SemanticError_closure1, E.LinkError_closure4, E.LinkError_closure8, E.LinkError_closure3, E.LinkError_closure17, E.LinkError_closure9, E.LinkError_closure13, E.LinkError_closure12, E.LinkError_closure15, E.LinkError_closure16, E.LinkError_closure11, E.LinkError_closure14, E.LinkError_closure10, E.LinkError_closure2, E.LinkError_closure18, E.LinkError_closure7, E.LinkError_closure35, E.LinkError_closure21, E.LinkError_closure22, E.LinkError_closure19, E.LinkError_closure20, E.LinkError_closure28, E.LinkError_closure27, E.LinkError_closure26, E.LinkError_closure25, E.LinkError_closure29, E.LinkError_closure24, E.LinkError_closure23, E.LinkError_closure6, E.LinkError_closure30, E.LinkError_closure33, E.LinkError_closure32, E.LinkError_closure31, E.LinkError_closure34, E.LinkError_closure36, E.LinkError_closure1, E.LinkError_closure0, E.LinkError_closure, E.LinkError_closure37, E.LinkError_closure38, E.LinkError_closure5, E.GlbError_closure12, E.GlbError_closure11, E.GlbError_closure10, E.GlbError_closure9, E.GlbError_closure0, E.GlbError_closure8, E.GlbError_closure4, E.GlbError_closure5, E.GlbError_closure1, E.GlbError_closure, E.GlbError_closure2, E.GlbError_closure7, E.GlbError_closure6, E.GlbError_closure3, X.KhrLightsPunctualGltf_link_closure, A.GlbReader_read_closure, A.GlbReader__onData_updateState, A.GlbReader__onDone_closure, K.GltfReader_detect_closure0, K.GltfReader_detect_closure1, K.GltfReader_detect_closure, K.GltfReader_detect_closure2, K.GltfJsonReader_read_closure, F.getIndicesMap_closure, F.getIndicesMapsList_closure, F.getIndicesMapsList_closure0, F.getExtensions_closure, A.ValidationResult__getGltfInfoMap_closure, A.ValidationResult__getGltfInfoMap__closure, A.hashObjects_closure, Q.main_onError, Q.main_closure, Q.main__closure0, Q.main___closure1, Q.main___closure2, Q.main_closure0, Q.main__closure, Q.main___closure, Q.main___closure0, Q.main_closure1, Q.main_closure2, Q._getResourcesLoader_getBytes, Q._getResourcesLoader_getBytes_closure, Q._getResourcesLoader_getBytes_closure0, Q._getResourcesLoader_closure, Q._getResourcesLoader_closure0]);
    _inherit(P.ListBase, P._ListBase_Object_ListMixin);
    _inheritMany(P.ListBase, [H.UnmodifiableListBase, F.SafeList]);
    _inheritMany(H.UnmodifiableListBase, [H.CodeUnits, P.UnmodifiableListView]);
    _inheritMany(H.EfficientLengthIterable, [H.ListIterable, H.EmptyIterable, H.LinkedHashMapKeyIterable, P._HashMapKeyIterable, P.Set]);
    _inheritMany(H.ListIterable, [H.SubListIterable, H.MappedListIterable, P._JsonMapKeyIterable, P._GeneratorIterable]);
    _inherit(H.EfficientLengthMappedIterable, H.MappedIterable);
    _inheritMany(P.Iterator, [H.MappedIterator, H.WhereIterator, H.SkipIterator]);
    _inherit(H.EfficientLengthSkipIterable, H.SkipIterable);
    _inherit(P._UnmodifiableMapView_MapView__UnmodifiableMapMixin, P.MapView);
    _inherit(P.UnmodifiableMapView, P._UnmodifiableMapView_MapView__UnmodifiableMapMixin);
    _inherit(H.ConstantMapView, P.UnmodifiableMapView);
    _inheritMany(H.ConstantMap, [H.ConstantStringMap, H.GeneralConstantMap]);
    _inheritMany(P.Error, [H.NullError, H.JsNoSuchMethodError, H.UnknownJsTypeError, H.TypeErrorImplementation, H.CastErrorImplementation, H.RuntimeError, P.AssertionError, P.NullThrownError, P.ArgumentError, P.NoSuchMethodError, P.UnsupportedError, P.UnimplementedError, P.StateError, P.ConcurrentModificationError, P.CyclicInitializationError]);
    _inheritMany(H.TearOffClosure, [H.StaticClosure, H.BoundClosure]);
    _inherit(H._AssertionError, P.AssertionError);
    _inheritMany(H.NativeTypedData, [H.NativeByteData, H.NativeTypedArray]);
    _inheritMany(H.NativeTypedArray, [H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin, H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin]);
    _inherit(H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin, H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin);
    _inherit(H.NativeTypedArrayOfDouble, H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin);
    _inherit(H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin, H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin);
    _inherit(H.NativeTypedArrayOfInt, H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin);
    _inheritMany(H.NativeTypedArrayOfDouble, [H.NativeFloat32List, H.NativeFloat64List]);
    _inheritMany(H.NativeTypedArrayOfInt, [H.NativeInt16List, H.NativeInt32List, H.NativeInt8List, H.NativeUint16List, H.NativeUint32List, H.NativeUint8ClampedList, H.NativeUint8List]);
    _inherit(P._SyncStarIterable, P.IterableBase);
    _inherit(P._AsyncCompleter, P._Completer);
    _inheritMany(P._StreamController, [P._AsyncStreamController, P._SyncStreamController]);
    _inherit(P._StreamImpl, P.Stream);
    _inheritMany(P._StreamImpl, [P._ControllerStream, P._GeneratedStreamImpl]);
    _inherit(P._ControllerSubscription, P._BufferingStreamSubscription);
    _inheritMany(P._PendingEvents, [P._IterablePendingEvents, P._StreamImplEvents]);
    _inheritMany(P._DelayedEvent, [P._DelayedData, P._DelayedError]);
    _inherit(P._RootZone, P._Zone);
    _inherit(P._IdentityHashMap, P._HashMap);
    _inheritMany(P._SetBase, [P._LinkedHashSet, P._UnmodifiableSet]);
    _inherit(P.StringConversionSinkBase, P.StringConversionSinkMixin);
    _inherit(P._StringSinkConversionSink, P.StringConversionSinkBase);
    _inherit(P._JsonDecoderSink, P._StringSinkConversionSink);
    _inheritMany(P.Codec, [P.Base64Codec, P.Encoding, P.JsonCodec]);
    _inherit(P.Converter, P.StreamTransformerBase);
    _inheritMany(P.Converter, [P.Base64Encoder, P.Base64Decoder, P.JsonDecoder, P.Utf8Decoder]);
    _inheritMany(P.ChunkedConversionSink, [P.ByteConversionSink, P._SimpleCallbackSink]);
    _inherit(P._Utf8StringSinkAdapter, P.ByteConversionSink);
    _inherit(P.Utf8Codec, P.Encoding);
    _inheritMany(P.num, [P.double, P.int]);
    _inheritMany(P.ArgumentError, [P.RangeError, P.IndexError]);
    _inherit(P._DataUri, P._Uri);
    _inheritMany(V.GltfProperty, [V.GltfChildOfRootProperty, M.AccessorSparse, M.AccessorSparseIndices, M.AccessorSparseValues, Z.AnimationChannel, Z.AnimationChannelTarget, Z.AnimationSampler, T.Asset, G.CameraOrthographic, G.CameraPerspective, V.Gltf, Y.PbrMetallicRoughness, Y.TextureInfo, S.MeshPrimitive, D.ExtTextureWebPTexture, X.KhrLightsPunctualGltf, X.KhrLightsPunctualLightSpot, X.KhrLightsPunctualNode, A.KhrMaterialsPbrSpecularGlossiness, S.KhrMaterialsUnlit, L.KhrTextureTransform]);
    _inheritMany(V.GltfChildOfRootProperty, [M.Accessor, Z.Animation, Q.Buffer, V.BufferView, G.Camera, T.Image, Y.Material, S.Mesh, V.Node, T.Sampler, B.Scene, O.Skin, U.Texture, X.KhrLightsPunctualLight]);
    _inheritMany(M.Accessor, [M._AccessorInt, M._AccessorFloat]);
    _inheritMany(F.ElementChecker, [M.InvalidFloatChecker, M.MinFloatChecker, M.MaxFloatChecker, M.MinIntegerChecker, M.MaxIntegerChecker, Z.AnimationInputChecker, Z.QuaternionFloatChecker, S.IndexBufferIntegerChecker, O.IbmMatrixFloatChecker, F.UnitVec3FloatChecker, F.UnitVec3SignFloatChecker, F.ClampedRangeFloatChecker]);
    _inheritMany(Y.TextureInfo, [Y.OcclusionTextureInfo, Y.NormalTextureInfo]);
    _inheritMany(Y.ImageInfoDecoder, [Y.JpegInfoDecoder, Y.PngInfoDecoder, Y.WebPInfoDecoder]);
    _inheritMany(E.IssueType, [E.DataError, E.IoError, E.SchemaError, E.SemanticError, E.LinkError, E.GlbError]);
    _mixin(H.UnmodifiableListBase, H.UnmodifiableListMixin);
    _mixin(H.__CastListBase__CastIterableBase_ListMixin, P.ListMixin);
    _mixin(H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin, P.ListMixin);
    _mixin(H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin, H.FixedLengthListMixin);
    _mixin(H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin, P.ListMixin);
    _mixin(H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin, H.FixedLengthListMixin);
    _mixin(P._AsyncStreamController, P._AsyncStreamControllerDispatch);
    _mixin(P._SyncStreamController, P._SyncStreamControllerDispatch);
    _mixin(P._ListBase_Object_ListMixin, P.ListMixin);
    _mixin(P._UnmodifiableMapView_MapView__UnmodifiableMapMixin, P._UnmodifiableMapMixin);
  })();
  var init = {mangledGlobalNames: {int: "int", double: "double", num: "num", String: "String", bool: "bool", Null: "Null", List: "List"}, mangledNames: {}, getTypeFromName: getGlobalFromName, metadata: [], types: [{func: 1, ret: P.String, args: [[P.List,,]]}, {func: 1, ret: -1}, {func: 1, ret: P.Null}, {func: 1, ret: P.bool, args: [S.MeshPrimitive]}, {func: 1, args: [,]}, {func: 1, ret: P.double, args: [P.int]}, {func: 1, ret: P.Null, args: [P.String, P.Object]}, {func: 1, ret: P.Null, args: [P.String, P.int]}, {func: 1, ret: P.bool, args: [P.int]}, {func: 1, ret: P.Null, args: [V.Node, P.int, P.int]}, {func: 1, ret: -1, args: [P.Object]}, {func: 1, ret: -1, args: [{func: 1, ret: -1}]}, {func: 1, ret: -1, args: [M.Context]}, {func: 1, ret: P.Null, args: [,]}, {func: 1, ret: -1, args: [P.Object], opt: [P.StackTrace]}, {func: 1, ret: P.Null, args: [,,]}, {func: 1, ret: [P.Future,,]}, {func: 1, ret: [P.Iterable, P.int]}, {func: 1, ret: P.int, args: [P.int]}, {func: 1, ret: [P.Iterable, P.double]}, {func: 1, ret: P.Null, args: [P.int, S.MeshPrimitive]}, {func: 1, ret: -1, args: [P.String]}, {func: 1, ret: P.bool, args: [D.Extension]}, {func: 1, ret: P.Null, args: [[P.List, P.int]]}, {func: 1, ret: P.Null, args: [P.Object]}, {func: 1, ret: -1, args: [[P.List, P.int]]}, {func: 1, ret: P.Null, args: [{func: 1, ret: -1, args: [P.Object]}, P.Function]}, {func: 1, ret: P.Null, args: [[P.Map, P.String, P.Object]]}, {func: 1, ret: -1, args: [P.Object, P.StackTrace]}, {func: 1, ret: P.String, args: [P.Object]}, {func: 1, ret: P.Null, args: [P.int, V.ResourceValidatable]}, {func: 1, ret: P.Null, args: [P.int, Z.AnimationChannel]}, {func: 1, ret: -1, args: [[F.SafeList, V.GltfProperty], P.Type]}, {func: 1, ret: P.Null, args: [P.int, V.GltfProperty]}, {func: 1, ret: P.Null, args: [,], opt: [P.StackTrace]}, {func: 1, ret: P.Null, args: [P.int, V.Node]}, {func: 1, ret: P.bool, args: [V.Node]}, {func: 1, ret: -1, args: [[F.SafeList, V.ResourceValidatable]]}, {func: 1, ret: P.Null, args: [P.String,,]}, {func: 1, ret: -1, args: [V.GltfProperty, P.String]}, {func: 1, ret: [P._Future,,], args: [,]}, {func: 1, args: [P.String]}, {func: 1, args: [, P.String]}, {func: 1, ret: -1, opt: [[P.Future,,]]}, {func: 1, ret: [P.Set, [M.Accessor, P.num]]}, {func: 1, ret: P.bool, args: [P.Object]}, {func: 1, ret: P.Null, args: [P.Symbol0,,]}, {func: 1, ret: P.String, args: [D.Extension]}, {func: 1, ret: [P.List, [F.ElementChecker, P.num]]}, {func: 1, ret: P.String, args: [P.String]}, {func: 1, ret: -1, args: [P.String, P.int]}, {func: 1, ret: D.Extension}, {func: 1, ret: P.Null, args: [P.Type, D.ExtFuncs]}, {func: 1, ret: -1, args: [P.String], opt: [,]}, {func: 1, ret: P.int, args: [P.int, P.int]}, {func: 1, ret: P.bool, args: [[P.List, P.int], [P.List, P.int]]}, {func: 1, ret: {futureOr: 1, type: [P.List, P.int]}, args: [Q.Buffer]}, {func: 1, ret: [P.Stream, [P.List, P.int]], args: [T.Image]}, {func: 1, ret: P.Null, args: [P.int, [M.Accessor, P.num]]}, {func: 1, ret: P.bool, args: [[P.Iterator, P.num]]}, {func: 1, ret: P.Null, args: [P.String]}, {func: 1, ret: P.Null, args: [P.int, X.KhrLightsPunctualLight]}, {func: 1, ret: P.Uint8List, args: [P.int]}, {func: 1, ret: P.Uint8List, args: [,,]}, {func: 1, ret: -1, named: {seen: P.bool}}, {func: 1, ret: P.Null, args: [K.GltfReaderResult]}, {func: 1, ret: P.Null, args: [[P.List, P.Object]]}, {func: 1, ret: [P.Map, P.String, P.int], args: [[P.Map,,,]]}, {func: 1, ret: [P.List, D.LinkableExtensionEntry]}, {func: 1, ret: P.bool, args: [S.Mesh]}, {func: 1, ret: P.int, args: [P.int, P.Object]}, {func: 1, ret: [Q.Promise, -2], args: [P.Uint8List, P.Object]}, {func: 1, ret: P.double, args: [P.num]}, {func: 1, ret: -1, args: [,]}, {func: 1, ret: P.Null, args: [, P.StackTrace]}, {func: 1, ret: [Q.Promise, -2], args: [P.String, P.Object]}, {func: 1, ret: L.KhrTextureTransform, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1}, {func: 1, ret: [P.Future, P.Uint8List], args: [P.Uri]}, {func: 1, ret: {futureOr: 1, type: P.Uint8List}, opt: [P.Uri]}, {func: 1, ret: [P.Stream, P.Uint8List], args: [P.Uri]}, {func: 1, ret: P.Null, args: [P.int,,]}, {func: 1, ret: [M.Accessor, P.num], args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: M.AccessorSparse, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: M.AccessorSparseIndices, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: M.AccessorSparseValues, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Z.Animation, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Z.AnimationChannelTarget, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: T.Asset, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Q.Buffer, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: V.BufferView, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: G.Camera, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: G.CameraOrthographic, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: G.CameraPerspective, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: T.Image, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Y.Material, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Y.PbrMetallicRoughness, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Y.OcclusionTextureInfo, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Y.NormalTextureInfo, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: Y.TextureInfo, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: S.Mesh, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: V.Node, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: T.Sampler, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: B.Scene, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: O.Skin, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: U.Texture, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: P.Null, args: [{func: 1, ret: -1}]}, {func: 1, ret: P.Null, args: [P.int, Z.AnimationSampler]}, {func: 1, ret: D.ExtTextureWebPTexture, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: X.KhrLightsPunctualGltf, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: X.KhrLightsPunctualLightSpot, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: X.KhrLightsPunctualNode, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: A.KhrMaterialsPbrSpecularGlossiness, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: S.KhrMaterialsUnlit, args: [[P.Map, P.String, P.Object], M.Context]}, {func: 1, ret: P.String}], interceptorsByTag: null, leafTags: null};
  (function constants() {
    var makeConstList = hunkHelpers.makeConstList;
    C.Interceptor_methods = J.Interceptor.prototype;
    C.JSArray_methods = J.JSArray.prototype;
    C.JSBool_methods = J.JSBool.prototype;
    C.JSInt_methods = J.JSInt.prototype;
    C.JSNumber_methods = J.JSNumber.prototype;
    C.JSString_methods = J.JSString.prototype;
    C.JavaScriptFunction_methods = J.JavaScriptFunction.prototype;
    C.NativeFloat32List_methods = H.NativeFloat32List.prototype;
    C.NativeUint8List_methods = H.NativeUint8List.prototype;
    C.PlainJavaScriptObject_methods = J.PlainJavaScriptObject.prototype;
    C.UnknownJavaScriptObject_methods = J.UnknownJavaScriptObject.prototype;
    C.AccessorFormat_MAT4_5126_false = new V.AccessorFormat("MAT4", 5126, false);
    C.AccessorFormat_SCALAR_5126_false = new V.AccessorFormat("SCALAR", 5126, false);
    C.AccessorFormat_VEC2_5121_true = new V.AccessorFormat("VEC2", 5121, true);
    C.AccessorFormat_VEC2_5123_true = new V.AccessorFormat("VEC2", 5123, true);
    C.AccessorFormat_VEC2_5126_false = new V.AccessorFormat("VEC2", 5126, false);
    C.AccessorFormat_VEC3_5121_true = new V.AccessorFormat("VEC3", 5121, true);
    C.AccessorFormat_VEC3_5123_true = new V.AccessorFormat("VEC3", 5123, true);
    C.AccessorFormat_VEC3_5126_false = new V.AccessorFormat("VEC3", 5126, false);
    C.AccessorFormat_VEC4_5121_false = new V.AccessorFormat("VEC4", 5121, false);
    C.AccessorFormat_VEC4_5121_true = new V.AccessorFormat("VEC4", 5121, true);
    C.AccessorFormat_VEC4_5123_false = new V.AccessorFormat("VEC4", 5123, false);
    C.AccessorFormat_VEC4_5123_true = new V.AccessorFormat("VEC4", 5123, true);
    C.AccessorFormat_VEC4_5126_false = new V.AccessorFormat("VEC4", 5126, false);
    C.AccessorUsage_AnimationInput = new V.AccessorUsage("AnimationInput");
    C.AccessorUsage_AnimationOutput = new V.AccessorUsage("AnimationOutput");
    C.AccessorUsage_IBM = new V.AccessorUsage("IBM");
    C.AccessorUsage_PrimitiveIndices = new V.AccessorUsage("PrimitiveIndices");
    C.AccessorUsage_VertexAttribute = new V.AccessorUsage("VertexAttribute");
    C.BufferViewUsage_IBM = new V.BufferViewUsage("IBM");
    C.BufferViewUsage_Image = new V.BufferViewUsage("Image");
    C.BufferViewUsage_IndexBuffer = new V.BufferViewUsage("IndexBuffer");
    C.BufferViewUsage_Other = new V.BufferViewUsage("Other");
    C.BufferViewUsage_VertexBuffer = new V.BufferViewUsage("VertexBuffer");
    C.C_Base64Encoder = new P.Base64Encoder();
    C.C_Base64Codec = new P.Base64Codec();
    C.C_Base64Decoder = new P.Base64Decoder();
    C.C_EmptyIterator = new H.EmptyIterator([P.Null]);
    C.C_GltfInvalidFormatException = new K.GltfInvalidFormatException();
    C.C_IssuesLimitExceededException = new M.IssuesLimitExceededException();
    C.C_JS_CONST = function getTagFallback(o) {
  var s = Object.prototype.toString.call(o);
  return s.substring(8, s.length - 1);
};
    C.C_JS_CONST0 = function() {
  var toStringFunction = Object.prototype.toString;
  function getTag(o) {
    var s = toStringFunction.call(o);
    return s.substring(8, s.length - 1);
  }
  function getUnknownTag(object, tag) {
    if (/^HTML[A-Z].*Element$/.test(tag)) {
      var name = toStringFunction.call(object);
      if (name == "[object Object]") return null;
      return "HTMLElement";
    }
  }
  function getUnknownTagGenericBrowser(object, tag) {
    if (self.HTMLElement && object instanceof HTMLElement) return "HTMLElement";
    return getUnknownTag(object, tag);
  }
  function prototypeForTag(tag) {
    if (typeof window == "undefined") return null;
    if (typeof window[tag] == "undefined") return null;
    var constructor = window[tag];
    if (typeof constructor != "function") return null;
    return constructor.prototype;
  }
  function discriminator(tag) { return null; }
  var isBrowser = typeof navigator == "object";
  return {
    getTag: getTag,
    getUnknownTag: isBrowser ? getUnknownTagGenericBrowser : getUnknownTag,
    prototypeForTag: prototypeForTag,
    discriminator: discriminator };
};
    C.C_JS_CONST6 = function(getTagFallback) {
  return function(hooks) {
    if (typeof navigator != "object") return hooks;
    var ua = navigator.userAgent;
    if (ua.indexOf("DumpRenderTree") >= 0) return hooks;
    if (ua.indexOf("Chrome") >= 0) {
      function confirm(p) {
        return typeof window == "object" && window[p] && window[p].name == p;
      }
      if (confirm("Window") && confirm("HTMLElement")) return hooks;
    }
    hooks.getTag = getTagFallback;
  };
};
    C.C_JS_CONST1 = function(hooks) {
  if (typeof dartExperimentalFixupGetTag != "function") return hooks;
  hooks.getTag = dartExperimentalFixupGetTag(hooks.getTag);
};
    C.C_JS_CONST2 = function(hooks) {
  var getTag = hooks.getTag;
  var prototypeForTag = hooks.prototypeForTag;
  function getTagFixed(o) {
    var tag = getTag(o);
    if (tag == "Document") {
      if (!!o.xmlVersion) return "!Document";
      return "!HTMLDocument";
    }
    return tag;
  }
  function prototypeForTagFixed(tag) {
    if (tag == "Document") return null;
    return prototypeForTag(tag);
  }
  hooks.getTag = getTagFixed;
  hooks.prototypeForTag = prototypeForTagFixed;
};
    C.C_JS_CONST5 = function(hooks) {
  var userAgent = typeof navigator == "object" ? navigator.userAgent : "";
  if (userAgent.indexOf("Firefox") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "GeoGeolocation": "Geolocation",
    "Location": "!Location",
    "WorkerMessageEvent": "MessageEvent",
    "XMLDocument": "!Document"};
  function getTagFirefox(o) {
    var tag = getTag(o);
    return quickMap[tag] || tag;
  }
  hooks.getTag = getTagFirefox;
};
    C.C_JS_CONST4 = function(hooks) {
  var userAgent = typeof navigator == "object" ? navigator.userAgent : "";
  if (userAgent.indexOf("Trident/") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "HTMLDDElement": "HTMLElement",
    "HTMLDTElement": "HTMLElement",
    "HTMLPhraseElement": "HTMLElement",
    "Position": "Geoposition"
  };
  function getTagIE(o) {
    var tag = getTag(o);
    var newTag = quickMap[tag];
    if (newTag) return newTag;
    if (tag == "Object") {
      if (window.DataView && (o instanceof window.DataView)) return "DataView";
    }
    return tag;
  }
  function prototypeForTagIE(tag) {
    var constructor = window[tag];
    if (constructor == null) return null;
    return constructor.prototype;
  }
  hooks.getTag = getTagIE;
  hooks.prototypeForTag = prototypeForTagIE;
};
    C.C_JS_CONST3 = function(hooks) { return hooks; }
;
    C.C_JsonCodec = new P.JsonCodec();
    C.C_OutOfMemoryError = new P.OutOfMemoryError();
    C.C_UnexpectedEndOfStreamException = new Y.UnexpectedEndOfStreamException();
    C.C_UnsupportedImageFormatException = new Y.UnsupportedImageFormatException();
    C.C_Utf8Codec = new P.Utf8Codec();
    C.C__DelayedDone = new P._DelayedDone();
    C.C__RootZone = new P._RootZone();
    C.Format_0 = new Y.Format(0, "Format.Unknown");
    C.Format_1 = new Y.Format(1, "Format.RGB");
    C.Format_2 = new Y.Format(2, "Format.RGBA");
    C.Format_3 = new Y.Format(3, "Format.Luminance");
    C.Format_4 = new Y.Format(4, "Format.LuminanceAlpha");
    C.InvalidDataFormatException_AgZ = new Y.InvalidDataFormatException("Wrong WebP header.");
    C.InvalidDataFormatException_KIf = new Y.InvalidDataFormatException("PNG header not found.");
    C.InvalidDataFormatException_YbV = new Y.InvalidDataFormatException("Invalid JPEG marker segment length.");
    C.InvalidDataFormatException_b84 = new Y.InvalidDataFormatException("Wrong chunk length.");
    C.InvalidDataFormatException_sAZ = new Y.InvalidDataFormatException("Invalid start of file.");
    C.JsonDecoder_null = new P.JsonDecoder(null);
    C.List_0_0 = H.setRuntimeTypeInfo(makeConstList([0, 0]), [P.double]);
    C.List_0_0_0 = H.setRuntimeTypeInfo(makeConstList([0, 0, 0]), [P.double]);
    C.List_127_2047_65535_1114111 = H.setRuntimeTypeInfo(makeConstList([127, 2047, 65535, 1114111]), [P.int]);
    C.List_16 = H.setRuntimeTypeInfo(makeConstList([16]), [P.int]);
    C.List_1_1 = H.setRuntimeTypeInfo(makeConstList([1, 1]), [P.double]);
    C.List_1_1_1 = H.setRuntimeTypeInfo(makeConstList([1, 1, 1]), [P.double]);
    C.List_1_1_1_1 = H.setRuntimeTypeInfo(makeConstList([1, 1, 1, 1]), [P.double]);
    C.List_2 = H.setRuntimeTypeInfo(makeConstList([2]), [P.int]);
    C.List_255_216 = H.setRuntimeTypeInfo(makeConstList([255, 216]), [P.int]);
    C.List_2Vk0 = H.setRuntimeTypeInfo(makeConstList([0, 0, 32776, 33792, 1, 10240, 0, 0]), [P.int]);
    C.List_2Vk = H.setRuntimeTypeInfo(makeConstList([137, 80, 78, 71, 13, 10, 26, 10]), [P.int]);
    C.Type_Texture_gsm = H.createRuntimeType(U.Texture);
    C.ExtFuncs_fromMap = new D.ExtFuncs(D.ext_texture_webp_ExtTextureWebPTexture_fromMap$closure());
    C.Map_bHQKw = new H.GeneralConstantMap([C.Type_Texture_gsm, C.ExtFuncs_fromMap], [P.Type, D.ExtFuncs]);
    C.Extension_CC5 = new D.Extension("EXT_texture_webp", C.Map_bHQKw, D.ext_texture_webp___init$closure(), false);
    C.Type_Gltf_IeY = H.createRuntimeType(V.Gltf);
    C.Type_Node_jrF = H.createRuntimeType(V.Node);
    C.ExtFuncs_fromMap0 = new D.ExtFuncs(X.khr_lights_punctual_KhrLightsPunctualGltf_fromMap$closure());
    C.ExtFuncs_fromMap1 = new D.ExtFuncs(X.khr_lights_punctual_KhrLightsPunctualNode_fromMap$closure());
    C.Map_I6YMD = new H.GeneralConstantMap([C.Type_Gltf_IeY, C.ExtFuncs_fromMap0, C.Type_Node_jrF, C.ExtFuncs_fromMap1], [P.Type, D.ExtFuncs]);
    C.Extension_gg9 = new D.Extension("KHR_lights_punctual", C.Map_I6YMD, null, false);
    C.Type_Material_2bi = H.createRuntimeType(Y.Material);
    C.ExtFuncs_fromMap2 = new D.ExtFuncs(A.khr_materials_pbr_specular_glossiness_KhrMaterialsPbrSpecularGlossiness_fromMap$closure());
    C.Map_5YHpO = new H.GeneralConstantMap([C.Type_Material_2bi, C.ExtFuncs_fromMap2], [P.Type, D.ExtFuncs]);
    C.Extension_Oyf = new D.Extension("KHR_materials_pbrSpecularGlossiness", C.Map_5YHpO, null, false);
    C.ExtFuncs_fromMap3 = new D.ExtFuncs(S.khr_materials_unlit_KhrMaterialsUnlit_fromMap$closure());
    C.Map_5YHpO0 = new H.GeneralConstantMap([C.Type_Material_2bi, C.ExtFuncs_fromMap3], [P.Type, D.ExtFuncs]);
    C.Extension_58O = new D.Extension("KHR_materials_unlit", C.Map_5YHpO0, null, false);
    C.List_empty1 = H.setRuntimeTypeInfo(makeConstList([]), [P.Type]);
    C.Map_empty0 = new H.ConstantStringMap(0, {}, C.List_empty1, [P.Type, D.ExtFuncs]);
    C.Extension_yDH = new D.Extension("KHR_mesh_quantization", C.Map_empty0, U.khr_mesh_quantization___init$closure(), true);
    C.Type_TextureInfo_V3H = H.createRuntimeType(Y.TextureInfo);
    C.Type_NormalTextureInfo_0 = H.createRuntimeType(Y.NormalTextureInfo);
    C.Type_OcclusionTextureInfo_YCM = H.createRuntimeType(Y.OcclusionTextureInfo);
    C.ExtFuncs_fromMap4 = new D.ExtFuncs(L.khr_texture_transform_KhrTextureTransform_fromMap$closure());
    C.Map_RkAPm = new H.GeneralConstantMap([C.Type_TextureInfo_V3H, C.ExtFuncs_fromMap4, C.Type_NormalTextureInfo_0, C.ExtFuncs_fromMap4, C.Type_OcclusionTextureInfo_YCM, C.ExtFuncs_fromMap4], [P.Type, D.ExtFuncs]);
    C.Extension_Mul = new D.Extension("KHR_texture_transform", C.Map_RkAPm, null, false);
    C.List_2nP = H.setRuntimeTypeInfo(makeConstList([C.Extension_CC5, C.Extension_gg9, C.Extension_Oyf, C.Extension_58O, C.Extension_yDH, C.Extension_Mul]), [D.Extension]);
    C.List_3 = H.setRuntimeTypeInfo(makeConstList([3]), [P.int]);
    C.List_33071_33648_10497 = H.setRuntimeTypeInfo(makeConstList([33071, 33648, 10497]), [P.int]);
    C.List_34962_34963 = H.setRuntimeTypeInfo(makeConstList([34962, 34963]), [P.int]);
    C.List_4 = H.setRuntimeTypeInfo(makeConstList([4]), [P.int]);
    C.AccessorFormat_VEC2_5120_false = new V.AccessorFormat("VEC2", 5120, false);
    C.AccessorFormat_VEC2_5120_true = new V.AccessorFormat("VEC2", 5120, true);
    C.AccessorFormat_VEC2_5121_false = new V.AccessorFormat("VEC2", 5121, false);
    C.AccessorFormat_VEC2_5122_false = new V.AccessorFormat("VEC2", 5122, false);
    C.AccessorFormat_VEC2_5122_true = new V.AccessorFormat("VEC2", 5122, true);
    C.AccessorFormat_VEC2_5123_false = new V.AccessorFormat("VEC2", 5123, false);
    C.List_4CA = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC2_5120_false, C.AccessorFormat_VEC2_5120_true, C.AccessorFormat_VEC2_5121_false, C.AccessorFormat_VEC2_5122_false, C.AccessorFormat_VEC2_5122_true, C.AccessorFormat_VEC2_5123_false]), [V.AccessorFormat]);
    C.List_5121_5123_5125 = H.setRuntimeTypeInfo(makeConstList([5121, 5123, 5125]), [P.int]);
    C.List_6D4 = H.setRuntimeTypeInfo(makeConstList(["image/jpeg", "image/png"]), [P.String]);
    C.List_82_73_70_70 = H.setRuntimeTypeInfo(makeConstList([82, 73, 70, 70]), [P.int]);
    C.List_9728_9729 = H.setRuntimeTypeInfo(makeConstList([9728, 9729]), [P.int]);
    C.AccessorFormat_SCALAR_5121_false = new V.AccessorFormat("SCALAR", 5121, false);
    C.AccessorFormat_SCALAR_5123_false = new V.AccessorFormat("SCALAR", 5123, false);
    C.AccessorFormat_SCALAR_5125_false = new V.AccessorFormat("SCALAR", 5125, false);
    C.List_AKA = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_SCALAR_5121_false, C.AccessorFormat_SCALAR_5123_false, C.AccessorFormat_SCALAR_5125_false]), [V.AccessorFormat]);
    C.List_B9o = H.setRuntimeTypeInfo(makeConstList(["camera", "children", "skin", "matrix", "mesh", "rotation", "scale", "translation", "weights", "name"]), [P.String]);
    C.List_BKg = H.setRuntimeTypeInfo(makeConstList([9728, 9729, 9984, 9985, 9986, 9987]), [P.int]);
    C.List_COLOR_JOINTS_TEXCOORD_WEIGHTS = H.setRuntimeTypeInfo(makeConstList(["COLOR", "JOINTS", "TEXCOORD", "WEIGHTS"]), [P.String]);
    C.List_CVk = H.setRuntimeTypeInfo(makeConstList([0, 0, 65490, 45055, 65535, 34815, 65534, 18431]), [P.int]);
    C.List_INA = H.setRuntimeTypeInfo(makeConstList(["color", "intensity", "spot", "type", "range", "name"]), [P.String]);
    C.List_IVU = H.setRuntimeTypeInfo(makeConstList(["buffer", "byteOffset", "byteLength", "byteStride", "target", "name"]), [P.String]);
    C.List_JYB = H.setRuntimeTypeInfo(makeConstList([0, 0, 26624, 1023, 65534, 2047, 65534, 2047]), [P.int]);
    C.List_LINEAR_STEP_CUBICSPLINE = H.setRuntimeTypeInfo(makeConstList(["LINEAR", "STEP", "CUBICSPLINE"]), [P.String]);
    C.List_OPAQUE_MASK_BLEND = H.setRuntimeTypeInfo(makeConstList(["OPAQUE", "MASK", "BLEND"]), [P.String]);
    C.List_OdV = H.setRuntimeTypeInfo(makeConstList(["pbrMetallicRoughness", "normalTexture", "occlusionTexture", "emissiveTexture", "emissiveFactor", "alphaMode", "alphaCutoff", "doubleSided", "name"]), [P.String]);
    C.List_Q4K = H.setRuntimeTypeInfo(makeConstList([5120, 5121, 5122, 5123, 5125, 5126]), [P.int]);
    C.List_QW2 = H.setRuntimeTypeInfo(makeConstList(["inverseBindMatrices", "skeleton", "joints", "name"]), [P.String]);
    C.AccessorFormat_VEC3_5120_false = new V.AccessorFormat("VEC3", 5120, false);
    C.AccessorFormat_VEC3_5120_true = new V.AccessorFormat("VEC3", 5120, true);
    C.AccessorFormat_VEC3_5122_false = new V.AccessorFormat("VEC3", 5122, false);
    C.AccessorFormat_VEC3_5122_true = new V.AccessorFormat("VEC3", 5122, true);
    C.List_Ri2 = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC3_5120_false, C.AccessorFormat_VEC3_5120_true, C.AccessorFormat_VEC3_5122_false, C.AccessorFormat_VEC3_5122_true]), [V.AccessorFormat]);
    C.List_UWS = H.setRuntimeTypeInfo(makeConstList(["data-uri", "buffer-view", "glb", "external"]), [P.String]);
    C.List_WJh = H.setRuntimeTypeInfo(makeConstList(["POINTS", "LINES", "LINE_LOOP", "LINE_STRIP", "TRIANGLES", "TRIANGLE_STRIP", "TRIANGLE_FAN"]), [P.String]);
    C.List_YcR = H.setRuntimeTypeInfo(makeConstList(["bufferView", "byteOffset", "componentType"]), [P.String]);
    C.List_a9P = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC3_5120_true, C.AccessorFormat_VEC3_5122_true]), [V.AccessorFormat]);
    C.List_aspectRatio_yfov_zfar_znear = H.setRuntimeTypeInfo(makeConstList(["aspectRatio", "yfov", "zfar", "znear"]), [P.String]);
    C.List_avb = H.setRuntimeTypeInfo(makeConstList(["copyright", "generator", "version", "minVersion"]), [P.String]);
    C.List_bufferView_byteOffset = H.setRuntimeTypeInfo(makeConstList(["bufferView", "byteOffset"]), [P.String]);
    C.List_bufferView_mimeType_uri_name = H.setRuntimeTypeInfo(makeConstList(["bufferView", "mimeType", "uri", "name"]), [P.String]);
    C.List_channels_samplers_name = H.setRuntimeTypeInfo(makeConstList(["channels", "samplers", "name"]), [P.String]);
    C.List_chs = H.setRuntimeTypeInfo(makeConstList(["baseColorFactor", "baseColorTexture", "metallicFactor", "roughnessFactor", "metallicRoughnessTexture"]), [P.String]);
    C.List_count_indices_values = H.setRuntimeTypeInfo(makeConstList(["count", "indices", "values"]), [P.String]);
    C.List_cwF = H.setRuntimeTypeInfo(makeConstList(["diffuseFactor", "diffuseTexture", "specularFactor", "glossinessFactor", "specularGlossinessTexture"]), [P.String]);
    C.List_directional_point_spot = H.setRuntimeTypeInfo(makeConstList(["directional", "point", "spot"]), [P.String]);
    C.List_empty = H.setRuntimeTypeInfo(makeConstList([]), [P.String]);
    C.List_empty0 = makeConstList([]);
    C.List_extensions_extras = H.setRuntimeTypeInfo(makeConstList(["extensions", "extras"]), [P.String]);
    C.List_gRj = H.setRuntimeTypeInfo(makeConstList([0, 0, 32722, 12287, 65534, 34815, 65534, 18431]), [P.int]);
    C.List_index_texCoord = H.setRuntimeTypeInfo(makeConstList(["index", "texCoord"]), [P.String]);
    C.List_index_texCoord_scale = H.setRuntimeTypeInfo(makeConstList(["index", "texCoord", "scale"]), [P.String]);
    C.List_index_texCoord_strength = H.setRuntimeTypeInfo(makeConstList(["index", "texCoord", "strength"]), [P.String]);
    C.List_innerConeAngle_outerConeAngle = H.setRuntimeTypeInfo(makeConstList(["innerConeAngle", "outerConeAngle"]), [P.String]);
    C.List_input_interpolation_output = H.setRuntimeTypeInfo(makeConstList(["input", "interpolation", "output"]), [P.String]);
    C.List_iyy = H.setRuntimeTypeInfo(makeConstList(["attributes", "indices", "material", "mode", "targets"]), [P.String]);
    C.List_jxI = H.setRuntimeTypeInfo(makeConstList(["bufferView", "byteOffset", "componentType", "count", "type", "normalized", "max", "min", "sparse", "name"]), [P.String]);
    C.List_light = H.setRuntimeTypeInfo(makeConstList(["light"]), [P.String]);
    C.List_lights = H.setRuntimeTypeInfo(makeConstList(["lights"]), [P.String]);
    C.List_node_path = H.setRuntimeTypeInfo(makeConstList(["node", "path"]), [P.String]);
    C.List_nodes_name = H.setRuntimeTypeInfo(makeConstList(["nodes", "name"]), [P.String]);
    C.List_null_linear_srgb_custom = H.setRuntimeTypeInfo(makeConstList([null, "linear", "srgb", "custom"]), [P.String]);
    C.List_null_srgb_custom = H.setRuntimeTypeInfo(makeConstList([null, "srgb", "custom"]), [P.String]);
    C.List_nxB = H.setRuntimeTypeInfo(makeConstList([0, 0, 24576, 1023, 65534, 34815, 65534, 18431]), [P.int]);
    C.List_oCz = H.setRuntimeTypeInfo(makeConstList(["image/webp"]), [P.String]);
    C.List_offset_rotation_scale_texCoord = H.setRuntimeTypeInfo(makeConstList(["offset", "rotation", "scale", "texCoord"]), [P.String]);
    C.List_orthographic_perspective = H.setRuntimeTypeInfo(makeConstList(["orthographic", "perspective"]), [P.String]);
    C.List_primitives_weights_name = H.setRuntimeTypeInfo(makeConstList(["primitives", "weights", "name"]), [P.String]);
    C.Severity_0 = new E.Severity(0, "Severity.Error");
    C.Severity_1 = new E.Severity(1, "Severity.Warning");
    C.Severity_2 = new E.Severity(2, "Severity.Information");
    C.Severity_3 = new E.Severity(3, "Severity.Hint");
    C.List_qFu = H.setRuntimeTypeInfo(makeConstList([C.Severity_0, C.Severity_1, C.Severity_2, C.Severity_3]), [E.Severity]);
    C.List_qNA = H.setRuntimeTypeInfo(makeConstList([0, 0, 32754, 11263, 65534, 34815, 65534, 18431]), [P.int]);
    C.List_qPn = H.setRuntimeTypeInfo(makeConstList(["magFilter", "minFilter", "wrapS", "wrapT", "name"]), [P.String]);
    C.List_qVm = H.setRuntimeTypeInfo(makeConstList([null, "rgb", "rgba", "luminance", "luminance-alpha"]), [P.String]);
    C.List_qg4 = H.setRuntimeTypeInfo(makeConstList([0, 0, 65490, 12287, 65535, 34815, 65534, 18431]), [P.int]);
    C.List_sampler_source_name = H.setRuntimeTypeInfo(makeConstList(["sampler", "source", "name"]), [P.String]);
    C.List_source = H.setRuntimeTypeInfo(makeConstList(["source"]), [P.String]);
    C.AccessorFormat_VEC3_5121_false = new V.AccessorFormat("VEC3", 5121, false);
    C.AccessorFormat_VEC3_5123_false = new V.AccessorFormat("VEC3", 5123, false);
    C.List_tES = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC3_5120_false, C.AccessorFormat_VEC3_5120_true, C.AccessorFormat_VEC3_5121_false, C.AccessorFormat_VEC3_5121_true, C.AccessorFormat_VEC3_5122_false, C.AccessorFormat_VEC3_5122_true, C.AccessorFormat_VEC3_5123_false, C.AccessorFormat_VEC3_5123_true]), [V.AccessorFormat]);
    C.List_target_sampler = H.setRuntimeTypeInfo(makeConstList(["target", "sampler"]), [P.String]);
    C.List_translation_rotation_scale_weights = H.setRuntimeTypeInfo(makeConstList(["translation", "rotation", "scale", "weights"]), [P.String]);
    C.List_type_orthographic_perspective_name = H.setRuntimeTypeInfo(makeConstList(["type", "orthographic", "perspective", "name"]), [P.String]);
    C.List_uri_byteLength_name = H.setRuntimeTypeInfo(makeConstList(["uri", "byteLength", "name"]), [P.String]);
    C.List_xmag_ymag_zfar_znear = H.setRuntimeTypeInfo(makeConstList(["xmag", "ymag", "zfar", "znear"]), [P.String]);
    C.List_yvP = H.setRuntimeTypeInfo(makeConstList(["extensionsUsed", "extensionsRequired", "accessors", "animations", "asset", "buffers", "bufferViews", "cameras", "images", "materials", "meshes", "nodes", "samplers", "scene", "scenes", "skins", "textures"]), [P.String]);
    C.AccessorFormat_VEC4_5120_true = new V.AccessorFormat("VEC4", 5120, true);
    C.AccessorFormat_VEC4_5122_true = new V.AccessorFormat("VEC4", 5122, true);
    C.List_zzp = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC4_5120_true, C.AccessorFormat_VEC4_5122_true]), [V.AccessorFormat]);
    C.List_AccessorFormat_VEC3_5126_false = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC3_5126_false]), [V.AccessorFormat]);
    C.List_2AS = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_VEC4_5126_false, C.AccessorFormat_VEC4_5121_true, C.AccessorFormat_VEC4_5120_true, C.AccessorFormat_VEC4_5123_true, C.AccessorFormat_VEC4_5122_true]), [V.AccessorFormat]);
    C.AccessorFormat_SCALAR_5121_true = new V.AccessorFormat("SCALAR", 5121, true);
    C.AccessorFormat_SCALAR_5120_true = new V.AccessorFormat("SCALAR", 5120, true);
    C.AccessorFormat_SCALAR_5123_true = new V.AccessorFormat("SCALAR", 5123, true);
    C.AccessorFormat_SCALAR_5122_true = new V.AccessorFormat("SCALAR", 5122, true);
    C.List_i3t = H.setRuntimeTypeInfo(makeConstList([C.AccessorFormat_SCALAR_5126_false, C.AccessorFormat_SCALAR_5121_true, C.AccessorFormat_SCALAR_5120_true, C.AccessorFormat_SCALAR_5123_true, C.AccessorFormat_SCALAR_5122_true]), [V.AccessorFormat]);
    C.Map_0nNZ = new H.ConstantStringMap(4, {translation: C.List_AccessorFormat_VEC3_5126_false, rotation: C.List_2AS, scale: C.List_AccessorFormat_VEC3_5126_false, weights: C.List_i3t}, C.List_translation_rotation_scale_weights, [P.String, [P.List, V.AccessorFormat]]);
    C.List_A18 = H.setRuntimeTypeInfo(makeConstList(["SCALAR", "VEC2", "VEC3", "VEC4", "MAT2", "MAT3", "MAT4"]), [P.String]);
    C.Map_A1ato = new H.ConstantStringMap(7, {SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16}, C.List_A18, [P.String, P.int]);
    C.Map_ZGNO4 = new H.GeneralConstantMap([5120, "BYTE", 5121, "UNSIGNED_BYTE", 5122, "SHORT", 5123, "UNSIGNED_SHORT", 5124, "INT", 5125, "UNSIGNED_INT", 5126, "FLOAT", 35664, "FLOAT_VEC2", 35665, "FLOAT_VEC3", 35666, "FLOAT_VEC4", 35667, "INT_VEC2", 35668, "INT_VEC3", 35669, "INT_VEC4", 35670, "BOOL", 35671, "BOOL_VEC2", 35672, "BOOL_VEC3", 35673, "BOOL_VEC4", 35674, "FLOAT_MAT2", 35675, "FLOAT_MAT3", 35676, "FLOAT_MAT4", 35678, "SAMPLER_2D"], [P.int, P.String]);
    C.List_empty2 = H.setRuntimeTypeInfo(makeConstList([]), [P.Symbol0]);
    C.Map_empty = new H.ConstantStringMap(0, {}, C.List_empty2, [P.Symbol0, null]);
    C.List_AiV = H.setRuntimeTypeInfo(makeConstList(["KHR", "EXT", "ADOBE", "AGI", "AGT", "ALCM", "ALI", "AMZN", "AVR", "BLENDER", "CAPTURE", "CESIUM", "CVTOOLS", "FB", "FOXIT", "GOOGLE", "KDAB", "LLQ", "MESHOPT", "MOZ", "MSFT", "NV", "OWLII", "POLUTROPON", "S8S", "SI", "SKFB", "SKYLINE", "WEB3D"]), [P.String]);
    C.Map_Aicw1 = new H.ConstantStringMap(29, {KHR: null, EXT: null, ADOBE: null, AGI: null, AGT: null, ALCM: null, ALI: null, AMZN: null, AVR: null, BLENDER: null, CAPTURE: null, CESIUM: null, CVTOOLS: null, FB: null, FOXIT: null, GOOGLE: null, KDAB: null, LLQ: null, MESHOPT: null, MOZ: null, MSFT: null, NV: null, OWLII: null, POLUTROPON: null, S8S: null, SI: null, SKFB: null, SKYLINE: null, WEB3D: null}, C.List_AiV, [P.String, P.Null]);
    C.Set_AiVn = new P._UnmodifiableSet(C.Map_Aicw1, [P.String]);
    C.Symbol_call = new H.Symbol("call");
    C.Type_AccessorSparseIndices_XRi = H.createRuntimeType(M.AccessorSparseIndices);
    C.Type_AccessorSparseValues_Yas = H.createRuntimeType(M.AccessorSparseValues);
    C.Type_AccessorSparse_SoA = H.createRuntimeType(M.AccessorSparse);
    C.Type_Accessor_scC = H.createRuntimeType([M.Accessor, P.num]);
    C.Type_AnimationChannelTarget_Nno = H.createRuntimeType(Z.AnimationChannelTarget);
    C.Type_AnimationChannel_nvO = H.createRuntimeType(Z.AnimationChannel);
    C.Type_AnimationSampler_y5u = H.createRuntimeType(Z.AnimationSampler);
    C.Type_Animation_hcA = H.createRuntimeType(Z.Animation);
    C.Type_Asset_ePM = H.createRuntimeType(T.Asset);
    C.Type_BufferView_JO4 = H.createRuntimeType(V.BufferView);
    C.Type_Buffer_gn0 = H.createRuntimeType(Q.Buffer);
    C.Type_CameraOrthographic_wIv = H.createRuntimeType(G.CameraOrthographic);
    C.Type_CameraPerspective_EWB = H.createRuntimeType(G.CameraPerspective);
    C.Type_Camera_s3t = H.createRuntimeType(G.Camera);
    C.Type_DzG = H.createRuntimeType(A.KhrMaterialsPbrSpecularGlossiness);
    C.Type_ExtTextureWebPTexture_9YE = H.createRuntimeType(D.ExtTextureWebPTexture);
    C.Type_Image_5hW = H.createRuntimeType(T.Image);
    C.Type_KhrLightsPunctualGltf_4YB = H.createRuntimeType(X.KhrLightsPunctualGltf);
    C.Type_KhrLightsPunctualLightSpot_oBB = H.createRuntimeType(X.KhrLightsPunctualLightSpot);
    C.Type_KhrLightsPunctualLight_4m4 = H.createRuntimeType(X.KhrLightsPunctualLight);
    C.Type_KhrLightsPunctualNode_eHw = H.createRuntimeType(X.KhrLightsPunctualNode);
    C.Type_KhrMaterialsUnlit_0 = H.createRuntimeType(S.KhrMaterialsUnlit);
    C.Type_KhrTextureTransform_xSJ = H.createRuntimeType(L.KhrTextureTransform);
    C.Type_MeshPrimitive_TPX = H.createRuntimeType(S.MeshPrimitive);
    C.Type_Mesh_K2f = H.createRuntimeType(S.Mesh);
    C.Type_PbrMetallicRoughness_k2w = H.createRuntimeType(Y.PbrMetallicRoughness);
    C.Type_Sampler_mXu = H.createRuntimeType(T.Sampler);
    C.Type_Scene_9YE = H.createRuntimeType(B.Scene);
    C.Type_Skin_OJ4 = H.createRuntimeType(O.Skin);
    C._ColorPrimaries_0 = new Y._ColorPrimaries(0, "_ColorPrimaries.Unknown");
    C._ColorPrimaries_1 = new Y._ColorPrimaries(1, "_ColorPrimaries.sRGB");
    C._ColorPrimaries_2 = new Y._ColorPrimaries(2, "_ColorPrimaries.Custom");
    C._ColorTransfer_0 = new Y._ColorTransfer(0, "_ColorTransfer.Unknown");
    C._ColorTransfer_1 = new Y._ColorTransfer(1, "_ColorTransfer.Linear");
    C._ColorTransfer_2 = new Y._ColorTransfer(2, "_ColorTransfer.sRGB");
    C._ColorTransfer_3 = new Y._ColorTransfer(3, "_ColorTransfer.Custom");
    C._ImageCodec_0 = new Y._ImageCodec("_ImageCodec.JPEG");
    C._ImageCodec_1 = new Y._ImageCodec("_ImageCodec.PNG");
    C._ImageCodec_2 = new Y._ImageCodec("_ImageCodec.WebP");
    C._IterationMarker_null_2 = new P._IterationMarker(null, 2);
    C._Storage_0 = new N._Storage(0, "_Storage.DataUri");
    C._Storage_1 = new N._Storage(1, "_Storage.BufferView");
    C._Storage_2 = new N._Storage(2, "_Storage.GLB");
    C._Storage_3 = new N._Storage(3, "_Storage.External");
  })();
  (function staticFields() {
    $.Closure_functionCounter = 0;
    $.BoundClosure_selfFieldNameCache = null;
    $.BoundClosure_receiverFieldNameCache = null;
    $._inTypeAssertion = false;
    $.getTagFunction = null;
    $.alternateTagFunction = null;
    $.prototypeForTagFunction = null;
    $.dispatchRecordsForInstanceTags = null;
    $.interceptorsForUncacheableTags = null;
    $.initNativeDispatchFlag = null;
    $._nextCallback = null;
    $._lastCallback = null;
    $._lastPriorityCallback = null;
    $._isInCallbackLoop = false;
    $.Zone__current = C.C__RootZone;
    $._toStringVisiting = [];
  })();
  (function lazyInitializers() {
    var _lazy = hunkHelpers.lazy;
    _lazy($, "DART_CLOSURE_PROPERTY_NAME", "$get$DART_CLOSURE_PROPERTY_NAME", function() {
      return H.getIsolateAffinityTag("_$dart_dartClosure");
    });
    _lazy($, "JS_INTEROP_INTERCEPTOR_TAG", "$get$JS_INTEROP_INTERCEPTOR_TAG", function() {
      return H.getIsolateAffinityTag("_$dart_js");
    });
    _lazy($, "TypeErrorDecoder_noSuchMethodPattern", "$get$TypeErrorDecoder_noSuchMethodPattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokeCallErrorOn({
        toString: function() {
          return "$receiver$";
        }
      }));
    });
    _lazy($, "TypeErrorDecoder_notClosurePattern", "$get$TypeErrorDecoder_notClosurePattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokeCallErrorOn({$method$: null,
        toString: function() {
          return "$receiver$";
        }
      }));
    });
    _lazy($, "TypeErrorDecoder_nullCallPattern", "$get$TypeErrorDecoder_nullCallPattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokeCallErrorOn(null));
    });
    _lazy($, "TypeErrorDecoder_nullLiteralCallPattern", "$get$TypeErrorDecoder_nullLiteralCallPattern", function() {
      return H.TypeErrorDecoder_extractPattern(function() {
        var $argumentsExpr$ = '$arguments$';
        try {
          null.$method$($argumentsExpr$);
        } catch (e) {
          return e.message;
        }
      }());
    });
    _lazy($, "TypeErrorDecoder_undefinedCallPattern", "$get$TypeErrorDecoder_undefinedCallPattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokeCallErrorOn(void 0));
    });
    _lazy($, "TypeErrorDecoder_undefinedLiteralCallPattern", "$get$TypeErrorDecoder_undefinedLiteralCallPattern", function() {
      return H.TypeErrorDecoder_extractPattern(function() {
        var $argumentsExpr$ = '$arguments$';
        try {
          (void 0).$method$($argumentsExpr$);
        } catch (e) {
          return e.message;
        }
      }());
    });
    _lazy($, "TypeErrorDecoder_nullPropertyPattern", "$get$TypeErrorDecoder_nullPropertyPattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokePropertyErrorOn(null));
    });
    _lazy($, "TypeErrorDecoder_nullLiteralPropertyPattern", "$get$TypeErrorDecoder_nullLiteralPropertyPattern", function() {
      return H.TypeErrorDecoder_extractPattern(function() {
        try {
          null.$method$;
        } catch (e) {
          return e.message;
        }
      }());
    });
    _lazy($, "TypeErrorDecoder_undefinedPropertyPattern", "$get$TypeErrorDecoder_undefinedPropertyPattern", function() {
      return H.TypeErrorDecoder_extractPattern(H.TypeErrorDecoder_provokePropertyErrorOn(void 0));
    });
    _lazy($, "TypeErrorDecoder_undefinedLiteralPropertyPattern", "$get$TypeErrorDecoder_undefinedLiteralPropertyPattern", function() {
      return H.TypeErrorDecoder_extractPattern(function() {
        try {
          (void 0).$method$;
        } catch (e) {
          return e.message;
        }
      }());
    });
    _lazy($, "_AsyncRun__scheduleImmediateClosure", "$get$_AsyncRun__scheduleImmediateClosure", function() {
      return P._AsyncRun__initializeScheduleImmediate();
    });
    _lazy($, "Future__nullFuture", "$get$Future__nullFuture", function() {
      var t1 = new P._Future(C.C__RootZone, [P.Null]);
      t1._setValue$1(null);
      return t1;
    });
    _lazy($, "Utf8Decoder__decoder", "$get$Utf8Decoder__decoder", function() {
      return P.Utf8Decoder__makeDecoder();
    });
    _lazy($, "_Base64Decoder__inverseAlphabet", "$get$_Base64Decoder__inverseAlphabet", function() {
      return H.NativeInt8List__create1(H._ensureNativeList(H.setRuntimeTypeInfo([-2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -2, -1, -2, -2, -2, -2, -2, 62, -2, 62, -2, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -2, -2, -2, -1, -2, -2, -2, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -2, -2, -2, -2, 63, -2, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -2, -2, -2, -2, -2], [P.int])));
    });
    _lazy($, "_scannerTables", "$get$_scannerTables", function() {
      return P._createTables();
    });
    _lazy($, "Asset_versionRegexp", "$get$Asset_versionRegexp", function() {
      return P.RegExp_RegExp("^([0-9]+)\\.([0-9]+)$");
    });
    _lazy($, "Context__extNameFormat", "$get$Context__extNameFormat", function() {
      return P.RegExp_RegExp("^([A-Z0-9]+)_[A-Za-z0-9_]+$");
    });
    _lazy($, "DataError_bufferEmbeddedBytelengthMismatch", "$get$DataError_bufferEmbeddedBytelengthMismatch", function() {
      return E.DataError$_("BUFFER_EMBEDDED_BYTELENGTH_MISMATCH", new E.DataError_closure16(), C.Severity_0);
    });
    _lazy($, "DataError_bufferExternalBytelengthMismatch", "$get$DataError_bufferExternalBytelengthMismatch", function() {
      return E.DataError$_("BUFFER_EXTERNAL_BYTELENGTH_MISMATCH", new E.DataError_closure14(), C.Severity_0);
    });
    _lazy($, "DataError_bufferGlbChunkTooBig", "$get$DataError_bufferGlbChunkTooBig", function() {
      return E.DataError$_("BUFFER_GLB_CHUNK_TOO_BIG", new E.DataError_closure13(), C.Severity_1);
    });
    _lazy($, "DataError_accessorMinMismatch", "$get$DataError_accessorMinMismatch", function() {
      return E.DataError$_("ACCESSOR_MIN_MISMATCH", new E.DataError_closure20(), C.Severity_0);
    });
    _lazy($, "DataError_accessorMaxMismatch", "$get$DataError_accessorMaxMismatch", function() {
      return E.DataError$_("ACCESSOR_MAX_MISMATCH", new E.DataError_closure18(), C.Severity_0);
    });
    _lazy($, "DataError_accessorElementOutOfMinBound", "$get$DataError_accessorElementOutOfMinBound", function() {
      return E.DataError$_("ACCESSOR_ELEMENT_OUT_OF_MIN_BOUND", new E.DataError_closure19(), C.Severity_0);
    });
    _lazy($, "DataError_accessorElementOutOfMaxBound", "$get$DataError_accessorElementOutOfMaxBound", function() {
      return E.DataError$_("ACCESSOR_ELEMENT_OUT_OF_MAX_BOUND", new E.DataError_closure17(), C.Severity_0);
    });
    _lazy($, "DataError_accessorVector3NonUnit", "$get$DataError_accessorVector3NonUnit", function() {
      return E.DataError$_("ACCESSOR_VECTOR3_NON_UNIT", new E.DataError_closure29(), C.Severity_0);
    });
    _lazy($, "DataError_accessorInvalidSign", "$get$DataError_accessorInvalidSign", function() {
      return E.DataError$_("ACCESSOR_INVALID_SIGN", new E.DataError_closure30(), C.Severity_0);
    });
    _lazy($, "DataError_accessorAnimationSamplerOutputNonNormalizedQuaternion", "$get$DataError_accessorAnimationSamplerOutputNonNormalizedQuaternion", function() {
      return E.DataError$_("ACCESSOR_ANIMATION_SAMPLER_OUTPUT_NON_NORMALIZED_QUATERNION", new E.DataError_closure22(), C.Severity_0);
    });
    _lazy($, "DataError_accessorNonClamped", "$get$DataError_accessorNonClamped", function() {
      return E.DataError$_("ACCESSOR_NON_CLAMPED", new E.DataError_closure28(), C.Severity_0);
    });
    _lazy($, "DataError_accessorInvalidFloat", "$get$DataError_accessorInvalidFloat", function() {
      return E.DataError$_("ACCESSOR_INVALID_FLOAT", new E.DataError_closure21(), C.Severity_0);
    });
    _lazy($, "DataError_accessorIndexOob", "$get$DataError_accessorIndexOob", function() {
      return E.DataError$_("ACCESSOR_INDEX_OOB", new E.DataError_closure27(), C.Severity_0);
    });
    _lazy($, "DataError_accessorIndexTriangleDegenerate", "$get$DataError_accessorIndexTriangleDegenerate", function() {
      return E.DataError$_("ACCESSOR_INDEX_TRIANGLE_DEGENERATE", new E.DataError_closure25(), C.Severity_2);
    });
    _lazy($, "DataError_accessorIndexPrimitiveRestart", "$get$DataError_accessorIndexPrimitiveRestart", function() {
      return E.DataError$_("ACCESSOR_INDEX_PRIMITIVE_RESTART", new E.DataError_closure26(), C.Severity_0);
    });
    _lazy($, "DataError_accessorAnimationInputNegative", "$get$DataError_accessorAnimationInputNegative", function() {
      return E.DataError$_("ACCESSOR_ANIMATION_INPUT_NEGATIVE", new E.DataError_closure24(), C.Severity_0);
    });
    _lazy($, "DataError_accessorAnimationInputNonIncreasing", "$get$DataError_accessorAnimationInputNonIncreasing", function() {
      return E.DataError$_("ACCESSOR_ANIMATION_INPUT_NON_INCREASING", new E.DataError_closure23(), C.Severity_0);
    });
    _lazy($, "DataError_accessorSparseIndicesNonIncreasing", "$get$DataError_accessorSparseIndicesNonIncreasing", function() {
      return E.DataError$_("ACCESSOR_SPARSE_INDICES_NON_INCREASING", new E.DataError_closure5(), C.Severity_0);
    });
    _lazy($, "DataError_accessorSparseIndexOob", "$get$DataError_accessorSparseIndexOob", function() {
      return E.DataError$_("ACCESSOR_SPARSE_INDEX_OOB", new E.DataError_closure4(), C.Severity_0);
    });
    _lazy($, "DataError_accessorInvalidInverseBindMatrix", "$get$DataError_accessorInvalidInverseBindMatrix", function() {
      return E.DataError$_("ACCESSOR_INVALID_IBM", new E.DataError_closure31(), C.Severity_0);
    });
    _lazy($, "DataError_imageDataInvalid", "$get$DataError_imageDataInvalid", function() {
      return E.DataError$_("IMAGE_DATA_INVALID", new E.DataError_closure9(), C.Severity_0);
    });
    _lazy($, "DataError_imageMimeTypeInvalid", "$get$DataError_imageMimeTypeInvalid", function() {
      return E.DataError$_("IMAGE_MIME_TYPE_INVALID", new E.DataError_closure8(), C.Severity_0);
    });
    _lazy($, "DataError_imageUnexpectedEos", "$get$DataError_imageUnexpectedEos", function() {
      return E.DataError$_("IMAGE_UNEXPECTED_EOS", new E.DataError_closure10(), C.Severity_0);
    });
    _lazy($, "DataError_imageUnrecognizedFormat", "$get$DataError_imageUnrecognizedFormat", function() {
      return E.DataError$_("IMAGE_UNRECOGNIZED_FORMAT", new E.DataError_closure11(), C.Severity_1);
    });
    _lazy($, "DataError_imageNonEnabledMimeType", "$get$DataError_imageNonEnabledMimeType", function() {
      return E.DataError$_("IMAGE_NON_ENABLED_MIME_TYPE", new E.DataError_closure12(), C.Severity_0);
    });
    _lazy($, "DataError_imageNonPowerOfTwoDimensions", "$get$DataError_imageNonPowerOfTwoDimensions", function() {
      return E.DataError$_("IMAGE_NPOT_DIMENSIONS", new E.DataError_closure7(), C.Severity_2);
    });
    _lazy($, "DataError_imageFeaturesUnsupported", "$get$DataError_imageFeaturesUnsupported", function() {
      return E.DataError$_("IMAGE_FEATURES_UNSUPPORTED", new E.DataError_closure6(), C.Severity_1);
    });
    _lazy($, "DataError_dataUriGlb", "$get$DataError_dataUriGlb", function() {
      return E.DataError$_("DATA_URI_GLB", new E.DataError_closure15(), C.Severity_2);
    });
    _lazy($, "DataError_accessorJointsIndexOob", "$get$DataError_accessorJointsIndexOob", function() {
      return E.DataError$_("ACCESSOR_JOINTS_INDEX_OOB", new E.DataError_closure3(), C.Severity_0);
    });
    _lazy($, "DataError_accessorJointsIndexDuplicate", "$get$DataError_accessorJointsIndexDuplicate", function() {
      return E.DataError$_("ACCESSOR_JOINTS_INDEX_DUPLICATE", new E.DataError_closure2(), C.Severity_0);
    });
    _lazy($, "DataError_accessorWeightsNegative", "$get$DataError_accessorWeightsNegative", function() {
      return E.DataError$_("ACCESSOR_WEIGHTS_NEGATIVE", new E.DataError_closure1(), C.Severity_0);
    });
    _lazy($, "DataError_accessorWeightsNonNormalized", "$get$DataError_accessorWeightsNonNormalized", function() {
      return E.DataError$_("ACCESSOR_WEIGHTS_NON_NORMALIZED", new E.DataError_closure(), C.Severity_0);
    });
    _lazy($, "DataError_accessorJointsUsedZeroWeight", "$get$DataError_accessorJointsUsedZeroWeight", function() {
      return E.DataError$_("ACCESSOR_JOINTS_USED_ZERO_WEIGHT", new E.DataError_closure0(), C.Severity_1);
    });
    _lazy($, "IoError_ioError", "$get$IoError_ioError", function() {
      return new E.IoError(C.Severity_0, "IO_ERROR", new E.IoError_closure());
    });
    _lazy($, "SchemaError_arrayLengthNotInList", "$get$SchemaError_arrayLengthNotInList", function() {
      return E.SchemaError$_("ARRAY_LENGTH_NOT_IN_LIST", new E.SchemaError_closure3(), C.Severity_0);
    });
    _lazy($, "SchemaError_arrayTypeMismatch", "$get$SchemaError_arrayTypeMismatch", function() {
      return E.SchemaError$_("ARRAY_TYPE_MISMATCH", new E.SchemaError_closure4(), C.Severity_0);
    });
    _lazy($, "SchemaError_arrayDuplicateElements", "$get$SchemaError_arrayDuplicateElements", function() {
      return E.SchemaError$_("DUPLICATE_ELEMENTS", new E.SchemaError_closure9(), C.Severity_0);
    });
    _lazy($, "SchemaError_invalidIndex", "$get$SchemaError_invalidIndex", function() {
      return E.SchemaError$_("INVALID_INDEX", new E.SchemaError_closure7(), C.Severity_0);
    });
    _lazy($, "SchemaError_invalidJson", "$get$SchemaError_invalidJson", function() {
      return E.SchemaError$_("INVALID_JSON", new E.SchemaError_closure14(), C.Severity_0);
    });
    _lazy($, "SchemaError_invalidUri", "$get$SchemaError_invalidUri", function() {
      return E.SchemaError$_("INVALID_URI", new E.SchemaError_closure10(), C.Severity_0);
    });
    _lazy($, "SchemaError_emptyEntity", "$get$SchemaError_emptyEntity", function() {
      return E.SchemaError$_("EMPTY_ENTITY", new E.SchemaError_closure5(), C.Severity_0);
    });
    _lazy($, "SchemaError_oneOfMismatch", "$get$SchemaError_oneOfMismatch", function() {
      return E.SchemaError$_("ONE_OF_MISMATCH", new E.SchemaError_closure11(), C.Severity_0);
    });
    _lazy($, "SchemaError_patternMismatch", "$get$SchemaError_patternMismatch", function() {
      return E.SchemaError$_("PATTERN_MISMATCH", new E.SchemaError_closure8(), C.Severity_0);
    });
    _lazy($, "SchemaError_typeMismatch", "$get$SchemaError_typeMismatch", function() {
      return E.SchemaError$_("TYPE_MISMATCH", new E.SchemaError_closure(), C.Severity_0);
    });
    _lazy($, "SchemaError_valueNotInList", "$get$SchemaError_valueNotInList", function() {
      return E.SchemaError$_("VALUE_NOT_IN_LIST", new E.SchemaError_closure2(), C.Severity_1);
    });
    _lazy($, "SchemaError_valueNotInRange", "$get$SchemaError_valueNotInRange", function() {
      return E.SchemaError$_("VALUE_NOT_IN_RANGE", new E.SchemaError_closure1(), C.Severity_0);
    });
    _lazy($, "SchemaError_valueMultipleOf", "$get$SchemaError_valueMultipleOf", function() {
      return E.SchemaError$_("VALUE_MULTIPLE_OF", new E.SchemaError_closure12(), C.Severity_0);
    });
    _lazy($, "SchemaError_undefinedProperty", "$get$SchemaError_undefinedProperty", function() {
      return E.SchemaError$_("UNDEFINED_PROPERTY", new E.SchemaError_closure0(), C.Severity_0);
    });
    _lazy($, "SchemaError_unexpectedProperty", "$get$SchemaError_unexpectedProperty", function() {
      return E.SchemaError$_("UNEXPECTED_PROPERTY", new E.SchemaError_closure6(), C.Severity_1);
    });
    _lazy($, "SchemaError_unsatisfiedDependency", "$get$SchemaError_unsatisfiedDependency", function() {
      return E.SchemaError$_("UNSATISFIED_DEPENDENCY", new E.SchemaError_closure13(), C.Severity_0);
    });
    _lazy($, "SemanticError_unknownAssetMajorVersion", "$get$SemanticError_unknownAssetMajorVersion", function() {
      return E.SemanticError$_("UNKNOWN_ASSET_MAJOR_VERSION", new E.SemanticError_closure38(), C.Severity_0);
    });
    _lazy($, "SemanticError_unknownAssetMinorVersion", "$get$SemanticError_unknownAssetMinorVersion", function() {
      return E.SemanticError$_("UNKNOWN_ASSET_MINOR_VERSION", new E.SemanticError_closure37(), C.Severity_1);
    });
    _lazy($, "SemanticError_minVersionGreaterThanVersion", "$get$SemanticError_minVersionGreaterThanVersion", function() {
      return E.SemanticError$_("ASSET_MIN_VERSION_GREATER_THAN_VERSION", new E.SemanticError_closure28(), C.Severity_1);
    });
    _lazy($, "SemanticError_invalidGlValue", "$get$SemanticError_invalidGlValue", function() {
      return E.SemanticError$_("INVALID_GL_VALUE", new E.SemanticError_closure26(), C.Severity_0);
    });
    _lazy($, "SemanticError_integerWrittenAsFloat", "$get$SemanticError_integerWrittenAsFloat", function() {
      return E.SemanticError$_("INTEGER_WRITTEN_AS_FLOAT", new E.SemanticError_closure27(), C.Severity_1);
    });
    _lazy($, "SemanticError_accessorNormalizedInvalid", "$get$SemanticError_accessorNormalizedInvalid", function() {
      return E.SemanticError$_("ACCESSOR_NORMALIZED_INVALID", new E.SemanticError_closure25(), C.Severity_0);
    });
    _lazy($, "SemanticError_accessorOffsetAlignment", "$get$SemanticError_accessorOffsetAlignment", function() {
      return E.SemanticError$_("ACCESSOR_OFFSET_ALIGNMENT", new E.SemanticError_closure23(), C.Severity_0);
    });
    _lazy($, "SemanticError_accessorMatrixAlignment", "$get$SemanticError_accessorMatrixAlignment", function() {
      return E.SemanticError$_("ACCESSOR_MATRIX_ALIGNMENT", new E.SemanticError_closure24(), C.Severity_0);
    });
    _lazy($, "SemanticError_accessorSparseCountOutOfRange", "$get$SemanticError_accessorSparseCountOutOfRange", function() {
      return E.SemanticError$_("ACCESSOR_SPARSE_COUNT_OUT_OF_RANGE", new E.SemanticError_closure33(), C.Severity_0);
    });
    _lazy($, "SemanticError_animationChannelTargetNodeSkin", "$get$SemanticError_animationChannelTargetNodeSkin", function() {
      return E.SemanticError$_("ANIMATION_CHANNEL_TARGET_NODE_SKIN", new E.SemanticError_closure34(), C.Severity_1);
    });
    _lazy($, "SemanticError_bufferDataUriMimeTypeInvalid", "$get$SemanticError_bufferDataUriMimeTypeInvalid", function() {
      return E.SemanticError$_("BUFFER_DATA_URI_MIME_TYPE_INVALID", new E.SemanticError_closure22(), C.Severity_0);
    });
    _lazy($, "SemanticError_bufferViewTooBigByteStride", "$get$SemanticError_bufferViewTooBigByteStride", function() {
      return E.SemanticError$_("BUFFER_VIEW_TOO_BIG_BYTE_STRIDE", new E.SemanticError_closure21(), C.Severity_0);
    });
    _lazy($, "SemanticError_bufferViewInvalidByteStride", "$get$SemanticError_bufferViewInvalidByteStride", function() {
      return E.SemanticError$_("BUFFER_VIEW_INVALID_BYTE_STRIDE", new E.SemanticError_closure20(), C.Severity_0);
    });
    _lazy($, "SemanticError_cameraXmagYmagZero", "$get$SemanticError_cameraXmagYmagZero", function() {
      return E.SemanticError$_("CAMERA_XMAG_YMAG_ZERO", new E.SemanticError_closure19(), C.Severity_1);
    });
    _lazy($, "SemanticError_cameraZfarLequalZnear", "$get$SemanticError_cameraZfarLequalZnear", function() {
      return E.SemanticError$_("CAMERA_ZFAR_LEQUAL_ZNEAR", new E.SemanticError_closure18(), C.Severity_0);
    });
    _lazy($, "SemanticError_materialAlphaCutoffInvalidMode", "$get$SemanticError_materialAlphaCutoffInvalidMode", function() {
      return E.SemanticError$_("MATERIAL_ALPHA_CUTOFF_INVALID_MODE", new E.SemanticError_closure16(), C.Severity_1);
    });
    _lazy($, "SemanticError_meshPrimitiveInvalidAttribute", "$get$SemanticError_meshPrimitiveInvalidAttribute", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_INVALID_ATTRIBUTE", new E.SemanticError_closure10(), C.Severity_0);
    });
    _lazy($, "SemanticError_meshPrimitivesUnequalTargetsCount", "$get$SemanticError_meshPrimitivesUnequalTargetsCount", function() {
      return E.SemanticError$_("MESH_PRIMITIVES_UNEQUAL_TARGETS_COUNT", new E.SemanticError_closure9(), C.Severity_0);
    });
    _lazy($, "SemanticError_meshPrimitivesUnequalJointsCount", "$get$SemanticError_meshPrimitivesUnequalJointsCount", function() {
      return E.SemanticError$_("MESH_PRIMITIVES_UNEQUAL_JOINTS_COUNT", new E.SemanticError_closure8(), C.Severity_1);
    });
    _lazy($, "SemanticError_meshPrimitiveNoPosition", "$get$SemanticError_meshPrimitiveNoPosition", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_NO_POSITION", new E.SemanticError_closure15(), C.Severity_1);
    });
    _lazy($, "SemanticError_meshPrimitiveIndexedSemanticContinuity", "$get$SemanticError_meshPrimitiveIndexedSemanticContinuity", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_INDEXED_SEMANTIC_CONTINUITY", new E.SemanticError_closure12(), C.Severity_0);
    });
    _lazy($, "SemanticError_meshPrimitiveTangentWithoutNormal", "$get$SemanticError_meshPrimitiveTangentWithoutNormal", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_TANGENT_WITHOUT_NORMAL", new E.SemanticError_closure14(), C.Severity_1);
    });
    _lazy($, "SemanticError_meshPrimitiveJointsWeightsMismatch", "$get$SemanticError_meshPrimitiveJointsWeightsMismatch", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_JOINTS_WEIGHTS_MISMATCH", new E.SemanticError_closure11(), C.Severity_0);
    });
    _lazy($, "SemanticError_meshPrimitiveTangentPoints", "$get$SemanticError_meshPrimitiveTangentPoints", function() {
      return E.SemanticError$_("MESH_PRIMITIVE_TANGENT_POINTS", new E.SemanticError_closure13(), C.Severity_1);
    });
    _lazy($, "SemanticError_meshInvalidWeightsCount", "$get$SemanticError_meshInvalidWeightsCount", function() {
      return E.SemanticError$_("MESH_INVALID_WEIGHTS_COUNT", new E.SemanticError_closure7(), C.Severity_0);
    });
    _lazy($, "SemanticError_nodeMatrixTrs", "$get$SemanticError_nodeMatrixTrs", function() {
      return E.SemanticError$_("NODE_MATRIX_TRS", new E.SemanticError_closure5(), C.Severity_0);
    });
    _lazy($, "SemanticError_nodeDefaultMatrix", "$get$SemanticError_nodeDefaultMatrix", function() {
      return E.SemanticError$_("NODE_MATRIX_DEFAULT", new E.SemanticError_closure4(), C.Severity_2);
    });
    _lazy($, "SemanticError_nodeNonTrsMatrix", "$get$SemanticError_nodeNonTrsMatrix", function() {
      return E.SemanticError$_("NODE_MATRIX_NON_TRS", new E.SemanticError_closure3(), C.Severity_0);
    });
    _lazy($, "SemanticError_rotationNonUnit", "$get$SemanticError_rotationNonUnit", function() {
      return E.SemanticError$_("ROTATION_NON_UNIT", new E.SemanticError_closure6(), C.Severity_0);
    });
    _lazy($, "SemanticError_unusedExtensionRequired", "$get$SemanticError_unusedExtensionRequired", function() {
      return E.SemanticError$_("UNUSED_EXTENSION_REQUIRED", new E.SemanticError_closure39(), C.Severity_0);
    });
    _lazy($, "SemanticError_nonRequiredExtension", "$get$SemanticError_nonRequiredExtension", function() {
      return E.SemanticError$_("NON_REQUIRED_EXTENSION", new E.SemanticError_closure40(), C.Severity_0);
    });
    _lazy($, "SemanticError_unreservedExtensionPrefix", "$get$SemanticError_unreservedExtensionPrefix", function() {
      return E.SemanticError$_("UNRESERVED_EXTENSION_PREFIX", new E.SemanticError_closure41(), C.Severity_1);
    });
    _lazy($, "SemanticError_invalidExtensionNameFormat", "$get$SemanticError_invalidExtensionNameFormat", function() {
      return E.SemanticError$_("INVALID_EXTENSION_NAME_FORMAT", new E.SemanticError_closure42(), C.Severity_1);
    });
    _lazy($, "SemanticError_nodeEmpty", "$get$SemanticError_nodeEmpty", function() {
      return E.SemanticError$_("NODE_EMPTY", new E.SemanticError_closure32(), C.Severity_2);
    });
    _lazy($, "SemanticError_nodeSkinnedMeshNonRoot", "$get$SemanticError_nodeSkinnedMeshNonRoot", function() {
      return E.SemanticError$_("NODE_SKINNED_MESH_NON_ROOT", new E.SemanticError_closure31(), C.Severity_1);
    });
    _lazy($, "SemanticError_nodeSkinnedMeshLocalTransforms", "$get$SemanticError_nodeSkinnedMeshLocalTransforms", function() {
      return E.SemanticError$_("NODE_SKINNED_MESH_LOCAL_TRANSFORMS", new E.SemanticError_closure30(), C.Severity_1);
    });
    _lazy($, "SemanticError_nodeSkinNoScene", "$get$SemanticError_nodeSkinNoScene", function() {
      return E.SemanticError$_("NODE_SKIN_NO_SCENE", new E.SemanticError_closure29(), C.Severity_0);
    });
    _lazy($, "SemanticError_skinNoCommonRoot", "$get$SemanticError_skinNoCommonRoot", function() {
      return E.SemanticError$_("SKIN_NO_COMMON_ROOT", new E.SemanticError_closure36(), C.Severity_0);
    });
    _lazy($, "SemanticError_skinSkeletonInvalid", "$get$SemanticError_skinSkeletonInvalid", function() {
      return E.SemanticError$_("SKIN_SKELETON_INVALID", new E.SemanticError_closure35(), C.Severity_0);
    });
    _lazy($, "SemanticError_nonRelativeUri", "$get$SemanticError_nonRelativeUri", function() {
      return E.SemanticError$_("NON_RELATIVE_URI", new E.SemanticError_closure17(), C.Severity_1);
    });
    _lazy($, "SemanticError_multipleExtensions", "$get$SemanticError_multipleExtensions", function() {
      return E.SemanticError$_("MULTIPLE_EXTENSIONS", new E.SemanticError_closure0(), C.Severity_1);
    });
    _lazy($, "SemanticError_nonObjectExtras", "$get$SemanticError_nonObjectExtras", function() {
      return E.SemanticError$_("NON_OBJECT_EXTRAS", new E.SemanticError_closure(), C.Severity_2);
    });
    _lazy($, "SemanticError_extraProperty", "$get$SemanticError_extraProperty", function() {
      return E.SemanticError$_("EXTRA_PROPERTY", new E.SemanticError_closure2(), C.Severity_2);
    });
    _lazy($, "SemanticError_khrLightsPunctualLightSpotAngles", "$get$SemanticError_khrLightsPunctualLightSpotAngles", function() {
      return E.SemanticError$_("KHR_LIGHTS_PUNCTUAL_LIGHT_SPOT_ANGLES", new E.SemanticError_closure1(), C.Severity_0);
    });
    _lazy($, "LinkError_accessorTotalOffsetAlignment", "$get$LinkError_accessorTotalOffsetAlignment", function() {
      return E.LinkError$_("ACCESSOR_TOTAL_OFFSET_ALIGNMENT", new E.LinkError_closure4(), C.Severity_0);
    });
    _lazy($, "LinkError_accessorSmallStride", "$get$LinkError_accessorSmallStride", function() {
      return E.LinkError$_("ACCESSOR_SMALL_BYTESTRIDE", new E.LinkError_closure8(), C.Severity_0);
    });
    _lazy($, "LinkError_accessorTooLong", "$get$LinkError_accessorTooLong", function() {
      return E.LinkError$_("ACCESSOR_TOO_LONG", new E.LinkError_closure3(), C.Severity_0);
    });
    _lazy($, "LinkError_accessorUsageOverride", "$get$LinkError_accessorUsageOverride", function() {
      return E.LinkError$_("ACCESSOR_USAGE_OVERRIDE", new E.LinkError_closure17(), C.Severity_0);
    });
    _lazy($, "LinkError_animationDuplicateTargets", "$get$LinkError_animationDuplicateTargets", function() {
      return E.LinkError$_("ANIMATION_DUPLICATE_TARGETS", new E.LinkError_closure9(), C.Severity_0);
    });
    _lazy($, "LinkError_animationChannelTargetNodeMatrix", "$get$LinkError_animationChannelTargetNodeMatrix", function() {
      return E.LinkError$_("ANIMATION_CHANNEL_TARGET_NODE_MATRIX", new E.LinkError_closure13(), C.Severity_0);
    });
    _lazy($, "LinkError_animationChannelTargetNodeWeightsNoMorphs", "$get$LinkError_animationChannelTargetNodeWeightsNoMorphs", function() {
      return E.LinkError$_("ANIMATION_CHANNEL_TARGET_NODE_WEIGHTS_NO_MORPHS", new E.LinkError_closure12(), C.Severity_0);
    });
    _lazy($, "LinkError_animationSamplerInputAccessorWithoutBounds", "$get$LinkError_animationSamplerInputAccessorWithoutBounds", function() {
      return E.LinkError$_("ANIMATION_SAMPLER_INPUT_ACCESSOR_WITHOUT_BOUNDS", new E.LinkError_closure15(), C.Severity_0);
    });
    _lazy($, "LinkError_animationSamplerInputAccessorInvalidFormat", "$get$LinkError_animationSamplerInputAccessorInvalidFormat", function() {
      return E.LinkError$_("ANIMATION_SAMPLER_INPUT_ACCESSOR_INVALID_FORMAT", new E.LinkError_closure16(), C.Severity_0);
    });
    _lazy($, "LinkError_animationSamplerOutputAccessorInvalidFormat", "$get$LinkError_animationSamplerOutputAccessorInvalidFormat", function() {
      return E.LinkError$_("ANIMATION_SAMPLER_OUTPUT_ACCESSOR_INVALID_FORMAT", new E.LinkError_closure11(), C.Severity_0);
    });
    _lazy($, "LinkError_animationSamplerInputAccessorTooFewElements", "$get$LinkError_animationSamplerInputAccessorTooFewElements", function() {
      return E.LinkError$_("ANIMATION_SAMPLER_INPUT_ACCESSOR_TOO_FEW_ELEMENTS", new E.LinkError_closure14(), C.Severity_0);
    });
    _lazy($, "LinkError_animationSamplerOutputAccessorInvalidCount", "$get$LinkError_animationSamplerOutputAccessorInvalidCount", function() {
      return E.LinkError$_("ANIMATION_SAMPLER_OUTPUT_ACCESSOR_INVALID_COUNT", new E.LinkError_closure10(), C.Severity_0);
    });
    _lazy($, "LinkError_bufferMissingGlbData", "$get$LinkError_bufferMissingGlbData", function() {
      return E.LinkError$_("BUFFER_MISSING_GLB_DATA", new E.LinkError_closure2(), C.Severity_0);
    });
    _lazy($, "LinkError_bufferViewTooLong", "$get$LinkError_bufferViewTooLong", function() {
      return E.LinkError$_("BUFFER_VIEW_TOO_LONG", new E.LinkError_closure18(), C.Severity_0);
    });
    _lazy($, "LinkError_bufferViewTargetOverride", "$get$LinkError_bufferViewTargetOverride", function() {
      return E.LinkError$_("BUFFER_VIEW_TARGET_OVERRIDE", new E.LinkError_closure7(), C.Severity_0);
    });
    _lazy($, "LinkError_invalidIbmAccessorCount", "$get$LinkError_invalidIbmAccessorCount", function() {
      return E.LinkError$_("INVALID_IBM_ACCESSOR_COUNT", new E.LinkError_closure35(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveAttributesAccessorInvalidFormat", "$get$LinkError_meshPrimitiveAttributesAccessorInvalidFormat", function() {
      return E.LinkError$_("MESH_PRIMITIVE_ATTRIBUTES_ACCESSOR_INVALID_FORMAT", new E.LinkError_closure21(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitivePositionAccessorWithoutBounds", "$get$LinkError_meshPrimitivePositionAccessorWithoutBounds", function() {
      return E.LinkError$_("MESH_PRIMITIVE_POSITION_ACCESSOR_WITHOUT_BOUNDS", new E.LinkError_closure22(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveAccessorWithoutByteStride", "$get$LinkError_meshPrimitiveAccessorWithoutByteStride", function() {
      return E.LinkError$_("MESH_PRIMITIVE_ACCESSOR_WITHOUT_BYTESTRIDE", new E.LinkError_closure19(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveAccessorUnaligned", "$get$LinkError_meshPrimitiveAccessorUnaligned", function() {
      return E.LinkError$_("MESH_PRIMITIVE_ACCESSOR_UNALIGNED", new E.LinkError_closure20(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveIndicesAccessorWithByteStride", "$get$LinkError_meshPrimitiveIndicesAccessorWithByteStride", function() {
      return E.LinkError$_("MESH_PRIMITIVE_INDICES_ACCESSOR_WITH_BYTESTRIDE", new E.LinkError_closure28(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveIndicesAccessorInvalidFormat", "$get$LinkError_meshPrimitiveIndicesAccessorInvalidFormat", function() {
      return E.LinkError$_("MESH_PRIMITIVE_INDICES_ACCESSOR_INVALID_FORMAT", new E.LinkError_closure27(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveIncompatibleMode", "$get$LinkError_meshPrimitiveIncompatibleMode", function() {
      return E.LinkError$_("MESH_PRIMITIVE_INCOMPATIBLE_MODE", new E.LinkError_closure26(), C.Severity_1);
    });
    _lazy($, "LinkError_meshPrimitiveTooFewTexcoords", "$get$LinkError_meshPrimitiveTooFewTexcoords", function() {
      return E.LinkError$_("MESH_PRIMITIVE_TOO_FEW_TEXCOORDS", new E.LinkError_closure25(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveUnequalAccessorsCount", "$get$LinkError_meshPrimitiveUnequalAccessorsCount", function() {
      return E.LinkError$_("MESH_PRIMITIVE_UNEQUAL_ACCESSOR_COUNT", new E.LinkError_closure29(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveMorphTargetNoBaseAccessor", "$get$LinkError_meshPrimitiveMorphTargetNoBaseAccessor", function() {
      return E.LinkError$_("MESH_PRIMITIVE_MORPH_TARGET_NO_BASE_ACCESSOR", new E.LinkError_closure24(), C.Severity_0);
    });
    _lazy($, "LinkError_meshPrimitiveMorphTargetInvalidAttributeCount", "$get$LinkError_meshPrimitiveMorphTargetInvalidAttributeCount", function() {
      return E.LinkError$_("MESH_PRIMITIVE_MORPH_TARGET_INVALID_ATTRIBUTE_COUNT", new E.LinkError_closure23(), C.Severity_0);
    });
    _lazy($, "LinkError_nodeLoop", "$get$LinkError_nodeLoop", function() {
      return E.LinkError$_("NODE_LOOP", new E.LinkError_closure6(), C.Severity_0);
    });
    _lazy($, "LinkError_nodeParentOverride", "$get$LinkError_nodeParentOverride", function() {
      return E.LinkError$_("NODE_PARENT_OVERRIDE", new E.LinkError_closure30(), C.Severity_0);
    });
    _lazy($, "LinkError_nodeWeightsInvalid", "$get$LinkError_nodeWeightsInvalid", function() {
      return E.LinkError$_("NODE_WEIGHTS_INVALID", new E.LinkError_closure33(), C.Severity_0);
    });
    _lazy($, "LinkError_nodeSkinWithNonSkinnedMesh", "$get$LinkError_nodeSkinWithNonSkinnedMesh", function() {
      return E.LinkError$_("NODE_SKIN_WITH_NON_SKINNED_MESH", new E.LinkError_closure32(), C.Severity_0);
    });
    _lazy($, "LinkError_nodeSkinnedMeshWithoutSkin", "$get$LinkError_nodeSkinnedMeshWithoutSkin", function() {
      return E.LinkError$_("NODE_SKINNED_MESH_WITHOUT_SKIN", new E.LinkError_closure31(), C.Severity_1);
    });
    _lazy($, "LinkError_sceneNonRootNode", "$get$LinkError_sceneNonRootNode", function() {
      return E.LinkError$_("SCENE_NON_ROOT_NODE", new E.LinkError_closure34(), C.Severity_0);
    });
    _lazy($, "LinkError_skinIbmInvalidFormat", "$get$LinkError_skinIbmInvalidFormat", function() {
      return E.LinkError$_("SKIN_IBM_INVALID_FORMAT", new E.LinkError_closure36(), C.Severity_0);
    });
    _lazy($, "LinkError_textureInvalidImageMimeType", "$get$LinkError_textureInvalidImageMimeType", function() {
      return E.LinkError$_("TEXTURE_INVALID_IMAGE_MIME_TYPE", new E.LinkError_closure1(), C.Severity_0);
    });
    _lazy($, "LinkError_undeclaredExtension", "$get$LinkError_undeclaredExtension", function() {
      return E.LinkError$_("UNDECLARED_EXTENSION", new E.LinkError_closure0(), C.Severity_0);
    });
    _lazy($, "LinkError_unexpectedExtensionObject", "$get$LinkError_unexpectedExtensionObject", function() {
      return E.LinkError$_("UNEXPECTED_EXTENSION_OBJECT", new E.LinkError_closure(), C.Severity_0);
    });
    _lazy($, "LinkError_unresolvedReference", "$get$LinkError_unresolvedReference", function() {
      return E.LinkError$_("UNRESOLVED_REFERENCE", new E.LinkError_closure37(), C.Severity_0);
    });
    _lazy($, "LinkError_unsupportedExtension", "$get$LinkError_unsupportedExtension", function() {
      return E.LinkError$_("UNSUPPORTED_EXTENSION", new E.LinkError_closure38(), C.Severity_1);
    });
    _lazy($, "LinkError_unusedObject", "$get$LinkError_unusedObject", function() {
      return E.LinkError$_("UNUSED_OBJECT", new E.LinkError_closure5(), C.Severity_2);
    });
    _lazy($, "GlbError_invalidMagic", "$get$GlbError_invalidMagic", function() {
      return E.GlbError$_("GLB_INVALID_MAGIC", new E.GlbError_closure12(), C.Severity_0);
    });
    _lazy($, "GlbError_invalidVersion", "$get$GlbError_invalidVersion", function() {
      return E.GlbError$_("GLB_INVALID_VERSION", new E.GlbError_closure11(), C.Severity_0);
    });
    _lazy($, "GlbError_lengthTooSmall", "$get$GlbError_lengthTooSmall", function() {
      return E.GlbError$_("GLB_LENGTH_TOO_SMALL", new E.GlbError_closure10(), C.Severity_0);
    });
    _lazy($, "GlbError_chunkLengthUnaligned", "$get$GlbError_chunkLengthUnaligned", function() {
      return E.GlbError$_("GLB_CHUNK_LENGTH_UNALIGNED", new E.GlbError_closure9(), C.Severity_0);
    });
    _lazy($, "GlbError_lengthMismatch", "$get$GlbError_lengthMismatch", function() {
      return E.GlbError$_("GLB_LENGTH_MISMATCH", new E.GlbError_closure0(), C.Severity_0);
    });
    _lazy($, "GlbError_chunkTooBig", "$get$GlbError_chunkTooBig", function() {
      return E.GlbError$_("GLB_CHUNK_TOO_BIG", new E.GlbError_closure8(), C.Severity_0);
    });
    _lazy($, "GlbError_emptyChunk", "$get$GlbError_emptyChunk", function() {
      return E.GlbError$_("GLB_EMPTY_CHUNK", new E.GlbError_closure4(), C.Severity_0);
    });
    _lazy($, "GlbError_duplicateChunk", "$get$GlbError_duplicateChunk", function() {
      return E.GlbError$_("GLB_DUPLICATE_CHUNK", new E.GlbError_closure5(), C.Severity_0);
    });
    _lazy($, "GlbError_unexpectedEndOfChunkHeader", "$get$GlbError_unexpectedEndOfChunkHeader", function() {
      return E.GlbError$_("GLB_UNEXPECTED_END_OF_CHUNK_HEADER", new E.GlbError_closure1(), C.Severity_0);
    });
    _lazy($, "GlbError_unexpectedEndOfChunkData", "$get$GlbError_unexpectedEndOfChunkData", function() {
      return E.GlbError$_("GLB_UNEXPECTED_END_OF_CHUNK_DATA", new E.GlbError_closure(), C.Severity_0);
    });
    _lazy($, "GlbError_unexpectedEndOfHeader", "$get$GlbError_unexpectedEndOfHeader", function() {
      return E.GlbError$_("GLB_UNEXPECTED_END_OF_HEADER", new E.GlbError_closure2(), C.Severity_0);
    });
    _lazy($, "GlbError_unexpectedFirstChunk", "$get$GlbError_unexpectedFirstChunk", function() {
      return E.GlbError$_("GLB_UNEXPECTED_FIRST_CHUNK", new E.GlbError_closure7(), C.Severity_0);
    });
    _lazy($, "GlbError_unexpectedBinChunk", "$get$GlbError_unexpectedBinChunk", function() {
      return E.GlbError$_("GLB_UNEXPECTED_BIN_CHUNK", new E.GlbError_closure6(), C.Severity_0);
    });
    _lazy($, "GlbError_unknownChunkType", "$get$GlbError_unknownChunkType", function() {
      return E.GlbError$_("GLB_UNKNOWN_CHUNK_TYPE", new E.GlbError_closure3(), C.Severity_1);
    });
    _lazy($, "_float", "$get$_float", function() {
      return H.NativeFloat32List_NativeFloat32List(1);
    });
    _lazy($, "_matrix", "$get$_matrix", function() {
      return T.Matrix4$zero();
    });
    _lazy($, "_translation", "$get$_translation", function() {
      return T.Vector3$zero();
    });
    _lazy($, "_rotation", "$get$_rotation", function() {
      var t1 = T.Quaternion$_();
      t1._qStorage[3] = 1;
      return t1;
    });
    _lazy($, "_scale", "$get$_scale", function() {
      return T.Vector3$zero();
    });
  })();
  (function nativeSupport() {
    !function() {
      var intern = function(s) {
        var o = {};
        o[s] = 1;
        return Object.keys(hunkHelpers.convertToFastObject(o))[0];
      };
      init.getIsolateTag = function(name) {
        return intern("___dart_" + name + init.isolateTag);
      };
      var tableProperty = "___dart_isolate_tags_";
      var usedProperties = Object[tableProperty] || (Object[tableProperty] = Object.create(null));
      var rootProperty = "_ZxYxX";
      for (var i = 0;; i++) {
        var property = intern(rootProperty + "_" + i + "_");
        if (!(property in usedProperties)) {
          usedProperties[property] = 1;
          init.isolateTag = property;
          break;
        }
      }
      init.dispatchPropertyName = init.getIsolateTag("dispatch_record");
    }();
    hunkHelpers.setOrUpdateInterceptorsByTag({ArrayBuffer: J.Interceptor, ArrayBufferView: H.NativeTypedData, DataView: H.NativeByteData, Float32Array: H.NativeFloat32List, Float64Array: H.NativeFloat64List, Int16Array: H.NativeInt16List, Int32Array: H.NativeInt32List, Int8Array: H.NativeInt8List, Uint16Array: H.NativeUint16List, Uint32Array: H.NativeUint32List, Uint8ClampedArray: H.NativeUint8ClampedList, CanvasPixelArray: H.NativeUint8ClampedList, Uint8Array: H.NativeUint8List});
    hunkHelpers.setOrUpdateLeafTags({ArrayBuffer: true, ArrayBufferView: false, DataView: true, Float32Array: true, Float64Array: true, Int16Array: true, Int32Array: true, Int8Array: true, Uint16Array: true, Uint32Array: true, Uint8ClampedArray: true, CanvasPixelArray: true, Uint8Array: false});
    H.NativeTypedArray.$nativeSuperclassTag = "ArrayBufferView";
    H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin.$nativeSuperclassTag = "ArrayBufferView";
    H._NativeTypedArrayOfDouble_NativeTypedArray_ListMixin_FixedLengthListMixin.$nativeSuperclassTag = "ArrayBufferView";
    H.NativeTypedArrayOfDouble.$nativeSuperclassTag = "ArrayBufferView";
    H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin.$nativeSuperclassTag = "ArrayBufferView";
    H._NativeTypedArrayOfInt_NativeTypedArray_ListMixin_FixedLengthListMixin.$nativeSuperclassTag = "ArrayBufferView";
    H.NativeTypedArrayOfInt.$nativeSuperclassTag = "ArrayBufferView";
  })();
  Function.prototype.call$1 = function(a) {
    return this(a);
  };
  Function.prototype.call$0 = function() {
    return this();
  };
  Function.prototype.call$2 = function(a, b) {
    return this(a, b);
  };
  Function.prototype.call$3 = function(a, b, c) {
    return this(a, b, c);
  };
  Function.prototype.call$4 = function(a, b, c, d) {
    return this(a, b, c, d);
  };
  Function.prototype.call$1$1 = function(a) {
    return this(a);
  };
  Function.prototype.call$1$0 = function() {
    return this();
  };
  Function.prototype.call$1$2 = function(a, b) {
    return this(a, b);
  };
  Function.prototype.call$2$0 = function() {
    return this();
  };
  convertAllToFastObject(holders);
  convertToFastObject($);
  (function(callback) {
    if (typeof document === "undefined") {
      callback(null);
      return;
    }
    if (typeof document.currentScript != 'undefined') {
      callback(document.currentScript);
      return;
    }
    var scripts = document.scripts;
    function onLoad(event) {
      for (var i = 0; i < scripts.length; ++i)
        scripts[i].removeEventListener("load", onLoad, false);
      callback(event.target);
    }
    for (var i = 0; i < scripts.length; ++i)
      scripts[i].addEventListener("load", onLoad, false);
  })(function(currentScript) {
    init.currentScript = currentScript;
    if (typeof dartMainRunner === "function")
      dartMainRunner(Q.main, []);
    else
      Q.main([]);
  });
})();

//# sourceMappingURL=gltf_validator.dart.js.map
